/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/case-law-app/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(422);
	module.exports = __webpack_require__(437);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(47);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(324)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentFlags = __webpack_require__(173);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(219);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(216);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(79);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(79);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(215);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 14 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(365);


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(127);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 20 */
[528, 89, 65, 28],
/* 21 */
[528, 154, 70, 34],
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(171);
	var PooledClass = __webpack_require__(37);
	var ReactFeatureFlags = __webpack_require__(176);
	var ReactReconciler = __webpack_require__(46);
	var Transaction = __webpack_require__(74);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(3);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	exports.embedProps = embedProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function embedProps(elements, extraProps) {
	        return _react2.default.Children.map(elements, function (element) {
	                return _react2.default.cloneElement(element, extraProps);
	        });
	}

/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(127);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var core = __webpack_require__(14);
	var ctx = __webpack_require__(81);
	var hide = __webpack_require__(40);
	var has = __webpack_require__(31);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 28 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 29 */
[513, 38, 131, 91, 30],
/* 30 */
[498, 39],
/* 31 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 32 */
[524, 132, 82],
/* 33 */
[494, 16],
/* 34 */
28,
/* 35 */
31,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(310);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports['default'] = utils;
	module.exports = exports['default'];

/***/ },
/* 37 */
[531, 5],
/* 38 */
[494, 41],
/* 39 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 40 */
[500, 29, 52, 30],
/* 41 */
16,
/* 42 */
39,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34);
	var hide = __webpack_require__(55);
	var has = __webpack_require__(35);
	var SRC = __webpack_require__(70)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(53).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(106);
	var setInnerHTML = __webpack_require__(76);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	var setTextContent = __webpack_require__(188);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(388);
	var ReactInstrumentation = __webpack_require__(18);
	
	var warning = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(484);
	var ReactComponent = __webpack_require__(124);
	var ReactPureComponent = __webpack_require__(489);
	var ReactClass = __webpack_require__(485);
	var ReactDOMFactories = __webpack_require__(486);
	var ReactElement = __webpack_require__(48);
	var ReactPropTypes = __webpack_require__(487);
	var ReactVersion = __webpack_require__(490);
	
	var onlyChild = __webpack_require__(491);
	var warning = __webpack_require__(3);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(25);
	
	var warning = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(208);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(206);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 49 */
5,
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 53 */
14,
/* 54 */
[498, 42],
/* 55 */
[500, 68, 97, 54],
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(107);
	var EventPluginUtils = __webpack_require__(108);
	var ReactErrorUtils = __webpack_require__(112);
	
	var accumulateInto = __webpack_require__(182);
	var forEachAccumulated = __webpack_require__(183);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(57);
	var EventPluginUtils = __webpack_require__(108);
	
	var accumulateInto = __webpack_require__(182);
	var forEachAccumulated = __webpack_require__(183);
	var warning = __webpack_require__(3);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(117);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 62 */
[518, 136, 83],
/* 63 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 64 */
[526, 82],
/* 65 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 66 */
[497, 272],
/* 67 */
51,
/* 68 */
[513, 33, 149, 156, 54],
/* 69 */
[524, 95, 144],
/* 70 */
65,
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(212);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
	    _reactDom2['default'].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2['default'])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(107);
	var ReactEventEmitterMixin = __webpack_require__(380);
	var ViewportMetrics = __webpack_require__(181);
	
	var getVendorPrefixedEventName = __webpack_require__(413);
	var isEventSupported = __webpack_require__(118);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(60);
	var ViewportMetrics = __webpack_require__(181);
	
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	var DOMNamespaces = __webpack_require__(106);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(416);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _defaultArrowRenderer = __webpack_require__(198);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(199);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(122);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(123);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(196);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(197);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 78 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 115);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 115:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_sigma_core_js__ = __webpack_require__(69);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_sigma_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sigma_react_src_sigma_core_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_conrad_js__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_conrad_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sigma_react_src_conrad_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_utils_sigma_utils_js__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_utils_sigma_utils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sigma_react_src_utils_sigma_utils_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_utils_sigma_polyfills_js__ = __webpack_require__(71);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_utils_sigma_polyfills_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sigma_react_src_utils_sigma_polyfills_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_sigma_settings_js__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_sigma_settings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sigma_react_src_sigma_settings_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_classes_sigma_classes_dispatcher_js__ = __webpack_require__(38);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_classes_sigma_classes_dispatcher_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sigma_react_src_classes_sigma_classes_dispatcher_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_src_classes_sigma_classes_configurable_js__ = __webpack_require__(37);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_src_classes_sigma_classes_configurable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sigma_react_src_classes_sigma_classes_configurable_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sigma_react_src_classes_sigma_classes_graph_js__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sigma_react_src_classes_sigma_classes_graph_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sigma_react_src_classes_sigma_classes_graph_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sigma_react_src_classes_sigma_classes_camera_js__ = __webpack_require__(36);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sigma_react_src_classes_sigma_classes_camera_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sigma_react_src_classes_sigma_classes_camera_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sigma_react_src_classes_sigma_classes_quad_js__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sigma_react_src_classes_sigma_classes_quad_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sigma_react_src_classes_sigma_classes_quad_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sigma_react_src_classes_sigma_classes_edgequad_js__ = __webpack_require__(39);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sigma_react_src_classes_sigma_classes_edgequad_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sigma_react_src_classes_sigma_classes_edgequad_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sigma_react_src_captors_sigma_captors_mouse_js__ = __webpack_require__(34);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sigma_react_src_captors_sigma_captors_mouse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sigma_react_src_captors_sigma_captors_mouse_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sigma_react_src_captors_sigma_captors_touch_js__ = __webpack_require__(35);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sigma_react_src_captors_sigma_captors_touch_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sigma_react_src_captors_sigma_captors_touch_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sigma_react_src_renderers_sigma_renderers_canvas_js__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sigma_react_src_renderers_sigma_renderers_canvas_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sigma_react_src_renderers_sigma_renderers_canvas_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sigma_react_src_renderers_canvas_sigma_canvas_labels_def_js__ = __webpack_require__(59);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sigma_react_src_renderers_canvas_sigma_canvas_labels_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sigma_react_src_renderers_canvas_sigma_canvas_labels_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sigma_react_src_renderers_canvas_sigma_canvas_hovers_def_js__ = __webpack_require__(58);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sigma_react_src_renderers_canvas_sigma_canvas_hovers_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sigma_react_src_renderers_canvas_sigma_canvas_hovers_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sigma_react_src_renderers_canvas_sigma_canvas_nodes_def_js__ = __webpack_require__(60);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sigma_react_src_renderers_canvas_sigma_canvas_nodes_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sigma_react_src_renderers_canvas_sigma_canvas_nodes_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sigma_react_src_renderers_canvas_sigma_canvas_edges_def_js__ = __webpack_require__(56);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sigma_react_src_renderers_canvas_sigma_canvas_edges_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sigma_react_src_renderers_canvas_sigma_canvas_edges_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_def_js__ = __webpack_require__(52);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sigma_react_src_renderers_canvas_sigma_canvas_extremities_def_js__ = __webpack_require__(57);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_sigma_react_src_renderers_canvas_sigma_canvas_extremities_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_sigma_react_src_renderers_canvas_sigma_canvas_extremities_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sigma_react_src_middlewares_sigma_middlewares_rescale_js__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_sigma_react_src_middlewares_sigma_middlewares_rescale_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_sigma_react_src_middlewares_sigma_middlewares_rescale_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sigma_react_src_middlewares_sigma_middlewares_copy_js__ = __webpack_require__(43);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sigma_react_src_middlewares_sigma_middlewares_copy_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sigma_react_src_middlewares_sigma_middlewares_copy_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sigma_react_src_misc_sigma_misc_animation_js__ = __webpack_require__(45);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sigma_react_src_misc_sigma_misc_animation_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sigma_react_src_misc_sigma_misc_animation_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sigma_react_src_misc_sigma_misc_bindEvents_js__ = __webpack_require__(47);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_sigma_react_src_misc_sigma_misc_bindEvents_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_sigma_react_src_misc_sigma_misc_bindEvents_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sigma_react_src_misc_sigma_misc_bindDOMEvents_js__ = __webpack_require__(46);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_sigma_react_src_misc_sigma_misc_bindDOMEvents_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_sigma_react_src_misc_sigma_misc_bindDOMEvents_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sigma_react_src_misc_sigma_misc_drawHovers_js__ = __webpack_require__(48);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_sigma_react_src_misc_sigma_misc_drawHovers_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_sigma_react_src_misc_sigma_misc_drawHovers_js__);
	// Sigma build is quite big and not friendly for webpack, therefore we use custom import
	
	// Core:
	
	
	// Utils:
	
	
	
	
	// Main classes:
	
	
	
	
	
	
	
	
	// Captors:
	
	
	
	// Renderers:
	
	
	// Sub functions per engine:
	
	
	
	
	
	
	
	// Middlewares:
	
	
	
	// Miscellaneous:
	
	
	
	
	
	var sigma = window.sigma;
	
	// By default we exclude WbGL renderer from the Sigma component.
	// WebGL has to be imported explicitly via <SigmaEnableWebGL /> in the global context.
	sigma.renderers.def = sigma.renderers.canvas;
	
	// We do not support svg at all to reduce package size
	//    'src/renderers/sigma.renderers.svg.js',
	//    'src/renderers/svg/sigma.svg.utils.js',
	//    'src/renderers/svg/sigma.svg.nodes.def.js',
	//    'src/renderers/svg/sigma.svg.edges.def.js',
	//    'src/renderers/svg/sigma.svg.edges.curve.js',
	//    'src/renderers/svg/sigma.svg.labels.def.js',
	//    'src/renderers/svg/sigma.svg.hovers.def.js',
	
	/* harmony default export */ __webpack_exports__["default"] = sigma;
	
	/***/ }),
	
	/***/ 34:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.captors');
	
	  /**
	   * The user inputs default captor. It deals with mouse events, keyboards
	   * events and touch events.
	   *
	   * @param  {DOMElement}   target   The DOM element where the listeners will be
	   *                                 bound.
	   * @param  {camera}       camera   The camera related to the target.
	   * @param  {configurable} settings The settings function.
	   * @return {sigma.captor}          The fresh new captor instance.
	   */
	  sigma.captors.mouse = function(target, camera, settings) {
	    var _self = this,
	        _target = target,
	        _camera = camera,
	        _settings = settings,
	
	        // CAMERA MANAGEMENT:
	        // ******************
	        // The camera position when the user starts dragging:
	        _startCameraX,
	        _startCameraY,
	        _startCameraAngle,
	
	        // The latest stage position:
	        _lastCameraX,
	        _lastCameraY,
	        _lastCameraAngle,
	        _lastCameraRatio,
	
	        // MOUSE MANAGEMENT:
	        // *****************
	        // The mouse position when the user starts dragging:
	        _startMouseX,
	        _startMouseY,
	
	        _isMouseDown,
	        _isMoving,
	        _hasDragged,
	        _downStartTime,
	        _movingTimeoutId;
	
	    sigma.classes.dispatcher.extend(this);
	
	    sigma.utils.doubleClick(_target, 'click', _doubleClickHandler);
	    _target.addEventListener('DOMMouseScroll', _wheelHandler, false);
	    _target.addEventListener('mousewheel', _wheelHandler, false);
	    _target.addEventListener('mousemove', _moveHandler, false);
	    _target.addEventListener('mousedown', _downHandler, false);
	    _target.addEventListener('click', _clickHandler, false);
	    _target.addEventListener('mouseout', _outHandler, false);
	    document.addEventListener('mouseup', _upHandler, false);
	
	
	
	
	    /**
	     * This method unbinds every handlers that makes the captor work.
	     */
	    this.kill = function() {
	      sigma.utils.unbindDoubleClick(_target, 'click');
	      _target.removeEventListener('DOMMouseScroll', _wheelHandler);
	      _target.removeEventListener('mousewheel', _wheelHandler);
	      _target.removeEventListener('mousemove', _moveHandler);
	      _target.removeEventListener('mousedown', _downHandler);
	      _target.removeEventListener('click', _clickHandler);
	      _target.removeEventListener('mouseout', _outHandler);
	      document.removeEventListener('mouseup', _upHandler);
	    };
	
	
	
	
	    // MOUSE EVENTS:
	    // *************
	
	    /**
	     * The handler listening to the 'move' mouse event. It will effectively
	     * drag the graph.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _moveHandler(e) {
	      var x,
	          y,
	          pos;
	
	      // Dispatch event:
	      if (_settings('mouseEnabled')) {
	        _self.dispatchEvent('mousemove',
	          sigma.utils.mouseCoords(e));
	
	        if (_isMouseDown) {
	          _isMoving = true;
	          _hasDragged = true;
	
	          if (_movingTimeoutId)
	            clearTimeout(_movingTimeoutId);
	
	          _movingTimeoutId = setTimeout(function() {
	            _isMoving = false;
	          }, _settings('dragTimeout'));
	
	          sigma.misc.animation.killAll(_camera);
	
	          _camera.isMoving = true;
	          pos = _camera.cameraPosition(
	            sigma.utils.getX(e) - _startMouseX,
	            sigma.utils.getY(e) - _startMouseY,
	            true
	          );
	
	          x = _startCameraX - pos.x;
	          y = _startCameraY - pos.y;
	
	          if (x !== _camera.x || y !== _camera.y) {
	            _lastCameraX = _camera.x;
	            _lastCameraY = _camera.y;
	
	            _camera.goTo({
	              x: x,
	              y: y
	            });
	          }
	
	          if (e.preventDefault)
	            e.preventDefault();
	          else
	            e.returnValue = false;
	
	          e.stopPropagation();
	          return false;
	        }
	      }
	    }
	
	    /**
	     * The handler listening to the 'up' mouse event. It will stop dragging the
	     * graph.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _upHandler(e) {
	      if (_settings('mouseEnabled') && _isMouseDown) {
	        _isMouseDown = false;
	        if (_movingTimeoutId)
	          clearTimeout(_movingTimeoutId);
	
	        _camera.isMoving = false;
	
	        var x = sigma.utils.getX(e),
	            y = sigma.utils.getY(e);
	
	        if (_isMoving) {
	          sigma.misc.animation.killAll(_camera);
	          sigma.misc.animation.camera(
	            _camera,
	            {
	              x: _camera.x +
	                _settings('mouseInertiaRatio') * (_camera.x - _lastCameraX),
	              y: _camera.y +
	                _settings('mouseInertiaRatio') * (_camera.y - _lastCameraY)
	            },
	            {
	              easing: 'quadraticOut',
	              duration: _settings('mouseInertiaDuration')
	            }
	          );
	        } else if (
	          _startMouseX !== x ||
	          _startMouseY !== y
	        )
	          _camera.goTo({
	            x: _camera.x,
	            y: _camera.y
	          });
	
	        _self.dispatchEvent('mouseup',
	          sigma.utils.mouseCoords(e));
	
	        // Update _isMoving flag:
	        _isMoving = false;
	      }
	    }
	
	    /**
	     * The handler listening to the 'down' mouse event. It will start observing
	     * the mouse position for dragging the graph.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _downHandler(e) {
	      if (_settings('mouseEnabled')) {
	        _startCameraX = _camera.x;
	        _startCameraY = _camera.y;
	
	        _lastCameraX = _camera.x;
	        _lastCameraY = _camera.y;
	
	        _startMouseX = sigma.utils.getX(e);
	        _startMouseY = sigma.utils.getY(e);
	
	        _hasDragged = false;
	        _downStartTime = (new Date()).getTime();
	
	        switch (e.which) {
	          case 2:
	            // Middle mouse button pressed
	            // Do nothing.
	            break;
	          case 3:
	            // Right mouse button pressed
	            _self.dispatchEvent('rightclick',
	              sigma.utils.mouseCoords(e, _startMouseX, _startMouseY));
	            break;
	          // case 1:
	          default:
	            // Left mouse button pressed
	            _isMouseDown = true;
	
	            _self.dispatchEvent('mousedown',
	              sigma.utils.mouseCoords(e, _startMouseX, _startMouseY));
	        }
	      }
	    }
	
	    /**
	     * The handler listening to the 'out' mouse event. It will just redispatch
	     * the event.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _outHandler(e) {
	      if (_settings('mouseEnabled'))
	        _self.dispatchEvent('mouseout');
	    }
	
	    /**
	     * The handler listening to the 'click' mouse event. It will redispatch the
	     * click event, but with normalized X and Y coordinates.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _clickHandler(e) {
	      if (_settings('mouseEnabled')) {
	        var event = sigma.utils.mouseCoords(e);
	        event.isDragging =
	          (((new Date()).getTime() - _downStartTime) > 100) && _hasDragged;
	        _self.dispatchEvent('click', event);
	      }
	
	      if (e.preventDefault)
	        e.preventDefault();
	      else
	        e.returnValue = false;
	
	      e.stopPropagation();
	      return false;
	    }
	
	    /**
	     * The handler listening to the double click custom event. It will
	     * basically zoom into the graph.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _doubleClickHandler(e) {
	      var pos,
	          ratio,
	          animation;
	
	      if (_settings('mouseEnabled')) {
	        ratio = 1 / _settings('doubleClickZoomingRatio');
	
	        _self.dispatchEvent('doubleclick',
	            sigma.utils.mouseCoords(e, _startMouseX, _startMouseY));
	
	        if (_settings('doubleClickEnabled')) {
	          pos = _camera.cameraPosition(
	            sigma.utils.getX(e) - sigma.utils.getCenter(e).x,
	            sigma.utils.getY(e) - sigma.utils.getCenter(e).y,
	            true
	          );
	
	          animation = {
	            duration: _settings('doubleClickZoomDuration')
	          };
	
	          sigma.utils.zoomTo(_camera, pos.x, pos.y, ratio, animation);
	        }
	
	        if (e.preventDefault)
	          e.preventDefault();
	        else
	          e.returnValue = false;
	
	        e.stopPropagation();
	        return false;
	      }
	    }
	
	    /**
	     * The handler listening to the 'wheel' mouse event. It will basically zoom
	     * in or not into the graph.
	     *
	     * @param {event} e A mouse event.
	     */
	    function _wheelHandler(e) {
	      var pos,
	          ratio,
	          animation,
	          wheelDelta = sigma.utils.getDelta(e);
	
	      if (_settings('mouseEnabled') && _settings('mouseWheelEnabled') && wheelDelta !== 0) {
	        ratio = wheelDelta > 0 ?
	          1 / _settings('zoomingRatio') :
	          _settings('zoomingRatio');
	
	        pos = _camera.cameraPosition(
	          sigma.utils.getX(e) - sigma.utils.getCenter(e).x,
	          sigma.utils.getY(e) - sigma.utils.getCenter(e).y,
	          true
	        );
	
	        animation = {
	          duration: _settings('mouseZoomDuration')
	        };
	
	        sigma.utils.zoomTo(_camera, pos.x, pos.y, ratio, animation);
	
	        if (e.preventDefault)
	          e.preventDefault();
	        else
	          e.returnValue = false;
	
	        e.stopPropagation();
	        return false;
	      }
	    }
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 35:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.captors');
	
	  /**
	   * The user inputs default captor. It deals with mouse events, keyboards
	   * events and touch events.
	   *
	   * @param  {DOMElement}   target   The DOM element where the listeners will be
	   *                                 bound.
	   * @param  {camera}       camera   The camera related to the target.
	   * @param  {configurable} settings The settings function.
	   * @return {sigma.captor}          The fresh new captor instance.
	   */
	  sigma.captors.touch = function(target, camera, settings) {
	    var _self = this,
	        _target = target,
	        _camera = camera,
	        _settings = settings,
	
	        // CAMERA MANAGEMENT:
	        // ******************
	        // The camera position when the user starts dragging:
	        _startCameraX,
	        _startCameraY,
	        _startCameraAngle,
	        _startCameraRatio,
	
	        // The latest stage position:
	        _lastCameraX,
	        _lastCameraY,
	        _lastCameraAngle,
	        _lastCameraRatio,
	
	        // TOUCH MANAGEMENT:
	        // *****************
	        // Touches that are down:
	        _downTouches = [],
	
	        _startTouchX0,
	        _startTouchY0,
	        _startTouchX1,
	        _startTouchY1,
	        _startTouchAngle,
	        _startTouchDistance,
	
	        _touchMode,
	
	        _isMoving,
	        _doubleTap,
	        _movingTimeoutId;
	
	    sigma.classes.dispatcher.extend(this);
	
	    sigma.utils.doubleClick(_target, 'touchstart', _doubleTapHandler);
	    _target.addEventListener('touchstart', _handleStart, false);
	    _target.addEventListener('touchend', _handleLeave, false);
	    _target.addEventListener('touchcancel', _handleLeave, false);
	    _target.addEventListener('touchleave', _handleLeave, false);
	    _target.addEventListener('touchmove', _handleMove, false);
	
	    function position(e) {
	      var offset = sigma.utils.getOffset(_target);
	
	      return {
	        x: e.pageX - offset.left,
	        y: e.pageY - offset.top
	      };
	    }
	
	    /**
	     * This method unbinds every handlers that makes the captor work.
	     */
	    this.kill = function() {
	      sigma.utils.unbindDoubleClick(_target, 'touchstart');
	      _target.addEventListener('touchstart', _handleStart);
	      _target.addEventListener('touchend', _handleLeave);
	      _target.addEventListener('touchcancel', _handleLeave);
	      _target.addEventListener('touchleave', _handleLeave);
	      _target.addEventListener('touchmove', _handleMove);
	    };
	
	    // TOUCH EVENTS:
	    // *************
	    /**
	     * The handler listening to the 'touchstart' event. It will set the touch
	     * mode ("_touchMode") and start observing the user touch moves.
	     *
	     * @param {event} e A touch event.
	     */
	    function _handleStart(e) {
	      if (_settings('touchEnabled')) {
	        var x0,
	            x1,
	            y0,
	            y1,
	            pos0,
	            pos1;
	
	        _downTouches = e.touches;
	
	        switch (_downTouches.length) {
	          case 1:
	            _camera.isMoving = true;
	            _touchMode = 1;
	
	            _startCameraX = _camera.x;
	            _startCameraY = _camera.y;
	
	            _lastCameraX = _camera.x;
	            _lastCameraY = _camera.y;
	
	            pos0 = position(_downTouches[0]);
	            _startTouchX0 = pos0.x;
	            _startTouchY0 = pos0.y;
	
	            break;
	          case 2:
	            _camera.isMoving = true;
	            _touchMode = 2;
	
	            pos0 = position(_downTouches[0]);
	            pos1 = position(_downTouches[1]);
	            x0 = pos0.x;
	            y0 = pos0.y;
	            x1 = pos1.x;
	            y1 = pos1.y;
	
	            _lastCameraX = _camera.x;
	            _lastCameraY = _camera.y;
	
	            _startCameraAngle = _camera.angle;
	            _startCameraRatio = _camera.ratio;
	
	            _startCameraX = _camera.x;
	            _startCameraY = _camera.y;
	
	            _startTouchX0 = x0;
	            _startTouchY0 = y0;
	            _startTouchX1 = x1;
	            _startTouchY1 = y1;
	
	            _startTouchAngle = Math.atan2(
	              _startTouchY1 - _startTouchY0,
	              _startTouchX1 - _startTouchX0
	            );
	            _startTouchDistance = Math.sqrt(
	              (_startTouchY1 - _startTouchY0) *
	                (_startTouchY1 - _startTouchY0) +
	              (_startTouchX1 - _startTouchX0) *
	                (_startTouchX1 - _startTouchX0)
	            );
	
	            e.preventDefault();
	            return false;
	        }
	      }
	    }
	
	    /**
	     * The handler listening to the 'touchend', 'touchcancel' and 'touchleave'
	     * event. It will update the touch mode if there are still at least one
	     * finger, and stop dragging else.
	     *
	     * @param {event} e A touch event.
	     */
	    function _handleLeave(e) {
	      if (_settings('touchEnabled')) {
	        _downTouches = e.touches;
	        var inertiaRatio = _settings('touchInertiaRatio');
	
	        if (_movingTimeoutId) {
	          _isMoving = false;
	          clearTimeout(_movingTimeoutId);
	        }
	
	        switch (_touchMode) {
	          case 2:
	            if (e.touches.length === 1) {
	              _handleStart(e);
	
	              e.preventDefault();
	              break;
	            }
	            /* falls through */
	          case 1:
	            _camera.isMoving = false;
	            _self.dispatchEvent('stopDrag');
	
	            if (_isMoving) {
	              _doubleTap = false;
	              sigma.misc.animation.camera(
	                _camera,
	                {
	                  x: _camera.x +
	                    inertiaRatio * (_camera.x - _lastCameraX),
	                  y: _camera.y +
	                    inertiaRatio * (_camera.y - _lastCameraY)
	                },
	                {
	                  easing: 'quadraticOut',
	                  duration: _settings('touchInertiaDuration')
	                }
	              );
	            }
	
	            _isMoving = false;
	            _touchMode = 0;
	            break;
	        }
	      }
	    }
	
	    /**
	     * The handler listening to the 'touchmove' event. It will effectively drag
	     * the graph, and eventually zooms and turn it if the user is using two
	     * fingers.
	     *
	     * @param {event} e A touch event.
	     */
	    function _handleMove(e) {
	      if (!_doubleTap && _settings('touchEnabled')) {
	        var x0,
	            x1,
	            y0,
	            y1,
	            cos,
	            sin,
	            end,
	            pos0,
	            pos1,
	            diff,
	            start,
	            dAngle,
	            dRatio,
	            newStageX,
	            newStageY,
	            newStageRatio,
	            newStageAngle;
	
	        _downTouches = e.touches;
	        _isMoving = true;
	
	        if (_movingTimeoutId)
	          clearTimeout(_movingTimeoutId);
	
	        _movingTimeoutId = setTimeout(function() {
	          _isMoving = false;
	        }, _settings('dragTimeout'));
	
	        switch (_touchMode) {
	          case 1:
	            pos0 = position(_downTouches[0]);
	            x0 = pos0.x;
	            y0 = pos0.y;
	
	            diff = _camera.cameraPosition(
	              x0 - _startTouchX0,
	              y0 - _startTouchY0,
	              true
	            );
	
	            newStageX = _startCameraX - diff.x;
	            newStageY = _startCameraY - diff.y;
	
	            if (newStageX !== _camera.x || newStageY !== _camera.y) {
	              _lastCameraX = _camera.x;
	              _lastCameraY = _camera.y;
	
	              _camera.goTo({
	                x: newStageX,
	                y: newStageY
	              });
	
	              _self.dispatchEvent('mousemove',
	                sigma.utils.mouseCoords(e, pos0.x, pos0.y));
	
	              _self.dispatchEvent('drag');
	            }
	            break;
	          case 2:
	            pos0 = position(_downTouches[0]);
	            pos1 = position(_downTouches[1]);
	            x0 = pos0.x;
	            y0 = pos0.y;
	            x1 = pos1.x;
	            y1 = pos1.y;
	
	            start = _camera.cameraPosition(
	              (_startTouchX0 + _startTouchX1) / 2 -
	                sigma.utils.getCenter(e).x,
	              (_startTouchY0 + _startTouchY1) / 2 -
	                sigma.utils.getCenter(e).y,
	              true
	            );
	            end = _camera.cameraPosition(
	              (x0 + x1) / 2 - sigma.utils.getCenter(e).x,
	              (y0 + y1) / 2 - sigma.utils.getCenter(e).y,
	              true
	            );
	
	            dAngle = Math.atan2(y1 - y0, x1 - x0) - _startTouchAngle;
	            dRatio = Math.sqrt(
	              (y1 - y0) * (y1 - y0) + (x1 - x0) * (x1 - x0)
	            ) / _startTouchDistance;
	
	            // Translation:
	            x0 = start.x;
	            y0 = start.y;
	
	            // Homothetic transformation:
	            newStageRatio = _startCameraRatio / dRatio;
	            x0 = x0 * dRatio;
	            y0 = y0 * dRatio;
	
	            // Rotation:
	            newStageAngle = _startCameraAngle - dAngle;
	            cos = Math.cos(-dAngle);
	            sin = Math.sin(-dAngle);
	            x1 = x0 * cos + y0 * sin;
	            y1 = y0 * cos - x0 * sin;
	            x0 = x1;
	            y0 = y1;
	
	            // Finalize:
	            newStageX = x0 - end.x + _startCameraX;
	            newStageY = y0 - end.y + _startCameraY;
	
	            if (
	              newStageRatio !== _camera.ratio ||
	              newStageAngle !== _camera.angle ||
	              newStageX !== _camera.x ||
	              newStageY !== _camera.y
	            ) {
	              _lastCameraX = _camera.x;
	              _lastCameraY = _camera.y;
	              _lastCameraAngle = _camera.angle;
	              _lastCameraRatio = _camera.ratio;
	
	              _camera.goTo({
	                x: newStageX,
	                y: newStageY,
	                angle: newStageAngle,
	                ratio: newStageRatio
	              });
	
	              _self.dispatchEvent('drag');
	            }
	
	            break;
	        }
	
	        e.preventDefault();
	        return false;
	      }
	    }
	
	    /**
	     * The handler listening to the double tap custom event. It will
	     * basically zoom into the graph.
	     *
	     * @param {event} e A touch event.
	     */
	    function _doubleTapHandler(e) {
	      var pos,
	          ratio,
	          animation;
	
	      if (e.touches && e.touches.length === 1 && _settings('touchEnabled')) {
	        _doubleTap = true;
	
	        ratio = 1 / _settings('doubleClickZoomingRatio');
	
	        pos = position(e.touches[0]);
	        _self.dispatchEvent('doubleclick',
	          sigma.utils.mouseCoords(e, pos.x, pos.y));
	
	        if (_settings('doubleClickEnabled')) {
	          pos = _camera.cameraPosition(
	            pos.x - sigma.utils.getCenter(e).x,
	            pos.y - sigma.utils.getCenter(e).y,
	            true
	          );
	
	          animation = {
	            duration: _settings('doubleClickZoomDuration'),
	            onComplete: function() {
	              _doubleTap = false;
	            }
	          };
	
	          sigma.utils.zoomTo(_camera, pos.x, pos.y, ratio, animation);
	        }
	
	        if (e.preventDefault)
	          e.preventDefault();
	        else
	          e.returnValue = false;
	
	        e.stopPropagation();
	        return false;
	      }
	    }
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 36:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  sigma.utils.pkg('sigma.classes');
	
	  /**
	   * The camera constructor. It just initializes its attributes and methods.
	   *
	   * @param  {string}       id       The id.
	   * @param  {sigma.classes.graph}  graph    The graph.
	   * @param  {configurable} settings The settings function.
	   * @param  {?object}      options  Eventually some overriding options.
	   * @return {camera}                Returns the fresh new camera instance.
	   */
	  sigma.classes.camera = function(id, graph, settings, options) {
	    sigma.classes.dispatcher.extend(this);
	
	    Object.defineProperty(this, 'graph', {
	      value: graph
	    });
	    Object.defineProperty(this, 'id', {
	      value: id
	    });
	    Object.defineProperty(this, 'readPrefix', {
	      value: 'read_cam' + id + ':'
	    });
	    Object.defineProperty(this, 'prefix', {
	      value: 'cam' + id + ':'
	    });
	
	    this.x = 0;
	    this.y = 0;
	    this.ratio = 1;
	    this.angle = 0;
	    this.isAnimated = false;
	    this.settings = (typeof options === 'object' && options) ?
	      settings.embedObject(options) :
	      settings;
	  };
	
	  /**
	   * Updates the camera position.
	   *
	   * @param  {object} coordinates The new coordinates object.
	   * @return {camera}             Returns the camera.
	   */
	  sigma.classes.camera.prototype.goTo = function(coordinates) {
	    if (!this.settings('enableCamera'))
	      return this;
	
	    var i,
	        l,
	        c = coordinates || {},
	        keys = ['x', 'y', 'ratio', 'angle'];
	
	    for (i = 0, l = keys.length; i < l; i++)
	      if (c[keys[i]] !== undefined) {
	        if (typeof c[keys[i]] === 'number' && !isNaN(c[keys[i]]))
	          this[keys[i]] = c[keys[i]];
	        else
	          throw 'Value for "' + keys[i] + '" is not a number.';
	      }
	
	    this.dispatchEvent('coordinatesUpdated');
	    return this;
	  };
	
	  /**
	   * This method takes a graph and computes for each node and edges its
	   * coordinates relatively to the center of the camera. Basically, it will
	   * compute the coordinates that will be used by the graphic renderers.
	   *
	   * Since it should be possible to use different cameras and different
	   * renderers, it is possible to specify a prefix to put before the new
	   * coordinates (to get something like "node.camera1_x")
	   *
	   * @param  {?string} read    The prefix of the coordinates to read.
	   * @param  {?string} write   The prefix of the coordinates to write.
	   * @param  {?object} options Eventually an object of options. Those can be:
	   *                           - A restricted nodes array.
	   *                           - A restricted edges array.
	   *                           - A width.
	   *                           - A height.
	   * @return {camera}        Returns the camera.
	   */
	  sigma.classes.camera.prototype.applyView = function(read, write, options) {
	    options = options || {};
	    write = write !== undefined ? write : this.prefix;
	    read = read !== undefined ? read : this.readPrefix;
	
	    var nodes = options.nodes || this.graph.nodes(),
	        edges = options.edges || this.graph.edges();
	
	    var i,
	        l,
	        node,
	        relCos = Math.cos(this.angle) / this.ratio,
	        relSin = Math.sin(this.angle) / this.ratio,
	        nodeRatio = Math.pow(this.ratio, this.settings('nodesPowRatio')),
	        edgeRatio = Math.pow(this.ratio, this.settings('edgesPowRatio')),
	        xOffset = (options.width || 0) / 2 - this.x * relCos - this.y * relSin,
	        yOffset = (options.height || 0) / 2 - this.y * relCos + this.x * relSin;
	
	    for (i = 0, l = nodes.length; i < l; i++) {
	      node = nodes[i];
	      node[write + 'x'] =
	        (node[read + 'x'] || 0) * relCos +
	        (node[read + 'y'] || 0) * relSin +
	        xOffset;
	      node[write + 'y'] =
	        (node[read + 'y'] || 0) * relCos -
	        (node[read + 'x'] || 0) * relSin +
	        yOffset;
	      node[write + 'size'] =
	        (node[read + 'size'] || 0) /
	        nodeRatio;
	    }
	
	    for (i = 0, l = edges.length; i < l; i++) {
	      edges[i][write + 'size'] =
	        (edges[i][read + 'size'] || 0) /
	        edgeRatio;
	    }
	
	    return this;
	  };
	
	  /**
	   * This function converts the coordinates of a point from the frame of the
	   * camera to the frame of the graph.
	   *
	   * @param  {number} x The X coordinate of the point in the frame of the
	   *                    camera.
	   * @param  {number} y The Y coordinate of the point in the frame of the
	   *                    camera.
	   * @return {object}   The point coordinates in the frame of the graph.
	   */
	  sigma.classes.camera.prototype.graphPosition = function(x, y, vector) {
	    var X = 0,
	        Y = 0,
	        cos = Math.cos(this.angle),
	        sin = Math.sin(this.angle);
	
	    // Revert the origin differential vector:
	    if (!vector) {
	      X = - (this.x * cos + this.y * sin) / this.ratio;
	      Y = - (this.y * cos - this.x * sin) / this.ratio;
	    }
	
	    return {
	      x: (x * cos + y * sin) / this.ratio + X,
	      y: (y * cos - x * sin) / this.ratio + Y
	    };
	  };
	
	  /**
	   * This function converts the coordinates of a point from the frame of the
	   * graph to the frame of the camera.
	   *
	   * @param  {number} x The X coordinate of the point in the frame of the
	   *                    graph.
	   * @param  {number} y The Y coordinate of the point in the frame of the
	   *                    graph.
	   * @return {object}   The point coordinates in the frame of the camera.
	   */
	  sigma.classes.camera.prototype.cameraPosition = function(x, y, vector) {
	    var X = 0,
	        Y = 0,
	        cos = Math.cos(this.angle),
	        sin = Math.sin(this.angle);
	
	    // Revert the origin differential vector:
	    if (!vector) {
	      X = - (this.x * cos + this.y * sin) / this.ratio;
	      Y = - (this.y * cos - this.x * sin) / this.ratio;
	    }
	
	    return {
	      x: ((x - X) * cos - (y - Y) * sin) * this.ratio,
	      y: ((y - Y) * cos + (x - X) * sin) * this.ratio
	    };
	  };
	
	  /**
	   * This method returns the transformation matrix of the camera. This is
	   * especially useful to apply the camera view directly in shaders, in case of
	   * WebGL rendering.
	   *
	   * @return {array} The transformation matrix.
	   */
	  sigma.classes.camera.prototype.getMatrix = function() {
	    var scale = sigma.utils.matrices.scale(1 / this.ratio),
	        rotation = sigma.utils.matrices.rotation(this.angle),
	        translation = sigma.utils.matrices.translation(-this.x, -this.y),
	        matrix = sigma.utils.matrices.multiply(
	          translation,
	          sigma.utils.matrices.multiply(
	            rotation,
	            scale
	          )
	        );
	
	    return matrix;
	  };
	
	  /**
	   * Taking a width and a height as parameters, this method returns the
	   * coordinates of the rectangle representing the camera on screen, in the
	   * graph's referentiel.
	   *
	   * To keep displaying labels of nodes going out of the screen, the method
	   * keeps a margin around the screen in the returned rectangle.
	   *
	   * @param  {number} width  The width of the screen.
	   * @param  {number} height The height of the screen.
	   * @return {object}        The rectangle as x1, y1, x2 and y2, representing
	   *                         two opposite points.
	   */
	  sigma.classes.camera.prototype.getRectangle = function(width, height) {
	    var widthVect = this.cameraPosition(width, 0, true),
	        heightVect = this.cameraPosition(0, height, true),
	        centerVect = this.cameraPosition(width / 2, height / 2, true),
	        marginX = this.cameraPosition(width / 4, 0, true).x,
	        marginY = this.cameraPosition(0, height / 4, true).y;
	
	    return {
	      x1: this.x - centerVect.x - marginX,
	      y1: this.y - centerVect.y - marginY,
	      x2: this.x - centerVect.x + marginX + widthVect.x,
	      y2: this.y - centerVect.y - marginY + widthVect.y,
	      height: Math.sqrt(
	        Math.pow(heightVect.x, 2) +
	        Math.pow(heightVect.y + 2 * marginY, 2)
	      )
	    };
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 37:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  /**
	   * This utils aims to facilitate the manipulation of each instance setting.
	   * Using a function instead of an object brings two main advantages: First,
	   * it will be easier in the future to catch settings updates through a
	   * function than an object. Second, giving it a full object will "merge" it
	   * to the settings object properly, keeping us to have to always add a loop.
	   *
	   * @return {configurable} The "settings" function.
	   */
	  var configurable = function() {
	    var i,
	        l,
	        data = {},
	        datas = Array.prototype.slice.call(arguments, 0);
	
	    /**
	     * The method to use to set or get any property of this instance.
	     *
	     * @param  {string|object}    a1 If it is a string and if a2 is undefined,
	     *                               then it will return the corresponding
	     *                               property. If it is a string and if a2 is
	     *                               set, then it will set a2 as the property
	     *                               corresponding to a1, and return this. If
	     *                               it is an object, then each pair string +
	     *                               object(or any other type) will be set as a
	     *                               property.
	     * @param  {*?}               a2 The new property corresponding to a1 if a1
	     *                               is a string.
	     * @return {*|configurable}      Returns itself or the corresponding
	     *                               property.
	     *
	     * Polymorphism:
	     * *************
	     * Here are some basic use examples:
	     *
	     *  > settings = new configurable();
	     *  > settings('mySetting', 42);
	     *  > settings('mySetting'); // Logs: 42
	     *  > settings('mySetting', 123);
	     *  > settings('mySetting'); // Logs: 123
	     *  > settings({mySetting: 456});
	     *  > settings('mySetting'); // Logs: 456
	     *
	     * Also, it is possible to use the function as a fallback:
	     *  > settings({mySetting: 'abc'}, 'mySetting');  // Logs: 'abc'
	     *  > settings({hisSetting: 'abc'}, 'mySetting'); // Logs: 456
	     */
	    var settings = function(a1, a2) {
	      var o,
	          i,
	          l,
	          k;
	
	      if (arguments.length === 1 && typeof a1 === 'string') {
	        if (data[a1] !== undefined)
	          return data[a1];
	        for (i = 0, l = datas.length; i < l; i++)
	          if (datas[i][a1] !== undefined)
	            return datas[i][a1];
	        return undefined;
	      } else if (typeof a1 === 'object' && typeof a2 === 'string') {
	        return (a1 || {})[a2] !== undefined ? a1[a2] : settings(a2);
	      } else {
	        o = (typeof a1 === 'object' && a2 === undefined) ? a1 : {};
	
	        if (typeof a1 === 'string')
	          o[a1] = a2;
	
	        for (i = 0, k = Object.keys(o), l = k.length; i < l; i++)
	          data[k[i]] = o[k[i]];
	
	        return this;
	      }
	    };
	
	    /**
	     * This method returns a new configurable function, with new objects
	     *
	     * @param  {object*}  Any number of objects to search in.
	     * @return {function} Returns the function. Check its documentation to know
	     *                    more about how it works.
	     */
	    settings.embedObjects = function() {
	      var args = datas.concat(
	        data
	      ).concat(
	        Array.prototype.splice.call(arguments, 0)
	      );
	
	      return configurable.apply({}, args);
	    };
	
	    // Initialize
	    for (i = 0, l = arguments.length; i < l; i++)
	      settings(arguments[i]);
	
	    return settings;
	  };
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof this.sigma !== 'undefined') {
	    this.sigma.classes = this.sigma.classes || {};
	    this.sigma.classes.configurable = configurable;
	  } else if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = configurable;
	    exports.configurable = configurable;
	  } else
	    this.configurable = configurable;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 38:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  /**
	   * Dispatcher constructor.
	   *
	   * @return {dispatcher} The new dispatcher instance.
	   */
	  var dispatcher = function() {
	    Object.defineProperty(this, '_handlers', {
	      value: {}
	    });
	  };
	
	
	
	
	  /**
	   * Will execute the handler everytime that the indicated event (or the
	   * indicated events) will be triggered.
	   *
	   * @param  {string}           events  The name of the event (or the events
	   *                                    separated by spaces).
	   * @param  {function(Object)} handler The handler to bind.
	   * @return {dispatcher}               Returns the instance itself.
	   */
	  dispatcher.prototype.bind = function(events, handler) {
	    var i,
	        l,
	        event,
	        eArray;
	
	    if (
	      arguments.length === 1 &&
	      typeof arguments[0] === 'object'
	    )
	      for (events in arguments[0])
	        this.bind(events, arguments[0][events]);
	    else if (
	      arguments.length === 2 &&
	      typeof arguments[1] === 'function'
	    ) {
	      eArray = typeof events === 'string' ? events.split(' ') : events;
	
	      for (i = 0, l = eArray.length; i !== l; i += 1) {
	        event = eArray[i];
	
	        // Check that event is not '':
	        if (!event)
	          continue;
	
	        if (!this._handlers[event])
	          this._handlers[event] = [];
	
	        // Using an object instead of directly the handler will make possible
	        // later to add flags
	        this._handlers[event].push({
	          handler: handler
	        });
	      }
	    } else
	      throw 'bind: Wrong arguments.';
	
	    return this;
	  };
	
	  /**
	   * Removes the handler from a specified event (or specified events).
	   *
	   * @param  {?string}           events  The name of the event (or the events
	   *                                     separated by spaces). If undefined,
	   *                                     then all handlers are removed.
	   * @param  {?function(object)} handler The handler to unbind. If undefined,
	   *                                     each handler bound to the event or the
	   *                                     events will be removed.
	   * @return {dispatcher}                Returns the instance itself.
	   */
	  dispatcher.prototype.unbind = function(events, handler) {
	    var i,
	        n,
	        j,
	        m,
	        k,
	        a,
	        event,
	        eArray = typeof events === 'string' ? events.split(' ') : events;
	
	    if (!arguments.length) {
	      for (k in this._handlers)
	        delete this._handlers[k];
	      return this;
	    }
	
	    if (handler) {
	      for (i = 0, n = eArray.length; i !== n; i += 1) {
	        event = eArray[i];
	        if (this._handlers[event]) {
	          a = [];
	          for (j = 0, m = this._handlers[event].length; j !== m; j += 1)
	            if (this._handlers[event][j].handler !== handler)
	              a.push(this._handlers[event][j]);
	
	          this._handlers[event] = a;
	        }
	
	        if (this._handlers[event] && this._handlers[event].length === 0)
	          delete this._handlers[event];
	      }
	    } else
	      for (i = 0, n = eArray.length; i !== n; i += 1)
	        delete this._handlers[eArray[i]];
	
	    return this;
	  };
	
	  /**
	   * Executes each handler bound to the event
	   *
	   * @param  {string}     events The name of the event (or the events separated
	   *                             by spaces).
	   * @param  {?object}    data   The content of the event (optional).
	   * @return {dispatcher}        Returns the instance itself.
	   */
	  dispatcher.prototype.dispatchEvent = function(events, data) {
	    var i,
	        n,
	        j,
	        m,
	        a,
	        event,
	        eventName,
	        self = this,
	        eArray = typeof events === 'string' ? events.split(' ') : events;
	
	    data = data === undefined ? {} : data;
	
	    for (i = 0, n = eArray.length; i !== n; i += 1) {
	      eventName = eArray[i];
	
	      if (this._handlers[eventName]) {
	        event = self.getEvent(eventName, data);
	        a = [];
	
	        for (j = 0, m = this._handlers[eventName].length; j !== m; j += 1) {
	          this._handlers[eventName][j].handler(event);
	          if (!this._handlers[eventName][j].one)
	            a.push(this._handlers[eventName][j]);
	        }
	
	        this._handlers[eventName] = a;
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * Return an event object.
	   *
	   * @param  {string}  events The name of the event.
	   * @param  {?object} data   The content of the event (optional).
	   * @return {object}         Returns the instance itself.
	   */
	  dispatcher.prototype.getEvent = function(event, data) {
	    return {
	      type: event,
	      data: data || {},
	      target: this
	    };
	  };
	
	  /**
	   * A useful function to deal with inheritance. It will make the target
	   * inherit the prototype of the class dispatcher as well as its constructor.
	   *
	   * @param {object} target The target.
	   */
	  dispatcher.extend = function(target, args) {
	    var k;
	
	    for (k in dispatcher.prototype)
	      if (dispatcher.prototype.hasOwnProperty(k))
	        target[k] = dispatcher.prototype[k];
	
	    dispatcher.apply(target, args);
	  };
	
	
	
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof this.sigma !== 'undefined') {
	    this.sigma.classes = this.sigma.classes || {};
	    this.sigma.classes.dispatcher = dispatcher;
	  } else if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = dispatcher;
	    exports.dispatcher = dispatcher;
	  } else
	    this.dispatcher = dispatcher;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 39:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  /**
	   * Sigma Quadtree Module for edges
	   * ===============================
	   *
	   * Author: Sébastien Heymann,
	   *   from the quad of Guillaume Plique (Yomguithereal)
	   * Version: 0.2
	   */
	
	
	
	  /**
	   * Quad Geometric Operations
	   * -------------------------
	   *
	   * A useful batch of geometric operations used by the quadtree.
	   */
	
	  var _geom = {
	
	    /**
	     * Transforms a graph node with x, y and size into an
	     * axis-aligned square.
	     *
	     * @param  {object} A graph node with at least a point (x, y) and a size.
	     * @return {object} A square: two points (x1, y1), (x2, y2) and height.
	     */
	    pointToSquare: function(n) {
	      return {
	        x1: n.x - n.size,
	        y1: n.y - n.size,
	        x2: n.x + n.size,
	        y2: n.y - n.size,
	        height: n.size * 2
	      };
	    },
	
	    /**
	     * Transforms a graph edge with x1, y1, x2, y2 and size into an
	     * axis-aligned square.
	     *
	     * @param  {object} A graph edge with at least two points
	     *                  (x1, y1), (x2, y2) and a size.
	     * @return {object} A square: two points (x1, y1), (x2, y2) and height.
	     */
	    lineToSquare: function(e) {
	      if (e.y1 < e.y2) {
	        // (e.x1, e.y1) on top
	        if (e.x1 < e.x2) {
	          // (e.x1, e.y1) on left
	          return {
	            x1: e.x1 - e.size,
	            y1: e.y1 - e.size,
	            x2: e.x2 + e.size,
	            y2: e.y1 - e.size,
	            height: e.y2 - e.y1 + e.size * 2
	          };
	        }
	        // (e.x1, e.y1) on right
	        return {
	          x1: e.x2 - e.size,
	          y1: e.y1 - e.size,
	          x2: e.x1 + e.size,
	          y2: e.y1 - e.size,
	          height: e.y2 - e.y1 + e.size * 2
	        };
	      }
	
	      // (e.x2, e.y2) on top
	      if (e.x1 < e.x2) {
	        // (e.x1, e.y1) on left
	        return {
	          x1: e.x1 - e.size,
	          y1: e.y2 - e.size,
	          x2: e.x2 + e.size,
	          y2: e.y2 - e.size,
	          height: e.y1 - e.y2 + e.size * 2
	        };
	      }
	      // (e.x2, e.y2) on right
	      return {
	        x1: e.x2 - e.size,
	        y1: e.y2 - e.size,
	        x2: e.x1 + e.size,
	        y2: e.y2 - e.size,
	        height: e.y1 - e.y2 + e.size * 2
	      };
	    },
	
	    /**
	     * Transforms a graph edge of type 'curve' with x1, y1, x2, y2,
	     * control point and size into an axis-aligned square.
	     *
	     * @param  {object} e  A graph edge with at least two points
	     *                     (x1, y1), (x2, y2) and a size.
	     * @param  {object} cp A control point (x,y).
	     * @return {object}    A square: two points (x1, y1), (x2, y2) and height.
	     */
	    quadraticCurveToSquare: function(e, cp) {
	      var pt = sigma.utils.getPointOnQuadraticCurve(
	        0.5,
	        e.x1,
	        e.y1,
	        e.x2,
	        e.y2,
	        cp.x,
	        cp.y
	      );
	
	      // Bounding box of the two points and the point at the middle of the
	      // curve:
	      var minX = Math.min(e.x1, e.x2, pt.x),
	          maxX = Math.max(e.x1, e.x2, pt.x),
	          minY = Math.min(e.y1, e.y2, pt.y),
	          maxY = Math.max(e.y1, e.y2, pt.y);
	
	      return {
	        x1: minX - e.size,
	        y1: minY - e.size,
	        x2: maxX + e.size,
	        y2: minY - e.size,
	        height: maxY - minY + e.size * 2
	      };
	    },
	
	    /**
	     * Transforms a graph self loop into an axis-aligned square.
	     *
	     * @param  {object} n A graph node with a point (x, y) and a size.
	     * @return {object}   A square: two points (x1, y1), (x2, y2) and height.
	     */
	    selfLoopToSquare: function(n) {
	      // Fitting to the curve is too costly, we compute a larger bounding box
	      // using the control points:
	      var cp = sigma.utils.getSelfLoopControlPoints(n.x, n.y, n.size);
	
	      // Bounding box of the point and the two control points:
	      var minX = Math.min(n.x, cp.x1, cp.x2),
	          maxX = Math.max(n.x, cp.x1, cp.x2),
	          minY = Math.min(n.y, cp.y1, cp.y2),
	          maxY = Math.max(n.y, cp.y1, cp.y2);
	
	      return {
	        x1: minX - n.size,
	        y1: minY - n.size,
	        x2: maxX + n.size,
	        y2: minY - n.size,
	        height: maxY - minY + n.size * 2
	      };
	    },
	
	    /**
	     * Checks whether a rectangle is axis-aligned.
	     *
	     * @param  {object}  A rectangle defined by two points
	     *                   (x1, y1) and (x2, y2).
	     * @return {boolean} True if the rectangle is axis-aligned.
	     */
	    isAxisAligned: function(r) {
	      return r.x1 === r.x2 || r.y1 === r.y2;
	    },
	
	    /**
	     * Compute top points of an axis-aligned rectangle. This is useful in
	     * cases when the rectangle has been rotated (left, right or bottom up) and
	     * later operations need to know the top points.
	     *
	     * @param  {object} An axis-aligned rectangle defined by two points
	     *                  (x1, y1), (x2, y2) and height.
	     * @return {object} A rectangle: two points (x1, y1), (x2, y2) and height.
	     */
	    axisAlignedTopPoints: function(r) {
	
	      // Basic
	      if (r.y1 === r.y2 && r.x1 < r.x2)
	        return r;
	
	      // Rotated to right
	      if (r.x1 === r.x2 && r.y2 > r.y1)
	        return {
	          x1: r.x1 - r.height, y1: r.y1,
	          x2: r.x1, y2: r.y1,
	          height: r.height
	        };
	
	      // Rotated to left
	      if (r.x1 === r.x2 && r.y2 < r.y1)
	        return {
	          x1: r.x1, y1: r.y2,
	          x2: r.x2 + r.height, y2: r.y2,
	          height: r.height
	        };
	
	      // Bottom's up
	      return {
	        x1: r.x2, y1: r.y1 - r.height,
	        x2: r.x1, y2: r.y1 - r.height,
	        height: r.height
	      };
	    },
	
	    /**
	     * Get coordinates of a rectangle's lower left corner from its top points.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @return {object} Coordinates of the corner (x, y).
	     */
	    lowerLeftCoor: function(r) {
	      var width = (
	        Math.sqrt(
	          Math.pow(r.x2 - r.x1, 2) +
	          Math.pow(r.y2 - r.y1, 2)
	        )
	      );
	
	      return {
	        x: r.x1 - (r.y2 - r.y1) * r.height / width,
	        y: r.y1 + (r.x2 - r.x1) * r.height / width
	      };
	    },
	
	    /**
	     * Get coordinates of a rectangle's lower right corner from its top points
	     * and its lower left corner.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @param  {object} A corner's coordinates (x, y).
	     * @return {object} Coordinates of the corner (x, y).
	     */
	    lowerRightCoor: function(r, llc) {
	      return {
	        x: llc.x - r.x1 + r.x2,
	        y: llc.y - r.y1 + r.y2
	      };
	    },
	
	    /**
	     * Get the coordinates of all the corners of a rectangle from its top point.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @return {array}  An array of the four corners' coordinates (x, y).
	     */
	    rectangleCorners: function(r) {
	      var llc = this.lowerLeftCoor(r),
	          lrc = this.lowerRightCoor(r, llc);
	
	      return [
	        {x: r.x1, y: r.y1},
	        {x: r.x2, y: r.y2},
	        {x: llc.x, y: llc.y},
	        {x: lrc.x, y: lrc.y}
	      ];
	    },
	
	    /**
	     * Split a square defined by its boundaries into four.
	     *
	     * @param  {object} Boundaries of the square (x, y, width, height).
	     * @return {array}  An array containing the four new squares, themselves
	     *                  defined by an array of their four corners (x, y).
	     */
	    splitSquare: function(b) {
	      return [
	        [
	          {x: b.x, y: b.y},
	          {x: b.x + b.width / 2, y: b.y},
	          {x: b.x, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2}
	        ],
	        [
	          {x: b.x + b.width / 2, y: b.y},
	          {x: b.x + b.width, y: b.y},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x + b.width, y: b.y + b.height / 2}
	        ],
	        [
	          {x: b.x, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x, y: b.y + b.height},
	          {x: b.x + b.width / 2, y: b.y + b.height}
	        ],
	        [
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x + b.width, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height},
	          {x: b.x + b.width, y: b.y + b.height}
	        ]
	      ];
	    },
	
	    /**
	     * Compute the four axis between corners of rectangle A and corners of
	     * rectangle B. This is needed later to check an eventual collision.
	     *
	     * @param  {array} An array of rectangle A's four corners (x, y).
	     * @param  {array} An array of rectangle B's four corners (x, y).
	     * @return {array} An array of four axis defined by their coordinates (x,y).
	     */
	    axis: function(c1, c2) {
	      return [
	        {x: c1[1].x - c1[0].x, y: c1[1].y - c1[0].y},
	        {x: c1[1].x - c1[3].x, y: c1[1].y - c1[3].y},
	        {x: c2[0].x - c2[2].x, y: c2[0].y - c2[2].y},
	        {x: c2[0].x - c2[1].x, y: c2[0].y - c2[1].y}
	      ];
	    },
	
	    /**
	     * Project a rectangle's corner on an axis.
	     *
	     * @param  {object} Coordinates of a corner (x, y).
	     * @param  {object} Coordinates of an axis (x, y).
	     * @return {object} The projection defined by coordinates (x, y).
	     */
	    projection: function(c, a) {
	      var l = (
	        (c.x * a.x + c.y * a.y) /
	        (Math.pow(a.x, 2) + Math.pow(a.y, 2))
	      );
	
	      return {
	        x: l * a.x,
	        y: l * a.y
	      };
	    },
	
	    /**
	     * Check whether two rectangles collide on one particular axis.
	     *
	     * @param  {object}   An axis' coordinates (x, y).
	     * @param  {array}    Rectangle A's corners.
	     * @param  {array}    Rectangle B's corners.
	     * @return {boolean}  True if the rectangles collide on the axis.
	     */
	    axisCollision: function(a, c1, c2) {
	      var sc1 = [],
	          sc2 = [];
	
	      for (var ci = 0; ci < 4; ci++) {
	        var p1 = this.projection(c1[ci], a),
	            p2 = this.projection(c2[ci], a);
	
	        sc1.push(p1.x * a.x + p1.y * a.y);
	        sc2.push(p2.x * a.x + p2.y * a.y);
	      }
	
	      var maxc1 = Math.max.apply(Math, sc1),
	          maxc2 = Math.max.apply(Math, sc2),
	          minc1 = Math.min.apply(Math, sc1),
	          minc2 = Math.min.apply(Math, sc2);
	
	      return (minc2 <= maxc1 && maxc2 >= minc1);
	    },
	
	    /**
	     * Check whether two rectangles collide on each one of their four axis. If
	     * all axis collide, then the two rectangles do collide on the plane.
	     *
	     * @param  {array}    Rectangle A's corners.
	     * @param  {array}    Rectangle B's corners.
	     * @return {boolean}  True if the rectangles collide.
	     */
	    collision: function(c1, c2) {
	      var axis = this.axis(c1, c2),
	          col = true;
	
	      for (var i = 0; i < 4; i++)
	        col = col && this.axisCollision(axis[i], c1, c2);
	
	      return col;
	    }
	  };
	
	
	  /**
	   * Quad Functions
	   * ------------
	   *
	   * The Quadtree functions themselves.
	   * For each of those functions, we consider that in a splitted quad, the
	   * index of each node is the following:
	   * 0: top left
	   * 1: top right
	   * 2: bottom left
	   * 3: bottom right
	   *
	   * Moreover, the hereafter quad's philosophy is to consider that if an element
	   * collides with more than one nodes, this element belongs to each of the
	   * nodes it collides with where other would let it lie on a higher node.
	   */
	
	  /**
	   * Get the index of the node containing the point in the quad
	   *
	   * @param  {object}  point      A point defined by coordinates (x, y).
	   * @param  {object}  quadBounds Boundaries of the quad (x, y, width, heigth).
	   * @return {integer}            The index of the node containing the point.
	   */
	  function _quadIndex(point, quadBounds) {
	    var xmp = quadBounds.x + quadBounds.width / 2,
	        ymp = quadBounds.y + quadBounds.height / 2,
	        top = (point.y < ymp),
	        left = (point.x < xmp);
	
	    if (top) {
	      if (left)
	        return 0;
	      else
	        return 1;
	    }
	    else {
	      if (left)
	        return 2;
	      else
	        return 3;
	    }
	  }
	
	  /**
	   * Get a list of indexes of nodes containing an axis-aligned rectangle
	   *
	   * @param  {object}  rectangle   A rectangle defined by two points (x1, y1),
	   *                               (x2, y2) and height.
	   * @param  {array}   quadCorners An array of the quad nodes' corners.
	   * @return {array}               An array of indexes containing one to
	   *                               four integers.
	   */
	  function _quadIndexes(rectangle, quadCorners) {
	    var indexes = [];
	
	    // Iterating through quads
	    for (var i = 0; i < 4; i++)
	      if ((rectangle.x2 >= quadCorners[i][0].x) &&
	          (rectangle.x1 <= quadCorners[i][1].x) &&
	          (rectangle.y1 + rectangle.height >= quadCorners[i][0].y) &&
	          (rectangle.y1 <= quadCorners[i][2].y))
	        indexes.push(i);
	
	    return indexes;
	  }
	
	  /**
	   * Get a list of indexes of nodes containing a non-axis-aligned rectangle
	   *
	   * @param  {array}  corners      An array containing each corner of the
	   *                               rectangle defined by its coordinates (x, y).
	   * @param  {array}  quadCorners  An array of the quad nodes' corners.
	   * @return {array}               An array of indexes containing one to
	   *                               four integers.
	   */
	  function _quadCollision(corners, quadCorners) {
	    var indexes = [];
	
	    // Iterating through quads
	    for (var i = 0; i < 4; i++)
	      if (_geom.collision(corners, quadCorners[i]))
	        indexes.push(i);
	
	    return indexes;
	  }
	
	  /**
	   * Subdivide a quad by creating a node at a precise index. The function does
	   * not generate all four nodes not to potentially create unused nodes.
	   *
	   * @param  {integer}  index The index of the node to create.
	   * @param  {object}   quad  The quad object to subdivide.
	   * @return {object}         A new quad representing the node created.
	   */
	  function _quadSubdivide(index, quad) {
	    var next = quad.level + 1,
	        subw = Math.round(quad.bounds.width / 2),
	        subh = Math.round(quad.bounds.height / 2),
	        qx = Math.round(quad.bounds.x),
	        qy = Math.round(quad.bounds.y),
	        x,
	        y;
	
	    switch (index) {
	      case 0:
	        x = qx;
	        y = qy;
	        break;
	      case 1:
	        x = qx + subw;
	        y = qy;
	        break;
	      case 2:
	        x = qx;
	        y = qy + subh;
	        break;
	      case 3:
	        x = qx + subw;
	        y = qy + subh;
	        break;
	    }
	
	    return _quadTree(
	      {x: x, y: y, width: subw, height: subh},
	      next,
	      quad.maxElements,
	      quad.maxLevel
	    );
	  }
	
	  /**
	   * Recursively insert an element into the quadtree. Only points
	   * with size, i.e. axis-aligned squares, may be inserted with this
	   * method.
	   *
	   * @param  {object}  el         The element to insert in the quadtree.
	   * @param  {object}  sizedPoint A sized point defined by two top points
	   *                              (x1, y1), (x2, y2) and height.
	   * @param  {object}  quad       The quad in which to insert the element.
	   * @return {undefined}          The function does not return anything.
	   */
	  function _quadInsert(el, sizedPoint, quad) {
	    if (quad.level < quad.maxLevel) {
	
	      // Searching appropriate quads
	      var indexes = _quadIndexes(sizedPoint, quad.corners);
	
	      // Iterating
	      for (var i = 0, l = indexes.length; i < l; i++) {
	
	        // Subdividing if necessary
	        if (quad.nodes[indexes[i]] === undefined)
	          quad.nodes[indexes[i]] = _quadSubdivide(indexes[i], quad);
	
	        // Recursion
	        _quadInsert(el, sizedPoint, quad.nodes[indexes[i]]);
	      }
	    }
	    else {
	
	      // Pushing the element in a leaf node
	      quad.elements.push(el);
	    }
	  }
	
	  /**
	   * Recursively retrieve every elements held by the node containing the
	   * searched point.
	   *
	   * @param  {object}  point The searched point (x, y).
	   * @param  {object}  quad  The searched quad.
	   * @return {array}         An array of elements contained in the relevant
	   *                         node.
	   */
	  function _quadRetrievePoint(point, quad) {
	    if (quad.level < quad.maxLevel) {
	      var index = _quadIndex(point, quad.bounds);
	
	      // If node does not exist we return an empty list
	      if (quad.nodes[index] !== undefined) {
	        return _quadRetrievePoint(point, quad.nodes[index]);
	      }
	      else {
	        return [];
	      }
	    }
	    else {
	      return quad.elements;
	    }
	  }
	
	  /**
	   * Recursively retrieve every elements contained within an rectangular area
	   * that may or may not be axis-aligned.
	   *
	   * @param  {object|array} rectData       The searched area defined either by
	   *                                       an array of four corners (x, y) in
	   *                                       the case of a non-axis-aligned
	   *                                       rectangle or an object with two top
	   *                                       points (x1, y1), (x2, y2) and height.
	   * @param  {object}       quad           The searched quad.
	   * @param  {function}     collisionFunc  The collision function used to search
	   *                                       for node indexes.
	   * @param  {array?}       els            The retrieved elements.
	   * @return {array}                       An array of elements contained in the
	   *                                       area.
	   */
	  function _quadRetrieveArea(rectData, quad, collisionFunc, els) {
	    els = els || {};
	
	    if (quad.level < quad.maxLevel) {
	      var indexes = collisionFunc(rectData, quad.corners);
	
	      for (var i = 0, l = indexes.length; i < l; i++)
	        if (quad.nodes[indexes[i]] !== undefined)
	          _quadRetrieveArea(
	            rectData,
	            quad.nodes[indexes[i]],
	            collisionFunc,
	            els
	          );
	    } else
	      for (var j = 0, m = quad.elements.length; j < m; j++)
	        if (els[quad.elements[j].id] === undefined)
	          els[quad.elements[j].id] = quad.elements[j];
	
	    return els;
	  }
	
	  /**
	   * Creates the quadtree object itself.
	   *
	   * @param  {object}   bounds       The boundaries of the quad defined by an
	   *                                 origin (x, y), width and heigth.
	   * @param  {integer}  level        The level of the quad in the tree.
	   * @param  {integer}  maxElements  The max number of element in a leaf node.
	   * @param  {integer}  maxLevel     The max recursion level of the tree.
	   * @return {object}                The quadtree object.
	   */
	  function _quadTree(bounds, level, maxElements, maxLevel) {
	    return {
	      level: level || 0,
	      bounds: bounds,
	      corners: _geom.splitSquare(bounds),
	      maxElements: maxElements || 40,
	      maxLevel: maxLevel || 8,
	      elements: [],
	      nodes: []
	    };
	  }
	
	
	  /**
	   * Sigma Quad Constructor
	   * ----------------------
	   *
	   * The edgequad API as exposed to sigma.
	   */
	
	  /**
	   * The edgequad core that will become the sigma interface with the quadtree.
	   *
	   * property {object} _tree     Property holding the quadtree object.
	   * property {object} _geom     Exposition of the _geom namespace for testing.
	   * property {object} _cache    Cache for the area method.
	   * property {boolean} _enabled Can index and retreive elements.
	   */
	  var edgequad = function() {
	    this._geom = _geom;
	    this._tree = null;
	    this._cache = {
	      query: false,
	      result: false
	    };
	    this._enabled = true;
	  };
	
	  /**
	   * Index a graph by inserting its edges into the quadtree.
	   *
	   * @param  {object} graph   A graph instance.
	   * @param  {object} params  An object of parameters with at least the quad
	   *                          bounds.
	   * @return {object}         The quadtree object.
	   *
	   * Parameters:
	   * ----------
	   * bounds:      {object}   boundaries of the quad defined by its origin (x, y)
	   *                         width and heigth.
	   * prefix:      {string?}  a prefix for edge geometric attributes.
	   * maxElements: {integer?} the max number of elements in a leaf node.
	   * maxLevel:    {integer?} the max recursion level of the tree.
	   */
	  edgequad.prototype.index = function(graph, params) {
	    if (!this._enabled)
	      return this._tree;
	
	    // Enforcing presence of boundaries
	    if (!params.bounds)
	      throw 'sigma.classes.edgequad.index: bounds information not given.';
	
	    // Prefix
	    var prefix = params.prefix || '',
	        cp,
	        source,
	        target,
	        n,
	        e;
	
	    // Building the tree
	    this._tree = _quadTree(
	      params.bounds,
	      0,
	      params.maxElements,
	      params.maxLevel
	    );
	
	    var edges = graph.edges();
	
	    // Inserting graph edges into the tree
	    for (var i = 0, l = edges.length; i < l; i++) {
	      source = graph.nodes(edges[i].source);
	      target = graph.nodes(edges[i].target);
	      e = {
	        x1: source[prefix + 'x'],
	        y1: source[prefix + 'y'],
	        x2: target[prefix + 'x'],
	        y2: target[prefix + 'y'],
	        size: edges[i][prefix + 'size'] || 0
	      };
	
	      // Inserting edge
	      if (edges[i].type === 'curve' || edges[i].type === 'curvedArrow') {
	        if (source.id === target.id) {
	          n = {
	            x: source[prefix + 'x'],
	            y: source[prefix + 'y'],
	            size: source[prefix + 'size'] || 0
	          };
	          _quadInsert(
	            edges[i],
	            _geom.selfLoopToSquare(n),
	            this._tree);
	        }
	        else {
	          cp = sigma.utils.getQuadraticControlPoint(e.x1, e.y1, e.x2, e.y2);
	          _quadInsert(
	            edges[i],
	            _geom.quadraticCurveToSquare(e, cp),
	            this._tree);
	        }
	      }
	      else {
	        _quadInsert(
	          edges[i],
	          _geom.lineToSquare(e),
	          this._tree);
	      }
	    }
	
	    // Reset cache:
	    this._cache = {
	      query: false,
	      result: false
	    };
	
	    // remove?
	    return this._tree;
	  };
	
	  /**
	   * Retrieve every graph edges held by the quadtree node containing the
	   * searched point.
	   *
	   * @param  {number} x of the point.
	   * @param  {number} y of the point.
	   * @return {array}  An array of edges retrieved.
	   */
	  edgequad.prototype.point = function(x, y) {
	    if (!this._enabled)
	      return [];
	
	    return this._tree ?
	      _quadRetrievePoint({x: x, y: y}, this._tree) || [] :
	      [];
	  };
	
	  /**
	   * Retrieve every graph edges within a rectangular area. The methods keep the
	   * last area queried in cache for optimization reason and will act differently
	   * for the same reason if the area is axis-aligned or not.
	   *
	   * @param  {object} A rectangle defined by two top points (x1, y1), (x2, y2)
	   *                  and height.
	   * @return {array}  An array of edges retrieved.
	   */
	  edgequad.prototype.area = function(rect) {
	    if (!this._enabled)
	      return [];
	
	    var serialized = JSON.stringify(rect),
	        collisionFunc,
	        rectData;
	
	    // Returning cache?
	    if (this._cache.query === serialized)
	      return this._cache.result;
	
	    // Axis aligned ?
	    if (_geom.isAxisAligned(rect)) {
	      collisionFunc = _quadIndexes;
	      rectData = _geom.axisAlignedTopPoints(rect);
	    }
	    else {
	      collisionFunc = _quadCollision;
	      rectData = _geom.rectangleCorners(rect);
	    }
	
	    // Retrieving edges
	    var edges = this._tree ?
	      _quadRetrieveArea(
	        rectData,
	        this._tree,
	        collisionFunc
	      ) :
	      [];
	
	    // Object to array
	    var edgesArray = [];
	    for (var i in edges)
	      edgesArray.push(edges[i]);
	
	    // Caching
	    this._cache.query = serialized;
	    this._cache.result = edgesArray;
	
	    return edgesArray;
	  };
	
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof this.sigma !== 'undefined') {
	    this.sigma.classes = this.sigma.classes || {};
	    this.sigma.classes.edgequad = edgequad;
	  } else if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = edgequad;
	    exports.edgequad = edgequad;
	  } else
	    this.edgequad = edgequad;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 40:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  var _methods = Object.create(null),
	      _indexes = Object.create(null),
	      _initBindings = Object.create(null),
	      _methodBindings = Object.create(null),
	      _methodBeforeBindings = Object.create(null),
	      _defaultSettings = {
	        immutable: true,
	        clone: true
	      },
	      _defaultSettingsFunction = function(key) {
	        return _defaultSettings[key];
	      };
	
	  /**
	   * The graph constructor. It initializes the data and the indexes, and binds
	   * the custom indexes and methods to its own scope.
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters in the settings
	   * object:
	   *
	   *   {boolean} clone     Indicates if the data have to be cloned in methods
	   *                       to add nodes or edges.
	   *   {boolean} immutable Indicates if nodes "id" values and edges "id",
	   *                       "source" and "target" values must be set as
	   *                       immutable.
	   *
	   * @param  {?configurable} settings Eventually a settings function.
	   * @return {graph}                  The new graph instance.
	   */
	  var graph = function(settings) {
	    var k,
	        fn,
	        data;
	
	    /**
	     * DATA:
	     * *****
	     * Every data that is callable from graph methods are stored in this "data"
	     * object. This object will be served as context for all these methods,
	     * and it is possible to add other type of data in it.
	     */
	    data = {
	      /**
	       * SETTINGS FUNCTION:
	       * ******************
	       */
	      settings: settings || _defaultSettingsFunction,
	
	      /**
	       * MAIN DATA:
	       * **********
	       */
	      nodesArray: [],
	      edgesArray: [],
	
	      /**
	       * GLOBAL INDEXES:
	       * ***************
	       * These indexes just index data by ids.
	       */
	      nodesIndex: Object.create(null),
	      edgesIndex: Object.create(null),
	
	      /**
	       * LOCAL INDEXES:
	       * **************
	       * These indexes refer from node to nodes. Each key is an id, and each
	       * value is the array of the ids of related nodes.
	       */
	      inNeighborsIndex: Object.create(null),
	      outNeighborsIndex: Object.create(null),
	      allNeighborsIndex: Object.create(null),
	
	      inNeighborsCount: Object.create(null),
	      outNeighborsCount: Object.create(null),
	      allNeighborsCount: Object.create(null)
	    };
	
	    // Execute bindings:
	    for (k in _initBindings)
	      _initBindings[k].call(data);
	
	    // Add methods to both the scope and the data objects:
	    for (k in _methods) {
	      fn = __bindGraphMethod(k, data, _methods[k]);
	      this[k] = fn;
	      data[k] = fn;
	    }
	  };
	
	
	
	
	  /**
	   * A custom tool to bind methods such that function that are bound to it will
	   * be executed anytime the method is called.
	   *
	   * @param  {string}   methodName The name of the method to bind.
	   * @param  {object}   scope      The scope where the method must be executed.
	   * @param  {function} fn         The method itself.
	   * @return {function}            The new method.
	   */
	  function __bindGraphMethod(methodName, scope, fn) {
	    var result = function() {
	      var k,
	          res;
	
	      // Execute "before" bound functions:
	      for (k in _methodBeforeBindings[methodName])
	        _methodBeforeBindings[methodName][k].apply(scope, arguments);
	
	      // Apply the method:
	      res = fn.apply(scope, arguments);
	
	      // Execute bound functions:
	      for (k in _methodBindings[methodName])
	        _methodBindings[methodName][k].apply(scope, arguments);
	
	      // Return res:
	      return res;
	    };
	
	    return result;
	  }
	
	  /**
	   * This custom tool function removes every pair key/value from an hash. The
	   * goal is to avoid creating a new object while some other references are
	   * still hanging in some scopes...
	   *
	   * @param  {object} obj The object to empty.
	   * @return {object}     The empty object.
	   */
	  function __emptyObject(obj) {
	    var k;
	
	    for (k in obj)
	      if (!('hasOwnProperty' in obj) || obj.hasOwnProperty(k))
	        delete obj[k];
	
	    return obj;
	  }
	
	
	
	
	  /**
	   * This global method adds a method that will be bound to the futurly created
	   * graph instances.
	   *
	   * Since these methods will be bound to their scope when the instances are
	   * created, it does not use the prototype. Because of that, methods have to
	   * be added before instances are created to make them available.
	   *
	   * Here is an example:
	   *
	   *  > graph.addMethod('getNodesCount', function() {
	   *  >   return this.nodesArray.length;
	   *  > });
	   *  >
	   *  > var myGraph = new graph();
	   *  > console.log(myGraph.getNodesCount()); // outputs 0
	   *
	   * @param  {string}   methodName The name of the method.
	   * @param  {function} fn         The method itself.
	   * @return {object}              The global graph constructor.
	   */
	  graph.addMethod = function(methodName, fn) {
	    if (
	      typeof methodName !== 'string' ||
	      typeof fn !== 'function' ||
	      arguments.length !== 2
	    )
	      throw 'addMethod: Wrong arguments.';
	
	    if (_methods[methodName] || graph[methodName])
	      throw 'The method "' + methodName + '" already exists.';
	
	    _methods[methodName] = fn;
	    _methodBindings[methodName] = Object.create(null);
	    _methodBeforeBindings[methodName] = Object.create(null);
	
	    return this;
	  };
	
	  /**
	   * This global method returns true if the method has already been added, and
	   * false else.
	   *
	   * Here are some examples:
	   *
	   *  > graph.hasMethod('addNode'); // returns true
	   *  > graph.hasMethod('hasMethod'); // returns true
	   *  > graph.hasMethod('unexistingMethod'); // returns false
	   *
	   * @param  {string}  methodName The name of the method.
	   * @return {boolean}            The result.
	   */
	  graph.hasMethod = function(methodName) {
	    return !!(_methods[methodName] || graph[methodName]);
	  };
	
	  /**
	   * This global methods attaches a function to a method. Anytime the specified
	   * method is called, the attached function is called right after, with the
	   * same arguments and in the same scope. The attached function is called
	   * right before if the last argument is true, unless the method is the graph
	   * constructor.
	   *
	   * To attach a function to the graph constructor, use 'constructor' as the
	   * method name (first argument).
	   *
	   * The main idea is to have a clean way to keep custom indexes up to date,
	   * for instance:
	   *
	   *  > var timesAddNodeCalled = 0;
	   *  > graph.attach('addNode', 'timesAddNodeCalledInc', function() {
	   *  >   timesAddNodeCalled++;
	   *  > });
	   *  >
	   *  > var myGraph = new graph();
	   *  > console.log(timesAddNodeCalled); // outputs 0
	   *  >
	   *  > myGraph.addNode({ id: '1' }).addNode({ id: '2' });
	   *  > console.log(timesAddNodeCalled); // outputs 2
	   *
	   * The idea for calling a function before is to provide pre-processors, for
	   * instance:
	   *
	   *  > var colorPalette = { Person: '#C3CBE1', Place: '#9BDEBD' };
	   *  > graph.attach('addNode', 'applyNodeColorPalette', function(n) {
	   *  >   n.color = colorPalette[n.category];
	   *  > }, true);
	   *  >
	   *  > var myGraph = new graph();
	   *  > myGraph.addNode({ id: 'n0', category: 'Person' });
	   *  > console.log(myGraph.nodes('n0').color); // outputs '#C3CBE1'
	   *
	   * @param  {string}   methodName The name of the related method or
	   *                               "constructor".
	   * @param  {string}   key        The key to identify the function to attach.
	   * @param  {function} fn         The function to bind.
	   * @param  {boolean}  before     If true the function is called right before.
	   * @return {object}              The global graph constructor.
	   */
	  graph.attach = function(methodName, key, fn, before) {
	    if (
	      typeof methodName !== 'string' ||
	      typeof key !== 'string' ||
	      typeof fn !== 'function' ||
	      arguments.length < 3 ||
	      arguments.length > 4
	    )
	      throw 'attach: Wrong arguments.';
	
	    var bindings;
	
	    if (methodName === 'constructor')
	      bindings = _initBindings;
	    else {
	      if (before) {
	        if (!_methodBeforeBindings[methodName])
	        throw 'The method "' + methodName + '" does not exist.';
	
	        bindings = _methodBeforeBindings[methodName];
	      }
	      else {
	        if (!_methodBindings[methodName])
	          throw 'The method "' + methodName + '" does not exist.';
	
	        bindings = _methodBindings[methodName];
	      }
	    }
	
	    if (bindings[key])
	      throw 'A function "' + key + '" is already attached ' +
	            'to the method "' + methodName + '".';
	
	    bindings[key] = fn;
	
	    return this;
	  };
	
	  /**
	   * Alias of attach(methodName, key, fn, true).
	   */
	  graph.attachBefore = function(methodName, key, fn) {
	    return this.attach(methodName, key, fn, true);
	  };
	
	  /**
	   * This methods is just an helper to deal with custom indexes. It takes as
	   * arguments the name of the index and an object containing all the different
	   * functions to bind to the methods.
	   *
	   * Here is a basic example, that creates an index to keep the number of nodes
	   * in the current graph. It also adds a method to provide a getter on that
	   * new index:
	   *
	   *  > sigma.classes.graph.addIndex('nodesCount', {
	   *  >   constructor: function() {
	   *  >     this.nodesCount = 0;
	   *  >   },
	   *  >   addNode: function() {
	   *  >     this.nodesCount++;
	   *  >   },
	   *  >   dropNode: function() {
	   *  >     this.nodesCount--;
	   *  >   }
	   *  > });
	   *  >
	   *  > sigma.classes.graph.addMethod('getNodesCount', function() {
	   *  >   return this.nodesCount;
	   *  > });
	   *  >
	   *  > var myGraph = new sigma.classes.graph();
	   *  > console.log(myGraph.getNodesCount()); // outputs 0
	   *  >
	   *  > myGraph.addNode({ id: '1' }).addNode({ id: '2' });
	   *  > console.log(myGraph.getNodesCount()); // outputs 2
	   *
	   * @param  {string} name     The name of the index.
	   * @param  {object} bindings The object containing the functions to bind.
	   * @return {object}          The global graph constructor.
	   */
	  graph.addIndex = function(name, bindings) {
	    if (
	      typeof name !== 'string' ||
	      Object(bindings) !== bindings ||
	      arguments.length !== 2
	    )
	      throw 'addIndex: Wrong arguments.';
	
	    if (_indexes[name])
	      throw 'The index "' + name + '" already exists.';
	
	    var k;
	
	    // Store the bindings:
	    _indexes[name] = bindings;
	
	    // Attach the bindings:
	    for (k in bindings)
	      if (typeof bindings[k] !== 'function')
	        throw 'The bindings must be functions.';
	      else
	        graph.attach(k, name, bindings[k]);
	
	    return this;
	  };
	
	
	
	
	  /**
	   * This method adds a node to the graph. The node must be an object, with a
	   * string under the key "id". Except for this, it is possible to add any
	   * other attribute, that will be preserved all along the manipulations.
	   *
	   * If the graph option "clone" has a truthy value, the node will be cloned
	   * when added to the graph. Also, if the graph option "immutable" has a
	   * truthy value, its id will be defined as immutable.
	   *
	   * @param  {object} node The node to add.
	   * @return {object}      The graph instance.
	   */
	  graph.addMethod('addNode', function(node) {
	    // Check that the node is an object and has an id:
	    if (Object(node) !== node || arguments.length !== 1)
	      throw 'addNode: Wrong arguments.';
	
	    if (typeof node.id !== 'string' && typeof node.id !== 'number')
	      throw 'The node must have a string or number id.';
	
	    if (this.nodesIndex[node.id])
	      throw 'The node "' + node.id + '" already exists.';
	
	    var k,
	        id = node.id,
	        validNode = Object.create(null);
	
	    // Check the "clone" option:
	    if (this.settings('clone')) {
	      for (k in node)
	        if (k !== 'id')
	          validNode[k] = node[k];
	    } else
	      validNode = node;
	
	    // Check the "immutable" option:
	    if (this.settings('immutable'))
	      Object.defineProperty(validNode, 'id', {
	        value: id,
	        enumerable: true
	      });
	    else
	      validNode.id = id;
	
	    // Add empty containers for edges indexes:
	    this.inNeighborsIndex[id] = Object.create(null);
	    this.outNeighborsIndex[id] = Object.create(null);
	    this.allNeighborsIndex[id] = Object.create(null);
	
	    this.inNeighborsCount[id] = 0;
	    this.outNeighborsCount[id] = 0;
	    this.allNeighborsCount[id] = 0;
	
	    // Add the node to indexes:
	    this.nodesArray.push(validNode);
	    this.nodesIndex[validNode.id] = validNode;
	
	    // Return the current instance:
	    return this;
	  });
	
	  /**
	   * This method adds an edge to the graph. The edge must be an object, with a
	   * string under the key "id", and strings under the keys "source" and
	   * "target" that design existing nodes. Except for this, it is possible to
	   * add any other attribute, that will be preserved all along the
	   * manipulations.
	   *
	   * If the graph option "clone" has a truthy value, the edge will be cloned
	   * when added to the graph. Also, if the graph option "immutable" has a
	   * truthy value, its id, source and target will be defined as immutable.
	   *
	   * @param  {object} edge The edge to add.
	   * @return {object}      The graph instance.
	   */
	  graph.addMethod('addEdge', function(edge) {
	    // Check that the edge is an object and has an id:
	    if (Object(edge) !== edge || arguments.length !== 1)
	      throw 'addEdge: Wrong arguments.';
	
	    if (typeof edge.id !== 'string' && typeof edge.id !== 'number')
	      throw 'The edge must have a string or number id.';
	
	    if ((typeof edge.source !== 'string' && typeof edge.source !== 'number') ||
	        !this.nodesIndex[edge.source])
	      throw 'The edge source must have an existing node id.';
	
	    if ((typeof edge.target !== 'string' && typeof edge.target !== 'number') ||
	        !this.nodesIndex[edge.target])
	      throw 'The edge target must have an existing node id.';
	
	    if (this.edgesIndex[edge.id])
	      throw 'The edge "' + edge.id + '" already exists.';
	
	    var k,
	        validEdge = Object.create(null);
	
	    // Check the "clone" option:
	    if (this.settings('clone')) {
	      for (k in edge)
	        if (k !== 'id' && k !== 'source' && k !== 'target')
	          validEdge[k] = edge[k];
	    } else
	      validEdge = edge;
	
	    // Check the "immutable" option:
	    if (this.settings('immutable')) {
	      Object.defineProperty(validEdge, 'id', {
	        value: edge.id,
	        enumerable: true
	      });
	
	      Object.defineProperty(validEdge, 'source', {
	        value: edge.source,
	        enumerable: true
	      });
	
	      Object.defineProperty(validEdge, 'target', {
	        value: edge.target,
	        enumerable: true
	      });
	    } else {
	      validEdge.id = edge.id;
	      validEdge.source = edge.source;
	      validEdge.target = edge.target;
	    }
	
	    // Add the edge to indexes:
	    this.edgesArray.push(validEdge);
	    this.edgesIndex[validEdge.id] = validEdge;
	
	    if (!this.inNeighborsIndex[validEdge.target][validEdge.source])
	      this.inNeighborsIndex[validEdge.target][validEdge.source] =
	        Object.create(null);
	    this.inNeighborsIndex[validEdge.target][validEdge.source][validEdge.id] =
	      validEdge;
	
	    if (!this.outNeighborsIndex[validEdge.source][validEdge.target])
	      this.outNeighborsIndex[validEdge.source][validEdge.target] =
	        Object.create(null);
	    this.outNeighborsIndex[validEdge.source][validEdge.target][validEdge.id] =
	      validEdge;
	
	    if (!this.allNeighborsIndex[validEdge.source][validEdge.target])
	      this.allNeighborsIndex[validEdge.source][validEdge.target] =
	        Object.create(null);
	    this.allNeighborsIndex[validEdge.source][validEdge.target][validEdge.id] =
	      validEdge;
	
	    if (validEdge.target !== validEdge.source) {
	      if (!this.allNeighborsIndex[validEdge.target][validEdge.source])
	        this.allNeighborsIndex[validEdge.target][validEdge.source] =
	          Object.create(null);
	      this.allNeighborsIndex[validEdge.target][validEdge.source][validEdge.id] =
	        validEdge;
	    }
	
	    // Keep counts up to date:
	    this.inNeighborsCount[validEdge.target]++;
	    this.outNeighborsCount[validEdge.source]++;
	    this.allNeighborsCount[validEdge.target]++;
	    this.allNeighborsCount[validEdge.source]++;
	
	    return this;
	  });
	
	  /**
	   * This method drops a node from the graph. It also removes each edge that is
	   * bound to it, through the dropEdge method. An error is thrown if the node
	   * does not exist.
	   *
	   * @param  {string} id The node id.
	   * @return {object}    The graph instance.
	   */
	  graph.addMethod('dropNode', function(id) {
	    // Check that the arguments are valid:
	    if ((typeof id !== 'string' && typeof id !== 'number') ||
	        arguments.length !== 1)
	      throw 'dropNode: Wrong arguments.';
	
	    if (!this.nodesIndex[id])
	      throw 'The node "' + id + '" does not exist.';
	
	    var i, k, l;
	
	    // Remove the node from indexes:
	    delete this.nodesIndex[id];
	    for (i = 0, l = this.nodesArray.length; i < l; i++)
	      if (this.nodesArray[i].id === id) {
	        this.nodesArray.splice(i, 1);
	        break;
	      }
	
	    // Remove related edges:
	    for (i = this.edgesArray.length - 1; i >= 0; i--)
	      if (this.edgesArray[i].source === id || this.edgesArray[i].target === id)
	        this.dropEdge(this.edgesArray[i].id);
	
	    // Remove related edge indexes:
	    delete this.inNeighborsIndex[id];
	    delete this.outNeighborsIndex[id];
	    delete this.allNeighborsIndex[id];
	
	    delete this.inNeighborsCount[id];
	    delete this.outNeighborsCount[id];
	    delete this.allNeighborsCount[id];
	
	    for (k in this.nodesIndex) {
	      delete this.inNeighborsIndex[k][id];
	      delete this.outNeighborsIndex[k][id];
	      delete this.allNeighborsIndex[k][id];
	    }
	
	    return this;
	  });
	
	  /**
	   * This method drops an edge from the graph. An error is thrown if the edge
	   * does not exist.
	   *
	   * @param  {string} id The edge id.
	   * @return {object}    The graph instance.
	   */
	  graph.addMethod('dropEdge', function(id) {
	    // Check that the arguments are valid:
	    if ((typeof id !== 'string' && typeof id !== 'number') ||
	        arguments.length !== 1)
	      throw 'dropEdge: Wrong arguments.';
	
	    if (!this.edgesIndex[id])
	      throw 'The edge "' + id + '" does not exist.';
	
	    var i, l, edge;
	
	    // Remove the edge from indexes:
	    edge = this.edgesIndex[id];
	    delete this.edgesIndex[id];
	    for (i = 0, l = this.edgesArray.length; i < l; i++)
	      if (this.edgesArray[i].id === id) {
	        this.edgesArray.splice(i, 1);
	        break;
	      }
	
	    delete this.inNeighborsIndex[edge.target][edge.source][edge.id];
	    if (!Object.keys(this.inNeighborsIndex[edge.target][edge.source]).length)
	      delete this.inNeighborsIndex[edge.target][edge.source];
	
	    delete this.outNeighborsIndex[edge.source][edge.target][edge.id];
	    if (!Object.keys(this.outNeighborsIndex[edge.source][edge.target]).length)
	      delete this.outNeighborsIndex[edge.source][edge.target];
	
	    delete this.allNeighborsIndex[edge.source][edge.target][edge.id];
	    if (!Object.keys(this.allNeighborsIndex[edge.source][edge.target]).length)
	      delete this.allNeighborsIndex[edge.source][edge.target];
	
	    if (edge.target !== edge.source) {
	      delete this.allNeighborsIndex[edge.target][edge.source][edge.id];
	      if (!Object.keys(this.allNeighborsIndex[edge.target][edge.source]).length)
	        delete this.allNeighborsIndex[edge.target][edge.source];
	    }
	
	    this.inNeighborsCount[edge.target]--;
	    this.outNeighborsCount[edge.source]--;
	    this.allNeighborsCount[edge.source]--;
	    this.allNeighborsCount[edge.target]--;
	
	    return this;
	  });
	
	  /**
	   * This method destroys the current instance. It basically empties each index
	   * and methods attached to the graph.
	   */
	  graph.addMethod('kill', function() {
	    // Delete arrays:
	    this.nodesArray.length = 0;
	    this.edgesArray.length = 0;
	    delete this.nodesArray;
	    delete this.edgesArray;
	
	    // Delete indexes:
	    delete this.nodesIndex;
	    delete this.edgesIndex;
	    delete this.inNeighborsIndex;
	    delete this.outNeighborsIndex;
	    delete this.allNeighborsIndex;
	    delete this.inNeighborsCount;
	    delete this.outNeighborsCount;
	    delete this.allNeighborsCount;
	  });
	
	  /**
	   * This method empties the nodes and edges arrays, as well as the different
	   * indexes.
	   *
	   * @return {object} The graph instance.
	   */
	  graph.addMethod('clear', function() {
	    this.nodesArray.length = 0;
	    this.edgesArray.length = 0;
	
	    // Due to GC issues, I prefer not to create new object. These objects are
	    // only available from the methods and attached functions, but still, it is
	    // better to prevent ghost references to unrelevant data...
	    __emptyObject(this.nodesIndex);
	    __emptyObject(this.edgesIndex);
	    __emptyObject(this.nodesIndex);
	    __emptyObject(this.inNeighborsIndex);
	    __emptyObject(this.outNeighborsIndex);
	    __emptyObject(this.allNeighborsIndex);
	    __emptyObject(this.inNeighborsCount);
	    __emptyObject(this.outNeighborsCount);
	    __emptyObject(this.allNeighborsCount);
	
	    return this;
	  });
	
	  /**
	   * This method reads an object and adds the nodes and edges, through the
	   * proper methods "addNode" and "addEdge".
	   *
	   * Here is an example:
	   *
	   *  > var myGraph = new graph();
	   *  > myGraph.read({
	   *  >   nodes: [
	   *  >     { id: 'n0' },
	   *  >     { id: 'n1' }
	   *  >   ],
	   *  >   edges: [
	   *  >     {
	   *  >       id: 'e0',
	   *  >       source: 'n0',
	   *  >       target: 'n1'
	   *  >     }
	   *  >   ]
	   *  > });
	   *  >
	   *  > console.log(
	   *  >   myGraph.nodes().length,
	   *  >   myGraph.edges().length
	   *  > ); // outputs 2 1
	   *
	   * @param  {object} g The graph object.
	   * @return {object}   The graph instance.
	   */
	  graph.addMethod('read', function(g) {
	    var i,
	        a,
	        l;
	
	    a = g.nodes || [];
	    for (i = 0, l = a.length; i < l; i++)
	      this.addNode(a[i]);
	
	    a = g.edges || [];
	    for (i = 0, l = a.length; i < l; i++)
	      this.addEdge(a[i]);
	
	    return this;
	  });
	
	  /**
	   * This methods returns one or several nodes, depending on how it is called.
	   *
	   * To get the array of nodes, call "nodes" without argument. To get a
	   * specific node, call it with the id of the node. The get multiple node,
	   * call it with an array of ids, and it will return the array of nodes, in
	   * the same order.
	   *
	   * @param  {?(string|array)} v Eventually one id, an array of ids.
	   * @return {object|array}      The related node or array of nodes.
	   */
	  graph.addMethod('nodes', function(v) {
	    // Clone the array of nodes and return it:
	    if (!arguments.length)
	      return this.nodesArray.slice(0);
	
	    // Return the related node:
	    if (arguments.length === 1 &&
	        (typeof v === 'string' || typeof v === 'number'))
	      return this.nodesIndex[v];
	
	    // Return an array of the related node:
	    if (
	      arguments.length === 1 &&
	      Object.prototype.toString.call(v) === '[object Array]'
	    ) {
	      var i,
	          l,
	          a = [];
	
	      for (i = 0, l = v.length; i < l; i++)
	        if (typeof v[i] === 'string' || typeof v[i] === 'number')
	          a.push(this.nodesIndex[v[i]]);
	        else
	          throw 'nodes: Wrong arguments.';
	
	      return a;
	    }
	
	    throw 'nodes: Wrong arguments.';
	  });
	
	  /**
	   * This methods returns the degree of one or several nodes, depending on how
	   * it is called. It is also possible to get incoming or outcoming degrees
	   * instead by specifying 'in' or 'out' as a second argument.
	   *
	   * @param  {string|array} v     One id, an array of ids.
	   * @param  {?string}      which Which degree is required. Values are 'in',
	   *                              'out', and by default the normal degree.
	   * @return {number|array}       The related degree or array of degrees.
	   */
	  graph.addMethod('degree', function(v, which) {
	    // Check which degree is required:
	    which = {
	      'in': this.inNeighborsCount,
	      'out': this.outNeighborsCount
	    }[which || ''] || this.allNeighborsCount;
	
	    // Return the related node:
	    if (typeof v === 'string' || typeof v === 'number')
	      return which[v];
	
	    // Return an array of the related node:
	    if (Object.prototype.toString.call(v) === '[object Array]') {
	      var i,
	          l,
	          a = [];
	
	      for (i = 0, l = v.length; i < l; i++)
	        if (typeof v[i] === 'string' || typeof v[i] === 'number')
	          a.push(which[v[i]]);
	        else
	          throw 'degree: Wrong arguments.';
	
	      return a;
	    }
	
	    throw 'degree: Wrong arguments.';
	  });
	
	  /**
	   * This methods returns one or several edges, depending on how it is called.
	   *
	   * To get the array of edges, call "edges" without argument. To get a
	   * specific edge, call it with the id of the edge. The get multiple edge,
	   * call it with an array of ids, and it will return the array of edges, in
	   * the same order.
	   *
	   * @param  {?(string|array)} v Eventually one id, an array of ids.
	   * @return {object|array}      The related edge or array of edges.
	   */
	  graph.addMethod('edges', function(v) {
	    // Clone the array of edges and return it:
	    if (!arguments.length)
	      return this.edgesArray.slice(0);
	
	    // Return the related edge:
	    if (arguments.length === 1 &&
	        (typeof v === 'string' || typeof v === 'number'))
	      return this.edgesIndex[v];
	
	    // Return an array of the related edge:
	    if (
	      arguments.length === 1 &&
	      Object.prototype.toString.call(v) === '[object Array]'
	    ) {
	      var i,
	          l,
	          a = [];
	
	      for (i = 0, l = v.length; i < l; i++)
	        if (typeof v[i] === 'string' || typeof v[i] === 'number')
	          a.push(this.edgesIndex[v[i]]);
	        else
	          throw 'edges: Wrong arguments.';
	
	      return a;
	    }
	
	    throw 'edges: Wrong arguments.';
	  });
	
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof sigma !== 'undefined') {
	    sigma.classes = sigma.classes || Object.create(null);
	    sigma.classes.graph = graph;
	  } else if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = graph;
	    exports.graph = graph;
	  } else
	    this.graph = graph;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 41:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  /**
	   * Sigma Quadtree Module
	   * =====================
	   *
	   * Author: Guillaume Plique (Yomguithereal)
	   * Version: 0.2
	   */
	
	
	
	  /**
	   * Quad Geometric Operations
	   * -------------------------
	   *
	   * A useful batch of geometric operations used by the quadtree.
	   */
	
	  var _geom = {
	
	    /**
	     * Transforms a graph node with x, y and size into an
	     * axis-aligned square.
	     *
	     * @param  {object} A graph node with at least a point (x, y) and a size.
	     * @return {object} A square: two points (x1, y1), (x2, y2) and height.
	     */
	    pointToSquare: function(n) {
	      return {
	        x1: n.x - n.size,
	        y1: n.y - n.size,
	        x2: n.x + n.size,
	        y2: n.y - n.size,
	        height: n.size * 2
	      };
	    },
	
	    /**
	     * Checks whether a rectangle is axis-aligned.
	     *
	     * @param  {object}  A rectangle defined by two points
	     *                   (x1, y1) and (x2, y2).
	     * @return {boolean} True if the rectangle is axis-aligned.
	     */
	    isAxisAligned: function(r) {
	      return r.x1 === r.x2 || r.y1 === r.y2;
	    },
	
	    /**
	     * Compute top points of an axis-aligned rectangle. This is useful in
	     * cases when the rectangle has been rotated (left, right or bottom up) and
	     * later operations need to know the top points.
	     *
	     * @param  {object} An axis-aligned rectangle defined by two points
	     *                  (x1, y1), (x2, y2) and height.
	     * @return {object} A rectangle: two points (x1, y1), (x2, y2) and height.
	     */
	    axisAlignedTopPoints: function(r) {
	
	      // Basic
	      if (r.y1 === r.y2 && r.x1 < r.x2)
	        return r;
	
	      // Rotated to right
	      if (r.x1 === r.x2 && r.y2 > r.y1)
	        return {
	          x1: r.x1 - r.height, y1: r.y1,
	          x2: r.x1, y2: r.y1,
	          height: r.height
	        };
	
	      // Rotated to left
	      if (r.x1 === r.x2 && r.y2 < r.y1)
	        return {
	          x1: r.x1, y1: r.y2,
	          x2: r.x2 + r.height, y2: r.y2,
	          height: r.height
	        };
	
	      // Bottom's up
	      return {
	        x1: r.x2, y1: r.y1 - r.height,
	        x2: r.x1, y2: r.y1 - r.height,
	        height: r.height
	      };
	    },
	
	    /**
	     * Get coordinates of a rectangle's lower left corner from its top points.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @return {object} Coordinates of the corner (x, y).
	     */
	    lowerLeftCoor: function(r) {
	      var width = (
	        Math.sqrt(
	          Math.pow(r.x2 - r.x1, 2) +
	          Math.pow(r.y2 - r.y1, 2)
	        )
	      );
	
	      return {
	        x: r.x1 - (r.y2 - r.y1) * r.height / width,
	        y: r.y1 + (r.x2 - r.x1) * r.height / width
	      };
	    },
	
	    /**
	     * Get coordinates of a rectangle's lower right corner from its top points
	     * and its lower left corner.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @param  {object} A corner's coordinates (x, y).
	     * @return {object} Coordinates of the corner (x, y).
	     */
	    lowerRightCoor: function(r, llc) {
	      return {
	        x: llc.x - r.x1 + r.x2,
	        y: llc.y - r.y1 + r.y2
	      };
	    },
	
	    /**
	     * Get the coordinates of all the corners of a rectangle from its top point.
	     *
	     * @param  {object} A rectangle defined by two points (x1, y1) and (x2, y2).
	     * @return {array}  An array of the four corners' coordinates (x, y).
	     */
	    rectangleCorners: function(r) {
	      var llc = this.lowerLeftCoor(r),
	          lrc = this.lowerRightCoor(r, llc);
	
	      return [
	        {x: r.x1, y: r.y1},
	        {x: r.x2, y: r.y2},
	        {x: llc.x, y: llc.y},
	        {x: lrc.x, y: lrc.y}
	      ];
	    },
	
	    /**
	     * Split a square defined by its boundaries into four.
	     *
	     * @param  {object} Boundaries of the square (x, y, width, height).
	     * @return {array}  An array containing the four new squares, themselves
	     *                  defined by an array of their four corners (x, y).
	     */
	    splitSquare: function(b) {
	      return [
	        [
	          {x: b.x, y: b.y},
	          {x: b.x + b.width / 2, y: b.y},
	          {x: b.x, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2}
	        ],
	        [
	          {x: b.x + b.width / 2, y: b.y},
	          {x: b.x + b.width, y: b.y},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x + b.width, y: b.y + b.height / 2}
	        ],
	        [
	          {x: b.x, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x, y: b.y + b.height},
	          {x: b.x + b.width / 2, y: b.y + b.height}
	        ],
	        [
	          {x: b.x + b.width / 2, y: b.y + b.height / 2},
	          {x: b.x + b.width, y: b.y + b.height / 2},
	          {x: b.x + b.width / 2, y: b.y + b.height},
	          {x: b.x + b.width, y: b.y + b.height}
	        ]
	      ];
	    },
	
	    /**
	     * Compute the four axis between corners of rectangle A and corners of
	     * rectangle B. This is needed later to check an eventual collision.
	     *
	     * @param  {array} An array of rectangle A's four corners (x, y).
	     * @param  {array} An array of rectangle B's four corners (x, y).
	     * @return {array} An array of four axis defined by their coordinates (x,y).
	     */
	    axis: function(c1, c2) {
	      return [
	        {x: c1[1].x - c1[0].x, y: c1[1].y - c1[0].y},
	        {x: c1[1].x - c1[3].x, y: c1[1].y - c1[3].y},
	        {x: c2[0].x - c2[2].x, y: c2[0].y - c2[2].y},
	        {x: c2[0].x - c2[1].x, y: c2[0].y - c2[1].y}
	      ];
	    },
	
	    /**
	     * Project a rectangle's corner on an axis.
	     *
	     * @param  {object} Coordinates of a corner (x, y).
	     * @param  {object} Coordinates of an axis (x, y).
	     * @return {object} The projection defined by coordinates (x, y).
	     */
	    projection: function(c, a) {
	      var l = (
	        (c.x * a.x + c.y * a.y) /
	        (Math.pow(a.x, 2) + Math.pow(a.y, 2))
	      );
	
	      return {
	        x: l * a.x,
	        y: l * a.y
	      };
	    },
	
	    /**
	     * Check whether two rectangles collide on one particular axis.
	     *
	     * @param  {object}   An axis' coordinates (x, y).
	     * @param  {array}    Rectangle A's corners.
	     * @param  {array}    Rectangle B's corners.
	     * @return {boolean}  True if the rectangles collide on the axis.
	     */
	    axisCollision: function(a, c1, c2) {
	      var sc1 = [],
	          sc2 = [];
	
	      for (var ci = 0; ci < 4; ci++) {
	        var p1 = this.projection(c1[ci], a),
	            p2 = this.projection(c2[ci], a);
	
	        sc1.push(p1.x * a.x + p1.y * a.y);
	        sc2.push(p2.x * a.x + p2.y * a.y);
	      }
	
	      var maxc1 = Math.max.apply(Math, sc1),
	          maxc2 = Math.max.apply(Math, sc2),
	          minc1 = Math.min.apply(Math, sc1),
	          minc2 = Math.min.apply(Math, sc2);
	
	      return (minc2 <= maxc1 && maxc2 >= minc1);
	    },
	
	    /**
	     * Check whether two rectangles collide on each one of their four axis. If
	     * all axis collide, then the two rectangles do collide on the plane.
	     *
	     * @param  {array}    Rectangle A's corners.
	     * @param  {array}    Rectangle B's corners.
	     * @return {boolean}  True if the rectangles collide.
	     */
	    collision: function(c1, c2) {
	      var axis = this.axis(c1, c2),
	          col = true;
	
	      for (var i = 0; i < 4; i++)
	        col = col && this.axisCollision(axis[i], c1, c2);
	
	      return col;
	    }
	  };
	
	
	  /**
	   * Quad Functions
	   * ------------
	   *
	   * The Quadtree functions themselves.
	   * For each of those functions, we consider that in a splitted quad, the
	   * index of each node is the following:
	   * 0: top left
	   * 1: top right
	   * 2: bottom left
	   * 3: bottom right
	   *
	   * Moreover, the hereafter quad's philosophy is to consider that if an element
	   * collides with more than one nodes, this element belongs to each of the
	   * nodes it collides with where other would let it lie on a higher node.
	   */
	
	  /**
	   * Get the index of the node containing the point in the quad
	   *
	   * @param  {object}  point      A point defined by coordinates (x, y).
	   * @param  {object}  quadBounds Boundaries of the quad (x, y, width, heigth).
	   * @return {integer}            The index of the node containing the point.
	   */
	  function _quadIndex(point, quadBounds) {
	    var xmp = quadBounds.x + quadBounds.width / 2,
	        ymp = quadBounds.y + quadBounds.height / 2,
	        top = (point.y < ymp),
	        left = (point.x < xmp);
	
	    if (top) {
	      if (left)
	        return 0;
	      else
	        return 1;
	    }
	    else {
	      if (left)
	        return 2;
	      else
	        return 3;
	    }
	  }
	
	  /**
	   * Get a list of indexes of nodes containing an axis-aligned rectangle
	   *
	   * @param  {object}  rectangle   A rectangle defined by two points (x1, y1),
	   *                               (x2, y2) and height.
	   * @param  {array}   quadCorners An array of the quad nodes' corners.
	   * @return {array}               An array of indexes containing one to
	   *                               four integers.
	   */
	  function _quadIndexes(rectangle, quadCorners) {
	    var indexes = [];
	
	    // Iterating through quads
	    for (var i = 0; i < 4; i++)
	      if ((rectangle.x2 >= quadCorners[i][0].x) &&
	          (rectangle.x1 <= quadCorners[i][1].x) &&
	          (rectangle.y1 + rectangle.height >= quadCorners[i][0].y) &&
	          (rectangle.y1 <= quadCorners[i][2].y))
	        indexes.push(i);
	
	    return indexes;
	  }
	
	  /**
	   * Get a list of indexes of nodes containing a non-axis-aligned rectangle
	   *
	   * @param  {array}  corners      An array containing each corner of the
	   *                               rectangle defined by its coordinates (x, y).
	   * @param  {array}  quadCorners  An array of the quad nodes' corners.
	   * @return {array}               An array of indexes containing one to
	   *                               four integers.
	   */
	  function _quadCollision(corners, quadCorners) {
	    var indexes = [];
	
	    // Iterating through quads
	    for (var i = 0; i < 4; i++)
	      if (_geom.collision(corners, quadCorners[i]))
	        indexes.push(i);
	
	    return indexes;
	  }
	
	  /**
	   * Subdivide a quad by creating a node at a precise index. The function does
	   * not generate all four nodes not to potentially create unused nodes.
	   *
	   * @param  {integer}  index The index of the node to create.
	   * @param  {object}   quad  The quad object to subdivide.
	   * @return {object}         A new quad representing the node created.
	   */
	  function _quadSubdivide(index, quad) {
	    var next = quad.level + 1,
	        subw = Math.round(quad.bounds.width / 2),
	        subh = Math.round(quad.bounds.height / 2),
	        qx = Math.round(quad.bounds.x),
	        qy = Math.round(quad.bounds.y),
	        x,
	        y;
	
	    switch (index) {
	      case 0:
	        x = qx;
	        y = qy;
	        break;
	      case 1:
	        x = qx + subw;
	        y = qy;
	        break;
	      case 2:
	        x = qx;
	        y = qy + subh;
	        break;
	      case 3:
	        x = qx + subw;
	        y = qy + subh;
	        break;
	    }
	
	    return _quadTree(
	      {x: x, y: y, width: subw, height: subh},
	      next,
	      quad.maxElements,
	      quad.maxLevel
	    );
	  }
	
	  /**
	   * Recursively insert an element into the quadtree. Only points
	   * with size, i.e. axis-aligned squares, may be inserted with this
	   * method.
	   *
	   * @param  {object}  el         The element to insert in the quadtree.
	   * @param  {object}  sizedPoint A sized point defined by two top points
	   *                              (x1, y1), (x2, y2) and height.
	   * @param  {object}  quad       The quad in which to insert the element.
	   * @return {undefined}          The function does not return anything.
	   */
	  function _quadInsert(el, sizedPoint, quad) {
	    if (quad.level < quad.maxLevel) {
	
	      // Searching appropriate quads
	      var indexes = _quadIndexes(sizedPoint, quad.corners);
	
	      // Iterating
	      for (var i = 0, l = indexes.length; i < l; i++) {
	
	        // Subdividing if necessary
	        if (quad.nodes[indexes[i]] === undefined)
	          quad.nodes[indexes[i]] = _quadSubdivide(indexes[i], quad);
	
	        // Recursion
	        _quadInsert(el, sizedPoint, quad.nodes[indexes[i]]);
	      }
	    }
	    else {
	
	      // Pushing the element in a leaf node
	      quad.elements.push(el);
	    }
	  }
	
	  /**
	   * Recursively retrieve every elements held by the node containing the
	   * searched point.
	   *
	   * @param  {object}  point The searched point (x, y).
	   * @param  {object}  quad  The searched quad.
	   * @return {array}         An array of elements contained in the relevant
	   *                         node.
	   */
	  function _quadRetrievePoint(point, quad) {
	    if (quad.level < quad.maxLevel) {
	      var index = _quadIndex(point, quad.bounds);
	
	      // If node does not exist we return an empty list
	      if (quad.nodes[index] !== undefined) {
	        return _quadRetrievePoint(point, quad.nodes[index]);
	      }
	      else {
	        return [];
	      }
	    }
	    else {
	      return quad.elements;
	    }
	  }
	
	  /**
	   * Recursively retrieve every elements contained within an rectangular area
	   * that may or may not be axis-aligned.
	   *
	   * @param  {object|array} rectData       The searched area defined either by
	   *                                       an array of four corners (x, y) in
	   *                                       the case of a non-axis-aligned
	   *                                       rectangle or an object with two top
	   *                                       points (x1, y1), (x2, y2) and height.
	   * @param  {object}       quad           The searched quad.
	   * @param  {function}     collisionFunc  The collision function used to search
	   *                                       for node indexes.
	   * @param  {array?}       els            The retrieved elements.
	   * @return {array}                       An array of elements contained in the
	   *                                       area.
	   */
	  function _quadRetrieveArea(rectData, quad, collisionFunc, els) {
	    els = els || {};
	
	    if (quad.level < quad.maxLevel) {
	      var indexes = collisionFunc(rectData, quad.corners);
	
	      for (var i = 0, l = indexes.length; i < l; i++)
	        if (quad.nodes[indexes[i]] !== undefined)
	          _quadRetrieveArea(
	            rectData,
	            quad.nodes[indexes[i]],
	            collisionFunc,
	            els
	          );
	    } else
	      for (var j = 0, m = quad.elements.length; j < m; j++)
	        if (els[quad.elements[j].id] === undefined)
	          els[quad.elements[j].id] = quad.elements[j];
	
	    return els;
	  }
	
	  /**
	   * Creates the quadtree object itself.
	   *
	   * @param  {object}   bounds       The boundaries of the quad defined by an
	   *                                 origin (x, y), width and heigth.
	   * @param  {integer}  level        The level of the quad in the tree.
	   * @param  {integer}  maxElements  The max number of element in a leaf node.
	   * @param  {integer}  maxLevel     The max recursion level of the tree.
	   * @return {object}                The quadtree object.
	   */
	  function _quadTree(bounds, level, maxElements, maxLevel) {
	    return {
	      level: level || 0,
	      bounds: bounds,
	      corners: _geom.splitSquare(bounds),
	      maxElements: maxElements || 20,
	      maxLevel: maxLevel || 4,
	      elements: [],
	      nodes: []
	    };
	  }
	
	
	  /**
	   * Sigma Quad Constructor
	   * ----------------------
	   *
	   * The quad API as exposed to sigma.
	   */
	
	  /**
	   * The quad core that will become the sigma interface with the quadtree.
	   *
	   * property {object} _tree  Property holding the quadtree object.
	   * property {object} _geom  Exposition of the _geom namespace for testing.
	   * property {object} _cache Cache for the area method.
	   */
	  var quad = function() {
	    this._geom = _geom;
	    this._tree = null;
	    this._cache = {
	      query: false,
	      result: false
	    };
	  };
	
	  /**
	   * Index a graph by inserting its nodes into the quadtree.
	   *
	   * @param  {array}  nodes   An array of nodes to index.
	   * @param  {object} params  An object of parameters with at least the quad
	   *                          bounds.
	   * @return {object}         The quadtree object.
	   *
	   * Parameters:
	   * ----------
	   * bounds:      {object}   boundaries of the quad defined by its origin (x, y)
	   *                         width and heigth.
	   * prefix:      {string?}  a prefix for node geometric attributes.
	   * maxElements: {integer?} the max number of elements in a leaf node.
	   * maxLevel:    {integer?} the max recursion level of the tree.
	   */
	  quad.prototype.index = function(nodes, params) {
	
	    // Enforcing presence of boundaries
	    if (!params.bounds)
	      throw 'sigma.classes.quad.index: bounds information not given.';
	
	    // Prefix
	    var prefix = params.prefix || '';
	
	    // Building the tree
	    this._tree = _quadTree(
	      params.bounds,
	      0,
	      params.maxElements,
	      params.maxLevel
	    );
	
	    // Inserting graph nodes into the tree
	    for (var i = 0, l = nodes.length; i < l; i++) {
	
	      // Inserting node
	      _quadInsert(
	        nodes[i],
	        _geom.pointToSquare({
	          x: nodes[i][prefix + 'x'],
	          y: nodes[i][prefix + 'y'],
	          size: nodes[i][prefix + 'size']
	        }),
	        this._tree
	      );
	    }
	
	    // Reset cache:
	    this._cache = {
	      query: false,
	      result: false
	    };
	
	    // remove?
	    return this._tree;
	  };
	
	  /**
	   * Retrieve every graph nodes held by the quadtree node containing the
	   * searched point.
	   *
	   * @param  {number} x of the point.
	   * @param  {number} y of the point.
	   * @return {array}  An array of nodes retrieved.
	   */
	  quad.prototype.point = function(x, y) {
	    return this._tree ?
	      _quadRetrievePoint({x: x, y: y}, this._tree) || [] :
	      [];
	  };
	
	  /**
	   * Retrieve every graph nodes within a rectangular area. The methods keep the
	   * last area queried in cache for optimization reason and will act differently
	   * for the same reason if the area is axis-aligned or not.
	   *
	   * @param  {object} A rectangle defined by two top points (x1, y1), (x2, y2)
	   *                  and height.
	   * @return {array}  An array of nodes retrieved.
	   */
	  quad.prototype.area = function(rect) {
	    var serialized = JSON.stringify(rect),
	        collisionFunc,
	        rectData;
	
	    // Returning cache?
	    if (this._cache.query === serialized)
	      return this._cache.result;
	
	    // Axis aligned ?
	    if (_geom.isAxisAligned(rect)) {
	      collisionFunc = _quadIndexes;
	      rectData = _geom.axisAlignedTopPoints(rect);
	    }
	    else {
	      collisionFunc = _quadCollision;
	      rectData = _geom.rectangleCorners(rect);
	    }
	
	    // Retrieving nodes
	    var nodes = this._tree ?
	      _quadRetrieveArea(
	        rectData,
	        this._tree,
	        collisionFunc
	      ) :
	      [];
	
	    // Object to array
	    var nodesArray = [];
	    for (var i in nodes)
	      nodesArray.push(nodes[i]);
	
	    // Caching
	    this._cache.query = serialized;
	    this._cache.result = nodesArray;
	
	    return nodesArray;
	  };
	
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof this.sigma !== 'undefined') {
	    this.sigma.classes = this.sigma.classes || {};
	    this.sigma.classes.quad = quad;
	  } else if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = quad;
	    exports.quad = quad;
	  } else
	    this.quad = quad;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 42:
	/***/ (function(module, exports, __webpack_require__) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * conrad.js is a tiny JavaScript jobs scheduler,
	 *
	 * Version: 0.1.0
	 * Sources: http://github.com/jacomyal/conrad.js
	 * Doc:     http://github.com/jacomyal/conrad.js#readme
	 *
	 * License:
	 * --------
	 * Copyright © 2013 Alexis Jacomy, Sciences-Po médialab
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to
	 * deal in the Software without restriction, including without limitation the
	 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	 * sell copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * The Software is provided "as is", without warranty of any kind, express or
	 * implied, including but not limited to the warranties of merchantability,
	 * fitness for a particular purpose and noninfringement. In no event shall the
	 * authors or copyright holders be liable for any claim, damages or other
	 * liability, whether in an action of contract, tort or otherwise, arising
	 * from, out of or in connection with the software or the use or other dealings
	 * in the Software.
	 */
	(function(global) {
	  'use strict';
	
	  // Check that conrad.js has not been loaded yet:
	  if (global.conrad)
	    throw new Error('conrad already exists');
	
	
	  /**
	   * PRIVATE VARIABLES:
	   * ******************
	   */
	
	  /**
	   * A flag indicating whether conrad is running or not.
	   *
	   * @type {Number}
	   */
	  var _lastFrameTime;
	
	  /**
	   * A flag indicating whether conrad is running or not.
	   *
	   * @type {Boolean}
	   */
	  var _isRunning = false;
	
	  /**
	   * The hash of registered jobs. Each job must at least have a unique ID
	   * under the key "id" and a function under the key "job". This hash
	   * contains each running job and each waiting job.
	   *
	   * @type {Object}
	   */
	  var _jobs = {};
	
	  /**
	   * The hash of currently running jobs.
	   *
	   * @type {Object}
	   */
	  var _runningJobs = {};
	
	  /**
	   * The array of currently running jobs, sorted by priority.
	   *
	   * @type {Array}
	   */
	  var _sortedByPriorityJobs = [];
	
	  /**
	   * The array of currently waiting jobs.
	   *
	   * @type {Object}
	   */
	  var _waitingJobs = {};
	
	  /**
	   * The array of finished jobs. They are stored in an array, since two jobs
	   * with the same "id" can happen at two different times.
	   *
	   * @type {Array}
	   */
	  var _doneJobs = [];
	
	  /**
	   * A dirty flag to keep conrad from starting: Indeed, when addJob() is called
	   * with several jobs, conrad must be started only at the end. This flag keeps
	   * me from duplicating the code that effectively adds a job.
	   *
	   * @type {Boolean}
	   */
	  var _noStart = false;
	
	  /**
	   * An hash containing some global settings about how conrad.js should
	   * behave.
	   *
	   * @type {Object}
	   */
	  var _parameters = {
	    frameDuration: 20,
	    history: true
	  };
	
	  /**
	   * This object contains every handlers bound to conrad events. It does not
	   * requirea any DOM implementation, since the events are all JavaScript.
	   *
	   * @type {Object}
	   */
	  var _handlers = Object.create(null);
	
	
	  /**
	   * PRIVATE FUNCTIONS:
	   * ******************
	   */
	
	  /**
	   * Will execute the handler everytime that the indicated event (or the
	   * indicated events) will be triggered.
	   *
	   * @param  {string|array|object} events  The name of the event (or the events
	   *                                       separated by spaces).
	   * @param  {function(Object)}    handler The handler to bind.
	   * @return {Object}                      Returns conrad.
	   */
	  function _bind(events, handler) {
	    var i,
	        i_end,
	        event,
	        eArray;
	
	    if (!arguments.length)
	      return;
	    else if (
	      arguments.length === 1 &&
	      Object(arguments[0]) === arguments[0]
	    )
	      for (events in arguments[0])
	        _bind(events, arguments[0][events]);
	    else if (arguments.length > 1) {
	      eArray =
	        Array.isArray(events) ?
	          events :
	          events.split(/ /);
	
	      for (i = 0, i_end = eArray.length; i !== i_end; i += 1) {
	        event = eArray[i];
	
	        if (!_handlers[event])
	          _handlers[event] = [];
	
	        // Using an object instead of directly the handler will make possible
	        // later to add flags
	        _handlers[event].push({
	          handler: handler
	        });
	      }
	    }
	  }
	
	  /**
	   * Removes the handler from a specified event (or specified events).
	   *
	   * @param  {?string}           events  The name of the event (or the events
	   *                                     separated by spaces). If undefined,
	   *                                     then all handlers are removed.
	   * @param  {?function(Object)} handler The handler to unbind. If undefined,
	   *                                     each handler bound to the event or the
	   *                                     events will be removed.
	   * @return {Object}            Returns conrad.
	   */
	  function _unbind(events, handler) {
	    var i,
	        i_end,
	        j,
	        j_end,
	        a,
	        event,
	        eArray = Array.isArray(events) ?
	                   events :
	                   events.split(/ /);
	
	    if (!arguments.length)
	      _handlers = Object.create(null);
	    else if (handler) {
	      for (i = 0, i_end = eArray.length; i !== i_end; i += 1) {
	        event = eArray[i];
	        if (_handlers[event]) {
	          a = [];
	          for (j = 0, j_end = _handlers[event].length; j !== j_end; j += 1)
	            if (_handlers[event][j].handler !== handler)
	              a.push(_handlers[event][j]);
	
	          _handlers[event] = a;
	        }
	
	        if (_handlers[event] && _handlers[event].length === 0)
	          delete _handlers[event];
	      }
	    } else
	      for (i = 0, i_end = eArray.length; i !== i_end; i += 1)
	        delete _handlers[eArray[i]];
	  }
	
	  /**
	   * Executes each handler bound to the event.
	   *
	   * @param  {string}  events The name of the event (or the events separated
	   *                          by spaces).
	   * @param  {?Object} data   The content of the event (optional).
	   * @return {Object}         Returns conrad.
	   */
	  function _dispatch(events, data) {
	    var i,
	        j,
	        i_end,
	        j_end,
	        event,
	        eventName,
	        eArray = Array.isArray(events) ?
	                   events :
	                   events.split(/ /);
	
	    data = data === undefined ? {} : data;
	
	    for (i = 0, i_end = eArray.length; i !== i_end; i += 1) {
	      eventName = eArray[i];
	
	      if (_handlers[eventName]) {
	        event = {
	          type: eventName,
	          data: data || {}
	        };
	
	        for (j = 0, j_end = _handlers[eventName].length; j !== j_end; j += 1)
	          try {
	            _handlers[eventName][j].handler(event);
	          } catch (e) {}
	      }
	    }
	  }
	
	  /**
	   * Executes the most prioritary job once, and deals with filling the stats
	   * (done, time, averageTime, currentTime, etc...).
	   *
	   * @return {?Object} Returns the job object if it has to be killed, null else.
	   */
	  function _executeFirstJob() {
	    var i,
	        l,
	        test,
	        kill,
	        pushed = false,
	        time = __dateNow(),
	        job = _sortedByPriorityJobs.shift();
	
	    // Execute the job and look at the result:
	    test = job.job();
	
	    // Deal with stats:
	    time = __dateNow() - time;
	    job.done++;
	    job.time += time;
	    job.currentTime += time;
	    job.weightTime = job.currentTime / (job.weight || 1);
	    job.averageTime = job.time / job.done;
	
	    // Check if the job has to be killed:
	    kill = job.count ? (job.count <= job.done) : !test;
	
	    // Reset priorities:
	    if (!kill) {
	      for (i = 0, l = _sortedByPriorityJobs.length; i < l; i++)
	        if (_sortedByPriorityJobs[i].weightTime > job.weightTime) {
	          _sortedByPriorityJobs.splice(i, 0, job);
	          pushed = true;
	          break;
	        }
	
	      if (!pushed)
	        _sortedByPriorityJobs.push(job);
	    }
	
	    return kill ? job : null;
	  }
	
	  /**
	   * Activates a job, by adding it to the _runningJobs object and the
	   * _sortedByPriorityJobs array. It also initializes its currentTime value.
	   *
	   * @param  {Object} job The job to activate.
	   */
	  function _activateJob(job) {
	    var l = _sortedByPriorityJobs.length;
	
	    // Add the job to the running jobs:
	    _runningJobs[job.id] = job;
	    job.status = 'running';
	
	    // Add the job to the priorities:
	    if (l) {
	      job.weightTime = _sortedByPriorityJobs[l - 1].weightTime;
	      job.currentTime = job.weightTime * (job.weight || 1);
	    }
	
	    // Initialize the job and dispatch:
	    job.startTime = __dateNow();
	    _dispatch('jobStarted', __clone(job));
	
	    _sortedByPriorityJobs.push(job);
	  }
	
	  /**
	   * The main loop of conrad.js:
	   *  . It executes job such that they all occupate the same processing time.
	   *  . It stops jobs that do not need to be executed anymore.
	   *  . It triggers callbacks when it is relevant.
	   *  . It starts waiting jobs when they need to be started.
	   *  . It injects frames to keep a constant frapes per second ratio.
	   *  . It stops itself when there are no more jobs to execute.
	   */
	  function _loop() {
	    var k,
	        o,
	        l,
	        job,
	        time,
	        deadJob;
	
	    // Deal with the newly added jobs (the _jobs object):
	    for (k in _jobs) {
	      job = _jobs[k];
	
	      if (job.after)
	        _waitingJobs[k] = job;
	      else
	        _activateJob(job);
	
	      delete _jobs[k];
	    }
	
	    // Set the _isRunning flag to false if there are no running job:
	    _isRunning = !!_sortedByPriorityJobs.length;
	
	    // Deal with the running jobs (the _runningJobs object):
	    while (
	      _sortedByPriorityJobs.length &&
	      __dateNow() - _lastFrameTime < _parameters.frameDuration
	    ) {
	      deadJob = _executeFirstJob();
	
	      // Deal with the case where the job has ended:
	      if (deadJob) {
	        _killJob(deadJob.id);
	
	        // Check for waiting jobs:
	        for (k in _waitingJobs)
	          if (_waitingJobs[k].after === deadJob.id) {
	            _activateJob(_waitingJobs[k]);
	            delete _waitingJobs[k];
	          }
	      }
	    }
	
	    // Check if conrad still has jobs to deal with, and kill it if not:
	    if (_isRunning) {
	      // Update the _lastFrameTime:
	      _lastFrameTime = __dateNow();
	
	      _dispatch('enterFrame');
	      setTimeout(_loop, 0);
	    } else
	      _dispatch('stop');
	  }
	
	  /**
	   * Adds one or more jobs, and starts the loop if no job was running before. A
	   * job is at least a unique string "id" and a function, and there are some
	   * parameters that you can specify for each job to modify the way conrad will
	   * execute it. If a job is added with the "id" of another job that is waiting
	   * or still running, an error will be thrown.
	   *
	   * When a job is added, it is referenced in the _jobs object, by its id.
	   * Then, if it has to be executed right now, it will be also referenced in
	   * the _runningJobs object. If it has to wait, then it will be added into the
	   * _waitingJobs object, until it can start.
	   *
	   * Keep reading this documentation to see how to call this method.
	   *
	   * @return {Object} Returns conrad.
	   *
	   * Adding one job:
	   * ***************
	   * Basically, a job is defined by its string id and a function (the job). It
	   * is also possible to add some parameters:
	   *
	   *  > conrad.addJob('myJobId', myJobFunction);
	   *  > conrad.addJob('myJobId', {
	   *  >   job: myJobFunction,
	   *  >   someParameter: someValue
	   *  > });
	   *  > conrad.addJob({
	   *  >   id: 'myJobId',
	   *  >   job: myJobFunction,
	   *  >   someParameter: someValue
	   *  > });
	   *
	   * Adding several jobs:
	   * ********************
	   * When adding several jobs at the same time, it is possible to specify
	   * parameters for each one individually or for all:
	   *
	   *  > conrad.addJob([
	   *  >   {
	   *  >     id: 'myJobId1',
	   *  >     job: myJobFunction1,
	   *  >     someParameter1: someValue1
	   *  >   },
	   *  >   {
	   *  >     id: 'myJobId2',
	   *  >     job: myJobFunction2,
	   *  >     someParameter2: someValue2
	   *  >   }
	   *  > ], {
	   *  >   someCommonParameter: someCommonValue
	   *  > });
	   *  > conrad.addJob({
	   *  >   myJobId1: {,
	   *  >     job: myJobFunction1,
	   *  >     someParameter1: someValue1
	   *  >   },
	   *  >   myJobId2: {,
	   *  >     job: myJobFunction2,
	   *  >     someParameter2: someValue2
	   *  >   }
	   *  > }, {
	   *  >   someCommonParameter: someCommonValue
	   *  > });
	   *  > conrad.addJob({
	   *  >   myJobId1: myJobFunction1,
	   *  >   myJobId2: myJobFunction2
	   *  > }, {
	   *  >   someCommonParameter: someCommonValue
	   *  > });
	   *
	   *  Recognized parameters:
	   *  **********************
	   *  Here is the exhaustive list of every accepted parameters:
	   *
	   *    {?Function} end      A callback to execute when the job is ended. It is
	   *                         not executed if the job is killed instead of ended
	   *                         "naturally".
	   *    {?Integer}  count    The number of time the job has to be executed.
	   *    {?Number}   weight   If specified, the job will be executed as it was
	   *                         added "weight" times.
	   *    {?String}   after    The id of another job (eventually not added yet).
	   *                         If specified, this job will start only when the
	   *                         specified "after" job is ended.
	   */
	  function _addJob(v1, v2) {
	    var i,
	        l,
	        o;
	
	    // Array of jobs:
	    if (Array.isArray(v1)) {
	      // Keep conrad to start until the last job is added:
	      _noStart = true;
	
	      for (i = 0, l = v1.length; i < l; i++)
	        _addJob(v1[i].id, __extend(v1[i], v2));
	
	      _noStart = false;
	      if (!_isRunning) {
	        // Update the _lastFrameTime:
	        _lastFrameTime = __dateNow();
	
	        _dispatch('start');
	        _loop();
	      }
	    } else if (typeof v1 === 'object') {
	      // One job (object):
	      if (typeof v1.id === 'string')
	        _addJob(v1.id, v1);
	
	      // Hash of jobs:
	      else {
	        // Keep conrad to start until the last job is added:
	        _noStart = true;
	
	        for (i in v1)
	          if (typeof v1[i] === 'function')
	            _addJob(i, __extend({
	              job: v1[i]
	            }, v2));
	          else
	            _addJob(i, __extend(v1[i], v2));
	
	        _noStart = false;
	        if (!_isRunning) {
	          // Update the _lastFrameTime:
	          _lastFrameTime = __dateNow();
	
	          _dispatch('start');
	          _loop();
	        }
	      }
	
	    // One job (string, *):
	    } else if (typeof v1 === 'string') {
	      if (_hasJob(v1))
	        throw new Error(
	          '[conrad.addJob] Job with id "' + v1 + '" already exists.'
	        );
	
	      // One job (string, function):
	      if (typeof v2 === 'function') {
	        o = {
	          id: v1,
	          done: 0,
	          time: 0,
	          status: 'waiting',
	          currentTime: 0,
	          averageTime: 0,
	          weightTime: 0,
	          job: v2
	        };
	
	      // One job (string, object):
	      } else if (typeof v2 === 'object') {
	        o = __extend(
	          {
	            id: v1,
	            done: 0,
	            time: 0,
	            status: 'waiting',
	            currentTime: 0,
	            averageTime: 0,
	            weightTime: 0
	          },
	          v2
	        );
	
	      // If none of those cases, throw an error:
	      } else
	        throw new Error('[conrad.addJob] Wrong arguments.');
	
	      // Effectively add the job:
	      _jobs[v1] = o;
	      _dispatch('jobAdded', __clone(o));
	
	      // Check if the loop has to be started:
	      if (!_isRunning && !_noStart) {
	        // Update the _lastFrameTime:
	        _lastFrameTime = __dateNow();
	
	        _dispatch('start');
	        _loop();
	      }
	
	    // If none of those cases, throw an error:
	    } else
	      throw new Error('[conrad.addJob] Wrong arguments.');
	
	    return this;
	  }
	
	  /**
	   * Kills one or more jobs, indicated by their ids. It is only possible to
	   * kill running jobs or waiting jobs. If you try to kill a job that does not
	   * exist or that is already killed, a warning will be thrown.
	   *
	   * @param  {Array|String} v1 A string job id or an array of job ids.
	   * @return {Object}       Returns conrad.
	   */
	  function _killJob(v1) {
	    var i,
	        l,
	        k,
	        a,
	        job,
	        found = false;
	
	    // Array of job ids:
	    if (Array.isArray(v1))
	      for (i = 0, l = v1.length; i < l; i++)
	        _killJob(v1[i]);
	
	    // One job's id:
	    else if (typeof v1 === 'string') {
	      a = [_runningJobs, _waitingJobs, _jobs];
	
	      // Remove the job from the hashes:
	      for (i = 0, l = a.length; i < l; i++)
	        if (v1 in a[i]) {
	          job = a[i][v1];
	
	          if (_parameters.history) {
	            job.status = 'done';
	            _doneJobs.push(job);
	          }
	
	          _dispatch('jobEnded', __clone(job));
	          delete a[i][v1];
	
	          if (typeof job.end === 'function')
	            job.end();
	
	          found = true;
	        }
	
	      // Remove the priorities array:
	      a = _sortedByPriorityJobs;
	      for (i = 0, l = a.length; i < l; i++)
	        if (a[i].id === v1) {
	          a.splice(i, 1);
	          break;
	        }
	
	      if (!found)
	        throw new Error('[conrad.killJob] Job "' + v1 + '" not found.');
	
	    // If none of those cases, throw an error:
	    } else
	      throw new Error('[conrad.killJob] Wrong arguments.');
	
	    return this;
	  }
	
	  /**
	   * Kills every running, waiting, and just added jobs.
	   *
	   * @return {Object} Returns conrad.
	   */
	  function _killAll() {
	    var k,
	        jobs = __extend(_jobs, _runningJobs, _waitingJobs);
	
	    // Take every jobs and push them into the _doneJobs object:
	    if (_parameters.history)
	      for (k in jobs) {
	        jobs[k].status = 'done';
	        _doneJobs.push(jobs[k]);
	
	        if (typeof jobs[k].end === 'function')
	          jobs[k].end();
	      }
	
	    // Reinitialize the different jobs lists:
	    _jobs = {};
	    _waitingJobs = {};
	    _runningJobs = {};
	    _sortedByPriorityJobs = [];
	
	    // In case some jobs are added right after the kill:
	    _isRunning = false;
	
	    return this;
	  }
	
	  /**
	   * Returns true if a job with the specified id is currently running or
	   * waiting, and false else.
	   *
	   * @param  {String}  id The id of the job.
	   * @return {?Object} Returns the job object if it exists.
	   */
	  function _hasJob(id) {
	    var job = _jobs[id] || _runningJobs[id] || _waitingJobs[id];
	    return job ? __extend(job) : null;
	  }
	
	  /**
	   * This method will set the setting specified by "v1" to the value specified
	   * by "v2" if both are given, and else return the current value of the
	   * settings "v1".
	   *
	   * @param  {String}   v1 The name of the property.
	   * @param  {?*}       v2 Eventually, a value to set to the specified
	   *                       property.
	   * @return {Object|*} Returns the specified settings value if "v2" is not
	   *                    given, and conrad else.
	   */
	  function _settings(v1, v2) {
	    var o;
	
	    if (typeof a1 === 'string' && arguments.length === 1)
	      return _parameters[a1];
	    else {
	      o = (typeof a1 === 'object' && arguments.length === 1) ?
	        a1 || {} :
	        {};
	      if (typeof a1 === 'string')
	        o[a1] = a2;
	
	      for (var k in o)
	        if (o[k] !== undefined)
	          _parameters[k] = o[k];
	        else
	          delete _parameters[k];
	
	      return this;
	    }
	  }
	
	  /**
	   * Returns true if conrad is currently running, and false else.
	   *
	   * @return {Boolean} Returns _isRunning.
	   */
	  function _getIsRunning() {
	    return _isRunning;
	  }
	
	  /**
	   * Unreference every job that is stored in the _doneJobs object. It will
	   * not be possible anymore to get stats about these jobs, but it will release
	   * the memory.
	   *
	   * @return {Object} Returns conrad.
	   */
	  function _clearHistory() {
	    _doneJobs = [];
	    return this;
	  }
	
	  /**
	   * Returns a snapshot of every data about jobs that wait to be started, are
	   * currently running or are done.
	   *
	   * It is possible to get only running, waiting or done jobs by giving
	   * "running", "waiting" or "done" as fist argument.
	   *
	   * It is also possible to get every job with a specified id by giving it as
	   * first argument. Also, using a RegExp instead of an id will return every
	   * jobs whose ids match the RegExp. And these two last use cases work as well
	   * by giving before "running", "waiting" or "done".
	   *
	   * @return {Array} The array of the matching jobs.
	   *
	   * Some call examples:
	   * *******************
	   *  > conrad.getStats('running')
	   *  > conrad.getStats('waiting')
	   *  > conrad.getStats('done')
	   *  > conrad.getStats('myJob')
	   *  > conrad.getStats(/test/)
	   *  > conrad.getStats('running', 'myRunningJob')
	   *  > conrad.getStats('running', /test/)
	   */
	  function _getStats(v1, v2) {
	    var a,
	        k,
	        i,
	        l,
	        stats,
	        pattern,
	        isPatternString;
	
	    if (!arguments.length) {
	      stats = [];
	
	      for (k in _jobs)
	        stats.push(_jobs[k]);
	
	      for (k in _waitingJobs)
	        stats.push(_waitingJobs[k]);
	
	      for (k in _runningJobs)
	        stats.push(_runningJobs[k]);
	
	      stats = stats.concat(_doneJobs);
	    }
	
	    if (typeof v1 === 'string')
	      switch (v1) {
	        case 'waiting':
	          stats = __objectValues(_waitingJobs);
	          break;
	        case 'running':
	          stats = __objectValues(_runningJobs);
	          break;
	        case 'done':
	          stats = _doneJobs;
	          break;
	        default:
	          pattern = v1;
	      }
	
	    if (v1 instanceof RegExp)
	      pattern = v1;
	
	    if (!pattern && (typeof v2 === 'string' || v2 instanceof RegExp))
	      pattern = v2;
	
	    // Filter jobs if a pattern is given:
	    if (pattern) {
	      isPatternString = typeof pattern === 'string';
	
	      if (stats instanceof Array) {
	        a = stats;
	      } else if (typeof stats === 'object') {
	        a = [];
	
	        for (k in stats)
	          a = a.concat(stats[k]);
	      } else {
	        a = [];
	
	        for (k in _jobs)
	          a.push(_jobs[k]);
	
	        for (k in _waitingJobs)
	          a.push(_waitingJobs[k]);
	
	        for (k in _runningJobs)
	          a.push(_runningJobs[k]);
	
	        a = a.concat(_doneJobs);
	      }
	
	      stats = [];
	      for (i = 0, l = a.length; i < l; i++)
	        if (isPatternString ? a[i].id === pattern : a[i].id.match(pattern))
	          stats.push(a[i]);
	    }
	
	    return __clone(stats);
	  }
	
	
	  /**
	   * TOOLS FUNCTIONS:
	   * ****************
	   */
	
	  /**
	   * This function takes any number of objects as arguments, copies from each
	   * of these objects each pair key/value into a new object, and finally
	   * returns this object.
	   *
	   * The arguments are parsed from the last one to the first one, such that
	   * when two objects have keys in common, the "earliest" object wins.
	   *
	   * Example:
	   * ********
	   *  > var o1 = {
	   *  >       a: 1,
	   *  >       b: 2,
	   *  >       c: '3'
	   *  >     },
	   *  >     o2 = {
	   *  >       c: '4',
	   *  >       d: [ 5 ]
	   *  >     };
	   *  > __extend(o1, o2);
	   *  > // Returns: {
	   *  > //   a: 1,
	   *  > //   b: 2,
	   *  > //   c: '3',
	   *  > //   d: [ 5 ]
	   *  > // };
	   *
	   * @param  {Object+} Any number of objects.
	   * @return {Object}  The merged object.
	   */
	  function __extend() {
	    var i,
	        k,
	        res = {},
	        l = arguments.length;
	
	    for (i = l - 1; i >= 0; i--)
	      for (k in arguments[i])
	        res[k] = arguments[i][k];
	
	    return res;
	  }
	
	  /**
	   * This function simply clones an object. This object must contain only
	   * objects, arrays and immutable values. Since it is not public, it does not
	   * deal with cyclic references, DOM elements and instantiated objects - so
	   * use it carefully.
	   *
	   * @param  {Object} The object to clone.
	   * @return {Object} The clone.
	   */
	  function __clone(item) {
	    var result, i, k, l;
	
	    if (!item)
	      return item;
	
	    if (Array.isArray(item)) {
	      result = [];
	      for (i = 0, l = item.length; i < l; i++)
	        result.push(__clone(item[i]));
	    } else if (typeof item === 'object') {
	      result = {};
	      for (i in item)
	        result[i] = __clone(item[i]);
	    } else
	      result = item;
	
	    return result;
	  }
	
	  /**
	   * Returns an array containing the values of an object.
	   *
	   * @param  {Object} The object.
	   * @return {Array}  The array of values.
	   */
	  function __objectValues(o) {
	    var k,
	        a = [];
	
	    for (k in o)
	      a.push(o[k]);
	
	    return a;
	  }
	
	  /**
	   * A short "Date.now()" polyfill.
	   *
	   * @return {Number} The current time (in ms).
	   */
	  function __dateNow() {
	    return Date.now ? Date.now() : new Date().getTime();
	  }
	
	  /**
	   * Polyfill for the Array.isArray function:
	   */
	  if (!Array.isArray)
	    Array.isArray = function(v) {
	      return Object.prototype.toString.call(v) === '[object Array]';
	    };
	
	
	  /**
	   * EXPORT PUBLIC API:
	   * ******************
	   */
	  var conrad = {
	    hasJob: _hasJob,
	    addJob: _addJob,
	    killJob: _killJob,
	    killAll: _killAll,
	    settings: _settings,
	    getStats: _getStats,
	    isRunning: _getIsRunning,
	    clearHistory: _clearHistory,
	
	    // Events management:
	    bind: _bind,
	    unbind: _unbind,
	
	    // Version:
	    version: '0.1.0'
	  };
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports)
	      exports = module.exports = conrad;
	    exports.conrad = conrad;
	  }
	  global.conrad = conrad;
	})(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 43:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.middlewares');
	
	  /**
	   * This middleware will just copy the graphic properties.
	   *
	   * @param {?string} readPrefix  The read prefix.
	   * @param {?string} writePrefix The write prefix.
	   */
	  sigma.middlewares.copy = function(readPrefix, writePrefix) {
	    var i,
	        l,
	        a;
	
	    if (writePrefix + '' === readPrefix + '')
	      return;
	
	    a = this.graph.nodes();
	    for (i = 0, l = a.length; i < l; i++) {
	      a[i][writePrefix + 'x'] = a[i][readPrefix + 'x'];
	      a[i][writePrefix + 'y'] = a[i][readPrefix + 'y'];
	      a[i][writePrefix + 'size'] = a[i][readPrefix + 'size'];
	    }
	
	    a = this.graph.edges();
	    for (i = 0, l = a.length; i < l; i++)
	      a[i][writePrefix + 'size'] = a[i][readPrefix + 'size'];
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 44:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.middlewares');
	  sigma.utils.pkg('sigma.utils');
	
	  /**
	   * This middleware will rescale the graph such that it takes an optimal space
	   * on the renderer.
	   *
	   * As each middleware, this function is executed in the scope of the sigma
	   * instance.
	   *
	   * @param {?string} readPrefix  The read prefix.
	   * @param {?string} writePrefix The write prefix.
	   * @param {object}  options     The parameters.
	   */
	  sigma.middlewares.rescale = function(readPrefix, writePrefix, options) {
	    var i,
	        l,
	        a,
	        b,
	        c,
	        d,
	        scale,
	        margin,
	        n = this.graph.nodes(),
	        e = this.graph.edges(),
	        settings = this.settings.embedObjects(options || {}),
	        bounds = settings('bounds') || sigma.utils.getBoundaries(
	          this.graph,
	          readPrefix,
	          true
	        ),
	        minX = bounds.minX,
	        minY = bounds.minY,
	        maxX = bounds.maxX,
	        maxY = bounds.maxY,
	        sizeMax = bounds.sizeMax,
	        weightMax = bounds.weightMax,
	        w = settings('width') || 1,
	        h = settings('height') || 1,
	        rescaleSettings = settings('autoRescale'),
	        validSettings = {
	          nodePosition: 1,
	          nodeSize: 1,
	          edgeSize: 1
	        };
	
	    /**
	     * What elements should we rescale?
	     */
	    if (!(rescaleSettings instanceof Array))
	      rescaleSettings = ['nodePosition', 'nodeSize', 'edgeSize'];
	
	    for (i = 0, l = rescaleSettings.length; i < l; i++)
	      if (!validSettings[rescaleSettings[i]])
	        throw new Error(
	          'The rescale setting "' + rescaleSettings[i] + '" is not recognized.'
	        );
	
	    var np = ~rescaleSettings.indexOf('nodePosition'),
	        ns = ~rescaleSettings.indexOf('nodeSize'),
	        es = ~rescaleSettings.indexOf('edgeSize');
	
	    /**
	     * First, we compute the scaling ratio, without considering the sizes
	     * of the nodes : Each node will have its center in the canvas, but might
	     * be partially out of it.
	     */
	    scale = settings('scalingMode') === 'outside' ?
	      Math.max(
	        w / Math.max(maxX - minX, 1),
	        h / Math.max(maxY - minY, 1)
	      ) :
	      Math.min(
	        w / Math.max(maxX - minX, 1),
	        h / Math.max(maxY - minY, 1)
	      );
	
	    /**
	     * Then, we correct that scaling ratio considering a margin, which is
	     * basically the size of the biggest node.
	     * This has to be done as a correction since to compare the size of the
	     * biggest node to the X and Y values, we have to first get an
	     * approximation of the scaling ratio.
	     **/
	    margin =
	      (
	        settings('rescaleIgnoreSize') ?
	          0 :
	          (settings('maxNodeSize') || sizeMax) / scale
	      ) +
	      (settings('sideMargin') || 0);
	    maxX += margin;
	    minX -= margin;
	    maxY += margin;
	    minY -= margin;
	
	    // Fix the scaling with the new extrema:
	    scale = settings('scalingMode') === 'outside' ?
	      Math.max(
	        w / Math.max(maxX - minX, 1),
	        h / Math.max(maxY - minY, 1)
	      ) :
	      Math.min(
	        w / Math.max(maxX - minX, 1),
	        h / Math.max(maxY - minY, 1)
	      );
	
	    // Size homothetic parameters:
	    if (!settings('maxNodeSize') && !settings('minNodeSize')) {
	      a = 1;
	      b = 0;
	    } else if (settings('maxNodeSize') === settings('minNodeSize')) {
	      a = 0;
	      b = +settings('maxNodeSize');
	    } else {
	      a = (settings('maxNodeSize') - settings('minNodeSize')) / sizeMax;
	      b = +settings('minNodeSize');
	    }
	
	    if (!settings('maxEdgeSize') && !settings('minEdgeSize')) {
	      c = 1;
	      d = 0;
	    } else if (settings('maxEdgeSize') === settings('minEdgeSize')) {
	      c = 0;
	      d = +settings('minEdgeSize');
	    } else {
	      c = (settings('maxEdgeSize') - settings('minEdgeSize')) / weightMax;
	      d = +settings('minEdgeSize');
	    }
	
	    // Rescale the nodes and edges:
	    for (i = 0, l = e.length; i < l; i++)
	      e[i][writePrefix + 'size'] =
	        e[i][readPrefix + 'size'] * (es ? c : 1) + (es ? d : 0);
	
	    for (i = 0, l = n.length; i < l; i++) {
	      n[i][writePrefix + 'size'] =
	        n[i][readPrefix + 'size'] * (ns ? a : 1) + (ns ? b : 0);
	      n[i][writePrefix + 'x'] =
	        (n[i][readPrefix + 'x'] - (maxX + minX) / 2) * (np ? scale : 1);
	      n[i][writePrefix + 'y'] =
	        (n[i][readPrefix + 'y'] - (maxY + minY) / 2) * (np ? scale : 1);
	    }
	  };
	
	  sigma.utils.getBoundaries = function(graph, prefix, doEdges) {
	    var i,
	        l,
	        e = graph.edges(),
	        n = graph.nodes(),
	        weightMax = -Infinity,
	        sizeMax = -Infinity,
	        minX = Infinity,
	        minY = Infinity,
	        maxX = -Infinity,
	        maxY = -Infinity;
	
	    if (doEdges)
	      for (i = 0, l = e.length; i < l; i++)
	        weightMax = Math.max(e[i][prefix + 'size'], weightMax);
	
	    for (i = 0, l = n.length; i < l; i++) {
	      sizeMax = Math.max(n[i][prefix + 'size'], sizeMax);
	      maxX = Math.max(n[i][prefix + 'x'], maxX);
	      minX = Math.min(n[i][prefix + 'x'], minX);
	      maxY = Math.max(n[i][prefix + 'y'], maxY);
	      minY = Math.min(n[i][prefix + 'y'], minY);
	    }
	
	    weightMax = weightMax || 1;
	    sizeMax = sizeMax || 1;
	
	    return {
	      weightMax: weightMax,
	      sizeMax: sizeMax,
	      minX: minX,
	      minY: minY,
	      maxX: maxX,
	      maxY: maxY
	    };
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 45:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.misc.animation.running');
	
	  /**
	   * Generates a unique ID for the animation.
	   *
	   * @return {string} Returns the new ID.
	   */
	  var _getID = (function() {
	    var id = 0;
	    return function() {
	      return '' + (++id);
	    };
	  })();
	
	  /**
	   * This function animates a camera. It has to be called with the camera to
	   * animate, the values of the coordinates to reach and eventually some
	   * options. It returns a number id, that you can use to kill the animation,
	   * with the method sigma.misc.animation.kill(id).
	   *
	   * The available options are:
	   *
	   *   {?number}            duration   The duration of the animation.
	   *   {?function}          onNewFrame A callback to execute when the animation
	   *                                   enter a new frame.
	   *   {?function}          onComplete A callback to execute when the animation
	   *                                   is completed or killed.
	   *   {?(string|function)} easing     The name of a function from the package
	   *                                   sigma.utils.easings, or a custom easing
	   *                                   function.
	   *
	   * @param  {camera}  camera  The camera to animate.
	   * @param  {object}  target  The coordinates to reach.
	   * @param  {?object} options Eventually an object to specify some options to
	   *                           the function. The available options are
	   *                           presented in the description of the function.
	   * @return {number}          The animation id, to make it easy to kill
	   *                           through the method "sigma.misc.animation.kill".
	   */
	  sigma.misc.animation.camera = function(camera, val, options) {
	    if (
	      !(camera instanceof sigma.classes.camera) ||
	      typeof val !== 'object' ||
	      !val
	    )
	      throw 'animation.camera: Wrong arguments.';
	
	    if (
	      typeof val.x !== 'number' &&
	      typeof val.y !== 'number' &&
	      typeof val.ratio !== 'number' &&
	      typeof val.angle !== 'number'
	    )
	      throw 'There must be at least one valid coordinate in the given val.';
	
	    var fn,
	        id,
	        anim,
	        easing,
	        duration,
	        initialVal,
	        o = options || {},
	        start = sigma.utils.dateNow();
	
	    // Store initial values:
	    initialVal = {
	      x: camera.x,
	      y: camera.y,
	      ratio: camera.ratio,
	      angle: camera.angle
	    };
	
	    duration = o.duration;
	    easing = typeof o.easing !== 'function' ?
	      sigma.utils.easings[o.easing || 'quadraticInOut'] :
	      o.easing;
	
	    fn = function() {
	      var coef,
	          t = o.duration ? (sigma.utils.dateNow() - start) / o.duration : 1;
	
	      // If the animation is over:
	      if (t >= 1) {
	        camera.isAnimated = false;
	        camera.goTo({
	          x: val.x !== undefined ? val.x : initialVal.x,
	          y: val.y !== undefined ? val.y : initialVal.y,
	          ratio: val.ratio !== undefined ? val.ratio : initialVal.ratio,
	          angle: val.angle !== undefined ? val.angle : initialVal.angle
	        });
	
	        cancelAnimationFrame(id);
	        delete sigma.misc.animation.running[id];
	
	        // Check callbacks:
	        if (typeof o.onComplete === 'function')
	          o.onComplete();
	
	      // Else, let's keep going:
	      } else {
	        coef = easing(t);
	        camera.isAnimated = true;
	        camera.goTo({
	          x: val.x !== undefined ?
	            initialVal.x + (val.x - initialVal.x) * coef :
	            initialVal.x,
	          y: val.y !== undefined ?
	            initialVal.y + (val.y - initialVal.y) * coef :
	            initialVal.y,
	          ratio: val.ratio !== undefined ?
	            initialVal.ratio + (val.ratio - initialVal.ratio) * coef :
	            initialVal.ratio,
	          angle: val.angle !== undefined ?
	            initialVal.angle + (val.angle - initialVal.angle) * coef :
	            initialVal.angle
	        });
	
	        // Check callbacks:
	        if (typeof o.onNewFrame === 'function')
	          o.onNewFrame();
	
	        anim.frameId = requestAnimationFrame(fn);
	      }
	    };
	
	    id = _getID();
	    anim = {
	      frameId: requestAnimationFrame(fn),
	      target: camera,
	      type: 'camera',
	      options: o,
	      fn: fn
	    };
	    sigma.misc.animation.running[id] = anim;
	
	    return id;
	  };
	
	  /**
	   * Kills a running animation. It triggers the eventual onComplete callback.
	   *
	   * @param  {number} id  The id of the animation to kill.
	   * @return {object}     Returns the sigma.misc.animation package.
	   */
	  sigma.misc.animation.kill = function(id) {
	    if (arguments.length !== 1 || typeof id !== 'number')
	      throw 'animation.kill: Wrong arguments.';
	
	    var o = sigma.misc.animation.running[id];
	
	    if (o) {
	      cancelAnimationFrame(id);
	      delete sigma.misc.animation.running[o.frameId];
	
	      if (o.type === 'camera')
	        o.target.isAnimated = false;
	
	      // Check callbacks:
	      if (typeof (o.options || {}).onComplete === 'function')
	        o.options.onComplete();
	    }
	
	    return this;
	  };
	
	  /**
	   * Kills every running animations, or only the one with the specified type,
	   * if a string parameter is given.
	   *
	   * @param  {?(string|object)} filter A string to filter the animations to kill
	   *                                   on their type (example: "camera"), or an
	   *                                   object to filter on their target.
	   * @return {number}                  Returns the number of animations killed
	   *                                   that way.
	   */
	  sigma.misc.animation.killAll = function(filter) {
	    var o,
	        id,
	        count = 0,
	        type = typeof filter === 'string' ? filter : null,
	        target = typeof filter === 'object' ? filter : null,
	        running = sigma.misc.animation.running;
	
	    for (id in running)
	      if (
	        (!type || running[id].type === type) &&
	        (!target || running[id].target === target)
	      ) {
	        o = sigma.misc.animation.running[id];
	        cancelAnimationFrame(o.frameId);
	        delete sigma.misc.animation.running[id];
	
	        if (o.type === 'camera')
	          o.target.isAnimated = false;
	
	        // Increment counter:
	        count++;
	
	        // Check callbacks:
	        if (typeof (o.options || {}).onComplete === 'function')
	          o.options.onComplete();
	      }
	
	    return count;
	  };
	
	  /**
	   * Returns "true" if any animation that is currently still running matches
	   * the filter given to the function.
	   *
	   * @param  {string|object} filter A string to filter the animations to kill
	   *                                on their type (example: "camera"), or an
	   *                                object to filter on their target.
	   * @return {boolean}              Returns true if any running animation
	   *                                matches.
	   */
	  sigma.misc.animation.has = function(filter) {
	    var id,
	        type = typeof filter === 'string' ? filter : null,
	        target = typeof filter === 'object' ? filter : null,
	        running = sigma.misc.animation.running;
	
	    for (id in running)
	      if (
	        (!type || running[id].type === type) &&
	        (!target || running[id].target === target)
	      )
	        return true;
	
	    return false;
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 46:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.misc');
	
	  /**
	   * This helper will bind any DOM renderer (for instance svg)
	   * to its captors, to properly dispatch the good events to the sigma instance
	   * to manage clicking, hovering etc...
	   *
	   * It has to be called in the scope of the related renderer.
	   */
	  sigma.misc.bindDOMEvents = function(container) {
	    var self = this,
	        graph = this.graph;
	
	    // DOMElement abstraction
	    function Element(domElement) {
	
	      // Helpers
	      this.attr = function(attrName) {
	        return domElement.getAttributeNS(null, attrName);
	      };
	
	      // Properties
	      this.tag = domElement.tagName;
	      this.class = this.attr('class');
	      this.id = this.attr('id');
	
	      // Methods
	      this.isNode = function() {
	        return !!~this.class.indexOf(self.settings('classPrefix') + '-node');
	      };
	
	      this.isEdge = function() {
	        return !!~this.class.indexOf(self.settings('classPrefix') + '-edge');
	      };
	
	      this.isHover = function() {
	        return !!~this.class.indexOf(self.settings('classPrefix') + '-hover');
	      };
	    }
	
	    // Click
	    function click(e) {
	      if (!self.settings('eventsEnabled'))
	        return;
	
	      // Generic event
	      self.dispatchEvent('click', e);
	
	      // Are we on a node?
	      var element = new Element(e.target);
	
	      if (element.isNode())
	        self.dispatchEvent('clickNode', {
	          node: graph.nodes(element.attr('data-node-id'))
	        });
	      else
	        self.dispatchEvent('clickStage');
	
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    // Double click
	    function doubleClick(e) {
	      if (!self.settings('eventsEnabled'))
	        return;
	
	      // Generic event
	      self.dispatchEvent('doubleClick', e);
	
	      // Are we on a node?
	      var element = new Element(e.target);
	
	      if (element.isNode())
	        self.dispatchEvent('doubleClickNode', {
	          node: graph.nodes(element.attr('data-node-id'))
	        });
	      else
	        self.dispatchEvent('doubleClickStage');
	
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    // On over
	    function onOver(e) {
	      var target = e.toElement || e.target;
	
	      if (!self.settings('eventsEnabled') || !target)
	        return;
	
	      var el = new Element(target);
	
	      if (el.isNode()) {
	        self.dispatchEvent('overNode', {
	          node: graph.nodes(el.attr('data-node-id'))
	        });
	      }
	      else if (el.isEdge()) {
	        var edge = graph.edges(el.attr('data-edge-id'));
	        self.dispatchEvent('overEdge', {
	          edge: edge,
	          source: graph.nodes(edge.source),
	          target: graph.nodes(edge.target)
	        });
	      }
	    }
	
	    // On out
	    function onOut(e) {
	      var target = e.fromElement || e.originalTarget;
	
	      if (!self.settings('eventsEnabled'))
	        return;
	
	      var el = new Element(target);
	
	      if (el.isNode()) {
	        self.dispatchEvent('outNode', {
	          node: graph.nodes(el.attr('data-node-id'))
	        });
	      }
	      else if (el.isEdge()) {
	        var edge = graph.edges(el.attr('data-edge-id'));
	        self.dispatchEvent('outEdge', {
	          edge: edge,
	          source: graph.nodes(edge.source),
	          target: graph.nodes(edge.target)
	        });
	      }
	    }
	
	    // Registering Events:
	
	    // Click
	    container.addEventListener('click', click, false);
	    sigma.utils.doubleClick(container, 'click', doubleClick);
	
	    // Touch counterparts
	    container.addEventListener('touchstart', click, false);
	    sigma.utils.doubleClick(container, 'touchstart', doubleClick);
	
	    // Mouseover
	    container.addEventListener('mouseover', onOver, true);
	
	    // Mouseout
	    container.addEventListener('mouseout', onOut, true);
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 47:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.misc');
	
	  /**
	   * This helper will bind any no-DOM renderer (for instance canvas or WebGL)
	   * to its captors, to properly dispatch the good events to the sigma instance
	   * to manage clicking, hovering etc...
	   *
	   * It has to be called in the scope of the related renderer.
	   */
	  sigma.misc.bindEvents = function(prefix) {
	    var i,
	        l,
	        mX,
	        mY,
	        captor,
	        self = this;
	
	    function getNodes(e) {
	      if (e) {
	        mX = 'x' in e.data ? e.data.x : mX;
	        mY = 'y' in e.data ? e.data.y : mY;
	      }
	
	      var i,
	          j,
	          l,
	          n,
	          x,
	          y,
	          s,
	          inserted,
	          selected = [],
	          modifiedX = mX + self.width / 2,
	          modifiedY = mY + self.height / 2,
	          point = self.camera.cameraPosition(
	            mX,
	            mY
	          ),
	          nodes = self.camera.quadtree.point(
	            point.x,
	            point.y
	          );
	
	      if (nodes.length)
	        for (i = 0, l = nodes.length; i < l; i++) {
	          n = nodes[i];
	          x = n[prefix + 'x'];
	          y = n[prefix + 'y'];
	          s = n[prefix + 'size'];
	
	          if (
	            !n.hidden &&
	            modifiedX > x - s &&
	            modifiedX < x + s &&
	            modifiedY > y - s &&
	            modifiedY < y + s &&
	            Math.sqrt(
	              Math.pow(modifiedX - x, 2) +
	              Math.pow(modifiedY - y, 2)
	            ) < s
	          ) {
	            // Insert the node:
	            inserted = false;
	
	            for (j = 0; j < selected.length; j++)
	              if (n.size > selected[j].size) {
	                selected.splice(j, 0, n);
	                inserted = true;
	                break;
	              }
	
	            if (!inserted)
	              selected.push(n);
	          }
	        }
	
	      return selected;
	    }
	
	
	    function getEdges(e) {
	      if (!self.settings('enableEdgeHovering')) {
	        // No event if the setting is off:
	        return [];
	      }
	
	      var isCanvas = (
	        sigma.renderers.canvas && self instanceof sigma.renderers.canvas);
	
	      if (!isCanvas) {
	        // A quick hardcoded rule to prevent people from using this feature
	        // with the WebGL renderer (which is not good enough at the moment):
	        throw new Error(
	          'The edge events feature is not compatible with the WebGL renderer'
	        );
	      }
	
	      if (e) {
	        mX = 'x' in e.data ? e.data.x : mX;
	        mY = 'y' in e.data ? e.data.y : mY;
	      }
	
	      var i,
	          j,
	          l,
	          a,
	          edge,
	          s,
	          maxEpsilon = self.settings('edgeHoverPrecision'),
	          source,
	          target,
	          cp,
	          nodeIndex = {},
	          inserted,
	          selected = [],
	          modifiedX = mX + self.width / 2,
	          modifiedY = mY + self.height / 2,
	          point = self.camera.cameraPosition(
	            mX,
	            mY
	          ),
	          edges = [];
	
	      if (isCanvas) {
	        var nodesOnScreen = self.camera.quadtree.area(
	          self.camera.getRectangle(self.width, self.height)
	        );
	        for (a = nodesOnScreen, i = 0, l = a.length; i < l; i++)
	          nodeIndex[a[i].id] = a[i];
	      }
	
	      if (self.camera.edgequadtree !== undefined) {
	        edges = self.camera.edgequadtree.point(
	          point.x,
	          point.y
	        );
	      }
	
	      function insertEdge(selected, edge) {
	        inserted = false;
	
	        for (j = 0; j < selected.length; j++)
	          if (edge.size > selected[j].size) {
	            selected.splice(j, 0, edge);
	            inserted = true;
	            break;
	          }
	
	        if (!inserted)
	          selected.push(edge);
	      }
	
	      if (edges.length)
	        for (i = 0, l = edges.length; i < l; i++) {
	          edge = edges[i];
	          source = self.graph.nodes(edge.source);
	          target = self.graph.nodes(edge.target);
	          // (HACK) we can't get edge[prefix + 'size'] on WebGL renderer:
	          s = edge[prefix + 'size'] ||
	              edge['read_' + prefix + 'size'];
	
	          // First, let's identify which edges are drawn. To do this, we keep
	          // every edges that have at least one extremity displayed according to
	          // the quadtree and the "hidden" attribute. We also do not keep hidden
	          // edges.
	          // Then, let's check if the mouse is on the edge (we suppose that it
	          // is a line segment).
	
	          if (
	            !edge.hidden &&
	            !source.hidden && !target.hidden &&
	            (!isCanvas ||
	              (nodeIndex[edge.source] || nodeIndex[edge.target])) &&
	            sigma.utils.getDistance(
	              source[prefix + 'x'],
	              source[prefix + 'y'],
	              modifiedX,
	              modifiedY) > source[prefix + 'size'] &&
	            sigma.utils.getDistance(
	              target[prefix + 'x'],
	              target[prefix + 'y'],
	              modifiedX,
	              modifiedY) > target[prefix + 'size']
	          ) {
	            if (edge.type == 'curve' || edge.type == 'curvedArrow') {
	              if (source.id === target.id) {
	                cp = sigma.utils.getSelfLoopControlPoints(
	                  source[prefix + 'x'],
	                  source[prefix + 'y'],
	                  source[prefix + 'size']
	                );
	                if (
	                  sigma.utils.isPointOnBezierCurve(
	                  modifiedX,
	                  modifiedY,
	                  source[prefix + 'x'],
	                  source[prefix + 'y'],
	                  target[prefix + 'x'],
	                  target[prefix + 'y'],
	                  cp.x1,
	                  cp.y1,
	                  cp.x2,
	                  cp.y2,
	                  Math.max(s, maxEpsilon)
	                )) {
	                  insertEdge(selected, edge);
	                }
	              }
	              else {
	                cp = sigma.utils.getQuadraticControlPoint(
	                  source[prefix + 'x'],
	                  source[prefix + 'y'],
	                  target[prefix + 'x'],
	                  target[prefix + 'y']);
	                if (
	                  sigma.utils.isPointOnQuadraticCurve(
	                  modifiedX,
	                  modifiedY,
	                  source[prefix + 'x'],
	                  source[prefix + 'y'],
	                  target[prefix + 'x'],
	                  target[prefix + 'y'],
	                  cp.x,
	                  cp.y,
	                  Math.max(s, maxEpsilon)
	                )) {
	                  insertEdge(selected, edge);
	                }
	              }
	            } else if (
	                sigma.utils.isPointOnSegment(
	                modifiedX,
	                modifiedY,
	                source[prefix + 'x'],
	                source[prefix + 'y'],
	                target[prefix + 'x'],
	                target[prefix + 'y'],
	                Math.max(s, maxEpsilon)
	              )) {
	              insertEdge(selected, edge);
	            }
	          }
	        }
	
	      return selected;
	    }
	
	
	    function bindCaptor(captor) {
	      var nodes,
	          edges,
	          overNodes = {},
	          overEdges = {};
	
	      function onClick(e) {
	        if (!self.settings('eventsEnabled'))
	          return;
	
	        self.dispatchEvent('click', e.data);
	
	        nodes = getNodes(e);
	        edges = getEdges(e);
	
	        if (nodes.length) {
	          self.dispatchEvent('clickNode', {
	            node: nodes[0],
	            captor: e.data
	          });
	          self.dispatchEvent('clickNodes', {
	            node: nodes,
	            captor: e.data
	          });
	        } else if (edges.length) {
	          self.dispatchEvent('clickEdge', {
	            edge: edges[0],
	            captor: e.data
	          });
	          self.dispatchEvent('clickEdges', {
	            edge: edges,
	            captor: e.data
	          });
	        } else
	          self.dispatchEvent('clickStage', {captor: e.data});
	      }
	
	      function onDoubleClick(e) {
	        if (!self.settings('eventsEnabled'))
	          return;
	
	        self.dispatchEvent('doubleClick', e.data);
	
	        nodes = getNodes(e);
	        edges = getEdges(e);
	
	        if (nodes.length) {
	          self.dispatchEvent('doubleClickNode', {
	            node: nodes[0],
	            captor: e.data
	          });
	          self.dispatchEvent('doubleClickNodes', {
	            node: nodes,
	            captor: e.data
	          });
	        } else if (edges.length) {
	          self.dispatchEvent('doubleClickEdge', {
	            edge: edges[0],
	            captor: e.data
	          });
	          self.dispatchEvent('doubleClickEdges', {
	            edge: edges,
	            captor: e.data
	          });
	        } else
	          self.dispatchEvent('doubleClickStage', {captor: e.data});
	      }
	
	      function onRightClick(e) {
	        if (!self.settings('eventsEnabled'))
	          return;
	
	        self.dispatchEvent('rightClick', e.data);
	
	        nodes = getNodes(e);
	        edges = getEdges(e);
	
	        if (nodes.length) {
	          self.dispatchEvent('rightClickNode', {
	            node: nodes[0],
	            captor: e.data
	          });
	          self.dispatchEvent('rightClickNodes', {
	            node: nodes,
	            captor: e.data
	          });
	        } else if (edges.length) {
	          self.dispatchEvent('rightClickEdge', {
	            edge: edges[0],
	            captor: e.data
	          });
	          self.dispatchEvent('rightClickEdges', {
	            edge: edges,
	            captor: e.data
	          });
	        } else
	          self.dispatchEvent('rightClickStage', {captor: e.data});
	      }
	
	      function onOut(e) {
	        if (!self.settings('eventsEnabled'))
	          return;
	
	        var k,
	            i,
	            l,
	            le,
	            outNodes = [],
	            outEdges = [];
	
	        for (k in overNodes)
	          outNodes.push(overNodes[k]);
	
	        overNodes = {};
	        // Dispatch both single and multi events:
	        for (i = 0, l = outNodes.length; i < l; i++)
	          self.dispatchEvent('outNode', {
	            node: outNodes[i],
	            captor: e.data
	          });
	        if (outNodes.length)
	          self.dispatchEvent('outNodes', {
	            nodes: outNodes,
	            captor: e.data
	          });
	
	        overEdges = {};
	        // Dispatch both single and multi events:
	        for (i = 0, le = outEdges.length; i < le; i++)
	          self.dispatchEvent('outEdge', {
	            edge: outEdges[i],
	            captor: e.data
	          });
	        if (outEdges.length)
	          self.dispatchEvent('outEdges', {
	            edges: outEdges,
	            captor: e.data
	          });
	      }
	
	      function onMove(e) {
	        if (!self.settings('eventsEnabled'))
	          return;
	
	        nodes = getNodes(e);
	        edges = getEdges(e);
	
	        var i,
	            k,
	            node,
	            edge,
	            newOutNodes = [],
	            newOverNodes = [],
	            currentOverNodes = {},
	            l = nodes.length,
	            newOutEdges = [],
	            newOverEdges = [],
	            currentOverEdges = {},
	            le = edges.length;
	
	        // Check newly overred nodes:
	        for (i = 0; i < l; i++) {
	          node = nodes[i];
	          currentOverNodes[node.id] = node;
	          if (!overNodes[node.id]) {
	            newOverNodes.push(node);
	            overNodes[node.id] = node;
	          }
	        }
	
	        // Check no more overred nodes:
	        for (k in overNodes)
	          if (!currentOverNodes[k]) {
	            newOutNodes.push(overNodes[k]);
	            delete overNodes[k];
	          }
	
	        // Dispatch both single and multi events:
	        for (i = 0, l = newOverNodes.length; i < l; i++)
	          self.dispatchEvent('overNode', {
	            node: newOverNodes[i],
	            captor: e.data
	          });
	        for (i = 0, l = newOutNodes.length; i < l; i++)
	          self.dispatchEvent('outNode', {
	            node: newOutNodes[i],
	            captor: e.data
	          });
	        if (newOverNodes.length)
	          self.dispatchEvent('overNodes', {
	            nodes: newOverNodes,
	            captor: e.data
	          });
	        if (newOutNodes.length)
	          self.dispatchEvent('outNodes', {
	            nodes: newOutNodes,
	            captor: e.data
	          });
	
	        // Check newly overred edges:
	        for (i = 0; i < le; i++) {
	          edge = edges[i];
	          currentOverEdges[edge.id] = edge;
	          if (!overEdges[edge.id]) {
	            newOverEdges.push(edge);
	            overEdges[edge.id] = edge;
	          }
	        }
	
	        // Check no more overred edges:
	        for (k in overEdges)
	          if (!currentOverEdges[k]) {
	            newOutEdges.push(overEdges[k]);
	            delete overEdges[k];
	          }
	
	        // Dispatch both single and multi events:
	        for (i = 0, le = newOverEdges.length; i < le; i++)
	          self.dispatchEvent('overEdge', {
	            edge: newOverEdges[i],
	            captor: e.data
	          });
	        for (i = 0, le = newOutEdges.length; i < le; i++)
	          self.dispatchEvent('outEdge', {
	            edge: newOutEdges[i],
	            captor: e.data
	          });
	        if (newOverEdges.length)
	          self.dispatchEvent('overEdges', {
	            edges: newOverEdges,
	            captor: e.data
	          });
	        if (newOutEdges.length)
	          self.dispatchEvent('outEdges', {
	            edges: newOutEdges,
	            captor: e.data
	          });
	      }
	
	      // Bind events:
	      captor.bind('click', onClick);
	      captor.bind('mousedown', onMove);
	      captor.bind('mouseup', onMove);
	      captor.bind('mousemove', onMove);
	      captor.bind('mouseout', onOut);
	      captor.bind('doubleclick', onDoubleClick);
	      captor.bind('rightclick', onRightClick);
	      self.bind('render', onMove);
	    }
	
	    for (i = 0, l = this.captors.length; i < l; i++)
	      bindCaptor(this.captors[i]);
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 48:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.misc');
	
	  /**
	   * This method listens to "overNode", "outNode", "overEdge" and "outEdge"
	   * events from a renderer and renders the nodes differently on the top layer.
	   * The goal is to make any node label readable with the mouse, and to
	   * highlight hovered nodes and edges.
	   *
	   * It has to be called in the scope of the related renderer.
	   */
	  sigma.misc.drawHovers = function(prefix) {
	    var self = this,
	        hoveredNodes = {},
	        hoveredEdges = {};
	
	    this.bind('overNode', function(event) {
	      var node = event.data.node;
	      if (!node.hidden) {
	        hoveredNodes[node.id] = node;
	        draw();
	      }
	    });
	
	    this.bind('outNode', function(event) {
	      delete hoveredNodes[event.data.node.id];
	      draw();
	    });
	
	    this.bind('overEdge', function(event) {
	      var edge = event.data.edge;
	      if (!edge.hidden) {
	        hoveredEdges[edge.id] = edge;
	        draw();
	      }
	    });
	
	    this.bind('outEdge', function(event) {
	      delete hoveredEdges[event.data.edge.id];
	      draw();
	    });
	
	    this.bind('render', function(event) {
	      draw();
	    });
	
	    function draw() {
	
	      var k,
	          source,
	          target,
	          hoveredNode,
	          hoveredEdge,
	          c = self.contexts.hover.canvas,
	          defaultNodeType = self.settings('defaultNodeType'),
	          defaultEdgeType = self.settings('defaultEdgeType'),
	          nodeRenderers = sigma.canvas.hovers,
	          edgeRenderers = sigma.canvas.edgehovers,
	          extremitiesRenderers = sigma.canvas.extremities,
	          embedSettings = self.settings.embedObjects({
	            prefix: prefix
	          });
	
	      // Clear self.contexts.hover:
	      self.contexts.hover.clearRect(0, 0, c.width, c.height);
	
	      // Node render: single hover
	      if (
	        embedSettings('enableHovering') &&
	        embedSettings('singleHover') &&
	        Object.keys(hoveredNodes).length
	      ) {
	        hoveredNode = hoveredNodes[Object.keys(hoveredNodes)[0]];
	        (
	          nodeRenderers[hoveredNode.type] ||
	          nodeRenderers[defaultNodeType] ||
	          nodeRenderers.def
	        )(
	          hoveredNode,
	          self.contexts.hover,
	          embedSettings
	        );
	      }
	
	      // Node render: multiple hover
	      if (
	        embedSettings('enableHovering') &&
	        !embedSettings('singleHover')
	      )
	        for (k in hoveredNodes)
	          (
	            nodeRenderers[hoveredNodes[k].type] ||
	            nodeRenderers[defaultNodeType] ||
	            nodeRenderers.def
	          )(
	            hoveredNodes[k],
	            self.contexts.hover,
	            embedSettings
	          );
	
	      // Edge render: single hover
	      if (
	        embedSettings('enableEdgeHovering') &&
	        embedSettings('singleHover') &&
	        Object.keys(hoveredEdges).length
	      ) {
	        hoveredEdge = hoveredEdges[Object.keys(hoveredEdges)[0]];
	        source = self.graph.nodes(hoveredEdge.source);
	        target = self.graph.nodes(hoveredEdge.target);
	
	        if (! hoveredEdge.hidden) {
	          (
	            edgeRenderers[hoveredEdge.type] ||
	            edgeRenderers[defaultEdgeType] ||
	            edgeRenderers.def
	          ) (
	            hoveredEdge,
	            source,
	            target,
	            self.contexts.hover,
	            embedSettings
	          );
	
	          if (embedSettings('edgeHoverExtremities')) {
	            (
	              extremitiesRenderers[hoveredEdge.type] ||
	              extremitiesRenderers.def
	            )(
	              hoveredEdge,
	              source,
	              target,
	              self.contexts.hover,
	              embedSettings
	            );
	
	          } else {
	            // Avoid edges rendered over nodes:
	            (
	              sigma.canvas.nodes[source.type] ||
	              sigma.canvas.nodes.def
	            ) (
	              source,
	              self.contexts.hover,
	              embedSettings
	            );
	            (
	              sigma.canvas.nodes[target.type] ||
	              sigma.canvas.nodes.def
	            ) (
	              target,
	              self.contexts.hover,
	              embedSettings
	            );
	          }
	        }
	      }
	
	      // Edge render: multiple hover
	      if (
	        embedSettings('enableEdgeHovering') &&
	        !embedSettings('singleHover')
	      ) {
	        for (k in hoveredEdges) {
	          hoveredEdge = hoveredEdges[k];
	          source = self.graph.nodes(hoveredEdge.source);
	          target = self.graph.nodes(hoveredEdge.target);
	
	          if (!hoveredEdge.hidden) {
	            (
	              edgeRenderers[hoveredEdge.type] ||
	              edgeRenderers[defaultEdgeType] ||
	              edgeRenderers.def
	            ) (
	              hoveredEdge,
	              source,
	              target,
	              self.contexts.hover,
	              embedSettings
	            );
	
	            if (embedSettings('edgeHoverExtremities')) {
	              (
	                extremitiesRenderers[hoveredEdge.type] ||
	                extremitiesRenderers.def
	              )(
	                hoveredEdge,
	                source,
	                target,
	                self.contexts.hover,
	                embedSettings
	              );
	            } else {
	              // Avoid edges rendered over nodes:
	              (
	                sigma.canvas.nodes[source.type] ||
	                sigma.canvas.nodes.def
	              ) (
	                source,
	                self.contexts.hover,
	                embedSettings
	              );
	              (
	                sigma.canvas.nodes[target.type] ||
	                sigma.canvas.nodes.def
	              ) (
	                target,
	                self.contexts.hover,
	                embedSettings
	              );
	            }
	          }
	        }
	      }
	    }
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 52:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.def =
	    function(edge, source, target, context, settings) {
	      var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 56:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * The default edge renderer. It renders the edge as a simple line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.def = function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 57:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.extremities');
	
	  /**
	   * The default renderer for hovered edge extremities. It renders the edge
	   * extremities as hovered.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.extremities.def =
	    function(edge, source, target, context, settings) {
	    // Source Node:
	    (
	      sigma.canvas.hovers[source.type] ||
	      sigma.canvas.hovers.def
	    ) (
	      source, context, settings
	    );
	
	    // Target Node:
	    (
	      sigma.canvas.hovers[target.type] ||
	      sigma.canvas.hovers.def
	    ) (
	      target, context, settings
	    );
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 58:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.hovers');
	
	  /**
	   * This hover renderer will basically display the label with a background.
	   *
	   * @param  {object}                   node     The node object.
	   * @param  {CanvasRenderingContext2D} context  The canvas context.
	   * @param  {configurable}             settings The settings function.
	   */
	  sigma.canvas.hovers.def = function(node, context, settings) {
	    var x,
	        y,
	        w,
	        h,
	        e,
	        fontStyle = settings('hoverFontStyle') || settings('fontStyle'),
	        prefix = settings('prefix') || '',
	        size = node[prefix + 'size'],
	        fontSize = (settings('labelSize') === 'fixed') ?
	          settings('defaultLabelSize') :
	          settings('labelSizeRatio') * size;
	
	    // Label background:
	    context.font = (fontStyle ? fontStyle + ' ' : '') +
	      fontSize + 'px ' + (settings('hoverFont') || settings('font'));
	
	    context.beginPath();
	    context.fillStyle = settings('labelHoverBGColor') === 'node' ?
	      (node.color || settings('defaultNodeColor')) :
	      settings('defaultHoverLabelBGColor');
	
	    if (node.label && settings('labelHoverShadow')) {
	      context.shadowOffsetX = 0;
	      context.shadowOffsetY = 0;
	      context.shadowBlur = 8;
	      context.shadowColor = settings('labelHoverShadowColor');
	    }
	
	    if (node.label && typeof node.label === 'string') {
	      x = Math.round(node[prefix + 'x'] - fontSize / 2 - 2);
	      y = Math.round(node[prefix + 'y'] - fontSize / 2 - 2);
	      w = Math.round(
	        context.measureText(node.label).width + fontSize / 2 + size + 7
	      );
	      h = Math.round(fontSize + 4);
	      e = Math.round(fontSize / 2 + 2);
	
	      context.moveTo(x, y + e);
	      context.arcTo(x, y, x + e, y, e);
	      context.lineTo(x + w, y);
	      context.lineTo(x + w, y + h);
	      context.lineTo(x + e, y + h);
	      context.arcTo(x, y + h, x, y + h - e, e);
	      context.lineTo(x, y + e);
	
	      context.closePath();
	      context.fill();
	
	      context.shadowOffsetX = 0;
	      context.shadowOffsetY = 0;
	      context.shadowBlur = 0;
	    }
	
	    // Node border:
	    if (settings('borderSize') > 0) {
	      context.beginPath();
	      context.fillStyle = settings('nodeBorderColor') === 'node' ?
	        (node.color || settings('defaultNodeColor')) :
	        settings('defaultNodeBorderColor');
	      context.arc(
	        node[prefix + 'x'],
	        node[prefix + 'y'],
	        size + settings('borderSize'),
	        0,
	        Math.PI * 2,
	        true
	      );
	      context.closePath();
	      context.fill();
	    }
	
	    // Node:
	    var nodeRenderer = sigma.canvas.nodes[node.type] || sigma.canvas.nodes.def;
	    nodeRenderer(node, context, settings);
	
	    // Display the label:
	    if (node.label && typeof node.label === 'string') {
	      context.fillStyle = (settings('labelHoverColor') === 'node') ?
	        (node.color || settings('defaultNodeColor')) :
	        settings('defaultLabelHoverColor');
	
	      context.fillText(
	        node.label,
	        Math.round(node[prefix + 'x'] + size + 3),
	        Math.round(node[prefix + 'y'] + fontSize / 3)
	      );
	    }
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 59:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.labels');
	
	  /**
	   * This label renderer will just display the label on the right of the node.
	   *
	   * @param  {object}                   node     The node object.
	   * @param  {CanvasRenderingContext2D} context  The canvas context.
	   * @param  {configurable}             settings The settings function.
	   */
	  sigma.canvas.labels.def = function(node, context, settings) {
	    var fontSize,
	        prefix = settings('prefix') || '',
	        size = node[prefix + 'size'];
	
	    if (size < settings('labelThreshold'))
	      return;
	
	    if (!node.label || typeof node.label !== 'string')
	      return;
	
	    fontSize = (settings('labelSize') === 'fixed') ?
	      settings('defaultLabelSize') :
	      settings('labelSizeRatio') * size;
	
	    context.font = (settings('fontStyle') ? settings('fontStyle') + ' ' : '') +
	      fontSize + 'px ' + settings('font');
	    context.fillStyle = (settings('labelColor') === 'node') ?
	      (node.color || settings('defaultNodeColor')) :
	      settings('defaultLabelColor');
	
	    context.fillText(
	      node.label,
	      Math.round(node[prefix + 'x'] + size + 3),
	      Math.round(node[prefix + 'y'] + fontSize / 3)
	    );
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 60:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.nodes');
	
	  /**
	   * The default node renderer. It renders the node as a simple disc.
	   *
	   * @param  {object}                   node     The node object.
	   * @param  {CanvasRenderingContext2D} context  The canvas context.
	   * @param  {configurable}             settings The settings function.
	   */
	  sigma.canvas.nodes.def = function(node, context, settings) {
	    var prefix = settings('prefix') || '';
	
	    context.fillStyle = node.color || settings('defaultNodeColor');
	    context.beginPath();
	    context.arc(
	      node[prefix + 'x'],
	      node[prefix + 'y'],
	      node[prefix + 'size'],
	      0,
	      Math.PI * 2,
	      true
	    );
	
	    context.closePath();
	    context.fill();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 61:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  if (typeof conrad === 'undefined')
	    throw 'conrad is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.renderers');
	
	  /**
	   * This function is the constructor of the canvas sigma's renderer.
	   *
	   * @param  {sigma.classes.graph}            graph    The graph to render.
	   * @param  {sigma.classes.camera}           camera   The camera.
	   * @param  {configurable}           settings The sigma instance settings
	   *                                           function.
	   * @param  {object}                 object   The options object.
	   * @return {sigma.renderers.canvas}          The renderer instance.
	   */
	  sigma.renderers.canvas = function(graph, camera, settings, options) {
	    if (typeof options !== 'object')
	      throw 'sigma.renderers.canvas: Wrong arguments.';
	
	    if (!(options.container instanceof HTMLElement))
	      throw 'Container not found.';
	
	    var k,
	        i,
	        l,
	        a,
	        fn,
	        self = this;
	
	    sigma.classes.dispatcher.extend(this);
	
	    // Initialize main attributes:
	    Object.defineProperty(this, 'conradId', {
	      value: sigma.utils.id()
	    });
	    this.graph = graph;
	    this.camera = camera;
	    this.contexts = {};
	    this.domElements = {};
	    this.options = options;
	    this.container = this.options.container;
	    this.settings = (
	        typeof options.settings === 'object' &&
	        options.settings
	      ) ?
	        settings.embedObjects(options.settings) :
	        settings;
	
	    // Node indexes:
	    this.nodesOnScreen = [];
	    this.edgesOnScreen = [];
	
	    // Conrad related attributes:
	    this.jobs = {};
	
	    // Find the prefix:
	    this.options.prefix = 'renderer' + this.conradId + ':';
	
	    // Initialize the DOM elements:
	    if (
	      !this.settings('batchEdgesDrawing')
	    ) {
	      this.initDOM('canvas', 'scene');
	      this.contexts.edges = this.contexts.scene;
	      this.contexts.nodes = this.contexts.scene;
	      this.contexts.labels = this.contexts.scene;
	    } else {
	      this.initDOM('canvas', 'edges');
	      this.initDOM('canvas', 'scene');
	      this.contexts.nodes = this.contexts.scene;
	      this.contexts.labels = this.contexts.scene;
	    }
	
	    this.initDOM('canvas', 'mouse');
	    this.contexts.hover = this.contexts.mouse;
	
	    // Initialize captors:
	    this.captors = [];
	    a = this.options.captors || [sigma.captors.mouse, sigma.captors.touch];
	    for (i = 0, l = a.length; i < l; i++) {
	      fn = typeof a[i] === 'function' ? a[i] : sigma.captors[a[i]];
	      this.captors.push(
	        new fn(
	          this.domElements.mouse,
	          this.camera,
	          this.settings
	        )
	      );
	    }
	
	    // Deal with sigma events:
	    sigma.misc.bindEvents.call(this, this.options.prefix);
	    sigma.misc.drawHovers.call(this, this.options.prefix);
	
	    this.resize(false);
	  };
	
	
	
	
	  /**
	   * This method renders the graph on the canvases.
	   *
	   * @param  {?object}                options Eventually an object of options.
	   * @return {sigma.renderers.canvas}         Returns the instance itself.
	   */
	  sigma.renderers.canvas.prototype.render = function(options) {
	    options = options || {};
	
	    var a,
	        i,
	        k,
	        l,
	        o,
	        id,
	        end,
	        job,
	        start,
	        edges,
	        renderers,
	        rendererType,
	        batchSize,
	        tempGCO,
	        index = {},
	        graph = this.graph,
	        nodes = this.graph.nodes,
	        prefix = this.options.prefix || '',
	        drawEdges = this.settings(options, 'drawEdges'),
	        drawNodes = this.settings(options, 'drawNodes'),
	        drawLabels = this.settings(options, 'drawLabels'),
	        drawEdgeLabels = this.settings(options, 'drawEdgeLabels'),
	        embedSettings = this.settings.embedObjects(options, {
	          prefix: this.options.prefix
	        });
	
	    // Call the resize function:
	    this.resize(false);
	
	    // Check the 'hideEdgesOnMove' setting:
	    if (this.settings(options, 'hideEdgesOnMove'))
	      if (this.camera.isAnimated || this.camera.isMoving)
	        drawEdges = false;
	
	    // Apply the camera's view:
	    this.camera.applyView(
	      undefined,
	      this.options.prefix,
	      {
	        width: this.width,
	        height: this.height
	      }
	    );
	
	    // Clear canvases:
	    this.clear();
	
	    // Kill running jobs:
	    for (k in this.jobs)
	      if (conrad.hasJob(k))
	        conrad.killJob(k);
	
	    // Find which nodes are on screen:
	    this.edgesOnScreen = [];
	    this.nodesOnScreen = this.camera.quadtree.area(
	      this.camera.getRectangle(this.width, this.height)
	    );
	
	    for (a = this.nodesOnScreen, i = 0, l = a.length; i < l; i++)
	      index[a[i].id] = a[i];
	
	    // Draw edges:
	    // - If settings('batchEdgesDrawing') is true, the edges are displayed per
	    //   batches. If not, they are drawn in one frame.
	    if (drawEdges) {
	      // First, let's identify which edges to draw. To do this, we just keep
	      // every edges that have at least one extremity displayed according to
	      // the quadtree and the "hidden" attribute. We also do not keep hidden
	      // edges.
	      for (a = graph.edges(), i = 0, l = a.length; i < l; i++) {
	        o = a[i];
	        if (
	          (index[o.source] || index[o.target]) &&
	          (!o.hidden && !nodes(o.source).hidden && !nodes(o.target).hidden)
	        )
	          this.edgesOnScreen.push(o);
	      }
	
	      // If the "batchEdgesDrawing" settings is true, edges are batched:
	      if (this.settings(options, 'batchEdgesDrawing')) {
	        id = 'edges_' + this.conradId;
	        batchSize = embedSettings('canvasEdgesBatchSize');
	
	        edges = this.edgesOnScreen;
	        l = edges.length;
	
	        start = 0;
	        end = Math.min(edges.length, start + batchSize);
	
	        job = function() {
	          tempGCO = this.contexts.edges.globalCompositeOperation;
	          this.contexts.edges.globalCompositeOperation = 'destination-over';
	
	          renderers = sigma.canvas.edges;
	          for (i = start; i < end; i++) {
	            o = edges[i];
	            (renderers[
	              o.type || this.settings(options, 'defaultEdgeType')
	            ] || renderers.def)(
	              o,
	              graph.nodes(o.source),
	              graph.nodes(o.target),
	              this.contexts.edges,
	              embedSettings
	            );
	          }
	
	          // Draw edge labels:
	          if (drawEdgeLabels) {
	            renderers = sigma.canvas.edges.labels;
	            for (i = start; i < end; i++) {
	              o = edges[i];
	              if (!o.hidden)
	                (renderers[
	                  o.type || this.settings(options, 'defaultEdgeType')
	                ] || renderers.def)(
	                  o,
	                  graph.nodes(o.source),
	                  graph.nodes(o.target),
	                  this.contexts.labels,
	                  embedSettings
	                );
	            }
	          }
	
	          // Restore original globalCompositeOperation:
	          this.contexts.edges.globalCompositeOperation = tempGCO;
	
	          // Catch job's end:
	          if (end === edges.length) {
	            delete this.jobs[id];
	            return false;
	          }
	
	          start = end + 1;
	          end = Math.min(edges.length, start + batchSize);
	          return true;
	        };
	
	        this.jobs[id] = job;
	        conrad.addJob(id, job.bind(this));
	
	      // If not, they are drawn in one frame:
	      } else {
	        renderers = sigma.canvas.edges;
	        for (a = this.edgesOnScreen, i = 0, l = a.length; i < l; i++) {
	          o = a[i];
	          (renderers[
	            o.type || this.settings(options, 'defaultEdgeType')
	          ] || renderers.def)(
	            o,
	            graph.nodes(o.source),
	            graph.nodes(o.target),
	            this.contexts.edges,
	            embedSettings
	          );
	        }
	
	        // Draw edge labels:
	        // - No batching
	        if (drawEdgeLabels) {
	          renderers = sigma.canvas.edges.labels;
	          for (a = this.edgesOnScreen, i = 0, l = a.length; i < l; i++)
	            if (!a[i].hidden)
	              (renderers[
	                a[i].type || this.settings(options, 'defaultEdgeType')
	              ] || renderers.def)(
	                a[i],
	                graph.nodes(a[i].source),
	                graph.nodes(a[i].target),
	                this.contexts.labels,
	                embedSettings
	              );
	        }
	      }
	    }
	
	    // Draw nodes:
	    // - No batching
	    if (drawNodes) {
	      renderers = sigma.canvas.nodes;
	      for (a = this.nodesOnScreen, i = 0, l = a.length; i < l; i++)
	        if (!a[i].hidden)
	          (renderers[
	            a[i].type || this.settings(options, 'defaultNodeType')
	          ] || renderers.def)(
	            a[i],
	            this.contexts.nodes,
	            embedSettings
	          );
	    }
	
	    // Draw labels:
	    // - No batching
	    if (drawLabels) {
	      renderers = sigma.canvas.labels;
	      for (a = this.nodesOnScreen, i = 0, l = a.length; i < l; i++)
	        if (!a[i].hidden)
	          (renderers[
	            a[i].type || this.settings(options, 'defaultNodeType')
	          ] || renderers.def)(
	            a[i],
	            this.contexts.labels,
	            embedSettings
	          );
	    }
	
	    this.dispatchEvent('render');
	
	    return this;
	  };
	
	  /**
	   * This method creates a DOM element of the specified type, switches its
	   * position to "absolute", references it to the domElements attribute, and
	   * finally appends it to the container.
	   *
	   * @param  {string} tag The label tag.
	   * @param  {string} id  The id of the element (to store it in "domElements").
	   */
	  sigma.renderers.canvas.prototype.initDOM = function(tag, id) {
	    var dom = document.createElement(tag);
	
	    dom.style.position = 'absolute';
	    dom.setAttribute('class', 'sigma-' + id);
	
	    this.domElements[id] = dom;
	    this.container.appendChild(dom);
	
	    if (tag.toLowerCase() === 'canvas')
	      this.contexts[id] = dom.getContext('2d');
	  };
	
	  /**
	   * This method resizes each DOM elements in the container and stores the new
	   * dimensions. Then, it renders the graph.
	   *
	   * @param  {?number}                width  The new width of the container.
	   * @param  {?number}                height The new height of the container.
	   * @return {sigma.renderers.canvas}        Returns the instance itself.
	   */
	  sigma.renderers.canvas.prototype.resize = function(w, h) {
	    var k,
	        oldWidth = this.width,
	        oldHeight = this.height,
	        pixelRatio = sigma.utils.getPixelRatio();
	
	    if (w !== undefined && h !== undefined) {
	      this.width = w;
	      this.height = h;
	    } else {
	      this.width = this.container.offsetWidth;
	      this.height = this.container.offsetHeight;
	
	      w = this.width;
	      h = this.height;
	    }
	
	    if (oldWidth !== this.width || oldHeight !== this.height) {
	      for (k in this.domElements) {
	        this.domElements[k].style.width = w + 'px';
	        this.domElements[k].style.height = h + 'px';
	
	        if (this.domElements[k].tagName.toLowerCase() === 'canvas') {
	          this.domElements[k].setAttribute('width', (w * pixelRatio) + 'px');
	          this.domElements[k].setAttribute('height', (h * pixelRatio) + 'px');
	
	          if (pixelRatio !== 1)
	            this.contexts[k].scale(pixelRatio, pixelRatio);
	        }
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * This method clears each canvas.
	   *
	   * @return {sigma.renderers.canvas} Returns the instance itself.
	   */
	  sigma.renderers.canvas.prototype.clear = function() {
	    for (var k in this.contexts) {
	      this.contexts[k].clearRect(0, 0, this.width, this.height);
	    }
	
	    return this;
	  };
	
	  /**
	   * This method kills contexts and other attributes.
	   */
	  sigma.renderers.canvas.prototype.kill = function() {
	    var k,
	        captor;
	
	    // Kill captors:
	    while ((captor = this.captors.pop()))
	      captor.kill();
	    delete this.captors;
	
	    // Kill contexts:
	    for (k in this.domElements) {
	      this.domElements[k].parentNode.removeChild(this.domElements[k]);
	      delete this.domElements[k];
	      delete this.contexts[k];
	    }
	    delete this.domElements;
	    delete this.contexts;
	  };
	
	
	
	
	  /**
	   * The labels, nodes and edges renderers are stored in the three following
	   * objects. When an element is drawn, its type will be checked and if a
	   * renderer with the same name exists, it will be used. If not found, the
	   * default renderer will be used instead.
	   *
	   * They are stored in different files, in the "./canvas" folder.
	   */
	  sigma.utils.pkg('sigma.canvas.nodes');
	  sigma.utils.pkg('sigma.canvas.edges');
	  sigma.utils.pkg('sigma.canvas.labels');
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 69:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  var __instances = {};
	
	  /**
	   * This is the sigma instances constructor. One instance of sigma represent
	   * one graph. It is possible to represent this grapĥ with several renderers
	   * at the same time. By default, the default renderer (WebGL + Canvas
	   * polyfill) will be used as the only renderer, with the container specified
	   * in the configuration.
	   *
	   * @param  {?*}    conf The configuration of the instance. There are a lot of
	   *                      different recognized forms to instantiate sigma, check
	   *                      example files, documentation in this file and unit
	   *                      tests to know more.
	   * @return {sigma}      The fresh new sigma instance.
	   *
	   * Instanciating sigma:
	   * ********************
	   * If no parameter is given to the constructor, the instance will be created
	   * without any renderer or camera. It will just instantiate the graph, and
	   * other modules will have to be instantiated through the public methods,
	   * like "addRenderer" etc:
	   *
	   *  > s0 = new sigma();
	   *  > s0.addRenderer({
	   *  >   type: 'canvas',
	   *  >   container: 'my-container-id'
	   *  > });
	   *
	   * In most of the cases, sigma will simply be used with the default renderer.
	   * Then, since the only required parameter is the DOM container, there are
	   * some simpler way to call the constructor. The four following calls do the
	   * exact same things:
	   *
	   *  > s1 = new sigma('my-container-id');
	   *  > s2 = new sigma(document.getElementById('my-container-id'));
	   *  > s3 = new sigma({
	   *  >   container: document.getElementById('my-container-id')
	   *  > });
	   *  > s4 = new sigma({
	   *  >   renderers: [{
	   *  >     container: document.getElementById('my-container-id')
	   *  >   }]
	   *  > });
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters, when calling the
	   * constructor with to top level configuration object (fourth case in the
	   * previous examples):
	   *
	   *   {?string} id        The id of the instance. It will be generated
	   *                       automatically if not specified.
	   *   {?array}  renderers An array containing objects describing renderers.
	   *   {?object} graph     An object containing an array of nodes and an array
	   *                       of edges, to avoid having to add them by hand later.
	   *   {?object} settings  An object containing instance specific settings that
	   *                       will override the default ones defined in the object
	   *                       sigma.settings.
	   */
	  var sigma = function(conf) {
	    // Local variables:
	    // ****************
	    var i,
	        l,
	        a,
	        c,
	        o,
	        id;
	
	    sigma.classes.dispatcher.extend(this);
	
	    // Private attributes:
	    // *******************
	    var _self = this,
	        _conf = conf || {};
	
	    // Little shortcut:
	    // ****************
	    // The configuration is supposed to have a list of the configuration
	    // objects for each renderer.
	    //  - If there are no configuration at all, then nothing is done.
	    //  - If there are no renderer list, the given configuration object will be
	    //    considered as describing the first and only renderer.
	    //  - If there are no renderer list nor "container" object, it will be
	    //    considered as the container itself (a DOM element).
	    //  - If the argument passed to sigma() is a string, it will be considered
	    //    as the ID of the DOM container.
	    if (
	      typeof _conf === 'string' ||
	      _conf instanceof HTMLElement
	    )
	      _conf = {
	        renderers: [_conf]
	      };
	    else if (Object.prototype.toString.call(_conf) === '[object Array]')
	      _conf = {
	        renderers: _conf
	      };
	
	    // Also check "renderer" and "container" keys:
	    o = _conf.renderers || _conf.renderer || _conf.container;
	    if (!_conf.renderers || _conf.renderers.length === 0)
	      if (
	        typeof o === 'string' ||
	        o instanceof HTMLElement ||
	        (typeof o === 'object' && 'container' in o)
	      )
	        _conf.renderers = [o];
	
	    // Recense the instance:
	    if (_conf.id) {
	      if (__instances[_conf.id])
	        throw 'sigma: Instance "' + _conf.id + '" already exists.';
	      Object.defineProperty(this, 'id', {
	        value: _conf.id
	      });
	    } else {
	      id = 0;
	      while (__instances[id])
	        id++;
	      Object.defineProperty(this, 'id', {
	        value: '' + id
	      });
	    }
	    __instances[this.id] = this;
	
	    // Initialize settings function:
	    this.settings = new sigma.classes.configurable(
	      sigma.settings,
	      _conf.settings || {}
	    );
	
	    // Initialize locked attributes:
	    Object.defineProperty(this, 'graph', {
	      value: new sigma.classes.graph(this.settings),
	      configurable: true
	    });
	    Object.defineProperty(this, 'middlewares', {
	      value: [],
	      configurable: true
	    });
	    Object.defineProperty(this, 'cameras', {
	      value: {},
	      configurable: true
	    });
	    Object.defineProperty(this, 'renderers', {
	      value: {},
	      configurable: true
	    });
	    Object.defineProperty(this, 'renderersPerCamera', {
	      value: {},
	      configurable: true
	    });
	    Object.defineProperty(this, 'cameraFrames', {
	      value: {},
	      configurable: true
	    });
	    Object.defineProperty(this, 'camera', {
	      get: function() {
	        return this.cameras[0];
	      }
	    });
	    Object.defineProperty(this, 'events', {
	      value: [
	        'click',
	        'rightClick',
	        'clickStage',
	        'doubleClickStage',
	        'rightClickStage',
	        'clickNode',
	        'clickNodes',
	        'doubleClickNode',
	        'doubleClickNodes',
	        'rightClickNode',
	        'rightClickNodes',
	        'overNode',
	        'overNodes',
	        'outNode',
	        'outNodes',
	        'downNode',
	        'downNodes',
	        'upNode',
	        'upNodes'
	      ],
	      configurable: true
	    });
	
	    // Add a custom handler, to redispatch events from renderers:
	    this._handler = (function(e) {
	      var k,
	          data = {};
	
	      for (k in e.data)
	        data[k] = e.data[k];
	
	      data.renderer = e.target;
	      this.dispatchEvent(e.type, data);
	    }).bind(this);
	
	    // Initialize renderers:
	    a = _conf.renderers || [];
	    for (i = 0, l = a.length; i < l; i++)
	      this.addRenderer(a[i]);
	
	    // Initialize middlewares:
	    a = _conf.middlewares || [];
	    for (i = 0, l = a.length; i < l; i++)
	      this.middlewares.push(
	        typeof a[i] === 'string' ?
	          sigma.middlewares[a[i]] :
	          a[i]
	      );
	
	    // Check if there is already a graph to fill in:
	    if (typeof _conf.graph === 'object' && _conf.graph) {
	      this.graph.read(_conf.graph);
	
	      // If a graph is given to the to the instance, the "refresh" method is
	      // directly called:
	      this.refresh();
	    }
	
	    // Deal with resize:
	    window.addEventListener('resize', function() {
	      if (_self.settings)
	        _self.refresh();
	    });
	  };
	
	
	
	
	  /**
	   * This methods will instantiate and reference a new camera. If no id is
	   * specified, then an automatic id will be generated.
	   *
	   * @param  {?string}              id Eventually the camera id.
	   * @return {sigma.classes.camera}    The fresh new camera instance.
	   */
	  sigma.prototype.addCamera = function(id) {
	    var self = this,
	        camera;
	
	    if (!arguments.length) {
	      id = 0;
	      while (this.cameras['' + id])
	        id++;
	      id = '' + id;
	    }
	
	    if (this.cameras[id])
	      throw 'sigma.addCamera: The camera "' + id + '" already exists.';
	
	    camera = new sigma.classes.camera(id, this.graph, this.settings);
	    this.cameras[id] = camera;
	
	    // Add a quadtree to the camera:
	    camera.quadtree = new sigma.classes.quad();
	
	    // Add an edgequadtree to the camera:
	    if (sigma.classes.edgequad !== undefined) {
	      camera.edgequadtree = new sigma.classes.edgequad();
	    }
	
	    camera.bind('coordinatesUpdated', function(e) {
	      self.renderCamera(camera, camera.isAnimated);
	    });
	
	    this.renderersPerCamera[id] = [];
	
	    return camera;
	  };
	
	  /**
	   * This method kills a camera, and every renderer attached to it.
	   *
	   * @param  {string|camera} v The camera to kill or its ID.
	   * @return {sigma}           Returns the instance.
	   */
	  sigma.prototype.killCamera = function(v) {
	    v = typeof v === 'string' ? this.cameras[v] : v;
	
	    if (!v)
	      throw 'sigma.killCamera: The camera is undefined.';
	
	    var i,
	        l,
	        a = this.renderersPerCamera[v.id];
	
	    for (l = a.length, i = l - 1; i >= 0; i--)
	      this.killRenderer(a[i]);
	
	    delete this.renderersPerCamera[v.id];
	    delete this.cameraFrames[v.id];
	    delete this.cameras[v.id];
	
	    if (v.kill)
	      v.kill();
	
	    return this;
	  };
	
	  /**
	   * This methods will instantiate and reference a new renderer. The "type"
	   * argument can be the constructor or its name in the "sigma.renderers"
	   * package. If no type is specified, then "sigma.renderers.def" will be used.
	   * If no id is specified, then an automatic id will be generated.
	   *
	   * @param  {?object}  options Eventually some options to give to the renderer
	   *                            constructor.
	   * @return {renderer}         The fresh new renderer instance.
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters in the "options"
	   * object:
	   *
	   *   {?string}            id     Eventually the renderer id.
	   *   {?(function|string)} type   Eventually the renderer constructor or its
	   *                               name in the "sigma.renderers" package.
	   *   {?(camera|string)}   camera Eventually the renderer camera or its
	   *                               id.
	   */
	  sigma.prototype.addRenderer = function(options) {
	    var id,
	        fn,
	        camera,
	        renderer,
	        o = options || {};
	
	    // Polymorphism:
	    if (typeof o === 'string')
	      o = {
	        container: document.getElementById(o)
	      };
	    else if (o instanceof HTMLElement)
	      o = {
	        container: o
	      };
	
	    // If the container still is a string, we get it by id
	    if (typeof o.container === 'string')
	      o.container = document.getElementById(o.container);
	
	    // Reference the new renderer:
	    if (!('id' in o)) {
	      id = 0;
	      while (this.renderers['' + id])
	        id++;
	      id = '' + id;
	    } else
	      id = o.id;
	
	    if (this.renderers[id])
	      throw 'sigma.addRenderer: The renderer "' + id + '" already exists.';
	
	    // Find the good constructor:
	    fn = typeof o.type === 'function' ? o.type : sigma.renderers[o.type];
	    fn = fn || sigma.renderers.def;
	
	    // Find the good camera:
	    camera = 'camera' in o ?
	      (
	        o.camera instanceof sigma.classes.camera ?
	          o.camera :
	          this.cameras[o.camera] || this.addCamera(o.camera)
	      ) :
	      this.addCamera();
	
	    if (this.cameras[camera.id] !== camera)
	      throw 'sigma.addRenderer: The camera is not properly referenced.';
	
	    // Instantiate:
	    renderer = new fn(this.graph, camera, this.settings, o);
	    this.renderers[id] = renderer;
	    Object.defineProperty(renderer, 'id', {
	      value: id
	    });
	
	    // Bind events:
	    if (renderer.bind)
	      renderer.bind(
	        [
	          'click',
	          'rightClick',
	          'clickStage',
	          'doubleClickStage',
	          'rightClickStage',
	          'clickNode',
	          'clickNodes',
	          'clickEdge',
	          'clickEdges',
	          'doubleClickNode',
	          'doubleClickNodes',
	          'doubleClickEdge',
	          'doubleClickEdges',
	          'rightClickNode',
	          'rightClickNodes',
	          'rightClickEdge',
	          'rightClickEdges',
	          'overNode',
	          'overNodes',
	          'overEdge',
	          'overEdges',
	          'outNode',
	          'outNodes',
	          'outEdge',
	          'outEdges',
	          'downNode',
	          'downNodes',
	          'downEdge',
	          'downEdges',
	          'upNode',
	          'upNodes',
	          'upEdge',
	          'upEdges'
	        ],
	        this._handler
	      );
	
	    // Reference the renderer by its camera:
	    this.renderersPerCamera[camera.id].push(renderer);
	
	    return renderer;
	  };
	
	  /**
	   * This method kills a renderer.
	   *
	   * @param  {string|renderer} v The renderer to kill or its ID.
	   * @return {sigma}             Returns the instance.
	   */
	  sigma.prototype.killRenderer = function(v) {
	    v = typeof v === 'string' ? this.renderers[v] : v;
	
	    if (!v)
	      throw 'sigma.killRenderer: The renderer is undefined.';
	
	    var a = this.renderersPerCamera[v.camera.id],
	        i = a.indexOf(v);
	
	    if (i >= 0)
	      a.splice(i, 1);
	
	    if (v.kill)
	      v.kill();
	
	    delete this.renderers[v.id];
	
	    return this;
	  };
	
	
	
	
	  /**
	   * This method calls the "render" method of each renderer, with the same
	   * arguments than the "render" method, but will also check if the renderer
	   * has a "process" method, and call it if it exists.
	   *
	   * It is useful for quadtrees or WebGL processing, for instance.
	   *
	   * @param  {?object}  options Eventually some options to give to the refresh
	   *                            method.
	   * @return {sigma}            Returns the instance itself.
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters in the "options"
	   * object:
	   *
	   *   {?boolean} skipIndexation A flag specifying wether or not the refresh
	   *                             function should reindex the graph in the
	   *                             quadtrees or not (default: false).
	   */
	  sigma.prototype.refresh = function(options) {
	    var i,
	        l,
	        k,
	        a,
	        c,
	        bounds,
	        prefix = 0;
	
	    options = options || {};
	
	    // Call each middleware:
	    a = this.middlewares || [];
	    for (i = 0, l = a.length; i < l; i++)
	      a[i].call(
	        this,
	        (i === 0) ? '' : 'tmp' + prefix + ':',
	        (i === l - 1) ? 'ready:' : ('tmp' + (++prefix) + ':')
	      );
	
	    // Then, for each camera, call the "rescale" middleware, unless the
	    // settings specify not to:
	    for (k in this.cameras) {
	      c = this.cameras[k];
	      if (
	        c.settings('autoRescale') &&
	        this.renderersPerCamera[c.id] &&
	        this.renderersPerCamera[c.id].length
	      )
	        sigma.middlewares.rescale.call(
	          this,
	          a.length ? 'ready:' : '',
	          c.readPrefix,
	          {
	            width: this.renderersPerCamera[c.id][0].width,
	            height: this.renderersPerCamera[c.id][0].height
	          }
	        );
	      else
	        sigma.middlewares.copy.call(
	          this,
	          a.length ? 'ready:' : '',
	          c.readPrefix
	        );
	
	      if (!options.skipIndexation) {
	        // Find graph boundaries:
	        bounds = sigma.utils.getBoundaries(
	          this.graph,
	          c.readPrefix
	        );
	
	        // Refresh quadtree:
	        c.quadtree.index(this.graph.nodes(), {
	          prefix: c.readPrefix,
	          bounds: {
	            x: bounds.minX,
	            y: bounds.minY,
	            width: bounds.maxX - bounds.minX,
	            height: bounds.maxY - bounds.minY
	          }
	        });
	
	        // Refresh edgequadtree:
	        if (
	          c.edgequadtree !== undefined &&
	          c.settings('drawEdges') &&
	          c.settings('enableEdgeHovering')
	        ) {
	          c.edgequadtree.index(this.graph, {
	            prefix: c.readPrefix,
	            bounds: {
	              x: bounds.minX,
	              y: bounds.minY,
	              width: bounds.maxX - bounds.minX,
	              height: bounds.maxY - bounds.minY
	            }
	          });
	        }
	      }
	    }
	
	    // Call each renderer:
	    a = Object.keys(this.renderers);
	    for (i = 0, l = a.length; i < l; i++)
	      if (this.renderers[a[i]].process) {
	        if (this.settings('skipErrors'))
	          try {
	            this.renderers[a[i]].process();
	          } catch (e) {
	            console.log(
	              'Warning: The renderer "' + a[i] + '" crashed on ".process()"'
	            );
	          }
	        else
	          this.renderers[a[i]].process();
	      }
	
	    this.render();
	
	    return this;
	  };
	
	  /**
	   * This method calls the "render" method of each renderer.
	   *
	   * @return {sigma} Returns the instance itself.
	   */
	  sigma.prototype.render = function() {
	    var i,
	        l,
	        a,
	        prefix = 0;
	
	    // Call each renderer:
	    a = Object.keys(this.renderers);
	    for (i = 0, l = a.length; i < l; i++)
	      if (this.settings('skipErrors'))
	        try {
	          this.renderers[a[i]].render();
	        } catch (e) {
	          if (this.settings('verbose'))
	            console.log(
	              'Warning: The renderer "' + a[i] + '" crashed on ".render()"'
	            );
	        }
	      else
	        this.renderers[a[i]].render();
	
	    return this;
	  };
	
	  /**
	   * This method calls the "render" method of each renderer that is bound to
	   * the specified camera. To improve the performances, if this method is
	   * called too often, the number of effective renderings is limitated to one
	   * per frame, unless you are using the "force" flag.
	   *
	   * @param  {sigma.classes.camera} camera The camera to render.
	   * @param  {?boolean}             force  If true, will render the camera
	   *                                       directly.
	   * @return {sigma}                       Returns the instance itself.
	   */
	  sigma.prototype.renderCamera = function(camera, force) {
	    var i,
	        l,
	        a,
	        self = this;
	
	    if (force) {
	      a = this.renderersPerCamera[camera.id];
	      for (i = 0, l = a.length; i < l; i++)
	        if (this.settings('skipErrors'))
	          try {
	            a[i].render();
	          } catch (e) {
	            if (this.settings('verbose'))
	              console.log(
	                'Warning: The renderer "' + a[i].id + '" crashed on ".render()"'
	              );
	          }
	        else
	          a[i].render();
	    } else {
	      if (!this.cameraFrames[camera.id]) {
	        a = this.renderersPerCamera[camera.id];
	        for (i = 0, l = a.length; i < l; i++)
	          if (this.settings('skipErrors'))
	            try {
	              a[i].render();
	            } catch (e) {
	              if (this.settings('verbose'))
	                console.log(
	                  'Warning: The renderer "' +
	                    a[i].id +
	                    '" crashed on ".render()"'
	                );
	            }
	          else
	            a[i].render();
	
	        this.cameraFrames[camera.id] = requestAnimationFrame(function() {
	          delete self.cameraFrames[camera.id];
	        });
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * This method calls the "kill" method of each module and destroys any
	   * reference from the instance.
	   */
	  sigma.prototype.kill = function() {
	    var k;
	
	    // Dispatching event
	    this.dispatchEvent('kill');
	
	    // Kill graph:
	    this.graph.kill();
	
	    // Kill middlewares:
	    delete this.middlewares;
	
	    // Kill each renderer:
	    for (k in this.renderers)
	      this.killRenderer(this.renderers[k]);
	
	    // Kill each camera:
	    for (k in this.cameras)
	      this.killCamera(this.cameras[k]);
	
	    delete this.renderers;
	    delete this.cameras;
	
	    // Kill everything else:
	    for (k in this)
	      if (this.hasOwnProperty(k))
	        delete this[k];
	
	    delete __instances[this.id];
	  };
	
	
	
	
	  /**
	   * Returns a clone of the instances object or a specific running instance.
	   *
	   * @param  {?string} id Eventually an instance ID.
	   * @return {object}     The related instance or a clone of the instances
	   *                      object.
	   */
	  sigma.instances = function(id) {
	    return arguments.length ?
	      __instances[id] :
	      sigma.utils.extend({}, __instances);
	  };
	
	
	
	  /**
	   * The current version of sigma:
	   */
	  sigma.version = '1.2.0';
	
	
	
	
	  /**
	   * EXPORT:
	   * *******
	   */
	  if (typeof this.sigma !== 'undefined')
	    throw 'An object called sigma is already in the global scope.';
	
	  this.sigma = sigma;
	
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 70:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Packages initialization:
	  sigma.utils.pkg('sigma.settings');
	
	  var settings = {
	    /**
	     * GRAPH SETTINGS:
	     * ***************
	     */
	    // {boolean} Indicates if the data have to be cloned in methods to add
	    //           nodes or edges.
	    clone: true,
	    // {boolean} Indicates if nodes "id" values and edges "id", "source" and
	    //           "target" values must be set as immutable.
	    immutable: true,
	    // {boolean} Indicates if sigma can log its errors and warnings.
	    verbose: false,
	
	
	    /**
	     * RENDERERS SETTINGS:
	     * *******************
	     */
	    // {string}
	    classPrefix: 'sigma',
	    // {string}
	    defaultNodeType: 'def',
	    // {string}
	    defaultEdgeType: 'def',
	    // {string}
	    defaultLabelColor: '#000',
	    // {string}
	    defaultEdgeColor: '#000',
	    // {string}
	    defaultNodeColor: '#000',
	    // {string}
	    defaultLabelSize: 14,
	    // {string} Indicates how to choose the edges color. Available values:
	    //          "source", "target", "default"
	    edgeColor: 'source',
	    // {number} Defines the minimal edge's arrow display size.
	    minArrowSize: 0,
	    // {string}
	    font: 'arial',
	    // {string} Example: 'bold'
	    fontStyle: '',
	    // {string} Indicates how to choose the labels color. Available values:
	    //          "node", "default"
	    labelColor: 'default',
	    // {string} Indicates how to choose the labels size. Available values:
	    //          "fixed", "proportional"
	    labelSize: 'fixed',
	    // {string} The ratio between the font size of the label and the node size.
	    labelSizeRatio: 1,
	    // {number} The minimum size a node must have to see its label displayed.
	    labelThreshold: 8,
	    // {number} The oversampling factor used in WebGL renderer.
	    webglOversamplingRatio: 2,
	    // {number} The size of the border of hovered nodes.
	    borderSize: 0,
	    // {number} The default hovered node border's color.
	    defaultNodeBorderColor: '#000',
	    // {number} The hovered node's label font. If not specified, will heritate
	    //          the "font" value.
	    hoverFont: '',
	    // {boolean} If true, then only one node can be hovered at a time.
	    singleHover: true,
	    // {string} Example: 'bold'
	    hoverFontStyle: '',
	    // {string} Indicates how to choose the hovered nodes shadow color.
	    //          Available values: "node", "default"
	    labelHoverShadow: 'default',
	    // {string}
	    labelHoverShadowColor: '#000',
	    // {string} Indicates how to choose the hovered nodes color.
	    //          Available values: "node", "default"
	    nodeHoverColor: 'node',
	    // {string}
	    defaultNodeHoverColor: '#000',
	    // {string} Indicates how to choose the hovered nodes background color.
	    //          Available values: "node", "default"
	    labelHoverBGColor: 'default',
	    // {string}
	    defaultHoverLabelBGColor: '#fff',
	    // {string} Indicates how to choose the hovered labels color.
	    //          Available values: "node", "default"
	    labelHoverColor: 'default',
	    // {string}
	    defaultLabelHoverColor: '#000',
	    // {string} Indicates how to choose the edges hover color. Available values:
	    //          "edge", "default"
	    edgeHoverColor: 'edge',
	    // {number} The size multiplicator of hovered edges.
	    edgeHoverSizeRatio: 1,
	    // {string}
	    defaultEdgeHoverColor: '#000',
	    // {boolean} Indicates if the edge extremities must be hovered when the
	    //           edge is hovered.
	    edgeHoverExtremities: false,
	    // {booleans} The different drawing modes:
	    //           false: Layered not displayed.
	    //           true: Layered displayed.
	    drawEdges: true,
	    drawNodes: true,
	    drawLabels: true,
	    drawEdgeLabels: false,
	    // {boolean} Indicates if the edges must be drawn in several frames or in
	    //           one frame, as the nodes and labels are drawn.
	    batchEdgesDrawing: false,
	    // {boolean} Indicates if the edges must be hidden during dragging and
	    //           animations.
	    hideEdgesOnMove: false,
	    // {numbers} The different batch sizes, when elements are displayed in
	    //           several frames.
	    canvasEdgesBatchSize: 500,
	    webglEdgesBatchSize: 1000,
	
	
	
	
	    /**
	     * RESCALE SETTINGS:
	     * *****************
	     */
	    // {string} Indicates of to scale the graph relatively to its container.
	    //          Available values: "inside", "outside"
	    scalingMode: 'inside',
	    // {number} The margin to keep around the graph.
	    sideMargin: 0,
	    // {number} Determine the size of the smallest and the biggest node / edges
	    //          on the screen. This mapping makes easier to display the graph,
	    //          avoiding too big nodes that take half of the screen, or too
	    //          small ones that are not readable. If the two parameters are
	    //          equals, then the minimal display size will be 0. And if they
	    //          are both equal to 0, then there is no mapping, and the radius
	    //          of the nodes will be their size.
	    minEdgeSize: 0.5,
	    maxEdgeSize: 1,
	    minNodeSize: 1,
	    maxNodeSize: 8,
	
	
	
	
	    /**
	     * CAPTORS SETTINGS:
	     * *****************
	     */
	    // {boolean}
	    touchEnabled: true,
	    // {boolean}
	    mouseEnabled: true,
	    // {boolean}
	    mouseWheelEnabled: true,
	    // {boolean}
	    doubleClickEnabled: true,
	    // {boolean} Defines whether the custom events such as "clickNode" can be
	    //           used.
	    eventsEnabled: true,
	    // {number} Defines by how much multiplicating the zooming level when the
	    //          user zooms with the mouse-wheel.
	    zoomingRatio: 1.7,
	    // {number} Defines by how much multiplicating the zooming level when the
	    //          user zooms by double clicking.
	    doubleClickZoomingRatio: 2.2,
	    // {number} The minimum zooming level.
	    zoomMin: 0.0625,
	    // {number} The maximum zooming level.
	    zoomMax: 2,
	    // {number} The duration of animations following a mouse scrolling.
	    mouseZoomDuration: 200,
	    // {number} The duration of animations following a mouse double click.
	    doubleClickZoomDuration: 200,
	    // {number} The duration of animations following a mouse dropping.
	    mouseInertiaDuration: 200,
	    // {number} The inertia power (mouse captor).
	    mouseInertiaRatio: 3,
	    // {number} The duration of animations following a touch dropping.
	    touchInertiaDuration: 200,
	    // {number} The inertia power (touch captor).
	    touchInertiaRatio: 3,
	    // {number} The maximum time between two clicks to make it a double click.
	    doubleClickTimeout: 300,
	    // {number} The maximum time between two taps to make it a double tap.
	    doubleTapTimeout: 300,
	    // {number} The maximum time of dragging to trigger intertia.
	    dragTimeout: 200,
	
	
	
	
	    /**
	     * GLOBAL SETTINGS:
	     * ****************
	     */
	    // {boolean} Determines whether the instance has to refresh itself
	    //           automatically when a "resize" event is dispatched from the
	    //           window object.
	    autoResize: true,
	    // {boolean} Determines whether the "rescale" middleware has to be called
	    //           automatically for each camera on refresh.
	    autoRescale: true,
	    // {boolean} If set to false, the camera method "goTo" will basically do
	    //           nothing.
	    enableCamera: true,
	    // {boolean} If set to false, the nodes cannot be hovered.
	    enableHovering: true,
	    // {boolean} If set to true, the edges can be hovered.
	    enableEdgeHovering: false,
	    // {number} The size of the area around the edges to activate hovering.
	    edgeHoverPrecision: 5,
	    // {boolean} If set to true, the rescale middleware will ignore node sizes
	    //           to determine the graphs boundings.
	    rescaleIgnoreSize: false,
	    // {boolean} Determines if the core has to try to catch errors on
	    //           rendering.
	    skipErrors: false,
	
	
	
	
	    /**
	     * CAMERA SETTINGS:
	     * ****************
	     */
	    // {number} The power degrees applied to the nodes/edges size relatively to
	    //          the zooming level. Basically:
	    //           > onScreenR = Math.pow(zoom, nodesPowRatio) * R
	    //           > onScreenT = Math.pow(zoom, edgesPowRatio) * T
	    nodesPowRatio: 0.5,
	    edgesPowRatio: 0.5,
	
	
	
	
	    /**
	     * ANIMATIONS SETTINGS:
	     * ********************
	     */
	    // {number} The default animation time.
	    animationsTime: 200
	  };
	
	  // Export the previously designed settings:
	  sigma.settings = sigma.utils.extend(sigma.settings || {}, settings);
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 71:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(global) {
	  'use strict';
	
	  /**
	   * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	   * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	   * requestAnimationFrame polyfill by Erik Möller.
	   * fixes from Paul Irish and Tino Zijdel
	   * MIT license
	   */
	  var x,
	      lastTime = 0,
	      vendors = ['ms', 'moz', 'webkit', 'o'];
	
	  for (x = 0; x < vendors.length && !global.requestAnimationFrame; x++) {
	    global.requestAnimationFrame =
	      global[vendors[x] + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame =
	      global[vendors[x] + 'CancelAnimationFrame'] ||
	      global[vendors[x] + 'CancelRequestAnimationFrame'];
	  }
	
	  if (!global.requestAnimationFrame)
	    global.requestAnimationFrame = function(callback, element) {
	      var currTime = new Date().getTime(),
	          timeToCall = Math.max(0, 16 - (currTime - lastTime)),
	          id = global.setTimeout(
	            function() {
	              callback(currTime + timeToCall);
	            },
	            timeToCall
	          );
	
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	
	  if (!global.cancelAnimationFrame)
	    global.cancelAnimationFrame = function(id) {
	      clearTimeout(id);
	    };
	
	  /**
	   * Function.prototype.bind polyfill found on MDN.
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Compatibility
	   * Public domain
	   */
	  if (!Function.prototype.bind)
	    Function.prototype.bind = function(oThis) {
	      if (typeof this !== 'function')
	        // Closest thing possible to the ECMAScript 5 internal IsCallable
	        // function:
	        throw new TypeError(
	          'Function.prototype.bind - what is trying to be bound is not callable'
	        );
	
	      var aArgs = Array.prototype.slice.call(arguments, 1),
	          fToBind = this,
	          fNOP,
	          fBound;
	
	      fNOP = function() {};
	      fBound = function() {
	        return fToBind.apply(
	          this instanceof fNOP && oThis ?
	            this :
	            oThis,
	          aArgs.concat(Array.prototype.slice.call(arguments))
	        );
	      };
	
	      fNOP.prototype = this.prototype;
	      fBound.prototype = new fNOP();
	
	      return fBound;
	    };
	})(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 72:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  var _root = this;
	
	  // Initialize packages:
	  sigma.utils = sigma.utils || {};
	
	  /**
	   * MISC UTILS:
	   */
	  /**
	   * This function takes any number of objects as arguments, copies from each
	   * of these objects each pair key/value into a new object, and finally
	   * returns this object.
	   *
	   * The arguments are parsed from the last one to the first one, such that
	   * when several objects have keys in common, the "earliest" object wins.
	   *
	   * Example:
	   * ********
	   *  > var o1 = {
	   *  >       a: 1,
	   *  >       b: 2,
	   *  >       c: '3'
	   *  >     },
	   *  >     o2 = {
	   *  >       c: '4',
	   *  >       d: [ 5 ]
	   *  >     };
	   *  > sigma.utils.extend(o1, o2);
	   *  > // Returns: {
	   *  > //   a: 1,
	   *  > //   b: 2,
	   *  > //   c: '3',
	   *  > //   d: [ 5 ]
	   *  > // };
	   *
	   * @param  {object+} Any number of objects.
	   * @return {object}  The merged object.
	   */
	  sigma.utils.extend = function() {
	    var i,
	        k,
	        res = {},
	        l = arguments.length;
	
	    for (i = l - 1; i >= 0; i--)
	      for (k in arguments[i])
	        res[k] = arguments[i][k];
	
	    return res;
	  };
	
	  /**
	   * A short "Date.now()" polyfill.
	   *
	   * @return {Number} The current time (in ms).
	   */
	  sigma.utils.dateNow = function() {
	    return Date.now ? Date.now() : new Date().getTime();
	  };
	
	  /**
	   * Takes a package name as parameter and checks at each lebel if it exists,
	   * and if it does not, creates it.
	   *
	   * Example:
	   * ********
	   *  > sigma.utils.pkg('a.b.c');
	   *  > a.b.c;
	   *  > // Object {};
	   *  >
	   *  > sigma.utils.pkg('a.b.d');
	   *  > a.b;
	   *  > // Object { c: {}, d: {} };
	   *
	   * @param  {string} pkgName The name of the package to create/find.
	   * @return {object}         The related package.
	   */
	  sigma.utils.pkg = function(pkgName) {
	    return (pkgName || '').split('.').reduce(function(context, objName) {
	      return (objName in context) ?
	        context[objName] :
	        (context[objName] = {});
	    }, _root);
	  };
	
	  /**
	   * Returns a unique incremental number ID.
	   *
	   * Example:
	   * ********
	   *  > sigma.utils.id();
	   *  > // 1;
	   *  >
	   *  > sigma.utils.id();
	   *  > // 2;
	   *  >
	   *  > sigma.utils.id();
	   *  > // 3;
	   *
	   * @param  {string} pkgName The name of the package to create/find.
	   * @return {object}         The related package.
	   */
	  sigma.utils.id = (function() {
	    var i = 0;
	    return function() {
	      return ++i;
	    };
	  })();
	
	  /**
	   * This function takes an hexa color (for instance "#ffcc00" or "#fc0") or a
	   * rgb / rgba color (like "rgb(255,255,12)" or "rgba(255,255,12,1)") and
	   * returns an integer equal to "r * 255 * 255 + g * 255 + b", to gain some
	   * memory in the data given to WebGL shaders.
	   *
	   * Note that the function actually caches its results for better performance.
	   *
	   * @param  {string} val The hexa or rgba color.
	   * @return {number}     The number value.
	   */
	  var floatColorCache = {};
	
	  sigma.utils.floatColor = function(val) {
	
	    // Is the color already computed?
	    if (floatColorCache[val])
	      return floatColorCache[val];
	
	    var original = val,
	        r = 0,
	        g = 0,
	        b = 0;
	
	    if (val[0] === '#') {
	      val = val.slice(1);
	
	      if (val.length === 3) {
	        r = parseInt(val.charAt(0) + val.charAt(0), 16);
	        g = parseInt(val.charAt(1) + val.charAt(1), 16);
	        b = parseInt(val.charAt(2) + val.charAt(2), 16);
	      }
	      else {
	        r = parseInt(val.charAt(0) + val.charAt(1), 16);
	        g = parseInt(val.charAt(2) + val.charAt(3), 16);
	        b = parseInt(val.charAt(4) + val.charAt(5), 16);
	      }
	    } else if (val.match(/^ *rgba? *\(/)) {
	      val = val.match(
	        /^ *rgba? *\( *([0-9]*) *, *([0-9]*) *, *([0-9]*) *(,.*)?\) *$/
	      );
	      r = +val[1];
	      g = +val[2];
	      b = +val[3];
	    }
	
	    var color = (
	      r * 256 * 256 +
	      g * 256 +
	      b
	    );
	
	    // Caching the color
	    floatColorCache[original] = color;
	
	    return color;
	  };
	
	    /**
	   * Perform a zoom into a camera, with or without animation, to the
	   * coordinates indicated using a specified ratio.
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters in the animation
	   * object:
	   *
	   *   {?number} duration     An amount of time that means the duration of the
	   *                          animation. If this parameter doesn't exist the
	   *                          zoom will be performed without animation.
	   *   {?function} onComplete A function to perform it after the animation. It
	   *                          will be performed even if there is no duration.
	   *
	   * @param {camera}     The camera where perform the zoom.
	   * @param {x}          The X coordiantion where the zoom goes.
	   * @param {y}          The Y coordiantion where the zoom goes.
	   * @param {ratio}      The ratio to apply it to the current camera ratio.
	   * @param {?animation} A dictionary with options for a possible animation.
	   */
	  sigma.utils.zoomTo = function(camera, x, y, ratio, animation) {
	    var settings = camera.settings,
	        count,
	        newRatio,
	        animationSettings,
	        coordinates;
	
	    // Create the newRatio dealing with min / max:
	    newRatio = Math.max(
	      settings('zoomMin'),
	      Math.min(
	        settings('zoomMax'),
	        camera.ratio * ratio
	      )
	    );
	
	    // Check that the new ratio is different from the initial one:
	    if (newRatio !== camera.ratio) {
	      // Create the coordinates variable:
	      ratio = newRatio / camera.ratio;
	      coordinates = {
	        x: x * (1 - ratio) + camera.x,
	        y: y * (1 - ratio) + camera.y,
	        ratio: newRatio
	      };
	
	      if (animation && animation.duration) {
	        // Complete the animation setings:
	        count = sigma.misc.animation.killAll(camera);
	        animation = sigma.utils.extend(
	          animation,
	          {
	            easing: count ? 'quadraticOut' : 'quadraticInOut'
	          }
	        );
	
	        sigma.misc.animation.camera(camera, coordinates, animation);
	      } else {
	        camera.goTo(coordinates);
	        if (animation && animation.onComplete)
	          animation.onComplete();
	      }
	    }
	  };
	
	  /**
	   * Return the control point coordinates for a quadratic bezier curve.
	   *
	   * @param  {number} x1  The X coordinate of the start point.
	   * @param  {number} y1  The Y coordinate of the start point.
	   * @param  {number} x2  The X coordinate of the end point.
	   * @param  {number} y2  The Y coordinate of the end point.
	   * @return {x,y}        The control point coordinates.
	   */
	  sigma.utils.getQuadraticControlPoint = function(x1, y1, x2, y2) {
	    return {
	      x: (x1 + x2) / 2 + (y2 - y1) / 4,
	      y: (y1 + y2) / 2 + (x1 - x2) / 4
	    };
	  };
	
	  /**
	    * Compute the coordinates of the point positioned
	    * at length t in the quadratic bezier curve.
	    *
	    * @param  {number} t  In [0,1] the step percentage to reach
	    *                     the point in the curve from the context point.
	    * @param  {number} x1 The X coordinate of the context point.
	    * @param  {number} y1 The Y coordinate of the context point.
	    * @param  {number} x2 The X coordinate of the ending point.
	    * @param  {number} y2 The Y coordinate of the ending point.
	    * @param  {number} xi The X coordinate of the control point.
	    * @param  {number} yi The Y coordinate of the control point.
	    * @return {object}    {x,y}.
	  */
	  sigma.utils.getPointOnQuadraticCurve = function(t, x1, y1, x2, y2, xi, yi) {
	    // http://stackoverflow.com/a/5634528
	    return {
	      x: Math.pow(1 - t, 2) * x1 + 2 * (1 - t) * t * xi + Math.pow(t, 2) * x2,
	      y: Math.pow(1 - t, 2) * y1 + 2 * (1 - t) * t * yi + Math.pow(t, 2) * y2
	    };
	  };
	
	  /**
	    * Compute the coordinates of the point positioned
	    * at length t in the cubic bezier curve.
	    *
	    * @param  {number} t  In [0,1] the step percentage to reach
	    *                     the point in the curve from the context point.
	    * @param  {number} x1 The X coordinate of the context point.
	    * @param  {number} y1 The Y coordinate of the context point.
	    * @param  {number} x2 The X coordinate of the end point.
	    * @param  {number} y2 The Y coordinate of the end point.
	    * @param  {number} cx The X coordinate of the first control point.
	    * @param  {number} cy The Y coordinate of the first control point.
	    * @param  {number} dx The X coordinate of the second control point.
	    * @param  {number} dy The Y coordinate of the second control point.
	    * @return {object}    {x,y} The point at t.
	  */
	  sigma.utils.getPointOnBezierCurve =
	    function(t, x1, y1, x2, y2, cx, cy, dx, dy) {
	    // http://stackoverflow.com/a/15397596
	    // Blending functions:
	    var B0_t = Math.pow(1 - t, 3),
	        B1_t = 3 * t * Math.pow(1 - t, 2),
	        B2_t = 3 * Math.pow(t, 2) * (1 - t),
	        B3_t = Math.pow(t, 3);
	
	    return {
	      x: (B0_t * x1) + (B1_t * cx) + (B2_t * dx) + (B3_t * x2),
	      y: (B0_t * y1) + (B1_t * cy) + (B2_t * dy) + (B3_t * y2)
	    };
	  };
	
	  /**
	   * Return the coordinates of the two control points for a self loop (i.e.
	   * where the start point is also the end point) computed as a cubic bezier
	   * curve.
	   *
	   * @param  {number} x    The X coordinate of the node.
	   * @param  {number} y    The Y coordinate of the node.
	   * @param  {number} size The node size.
	   * @return {x1,y1,x2,y2} The coordinates of the two control points.
	   */
	  sigma.utils.getSelfLoopControlPoints = function(x , y, size) {
	    return {
	      x1: x - size * 7,
	      y1: y,
	      x2: x,
	      y2: y + size * 7
	    };
	  };
	
	  /**
	   * Return the euclidian distance between two points of a plane
	   * with an orthonormal basis.
	   *
	   * @param  {number} x1  The X coordinate of the first point.
	   * @param  {number} y1  The Y coordinate of the first point.
	   * @param  {number} x2  The X coordinate of the second point.
	   * @param  {number} y2  The Y coordinate of the second point.
	   * @return {number}     The euclidian distance.
	   */
	  sigma.utils.getDistance = function(x0, y0, x1, y1) {
	    return Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2));
	  };
	
	  /**
	   * Return the coordinates of the intersection points of two circles.
	   *
	   * @param  {number} x0  The X coordinate of center location of the first
	   *                      circle.
	   * @param  {number} y0  The Y coordinate of center location of the first
	   *                      circle.
	   * @param  {number} r0  The radius of the first circle.
	   * @param  {number} x1  The X coordinate of center location of the second
	   *                      circle.
	   * @param  {number} y1  The Y coordinate of center location of the second
	   *                      circle.
	   * @param  {number} r1  The radius of the second circle.
	   * @return {xi,yi}      The coordinates of the intersection points.
	   */
	  sigma.utils.getCircleIntersection = function(x0, y0, r0, x1, y1, r1) {
	    // http://stackoverflow.com/a/12219802
	    var a, dx, dy, d, h, rx, ry, x2, y2;
	
	    // dx and dy are the vertical and horizontal distances between the circle
	    // centers:
	    dx = x1 - x0;
	    dy = y1 - y0;
	
	    // Determine the straight-line distance between the centers:
	    d = Math.sqrt((dy * dy) + (dx * dx));
	
	    // Check for solvability:
	    if (d > (r0 + r1)) {
	        // No solution. circles do not intersect.
	        return false;
	    }
	    if (d < Math.abs(r0 - r1)) {
	        // No solution. one circle is contained in the other.
	        return false;
	    }
	
	    //'point 2' is the point where the line through the circle intersection
	    // points crosses the line between the circle centers.
	
	    // Determine the distance from point 0 to point 2:
	    a = ((r0 * r0) - (r1 * r1) + (d * d)) / (2.0 * d);
	
	    // Determine the coordinates of point 2:
	    x2 = x0 + (dx * a / d);
	    y2 = y0 + (dy * a / d);
	
	    // Determine the distance from point 2 to either of the intersection
	    // points:
	    h = Math.sqrt((r0 * r0) - (a * a));
	
	    // Determine the offsets of the intersection points from point 2:
	    rx = -dy * (h / d);
	    ry = dx * (h / d);
	
	    // Determine the absolute intersection points:
	    var xi = x2 + rx;
	    var xi_prime = x2 - rx;
	    var yi = y2 + ry;
	    var yi_prime = y2 - ry;
	
	    return {xi: xi, xi_prime: xi_prime, yi: yi, yi_prime: yi_prime};
	  };
	
	  /**
	    * Check if a point is on a line segment.
	    *
	    * @param  {number} x       The X coordinate of the point to check.
	    * @param  {number} y       The Y coordinate of the point to check.
	    * @param  {number} x1      The X coordinate of the line start point.
	    * @param  {number} y1      The Y coordinate of the line start point.
	    * @param  {number} x2      The X coordinate of the line end point.
	    * @param  {number} y2      The Y coordinate of the line end point.
	    * @param  {number} epsilon The precision (consider the line thickness).
	    * @return {boolean}        True if point is "close to" the line
	    *                          segment, false otherwise.
	  */
	  sigma.utils.isPointOnSegment = function(x, y, x1, y1, x2, y2, epsilon) {
	    // http://stackoverflow.com/a/328122
	    var crossProduct = Math.abs((y - y1) * (x2 - x1) - (x - x1) * (y2 - y1)),
	        d = sigma.utils.getDistance(x1, y1, x2, y2),
	        nCrossProduct = crossProduct / d; // normalized cross product
	
	    return (nCrossProduct < epsilon &&
	     Math.min(x1, x2) <= x && x <= Math.max(x1, x2) &&
	     Math.min(y1, y2) <= y && y <= Math.max(y1, y2));
	  };
	
	  /**
	    * Check if a point is on a quadratic bezier curve segment with a thickness.
	    *
	    * @param  {number} x       The X coordinate of the point to check.
	    * @param  {number} y       The Y coordinate of the point to check.
	    * @param  {number} x1      The X coordinate of the curve start point.
	    * @param  {number} y1      The Y coordinate of the curve start point.
	    * @param  {number} x2      The X coordinate of the curve end point.
	    * @param  {number} y2      The Y coordinate of the curve end point.
	    * @param  {number} cpx     The X coordinate of the curve control point.
	    * @param  {number} cpy     The Y coordinate of the curve control point.
	    * @param  {number} epsilon The precision (consider the line thickness).
	    * @return {boolean}        True if (x,y) is on the curve segment,
	    *                          false otherwise.
	  */
	  sigma.utils.isPointOnQuadraticCurve =
	    function(x, y, x1, y1, x2, y2, cpx, cpy, epsilon) {
	    // Fails if the point is too far from the extremities of the segment,
	    // preventing for more costly computation:
	    var dP1P2 = sigma.utils.getDistance(x1, y1, x2, y2);
	    if (Math.abs(x - x1) > dP1P2 || Math.abs(y - y1) > dP1P2) {
	      return false;
	    }
	
	    var dP1 = sigma.utils.getDistance(x, y, x1, y1),
	        dP2 = sigma.utils.getDistance(x, y, x2, y2),
	        t = 0.5,
	        r = (dP1 < dP2) ? -0.01 : 0.01,
	        rThreshold = 0.001,
	        i = 100,
	        pt = sigma.utils.getPointOnQuadraticCurve(t, x1, y1, x2, y2, cpx, cpy),
	        dt = sigma.utils.getDistance(x, y, pt.x, pt.y),
	        old_dt;
	
	    // This algorithm minimizes the distance from the point to the curve. It
	    // find the optimal t value where t=0 is the start point and t=1 is the end
	    // point of the curve, starting from t=0.5.
	    // It terminates because it runs a maximum of i interations.
	    while (i-- > 0 &&
	      t >= 0 && t <= 1 &&
	      (dt > epsilon) &&
	      (r > rThreshold || r < -rThreshold)) {
	      old_dt = dt;
	      pt = sigma.utils.getPointOnQuadraticCurve(t, x1, y1, x2, y2, cpx, cpy);
	      dt = sigma.utils.getDistance(x, y, pt.x, pt.y);
	
	      if (dt > old_dt) {
	        // not the right direction:
	        // halfstep in the opposite direction
	        r = -r / 2;
	        t += r;
	      }
	      else if (t + r < 0 || t + r > 1) {
	        // oops, we've gone too far:
	        // revert with a halfstep
	        r = r / 2;
	        dt = old_dt;
	      }
	      else {
	        // progress:
	        t += r;
	      }
	    }
	
	    return dt < epsilon;
	  };
	
	
	  /**
	    * Check if a point is on a cubic bezier curve segment with a thickness.
	    *
	    * @param  {number} x       The X coordinate of the point to check.
	    * @param  {number} y       The Y coordinate of the point to check.
	    * @param  {number} x1      The X coordinate of the curve start point.
	    * @param  {number} y1      The Y coordinate of the curve start point.
	    * @param  {number} x2      The X coordinate of the curve end point.
	    * @param  {number} y2      The Y coordinate of the curve end point.
	    * @param  {number} cpx1    The X coordinate of the 1st curve control point.
	    * @param  {number} cpy1    The Y coordinate of the 1st curve control point.
	    * @param  {number} cpx2    The X coordinate of the 2nd curve control point.
	    * @param  {number} cpy2    The Y coordinate of the 2nd curve control point.
	    * @param  {number} epsilon The precision (consider the line thickness).
	    * @return {boolean}        True if (x,y) is on the curve segment,
	    *                          false otherwise.
	  */
	  sigma.utils.isPointOnBezierCurve =
	    function(x, y, x1, y1, x2, y2, cpx1, cpy1, cpx2, cpy2, epsilon) {
	    // Fails if the point is too far from the extremities of the segment,
	    // preventing for more costly computation:
	    var dP1CP1 = sigma.utils.getDistance(x1, y1, cpx1, cpy1);
	    if (Math.abs(x - x1) > dP1CP1 || Math.abs(y - y1) > dP1CP1) {
	      return false;
	    }
	
	    var dP1 = sigma.utils.getDistance(x, y, x1, y1),
	        dP2 = sigma.utils.getDistance(x, y, x2, y2),
	        t = 0.5,
	        r = (dP1 < dP2) ? -0.01 : 0.01,
	        rThreshold = 0.001,
	        i = 100,
	        pt = sigma.utils.getPointOnBezierCurve(
	          t, x1, y1, x2, y2, cpx1, cpy1, cpx2, cpy2),
	        dt = sigma.utils.getDistance(x, y, pt.x, pt.y),
	        old_dt;
	
	    // This algorithm minimizes the distance from the point to the curve. It
	    // find the optimal t value where t=0 is the start point and t=1 is the end
	    // point of the curve, starting from t=0.5.
	    // It terminates because it runs a maximum of i interations.
	    while (i-- > 0 &&
	      t >= 0 && t <= 1 &&
	      (dt > epsilon) &&
	      (r > rThreshold || r < -rThreshold)) {
	      old_dt = dt;
	      pt = sigma.utils.getPointOnBezierCurve(
	        t, x1, y1, x2, y2, cpx1, cpy1, cpx2, cpy2);
	      dt = sigma.utils.getDistance(x, y, pt.x, pt.y);
	
	      if (dt > old_dt) {
	        // not the right direction:
	        // halfstep in the opposite direction
	        r = -r / 2;
	        t += r;
	      }
	      else if (t + r < 0 || t + r > 1) {
	        // oops, we've gone too far:
	        // revert with a halfstep
	        r = r / 2;
	        dt = old_dt;
	      }
	      else {
	        // progress:
	        t += r;
	      }
	    }
	
	    return dt < epsilon;
	  };
	
	
	  /**
	   * ************
	   * EVENTS UTILS:
	   * ************
	   */
	  /**
	   * Here are some useful functions to unify extraction of the information we
	   * need with mouse events and touch events, from different browsers:
	   */
	
	  /**
	   * Extract the local X position from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {number}   The local X value of the mouse.
	   */
	  sigma.utils.getX = function(e) {
	    return (
	      (e.offsetX !== undefined && e.offsetX) ||
	      (e.layerX !== undefined && e.layerX) ||
	      (e.clientX !== undefined && e.clientX)
	    );
	  };
	
	  /**
	   * Extract the local Y position from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {number}   The local Y value of the mouse.
	   */
	  sigma.utils.getY = function(e) {
	    return (
	      (e.offsetY !== undefined && e.offsetY) ||
	      (e.layerY !== undefined && e.layerY) ||
	      (e.clientY !== undefined && e.clientY)
	    );
	  };
	
	  /**
	   * The pixel ratio of the screen. Taking zoom into account
	   *
	   * @return {number}        Pixel ratio of the screen
	   */
	  sigma.utils.getPixelRatio = function() {
	    var ratio = 1;
	    if (window.screen.deviceXDPI !== undefined &&
	         window.screen.logicalXDPI !== undefined &&
	         window.screen.deviceXDPI > window.screen.logicalXDPI) {
	        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
	    }
	    else if (window.devicePixelRatio !== undefined) {
	        ratio = window.devicePixelRatio;
	    }
	    return ratio;
	  };
	
	  /**
	   * Extract the width from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {number}   The width of the event's target.
	   */
	  sigma.utils.getWidth = function(e) {
	    var w = (!e.target.ownerSVGElement) ?
	              e.target.width :
	              e.target.ownerSVGElement.width;
	
	    return (
	      (typeof w === 'number' && w) ||
	      (w !== undefined && w.baseVal !== undefined && w.baseVal.value)
	    );
	  };
	
	  /**
	   * Extract the center from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {object}   The center of the event's target.
	   */
	  sigma.utils.getCenter = function(e) {
	    var ratio = e.target.namespaceURI.indexOf('svg') !== -1 ? 1 :
	        sigma.utils.getPixelRatio();
	    return {
	      x: sigma.utils.getWidth(e) / (2 * ratio),
	      y: sigma.utils.getHeight(e) / (2 * ratio)
	    };
	  };
	
	  /**
	   * Convert mouse coords to sigma coords
	   *
	   * @param  {event}   e A mouse or touch event.
	   * @param  {number?} x The x coord to convert
	   * @param  {number?} x The y coord to convert
	   *
	   * @return {object}    The standardized event
	   */
	  sigma.utils.mouseCoords = function(e, x, y) {
	    x = x || sigma.utils.getX(e);
	    y = y || sigma.utils.getY(e);
	    return {
	        x: x - sigma.utils.getCenter(e).x,
	        y: y - sigma.utils.getCenter(e).y,
	        clientX: e.clientX,
	        clientY: e.clientY,
	        ctrlKey: e.ctrlKey,
	        metaKey: e.metaKey,
	        altKey: e.altKey,
	        shiftKey: e.shiftKey
	    };
	  };
	
	  /**
	   * Extract the height from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {number}   The height of the event's target.
	   */
	  sigma.utils.getHeight = function(e) {
	    var h = (!e.target.ownerSVGElement) ?
	              e.target.height :
	              e.target.ownerSVGElement.height;
	
	    return (
	      (typeof h === 'number' && h) ||
	      (h !== undefined && h.baseVal !== undefined && h.baseVal.value)
	    );
	  };
	
	  /**
	   * Extract the wheel delta from a mouse or touch event.
	   *
	   * @param  {event}  e A mouse or touch event.
	   * @return {number}   The wheel delta of the mouse.
	   */
	  sigma.utils.getDelta = function(e) {
	    return (
	      (e.wheelDelta !== undefined && e.wheelDelta) ||
	      (e.detail !== undefined && -e.detail)
	    );
	  };
	
	  /**
	   * Returns the offset of a DOM element.
	   *
	   * @param  {DOMElement} dom The element to retrieve the position.
	   * @return {object}         The offset of the DOM element (top, left).
	   */
	  sigma.utils.getOffset = function(dom) {
	    var left = 0,
	        top = 0;
	
	    while (dom) {
	      top = top + parseInt(dom.offsetTop);
	      left = left + parseInt(dom.offsetLeft);
	      dom = dom.offsetParent;
	    }
	
	    return {
	      top: top,
	      left: left
	    };
	  };
	
	  /**
	   * Simulates a "double click" event.
	   *
	   * @param  {HTMLElement} target   The event target.
	   * @param  {string}      type     The event type.
	   * @param  {function}    callback The callback to execute.
	   */
	  sigma.utils.doubleClick = function(target, type, callback) {
	    var clicks = 0,
	        self = this,
	        handlers;
	
	    target._doubleClickHandler = target._doubleClickHandler || {};
	    target._doubleClickHandler[type] = target._doubleClickHandler[type] || [];
	    handlers = target._doubleClickHandler[type];
	
	    handlers.push(function(e) {
	      clicks++;
	
	      if (clicks === 2) {
	        clicks = 0;
	        return callback(e);
	      } else if (clicks === 1) {
	        setTimeout(function() {
	          clicks = 0;
	        }, sigma.settings.doubleClickTimeout);
	      }
	    });
	
	    target.addEventListener(type, handlers[handlers.length - 1], false);
	  };
	
	  /**
	   * Unbind simulated "double click" events.
	   *
	   * @param  {HTMLElement} target   The event target.
	   * @param  {string}      type     The event type.
	   */
	  sigma.utils.unbindDoubleClick = function(target, type) {
	    var handler,
	        handlers = (target._doubleClickHandler || {})[type] || [];
	
	    while ((handler = handlers.pop())) {
	      target.removeEventListener(type, handler);
	    }
	
	    delete (target._doubleClickHandler || {})[type];
	  };
	
	
	
	
	  /**
	   * Here are just some of the most basic easing functions, used for the
	   * animated camera "goTo" calls.
	   *
	   * If you need some more easings functions, don't hesitate to add them to
	   * sigma.utils.easings. But I will not add some more here or merge PRs
	   * containing, because I do not want sigma sources full of overkill and never
	   * used stuff...
	   */
	  sigma.utils.easings = sigma.utils.easings || {};
	  sigma.utils.easings.linearNone = function(k) {
	    return k;
	  };
	  sigma.utils.easings.quadraticIn = function(k) {
	    return k * k;
	  };
	  sigma.utils.easings.quadraticOut = function(k) {
	    return k * (2 - k);
	  };
	  sigma.utils.easings.quadraticInOut = function(k) {
	    if ((k *= 2) < 1)
	      return 0.5 * k * k;
	    return - 0.5 * (--k * (k - 2) - 1);
	  };
	  sigma.utils.easings.cubicIn = function(k) {
	    return k * k * k;
	  };
	  sigma.utils.easings.cubicOut = function(k) {
	    return --k * k * k + 1;
	  };
	  sigma.utils.easings.cubicInOut = function(k) {
	    if ((k *= 2) < 1)
	      return 0.5 * k * k * k;
	    return 0.5 * ((k -= 2) * k * k + 2);
	  };
	
	
	
	
	  /**
	   * ************
	   * WEBGL UTILS:
	   * ************
	   */
	  /**
	   * Loads a WebGL shader and returns it.
	   *
	   * @param  {WebGLContext}           gl           The WebGLContext to use.
	   * @param  {string}                 shaderSource The shader source.
	   * @param  {number}                 shaderType   The type of shader.
	   * @param  {function(string): void} error        Callback for errors.
	   * @return {WebGLShader}                         The created shader.
	   */
	  sigma.utils.loadShader = function(gl, shaderSource, shaderType, error) {
	    var compiled,
	        shader = gl.createShader(shaderType);
	
	    // Load the shader source
	    gl.shaderSource(shader, shaderSource);
	
	    // Compile the shader
	    gl.compileShader(shader);
	
	    // Check the compile status
	    compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	
	    // If something went wrong:
	    if (!compiled) {
	      if (error) {
	        error(
	          'Error compiling shader "' + shader + '":' +
	          gl.getShaderInfoLog(shader)
	        );
	      }
	
	      gl.deleteShader(shader);
	      return null;
	    }
	
	    return shader;
	  };
	
	  /**
	   * Creates a program, attaches shaders, binds attrib locations, links the
	   * program and calls useProgram.
	   *
	   * @param  {Array.<WebGLShader>}    shaders   The shaders to attach.
	   * @param  {Array.<string>}         attribs   The attribs names.
	   * @param  {Array.<number>}         locations The locations for the attribs.
	   * @param  {function(string): void} error     Callback for errors.
	   * @return {WebGLProgram}                     The created program.
	   */
	  sigma.utils.loadProgram = function(gl, shaders, attribs, loc, error) {
	    var i,
	        linked,
	        program = gl.createProgram();
	
	    for (i = 0; i < shaders.length; ++i)
	      gl.attachShader(program, shaders[i]);
	
	    if (attribs)
	      for (i = 0; i < attribs.length; ++i)
	        gl.bindAttribLocation(
	          program,
	          locations ? locations[i] : i,
	          opt_attribs[i]
	        );
	
	    gl.linkProgram(program);
	
	    // Check the link status
	    linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      if (error)
	        error('Error in program linking: ' + gl.getProgramInfoLog(program));
	
	      gl.deleteProgram(program);
	      return null;
	    }
	
	    return program;
	  };
	
	
	
	
	  /**
	   * *********
	   * MATRICES:
	   * *********
	   * The following utils are just here to help generating the transformation
	   * matrices for the WebGL renderers.
	   */
	  sigma.utils.pkg('sigma.utils.matrices');
	
	  /**
	   * The returns a 3x3 translation matrix.
	   *
	   * @param  {number} dx The X translation.
	   * @param  {number} dy The Y translation.
	   * @return {array}     Returns the matrix.
	   */
	  sigma.utils.matrices.translation = function(dx, dy) {
	    return [
	      1, 0, 0,
	      0, 1, 0,
	      dx, dy, 1
	    ];
	  };
	
	  /**
	   * The returns a 3x3 or 2x2 rotation matrix.
	   *
	   * @param  {number}  angle The rotation angle.
	   * @param  {boolean} m2    If true, the function will return a 2x2 matrix.
	   * @return {array}         Returns the matrix.
	   */
	  sigma.utils.matrices.rotation = function(angle, m2) {
	    var cos = Math.cos(angle),
	        sin = Math.sin(angle);
	
	    return m2 ? [
	      cos, -sin,
	      sin, cos
	    ] : [
	      cos, -sin, 0,
	      sin, cos, 0,
	      0, 0, 1
	    ];
	  };
	
	  /**
	   * The returns a 3x3 or 2x2 homothetic transformation matrix.
	   *
	   * @param  {number}  ratio The scaling ratio.
	   * @param  {boolean} m2    If true, the function will return a 2x2 matrix.
	   * @return {array}         Returns the matrix.
	   */
	  sigma.utils.matrices.scale = function(ratio, m2) {
	    return m2 ? [
	      ratio, 0,
	      0, ratio
	    ] : [
	      ratio, 0, 0,
	      0, ratio, 0,
	      0, 0, 1
	    ];
	  };
	
	  /**
	   * The returns a 3x3 or 2x2 homothetic transformation matrix.
	   *
	   * @param  {array}   a  The first matrix.
	   * @param  {array}   b  The second matrix.
	   * @param  {boolean} m2 If true, the function will assume both matrices are
	   *                      2x2.
	   * @return {array}      Returns the matrix.
	   */
	  sigma.utils.matrices.multiply = function(a, b, m2) {
	    var l = m2 ? 2 : 3,
	        a00 = a[0 * l + 0],
	        a01 = a[0 * l + 1],
	        a02 = a[0 * l + 2],
	        a10 = a[1 * l + 0],
	        a11 = a[1 * l + 1],
	        a12 = a[1 * l + 2],
	        a20 = a[2 * l + 0],
	        a21 = a[2 * l + 1],
	        a22 = a[2 * l + 2],
	        b00 = b[0 * l + 0],
	        b01 = b[0 * l + 1],
	        b02 = b[0 * l + 2],
	        b10 = b[1 * l + 0],
	        b11 = b[1 * l + 1],
	        b12 = b[1 * l + 2],
	        b20 = b[2 * l + 0],
	        b21 = b[2 * l + 1],
	        b22 = b[2 * l + 2];
	
	    return m2 ? [
	      a00 * b00 + a01 * b10,
	      a00 * b01 + a01 * b11,
	      a10 * b00 + a11 * b10,
	      a10 * b01 + a11 * b11
	    ] : [
	      a00 * b00 + a01 * b10 + a02 * b20,
	      a00 * b01 + a01 * b11 + a02 * b21,
	      a00 * b02 + a01 * b12 + a02 * b22,
	      a10 * b00 + a11 * b10 + a12 * b20,
	      a10 * b01 + a11 * b11 + a12 * b21,
	      a10 * b02 + a11 * b12 + a12 * b22,
	      a20 * b00 + a21 * b10 + a22 * b20,
	      a20 * b01 + a21 * b11 + a22 * b21,
	      a20 * b02 + a21 * b12 + a22 * b22
	    ];
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(221);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(220);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 80 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 81 */
[497, 238],
/* 82 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 83 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 84 */
[512, 38, 253, 83, 88, 130, 244],
/* 85 */
[515, 63, 52, 32, 91, 31, 131, 30],
/* 86 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 87 */
[520, 29, 31, 20],
/* 88 */
[521, 89, 65],
/* 89 */
[522, 14, 28, 61],
/* 90 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 91 */
[527, 41],
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(28);
	var core = __webpack_require__(14);
	var LIBRARY = __webpack_require__(61);
	var wksExt = __webpack_require__(93);
	var defineProperty = __webpack_require__(29).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(20);


/***/ },
/* 94 */
80,
/* 95 */
[503, 94],
/* 96 */
[510, 70, 16, 35, 68, 42],
/* 97 */
52,
/* 98 */
[520, 68, 35, 21],
/* 99 */
[521, 154, 70],
/* 100 */
[525, 155],
/* 101 */
[526, 144],
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(50);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addEventListener = __webpack_require__(71);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Handle = function (_React$Component) {
	  (0, _inherits3['default'])(Handle, _React$Component);
	
	  function Handle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Handle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clickFocused: false
	    }, _this.setHandleRef = function (node) {
	      _this.handle = node;
	    }, _this.handleMouseUp = function () {
	      if (document.activeElement === _this.handle) {
	        _this.setClickFocus(true);
	      }
	    }, _this.handleBlur = function () {
	      _this.setClickFocus(false);
	    }, _this.handleKeyDown = function () {
	      _this.setClickFocus(false);
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Handle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // mouseup won't trigger if mouse moved out of handle,
	      // so we listen on document here.
	      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.onMouseUpListener) {
	        this.onMouseUpListener.remove();
	      }
	    }
	  }, {
	    key: 'setClickFocus',
	    value: function setClickFocus(focused) {
	      this.setState({ clickFocused: focused });
	    }
	  }, {
	    key: 'clickFocus',
	    value: function clickFocus() {
	      this.setClickFocus(true);
	      this.focus();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.handle.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.handle.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          vertical = _props.vertical,
	          offset = _props.offset,
	          style = _props.style,
	          disabled = _props.disabled,
	          min = _props.min,
	          max = _props.max,
	          value = _props.value,
	          tabIndex = _props.tabIndex,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
	
	
	      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
	
	      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
	      var elStyle = (0, _extends3['default'])({}, style, postionStyle);
	
	      return _react2['default'].createElement('div', (0, _extends3['default'])({
	        ref: this.setHandleRef,
	        tabIndex: disabled ? null : tabIndex || 0
	      }, restProps, {
	        className: className,
	        style: elStyle,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown
	
	        // aria attribute
	        , role: 'slider',
	        'aria-valuemin': min,
	        'aria-valuemax': max,
	        'aria-valuenow': value,
	        'aria-disabled': !!disabled
	      }));
	    }
	  }]);
	  return Handle;
	}(_react2['default'].Component);
	
	exports['default'] = Handle;
	
	
	Handle.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  offset: _propTypes2['default'].number,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  tabIndex: _propTypes2['default'].number
	};
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(128);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	exports.getKeyboardValueMutator = getKeyboardValueMutator;
	
	var _reactDom = __webpack_require__(15);
	
	var _KeyCode = __webpack_require__(350);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isEventFromHandle(e, handles) {
	  return Object.keys(handles).some(function (key) {
	    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	  });
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min;
	
	  var points = Object.keys(marks).map(parseFloat);
	  if (step !== null) {
	    var closestStep = Math.round((val - min) / step) * step + min;
	    points.push(closestStep);
	  }
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	  if (val >= max) {
	    return max;
	  }
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	
	  var closestPoint = getClosestPoint(val, props);
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function getKeyboardValueMutator(e) {
	  switch (e.keyCode) {
	    case _KeyCode2['default'].UP:
	    case _KeyCode2['default'].RIGHT:
	      return function (value, props) {
	        return value + props.step;
	      };
	
	    case _KeyCode2['default'].DOWN:
	    case _KeyCode2['default'].LEFT:
	      return function (value, props) {
	        return value - props.step;
	      };
	
	    case _KeyCode2['default'].END:
	      return function (value, props) {
	        return props.max;
	      };
	    case _KeyCode2['default'].HOME:
	      return function (value, props) {
	        return props.min;
	      };
	    case _KeyCode2['default'].PAGE_UP:
	      return function (value, props) {
	        return value + props.step * 2;
	      };
	    case _KeyCode2['default'].PAGE_DOWN:
	      return function (value, props) {
	        return value - props.step * 2;
	      };
	
	    default:
	      return undefined;
	  }
	}

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(44);
	var Danger = __webpack_require__(357);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(18);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	var setInnerHTML = __webpack_require__(76);
	var setTextContent = __webpack_require__(188);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactErrorUtils = __webpack_require__(112);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(47);
	var ReactPropTypesSecret = __webpack_require__(386);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactInstanceMap = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(3);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 121 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(200);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(457);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(49);
	
	var ReactNoopUpdateQueue = __webpack_require__(125);
	
	var canDefineProperty = __webpack_require__(208);
	var emptyObject = __webpack_require__(56);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(214);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 130 */
[499, 41, 28],
/* 131 */
[502, 30, 39, 130],
/* 132 */
[503, 80],
/* 133 */
[508, 61, 27, 138, 40, 51, 248, 87, 135, 20],
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(136);
	var hiddenKeys = __webpack_require__(83).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 135 */
[516, 31, 64, 88],
/* 136 */
[517, 31, 32, 240, 88],
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(27);
	var core = __webpack_require__(14);
	var fails = __webpack_require__(39);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(40);


/***/ },
/* 139 */
[525, 90],
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(256)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(133)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(66);
	var IObject = __webpack_require__(95);
	var toObject = __webpack_require__(101);
	var toLength = __webpack_require__(100);
	var asc = __webpack_require__(276);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 143 */
[496, 94, 21],
/* 144 */
82,
/* 145 */
[499, 16, 34],
/* 146 */
83,
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(34);
	var core = __webpack_require__(53);
	var hide = __webpack_require__(55);
	var redefine = __webpack_require__(43);
	var ctx = __webpack_require__(66);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(66);
	var call = __webpack_require__(283);
	var isArrayIter = __webpack_require__(281);
	var anObject = __webpack_require__(33);
	var toLength = __webpack_require__(100);
	var getIterFn = __webpack_require__(297);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 149 */
[502, 54, 42, 145],
/* 150 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 151 */
[518, 294, 146],
/* 152 */
63,
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(43);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 154 */
[522, 53, 34, 150],
/* 155 */
90,
/* 156 */
[527, 16],
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getVisibleRectForElement = __webpack_require__(161);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(303);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(160);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(307);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	} /**
	   * align dom node flexibly
	   * @author yiminghe@gmail.com
	   */
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2['default'].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2['default'])(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2['default'].merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2['default'])(elRegion, tgtRegion, points, offset, targetOffset);
	      _utils2['default'].mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      points = align.points;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2['default'])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2['default'].css(source, 'width', _utils2['default'].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2['default'].css(source, 'height', _utils2['default'].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2['default'].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	exports['default'] = doAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2['default'].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports['default'] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2['default'].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2['default'].offset(node);
	    w = _utils2['default'].outerWidth(node);
	    h = _utils2['default'].outerHeight(node);
	  } else {
	    var win = _utils2['default'].getWindow(node);
	    offset = {
	      left: _utils2['default'].getWindowScrollLeft(win),
	      top: _utils2['default'].getWindowScrollTop(win)
	    };
	    w = _utils2['default'].viewportWidth(win);
	    h = _utils2['default'].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports['default'] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(159);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _isAncestorFixed = __webpack_require__(309);
	
	var _isAncestorFixed2 = _interopRequireDefault(_isAncestorFixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2['default'])(element);
	  var doc = _utils2['default'].getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2['default'].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2['default'].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2['default'])(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!_utils2['default'].isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = _utils2['default'].css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if ((0, _isAncestorFixed2['default'])(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports['default'] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 165 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Track = function Track(props) {
	  var className = props.className,
	      included = props.included,
	      vertical = props.vertical,
	      offset = props.offset,
	      length = props.length,
	      style = props.style;
	
	
	  var positonStyle = vertical ? {
	    bottom: offset + '%',
	    height: length + '%'
	  } : {
	    left: offset + '%',
	    width: length + '%'
	  };
	
	  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
	  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
	}; /* eslint-disable react/prop-types */
	exports['default'] = Track;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(50);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(222);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSlider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(71);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(126);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Steps = __webpack_require__(338);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(337);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	var _Handle = __webpack_require__(103);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _utils = __webpack_require__(104);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function createSlider(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    (0, _inherits3['default'])(ComponentEnhancer, _Component);
	
	    function ComponentEnhancer(props) {
	      (0, _classCallCheck3['default'])(this, ComponentEnhancer);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.removeDocumentEvents();
	        _this.onStart(position);
	        _this.addDocumentMouseEvents();
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentTouchEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onFocus = function (e) {
	        var _this$props = _this.props,
	            onFocus = _this$props.onFocus,
	            vertical = _this$props.vertical;
	
	        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
	          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
	          _this.dragOffset = 0;
	          _this.onStart(handlePosition);
	          utils.pauseEvent(e);
	          if (onFocus) {
	            onFocus(e);
	          }
	        }
	      };
	
	      _this.onBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        _this.onEnd(e);
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.onMouseUp = function () {
	        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
	          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
	        }
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	        var position = utils.getMousePosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onKeyDown = function (e) {
	        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.onKeyboard(e);
	        }
	      };
	
	      _this.onClickMarkLabel = function (e, value) {
	        e.stopPropagation();
	        _this.onChange({ value: value });
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      if (false) {
	        var step = props.step,
	            max = props.max,
	            min = props.min;
	
	        (0, _warning2['default'])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
	      }
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    (0, _createClass3['default'])(ComponentEnhancer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Snapshot testing cannot handle refs, so be sure to null-check this.
	        this.document = this.sliderRef && this.sliderRef.ownerDocument;
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        this.removeDocumentEvents();
	      }
	    }, {
	      key: 'getSliderStart',
	      value: function getSliderStart() {
	        var slider = this.sliderRef;
	        var rect = slider.getBoundingClientRect();
	
	        return this.props.vertical ? rect.top : rect.left;
	      }
	    }, {
	      key: 'getSliderLength',
	      value: function getSliderLength() {
	        var slider = this.sliderRef;
	        if (!slider) {
	          return 0;
	        }
	
	        var coords = slider.getBoundingClientRect();
	        return this.props.vertical ? coords.height : coords.width;
	      }
	    }, {
	      key: 'addDocumentTouchEvents',
	      value: function addDocumentTouchEvents() {
	        // just work for Chrome iOS Safari and Android Browser
	        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
	        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
	      }
	    }, {
	      key: 'addDocumentMouseEvents',
	      value: function addDocumentMouseEvents() {
	        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
	        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
	      }
	    }, {
	      key: 'removeDocumentEvents',
	      value: function removeDocumentEvents() {
	        /* eslint-disable no-unused-expressions */
	        this.onTouchMoveListener && this.onTouchMoveListener.remove();
	        this.onTouchUpListener && this.onTouchUpListener.remove();
	
	        this.onMouseMoveListener && this.onMouseMoveListener.remove();
	        this.onMouseUpListener && this.onMouseUpListener.remove();
	        /* eslint-enable no-unused-expressions */
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (!this.props.disabled) {
	          this.handlesRefs[0].focus();
	        }
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        var _this2 = this;
	
	        if (!this.props.disabled) {
	          Object.keys(this.handlesRefs).forEach(function (key) {
	            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
	              _this2.handlesRefs[key].blur();
	            }
	          });
	        }
	      }
	    }, {
	      key: 'calcValue',
	      value: function calcValue(offset) {
	        var _props = this.props,
	            vertical = _props.vertical,
	            min = _props.min,
	            max = _props.max;
	
	        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	        return value;
	      }
	    }, {
	      key: 'calcValueByPos',
	      value: function calcValueByPos(position) {
	        var pixelOffset = position - this.getSliderStart();
	        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	        return nextValue;
	      }
	    }, {
	      key: 'calcOffset',
	      value: function calcOffset(value) {
	        var _props2 = this.props,
	            min = _props2.min,
	            max = _props2.max;
	
	        var ratio = (value - min) / (max - min);
	        return ratio * 100;
	      }
	    }, {
	      key: 'saveHandle',
	      value: function saveHandle(index, handle) {
	        this.handlesRefs[index] = handle;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _props3 = this.props,
	            prefixCls = _props3.prefixCls,
	            className = _props3.className,
	            marks = _props3.marks,
	            dots = _props3.dots,
	            step = _props3.step,
	            included = _props3.included,
	            disabled = _props3.disabled,
	            vertical = _props3.vertical,
	            min = _props3.min,
	            max = _props3.max,
	            children = _props3.children,
	            maximumTrackStyle = _props3.maximumTrackStyle,
	            style = _props3.style,
	            railStyle = _props3.railStyle,
	            dotStyle = _props3.dotStyle,
	            activeDotStyle = _props3.activeDotStyle;
	
	        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
	            tracks = _get$call.tracks,
	            handles = _get$call.handles;
	
	        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.saveSlider,
	            className: sliderClassName,
	            onTouchStart: disabled ? noop : this.onTouchStart,
	            onMouseDown: disabled ? noop : this.onMouseDown,
	            onMouseUp: disabled ? noop : this.onMouseUp,
	            onKeyDown: disabled ? noop : this.onKeyDown,
	            onFocus: disabled ? noop : this.onFocus,
	            onBlur: disabled ? noop : this.onBlur,
	            style: style
	          },
	          _react2['default'].createElement('div', {
	            className: prefixCls + '-rail',
	            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
	          }),
	          tracks,
	          _react2['default'].createElement(_Steps2['default'], {
	            prefixCls: prefixCls,
	            vertical: vertical,
	            marks: marks,
	            dots: dots,
	            step: step,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min,
	            dotStyle: dotStyle,
	            activeDotStyle: activeDotStyle
	          }),
	          handles,
	          _react2['default'].createElement(_Marks2['default'], {
	            className: prefixCls + '-mark',
	            onClickLabel: disabled ? noop : this.onClickMarkLabel,
	            vertical: vertical,
	            marks: marks,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min
	          }),
	          children
	        );
	      }
	    }]);
	    return ComponentEnhancer;
	  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
	    min: _propTypes2['default'].number,
	    max: _propTypes2['default'].number,
	    step: _propTypes2['default'].number,
	    marks: _propTypes2['default'].object,
	    included: _propTypes2['default'].bool,
	    className: _propTypes2['default'].string,
	    prefixCls: _propTypes2['default'].string,
	    disabled: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    onBeforeChange: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onAfterChange: _propTypes2['default'].func,
	    handle: _propTypes2['default'].func,
	    dots: _propTypes2['default'].bool,
	    vertical: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    railStyle: _propTypes2['default'].object,
	    dotStyle: _propTypes2['default'].object,
	    activeDotStyle: _propTypes2['default'].object,
	    autoFocus: _propTypes2['default'].bool,
	    onFocus: _propTypes2['default'].func,
	    onBlur: _propTypes2['default'].func
	  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(_ref) {
	      var index = _ref.index,
	          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);
	
	      delete restProps.dragging;
	      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
	    },
	
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false,
	    trackStyle: [{}],
	    handleStyle: [{}],
	    railStyle: {},
	    dotStyle: {},
	    activeDotStyle: {}
	  }), _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(50);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 170 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(37);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(18);
	
	var quoteAttributeValueForBrowser = __webpack_require__(414);
	var warning = __webpack_require__(3);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(22);
	
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(373);
	
	var containsNode = __webpack_require__(313);
	var focusNode = __webpack_require__(163);
	var getActiveElement = __webpack_require__(164);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(44);
	var DOMProperty = __webpack_require__(45);
	var React = __webpack_require__(47);
	var ReactBrowserEventEmitter = __webpack_require__(72);
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMContainerInfo = __webpack_require__(367);
	var ReactDOMFeatureFlags = __webpack_require__(369);
	var ReactFeatureFlags = __webpack_require__(176);
	var ReactInstanceMap = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMarkupChecksum = __webpack_require__(383);
	var ReactReconciler = __webpack_require__(46);
	var ReactUpdateQueue = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(22);
	
	var emptyObject = __webpack_require__(56);
	var instantiateReactComponent = __webpack_require__(186);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(76);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(47);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(180);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(364);
	var ReactEmptyComponent = __webpack_require__(175);
	var ReactHostComponent = __webpack_require__(177);
	
	var getNextDebugID = __webpack_require__(411);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	var escapeTextContentForBrowser = __webpack_require__(75);
	var setInnerHTML = __webpack_require__(76);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var REACT_ELEMENT_TYPE = __webpack_require__(379);
	
	var getIteratorFn = __webpack_require__(410);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(109);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(419);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FABButton = function FABButton(props) {
	    var mini = props.mini,
	        className = props.className,
	        children = props.children,
	        otherProps = _objectWithoutProperties(props, ['mini', 'className', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-button--fab', {
	        'mdl-button--mini-fab': mini
	    }, className);
	
	    return _react2.default.createElement(
	        _Button2.default,
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	FABButton.propTypes = {
	    className: _propTypes2.default.string,
	    mini: _propTypes2.default.bool
	};
	
	exports.default = FABButton;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PropTypes = _react2.default.PropTypes;
	
	
	var icons = {
	  upload: 'M832 64h-640l-192 192v672c0 17.674 14.326 32 32 32h960c17.672 0 32-14.326 32-32v-672l-192-192zM640 640v192h-256v-192h-192l320-256 320 256h-192zM154.51 192l64-64h586.976l64 64h-714.976z',
	  download: 'M832 64h-640l-192 192v672c0 17.674 14.326 32 32 32h960c17.672 0 32-14.326 32-32v-672l-192-192zM512 832l-320-256h192v-192h256v192h192l-320 256zM154.51 192l64-64h586.978l64 64h-714.978z'
	};
	
	var Icon = function Icon(props) {
	  return _react2.default.createElement(
	    'svg',
	    { width: '20px', height: '20px', viewBox: '0 0 1024 1024' },
	    _react2.default.createElement('path', { d: icons[props.icon], fill: '#fff' })
	  );
	};
	
	Icon.propTypes = {
	  icon: PropTypes.string.isRequired
	};
	
	exports.default = Icon;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(438)
	var ieee754 = __webpack_require__(445)
	var isArray = __webpack_require__(446)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192).Buffer, (function() { return this; }())))

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(423);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(77);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(200);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(122);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(123);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(77);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(456);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var palette = ["#5DA5DA", "#60BD68", "#B2912F", "#F15854", "#DECF3F", "#FAA43A", "#B276B2", "#F17CB0", "#4D4D4D"];
	
	/*
		Default node and edge transformation for NeoCypher,
		class has 2 functions: node() and edge() which transform data from Neo4j format into Sigma.
	
		Also it iterates colors assignments from palette based on node.label and edge.type.
	*/
	
	var NeoGraphItemsProducers = function () {
		function NeoGraphItemsProducers() {
			_classCallCheck(this, NeoGraphItemsProducers);
	
			this._currentColor = 0;
			this._colorsMap = {};
		}
	
		_createClass(NeoGraphItemsProducers, [{
			key: "node",
			value: function node(_node) {
				return {
					id: _node.id,
					label: _node.properties.name,
					x: Math.random(),
					y: Math.random(),
					size: 1,
					color: this.colorsMap(_node.labels[0]),
					neo4j_labels: _node.labels,
					neo4j_data: _node.properties
				};
			}
		}, {
			key: "edge",
			value: function edge(_edge) {
				return {
					id: _edge.id,
					label: _edge.type,
					source: _edge.startNode,
					target: _edge.endNode,
					color: this.colorsMap(_edge.type),
					neo4j_type: _edge.type,
					neo4j_data: _edge.properties
				};
			}
		}, {
			key: "colorsMap",
			value: function colorsMap(label) {
				var color = this._colorsMap[label];
				if (!color) {
					color = palette[this._currentColor++ % palette.length];
					this._colorsMap[label] = color;
				}
				return color;
			}
		}]);
	
		return NeoGraphItemsProducers;
	}();
	
	exports.default = NeoGraphItemsProducers;

/***/ },
/* 202 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 125);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 125:
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(15);
	module.exports = __webpack_require__(16);
	
	
	/***/ }),
	
	/***/ 15:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  /**
	   * Sigma ForceAtlas2.5 Supervisor
	   * ===============================
	   *
	   * Author: Guillaume Plique (Yomguithereal)
	   * Version: 0.1
	   */
	  var _root = this;
	
	  /**
	   * Feature detection
	   * ------------------
	   */
	  var webWorkers = 'Worker' in _root;
	
	  /**
	   * Supervisor Object
	   * ------------------
	   */
	  function Supervisor(sigInst, options) {
	    var _this = this,
	        workerFn = sigInst.getForceAtlas2Worker &&
	          sigInst.getForceAtlas2Worker();
	
	    options = options || {};
	
	    // _root URL Polyfill
	    _root.URL = _root.URL || _root.webkitURL;
	
	    // Properties
	    this.sigInst = sigInst;
	    this.graph = this.sigInst.graph;
	    this.ppn = 10;
	    this.ppe = 3;
	    this.config = {};
	    this.shouldUseWorker =
	      options.worker === false ? false : true && webWorkers;
	    this.workerUrl = options.workerUrl;
	
	    // State
	    this.started = false;
	    this.running = false;
	
	    // Web worker or classic DOM events?
	    if (this.shouldUseWorker) {
	      if (!this.workerUrl) {
	        var blob = this.makeBlob(workerFn);
	        this.worker = new Worker(URL.createObjectURL(blob));
	      }
	      else {
	        this.worker = new Worker(this.workerUrl);
	      }
	
	      // Post Message Polyfill
	      this.worker.postMessage =
	        this.worker.webkitPostMessage || this.worker.postMessage;
	    }
	    else {
	
	      eval(workerFn);
	    }
	
	    // Worker message receiver
	    this.msgName = (this.worker) ? 'message' : 'newCoords';
	    this.listener = function(e) {
	
	      // Retrieving data
	      _this.nodesByteArray = new Float32Array(e.data.nodes);
	
	      // If ForceAtlas2 is running, we act accordingly
	      if (_this.running) {
	
	        // Applying layout
	        _this.applyLayoutChanges();
	
	        // Send data back to worker and loop
	        _this.sendByteArrayToWorker();
	
	        // Rendering graph
	        _this.sigInst.refresh();
	      }
	    };
	
	    (this.worker || document).addEventListener(this.msgName, this.listener);
	
	    // Filling byteArrays
	    this.graphToByteArrays();
	
	    // Binding on kill to properly terminate layout when parent is killed
	    sigInst.bind('kill', function() {
	      sigInst.killForceAtlas2();
	    });
	  }
	
	  Supervisor.prototype.makeBlob = function(workerFn) {
	    var blob;
	
	    try {
	      blob = new Blob([workerFn], {type: 'application/javascript'});
	    }
	    catch (e) {
	      _root.BlobBuilder = _root.BlobBuilder ||
	                          _root.WebKitBlobBuilder ||
	                          _root.MozBlobBuilder;
	
	      blob = new BlobBuilder();
	      blob.append(workerFn);
	      blob = blob.getBlob();
	    }
	
	    return blob;
	  };
	
	  Supervisor.prototype.graphToByteArrays = function() {
	    var nodes = this.graph.nodes(),
	        edges = this.graph.edges(),
	        nbytes = nodes.length * this.ppn,
	        ebytes = edges.length * this.ppe,
	        nIndex = {},
	        i,
	        j,
	        l;
	
	    // Allocating Byte arrays with correct nb of bytes
	    this.nodesByteArray = new Float32Array(nbytes);
	    this.edgesByteArray = new Float32Array(ebytes);
	
	    // Iterate through nodes
	    for (i = j = 0, l = nodes.length; i < l; i++) {
	
	      // Populating index
	      nIndex[nodes[i].id] = j;
	
	      // Populating byte array
	      this.nodesByteArray[j] = nodes[i].x;
	      this.nodesByteArray[j + 1] = nodes[i].y;
	      this.nodesByteArray[j + 2] = 0;
	      this.nodesByteArray[j + 3] = 0;
	      this.nodesByteArray[j + 4] = 0;
	      this.nodesByteArray[j + 5] = 0;
	      this.nodesByteArray[j + 6] = 1 + this.graph.degree(nodes[i].id);
	      this.nodesByteArray[j + 7] = 1;
	      this.nodesByteArray[j + 8] = nodes[i].size;
	      this.nodesByteArray[j + 9] = 0;
	      j += this.ppn;
	    }
	
	    // Iterate through edges
	    for (i = j = 0, l = edges.length; i < l; i++) {
	      this.edgesByteArray[j] = nIndex[edges[i].source];
	      this.edgesByteArray[j + 1] = nIndex[edges[i].target];
	      this.edgesByteArray[j + 2] = edges[i].weight || 0;
	      j += this.ppe;
	    }
	  };
	
	  // TODO: make a better send function
	  Supervisor.prototype.applyLayoutChanges = function() {
	    var nodes = this.graph.nodes(),
	        j = 0,
	        realIndex;
	
	    // Moving nodes
	    for (var i = 0, l = this.nodesByteArray.length; i < l; i += this.ppn) {
	      nodes[j].x = this.nodesByteArray[i];
	      nodes[j].y = this.nodesByteArray[i + 1];
	      j++;
	    }
	  };
	
	  Supervisor.prototype.sendByteArrayToWorker = function(action) {
	    var content = {
	      action: action || 'loop',
	      nodes: this.nodesByteArray.buffer
	    };
	
	    var buffers = [this.nodesByteArray.buffer];
	
	    if (action === 'start') {
	      content.config = this.config || {};
	      content.edges = this.edgesByteArray.buffer;
	      buffers.push(this.edgesByteArray.buffer);
	    }
	
	    if (this.shouldUseWorker)
	      this.worker.postMessage(content, buffers);
	    else
	      _root.postMessage(content, '*');
	  };
	
	  Supervisor.prototype.start = function() {
	    if (this.running)
	      return;
	
	    this.running = true;
	
	    // Do not refresh edgequadtree during layout:
	    var k,
	        c;
	    for (k in this.sigInst.cameras) {
	      c = this.sigInst.cameras[k];
	      c.edgequadtree._enabled = false;
	    }
	
	    if (!this.started) {
	
	      // Sending init message to worker
	      this.sendByteArrayToWorker('start');
	      this.started = true;
	    }
	    else {
	      this.sendByteArrayToWorker();
	    }
	  };
	
	  Supervisor.prototype.stop = function() {
	    if (!this.running)
	      return;
	
	    // Allow to refresh edgequadtree:
	    var k,
	        c,
	        bounds;
	    for (k in this.sigInst.cameras) {
	      c = this.sigInst.cameras[k];
	      c.edgequadtree._enabled = true;
	
	      // Find graph boundaries:
	      bounds = sigma.utils.getBoundaries(
	        this.graph,
	        c.readPrefix
	      );
	
	      // Refresh edgequadtree:
	      if (c.settings('drawEdges') && c.settings('enableEdgeHovering'))
	        c.edgequadtree.index(this.sigInst.graph, {
	          prefix: c.readPrefix,
	          bounds: {
	            x: bounds.minX,
	            y: bounds.minY,
	            width: bounds.maxX - bounds.minX,
	            height: bounds.maxY - bounds.minY
	          }
	        });
	    }
	
	    this.running = false;
	  };
	
	  Supervisor.prototype.killWorker = function() {
	    if (this.worker) {
	      this.worker.terminate();
	    }
	    else {
	      _root.postMessage({action: 'kill'}, '*');
	      document.removeEventListener(this.msgName, this.listener);
	    }
	  };
	
	  Supervisor.prototype.configure = function(config) {
	
	    // Setting configuration
	    this.config = config;
	
	    if (!this.started)
	      return;
	
	    var data = {action: 'config', config: this.config};
	
	    if (this.shouldUseWorker)
	      this.worker.postMessage(data);
	    else
	      _root.postMessage(data, '*');
	  };
	
	  /**
	   * Interface
	   * ----------
	   */
	  sigma.prototype.startForceAtlas2 = function(config) {
	
	    // Create supervisor if undefined
	    if (!this.supervisor)
	      this.supervisor = new Supervisor(this, config);
	
	    // Configuration provided?
	    if (config)
	      this.supervisor.configure(config);
	
	    // Start algorithm
	    this.supervisor.start();
	
	    return this;
	  };
	
	  sigma.prototype.stopForceAtlas2 = function() {
	    if (!this.supervisor)
	      return this;
	
	    // Pause algorithm
	    this.supervisor.stop();
	
	    return this;
	  };
	
	  sigma.prototype.killForceAtlas2 = function() {
	    if (!this.supervisor)
	      return this;
	
	    // Stop Algorithm
	    this.supervisor.stop();
	
	    // Kill Worker
	    this.supervisor.killWorker();
	
	    // Kill supervisor
	    this.supervisor = null;
	
	    return this;
	  };
	
	  sigma.prototype.configForceAtlas2 = function(config) {
	    if (!this.supervisor)
	      this.supervisor = new Supervisor(this, config);
	
	    this.supervisor.configure(config);
	
	    return this;
	  };
	
	  sigma.prototype.isForceAtlas2Running = function(config) {
	    return !!this.supervisor && this.supervisor.running;
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  /**
	   * Sigma ForceAtlas2.5 Webworker
	   * ==============================
	   *
	   * Author: Guillaume Plique (Yomguithereal)
	   * Algorithm author: Mathieu Jacomy @ Sciences Po Medialab & WebAtlas
	   * Version: 1.0.3
	   */
	
	  var _root = this,
	      inWebWorker = !('document' in _root);
	
	  /**
	   * Worker Function Wrapper
	   * ------------------------
	   *
	   * The worker has to be wrapped into a single stringified function
	   * to be passed afterwards as a BLOB object to the supervisor.
	   */
	  var Worker = function(undefined) {
	    'use strict';
	
	    /**
	     * Worker settings and properties
	     */
	    var W = {
	
	      // Properties
	      ppn: 10,
	      ppe: 3,
	      ppr: 9,
	      maxForce: 10,
	      iterations: 0,
	      converged: false,
	
	      // Possible to change through config
	      settings: {
	        linLogMode: false,
	        outboundAttractionDistribution: false,
	        adjustSizes: false,
	        edgeWeightInfluence: 0,
	        scalingRatio: 1,
	        strongGravityMode: false,
	        gravity: 1,
	        slowDown: 1,
	        barnesHutOptimize: false,
	        barnesHutTheta: 0.5,
	        startingIterations: 1,
	        iterationsPerRender: 1
	      }
	    };
	
	    var NodeMatrix,
	        EdgeMatrix,
	        RegionMatrix;
	
	    /**
	     * Helpers
	     */
	    function extend() {
	      var i,
	          k,
	          res = {},
	          l = arguments.length;
	
	      for (i = l - 1; i >= 0; i--)
	        for (k in arguments[i])
	          res[k] = arguments[i][k];
	      return res;
	    }
	
	    function __emptyObject(obj) {
	      var k;
	
	      for (k in obj)
	        if (!('hasOwnProperty' in obj) || obj.hasOwnProperty(k))
	          delete obj[k];
	
	      return obj;
	    }
	
	    /**
	     * Matrices properties accessors
	     */
	    var nodeProperties = {
	      x: 0,
	      y: 1,
	      dx: 2,
	      dy: 3,
	      old_dx: 4,
	      old_dy: 5,
	      mass: 6,
	      convergence: 7,
	      size: 8,
	      fixed: 9
	    };
	
	    var edgeProperties = {
	      source: 0,
	      target: 1,
	      weight: 2
	    };
	
	    var regionProperties = {
	      node: 0,
	      centerX: 1,
	      centerY: 2,
	      size: 3,
	      nextSibling: 4,
	      firstChild: 5,
	      mass: 6,
	      massCenterX: 7,
	      massCenterY: 8
	    };
	
	    function np(i, p) {
	
	      // DEBUG: safeguards
	      if ((i % W.ppn) !== 0)
	        throw 'np: non correct (' + i + ').';
	      if (i !== parseInt(i))
	        throw 'np: non int.';
	
	      if (p in nodeProperties)
	        return i + nodeProperties[p];
	      else
	        throw 'ForceAtlas2.Worker - ' +
	              'Inexistant node property given (' + p + ').';
	    }
	
	    function ep(i, p) {
	
	      // DEBUG: safeguards
	      if ((i % W.ppe) !== 0)
	        throw 'ep: non correct (' + i + ').';
	      if (i !== parseInt(i))
	        throw 'ep: non int.';
	
	      if (p in edgeProperties)
	        return i + edgeProperties[p];
	      else
	        throw 'ForceAtlas2.Worker - ' +
	              'Inexistant edge property given (' + p + ').';
	    }
	
	    function rp(i, p) {
	
	      // DEBUG: safeguards
	      if ((i % W.ppr) !== 0)
	        throw 'rp: non correct (' + i + ').';
	      if (i !== parseInt(i))
	        throw 'rp: non int.';
	
	      if (p in regionProperties)
	        return i + regionProperties[p];
	      else
	        throw 'ForceAtlas2.Worker - ' +
	              'Inexistant region property given (' + p + ').';
	    }
	
	    // DEBUG
	    function nan(v) {
	      if (isNaN(v))
	        throw 'NaN alert!';
	    }
	
	
	    /**
	     * Algorithm initialization
	     */
	
	    function init(nodes, edges, config) {
	      config = config || {};
	      var i, l;
	
	      // Matrices
	      NodeMatrix = nodes;
	      EdgeMatrix = edges;
	
	      // Length
	      W.nodesLength = NodeMatrix.length;
	      W.edgesLength = EdgeMatrix.length;
	
	      // Merging configuration
	      configure(config);
	    }
	
	    function configure(o) {
	      W.settings = extend(o, W.settings);
	    }
	
	    /**
	     * Algorithm pass
	     */
	
	    // MATH: get distances stuff and power 2 issues
	    function pass() {
	      var a, i, j, l, r, n, n1, n2, e, w, g, k, m;
	
	      var outboundAttCompensation,
	          coefficient,
	          xDist,
	          yDist,
	          ewc,
	          mass,
	          distance,
	          size,
	          factor;
	
	      // 1) Initializing layout data
	      //-----------------------------
	
	      // Resetting positions & computing max values
	      for (n = 0; n < W.nodesLength; n += W.ppn) {
	        NodeMatrix[np(n, 'old_dx')] = NodeMatrix[np(n, 'dx')];
	        NodeMatrix[np(n, 'old_dy')] = NodeMatrix[np(n, 'dy')];
	        NodeMatrix[np(n, 'dx')] = 0;
	        NodeMatrix[np(n, 'dy')] = 0;
	      }
	
	      // If outbound attraction distribution, compensate
	      if (W.settings.outboundAttractionDistribution) {
	        outboundAttCompensation = 0;
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	          outboundAttCompensation += NodeMatrix[np(n, 'mass')];
	        }
	
	        outboundAttCompensation /= W.nodesLength;
	      }
	
	
	      // 1.bis) Barnes-Hut computation
	      //------------------------------
	
	      if (W.settings.barnesHutOptimize) {
	
	        var minX = Infinity,
	            maxX = -Infinity,
	            minY = Infinity,
	            maxY = -Infinity,
	            q, q0, q1, q2, q3;
	
	        // Setting up
	        // RegionMatrix = new Float32Array(W.nodesLength / W.ppn * 4 * W.ppr);
	        RegionMatrix = [];
	
	        // Computing min and max values
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	          minX = Math.min(minX, NodeMatrix[np(n, 'x')]);
	          maxX = Math.max(maxX, NodeMatrix[np(n, 'x')]);
	          minY = Math.min(minY, NodeMatrix[np(n, 'y')]);
	          maxY = Math.max(maxY, NodeMatrix[np(n, 'y')]);
	        }
	
	        // Build the Barnes Hut root region
	        RegionMatrix[rp(0, 'node')] = -1;
	        RegionMatrix[rp(0, 'centerX')] = (minX + maxX) / 2;
	        RegionMatrix[rp(0, 'centerY')] = (minY + maxY) / 2;
	        RegionMatrix[rp(0, 'size')] = Math.max(maxX - minX, maxY - minY);
	        RegionMatrix[rp(0, 'nextSibling')] = -1;
	        RegionMatrix[rp(0, 'firstChild')] = -1;
	        RegionMatrix[rp(0, 'mass')] = 0;
	        RegionMatrix[rp(0, 'massCenterX')] = 0;
	        RegionMatrix[rp(0, 'massCenterY')] = 0;
	
	        // Add each node in the tree
	        l = 1;
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	
	          // Current region, starting with root
	          r = 0;
	
	          while (true) {
	            // Are there sub-regions?
	
	            // We look at first child index
	            if (RegionMatrix[rp(r, 'firstChild')] >= 0) {
	
	              // There are sub-regions
	
	              // We just iterate to find a "leave" of the tree
	              // that is an empty region or a region with a single node
	              // (see next case)
	
	              // Find the quadrant of n
	              if (NodeMatrix[np(n, 'x')] < RegionMatrix[rp(r, 'centerX')]) {
	
	                if (NodeMatrix[np(n, 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                  // Top Left quarter
	                  q = RegionMatrix[rp(r, 'firstChild')];
	                }
	                else {
	
	                  // Bottom Left quarter
	                  q = RegionMatrix[rp(r, 'firstChild')] + W.ppr;
	                }
	              }
	              else {
	                if (NodeMatrix[np(n, 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                  // Top Right quarter
	                  q = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 2;
	                }
	                else {
	
	                  // Bottom Right quarter
	                  q = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 3;
	                }
	              }
	
	              // Update center of mass and mass (we only do it for non-leave regions)
	              RegionMatrix[rp(r, 'massCenterX')] =
	                (RegionMatrix[rp(r, 'massCenterX')] * RegionMatrix[rp(r, 'mass')] +
	                 NodeMatrix[np(n, 'x')] * NodeMatrix[np(n, 'mass')]) /
	                (RegionMatrix[rp(r, 'mass')] + NodeMatrix[np(n, 'mass')]);
	
	              RegionMatrix[rp(r, 'massCenterY')] =
	                (RegionMatrix[rp(r, 'massCenterY')] * RegionMatrix[rp(r, 'mass')] +
	                 NodeMatrix[np(n, 'y')] * NodeMatrix[np(n, 'mass')]) /
	                (RegionMatrix[rp(r, 'mass')] + NodeMatrix[np(n, 'mass')]);
	
	              RegionMatrix[rp(r, 'mass')] += NodeMatrix[np(n, 'mass')];
	
	              // Iterate on the right quadrant
	              r = q;
	              continue;
	            }
	            else {
	
	              // There are no sub-regions: we are in a "leave"
	
	              // Is there a node in this leave?
	              if (RegionMatrix[rp(r, 'node')] < 0) {
	
	                // There is no node in region:
	                // we record node n and go on
	                RegionMatrix[rp(r, 'node')] = n;
	                break;
	              }
	              else {
	
	                // There is a node in this region
	
	                // We will need to create sub-regions, stick the two
	                // nodes (the old one r[0] and the new one n) in two
	                // subregions. If they fall in the same quadrant,
	                // we will iterate.
	
	                // Create sub-regions
	                RegionMatrix[rp(r, 'firstChild')] = l * W.ppr;
	                w = RegionMatrix[rp(r, 'size')] / 2;  // new size (half)
	
	                // NOTE: we use screen coordinates
	                // from Top Left to Bottom Right
	
	                // Top Left sub-region
	                g = RegionMatrix[rp(r, 'firstChild')];
	
	                RegionMatrix[rp(g, 'node')] = -1;
	                RegionMatrix[rp(g, 'centerX')] = RegionMatrix[rp(r, 'centerX')] - w;
	                RegionMatrix[rp(g, 'centerY')] = RegionMatrix[rp(r, 'centerY')] - w;
	                RegionMatrix[rp(g, 'size')] = w;
	                RegionMatrix[rp(g, 'nextSibling')] = g + W.ppr;
	                RegionMatrix[rp(g, 'firstChild')] = -1;
	                RegionMatrix[rp(g, 'mass')] = 0;
	                RegionMatrix[rp(g, 'massCenterX')] = 0;
	                RegionMatrix[rp(g, 'massCenterY')] = 0;
	
	                // Bottom Left sub-region
	                g += W.ppr;
	                RegionMatrix[rp(g, 'node')] = -1;
	                RegionMatrix[rp(g, 'centerX')] = RegionMatrix[rp(r, 'centerX')] - w;
	                RegionMatrix[rp(g, 'centerY')] = RegionMatrix[rp(r, 'centerY')] + w;
	                RegionMatrix[rp(g, 'size')] = w;
	                RegionMatrix[rp(g, 'nextSibling')] = g + W.ppr;
	                RegionMatrix[rp(g, 'firstChild')] = -1;
	                RegionMatrix[rp(g, 'mass')] = 0;
	                RegionMatrix[rp(g, 'massCenterX')] = 0;
	                RegionMatrix[rp(g, 'massCenterY')] = 0;
	
	                // Top Right sub-region
	                g += W.ppr;
	                RegionMatrix[rp(g, 'node')] = -1;
	                RegionMatrix[rp(g, 'centerX')] = RegionMatrix[rp(r, 'centerX')] + w;
	                RegionMatrix[rp(g, 'centerY')] = RegionMatrix[rp(r, 'centerY')] - w;
	                RegionMatrix[rp(g, 'size')] = w;
	                RegionMatrix[rp(g, 'nextSibling')] = g + W.ppr;
	                RegionMatrix[rp(g, 'firstChild')] = -1;
	                RegionMatrix[rp(g, 'mass')] = 0;
	                RegionMatrix[rp(g, 'massCenterX')] = 0;
	                RegionMatrix[rp(g, 'massCenterY')] = 0;
	
	                // Bottom Right sub-region
	                g += W.ppr;
	                RegionMatrix[rp(g, 'node')] = -1;
	                RegionMatrix[rp(g, 'centerX')] = RegionMatrix[rp(r, 'centerX')] + w;
	                RegionMatrix[rp(g, 'centerY')] = RegionMatrix[rp(r, 'centerY')] + w;
	                RegionMatrix[rp(g, 'size')] = w;
	                RegionMatrix[rp(g, 'nextSibling')] = RegionMatrix[rp(r, 'nextSibling')];
	                RegionMatrix[rp(g, 'firstChild')] = -1;
	                RegionMatrix[rp(g, 'mass')] = 0;
	                RegionMatrix[rp(g, 'massCenterX')] = 0;
	                RegionMatrix[rp(g, 'massCenterY')] = 0;
	
	                l += 4;
	
	                // Now the goal is to find two different sub-regions
	                // for the two nodes: the one previously recorded (r[0])
	                // and the one we want to add (n)
	
	                // Find the quadrant of the old node
	                if (NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'x')] < RegionMatrix[rp(r, 'centerX')]) {
	                  if (NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                    // Top Left quarter
	                    q = RegionMatrix[rp(r, 'firstChild')];
	                  }
	                  else {
	
	                    // Bottom Left quarter
	                    q = RegionMatrix[rp(r, 'firstChild')] + W.ppr;
	                  }
	                }
	                else {
	                  if (NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                    // Top Right quarter
	                    q = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 2;
	                  }
	                  else {
	
	                    // Bottom Right quarter
	                    q = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 3;
	                  }
	                }
	
	                // We remove r[0] from the region r, add its mass to r and record it in q
	                RegionMatrix[rp(r, 'mass')] = NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'mass')];
	                RegionMatrix[rp(r, 'massCenterX')] = NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'x')];
	                RegionMatrix[rp(r, 'massCenterY')] = NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'y')];
	
	                RegionMatrix[rp(q, 'node')] = RegionMatrix[rp(r, 'node')];
	                RegionMatrix[rp(r, 'node')] = -1;
	
	                // Find the quadrant of n
	                if (NodeMatrix[np(n, 'x')] < RegionMatrix[rp(r, 'centerX')]) {
	                  if (NodeMatrix[np(n, 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                    // Top Left quarter
	                    q2 = RegionMatrix[rp(r, 'firstChild')];
	                  }
	                  else {
	                    // Bottom Left quarter
	                    q2 = RegionMatrix[rp(r, 'firstChild')] + W.ppr;
	                  }
	                }
	                else {
	                  if(NodeMatrix[np(n, 'y')] < RegionMatrix[rp(r, 'centerY')]) {
	
	                    // Top Right quarter
	                    q2 = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 2;
	                  }
	                  else {
	
	                    // Bottom Right quarter
	                    q2 = RegionMatrix[rp(r, 'firstChild')] + W.ppr * 3;
	                  }
	                }
	
	                if (q === q2) {
	
	                  // If both nodes are in the same quadrant,
	                  // we have to try it again on this quadrant
	                  r = q;
	                  continue;
	                }
	
	                // If both quadrants are different, we record n
	                // in its quadrant
	                RegionMatrix[rp(q2, 'node')] = n;
	                break;
	              }
	            }
	          }
	        }
	      }
	
	
	      // 2) Repulsion
	      //--------------
	      // NOTES: adjustSizes = antiCollision & scalingRatio = coefficient
	
	      if (W.settings.barnesHutOptimize) {
	        coefficient = W.settings.scalingRatio;
	
	        // Applying repulsion through regions
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	
	          // Computing leaf quad nodes iteration
	
	          r = 0; // Starting with root region
	          while (true) {
	
	            if (RegionMatrix[rp(r, 'firstChild')] >= 0) {
	
	              // The region has sub-regions
	
	              // We run the Barnes Hut test to see if we are at the right distance
	              distance = Math.sqrt(
	                (Math.pow(NodeMatrix[np(n, 'x')] - RegionMatrix[rp(r, 'massCenterX')], 2)) +
	                (Math.pow(NodeMatrix[np(n, 'y')] - RegionMatrix[rp(r, 'massCenterY')], 2))
	              );
	
	              if (2 * RegionMatrix[rp(r, 'size')] / distance < W.settings.barnesHutTheta) {
	
	                // We treat the region as a single body, and we repulse
	
	                xDist = NodeMatrix[np(n, 'x')] - RegionMatrix[rp(r, 'massCenterX')];
	                yDist = NodeMatrix[np(n, 'y')] - RegionMatrix[rp(r, 'massCenterY')];
	
	                if (W.settings.adjustSizes) {
	
	                  //-- Linear Anti-collision Repulsion
	                  if (distance > 0) {
	                    factor = coefficient * NodeMatrix[np(n, 'mass')] *
	                      RegionMatrix[rp(r, 'mass')] / distance / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                  else if (distance < 0) {
	                    factor = -coefficient * NodeMatrix[np(n, 'mass')] *
	                      RegionMatrix[rp(r, 'mass')] / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                }
	                else {
	
	                  //-- Linear Repulsion
	                  if (distance > 0) {
	                    factor = coefficient * NodeMatrix[np(n, 'mass')] *
	                      RegionMatrix[rp(r, 'mass')] / distance / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                }
	
	                // When this is done, we iterate. We have to look at the next sibling.
	                if (RegionMatrix[rp(r, 'nextSibling')] < 0)
	                  break;  // No next sibling: we have finished the tree
	                r = RegionMatrix[rp(r, 'nextSibling')];
	                continue;
	
	              }
	              else {
	
	                // The region is too close and we have to look at sub-regions
	                r = RegionMatrix[rp(r, 'firstChild')];
	                continue;
	              }
	
	            }
	            else {
	
	              // The region has no sub-region
	              // If there is a node r[0] and it is not n, then repulse
	
	              if (RegionMatrix[rp(r, 'node')] >= 0 && RegionMatrix[rp(r, 'node')] !== n) {
	                xDist = NodeMatrix[np(n, 'x')] - NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'x')];
	                yDist = NodeMatrix[np(n, 'y')] - NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'y')];
	
	                distance = Math.sqrt(xDist * xDist + yDist * yDist);
	
	                if (W.settings.adjustSizes) {
	
	                  //-- Linear Anti-collision Repulsion
	                  if (distance > 0) {
	                    factor = coefficient * NodeMatrix[np(n, 'mass')] *
	                      NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'mass')] / distance / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                  else if (distance < 0) {
	                    factor = -coefficient * NodeMatrix[np(n, 'mass')] *
	                      NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'mass')] / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                }
	                else {
	
	                  //-- Linear Repulsion
	                  if (distance > 0) {
	                    factor = coefficient * NodeMatrix[np(n, 'mass')] *
	                      NodeMatrix[np(RegionMatrix[rp(r, 'node')], 'mass')] / distance / distance;
	
	                    NodeMatrix[np(n, 'dx')] += xDist * factor;
	                    NodeMatrix[np(n, 'dy')] += yDist * factor;
	                  }
	                }
	
	              }
	
	              // When this is done, we iterate. We have to look at the next sibling.
	              if (RegionMatrix[rp(r, 'nextSibling')] < 0)
	                break;  // No next sibling: we have finished the tree
	              r = RegionMatrix[rp(r, 'nextSibling')];
	              continue;
	            }
	          }
	        }
	      }
	      else {
	        coefficient = W.settings.scalingRatio;
	
	        // Square iteration
	        for (n1 = 0; n1 < W.nodesLength; n1 += W.ppn) {
	          for (n2 = 0; n2 < n1; n2 += W.ppn) {
	
	            // Common to both methods
	            xDist = NodeMatrix[np(n1, 'x')] - NodeMatrix[np(n2, 'x')];
	            yDist = NodeMatrix[np(n1, 'y')] - NodeMatrix[np(n2, 'y')];
	
	            if (W.settings.adjustSizes) {
	
	              //-- Anticollision Linear Repulsion
	              distance = Math.sqrt(xDist * xDist + yDist * yDist) -
	                NodeMatrix[np(n1, 'size')] -
	                NodeMatrix[np(n2, 'size')];
	
	              if (distance > 0) {
	                factor = coefficient *
	                  NodeMatrix[np(n1, 'mass')] *
	                  NodeMatrix[np(n2, 'mass')] /
	                  distance / distance;
	
	                // Updating nodes' dx and dy
	                NodeMatrix[np(n1, 'dx')] += xDist * factor;
	                NodeMatrix[np(n1, 'dy')] += yDist * factor;
	
	                NodeMatrix[np(n2, 'dx')] += xDist * factor;
	                NodeMatrix[np(n2, 'dy')] += yDist * factor;
	              }
	              else if (distance < 0) {
	                factor = 100 * coefficient *
	                  NodeMatrix[np(n1, 'mass')] *
	                  NodeMatrix[np(n2, 'mass')];
	
	                // Updating nodes' dx and dy
	                NodeMatrix[np(n1, 'dx')] += xDist * factor;
	                NodeMatrix[np(n1, 'dy')] += yDist * factor;
	
	                NodeMatrix[np(n2, 'dx')] -= xDist * factor;
	                NodeMatrix[np(n2, 'dy')] -= yDist * factor;
	              }
	            }
	            else {
	
	              //-- Linear Repulsion
	              distance = Math.sqrt(xDist * xDist + yDist * yDist);
	
	              if (distance > 0) {
	                factor = coefficient *
	                  NodeMatrix[np(n1, 'mass')] *
	                  NodeMatrix[np(n2, 'mass')] /
	                  distance / distance;
	
	                // Updating nodes' dx and dy
	                NodeMatrix[np(n1, 'dx')] += xDist * factor;
	                NodeMatrix[np(n1, 'dy')] += yDist * factor;
	
	                NodeMatrix[np(n2, 'dx')] -= xDist * factor;
	                NodeMatrix[np(n2, 'dy')] -= yDist * factor;
	              }
	            }
	          }
	        }
	      }
	
	
	      // 3) Gravity
	      //------------
	      g = W.settings.gravity / W.settings.scalingRatio;
	      coefficient = W.settings.scalingRatio;
	      for (n = 0; n < W.nodesLength; n += W.ppn) {
	        factor = 0;
	
	        // Common to both methods
	        xDist = NodeMatrix[np(n, 'x')];
	        yDist = NodeMatrix[np(n, 'y')];
	        distance = Math.sqrt(
	          Math.pow(xDist, 2) + Math.pow(yDist, 2)
	        );
	
	        if (W.settings.strongGravityMode) {
	
	          //-- Strong gravity
	          if (distance > 0)
	            factor = coefficient * NodeMatrix[np(n, 'mass')] * g;
	        }
	        else {
	
	          //-- Linear Anti-collision Repulsion n
	          if (distance > 0)
	            factor = coefficient * NodeMatrix[np(n, 'mass')] * g / distance;
	        }
	
	        // Updating node's dx and dy
	        NodeMatrix[np(n, 'dx')] -= xDist * factor;
	        NodeMatrix[np(n, 'dy')] -= yDist * factor;
	      }
	
	
	
	      // 4) Attraction
	      //---------------
	      coefficient = 1 *
	        (W.settings.outboundAttractionDistribution ?
	          outboundAttCompensation :
	          1);
	
	      // TODO: simplify distance
	      // TODO: coefficient is always used as -c --> optimize?
	      for (e = 0; e < W.edgesLength; e += W.ppe) {
	        n1 = EdgeMatrix[ep(e, 'source')];
	        n2 = EdgeMatrix[ep(e, 'target')];
	        w = EdgeMatrix[ep(e, 'weight')];
	
	        // Edge weight influence
	        ewc = Math.pow(w, W.settings.edgeWeightInfluence);
	
	        // Common measures
	        xDist = NodeMatrix[np(n1, 'x')] - NodeMatrix[np(n2, 'x')];
	        yDist = NodeMatrix[np(n1, 'y')] - NodeMatrix[np(n2, 'y')];
	
	        // Applying attraction to nodes
	        if (W.settings.adjustSizes) {
	
	          distance = Math.sqrt(
	            (Math.pow(xDist, 2) + Math.pow(yDist, 2)) -
	            NodeMatrix[np(n1, 'size')] -
	            NodeMatrix[np(n2, 'size')]
	          );
	
	          if (W.settings.linLogMode) {
	            if (W.settings.outboundAttractionDistribution) {
	
	              //-- LinLog Degree Distributed Anti-collision Attraction
	              if (distance > 0) {
	                factor = -coefficient * ewc * Math.log(1 + distance) /
	                distance /
	                NodeMatrix[np(n1, 'mass')];
	              }
	            }
	            else {
	
	              //-- LinLog Anti-collision Attraction
	              if (distance > 0) {
	                factor = -coefficient * ewc * Math.log(1 + distance) / distance;
	              }
	            }
	          }
	          else {
	            if (W.settings.outboundAttractionDistribution) {
	
	              //-- Linear Degree Distributed Anti-collision Attraction
	              if (distance > 0) {
	                factor = -coefficient * ewc / NodeMatrix[np(n1, 'mass')];
	              }
	            }
	            else {
	
	              //-- Linear Anti-collision Attraction
	              if (distance > 0) {
	                factor = -coefficient * ewc;
	              }
	            }
	          }
	        }
	        else {
	
	          distance = Math.sqrt(
	            Math.pow(xDist, 2) + Math.pow(yDist, 2)
	          );
	
	          if (W.settings.linLogMode) {
	            if (W.settings.outboundAttractionDistribution) {
	
	              //-- LinLog Degree Distributed Attraction
	              if (distance > 0) {
	                factor = -coefficient * ewc * Math.log(1 + distance) /
	                  distance /
	                  NodeMatrix[np(n1, 'mass')];
	              }
	            }
	            else {
	
	              //-- LinLog Attraction
	              if (distance > 0)
	                factor = -coefficient * ewc * Math.log(1 + distance) / distance;
	            }
	          }
	          else {
	            if (W.settings.outboundAttractionDistribution) {
	
	              //-- Linear Attraction Mass Distributed
	              // NOTE: Distance is set to 1 to override next condition
	              distance = 1;
	              factor = -coefficient * ewc / NodeMatrix[np(n1, 'mass')];
	            }
	            else {
	
	              //-- Linear Attraction
	              // NOTE: Distance is set to 1 to override next condition
	              distance = 1;
	              factor = -coefficient * ewc;
	            }
	          }
	        }
	
	        // Updating nodes' dx and dy
	        // TODO: if condition or factor = 1?
	        if (distance > 0) {
	
	          // Updating nodes' dx and dy
	          NodeMatrix[np(n1, 'dx')] += xDist * factor;
	          NodeMatrix[np(n1, 'dy')] += yDist * factor;
	
	          NodeMatrix[np(n2, 'dx')] -= xDist * factor;
	          NodeMatrix[np(n2, 'dy')] -= yDist * factor;
	        }
	      }
	
	
	      // 5) Apply Forces
	      //-----------------
	      var force,
	          swinging,
	          traction,
	          nodespeed;
	
	      // MATH: sqrt and square distances
	      if (W.settings.adjustSizes) {
	
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	          if (!NodeMatrix[np(n, 'fixed')]) {
	            force = Math.sqrt(
	              Math.pow(NodeMatrix[np(n, 'dx')], 2) +
	              Math.pow(NodeMatrix[np(n, 'dy')], 2)
	            );
	
	            if (force > W.maxForce) {
	              NodeMatrix[np(n, 'dx')] =
	                NodeMatrix[np(n, 'dx')] * W.maxForce / force;
	              NodeMatrix[np(n, 'dy')] =
	                NodeMatrix[np(n, 'dy')] * W.maxForce / force;
	            }
	
	            swinging = NodeMatrix[np(n, 'mass')] *
	              Math.sqrt(
	                (NodeMatrix[np(n, 'old_dx')] - NodeMatrix[np(n, 'dx')]) *
	                (NodeMatrix[np(n, 'old_dx')] - NodeMatrix[np(n, 'dx')]) +
	                (NodeMatrix[np(n, 'old_dy')] - NodeMatrix[np(n, 'dy')]) *
	                (NodeMatrix[np(n, 'old_dy')] - NodeMatrix[np(n, 'dy')])
	              );
	
	            traction = Math.sqrt(
	              (NodeMatrix[np(n, 'old_dx')] + NodeMatrix[np(n, 'dx')]) *
	              (NodeMatrix[np(n, 'old_dx')] + NodeMatrix[np(n, 'dx')]) +
	              (NodeMatrix[np(n, 'old_dy')] + NodeMatrix[np(n, 'dy')]) *
	              (NodeMatrix[np(n, 'old_dy')] + NodeMatrix[np(n, 'dy')])
	            ) / 2;
	
	            nodespeed =
	              0.1 * Math.log(1 + traction) / (1 + Math.sqrt(swinging));
	
	            // Updating node's positon
	            NodeMatrix[np(n, 'x')] =
	              NodeMatrix[np(n, 'x')] + NodeMatrix[np(n, 'dx')] *
	              (nodespeed / W.settings.slowDown);
	            NodeMatrix[np(n, 'y')] =
	              NodeMatrix[np(n, 'y')] + NodeMatrix[np(n, 'dy')] *
	              (nodespeed / W.settings.slowDown);
	          }
	        }
	      }
	      else {
	
	        for (n = 0; n < W.nodesLength; n += W.ppn) {
	          if (!NodeMatrix[np(n, 'fixed')]) {
	
	            swinging = NodeMatrix[np(n, 'mass')] *
	              Math.sqrt(
	                (NodeMatrix[np(n, 'old_dx')] - NodeMatrix[np(n, 'dx')]) *
	                (NodeMatrix[np(n, 'old_dx')] - NodeMatrix[np(n, 'dx')]) +
	                (NodeMatrix[np(n, 'old_dy')] - NodeMatrix[np(n, 'dy')]) *
	                (NodeMatrix[np(n, 'old_dy')] - NodeMatrix[np(n, 'dy')])
	              );
	
	            traction = Math.sqrt(
	              (NodeMatrix[np(n, 'old_dx')] + NodeMatrix[np(n, 'dx')]) *
	              (NodeMatrix[np(n, 'old_dx')] + NodeMatrix[np(n, 'dx')]) +
	              (NodeMatrix[np(n, 'old_dy')] + NodeMatrix[np(n, 'dy')]) *
	              (NodeMatrix[np(n, 'old_dy')] + NodeMatrix[np(n, 'dy')])
	            ) / 2;
	
	            nodespeed = NodeMatrix[np(n, 'convergence')] *
	              Math.log(1 + traction) / (1 + Math.sqrt(swinging));
	
	            // Updating node convergence
	            NodeMatrix[np(n, 'convergence')] =
	              Math.min(1, Math.sqrt(
	                nodespeed *
	                (Math.pow(NodeMatrix[np(n, 'dx')], 2) +
	                 Math.pow(NodeMatrix[np(n, 'dy')], 2)) /
	                (1 + Math.sqrt(swinging))
	              ));
	
	            // Updating node's positon
	            NodeMatrix[np(n, 'x')] =
	              NodeMatrix[np(n, 'x')] + NodeMatrix[np(n, 'dx')] *
	              (nodespeed / W.settings.slowDown);
	            NodeMatrix[np(n, 'y')] =
	              NodeMatrix[np(n, 'y')] + NodeMatrix[np(n, 'dy')] *
	              (nodespeed / W.settings.slowDown);
	          }
	        }
	      }
	
	      // Counting one more iteration
	      W.iterations++;
	    }
	
	    /**
	     * Message reception & sending
	     */
	
	    // Sending data back to the supervisor
	    var sendNewCoords;
	
	    if (typeof window !== 'undefined' && window.document) {
	
	      // From same document as sigma
	      sendNewCoords = function() {
	        var e;
	
	        if (document.createEvent) {
	          e = document.createEvent('Event');
	          e.initEvent('newCoords', true, false);
	        }
	        else {
	          e = document.createEventObject();
	          e.eventType = 'newCoords';
	        }
	
	        e.eventName = 'newCoords';
	        e.data = {
	          nodes: NodeMatrix.buffer
	        };
	        requestAnimationFrame(function() {
	          document.dispatchEvent(e);
	        });
	      };
	    }
	    else {
	
	      // From a WebWorker
	      sendNewCoords = function() {
	        self.postMessage(
	          {nodes: NodeMatrix.buffer},
	          [NodeMatrix.buffer]
	        );
	      };
	    }
	
	    // Algorithm run
	    function run(n) {
	      for (var i = 0; i < n; i++)
	        pass();
	      sendNewCoords();
	    }
	
	    // On supervisor message
	    var listener = function(e) {
	      switch (e.data.action) {
	        case 'start':
	          init(
	            new Float32Array(e.data.nodes),
	            new Float32Array(e.data.edges),
	            e.data.config
	          );
	
	          // First iteration(s)
	          run(W.settings.startingIterations);
	          break;
	
	        case 'loop':
	          NodeMatrix = new Float32Array(e.data.nodes);
	          run(W.settings.iterationsPerRender);
	          break;
	
	        case 'config':
	
	          // Merging new settings
	          configure(e.data.config);
	          break;
	
	        case 'kill':
	
	          // Deleting context for garbage collection
	          __emptyObject(W);
	          NodeMatrix = null;
	          EdgeMatrix = null;
	          RegionMatrix = null;
	          self.removeEventListener('message', listener);
	          break;
	
	        default:
	      }
	    };
	
	    // Adding event listener
	    self.addEventListener('message', listener);
	  };
	
	
	  /**
	   * Exporting
	   * ----------
	   *
	   * Crush the worker function and make it accessible by sigma's instances so
	   * the supervisor can call it.
	   */
	  function crush(fnString) {
	    var pattern,
	        i,
	        l;
	
	    var np = [
	      'x',
	      'y',
	      'dx',
	      'dy',
	      'old_dx',
	      'old_dy',
	      'mass',
	      'convergence',
	      'size',
	      'fixed'
	    ];
	
	    var ep = [
	      'source',
	      'target',
	      'weight'
	    ];
	
	    var rp = [
	      'node',
	      'centerX',
	      'centerY',
	      'size',
	      'nextSibling',
	      'firstChild',
	      'mass',
	      'massCenterX',
	      'massCenterY'
	    ];
	
	    // rp
	    // NOTE: Must go first
	    for (i = 0, l = rp.length; i < l; i++) {
	      pattern = new RegExp('rp\\(([^,]*), \'' + rp[i] + '\'\\)', 'g');
	      fnString = fnString.replace(
	        pattern,
	        (i === 0) ? '$1' : '$1 + ' + i
	      );
	    }
	
	    // np
	    for (i = 0, l = np.length; i < l; i++) {
	      pattern = new RegExp('np\\(([^,]*), \'' + np[i] + '\'\\)', 'g');
	      fnString = fnString.replace(
	        pattern,
	        (i === 0) ? '$1' : '$1 + ' + i
	      );
	    }
	
	    // ep
	    for (i = 0, l = ep.length; i < l; i++) {
	      pattern = new RegExp('ep\\(([^,]*), \'' + ep[i] + '\'\\)', 'g');
	      fnString = fnString.replace(
	        pattern,
	        (i === 0) ? '$1' : '$1 + ' + i
	      );
	    }
	
	    return fnString;
	  }
	
	  // Exporting
	  function getWorkerFn() {
	    var fnString = crush ? crush(Worker.toString()) : Worker.toString();
	    return ';(' + fnString + ').call(this);';
	  }
	
	  if (inWebWorker) {
	
	    // We are in a webworker, so we launch the Worker function
	    eval(getWorkerFn());
	  }
	  else {
	
	    // We are requesting the worker from sigma, we retrieve it therefore
	    if (typeof sigma === 'undefined')
	      throw 'sigma is not declared';
	
	    sigma.prototype.getForceAtlas2Worker = getWorkerFn;
	  }
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 203 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 120);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 120:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize package:
	  sigma.utils.pkg('sigma.parsers');
	  sigma.utils.pkg('sigma.utils');
	
	  /**
	   * Just an XmlHttpRequest polyfill for different IE versions.
	   *
	   * @return {*} The XHR like object.
	   */
	  sigma.utils.xhr = function() {
	    if (window.XMLHttpRequest)
	      return new XMLHttpRequest();
	
	    var names,
	        i;
	
	    if (window.ActiveXObject) {
	      names = [
	        'Msxml2.XMLHTTP.6.0',
	        'Msxml2.XMLHTTP.3.0',
	        'Msxml2.XMLHTTP',
	        'Microsoft.XMLHTTP'
	      ];
	
	      for (i in names)
	        try {
	          return new ActiveXObject(names[i]);
	        } catch (e) {}
	    }
	
	    return null;
	  };
	
	  /**
	   * This function loads a JSON file and creates a new sigma instance or
	   * updates the graph of a given instance. It is possible to give a callback
	   * that will be executed at the end of the process.
	   *
	   * @param  {string}       url      The URL of the JSON file.
	   * @param  {object|sigma} sig      A sigma configuration object or a sigma
	   *                                 instance.
	   * @param  {?function}    callback Eventually a callback to execute after
	   *                                 having parsed the file. It will be called
	   *                                 with the related sigma instance as
	   *                                 parameter.
	   */
	  sigma.parsers.json = function(url, sig, callback) {
	    var graph,
	        xhr = sigma.utils.xhr();
	
	    if (!xhr)
	      throw 'XMLHttpRequest not supported, cannot load the file.';
	
	    xhr.open('GET', url, true);
	    xhr.onreadystatechange = function() {
	      if (xhr.readyState === 4) {
	        graph = JSON.parse(xhr.responseText);
	
	        // Update the instance's graph:
	        if (sig instanceof sigma) {
	          sig.graph.clear();
	          sig.graph.read(graph);
	
	        // ...or instantiate sigma if needed:
	        } else if (typeof sig === 'object') {
	          sig.graph = graph;
	          sig = new sigma(sig);
	
	        // ...or it's finally the callback:
	        } else if (typeof sig === 'function') {
	          callback = sig;
	          sig = null;
	        }
	
	        // Call the callback if specified:
	        if (callback)
	          callback(sig || graph);
	      }
	    };
	    xhr.send();
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 204 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 121);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 121:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * This plugin provides a method to animate a sigma instance by interpolating
	 * some node properties. Check the sigma.plugins.animate function doc or the
	 * examples/animate.html code sample to know more.
	 */
	(function() {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  sigma.utils.pkg('sigma.plugins');
	
	  var _id = 0,
	      _cache = {};
	
	  // TOOLING FUNCTIONS:
	  // ******************
	  function parseColor(val) {
	    if (_cache[val])
	      return _cache[val];
	
	    var result = [0, 0, 0];
	
	    if (val.match(/^#/)) {
	      val = (val || '').replace(/^#/, '');
	      result = (val.length === 3) ?
	        [
	          parseInt(val.charAt(0) + val.charAt(0), 16),
	          parseInt(val.charAt(1) + val.charAt(1), 16),
	          parseInt(val.charAt(2) + val.charAt(2), 16)
	        ] :
	        [
	          parseInt(val.charAt(0) + val.charAt(1), 16),
	          parseInt(val.charAt(2) + val.charAt(3), 16),
	          parseInt(val.charAt(4) + val.charAt(5), 16)
	        ];
	    } else if (val.match(/^ *rgba? *\(/)) {
	      val = val.match(
	        /^ *rgba? *\( *([0-9]*) *, *([0-9]*) *, *([0-9]*) *(,.*)?\) *$/
	      );
	      result = [
	        +val[1],
	        +val[2],
	        +val[3]
	      ];
	    }
	
	    _cache[val] = {
	      r: result[0],
	      g: result[1],
	      b: result[2]
	    };
	
	    return _cache[val];
	  }
	
	  function interpolateColors(c1, c2, p) {
	    c1 = parseColor(c1);
	    c2 = parseColor(c2);
	
	    var c = {
	      r: c1.r * (1 - p) + c2.r * p,
	      g: c1.g * (1 - p) + c2.g * p,
	      b: c1.b * (1 - p) + c2.b * p
	    };
	
	    return 'rgb(' + [c.r | 0, c.g | 0, c.b | 0].join(',') + ')';
	  }
	
	  /**
	   * This function will animate some specified node properties. It will
	   * basically call requestAnimationFrame, interpolate the values and call the
	   * refresh method during a specified duration.
	   *
	   * Recognized parameters:
	   * **********************
	   * Here is the exhaustive list of every accepted parameters in the settings
	   * object:
	   *
	   *   {?array}             nodes      An array of node objects or node ids. If
	   *                                   not specified, all nodes of the graph
	   *                                   will be animated.
	   *   {?(function|string)} easing     Either the name of an easing in the
	   *                                   sigma.utils.easings package or a
	   *                                   function. If not specified, the
	   *                                   quadraticInOut easing from this package
	   *                                   will be used instead.
	   *   {?number}            duration   The duration of the animation. If not
	   *                                   specified, the "animationsTime" setting
	   *                                   value of the sigma instance will be used
	   *                                   instead.
	   *   {?function}          onComplete Eventually a function to call when the
	   *                                   animation is ended.
	   *
	   * @param  {sigma}   s       The related sigma instance.
	   * @param  {object}  animate An hash with the keys being the node properties
	   *                           to interpolate, and the values being the related
	   *                           target values.
	   * @param  {?object} options Eventually an object with options.
	   */
	  sigma.plugins.animate = function(s, animate, options) {
	    var o = options || {},
	        id = ++_id,
	        duration = o.duration || s.settings('animationsTime'),
	        easing = typeof o.easing === 'string' ?
	          sigma.utils.easings[o.easing] :
	          typeof o.easing === 'function' ?
	          o.easing :
	          sigma.utils.easings.quadraticInOut,
	        start = sigma.utils.dateNow(),
	        nodes,
	        startPositions;
	
	    if (o.nodes && o.nodes.length) {
	      if (typeof o.nodes[0] === 'object')
	        nodes = o.nodes;
	      else
	        nodes = s.graph.nodes(o.nodes); // argument is an array of IDs
	    }
	    else
	      nodes = s.graph.nodes();
	
	    // Store initial positions:
	    startPositions = nodes.reduce(function(res, node) {
	      var k;
	      res[node.id] = {};
	      for (k in animate)
	        if (k in node)
	          res[node.id][k] = node[k];
	      return res;
	    }, {});
	
	    s.animations = s.animations || Object.create({});
	    sigma.plugins.kill(s);
	
	    // Do not refresh edgequadtree during drag:
	    var k,
	        c;
	    for (k in s.cameras) {
	      c = s.cameras[k];
	      c.edgequadtree._enabled = false;
	    }
	
	    function step() {
	      var p = (sigma.utils.dateNow() - start) / duration;
	
	      if (p >= 1) {
	        nodes.forEach(function(node) {
	          for (var k in animate)
	            if (k in animate)
	              node[k] = node[animate[k]];
	        });
	
	        // Allow to refresh edgequadtree:
	        var k,
	            c;
	        for (k in s.cameras) {
	          c = s.cameras[k];
	          c.edgequadtree._enabled = true;
	        }
	
	        s.refresh();
	        if (typeof o.onComplete === 'function')
	          o.onComplete();
	      } else {
	        p = easing(p);
	        nodes.forEach(function(node) {
	          for (var k in animate)
	            if (k in animate) {
	              if (k.match(/color$/))
	                node[k] = interpolateColors(
	                  startPositions[node.id][k],
	                  node[animate[k]],
	                  p
	                );
	              else
	                node[k] =
	                  node[animate[k]] * p +
	                  startPositions[node.id][k] * (1 - p);
	            }
	        });
	
	        s.refresh();
	        s.animations[id] = requestAnimationFrame(step);
	      }
	    }
	
	    step();
	  };
	
	  sigma.plugins.kill = function(s) {
	    for (var k in (s.animations || {}))
	      cancelAnimationFrame(s.animations[k]);
	
	    // Allow to refresh edgequadtree:
	    var k,
	        c;
	    for (k in s.cameras) {
	      c = s.cameras[k];
	      c.edgequadtree._enabled = true;
	    }
	  };
	}).call(window);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(49);
	
	var ReactCurrentOwner = __webpack_require__(25);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 206 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 210 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventBaseObject = __webpack_require__(210);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = void 0;
	    var deltaY = void 0;
	    var delta = void 0;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = void 0;
	    var doc = void 0;
	    var body = void 0;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2["default"].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = void 0;
	  var l = void 0;
	  var prop = void 0;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2["default"].prototype;
	
	(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports["default"] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListener;
	
	var _EventObject = __webpack_require__(211);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2["default"](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	var arraytools  = function () {
	
	  var that = {};
	
	  var RGB_REGEX =  /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(,.*)?\)$/;
	  var RGB_GROUP_REGEX = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,?\s*(.*)?\)$/;
	
	  function isPlainObject (v) {
	    return !Array.isArray(v) && v !== null && typeof v === 'object';
	  }
	
	  function linspace (start, end, num) {
	    var inc = (end - start) / Math.max(num - 1, 1);
	    var a = [];
	    for( var ii = 0; ii < num; ii++)
	      a.push(start + ii*inc);
	    return a;
	  }
	
	  function zip () {
	      var arrays = [].slice.call(arguments);
	      var lengths = arrays.map(function (a) {return a.length;});
	      var len = Math.min.apply(null, lengths);
	      var zipped = [];
	      for (var i = 0; i < len; i++) {
	          zipped[i] = [];
	          for (var j = 0; j < arrays.length; ++j) {
	              zipped[i][j] = arrays[j][i];
	          }
	      }
	      return zipped;
	  }
	
	  function zip3 (a, b, c) {
	      var len = Math.min.apply(null, [a.length, b.length, c.length]);
	      var result = [];
	      for (var n = 0; n < len; n++) {
	          result.push([a[n], b[n], c[n]]);
	      }
	      return result;
	  }
	
	  function sum (A) {
	    var acc = 0;
	    accumulate(A, acc);
	    function accumulate(x) {
	      for (var i = 0; i < x.length; i++) {
	        if (Array.isArray(x[i]))
	          accumulate(x[i], acc);
	        else
	          acc += x[i];
	      }
	    }
	    return acc;
	  }
	
	  function copy2D (arr) {
	    var carr = [];
	    for (var i = 0; i < arr.length; ++i) {
	      carr[i] = [];
	      for (var j = 0; j < arr[i].length; ++j) {
	        carr[i][j] = arr[i][j];
	      }
	    }
	
	    return carr;
	  }
	
	
	  function copy1D (arr) {
	    var carr = [];
	    for (var i = 0; i < arr.length; ++i) {
	      carr[i] = arr[i];
	    }
	
	    return carr;
	  }
	
	
	  function isEqual(arr1, arr2) {
	    if(arr1.length !== arr2.length)
	      return false;
	    for(var i = arr1.length; i--;) {
	      if(arr1[i] !== arr2[i])
	        return false;
	    }
	
	    return true;
	  }
	
	
	  function str2RgbArray(str, twoFiftySix) {
	    // convert hex or rbg strings to 0->1 or 0->255 rgb array
	    var rgb,
	        match;
	
	    if (typeof str !== 'string') return str;
	
	    rgb = [];
	    // hex notation
	    if (str[0] === '#') {
	      str = str.substr(1) // remove hash
	      if (str.length === 3) str += str // fff -> ffffff
	      match = parseInt(str, 16);
	      rgb[0] = ((match >> 16) & 255);
	      rgb[1] = ((match >> 8) & 255);
	      rgb[2] = (match & 255);
	    }
	
	    // rgb(34, 34, 127) or rgba(34, 34, 127, 0.1) notation
	    else if (RGB_REGEX.test(str)) {
	      match = str.match(RGB_GROUP_REGEX);
	      rgb[0] = parseInt(match[1]);
	      rgb[1] = parseInt(match[2]);
	      rgb[2] = parseInt(match[3]);
	    }
	
	    if (!twoFiftySix) {
	      for (var j=0; j<3; ++j) rgb[j] = rgb[j]/255
	    }
	
	
	    return rgb;
	  }
	
	
	  function str2RgbaArray(str, twoFiftySix) {
	    // convert hex or rbg strings to 0->1 or 0->255 rgb array
	    var rgb,
	        match;
	
	    if (typeof str !== 'string') return str;
	
	    rgb = [];
	    // hex notation
	    if (str[0] === '#') {
	      str = str.substr(1) // remove hash
	      if (str.length === 3) str += str // fff -> ffffff
	      match = parseInt(str, 16);
	      rgb[0] = ((match >> 16) & 255);
	      rgb[1] = ((match >> 8) & 255);
	      rgb[2] = (match & 255);
	    }
	
	    // rgb(34, 34, 127) or rgba(34, 34, 127, 0.1) notation
	    else if (RGB_REGEX.test(str)) {
	      match = str.match(RGB_GROUP_REGEX);
	      rgb[0] = parseInt(match[1]);
	      rgb[1] = parseInt(match[2]);
	      rgb[2] = parseInt(match[3]);
	      if (match[4]) rgb[3] = parseFloat(match[4]);
	      else rgb[3] = 1.0;
	    }
	
	
	
	    if (!twoFiftySix) {
	      for (var j=0; j<3; ++j) rgb[j] = rgb[j]/255
	    }
	
	
	    return rgb;
	  }
	
	
	
	
	
	  that.isPlainObject = isPlainObject;
	  that.linspace = linspace;
	  that.zip3 = zip3;
	  that.sum = sum;
	  that.zip = zip;
	  that.isEqual = isEqual;
	  that.copy2D = copy2D;
	  that.copy1D = copy1D;
	  that.str2RgbArray = str2RgbArray;
	  that.str2RgbaArray = str2RgbaArray;
	
	  return that
	
	}
	
	
	module.exports = arraytools();


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(229), __esModule: true };

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(230), __esModule: true };

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(233), __esModule: true };

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(235), __esModule: true };

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(236), __esModule: true };

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(218);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(217);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
		Baby Parse
		v0.4.1
		https://github.com/Rich-Harris/BabyParse
	
		Created by Rich Harris
		Maintained by Matt Holt
	
		Based on Papa Parse v4.0.7 by Matt Holt
		https://github.com/mholt/PapaParse
	*/
	(function(global)
	{
	
		// A configuration object from which to draw default settings
		var DEFAULTS = {
			delimiter: "",	// empty: auto-detect
			newline: "",	// empty: auto-detect
			header: false,
			dynamicTyping: false,
			preview: 0,
			step: undefined,
			comments: false,
			complete: undefined,
			skipEmptyLines: false,
			fastMode: false
		};
	
		var Baby = {};
		Baby.parse = CsvToJson;
		Baby.parseFiles = ParseFiles;
		Baby.unparse = JsonToCsv;
		Baby.RECORD_SEP = String.fromCharCode(30);
		Baby.UNIT_SEP = String.fromCharCode(31);
		Baby.BYTE_ORDER_MARK = "\ufeff";
		Baby.BAD_DELIMITERS = ["\r", "\n", "\"", Baby.BYTE_ORDER_MARK];
		Baby.DefaultDelimiter = ",";		// Used if not specified and detection fails
		Baby.Parser = Parser;				// For testing/dev only
		Baby.ParserHandle = ParserHandle;	// For testing/dev only
		
		var fs = fs || __webpack_require__(449)
		
		function ParseFiles(_input, _config)
		{
			if (Array.isArray(_input)) {
				var results = [];
				_input.forEach(function(input) {
					if(typeof input === 'object')
						results.push(ParseFiles(input.file, input.config));
					else
						results.push(ParseFiles(input, _config));
				});
				return results;
			} else {
				var results = {
					data: [],
					errors: []
				};
				if ((/(\.csv|\.txt)$/).test(_input)) {
					try {
						var contents = fs.readFileSync(_input).toString();
						return CsvToJson(contents, _config);
					} catch (err) {
						results.errors.push(err);
						return results;
					}
				} else {
					results.errors.push({
						type: '',
						code: '',
						message: 'Unsupported file type.',
						row: ''
					});
					return results;
				}
			}
		}
	
		function CsvToJson(_input, _config)
		{
			var config = copyAndValidateConfig(_config);
			var ph = new ParserHandle(config);
			var results = ph.parse(_input);
			return results;
		}
	
	
	
	
		function JsonToCsv(_input, _config)
		{
			var _output = "";
			var _fields = [];
	
			// Default configuration
			var _quotes = false;	// whether to surround every datum with quotes
			var _delimiter = ",";	// delimiting character
			var _newline = "\r\n";	// newline character(s)
	
			unpackConfig();
	
			if (typeof _input === 'string')
				_input = JSON.parse(_input);
	
			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);
	
				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields = _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);
	
					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ["asdf"]
				}
	
				return serialize(_input.fields || [], _input.data || []);
			}
	
			// Default (any valid paths should return before this)
			throw "exception: Unable to serialize unrecognized input";
	
	
			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;
	
				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length == 1
					&& Baby.BAD_DELIMITERS.indexOf(_config.delimiter) == -1)
				{
					_delimiter = _config.delimiter;
				}
	
				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;
	
				if (typeof _config.newline === 'string')
					_newline = _config.newline;
			}
	
	
			// Turns an object's keys into an array
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}
	
			// The double for loop that iterates the data and writes out a CSV string including header row
			function serialize(fields, data)
			{
				var csv = "";
	
				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);
	
				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);
	
				// If there a header row, write it first
				if (hasHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}
	
				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;
	
					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}
	
					if (row < data.length - 1)
						csv += _newline;
				}
	
				return csv;
			}
	
			// Encloses a value around quotes if needed (makes a value safe for CSV insertion)
			function safe(str, col)
			{
				if (typeof str === "undefined" || str === null)
					return "";
	
				str = str.toString().replace(/"/g, '""');
	
				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Baby.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) == ' '
								|| str.charAt(str.length - 1) == ' ';
	
				return needsQuotes ? '"' + str + '"' : str;
			}
	
			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}
	
	
	
	
	
	
		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;
	
			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};
	
			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;
	
					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();
	
						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length == 0)
							return;
	
						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}
	
			this.parse = function(input)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);
	
				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Baby.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}
	
				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row
	
				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input);
				processResults();
				if (isFunction(_config.complete) && !_paused && (!self.streamer || self.streamer.finished()))
					_config.complete(_results);
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};
	
			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};
	
			this.resume = function()
			{
				_paused = false;
				_parser = new Parser(_config);
				_parser.parse(_input);
				if (!_paused)
				{
					if (self.streamer && !self.streamer.finished())
						self.streamer.resume();		// more of the file yet to come
					else if (isFunction(_config.complete))
						_config.complete(_results);
				}
			};
	
			this.abort = function()
			{
				_parser.abort();
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = "";
			};
	
			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '"+Baby.DefaultDelimiter+"'");
					_delimiterError = false;
				}
	
				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length == 1 && _results.data[i][0] == "")
							_results.data.splice(i--, 1);
				}
	
				if (needsHeaderRow())
					fillHeaderFields();
	
				return applyHeaderAndDynamicTyping();
			}
	
			function needsHeaderRow()
			{
				return _config.header && _fields.length == 0;
			}
	
			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}
	
			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;
	
				for (var i = 0; i < _results.data.length; i++)
				{
					var row = {};
	
					for (var j = 0; j < _results.data[i].length; j++)
					{
						if (_config.dynamicTyping)
						{
							var value = _results.data[i][j];
							if (value == "true" || value === "TRUE")
								_results.data[i][j] = true;
							else if (value == "false" || value === "FALSE")
								_results.data[i][j] = false;
							else
								_results.data[i][j] = tryParseFloat(value);
						}
	
						if (_config.header)
						{
							if (j >= _fields.length)
							{
								if (!row["__parsed_extra"])
									row["__parsed_extra"] = [];
								row["__parsed_extra"].push(_results.data[i][j]);
							}
							else
								row[_fields[j]] = _results.data[i][j];
						}
					}
	
					if (_config.header)
					{
						_results.data[i] = row;
						if (j > _fields.length)
							addError("FieldMismatch", "TooManyFields", "Too many fields: expected " + _fields.length + " fields but parsed " + j, i);
						else if (j < _fields.length)
							addError("FieldMismatch", "TooFewFields", "Too few fields: expected " + _fields.length + " fields but parsed " + j, i);
					}
				}
	
				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}
	
			function guessDelimiter(input)
			{
				var delimChoices = [",", "\t", "|", ";", Baby.RECORD_SEP, Baby.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;
	
				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0;
					fieldCountPrevRow = undefined;
	
					var preview = new Parser({
						delimiter: delim,
						preview: 10
					}).parse(input);
	
					for (var j = 0; j < preview.data.length; j++)
					{
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;
	
						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}
	
					avgFieldCount /= preview.data.length;
	
					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}
	
				_config.delimiter = bestDelim;
	
				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}
	
			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB
	
				var r = input.split('\r');
	
				if (r.length == 1)
					return '\n';
	
				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] == '\n')
						numWithN++;
				}
	
				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}
	
			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}
	
			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}
	
	
	
	
	
	
		// The core parser implements speedy and correct CSV parsing
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;
	
			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| delim.length != 1
				|| Baby.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ",";
	
			// Comment character must be valid
			if (comments === delim)
				throw "Comment character same as delimiter";
			else if (comments === true)
				comments = "#";
			else if (typeof comments !== 'string'
				|| Baby.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;
	
			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';
	
			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;
	
			this.parse = function(input)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw "Input must be a string";
	
				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = typeof step === 'function';
	
				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [];
	
				if (!input)
					return returnable();
	
				if (fastMode)
				{
					// Fast mode assumes there are no quoted fields in the input
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						if (comments && rows[i].substr(0, commentsLen) == comments)
							continue;
						if (stepIsFunction)
						{
							data = [ rows[i].split(delim) ];
							doStep();
							if (aborted)
								return returnable();
						}
						else
							data.push(rows[i].split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}
	
				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);
	
				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] == '"')
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;
	
						// Skip the opening quote
						cursor++;
	
						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf('"', quoteSearch+1);
	
							if (quoteSearch === -1)
							{
								// No closing quote... what a pity
								errors.push({
									type: "Quotes",
									code: "MissingQuotes",
									message: "Quoted field unterminated",
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
								return finish();
							}
	
							if (quoteSearch === inputLen-1)
							{
								// Closing quote at EOF
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								data.push(row);
								if (stepIsFunction)
									doStep();
								return returnable();
							}
	
							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] == '"')
							{
								quoteSearch++;
								continue;
							}
	
							if (input[quoteSearch+1] == delim)
							{
								// Closing quote followed by delimiter
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}
	
							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								// Closing quote followed by newline
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field
	
								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
								
								if (preview && data.length >= preview)
									return returnable(true);
	
								break;
							}
						}
	
						continue;
					}
	
					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline == -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}
	
					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);
	
						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}
	
						if (preview && data.length >= preview)
							return returnable(true);
	
						continue;
					}
	
					break;
				}
	
	
				return finish();
	
	
				// Appends the remaining input from cursor to the end into
				// row, saves the row, calls step, and returns the results.
				function finish()
				{
					row.push(input.substr(cursor));
					data.push(row);
					cursor = inputLen;	// important in case parsing is paused
					if (stepIsFunction)
						doStep();
					return returnable();
				}
	
				// Appends the current row to the results. It sets the cursor
				// to newCursor and finds the nextNewline. The caller should
				// take care to execute user's step function and check for
				// preview and end parsing if necessary.
				function saveRow(newCursor)
				{
					data.push(row);
					row = [];
					cursor = newCursor;
					nextNewline = input.indexOf(newline, cursor);
				}
	
				// Returns an object with the results, errors, and meta.
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped
						}
					};
				}
	
				// Executes the user's step function and resets data & errors.
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};
	
			// Sets the abort flag
			this.abort = function()
			{
				aborted = true;
			};
	
			// Gets the cursor position
			this.getCharIndex = function()
			{
				return cursor;
			};
		}
	
	
	
	
		// Replaces bad config values with good, default ones
		function copyAndValidateConfig(origConfig)
		{
			if (typeof origConfig !== 'object')
				origConfig = {};
	
			var config = copy(origConfig);
	
			if (typeof config.delimiter !== 'string'
				|| config.delimiter.length != 1
				|| Baby.BAD_DELIMITERS.indexOf(config.delimiter) > -1)
				config.delimiter = DEFAULTS.delimiter;
	
			if (config.newline != '\n'
				&& config.newline != '\r'
				&& config.newline != '\r\n')
				config.newline = DEFAULTS.newline;
	
			if (typeof config.header !== 'boolean')
				config.header = DEFAULTS.header;
	
			if (typeof config.dynamicTyping !== 'boolean')
				config.dynamicTyping = DEFAULTS.dynamicTyping;
	
			if (typeof config.preview !== 'number')
				config.preview = DEFAULTS.preview;
	
			if (typeof config.step !== 'function')
				config.step = DEFAULTS.step;
	
			if (typeof config.complete !== 'function')
				config.complete = DEFAULTS.complete;
	
			if (typeof config.skipEmptyLines !== 'boolean')
				config.skipEmptyLines = DEFAULTS.skipEmptyLines;
	
			if (typeof config.fastMode !== 'boolean')
				config.fastMode = DEFAULTS.fastMode;
	
			return config;
		}
	
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}
	
		function isFunction(func)
		{
			return typeof func === 'function';
		}
	
	
	
	
	
	
		// export to Node...
		if ( typeof module !== 'undefined' && module.exports ) {
			module.exports = Baby;
		}
	
		// ...or as AMD module...
		else if ( true ) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return Baby; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		// ...or as browser global
		else {
			global.Baby = Baby;
		}
	
	})(typeof window !== 'undefined' ? window : this);


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(192).Buffer))

/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports={
		"jet":[{"index":0,"rgb":[0,0,131]},{"index":0.125,"rgb":[0,60,170]},{"index":0.375,"rgb":[5,255,255]},{"index":0.625,"rgb":[255,255,0]},{"index":0.875,"rgb":[250,0,0]},{"index":1,"rgb":[128,0,0]}],
	
		"hsv":[{"index":0,"rgb":[255,0,0]},{"index":0.169,"rgb":[253,255,2]},{"index":0.173,"rgb":[247,255,2]},{"index":0.337,"rgb":[0,252,4]},{"index":0.341,"rgb":[0,252,10]},{"index":0.506,"rgb":[1,249,255]},{"index":0.671,"rgb":[2,0,253]},{"index":0.675,"rgb":[8,0,253]},{"index":0.839,"rgb":[255,0,251]},{"index":0.843,"rgb":[255,0,245]},{"index":1,"rgb":[255,0,6]}],
	
		"hot":[{"index":0,"rgb":[0,0,0]},{"index":0.3,"rgb":[230,0,0]},{"index":0.6,"rgb":[255,210,0]},{"index":1,"rgb":[255,255,255]}],
	
		"cool":[{"index":0,"rgb":[0,255,255]},{"index":1,"rgb":[255,0,255]}],
	
		"spring":[{"index":0,"rgb":[255,0,255]},{"index":1,"rgb":[255,255,0]}],
	
		"summer":[{"index":0,"rgb":[0,128,102]},{"index":1,"rgb":[255,255,102]}],
	
		"autumn":[{"index":0,"rgb":[255,0,0]},{"index":1,"rgb":[255,255,0]}],
	
		"winter":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[0,255,128]}],
	
		"bone":[{"index":0,"rgb":[0,0,0]},{"index":0.376,"rgb":[84,84,116]},{"index":0.753,"rgb":[169,200,200]},{"index":1,"rgb":[255,255,255]}],
	
		"copper":[{"index":0,"rgb":[0,0,0]},{"index":0.804,"rgb":[255,160,102]},{"index":1,"rgb":[255,199,127]}],
	
		"greys":[{"index":0,"rgb":[0,0,0]},{"index":1,"rgb":[255,255,255]}],
	
		"yignbu":[{"index":0,"rgb":[8,29,88]},{"index":0.125,"rgb":[37,52,148]},{"index":0.25,"rgb":[34,94,168]},{"index":0.375,"rgb":[29,145,192]},{"index":0.5,"rgb":[65,182,196]},{"index":0.625,"rgb":[127,205,187]},{"index":0.75,"rgb":[199,233,180]},{"index":0.875,"rgb":[237,248,217]},{"index":1,"rgb":[255,255,217]}],
	
		"greens":[{"index":0,"rgb":[0,68,27]},{"index":0.125,"rgb":[0,109,44]},{"index":0.25,"rgb":[35,139,69]},{"index":0.375,"rgb":[65,171,93]},{"index":0.5,"rgb":[116,196,118]},{"index":0.625,"rgb":[161,217,155]},{"index":0.75,"rgb":[199,233,192]},{"index":0.875,"rgb":[229,245,224]},{"index":1,"rgb":[247,252,245]}],
	
		"yiorrd":[{"index":0,"rgb":[128,0,38]},{"index":0.125,"rgb":[189,0,38]},{"index":0.25,"rgb":[227,26,28]},{"index":0.375,"rgb":[252,78,42]},{"index":0.5,"rgb":[253,141,60]},{"index":0.625,"rgb":[254,178,76]},{"index":0.75,"rgb":[254,217,118]},{"index":0.875,"rgb":[255,237,160]},{"index":1,"rgb":[255,255,204]}],
	
		"bluered":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[255,0,0]}],
	
		"rdbu":[{"index":0,"rgb":[5,10,172]},{"index":0.35,"rgb":[106,137,247]},{"index":0.5,"rgb":[190,190,190]},{"index":0.6,"rgb":[220,170,132]},{"index":0.7,"rgb":[230,145,90]},{"index":1,"rgb":[178,10,28]}],
	
		"picnic":[{"index":0,"rgb":[0,0,255]},{"index":0.1,"rgb":[51,153,255]},{"index":0.2,"rgb":[102,204,255]},{"index":0.3,"rgb":[153,204,255]},{"index":0.4,"rgb":[204,204,255]},{"index":0.5,"rgb":[255,255,255]},{"index":0.6,"rgb":[255,204,255]},{"index":0.7,"rgb":[255,153,255]},{"index":0.8,"rgb":[255,102,204]},{"index":0.9,"rgb":[255,102,102]},{"index":1,"rgb":[255,0,0]}],
	
		"rainbow":[{"index":0,"rgb":[150,0,90]},{"index":0.125,"rgb":[0,0,200]},{"index":0.25,"rgb":[0,25,255]},{"index":0.375,"rgb":[0,152,255]},{"index":0.5,"rgb":[44,255,150]},{"index":0.625,"rgb":[151,255,0]},{"index":0.75,"rgb":[255,234,0]},{"index":0.875,"rgb":[255,111,0]},{"index":1,"rgb":[255,0,0]}],
	
		"portland":[{"index":0,"rgb":[12,51,131]},{"index":0.25,"rgb":[10,136,186]},{"index":0.5,"rgb":[242,211,56]},{"index":0.75,"rgb":[242,143,56]},{"index":1,"rgb":[217,30,30]}],
	
		"blackbody":[{"index":0,"rgb":[0,0,0]},{"index":0.2,"rgb":[230,0,0]},{"index":0.4,"rgb":[230,210,0]},{"index":0.7,"rgb":[255,255,255]},{"index":1,"rgb":[160,200,255]}],
	
		"earth":[{"index":0,"rgb":[0,0,130]},{"index":0.1,"rgb":[0,180,180]},{"index":0.2,"rgb":[40,210,40]},{"index":0.4,"rgb":[230,230,50]},{"index":0.6,"rgb":[120,70,20]},{"index":1,"rgb":[255,255,255]}],
	
		"electric":[{"index":0,"rgb":[0,0,0]},{"index":0.15,"rgb":[30,0,100]},{"index":0.4,"rgb":[120,0,100]},{"index":0.6,"rgb":[160,90,0]},{"index":0.8,"rgb":[230,200,0]},{"index":1,"rgb":[255,250,220]}],
	
		"alpha": [{"index":0, "rgb": [255,255,255,0]},{"index":0, "rgb": [255,255,255,1]}],
	
		"viridis": [{"index":0,"rgb":[68,1,84]},{"index":0.13,"rgb":[71,44,122]},{"index":0.25,"rgb":[59,81,139]},{"index":0.38,"rgb":[44,113,142]},{"index":0.5,"rgb":[33,144,141]},{"index":0.63,"rgb":[39,173,129]},{"index":0.75,"rgb":[92,200,99]},{"index":0.88,"rgb":[170,220,50]},{"index":1,"rgb":[253,231,37]}],
	
		"inferno": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[31,12,72]},{"index":0.25,"rgb":[85,15,109]},{"index":0.38,"rgb":[136,34,106]},{"index":0.5,"rgb":[186,54,85]},{"index":0.63,"rgb":[227,89,51]},{"index":0.75,"rgb":[249,140,10]},{"index":0.88,"rgb":[249,201,50]},{"index":1,"rgb":[252,255,164]}],
	
		"magma": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[28,16,68]},{"index":0.25,"rgb":[79,18,123]},{"index":0.38,"rgb":[129,37,129]},{"index":0.5,"rgb":[181,54,122]},{"index":0.63,"rgb":[229,80,100]},{"index":0.75,"rgb":[251,135,97]},{"index":0.88,"rgb":[254,194,135]},{"index":1,"rgb":[252,253,191]}],
	
		"plasma": [{"index":0,"rgb":[13,8,135]},{"index":0.13,"rgb":[75,3,161]},{"index":0.25,"rgb":[125,3,168]},{"index":0.38,"rgb":[168,34,150]},{"index":0.5,"rgb":[203,70,121]},{"index":0.63,"rgb":[229,107,93]},{"index":0.75,"rgb":[248,148,65]},{"index":0.88,"rgb":[253,195,40]},{"index":1,"rgb":[240,249,33]}],
	
		"warm": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[172,0,187]},{"index":0.25,"rgb":[219,0,170]},{"index":0.38,"rgb":[255,0,130]},{"index":0.5,"rgb":[255,63,74]},{"index":0.63,"rgb":[255,123,0]},{"index":0.75,"rgb":[234,176,0]},{"index":0.88,"rgb":[190,228,0]},{"index":1,"rgb":[147,255,0]}],
	
		"cool": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[116,0,218]},{"index":0.25,"rgb":[98,74,237]},{"index":0.38,"rgb":[68,146,231]},{"index":0.5,"rgb":[0,204,197]},{"index":0.63,"rgb":[0,247,146]},{"index":0.75,"rgb":[0,255,88]},{"index":0.88,"rgb":[40,255,8]},{"index":1,"rgb":[147,255,0]}],
	
		"rainbow-soft": [{"index":0,"rgb":[125,0,179]},{"index":0.1,"rgb":[199,0,180]},{"index":0.2,"rgb":[255,0,121]},{"index":0.3,"rgb":[255,108,0]},{"index":0.4,"rgb":[222,194,0]},{"index":0.5,"rgb":[150,255,0]},{"index":0.6,"rgb":[0,255,55]},{"index":0.7,"rgb":[0,246,150]},{"index":0.8,"rgb":[50,167,222]},{"index":0.9,"rgb":[103,51,235]},{"index":1,"rgb":[124,0,186]}],
	
		"bathymetry": [{"index":0,"rgb":[40,26,44]},{"index":0.13,"rgb":[59,49,90]},{"index":0.25,"rgb":[64,76,139]},{"index":0.38,"rgb":[63,110,151]},{"index":0.5,"rgb":[72,142,158]},{"index":0.63,"rgb":[85,174,163]},{"index":0.75,"rgb":[120,206,163]},{"index":0.88,"rgb":[187,230,172]},{"index":1,"rgb":[253,254,204]}],
	
		"cdom": [{"index":0,"rgb":[47,15,62]},{"index":0.13,"rgb":[87,23,86]},{"index":0.25,"rgb":[130,28,99]},{"index":0.38,"rgb":[171,41,96]},{"index":0.5,"rgb":[206,67,86]},{"index":0.63,"rgb":[230,106,84]},{"index":0.75,"rgb":[242,149,103]},{"index":0.88,"rgb":[249,193,135]},{"index":1,"rgb":[254,237,176]}],
	
		"chlorophyll": [{"index":0,"rgb":[18,36,20]},{"index":0.13,"rgb":[25,63,41]},{"index":0.25,"rgb":[24,91,59]},{"index":0.38,"rgb":[13,119,72]},{"index":0.5,"rgb":[18,148,80]},{"index":0.63,"rgb":[80,173,89]},{"index":0.75,"rgb":[132,196,122]},{"index":0.88,"rgb":[175,221,162]},{"index":1,"rgb":[215,249,208]}],
	
		"density": [{"index":0,"rgb":[54,14,36]},{"index":0.13,"rgb":[89,23,80]},{"index":0.25,"rgb":[110,45,132]},{"index":0.38,"rgb":[120,77,178]},{"index":0.5,"rgb":[120,113,213]},{"index":0.63,"rgb":[115,151,228]},{"index":0.75,"rgb":[134,185,227]},{"index":0.88,"rgb":[177,214,227]},{"index":1,"rgb":[230,241,241]}],
	
		"freesurface-blue": [{"index":0,"rgb":[30,4,110]},{"index":0.13,"rgb":[47,14,176]},{"index":0.25,"rgb":[41,45,236]},{"index":0.38,"rgb":[25,99,212]},{"index":0.5,"rgb":[68,131,200]},{"index":0.63,"rgb":[114,156,197]},{"index":0.75,"rgb":[157,181,203]},{"index":0.88,"rgb":[200,208,216]},{"index":1,"rgb":[241,237,236]}],
	
		"freesurface-red": [{"index":0,"rgb":[60,9,18]},{"index":0.13,"rgb":[100,17,27]},{"index":0.25,"rgb":[142,20,29]},{"index":0.38,"rgb":[177,43,27]},{"index":0.5,"rgb":[192,87,63]},{"index":0.63,"rgb":[205,125,105]},{"index":0.75,"rgb":[216,162,148]},{"index":0.88,"rgb":[227,199,193]},{"index":1,"rgb":[241,237,236]}],
	
		"oxygen": [{"index":0,"rgb":[64,5,5]},{"index":0.13,"rgb":[106,6,15]},{"index":0.25,"rgb":[144,26,7]},{"index":0.38,"rgb":[168,64,3]},{"index":0.5,"rgb":[188,100,4]},{"index":0.63,"rgb":[206,136,11]},{"index":0.75,"rgb":[220,174,25]},{"index":0.88,"rgb":[231,215,44]},{"index":1,"rgb":[248,254,105]}],
	
		"par": [{"index":0,"rgb":[51,20,24]},{"index":0.13,"rgb":[90,32,35]},{"index":0.25,"rgb":[129,44,34]},{"index":0.38,"rgb":[159,68,25]},{"index":0.5,"rgb":[182,99,19]},{"index":0.63,"rgb":[199,134,22]},{"index":0.75,"rgb":[212,171,35]},{"index":0.88,"rgb":[221,210,54]},{"index":1,"rgb":[225,253,75]}],
	
		"phase": [{"index":0,"rgb":[145,105,18]},{"index":0.13,"rgb":[184,71,38]},{"index":0.25,"rgb":[186,58,115]},{"index":0.38,"rgb":[160,71,185]},{"index":0.5,"rgb":[110,97,218]},{"index":0.63,"rgb":[50,123,164]},{"index":0.75,"rgb":[31,131,110]},{"index":0.88,"rgb":[77,129,34]},{"index":1,"rgb":[145,105,18]}],
	
		"salinity": [{"index":0,"rgb":[42,24,108]},{"index":0.13,"rgb":[33,50,162]},{"index":0.25,"rgb":[15,90,145]},{"index":0.38,"rgb":[40,118,137]},{"index":0.5,"rgb":[59,146,135]},{"index":0.63,"rgb":[79,175,126]},{"index":0.75,"rgb":[120,203,104]},{"index":0.88,"rgb":[193,221,100]},{"index":1,"rgb":[253,239,154]}],
	
		"temperature": [{"index":0,"rgb":[4,35,51]},{"index":0.13,"rgb":[23,51,122]},{"index":0.25,"rgb":[85,59,157]},{"index":0.38,"rgb":[129,79,143]},{"index":0.5,"rgb":[175,95,130]},{"index":0.63,"rgb":[222,112,101]},{"index":0.75,"rgb":[249,146,66]},{"index":0.88,"rgb":[249,196,65]},{"index":1,"rgb":[232,250,91]}],
	
		"turbidity": [{"index":0,"rgb":[34,31,27]},{"index":0.13,"rgb":[65,50,41]},{"index":0.25,"rgb":[98,69,52]},{"index":0.38,"rgb":[131,89,57]},{"index":0.5,"rgb":[161,112,59]},{"index":0.63,"rgb":[185,140,66]},{"index":0.75,"rgb":[202,174,88]},{"index":0.88,"rgb":[216,209,126]},{"index":1,"rgb":[233,246,171]}],
	
		"velocity-blue": [{"index":0,"rgb":[17,32,64]},{"index":0.13,"rgb":[35,52,116]},{"index":0.25,"rgb":[29,81,156]},{"index":0.38,"rgb":[31,113,162]},{"index":0.5,"rgb":[50,144,169]},{"index":0.63,"rgb":[87,173,176]},{"index":0.75,"rgb":[149,196,189]},{"index":0.88,"rgb":[203,221,211]},{"index":1,"rgb":[254,251,230]}],
	
		"velocity-green": [{"index":0,"rgb":[23,35,19]},{"index":0.13,"rgb":[24,64,38]},{"index":0.25,"rgb":[11,95,45]},{"index":0.38,"rgb":[39,123,35]},{"index":0.5,"rgb":[95,146,12]},{"index":0.63,"rgb":[152,165,18]},{"index":0.75,"rgb":[201,186,69]},{"index":0.88,"rgb":[233,216,137]},{"index":1,"rgb":[255,253,205]}],
	
		"cubehelix": [{"index":0,"rgb":[0,0,0]},{"index":0.07,"rgb":[22,5,59]},{"index":0.13,"rgb":[60,4,105]},{"index":0.2,"rgb":[109,1,135]},{"index":0.27,"rgb":[161,0,147]},{"index":0.33,"rgb":[210,2,142]},{"index":0.4,"rgb":[251,11,123]},{"index":0.47,"rgb":[255,29,97]},{"index":0.53,"rgb":[255,54,69]},{"index":0.6,"rgb":[255,85,46]},{"index":0.67,"rgb":[255,120,34]},{"index":0.73,"rgb":[255,157,37]},{"index":0.8,"rgb":[241,191,57]},{"index":0.87,"rgb":[224,220,93]},{"index":0.93,"rgb":[218,241,142]},{"index":1,"rgb":[227,253,198]}]
	};


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Ben Postlethwaite
	 * January 2013
	 * License MIT
	 */
	'use strict';
	
	var at = __webpack_require__(213);
	var clone = __webpack_require__(224);
	var colorScale = __webpack_require__(225);
	
	module.exports = createColormap;
	
	function createColormap (spec) {
	    /*
	     * Default Options
	     */
	    var indicies, rgba, fromrgba, torgba,
	        nsteps, cmap, colormap, format,
	        nshades, colors, alpha, index, i,
	        r = [],
	        g = [],
	        b = [],
	        a = [];
	
	    if ( !at.isPlainObject(spec) ) spec = {};
	
	    nshades = spec.nshades || 72;
	    format = spec.format || 'hex';
	
	    colormap = spec.colormap;
	    if (!colormap) colormap = 'jet';
	
	    if (typeof colormap === 'string') {
	        colormap = colormap.toLowerCase();
	
	        if (!colorScale[colormap]) {
	            throw Error(colormap + ' not a supported colorscale');
	        }
	
	        cmap = clone(colorScale[colormap]);
	
	    } else if (Array.isArray(colormap)) {
	        cmap = clone(colormap);
	
	    } else {
	        throw Error('unsupported colormap option', colormap);
	    }
	
	    if (cmap.length > nshades) {
	        throw new Error(
	            colormap+' map requires nshades to be at least size '+cmap.length
	        );
	    }
	
	    if (!Array.isArray(spec.alpha)) {
	
	        if (typeof spec.alpha === 'number') {
	            alpha = [spec.alpha, spec.alpha];
	
	        } else {
	            alpha = [1, 1];
	        }
	
	    } else if (spec.alpha.length !== 2) {
	        alpha = [1, 1];
	
	    } else {
	        alpha = clone(spec.alpha);
	    }
	
	    /*
	     * map index points from 0->1 to 0 -> n-1
	     */
	    indicies = cmap.map(function(c) {
	        return Math.round(c.index * nshades);
	    });
	
	    /*
	     * Add alpha channel to the map
	     */
	    if (alpha[0] < 0) alpha[0] = 0;
	    if (alpha[1] < 0) alpha[0] = 0;
	    if (alpha[0] > 1) alpha[0] = 1;
	    if (alpha[1] > 1) alpha[0] = 1;
	
	    for (i = 0; i < indicies.length; ++i) {
	        index = cmap[i].index;
	        rgba = cmap[i].rgb;
	
	        // if user supplies their own map use it
	        if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) continue;
	        rgba[3] = alpha[0] + (alpha[1] - alpha[0])*index;
	    }
	
	    /*
	     * map increasing linear values between indicies to
	     * linear steps in colorvalues
	     */
	    for (i = 0; i < indicies.length-1; ++i) {
	        nsteps = indicies[i+1] - indicies[i];
	        fromrgba = cmap[i].rgb;
	        torgba = cmap[i+1].rgb;
	        r = r.concat(at.linspace(fromrgba[0], torgba[0], nsteps ) );
	        g = g.concat(at.linspace(fromrgba[1], torgba[1], nsteps ) );
	        b = b.concat(at.linspace(fromrgba[2], torgba[2], nsteps ) );
	        a = a.concat(at.linspace(fromrgba[3], torgba[3], nsteps ) );
	    }
	
	    r = r.map( Math.round );
	    g = g.map( Math.round );
	    b = b.map( Math.round );
	
	    colors = at.zip(r, g, b, a);
	
	    if (format === 'hex') colors = colors.map( rgb2hex );
	    if (format === 'rgbaString') colors = colors.map( rgbaStr );
	
	    return colors;
	};
	
	
	function rgb2hex (rgba) {
	    var dig, hex = '#';
	    for (var i = 0; i < 3; ++i) {
	        dig = rgba[i];
	        dig = dig.toString(16);
	        hex += ('00' + dig).substr( dig.length );
	    }
	    return hex;
	}
	
	function rgbaStr (rgba) {
	    return 'rgba(' + rgba.join(',') + ')';
	}


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(129);
	} catch (err) {
	  var index = __webpack_require__(129);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	__webpack_require__(298);
	__webpack_require__(300);
	module.exports = __webpack_require__(53).WeakMap;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	__webpack_require__(259);
	module.exports = __webpack_require__(14).Array.from;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(261);
	module.exports = __webpack_require__(14).Object.assign;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(262);
	var $Object = __webpack_require__(14).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(263);
	var $Object = __webpack_require__(14).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(264);
	var $Object = __webpack_require__(14).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(265);
	module.exports = __webpack_require__(14).Object.getPrototypeOf;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(266);
	module.exports = __webpack_require__(14).Object.setPrototypeOf;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(268);
	__webpack_require__(267);
	__webpack_require__(269);
	__webpack_require__(270);
	module.exports = __webpack_require__(14).Symbol;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	__webpack_require__(271);
	module.exports = __webpack_require__(93).f('iterator');


/***/ },
/* 238 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 239 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 240 */
[495, 32, 139, 257],
/* 241 */
[496, 80, 20],
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(29);
	var createDesc = __webpack_require__(52);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(62);
	var gOPS = __webpack_require__(86);
	var pIE = __webpack_require__(63);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 244 */
[501, 28],
/* 245 */
[504, 51, 20],
/* 246 */
[505, 80],
/* 247 */
[506, 38],
/* 248 */
[507, 84, 52, 87, 40, 20],
/* 249 */
[509, 20],
/* 250 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 251 */
[510, 65, 41, 31, 29, 39],
/* 252 */
[511, 62, 86, 63, 64, 132, 39],
/* 253 */
[514, 29, 38, 62, 30],
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(134).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 255 */
[519, 41, 38, 81, 85],
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(90);
	var defined = __webpack_require__(82);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 257 */
[523, 90],
/* 258 */
[529, 241, 20, 51, 14],
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(81);
	var $export = __webpack_require__(27);
	var toObject = __webpack_require__(64);
	var call = __webpack_require__(247);
	var isArrayIter = __webpack_require__(245);
	var toLength = __webpack_require__(139);
	var createProperty = __webpack_require__(242);
	var getIterFn = __webpack_require__(258);
	
	$export($export.S + $export.F * !__webpack_require__(249)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 260 */
[530, 239, 250, 51, 32, 133],
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(27);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(252) });


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(27);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(84) });


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(27);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(30), 'Object', { defineProperty: __webpack_require__(29).f });


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(32);
	var $getOwnPropertyDescriptor = __webpack_require__(85).f;
	
	__webpack_require__(137)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(64);
	var $getPrototypeOf = __webpack_require__(135);
	
	__webpack_require__(137)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(27);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(255).set });


/***/ },
/* 267 */
/***/ function(module, exports) {



/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(28);
	var has = __webpack_require__(31);
	var DESCRIPTORS = __webpack_require__(30);
	var $export = __webpack_require__(27);
	var redefine = __webpack_require__(138);
	var META = __webpack_require__(251).KEY;
	var $fails = __webpack_require__(39);
	var shared = __webpack_require__(89);
	var setToStringTag = __webpack_require__(87);
	var uid = __webpack_require__(65);
	var wks = __webpack_require__(20);
	var wksExt = __webpack_require__(93);
	var wksDefine = __webpack_require__(92);
	var enumKeys = __webpack_require__(243);
	var isArray = __webpack_require__(246);
	var anObject = __webpack_require__(38);
	var isObject = __webpack_require__(41);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(91);
	var createDesc = __webpack_require__(52);
	var _create = __webpack_require__(84);
	var gOPNExt = __webpack_require__(254);
	var $GOPD = __webpack_require__(85);
	var $DP = __webpack_require__(29);
	var $keys = __webpack_require__(62);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(134).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(63).f = $propertyIsEnumerable;
	  __webpack_require__(86).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(61)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(92)('asyncIterator');


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(92)('observable');


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(260);
	var global = __webpack_require__(28);
	var hide = __webpack_require__(40);
	var Iterators = __webpack_require__(51);
	var TO_STRING_TAG = __webpack_require__(20)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 272 */
238,
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(21)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(55)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 274 */
[495, 69, 100, 296],
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16);
	var isArray = __webpack_require__(282);
	var SPECIES = __webpack_require__(21)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(275);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(153);
	var getWeak = __webpack_require__(96).getWeak;
	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(16);
	var anInstance = __webpack_require__(141);
	var forOf = __webpack_require__(148);
	var createArrayMethod = __webpack_require__(142);
	var $has = __webpack_require__(35);
	var validate = __webpack_require__(157);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(34);
	var $export = __webpack_require__(147);
	var redefine = __webpack_require__(43);
	var redefineAll = __webpack_require__(153);
	var meta = __webpack_require__(96);
	var forOf = __webpack_require__(148);
	var anInstance = __webpack_require__(141);
	var isObject = __webpack_require__(16);
	var fails = __webpack_require__(42);
	var $iterDetect = __webpack_require__(286);
	var setToStringTag = __webpack_require__(98);
	var inheritIfRequired = __webpack_require__(280);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 279 */
[501, 34],
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(16);
	var setPrototypeOf = __webpack_require__(295).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 281 */
[504, 67, 21],
/* 282 */
[505, 94],
/* 283 */
[506, 33],
/* 284 */
[507, 289, 97, 98, 55, 21],
/* 285 */
[508, 150, 147, 43, 55, 67, 284, 98, 293, 21],
/* 286 */
[509, 21],
/* 287 */
250,
/* 288 */
[511, 151, 292, 152, 101, 95, 42],
/* 289 */
[512, 33, 290, 146, 99, 145, 279],
/* 290 */
[514, 68, 33, 151, 54],
/* 291 */
[515, 152, 97, 69, 156, 35, 149, 54],
/* 292 */
86,
/* 293 */
[516, 35, 101, 99],
/* 294 */
[517, 35, 69, 274, 99],
/* 295 */
[519, 16, 33, 66, 291],
/* 296 */
[523, 155],
/* 297 */
[529, 143, 21, 67, 53],
/* 298 */
[530, 273, 287, 67, 69, 285],
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(143);
	var test = {};
	test[__webpack_require__(21)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(43)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(142)(0);
	var redefine = __webpack_require__(43);
	var meta = __webpack_require__(96);
	var assign = __webpack_require__(288);
	var weak = __webpack_require__(277);
	var isObject = __webpack_require__(16);
	var fails = __webpack_require__(42);
	var validate = __webpack_require__(157);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(278)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 301 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(79);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(301);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(227);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2['default'].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2['default'].mix(pos, size);
	}
	
	exports['default'] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _align = __webpack_require__(158);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _getOffsetParent = __webpack_require__(159);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(161);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _getRegion = __webpack_require__(160);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isOutOfVisibleRect(target) {
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(target);
	  var targetRegion = (0, _getRegion2['default'])(target);
	
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = (0, _getRegion2['default'])(target);
	
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
	
	  return (0, _align2['default'])(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = _getOffsetParent2['default'];
	
	alignElement.__getVisibleRectForElement = _getVisibleRectForElement2['default'];
	
	exports['default'] = alignElement;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _align = __webpack_require__(158);
	
	var _align2 = _interopRequireDefault(_align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX = void 0;
	  var pageY = void 0;
	
	  var doc = _utils2['default'].getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	
	  return (0, _align2['default'])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
	}
	
	exports['default'] = alignPoint;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports['default'] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(306);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = (0, _getAlignOffset2['default'])(refNodeRegion, points[1]);
	  var p2 = (0, _getAlignOffset2['default'])(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
	    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports['default'] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignPoint = exports.alignElement = undefined;
	
	var _alignElement = __webpack_require__(304);
	
	var _alignElement2 = _interopRequireDefault(_alignElement);
	
	var _alignPoint = __webpack_require__(305);
	
	var _alignPoint2 = _interopRequireDefault(_alignPoint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.alignElement = _alignElement2['default'];
	exports.alignPoint = _alignPoint2['default'];
	exports['default'] = _alignElement2['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAncestorFixed;
	
	var _utils = __webpack_require__(36);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAncestorFixed(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    var positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(311);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(321);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	var createArrayFromMixed = __webpack_require__(314);
	var getMarkupWrap = __webpack_require__(316);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 318 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(318);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 320 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(320);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 322 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(325);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 325 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(323)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(308);
	
	var _addEventListener = __webpack_require__(71);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Align.prototype.componentDidMount = function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      var source = _reactDom2['default'].findDOMNode(this);
	      var sourceRect = source ? source.getBoundingClientRect() : null;
	
	      if (prevProps.disabled) {
	        reAlign = true;
	      } else {
	        var lastElement = getElement(prevProps.target);
	        var currentElement = getElement(props.target);
	        var lastPoint = getPoint(prevProps.target);
	        var currentPoint = getPoint(props.target);
	
	        if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	          // Skip if is window
	          reAlign = false;
	        } else if (lastElement !== currentElement || // Element change
	        lastElement && !currentElement && currentPoint || // Change from element to point
	        lastPoint && currentPoint && currentElement || // Change from point to element
	        currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	          reAlign = true;
	        }
	
	        // If source element size changed
	        var preRect = this.sourceRect || {};
	        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
	          reAlign = true;
	        }
	      }
	
	      this.sourceRect = sourceRect;
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  };
	
	  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	    }
	  };
	
	  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  };
	
	  Align.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      var propList = Object.keys(childrenProps);
	      propList.forEach(function (prop) {
	        newProps[prop] = _this2.props[childrenProps[prop]];
	      });
	
	      return _react2['default'].cloneElement(child, newProps);
	    }
	    return child;
	  };
	
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Align = __webpack_require__(327);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChildrenUtils = __webpack_require__(333);
	
	var _AnimateChild = __webpack_require__(331);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _CSSMotion = __webpack_require__(332);
	
	var _CSSMotion2 = _interopRequireDefault(_CSSMotion);
	
	var _animate = __webpack_require__(165);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  } // eslint-disable-line
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.CSSMotion = _CSSMotion2['default'];
	Animate.propTypes = {
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = Animate;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(302);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(165);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotion = genCSSMotion;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(417);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(326);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _motion = __webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_NONE = 'none';
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(transitionSupport) {
	  function isSupportTransition(props) {
	    return !!(props.motionName && transitionSupport);
	  }
	
	  var CSSMotion = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotion, _React$Component);
	
	    function CSSMotion() {
	      (0, _classCallCheck3['default'])(this, CSSMotion);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));
	
	      _this.onDomUpdate = function () {
	        var _this$state = _this.state,
	            status = _this$state.status,
	            newStatus = _this$state.newStatus;
	        var _this$props = _this.props,
	            onAppearStart = _this$props.onAppearStart,
	            onEnterStart = _this$props.onEnterStart,
	            onLeaveStart = _this$props.onLeaveStart,
	            onAppearActive = _this$props.onAppearActive,
	            onEnterActive = _this$props.onEnterActive,
	            onLeaveActive = _this$props.onLeaveActive,
	            motionAppear = _this$props.motionAppear,
	            motionEnter = _this$props.motionEnter,
	            motionLeave = _this$props.motionLeave;
	
	
	        if (!isSupportTransition(_this.props)) {
	          return;
	        }
	
	        // Event injection
	        var $ele = _reactDom2['default'].findDOMNode(_this);
	        if (_this.$ele !== $ele) {
	          _this.removeEventListener(_this.$ele);
	          _this.addEventListener($ele);
	          _this.$ele = $ele;
	        }
	
	        // Init status
	        if (newStatus && status === STATUS_APPEAR && motionAppear) {
	          _this.updateStatus(onAppearStart, null, null, function () {
	            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
	          });
	        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
	          _this.updateStatus(onEnterStart, null, null, function () {
	            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
	          });
	        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
	          _this.updateStatus(onLeaveStart, null, null, function () {
	            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
	          });
	        }
	      };
	
	      _this.onMotionEnd = function (event) {
	        var _this$state2 = _this.state,
	            status = _this$state2.status,
	            statusActive = _this$state2.statusActive;
	        var _this$props2 = _this.props,
	            onAppearEnd = _this$props2.onAppearEnd,
	            onEnterEnd = _this$props2.onEnterEnd,
	            onLeaveEnd = _this$props2.onLeaveEnd;
	
	        if (status === STATUS_APPEAR && statusActive) {
	          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_ENTER && statusActive) {
	          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_LEAVE && statusActive) {
	          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
	        }
	      };
	
	      _this.addEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.addEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.addEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.removeEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.removeEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.removeEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
	        var statusStyle = styleFunc ? styleFunc(_reactDom2['default'].findDOMNode(_this), event) : null;
	
	        if (statusStyle === false || _this._destroyed) return;
	
	        var nextStep = void 0;
	        if (callback) {
	          nextStep = function nextStep() {
	            _this.nextFrame(callback);
	          };
	        }
	
	        _this.setState((0, _extends3['default'])({
	          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
	          newStatus: false
	        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
	      };
	
	      _this.updateActiveStatus = function (styleFunc, currentStatus) {
	        // `setState` use `postMessage` to trigger at the end of frame.
	        // Let's use requestAnimationFrame to update new state in next frame.
	        _this.nextFrame(function () {
	          var status = _this.state.status;
	
	          if (status !== currentStatus) return;
	
	          _this.updateStatus(styleFunc, { statusActive: true });
	        });
	      };
	
	      _this.nextFrame = function (func) {
	        _this.cancelNextFrame();
	        _this.raf = (0, _raf2['default'])(func);
	      };
	
	      _this.cancelNextFrame = function () {
	        if (_this.raf) {
	          _raf2['default'].cancel(_this.raf);
	          _this.raf = null;
	        }
	      };
	
	      _this.state = {
	        status: STATUS_NONE,
	        statusActive: false,
	        newStatus: false,
	        statusStyle: null
	      };
	      _this.$ele = null;
	      _this.raf = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(CSSMotion, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._destroyed = true;
	        this.removeEventListener(this.$ele);
	        this.cancelNextFrame();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _state = this.state,
	            status = _state.status,
	            statusActive = _state.statusActive,
	            statusStyle = _state.statusStyle;
	        var _props = this.props,
	            children = _props.children,
	            motionName = _props.motionName,
	            visible = _props.visible,
	            removeOnLeave = _props.removeOnLeave;
	
	
	        if (!children) return null;
	
	        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
	          return visible || !removeOnLeave ? children({}) : null;
	        }
	
	        return children({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	          style: statusStyle
	        });
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(props, _ref) {
	        var prevProps = _ref.prevProps;
	
	        if (!isSupportTransition(props)) return {};
	
	        var visible = props.visible,
	            motionAppear = props.motionAppear,
	            motionEnter = props.motionEnter,
	            motionLeave = props.motionLeave,
	            motionLeaveImmediately = props.motionLeaveImmediately;
	
	        var newState = {
	          prevProps: props
	        };
	
	        // Appear
	        if (!prevProps && visible && motionAppear) {
	          newState.status = STATUS_APPEAR;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Enter
	        if (prevProps && !prevProps.visible && visible && motionEnter) {
	          newState.status = STATUS_ENTER;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Leave
	        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
	          newState.status = STATUS_LEAVE;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        return newState;
	      }
	    }]);
	    return CSSMotion;
	  }(_react2['default'].Component);
	
	  CSSMotion.propTypes = {
	    visible: _propTypes2['default'].bool,
	    children: _propTypes2['default'].func,
	    motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    motionAppear: _propTypes2['default'].bool,
	    motionEnter: _propTypes2['default'].bool,
	    motionLeave: _propTypes2['default'].bool,
	    motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
	    removeOnLeave: _propTypes2['default'].bool,
	    onAppearStart: _propTypes2['default'].func,
	    onAppearActive: _propTypes2['default'].func,
	    onAppearEnd: _propTypes2['default'].func,
	    onEnterStart: _propTypes2['default'].func,
	    onEnterActive: _propTypes2['default'].func,
	    onEnterEnd: _propTypes2['default'].func,
	    onLeaveStart: _propTypes2['default'].func,
	    onLeaveActive: _propTypes2['default'].func,
	    onLeaveEnd: _propTypes2['default'].func
	  };
	  CSSMotion.defaultProps = {
	    visible: true,
	    motionEnter: true,
	    motionAppear: true,
	    motionLeave: true,
	    removeOnLeave: true
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);
	
	  return CSSMotion;
	}
	
	exports['default'] = genCSSMotion(_motion.supportTransition);

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.getTransitionName = getTransitionName;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	
	  return prefixes;
	}
	
	var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});
	
	var style = {};
	
	if (canUseDOM) {
	  style = document.createElement('div').style;
	}
	
	var prefixedEventNames = {};
	
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	
	  return '';
	}
	
	var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
	var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);
	
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	
	  if (typeof transitionName === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	
	  return transitionName + '-' + transitionType;
	}

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(128);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(493);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _Track = __webpack_require__(166);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(167);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(104);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Range = function (_React$Component) {
	  (0, _inherits3['default'])(Range, _React$Component);
	
	  function Range(props) {
	    (0, _classCallCheck3['default'])(this, Range);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({
	        handle: null
	      }, _this.blur);
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	
	    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v, i) {
	      return _this.trimAlignValue(v, i);
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Range, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	      if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
	        return;
	      }
	
	      var bounds = this.state.bounds;
	
	      var value = nextProps.value || bounds;
	      var nextBounds = value.map(function (v, i) {
	        return _this2.trimAlignValue(v, i, nextProps);
	      });
	      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
	        return v === bounds[i];
	      })) return;
	
	      this.setState({ bounds: nextBounds });
	
	      if (bounds.some(function (v) {
	        return utils.isValueOutOfRange(v, nextProps);
	      })) {
	        var newValues = value.map(function (v) {
	          return utils.ensureValueInRange(v, nextProps);
	        });
	        this.props.onChange(newValues);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      } else if (state.handle !== undefined) {
	        this.setState({ handle: state.handle });
	      }
	
	      var data = (0, _extends3['default'])({}, this.state, state);
	      var changedValue = data.bounds;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      var props = this.props;
	      var state = this.state;
	      var bounds = this.getValue();
	      props.onBeforeChange(bounds);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      var closestBound = this.getClosestBound(value);
	      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
	
	      this.setState({
	        handle: this.prevMovedHandleIndex,
	        recent: this.prevMovedHandleIndex
	      });
	
	      var prevValue = bounds[this.prevMovedHandleIndex];
	      if (value === prevValue) return;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      nextBounds[this.prevMovedHandleIndex] = value;
	      this.onChange({ bounds: nextBounds });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var state = this.state;
	
	      var value = this.calcValueByPos(position);
	      var oldValue = state.bounds[state.handle];
	      if (value === oldValue) return;
	
	      this.moveTo(value);
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var valueMutator = utils.getKeyboardValueMutator(e);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state,
	            props = this.props;
	        var bounds = state.bounds,
	            handle = state.handle;
	
	        var oldValue = bounds[handle];
	        var mutatedValue = valueMutator(oldValue, props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	        var isFromKeyboardEvent = true;
	        this.moveTo(value, isFromKeyboardEvent);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.bounds;
	    }
	  }, {
	    key: 'getClosestBound',
	    value: function getClosestBound(value) {
	      var bounds = this.state.bounds;
	
	      var closestBound = 0;
	      for (var i = 1; i < bounds.length - 1; ++i) {
	        if (value > bounds[i]) {
	          closestBound = i;
	        }
	      }
	      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	        closestBound += 1;
	      }
	      return closestBound;
	    }
	  }, {
	    key: 'getBoundNeedMoving',
	    value: function getBoundNeedMoving(value, closestBound) {
	      var _state = this.state,
	          bounds = _state.bounds,
	          recent = _state.recent;
	
	      var boundNeedMoving = closestBound;
	      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	
	      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
	        boundNeedMoving = recent;
	      }
	
	      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	      }
	      return boundNeedMoving;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.state.bounds[0];
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      var bounds = this.state.bounds;
	
	      return bounds[bounds.length - 1];
	    }
	
	    /**
	     * Returns an array of possible slider points, taking into account both
	     * `marks` and `step`. The result is cached.
	     */
	
	  }, {
	    key: 'getPoints',
	    value: function getPoints() {
	      var _props = this.props,
	          marks = _props.marks,
	          step = _props.step,
	          min = _props.min,
	          max = _props.max;
	
	      var cache = this._getPointsCache;
	      if (!cache || cache.marks !== marks || cache.step !== step) {
	        var pointsObject = (0, _extends3['default'])({}, marks);
	        if (step !== null) {
	          for (var point = min; point <= max; point += step) {
	            pointsObject[point] = point;
	          }
	        }
	        var points = Object.keys(pointsObject).map(parseFloat);
	        points.sort(function (a, b) {
	          return a - b;
	        });
	        this._getPointsCache = { marks: marks, step: step, points: points };
	      }
	      return this._getPointsCache.points;
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(value, isFromKeyboardEvent) {
	      var _this3 = this;
	
	      var state = this.state,
	          props = this.props;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      nextBounds[state.handle] = value;
	      var nextHandle = state.handle;
	      if (props.pushable !== false) {
	        this.pushSurroundingHandles(nextBounds, nextHandle);
	      } else if (props.allowCross) {
	        nextBounds.sort(function (a, b) {
	          return a - b;
	        });
	        nextHandle = nextBounds.indexOf(value);
	      }
	      this.onChange({
	        handle: nextHandle,
	        bounds: nextBounds
	      });
	      if (isFromKeyboardEvent) {
	        // known problem: because setState is async,
	        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
	        // cause onBeforeChange and onAfterChange receive wrong value.
	        // here use setState callback to hack，but not elegant
	        this.setState({}, function () {
	          _this3.handlesRefs[nextHandle].focus();
	        });
	      }
	    }
	  }, {
	    key: 'pushSurroundingHandles',
	    value: function pushSurroundingHandles(bounds, handle) {
	      var value = bounds[handle];
	      var threshold = this.props.pushable;
	
	      threshold = Number(threshold);
	
	      var direction = 0;
	      if (bounds[handle + 1] - value < threshold) {
	        direction = +1; // push to right
	      }
	      if (value - bounds[handle - 1] < threshold) {
	        direction = -1; // push to left
	      }
	
	      if (direction === 0) {
	        return;
	      }
	
	      var nextHandle = handle + direction;
	      var diffToNext = direction * (bounds[nextHandle] - value);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // revert to original value if pushing is impossible
	        bounds[handle] = bounds[nextHandle] - direction * threshold;
	      }
	    }
	  }, {
	    key: 'pushHandle',
	    value: function pushHandle(bounds, handle, direction, amount) {
	      var originalValue = bounds[handle];
	      var currentValue = bounds[handle];
	      while (direction * (currentValue - originalValue) < amount) {
	        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	          // can't push handle enough to create the needed `amount` gap, so we
	          // revert its position to the original value
	          bounds[handle] = originalValue;
	          return false;
	        }
	        currentValue = bounds[handle];
	      }
	      // the handle was pushed enough to create the needed `amount` gap
	      return true;
	    }
	  }, {
	    key: 'pushHandleOnePoint',
	    value: function pushHandleOnePoint(bounds, handle, direction) {
	      var points = this.getPoints();
	      var pointIndex = points.indexOf(bounds[handle]);
	      var nextPointIndex = pointIndex + direction;
	      if (nextPointIndex >= points.length || nextPointIndex < 0) {
	        // reached the minimum or maximum available point, can't push anymore
	        return false;
	      }
	      var nextHandle = handle + direction;
	      var nextValue = points[nextPointIndex];
	      var threshold = this.props.pushable;
	
	      var diffToNext = direction * (bounds[nextHandle] - nextValue);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // couldn't push next handle, so we won't push this one either
	        return false;
	      }
	      // push the handle
	      bounds[handle] = nextValue;
	      return true;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v, handle) {
	      var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	      var valInRange = utils.ensureValueInRange(v, mergedProps);
	      var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
	      return utils.ensureValuePrecision(valNotConflict, mergedProps);
	    }
	  }, {
	    key: 'ensureValueNotConflict',
	    value: function ensureValueNotConflict(handle, val, _ref) {
	      var allowCross = _ref.allowCross,
	          thershold = _ref.pushable;
	
	      var state = this.state || {};
	      var bounds = state.bounds;
	
	      handle = handle === undefined ? state.handle : handle;
	      thershold = Number(thershold);
	      /* eslint-disable eqeqeq */
	      if (!allowCross && handle != null && bounds !== undefined) {
	        if (handle > 0 && val <= bounds[handle - 1] + thershold) {
	          return bounds[handle - 1] + thershold;
	        }
	        if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
	          return bounds[handle + 1] - thershold;
	        }
	      }
	      /* eslint-enable eqeqeq */
	      return val;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          handle = _state2.handle,
	          bounds = _state2.bounds;
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          vertical = _props2.vertical,
	          included = _props2.included,
	          disabled = _props2.disabled,
	          min = _props2.min,
	          max = _props2.max,
	          handleGenerator = _props2.handle,
	          trackStyle = _props2.trackStyle,
	          handleStyle = _props2.handleStyle,
	          tabIndex = _props2.tabIndex;
	
	
	      var offsets = bounds.map(function (v) {
	        return _this4.calcOffset(v);
	      });
	
	      var handleClassName = prefixCls + '-handle';
	      var handles = bounds.map(function (v, i) {
	        var _classNames;
	
	        return handleGenerator({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
	          prefixCls: prefixCls,
	          vertical: vertical,
	          offset: offsets[i],
	          value: v,
	          dragging: handle === i,
	          index: i,
	          tabIndex: tabIndex[i] || 0,
	          min: min,
	          max: max,
	          disabled: disabled,
	          style: handleStyle[i],
	          ref: function ref(h) {
	            return _this4.saveHandle(i, h);
	          }
	        });
	      });
	
	      var tracks = bounds.slice(0, -1).map(function (_, index) {
	        var _classNames2;
	
	        var i = index + 1;
	        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
	        return _react2['default'].createElement(_Track2['default'], {
	          className: trackClassName,
	          vertical: vertical,
	          included: included,
	          offset: offsets[i - 1],
	          length: offsets[i] - offsets[i - 1],
	          style: trackStyle[index],
	          key: i
	        });
	      });
	
	      return { tracks: tracks, handles: handles };
	    }
	  }]);
	  return Range;
	}(_react2['default'].Component); /* eslint-disable react/prop-types */
	
	
	Range.displayName = 'Range';
	Range.propTypes = {
	  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  count: _propTypes2['default'].number,
	  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
	  allowCross: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number)
	};
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false,
	  tabIndex: []
	};
	exports['default'] = (0, _createSlider2['default'])(Range);
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(126);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Track = __webpack_require__(166);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(167);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(104);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var Slider = function (_React$Component) {
	  (0, _inherits3['default'])(Slider, _React$Component);
	
	  function Slider(props) {
	    (0, _classCallCheck3['default'])(this, Slider);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ dragging: false });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	    if (false) {
	      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
	      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
	    }
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          autoFocus = _props.autoFocus,
	          disabled = _props.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	
	      var prevValue = this.state.value;
	      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
	      var nextValue = this.trimAlignValue(value, nextProps);
	      if (nextValue === prevValue) return;
	
	      this.setState({ value: nextValue });
	      if (utils.isValueOutOfRange(value, nextProps)) {
	        this.props.onChange(nextValue);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      }
	
	      var changedValue = state.value;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      this.setState({ dragging: true });
	      var props = this.props;
	      var prevValue = this.getValue();
	      props.onBeforeChange(prevValue);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      if (value === prevValue) return;
	
	      this.prevMovedHandleIndex = 0;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var oldValue = this.state.value;
	
	      var value = this.calcValueByPos(position);
	      if (value === oldValue) return;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var valueMutator = utils.getKeyboardValueMutator(e);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state;
	        var oldValue = state.value;
	        var mutatedValue = valueMutator(oldValue, this.props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	
	        this.onChange({ value: value });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.props.min;
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      return this.state.value;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v) {
	      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	      var val = utils.ensureValueInRange(v, mergedProps);
	      return utils.ensureValuePrecision(val, mergedProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          vertical = _props2.vertical,
	          included = _props2.included,
	          disabled = _props2.disabled,
	          minimumTrackStyle = _props2.minimumTrackStyle,
	          trackStyle = _props2.trackStyle,
	          handleStyle = _props2.handleStyle,
	          tabIndex = _props2.tabIndex,
	          min = _props2.min,
	          max = _props2.max,
	          handleGenerator = _props2.handle;
	      var _state = this.state,
	          value = _state.value,
	          dragging = _state.dragging;
	
	      var offset = this.calcOffset(value);
	      var handle = handleGenerator({
	        className: prefixCls + '-handle',
	        prefixCls: prefixCls,
	        vertical: vertical,
	        offset: offset,
	        value: value,
	        dragging: dragging,
	        disabled: disabled,
	        min: min,
	        max: max,
	        index: 0,
	        tabIndex: tabIndex,
	        style: handleStyle[0] || handleStyle,
	        ref: function ref(h) {
	          return _this2.saveHandle(0, h);
	        }
	      });
	
	      var _trackStyle = trackStyle[0] || trackStyle;
	      var track = _react2['default'].createElement(_Track2['default'], {
	        className: prefixCls + '-track',
	        vertical: vertical,
	        included: included,
	        offset: 0,
	        length: offset,
	        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
	      });
	
	      return { tracks: track, handles: handle };
	    }
	  }]);
	  return Slider;
	}(_react2['default'].Component);
	
	Slider.propTypes = {
	  defaultValue: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  disabled: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].number
	};
	exports['default'] = (0, _createSlider2['default'])(Slider);
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min,
	      onClickLabel = _ref.onClickLabel;
	
	  var marksKeys = Object.keys(marks);
	  var marksCount = marksKeys.length;
	  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
	  var markWidth = unit * 0.9;
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var markPoint = marks[point];
	    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    if (!markLabel && markLabel !== 0) {
	      return null;
	    }
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));
	
	    var bottomStyle = {
	      marginBottom: '-50%',
	      bottom: (point - min) / range * 100 + '%'
	    };
	
	    var leftStyle = {
	      width: markWidth + '%',
	      marginLeft: -markWidth / 2 + '%',
	      left: (point - min) / range * 100 + '%'
	    };
	
	    var style = vertical ? bottomStyle : leftStyle;
	    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: markClassName,
	        style: markStyle,
	        key: point,
	        onMouseDown: function onMouseDown(e) {
	          return onClickLabel(e, point);
	        },
	        onTouchStart: function onTouchStart(e) {
	          return onClickLabel(e, point);
	        }
	      },
	      markLabel
	    );
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	Marks.propTypes = {
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  marks: _propTypes2['default'].object,
	  included: _propTypes2['default'].bool,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  onClickLabel: _propTypes2['default'].func
	};
	
	exports['default'] = Marks;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(126);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat);
	  if (dots) {
	    for (var i = min; i <= max; i += step) {
	      if (points.indexOf(i) === -1) {
	        points.push(i);
	      }
	    }
	  }
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min,
	      dotStyle = _ref.dotStyle,
	      activeDotStyle = _ref.activeDotStyle;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
	    if (isActived) {
	      style = (0, _extends3['default'])({}, style, activeDotStyle);
	    }
	
	    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));
	
	    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	Steps.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  activeDotStyle: _propTypes2['default'].object,
	  dotStyle: _propTypes2['default'].object,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  included: _propTypes2['default'].bool,
	  dots: _propTypes2['default'].bool,
	  step: _propTypes2['default'].number,
	  marks: _propTypes2['default'].object,
	  vertical: _propTypes2['default'].bool
	};
	
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(50);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(26);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(11);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSliderWithTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTooltip = __webpack_require__(343);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Handle = __webpack_require__(103);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function createSliderWithTooltip(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3['default'])(ComponentWrapper, _React$Component);
	
	    function ComponentWrapper(props) {
	      (0, _classCallCheck3['default'])(this, ComponentWrapper);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call(this, props));
	
	      _this.handleTooltipVisibleChange = function (index, visible) {
	        _this.setState(function (prevState) {
	          return {
	            visibles: (0, _extends4['default'])({}, prevState.visibles, (0, _defineProperty3['default'])({}, index, visible))
	          };
	        });
	      };
	
	      _this.handleWithTooltip = function (_ref) {
	        var value = _ref.value,
	            dragging = _ref.dragging,
	            index = _ref.index,
	            disabled = _ref.disabled,
	            restProps = (0, _objectWithoutProperties3['default'])(_ref, ['value', 'dragging', 'index', 'disabled']);
	        var _this$props = _this.props,
	            tipFormatter = _this$props.tipFormatter,
	            tipProps = _this$props.tipProps,
	            handleStyle = _this$props.handleStyle;
	        var _tipProps$prefixCls = tipProps.prefixCls,
	            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
	            _tipProps$overlay = tipProps.overlay,
	            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
	            _tipProps$placement = tipProps.placement,
	            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
	            _tipProps$visible = tipProps.visible,
	            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
	            restTooltipProps = (0, _objectWithoutProperties3['default'])(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);
	
	
	        var handleStyleWithIndex = void 0;
	        if (Array.isArray(handleStyle)) {
	          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
	        } else {
	          handleStyleWithIndex = handleStyle;
	        }
	
	        return _react2['default'].createElement(
	          _rcTooltip2['default'],
	          (0, _extends4['default'])({}, restTooltipProps, {
	            prefixCls: prefixCls,
	            overlay: overlay,
	            placement: placement,
	            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
	            key: index
	          }),
	          _react2['default'].createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, {
	            style: (0, _extends4['default'])({}, handleStyleWithIndex),
	            value: value,
	            onMouseEnter: function onMouseEnter() {
	              return _this.handleTooltipVisibleChange(index, true);
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this.handleTooltipVisibleChange(index, false);
	            }
	          }))
	        );
	      };
	
	      _this.state = { visibles: {} };
	      return _this;
	    }
	
	    (0, _createClass3['default'])(ComponentWrapper, [{
	      key: 'render',
	      value: function render() {
	        return _react2['default'].createElement(Component, (0, _extends4['default'])({}, this.props, { handle: this.handleWithTooltip }));
	      }
	    }]);
	    return ComponentWrapper;
	  }(_react2['default'].Component), _class.propTypes = {
	    tipFormatter: _propTypes2['default'].func,
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    tipProps: _propTypes2['default'].object
	  }, _class.defaultProps = {
	    tipFormatter: function tipFormatter(value) {
	      return value;
	    },
	
	    handleStyle: [{}],
	    tipProps: {}
	  }, _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createSliderWithTooltip = exports.Handle = exports.Range = undefined;
	
	var _Slider = __webpack_require__(336);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Range = __webpack_require__(335);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Handle = __webpack_require__(103);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _createSliderWithTooltip = __webpack_require__(339);
	
	var _createSliderWithTooltip2 = _interopRequireDefault(_createSliderWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Slider2['default'].Range = _Range2['default'];
	_Slider2['default'].Handle = _Handle2['default'];
	_Slider2['default'].createSliderWithTooltip = _createSliderWithTooltip2['default'];
	exports['default'] = _Slider2['default'];
	exports.Range = _Range2['default'];
	exports.Handle = _Handle2['default'];
	exports.createSliderWithTooltip = _createSliderWithTooltip2['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(50);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(347);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(344);
	
	var _Content = __webpack_require__(341);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(342);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(328);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(330);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(346);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(168);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(168);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _contains = __webpack_require__(349);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(71);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(348);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(351);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(169);
	
	var _Popup = __webpack_require__(345);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.prevPopupVisible = popupVisible;
	
	    _this.state = {
	      popupVisible: popupVisible
	    };
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this2['fire' + h] = function (e) {
	        _this2.fireEvents(h, e);
	      };
	    });
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    this.prevPopupVisible = prevState.popupVisible;
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	
	
	    this.clearDelayTimer();
	
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this3 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this3.setPopupVisible(visible, point);
	        _this3.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this4 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this4.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        {
	          key: 'portal',
	          getContainer: this.getContainer,
	          didUpdate: this.handlePortalUpdate
	        },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this5.props.mouseEnterDelay;
	
	    _this5.fireEvents('onMouseEnter', e);
	    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this5.fireEvents('onMouseMove', e);
	    _this5.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this5.fireEvents('onMouseLeave', e);
	    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this5.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && (0, _contains2['default'])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this5.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this5.clearDelayTimer();
	    if (_this5.isFocusToShow()) {
	      _this5.focusTime = Date.now();
	      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this5.fireEvents('onMouseDown', e);
	    _this5.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this5.fireEvents('onTouchStart', e);
	    _this5.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this5.fireEvents('onBlur', e);
	    _this5.clearDelayTimer();
	    if (_this5.isBlurToHide()) {
	      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this5.fireEvents('onContextMenu', e);
	    _this5.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this5.isContextMenuToShow()) {
	      _this5.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this5.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this5.focusTime) {
	      var preTime = void 0;
	      if (_this5.preClickTime && _this5.preTouchTime) {
	        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
	      } else if (_this5.preClickTime) {
	        preTime = _this5.preClickTime;
	      } else if (_this5.preTouchTime) {
	        preTime = _this5.preTouchTime;
	      }
	      if (Math.abs(preTime - _this5.focusTime) < 20) {
	        return;
	      }
	      _this5.focusTime = 0;
	    }
	    _this5.preClickTime = 0;
	    _this5.preTouchTime = 0;
	    if (event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this5.state.popupVisible;
	    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
	      _this5.setPopupVisible(!_this5.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this5.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this5.hasPopupMouseDown = true;
	
	    clearTimeout(_this5.mouseDownTimeout);
	    _this5.mouseDownTimeout = setTimeout(function () {
	      _this5.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this5.props.mask && !_this5.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this5);
	    if (!(0, _contains2['default'])(root, target) && !_this5.hasPopupMouseDown) {
	      _this5.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this5);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this5.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this5.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this5.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this5.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this5.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
	    }
	    if (_this5.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this5.onPopupMouseDown;
	    mouseProps.onTouchStart = _this5.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this5.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this5.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this5.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this5)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this5.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this5.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
	      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this5._component = node;
	  };
	};
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ContainerRender = function (_React$Component) {
	  (0, _inherits3['default'])(ContainerRender, _React$Component);
	
	  function ContainerRender() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, ContainerRender);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom2['default'].unmountComponentAtNode(_this.container);
	        _this.container.parentNode.removeChild(_this.container);
	        _this.container = null;
	      }
	    }, _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	        _reactDom2['default'].unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(ContainerRender, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	  return ContainerRender;
	}(_react2['default'].Component);
	
	ContainerRender.propTypes = {
	  autoMount: _propTypes2['default'].bool,
	  autoDestroy: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  parent: _propTypes2['default'].any,
	  getComponent: _propTypes2['default'].func.isRequired,
	  getContainer: _propTypes2['default'].func.isRequired,
	  children: _propTypes2['default'].func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};
	exports['default'] = ContainerRender;
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33, // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35, // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36, // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40, // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45, // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46, // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63, // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91, // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186, // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189, // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187, // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188, // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190, // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191, // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192, // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222, // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219, // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220, // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221, // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229
	};
	
	/*
	 whether text and modified key is entered at the same time.
	 */
	KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
	  var keyCode = e.keyCode;
	  if (e.altKey && !e.ctrlKey || e.metaKey ||
	  // Function keys don't generate text
	  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	    return false;
	  }
	
	  // The following keys are quite harmless, even in combination with
	  // CTRL, ALT or SHIFT.
	  switch (keyCode) {
	    case KeyCode.ALT:
	    case KeyCode.CAPS_LOCK:
	    case KeyCode.CONTEXT_MENU:
	    case KeyCode.CTRL:
	    case KeyCode.DOWN:
	    case KeyCode.END:
	    case KeyCode.ESC:
	    case KeyCode.HOME:
	    case KeyCode.INSERT:
	    case KeyCode.LEFT:
	    case KeyCode.MAC_FF_META:
	    case KeyCode.META:
	    case KeyCode.NUMLOCK:
	    case KeyCode.NUM_CENTER:
	    case KeyCode.PAGE_DOWN:
	    case KeyCode.PAGE_UP:
	    case KeyCode.PAUSE:
	    case KeyCode.PRINT_SCREEN:
	    case KeyCode.RIGHT:
	    case KeyCode.SHIFT:
	    case KeyCode.UP:
	    case KeyCode.WIN_KEY:
	    case KeyCode.WIN_KEY_RIGHT:
	      return false;
	    default:
	      return true;
	  }
	};
	
	/*
	 whether character is entered.
	 */
	KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
	  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	    return true;
	  }
	
	  // Safari sends zero key code for non-latin characters.
	  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	    return true;
	  }
	
	  switch (keyCode) {
	    case KeyCode.SPACE:
	    case KeyCode.QUESTION_MARK:
	    case KeyCode.NUM_PLUS:
	    case KeyCode.NUM_MINUS:
	    case KeyCode.NUM_PERIOD:
	    case KeyCode.NUM_DIVISION:
	    case KeyCode.SEMICOLON:
	    case KeyCode.DASH:
	    case KeyCode.EQUALS:
	    case KeyCode.COMMA:
	    case KeyCode.PERIOD:
	    case KeyCode.SLASH:
	    case KeyCode.APOSTROPHE:
	    case KeyCode.SINGLE_QUOTE:
	    case KeyCode.OPEN_SQUARE_BRACKET:
	    case KeyCode.BACKSLASH:
	    case KeyCode.CLOSE_SQUARE_BRACKET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	exports['default'] = KeyCode;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(19);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Portal = function (_React$Component) {
	  (0, _inherits3['default'])(Portal, _React$Component);
	
	  function Portal() {
	    (0, _classCallCheck3['default'])(this, Portal);
	    return (0, _possibleConstructorReturn3['default'])(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: 'createContainer',
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: 'removeContainer',
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this._container) {
	        return _reactDom2['default'].createPortal(this.props.children, this._container);
	      }
	      return null;
	    }
	  }]);
	  return Portal;
	}(_react2['default'].Component);
	
	Portal.propTypes = {
	  getContainer: _propTypes2['default'].func.isRequired,
	  children: _propTypes2['default'].node.isRequired,
	  didUpdate: _propTypes2['default'].func
	};
	exports['default'] = Portal;
	module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var focusNode = __webpack_require__(163);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(58);
	var ExecutionEnvironment = __webpack_require__(12);
	var FallbackCompositionState = __webpack_require__(360);
	var SyntheticCompositionEvent = __webpack_require__(397);
	var SyntheticInputEvent = __webpack_require__(400);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(170);
	var ExecutionEnvironment = __webpack_require__(12);
	var ReactInstrumentation = __webpack_require__(18);
	
	var camelizeStyleName = __webpack_require__(312);
	var dangerousStyleValue = __webpack_require__(406);
	var hyphenateStyleName = __webpack_require__(319);
	var memoizeStringOnly = __webpack_require__(322);
	var warning = __webpack_require__(3);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(57);
	var EventPropagators = __webpack_require__(58);
	var ExecutionEnvironment = __webpack_require__(12);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(22);
	var SyntheticEvent = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(117);
	var isEventSupported = __webpack_require__(118);
	var isTextInputElement = __webpack_require__(187);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(12);
	
	var createNodesFromMarkup = __webpack_require__(315);
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(58);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticMouseEvent = __webpack_require__(73);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	
	var getTextContentAccessor = __webpack_require__(185);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(46);
	
	var instantiateReactComponent = __webpack_require__(186);
	var KeyEscapeUtils = __webpack_require__(109);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var traverseAllChildren = __webpack_require__(189);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/case-law-app"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(205);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(105);
	var ReactDOMIDOperations = __webpack_require__(370);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var React = __webpack_require__(47);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactErrorUtils = __webpack_require__(112);
	var ReactInstanceMap = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactNodeTypes = __webpack_require__(180);
	var ReactReconciler = __webpack_require__(46);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(56);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(102);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(3);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDefaultInjection = __webpack_require__(378);
	var ReactMount = __webpack_require__(179);
	var ReactReconciler = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(22);
	var ReactVersion = __webpack_require__(391);
	
	var findDOMNode = __webpack_require__(407);
	var getHostComponentFromComposite = __webpack_require__(184);
	var renderSubtreeIntoContainer = __webpack_require__(415);
	var warning = __webpack_require__(3);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(353);
	var CSSPropertyOperations = __webpack_require__(355);
	var DOMLazyTree = __webpack_require__(44);
	var DOMNamespaces = __webpack_require__(106);
	var DOMProperty = __webpack_require__(45);
	var DOMPropertyOperations = __webpack_require__(172);
	var EventPluginHub = __webpack_require__(57);
	var EventPluginRegistry = __webpack_require__(107);
	var ReactBrowserEventEmitter = __webpack_require__(72);
	var ReactDOMComponentFlags = __webpack_require__(173);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMInput = __webpack_require__(371);
	var ReactDOMOption = __webpack_require__(372);
	var ReactDOMSelect = __webpack_require__(174);
	var ReactDOMTextarea = __webpack_require__(375);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactMultiChild = __webpack_require__(384);
	var ReactServerRenderingTransaction = __webpack_require__(389);
	
	var emptyFunction = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(75);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(118);
	var shallowEqual = __webpack_require__(102);
	var validateDOMNesting = __webpack_require__(120);
	var warning = __webpack_require__(3);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(120);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 369 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMPropertyOperations = __webpack_require__(172);
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var React = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMSelect = __webpack_require__(174);
	
	var warning = __webpack_require__(3);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	var getNodeForCharacterOffset = __webpack_require__(412);
	var getTextContentAccessor = __webpack_require__(185);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(105);
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var escapeTextContentForBrowser = __webpack_require__(75);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(120);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(22);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(22);
	var Transaction = __webpack_require__(74);
	
	var emptyFunction = __webpack_require__(17);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(352);
	var BeforeInputEventPlugin = __webpack_require__(354);
	var ChangeEventPlugin = __webpack_require__(356);
	var DefaultEventPluginOrder = __webpack_require__(358);
	var EnterLeaveEventPlugin = __webpack_require__(359);
	var HTMLDOMPropertyConfig = __webpack_require__(361);
	var ReactComponentBrowserEnvironment = __webpack_require__(363);
	var ReactDOMComponent = __webpack_require__(366);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMEmptyComponent = __webpack_require__(368);
	var ReactDOMTreeTraversal = __webpack_require__(376);
	var ReactDOMTextComponent = __webpack_require__(374);
	var ReactDefaultBatchingStrategy = __webpack_require__(377);
	var ReactEventListener = __webpack_require__(381);
	var ReactInjection = __webpack_require__(382);
	var ReactReconcileTransaction = __webpack_require__(387);
	var SVGDOMPropertyConfig = __webpack_require__(392);
	var SelectEventPlugin = __webpack_require__(393);
	var SimpleEventPlugin = __webpack_require__(394);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 379 */
206,
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(57);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(162);
	var ExecutionEnvironment = __webpack_require__(12);
	var PooledClass = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(22);
	
	var getEventTarget = __webpack_require__(117);
	var getUnboundedScrollPosition = __webpack_require__(317);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(57);
	var EventPluginUtils = __webpack_require__(108);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactEmptyComponent = __webpack_require__(175);
	var ReactBrowserEventEmitter = __webpack_require__(72);
	var ReactHostComponent = __webpack_require__(177);
	var ReactUpdates = __webpack_require__(22);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(405);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactInstanceMap = __webpack_require__(59);
	var ReactInstrumentation = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactReconciler = __webpack_require__(46);
	var ReactChildReconciler = __webpack_require__(362);
	
	var emptyFunction = __webpack_require__(17);
	var flattenChildren = __webpack_require__(408);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(171);
	var PooledClass = __webpack_require__(37);
	var ReactBrowserEventEmitter = __webpack_require__(72);
	var ReactInputSelection = __webpack_require__(178);
	var ReactInstrumentation = __webpack_require__(18);
	var Transaction = __webpack_require__(74);
	var ReactUpdateQueue = __webpack_require__(113);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(385);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	var Transaction = __webpack_require__(74);
	var ReactInstrumentation = __webpack_require__(18);
	var ReactServerUpdateQueue = __webpack_require__(390);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(113);
	
	var warning = __webpack_require__(3);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.2';

/***/ },
/* 392 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(58);
	var ExecutionEnvironment = __webpack_require__(12);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInputSelection = __webpack_require__(178);
	var SyntheticEvent = __webpack_require__(23);
	
	var getActiveElement = __webpack_require__(164);
	var isTextInputElement = __webpack_require__(187);
	var shallowEqual = __webpack_require__(102);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventListener = __webpack_require__(162);
	var EventPropagators = __webpack_require__(58);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticAnimationEvent = __webpack_require__(395);
	var SyntheticClipboardEvent = __webpack_require__(396);
	var SyntheticEvent = __webpack_require__(23);
	var SyntheticFocusEvent = __webpack_require__(399);
	var SyntheticKeyboardEvent = __webpack_require__(401);
	var SyntheticMouseEvent = __webpack_require__(73);
	var SyntheticDragEvent = __webpack_require__(398);
	var SyntheticTouchEvent = __webpack_require__(402);
	var SyntheticTransitionEvent = __webpack_require__(403);
	var SyntheticUIEvent = __webpack_require__(60);
	var SyntheticWheelEvent = __webpack_require__(404);
	
	var emptyFunction = __webpack_require__(17);
	var getEventCharCode = __webpack_require__(115);
	var invariant = __webpack_require__(2);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(73);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(60);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(60);
	
	var getEventCharCode = __webpack_require__(115);
	var getEventKey = __webpack_require__(409);
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(60);
	
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(23);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(73);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 405 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(170);
	var warning = __webpack_require__(3);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstanceMap = __webpack_require__(59);
	
	var getHostComponentFromComposite = __webpack_require__(184);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(109);
	var traverseAllChildren = __webpack_require__(189);
	var warning = __webpack_require__(3);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/case-law-app"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(205);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(115);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 410 */
209,
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 412 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(12);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(75);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(179);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 418 */
/***/ function(module, exports) {

	;(function() {
	"use strict";
	
	if (typeof window === 'undefined') return;
	
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A component handler interface using the revealing module design pattern.
	 * More details on this design pattern here:
	 * https://github.com/jasonmayes/mdl-component-design-pattern
	 *
	 * @author Jason Mayes.
	 */
	/* exported componentHandler */
	
	// Pre-defining the componentHandler interface, for closure documentation and
	// static verification.
	var componentHandler = {
	  /**
	   * Searches existing DOM for elements of our component type and upgrades them
	   * if they have not already been upgraded.
	   *
	   * @param {string=} optJsClass the programatic name of the element class we
	   * need to create a new instance of.
	   * @param {string=} optCssClass the name of the CSS class elements of this
	   * type will have.
	   */
	  upgradeDom: function(optJsClass, optCssClass) {},
	  /**
	   * Upgrades a specific element rather than all in the DOM.
	   *
	   * @param {!Element} element The element we wish to upgrade.
	   * @param {string=} optJsClass Optional name of the class we want to upgrade
	   * the element to.
	   */
	  upgradeElement: function(element, optJsClass) {},
	  /**
	   * Upgrades a specific list of elements rather than all in the DOM.
	   *
	   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	   * The elements we wish to upgrade.
	   */
	  upgradeElements: function(elements) {},
	  /**
	   * Upgrades all registered components found in the current DOM. This is
	   * automatically called on window load.
	   */
	  upgradeAllRegistered: function() {},
	  /**
	   * Allows user to be alerted to any upgrades that are performed for a given
	   * component type
	   *
	   * @param {string} jsClass The class name of the MDL component we wish
	   * to hook into for any upgrades performed.
	   * @param {function(!HTMLElement)} callback The function to call upon an
	   * upgrade. This function should expect 1 parameter - the HTMLElement which
	   * got upgraded.
	   */
	  registerUpgradedCallback: function(jsClass, callback) {},
	  /**
	   * Registers a class for future use and attempts to upgrade existing DOM.
	   *
	   * @param {componentHandler.ComponentConfigPublic} config the registration configuration
	   */
	  register: function(config) {},
	  /**
	   * Downgrade either a given node, an array of nodes, or a NodeList.
	   *
	   * @param {!Node|!Array<!Node>|!NodeList} nodes
	   */
	  downgradeElements: function(nodes) {}
	};
	
	componentHandler = (function() {
	  'use strict';
	
	  /** @type {!Array<componentHandler.ComponentConfig>} */
	  var registeredComponents_ = [];
	
	  /** @type {!Array<componentHandler.Component>} */
	  var createdComponents_ = [];
	
	  var componentConfigProperty_ = 'mdlComponentConfigInternal_';
	
	  /**
	   * Searches registered components for a class we are interested in using.
	   * Optionally replaces a match with passed object if specified.
	   *
	   * @param {string} name The name of a class we want to use.
	   * @param {componentHandler.ComponentConfig=} optReplace Optional object to replace match with.
	   * @return {!Object|boolean}
	   * @private
	   */
	  function findRegisteredClass_(name, optReplace) {
	    for (var i = 0; i < registeredComponents_.length; i++) {
	      if (registeredComponents_[i].className === name) {
	        if (typeof optReplace !== 'undefined') {
	          registeredComponents_[i] = optReplace;
	        }
	        return registeredComponents_[i];
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Returns an array of the classNames of the upgraded classes on the element.
	   *
	   * @param {!Element} element The element to fetch data from.
	   * @return {!Array<string>}
	   * @private
	   */
	  function getUpgradedListOfElement_(element) {
	    var dataUpgraded = element.getAttribute('data-upgraded');
	    // Use `['']` as default value to conform the `,name,name...` style.
	    return dataUpgraded === null ? [''] : dataUpgraded.split(',');
	  }
	
	  /**
	   * Returns true if the given element has already been upgraded for the given
	   * class.
	   *
	   * @param {!Element} element The element we want to check.
	   * @param {string} jsClass The class to check for.
	   * @returns {boolean}
	   * @private
	   */
	  function isElementUpgraded_(element, jsClass) {
	    var upgradedList = getUpgradedListOfElement_(element);
	    return upgradedList.indexOf(jsClass) !== -1;
	  }
	
	  /**
	   * Searches existing DOM for elements of our component type and upgrades them
	   * if they have not already been upgraded.
	   *
	   * @param {string=} optJsClass the programatic name of the element class we
	   * need to create a new instance of.
	   * @param {string=} optCssClass the name of the CSS class elements of this
	   * type will have.
	   */
	  function upgradeDomInternal(optJsClass, optCssClass) {
	    if (typeof optJsClass === 'undefined' &&
	        typeof optCssClass === 'undefined') {
	      for (var i = 0; i < registeredComponents_.length; i++) {
	        upgradeDomInternal(registeredComponents_[i].className,
	            registeredComponents_[i].cssClass);
	      }
	    } else {
	      var jsClass = /** @type {string} */ (optJsClass);
	      if (typeof optCssClass === 'undefined') {
	        var registeredClass = findRegisteredClass_(jsClass);
	        if (registeredClass) {
	          optCssClass = registeredClass.cssClass;
	        }
	      }
	
	      var elements = document.querySelectorAll('.' + optCssClass);
	      for (var n = 0; n < elements.length; n++) {
	        upgradeElementInternal(elements[n], jsClass);
	      }
	    }
	  }
	
	  /**
	   * Upgrades a specific element rather than all in the DOM.
	   *
	   * @param {!Element} element The element we wish to upgrade.
	   * @param {string=} optJsClass Optional name of the class we want to upgrade
	   * the element to.
	   */
	  function upgradeElementInternal(element, optJsClass) {
	    // Verify argument type.
	    if (!(typeof element === 'object' && element instanceof Element)) {
	      throw new Error('Invalid argument provided to upgrade MDL element.');
	    }
	    var upgradedList = getUpgradedListOfElement_(element);
	    var classesToUpgrade = [];
	    // If jsClass is not provided scan the registered components to find the
	    // ones matching the element's CSS classList.
	    if (!optJsClass) {
	      var classList = element.classList;
	      registeredComponents_.forEach(function(component) {
	        // Match CSS & Not to be upgraded & Not upgraded.
	        if (classList.contains(component.cssClass) &&
	            classesToUpgrade.indexOf(component) === -1 &&
	            !isElementUpgraded_(element, component.className)) {
	          classesToUpgrade.push(component);
	        }
	      });
	    } else if (!isElementUpgraded_(element, optJsClass)) {
	      classesToUpgrade.push(findRegisteredClass_(optJsClass));
	    }
	
	    // Upgrade the element for each classes.
	    for (var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++) {
	      registeredClass = classesToUpgrade[i];
	      if (registeredClass) {
	        // Mark element as upgraded.
	        upgradedList.push(registeredClass.className);
	        element.setAttribute('data-upgraded', upgradedList.join(','));
	        var instance = new registeredClass.classConstructor(element);
	        instance[componentConfigProperty_] = registeredClass;
	        createdComponents_.push(instance);
	        // Call any callbacks the user has registered with this component type.
	        for (var j = 0, m = registeredClass.callbacks.length; j < m; j++) {
	          registeredClass.callbacks[j](element);
	        }
	
	        if (registeredClass.widget) {
	          // Assign per element instance for control over API
	          element[registeredClass.className] = instance;
	        }
	      } else {
	        throw new Error(
	          'Unable to find a registered component for the given class.');
	      }
	
	      var ev;
	      if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
	        ev = new CustomEvent('mdl-componentupgraded', {
	          bubbles: true, cancelable: false
	        });
	      } else {
	        ev = document.createEvent('Events');
	        ev.initEvent('mdl-componentupgraded', true, true);
	      }
	      element.dispatchEvent(ev);
	    }
	  }
	
	  /**
	   * Upgrades a specific list of elements rather than all in the DOM.
	   *
	   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	   * The elements we wish to upgrade.
	   */
	  function upgradeElementsInternal(elements) {
	    if (!Array.isArray(elements)) {
	      if (elements instanceof Element) {
	        elements = [elements];
	      } else {
	        elements = Array.prototype.slice.call(elements);
	      }
	    }
	    for (var i = 0, n = elements.length, element; i < n; i++) {
	      element = elements[i];
	      if (element instanceof HTMLElement) {
	        upgradeElementInternal(element);
	        if (element.children.length > 0) {
	          upgradeElementsInternal(element.children);
	        }
	      }
	    }
	  }
	
	  /**
	   * Registers a class for future use and attempts to upgrade existing DOM.
	   *
	   * @param {componentHandler.ComponentConfigPublic} config
	   */
	  function registerInternal(config) {
	    // In order to support both Closure-compiled and uncompiled code accessing
	    // this method, we need to allow for both the dot and array syntax for
	    // property access. You'll therefore see the `foo.bar || foo['bar']`
	    // pattern repeated across this method.
	    var widgetMissing = (typeof config.widget === 'undefined' &&
	        typeof config['widget'] === 'undefined');
	    var widget = true;
	
	    if (!widgetMissing) {
	      widget = config.widget || config['widget'];
	    }
	
	    var newConfig = /** @type {componentHandler.ComponentConfig} */ ({
	      classConstructor: config.constructor || config['constructor'],
	      className: config.classAsString || config['classAsString'],
	      cssClass: config.cssClass || config['cssClass'],
	      widget: widget,
	      callbacks: []
	    });
	
	    registeredComponents_.forEach(function(item) {
	      if (item.cssClass === newConfig.cssClass) {
	        throw new Error('The provided cssClass has already been registered: ' + item.cssClass);
	      }
	      if (item.className === newConfig.className) {
	        throw new Error('The provided className has already been registered');
	      }
	    });
	
	    if (config.constructor.prototype
	        .hasOwnProperty(componentConfigProperty_)) {
	      throw new Error(
	          'MDL component classes must not have ' + componentConfigProperty_ +
	          ' defined as a property.');
	    }
	
	    var found = findRegisteredClass_(config.classAsString, newConfig);
	
	    if (!found) {
	      registeredComponents_.push(newConfig);
	    }
	  }
	
	  /**
	   * Allows user to be alerted to any upgrades that are performed for a given
	   * component type
	   *
	   * @param {string} jsClass The class name of the MDL component we wish
	   * to hook into for any upgrades performed.
	   * @param {function(!HTMLElement)} callback The function to call upon an
	   * upgrade. This function should expect 1 parameter - the HTMLElement which
	   * got upgraded.
	   */
	  function registerUpgradedCallbackInternal(jsClass, callback) {
	    var regClass = findRegisteredClass_(jsClass);
	    if (regClass) {
	      regClass.callbacks.push(callback);
	    }
	  }
	
	  /**
	   * Upgrades all registered components found in the current DOM. This is
	   * automatically called on window load.
	   */
	  function upgradeAllRegisteredInternal() {
	    for (var n = 0; n < registeredComponents_.length; n++) {
	      upgradeDomInternal(registeredComponents_[n].className);
	    }
	  }
	
	  /**
	   * Check the component for the downgrade method.
	   * Execute if found.
	   * Remove component from createdComponents list.
	   *
	   * @param {?componentHandler.Component} component
	   */
	  function deconstructComponentInternal(component) {
	    if (component) {
	      var componentIndex = createdComponents_.indexOf(component);
	      createdComponents_.splice(componentIndex, 1);
	
	      var upgrades = component.element_.getAttribute('data-upgraded').split(',');
	      var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);
	      upgrades.splice(componentPlace, 1);
	      component.element_.setAttribute('data-upgraded', upgrades.join(','));
	
	      var ev;
	      if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
	        ev = new CustomEvent('mdl-componentdowngraded', {
	          bubbles: true, cancelable: false
	        });
	      } else {
	        ev = document.createEvent('Events');
	        ev.initEvent('mdl-componentdowngraded', true, true);
	      }
	      component.element_.dispatchEvent(ev);
	    }
	  }
	
	  /**
	   * Downgrade either a given node, an array of nodes, or a NodeList.
	   *
	   * @param {!Node|!Array<!Node>|!NodeList} nodes
	   */
	  function downgradeNodesInternal(nodes) {
	    /**
	     * Auxiliary function to downgrade a single node.
	     * @param  {!Node} node the node to be downgraded
	     */
	    var downgradeNode = function(node) {
	      createdComponents_.filter(function(item) {
	        return item.element_ === node;
	      }).forEach(deconstructComponentInternal);
	    };
	    if (nodes instanceof Array || nodes instanceof NodeList) {
	      for (var n = 0; n < nodes.length; n++) {
	        downgradeNode(nodes[n]);
	      }
	    } else if (nodes instanceof Node) {
	      downgradeNode(nodes);
	    } else {
	      throw new Error('Invalid argument provided to downgrade MDL nodes.');
	    }
	  }
	
	  // Now return the functions that should be made public with their publicly
	  // facing names...
	  return {
	    upgradeDom: upgradeDomInternal,
	    upgradeElement: upgradeElementInternal,
	    upgradeElements: upgradeElementsInternal,
	    upgradeAllRegistered: upgradeAllRegisteredInternal,
	    registerUpgradedCallback: registerUpgradedCallbackInternal,
	    register: registerInternal,
	    downgradeElements: downgradeNodesInternal
	  };
	})();
	
	/**
	 * Describes the type of a registered component type managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   constructor: Function,
	 *   classAsString: string,
	 *   cssClass: string,
	 *   widget: (string|boolean|undefined)
	 * }}
	 */
	componentHandler.ComponentConfigPublic;  // jshint ignore:line
	
	/**
	 * Describes the type of a registered component type managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   constructor: !Function,
	 *   className: string,
	 *   cssClass: string,
	 *   widget: (string|boolean),
	 *   callbacks: !Array<function(!HTMLElement)>
	 * }}
	 */
	componentHandler.ComponentConfig;  // jshint ignore:line
	
	/**
	 * Created component (i.e., upgraded element) type as managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   element_: !HTMLElement,
	 *   className: string,
	 *   classAsString: string,
	 *   cssClass: string,
	 *   widget: string
	 * }}
	 */
	componentHandler.Component;  // jshint ignore:line
	
	// Export all symbols, for the benefit of Closure compiler.
	// No effect on uncompiled code.
	componentHandler['upgradeDom'] = componentHandler.upgradeDom;
	componentHandler['upgradeElement'] = componentHandler.upgradeElement;
	componentHandler['upgradeElements'] = componentHandler.upgradeElements;
	componentHandler['upgradeAllRegistered'] =
	    componentHandler.upgradeAllRegistered;
	componentHandler['registerUpgradedCallback'] =
	    componentHandler.registerUpgradedCallback;
	componentHandler['register'] = componentHandler.register;
	componentHandler['downgradeElements'] = componentHandler.downgradeElements;
	window.componentHandler = componentHandler;
	window['componentHandler'] = componentHandler;
	
	window.addEventListener('load', function() {
	  'use strict';
	
	  /**
	   * Performs a "Cutting the mustard" test. If the browser supports the features
	   * tested, adds a mdl-js class to the <html> element. It then upgrades all MDL
	   * components requiring JavaScript.
	   */
	  if ('classList' in document.createElement('div') &&
	      'querySelector' in document &&
	      'addEventListener' in window && Array.prototype.forEach) {
	    document.documentElement.classList.add('mdl-js');
	  } else {
	    /**
	     * Dummy function to avoid JS errors.
	     */
	    componentHandler.upgradeElement = function() {};
	    /**
	     * Dummy function to avoid JS errors.
	     */
	    componentHandler.register = function() {};
	  }
	});
	
	// Source: https://github.com/darius/requestAnimationFrame/blob/master/requestAnimationFrame.js
	// Adapted from https://gist.github.com/paulirish/1579671 which derived from
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	// requestAnimationFrame polyfill by Erik Möller.
	// Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon
	// MIT license
	if (!Date.now) {
	    /**
	   * Date.now polyfill.
	   * @return {number} the current Date
	   */
	    Date.now = function () {
	        return new Date().getTime();
	    };
	    Date['now'] = Date.now;
	}
	var vendors = [
	    'webkit',
	    'moz'
	];
	for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	    var vp = vendors[i];
	    window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
	    window['requestAnimationFrame'] = window.requestAnimationFrame;
	    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	}
	if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	    var lastTime = 0;
	    /**
	   * requestAnimationFrame polyfill.
	   * @param  {!Function} callback the callback function.
	   */
	    window.requestAnimationFrame = function (callback) {
	        var now = Date.now();
	        var nextTime = Math.max(lastTime + 16, now);
	        return setTimeout(function () {
	            callback(lastTime = nextTime);
	        }, nextTime - now);
	    };
	    window.cancelAnimationFrame = clearTimeout;
	    window['requestAnimationFrame'] = window.requestAnimationFrame;
	    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	}
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Button MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialButton = function MaterialButton(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialButton'] = MaterialButton;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialButton.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialButton.prototype.CssClasses_ = {
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_CONTAINER: 'mdl-button__ripple-container',
	    RIPPLE: 'mdl-ripple'
	};
	/**
	   * Handle blur of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialButton.prototype.blurHandler_ = function (event) {
	    if (event) {
	        this.element_.blur();
	    }
	};
	// Public methods.
	/**
	   * Disable button.
	   *
	   * @public
	   */
	MaterialButton.prototype.disable = function () {
	    this.element_.disabled = true;
	};
	MaterialButton.prototype['disable'] = MaterialButton.prototype.disable;
	/**
	   * Enable button.
	   *
	   * @public
	   */
	MaterialButton.prototype.enable = function () {
	    this.element_.disabled = false;
	};
	MaterialButton.prototype['enable'] = MaterialButton.prototype.enable;
	/**
	   * Initialize element.
	   */
	MaterialButton.prototype.init = function () {
	    if (this.element_) {
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            var rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleElement_ = document.createElement('span');
	            this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	            rippleContainer.appendChild(this.rippleElement_);
	            this.boundRippleBlurHandler = this.blurHandler_.bind(this);
	            this.rippleElement_.addEventListener('mouseup', this.boundRippleBlurHandler);
	            this.element_.appendChild(rippleContainer);
	        }
	        this.boundButtonBlurHandler = this.blurHandler_.bind(this);
	        this.element_.addEventListener('mouseup', this.boundButtonBlurHandler);
	        this.element_.addEventListener('mouseleave', this.boundButtonBlurHandler);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialButton,
	    classAsString: 'MaterialButton',
	    cssClass: 'mdl-js-button',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Checkbox MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialCheckbox = function MaterialCheckbox(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialCheckbox'] = MaterialCheckbox;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialCheckbox.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialCheckbox.prototype.CssClasses_ = {
	    INPUT: 'mdl-checkbox__input',
	    BOX_OUTLINE: 'mdl-checkbox__box-outline',
	    FOCUS_HELPER: 'mdl-checkbox__focus-helper',
	    TICK_OUTLINE: 'mdl-checkbox__tick-outline',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-checkbox__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialCheckbox.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialCheckbox.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the inputs toggle state and update display.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialCheckbox.prototype['checkToggleState'] = MaterialCheckbox.prototype.checkToggleState;
	/**
	   * Check the inputs disabled state and update display.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialCheckbox.prototype['checkDisabled'] = MaterialCheckbox.prototype.checkDisabled;
	/**
	   * Disable checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['disable'] = MaterialCheckbox.prototype.disable;
	/**
	   * Enable checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['enable'] = MaterialCheckbox.prototype.enable;
	/**
	   * Check checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.check = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['check'] = MaterialCheckbox.prototype.check;
	/**
	   * Uncheck checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.uncheck = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['uncheck'] = MaterialCheckbox.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialCheckbox.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        var boxOutline = document.createElement('span');
	        boxOutline.classList.add(this.CssClasses_.BOX_OUTLINE);
	        var tickContainer = document.createElement('span');
	        tickContainer.classList.add(this.CssClasses_.FOCUS_HELPER);
	        var tickOutline = document.createElement('span');
	        tickOutline.classList.add(this.CssClasses_.TICK_OUTLINE);
	        boxOutline.appendChild(tickOutline);
	        this.element_.appendChild(tickContainer);
	        this.element_.appendChild(boxOutline);
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundInputOnChange = this.onChange_.bind(this);
	        this.boundInputOnFocus = this.onFocus_.bind(this);
	        this.boundInputOnBlur = this.onBlur_.bind(this);
	        this.boundElementMouseUp = this.onMouseUp_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundInputOnChange);
	        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	        this.element_.addEventListener('mouseup', this.boundElementMouseUp);
	        this.updateClasses_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialCheckbox,
	    classAsString: 'MaterialCheckbox',
	    cssClass: 'mdl-js-checkbox',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for icon toggle MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialIconToggle = function MaterialIconToggle(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialIconToggle'] = MaterialIconToggle;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialIconToggle.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialIconToggle.prototype.CssClasses_ = {
	    INPUT: 'mdl-icon-toggle__input',
	    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-icon-toggle__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialIconToggle.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialIconToggle.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the inputs toggle state and update display.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialIconToggle.prototype['checkToggleState'] = MaterialIconToggle.prototype.checkToggleState;
	/**
	   * Check the inputs disabled state and update display.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialIconToggle.prototype['checkDisabled'] = MaterialIconToggle.prototype.checkDisabled;
	/**
	   * Disable icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['disable'] = MaterialIconToggle.prototype.disable;
	/**
	   * Enable icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['enable'] = MaterialIconToggle.prototype.enable;
	/**
	   * Check icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.check = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['check'] = MaterialIconToggle.prototype.check;
	/**
	   * Uncheck icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.uncheck = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['uncheck'] = MaterialIconToggle.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialIconToggle.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        if (this.element_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.JS_RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundInputOnChange = this.onChange_.bind(this);
	        this.boundInputOnFocus = this.onFocus_.bind(this);
	        this.boundInputOnBlur = this.onBlur_.bind(this);
	        this.boundElementOnMouseUp = this.onMouseUp_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundInputOnChange);
	        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	        this.element_.addEventListener('mouseup', this.boundElementOnMouseUp);
	        this.updateClasses_();
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialIconToggle,
	    classAsString: 'MaterialIconToggle',
	    cssClass: 'mdl-js-icon-toggle',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for dropdown MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialMenu = function MaterialMenu(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialMenu'] = MaterialMenu;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialMenu.prototype.Constant_ = {
	    // Total duration of the menu animation.
	    TRANSITION_DURATION_SECONDS: 0.3,
	    // The fraction of the total duration we want to use for menu item animations.
	    TRANSITION_DURATION_FRACTION: 0.8,
	    // How long the menu stays open after choosing an option (so the user can see
	    // the ripple).
	    CLOSE_TIMEOUT: 150
	};
	/**
	   * Keycodes, for code readability.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialMenu.prototype.Keycodes_ = {
	    ENTER: 13,
	    ESCAPE: 27,
	    SPACE: 32,
	    UP_ARROW: 38,
	    DOWN_ARROW: 40
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialMenu.prototype.CssClasses_ = {
	    CONTAINER: 'mdl-menu__container',
	    OUTLINE: 'mdl-menu__outline',
	    ITEM: 'mdl-menu__item',
	    ITEM_RIPPLE_CONTAINER: 'mdl-menu__item-ripple-container',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE: 'mdl-ripple',
	    // Statuses
	    IS_UPGRADED: 'is-upgraded',
	    IS_VISIBLE: 'is-visible',
	    IS_ANIMATING: 'is-animating',
	    // Alignment options
	    BOTTOM_LEFT: 'mdl-menu--bottom-left',
	    // This is the default.
	    BOTTOM_RIGHT: 'mdl-menu--bottom-right',
	    TOP_LEFT: 'mdl-menu--top-left',
	    TOP_RIGHT: 'mdl-menu--top-right',
	    UNALIGNED: 'mdl-menu--unaligned'
	};
	/**
	   * Initialize element.
	   */
	MaterialMenu.prototype.init = function () {
	    if (this.element_) {
	        // Create container for the menu.
	        var container = document.createElement('div');
	        container.classList.add(this.CssClasses_.CONTAINER);
	        this.element_.parentElement.insertBefore(container, this.element_);
	        this.element_.parentElement.removeChild(this.element_);
	        container.appendChild(this.element_);
	        this.container_ = container;
	        // Create outline for the menu (shadow and background).
	        var outline = document.createElement('div');
	        outline.classList.add(this.CssClasses_.OUTLINE);
	        this.outline_ = outline;
	        container.insertBefore(outline, this.element_);
	        // Find the "for" element and bind events to it.
	        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
	        var forEl = null;
	        if (forElId) {
	            forEl = document.getElementById(forElId);
	            if (forEl) {
	                this.forElement_ = forEl;
	                forEl.addEventListener('click', this.handleForClick_.bind(this));
	                forEl.addEventListener('keydown', this.handleForKeyboardEvent_.bind(this));
	            }
	        }
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        this.boundItemKeydown_ = this.handleItemKeyboardEvent_.bind(this);
	        this.boundItemClick_ = this.handleItemClick_.bind(this);
	        for (var i = 0; i < items.length; i++) {
	            // Add a listener to each menu item.
	            items[i].addEventListener('click', this.boundItemClick_);
	            // Add a tab index to each menu item.
	            items[i].tabIndex = '-1';
	            // Add a keyboard listener to each menu item.
	            items[i].addEventListener('keydown', this.boundItemKeydown_);
	        }
	        // Add ripple classes to each item, if the user has enabled ripples.
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            for (i = 0; i < items.length; i++) {
	                var item = items[i];
	                var rippleContainer = document.createElement('span');
	                rippleContainer.classList.add(this.CssClasses_.ITEM_RIPPLE_CONTAINER);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                rippleContainer.appendChild(ripple);
	                item.appendChild(rippleContainer);
	                item.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            }
	        }
	        // Copy alignment classes to the container, so the outline can use them.
	        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_LEFT)) {
	            this.outline_.classList.add(this.CssClasses_.BOTTOM_LEFT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	            this.outline_.classList.add(this.CssClasses_.BOTTOM_RIGHT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	            this.outline_.classList.add(this.CssClasses_.TOP_LEFT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	            this.outline_.classList.add(this.CssClasses_.TOP_RIGHT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	            this.outline_.classList.add(this.CssClasses_.UNALIGNED);
	        }
	        container.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	/**
	   * Handles a click on the "for" element, by positioning the menu and then
	   * toggling it.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleForClick_ = function (evt) {
	    if (this.element_ && this.forElement_) {
	        var rect = this.forElement_.getBoundingClientRect();
	        var forRect = this.forElement_.parentElement.getBoundingClientRect();
	        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	        } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	            // Position below the "for" element, aligned to its right.
	            this.container_.style.right = forRect.right - rect.right + 'px';
	            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	            // Position above the "for" element, aligned to its left.
	            this.container_.style.left = this.forElement_.offsetLeft + 'px';
	            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	            // Position above the "for" element, aligned to its right.
	            this.container_.style.right = forRect.right - rect.right + 'px';
	            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	        } else {
	            // Default: position below the "for" element, aligned to its left.
	            this.container_.style.left = this.forElement_.offsetLeft + 'px';
	            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	        }
	    }
	    this.toggle(evt);
	};
	/**
	   * Handles a keyboard event on the "for" element.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleForKeyboardEvent_ = function (evt) {
	    if (this.element_ && this.container_ && this.forElement_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                evt.preventDefault();
	                items[items.length - 1].focus();
	            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                evt.preventDefault();
	                items[0].focus();
	            }
	        }
	    }
	};
	/**
	   * Handles a keyboard event on an item.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleItemKeyboardEvent_ = function (evt) {
	    if (this.element_ && this.container_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	            var currentIndex = Array.prototype.slice.call(items).indexOf(evt.target);
	            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                evt.preventDefault();
	                if (currentIndex > 0) {
	                    items[currentIndex - 1].focus();
	                } else {
	                    items[items.length - 1].focus();
	                }
	            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                evt.preventDefault();
	                if (items.length > currentIndex + 1) {
	                    items[currentIndex + 1].focus();
	                } else {
	                    items[0].focus();
	                }
	            } else if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	                evt.preventDefault();
	                // Send mousedown and mouseup to trigger ripple.
	                var e = new MouseEvent('mousedown');
	                evt.target.dispatchEvent(e);
	                e = new MouseEvent('mouseup');
	                evt.target.dispatchEvent(e);
	                // Send click.
	                evt.target.click();
	            } else if (evt.keyCode === this.Keycodes_.ESCAPE) {
	                evt.preventDefault();
	                this.hide();
	            }
	        }
	    }
	};
	/**
	   * Handles a click event on an item.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleItemClick_ = function (evt) {
	    if (evt.target.hasAttribute('disabled')) {
	        evt.stopPropagation();
	    } else {
	        // Wait some time before closing menu, so the user can see the ripple.
	        this.closing_ = true;
	        window.setTimeout(function (evt) {
	            this.hide();
	            this.closing_ = false;
	        }.bind(this), this.Constant_.CLOSE_TIMEOUT);
	    }
	};
	/**
	   * Calculates the initial clip (for opening the menu) or final clip (for closing
	   * it), and applies it. This allows us to animate from or to the correct point,
	   * that is, the point it's aligned to in the "for" element.
	   *
	   * @param {number} height Height of the clip rectangle
	   * @param {number} width Width of the clip rectangle
	   * @private
	   */
	MaterialMenu.prototype.applyClip_ = function (height, width) {
	    if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	        // Do not clip.
	        this.element_.style.clip = '';
	    } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	        // Clip to the top right corner of the menu.
	        this.element_.style.clip = 'rect(0 ' + width + 'px ' + '0 ' + width + 'px)';
	    } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	        // Clip to the bottom left corner of the menu.
	        this.element_.style.clip = 'rect(' + height + 'px 0 ' + height + 'px 0)';
	    } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	        // Clip to the bottom right corner of the menu.
	        this.element_.style.clip = 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)';
	    } else {
	        // Default: do not clip (same as clipping to the top left corner).
	        this.element_.style.clip = '';
	    }
	};
	/**
	   * Cleanup function to remove animation listeners.
	   *
	   * @param {Event} evt
	   * @private
	   */
	MaterialMenu.prototype.removeAnimationEndListener_ = function (evt) {
	    evt.target.classList.remove(MaterialMenu.prototype.CssClasses_.IS_ANIMATING);
	};
	/**
	   * Adds an event listener to clean up after the animation ends.
	   *
	   * @private
	   */
	MaterialMenu.prototype.addAnimationEndListener_ = function () {
	    this.element_.addEventListener('transitionend', this.removeAnimationEndListener_);
	    this.element_.addEventListener('webkitTransitionEnd', this.removeAnimationEndListener_);
	};
	/**
	   * Displays the menu.
	   *
	   * @public
	   */
	MaterialMenu.prototype.show = function (evt) {
	    if (this.element_ && this.container_ && this.outline_) {
	        // Measure the inner element.
	        var height = this.element_.getBoundingClientRect().height;
	        var width = this.element_.getBoundingClientRect().width;
	        // Apply the inner element's size to the container and outline.
	        this.container_.style.width = width + 'px';
	        this.container_.style.height = height + 'px';
	        this.outline_.style.width = width + 'px';
	        this.outline_.style.height = height + 'px';
	        var transitionDuration = this.Constant_.TRANSITION_DURATION_SECONDS * this.Constant_.TRANSITION_DURATION_FRACTION;
	        // Calculate transition delays for individual menu items, so that they fade
	        // in one at a time.
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        for (var i = 0; i < items.length; i++) {
	            var itemDelay = null;
	            if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT) || this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	                itemDelay = (height - items[i].offsetTop - items[i].offsetHeight) / height * transitionDuration + 's';
	            } else {
	                itemDelay = items[i].offsetTop / height * transitionDuration + 's';
	            }
	            items[i].style.transitionDelay = itemDelay;
	        }
	        // Apply the initial clip to the text before we start animating.
	        this.applyClip_(height, width);
	        // Wait for the next frame, turn on animation, and apply the final clip.
	        // Also make it visible. This triggers the transitions.
	        window.requestAnimationFrame(function () {
	            this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	            this.element_.style.clip = 'rect(0 ' + width + 'px ' + height + 'px 0)';
	            this.container_.classList.add(this.CssClasses_.IS_VISIBLE);
	        }.bind(this));
	        // Clean up after the animation is complete.
	        this.addAnimationEndListener_();
	        // Add a click listener to the document, to close the menu.
	        var callback = function (e) {
	            // Check to see if the document is processing the same event that
	            // displayed the menu in the first place. If so, do nothing.
	            // Also check to see if the menu is in the process of closing itself, and
	            // do nothing in that case.
	            // Also check if the clicked element is a menu item
	            // if so, do nothing.
	            if (e !== evt && !this.closing_ && e.target.parentNode !== this.element_) {
	                document.removeEventListener('click', callback);
	                this.hide();
	            }
	        }.bind(this);
	        document.addEventListener('click', callback);
	    }
	};
	MaterialMenu.prototype['show'] = MaterialMenu.prototype.show;
	/**
	   * Hides the menu.
	   *
	   * @public
	   */
	MaterialMenu.prototype.hide = function () {
	    if (this.element_ && this.container_ && this.outline_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        // Remove all transition delays; menu items fade out concurrently.
	        for (var i = 0; i < items.length; i++) {
	            items[i].style.removeProperty('transition-delay');
	        }
	        // Measure the inner element.
	        var rect = this.element_.getBoundingClientRect();
	        var height = rect.height;
	        var width = rect.width;
	        // Turn on animation, and apply the final clip. Also make invisible.
	        // This triggers the transitions.
	        this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	        this.applyClip_(height, width);
	        this.container_.classList.remove(this.CssClasses_.IS_VISIBLE);
	        // Clean up after the animation is complete.
	        this.addAnimationEndListener_();
	    }
	};
	MaterialMenu.prototype['hide'] = MaterialMenu.prototype.hide;
	/**
	   * Displays or hides the menu, depending on current state.
	   *
	   * @public
	   */
	MaterialMenu.prototype.toggle = function (evt) {
	    if (this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	        this.hide();
	    } else {
	        this.show(evt);
	    }
	};
	MaterialMenu.prototype['toggle'] = MaterialMenu.prototype.toggle;
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialMenu,
	    classAsString: 'MaterialMenu',
	    cssClass: 'mdl-js-menu',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Progress MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialProgress = function MaterialProgress(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialProgress'] = MaterialProgress;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialProgress.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialProgress.prototype.CssClasses_ = { INDETERMINATE_CLASS: 'mdl-progress__indeterminate' };
	/**
	   * Set the current progress of the progressbar.
	   *
	   * @param {number} p Percentage of the progress (0-100)
	   * @public
	   */
	MaterialProgress.prototype.setProgress = function (p) {
	    if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) {
	        return;
	    }
	    this.progressbar_.style.width = p + '%';
	};
	MaterialProgress.prototype['setProgress'] = MaterialProgress.prototype.setProgress;
	/**
	   * Set the current progress of the buffer.
	   *
	   * @param {number} p Percentage of the buffer (0-100)
	   * @public
	   */
	MaterialProgress.prototype.setBuffer = function (p) {
	    this.bufferbar_.style.width = p + '%';
	    this.auxbar_.style.width = 100 - p + '%';
	};
	MaterialProgress.prototype['setBuffer'] = MaterialProgress.prototype.setBuffer;
	/**
	   * Initialize element.
	   */
	MaterialProgress.prototype.init = function () {
	    if (this.element_) {
	        var el = document.createElement('div');
	        el.className = 'progressbar bar bar1';
	        this.element_.appendChild(el);
	        this.progressbar_ = el;
	        el = document.createElement('div');
	        el.className = 'bufferbar bar bar2';
	        this.element_.appendChild(el);
	        this.bufferbar_ = el;
	        el = document.createElement('div');
	        el.className = 'auxbar bar bar3';
	        this.element_.appendChild(el);
	        this.auxbar_ = el;
	        this.progressbar_.style.width = '0%';
	        this.bufferbar_.style.width = '100%';
	        this.auxbar_.style.width = '0%';
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialProgress,
	    classAsString: 'MaterialProgress',
	    cssClass: 'mdl-js-progress',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Radio MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialRadio = function MaterialRadio(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialRadio'] = MaterialRadio;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialRadio.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialRadio.prototype.CssClasses_ = {
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked',
	    IS_UPGRADED: 'is-upgraded',
	    JS_RADIO: 'mdl-js-radio',
	    RADIO_BTN: 'mdl-radio__button',
	    RADIO_OUTER_CIRCLE: 'mdl-radio__outer-circle',
	    RADIO_INNER_CIRCLE: 'mdl-radio__inner-circle',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-radio__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onChange_ = function (event) {
	    // Since other radio buttons don't get change events, we need to look for
	    // them to update their classes.
	    var radios = document.getElementsByClassName(this.CssClasses_.JS_RADIO);
	    for (var i = 0; i < radios.length; i++) {
	        var button = radios[i].querySelector('.' + this.CssClasses_.RADIO_BTN);
	        // Different name == different group, so no point updating those.
	        if (button.getAttribute('name') === this.btnElement_.getAttribute('name')) {
	            radios[i]['MaterialRadio'].updateClasses_();
	        }
	    }
	};
	/**
	   * Handle focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onMouseup_ = function (event) {
	    this.blur_();
	};
	/**
	   * Update classes.
	   *
	   * @private
	   */
	MaterialRadio.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialRadio.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.btnElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the components disabled state.
	   *
	   * @public
	   */
	MaterialRadio.prototype.checkDisabled = function () {
	    if (this.btnElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialRadio.prototype['checkDisabled'] = MaterialRadio.prototype.checkDisabled;
	/**
	   * Check the components toggled state.
	   *
	   * @public
	   */
	MaterialRadio.prototype.checkToggleState = function () {
	    if (this.btnElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialRadio.prototype['checkToggleState'] = MaterialRadio.prototype.checkToggleState;
	/**
	   * Disable radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.disable = function () {
	    this.btnElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialRadio.prototype['disable'] = MaterialRadio.prototype.disable;
	/**
	   * Enable radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.enable = function () {
	    this.btnElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialRadio.prototype['enable'] = MaterialRadio.prototype.enable;
	/**
	   * Check radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.check = function () {
	    this.btnElement_.checked = true;
	    this.onChange_(null);
	};
	MaterialRadio.prototype['check'] = MaterialRadio.prototype.check;
	/**
	   * Uncheck radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.uncheck = function () {
	    this.btnElement_.checked = false;
	    this.onChange_(null);
	};
	MaterialRadio.prototype['uncheck'] = MaterialRadio.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialRadio.prototype.init = function () {
	    if (this.element_) {
	        this.btnElement_ = this.element_.querySelector('.' + this.CssClasses_.RADIO_BTN);
	        this.boundChangeHandler_ = this.onChange_.bind(this);
	        this.boundFocusHandler_ = this.onChange_.bind(this);
	        this.boundBlurHandler_ = this.onBlur_.bind(this);
	        this.boundMouseUpHandler_ = this.onMouseup_.bind(this);
	        var outerCircle = document.createElement('span');
	        outerCircle.classList.add(this.CssClasses_.RADIO_OUTER_CIRCLE);
	        var innerCircle = document.createElement('span');
	        innerCircle.classList.add(this.CssClasses_.RADIO_INNER_CIRCLE);
	        this.element_.appendChild(outerCircle);
	        this.element_.appendChild(innerCircle);
	        var rippleContainer;
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            rippleContainer.addEventListener('mouseup', this.boundMouseUpHandler_);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            rippleContainer.appendChild(ripple);
	            this.element_.appendChild(rippleContainer);
	        }
	        this.btnElement_.addEventListener('change', this.boundChangeHandler_);
	        this.btnElement_.addEventListener('focus', this.boundFocusHandler_);
	        this.btnElement_.addEventListener('blur', this.boundBlurHandler_);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler_);
	        this.updateClasses_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialRadio,
	    classAsString: 'MaterialRadio',
	    cssClass: 'mdl-js-radio',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Slider MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSlider = function MaterialSlider(element) {
	    this.element_ = element;
	    // Browser feature detection.
	    this.isIE_ = window.navigator.msPointerEnabled;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSlider'] = MaterialSlider;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSlider.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSlider.prototype.CssClasses_ = {
	    IE_CONTAINER: 'mdl-slider__ie-container',
	    SLIDER_CONTAINER: 'mdl-slider__container',
	    BACKGROUND_FLEX: 'mdl-slider__background-flex',
	    BACKGROUND_LOWER: 'mdl-slider__background-lower',
	    BACKGROUND_UPPER: 'mdl-slider__background-upper',
	    IS_LOWEST_VALUE: 'is-lowest-value',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Handle input on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onInput_ = function (event) {
	    this.updateValueStyles_();
	};
	/**
	   * Handle change on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onChange_ = function (event) {
	    this.updateValueStyles_();
	};
	/**
	   * Handle mouseup on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onMouseUp_ = function (event) {
	    event.target.blur();
	};
	/**
	   * Handle mousedown on container element.
	   * This handler is purpose is to not require the use to click
	   * exactly on the 2px slider element, as FireFox seems to be very
	   * strict about this.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   * @suppress {missingProperties}
	   */
	MaterialSlider.prototype.onContainerMouseDown_ = function (event) {
	    // If this click is not on the parent element (but rather some child)
	    // ignore. It may still bubble up.
	    if (event.target !== this.element_.parentElement) {
	        return;
	    }
	    // Discard the original event and create a new event that
	    // is on the slider element.
	    event.preventDefault();
	    var newEvent = new MouseEvent('mousedown', {
	        target: event.target,
	        buttons: event.buttons,
	        clientX: event.clientX,
	        clientY: this.element_.getBoundingClientRect().y
	    });
	    this.element_.dispatchEvent(newEvent);
	};
	/**
	   * Handle updating of values.
	   *
	   * @private
	   */
	MaterialSlider.prototype.updateValueStyles_ = function () {
	    // Calculate and apply percentages to div structure behind slider.
	    var fraction = (this.element_.value - this.element_.min) / (this.element_.max - this.element_.min);
	    if (fraction === 0) {
	        this.element_.classList.add(this.CssClasses_.IS_LOWEST_VALUE);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_LOWEST_VALUE);
	    }
	    if (!this.isIE_) {
	        this.backgroundLower_.style.flex = fraction;
	        this.backgroundLower_.style.webkitFlex = fraction;
	        this.backgroundUpper_.style.flex = 1 - fraction;
	        this.backgroundUpper_.style.webkitFlex = 1 - fraction;
	    }
	};
	// Public methods.
	/**
	   * Disable slider.
	   *
	   * @public
	   */
	MaterialSlider.prototype.disable = function () {
	    this.element_.disabled = true;
	};
	MaterialSlider.prototype['disable'] = MaterialSlider.prototype.disable;
	/**
	   * Enable slider.
	   *
	   * @public
	   */
	MaterialSlider.prototype.enable = function () {
	    this.element_.disabled = false;
	};
	MaterialSlider.prototype['enable'] = MaterialSlider.prototype.enable;
	/**
	   * Update slider value.
	   *
	   * @param {number} value The value to which to set the control (optional).
	   * @public
	   */
	MaterialSlider.prototype.change = function (value) {
	    if (typeof value !== 'undefined') {
	        this.element_.value = value;
	    }
	    this.updateValueStyles_();
	};
	MaterialSlider.prototype['change'] = MaterialSlider.prototype.change;
	/**
	   * Initialize element.
	   */
	MaterialSlider.prototype.init = function () {
	    if (this.element_) {
	        if (this.isIE_) {
	            // Since we need to specify a very large height in IE due to
	            // implementation limitations, we add a parent here that trims it down to
	            // a reasonable size.
	            var containerIE = document.createElement('div');
	            containerIE.classList.add(this.CssClasses_.IE_CONTAINER);
	            this.element_.parentElement.insertBefore(containerIE, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            containerIE.appendChild(this.element_);
	        } else {
	            // For non-IE browsers, we need a div structure that sits behind the
	            // slider and allows us to style the left and right sides of it with
	            // different colors.
	            var container = document.createElement('div');
	            container.classList.add(this.CssClasses_.SLIDER_CONTAINER);
	            this.element_.parentElement.insertBefore(container, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            container.appendChild(this.element_);
	            var backgroundFlex = document.createElement('div');
	            backgroundFlex.classList.add(this.CssClasses_.BACKGROUND_FLEX);
	            container.appendChild(backgroundFlex);
	            this.backgroundLower_ = document.createElement('div');
	            this.backgroundLower_.classList.add(this.CssClasses_.BACKGROUND_LOWER);
	            backgroundFlex.appendChild(this.backgroundLower_);
	            this.backgroundUpper_ = document.createElement('div');
	            this.backgroundUpper_.classList.add(this.CssClasses_.BACKGROUND_UPPER);
	            backgroundFlex.appendChild(this.backgroundUpper_);
	        }
	        this.boundInputHandler = this.onInput_.bind(this);
	        this.boundChangeHandler = this.onChange_.bind(this);
	        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	        this.boundContainerMouseDownHandler = this.onContainerMouseDown_.bind(this);
	        this.element_.addEventListener('input', this.boundInputHandler);
	        this.element_.addEventListener('change', this.boundChangeHandler);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	        this.element_.parentElement.addEventListener('mousedown', this.boundContainerMouseDownHandler);
	        this.updateValueStyles_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSlider,
	    classAsString: 'MaterialSlider',
	    cssClass: 'mdl-js-slider',
	    widget: true
	});
	/**
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Snackbar MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSnackbar = function MaterialSnackbar(element) {
	    this.element_ = element;
	    this.textElement_ = this.element_.querySelector('.' + this.cssClasses_.MESSAGE);
	    this.actionElement_ = this.element_.querySelector('.' + this.cssClasses_.ACTION);
	    if (!this.textElement_) {
	        throw new Error('There must be a message element for a snackbar.');
	    }
	    if (!this.actionElement_) {
	        throw new Error('There must be an action element for a snackbar.');
	    }
	    this.active = false;
	    this.actionHandler_ = undefined;
	    this.message_ = undefined;
	    this.actionText_ = undefined;
	    this.queuedNotifications_ = [];
	    this.setActionHidden_(true);
	};
	window['MaterialSnackbar'] = MaterialSnackbar;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSnackbar.prototype.Constant_ = {
	    // The duration of the snackbar show/hide animation, in ms.
	    ANIMATION_LENGTH: 250
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSnackbar.prototype.cssClasses_ = {
	    SNACKBAR: 'mdl-snackbar',
	    MESSAGE: 'mdl-snackbar__text',
	    ACTION: 'mdl-snackbar__action',
	    ACTIVE: 'mdl-snackbar--active'
	};
	/**
	   * Display the snackbar.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.displaySnackbar_ = function () {
	    this.element_.setAttribute('aria-hidden', 'true');
	    if (this.actionHandler_) {
	        this.actionElement_.textContent = this.actionText_;
	        this.actionElement_.addEventListener('click', this.actionHandler_);
	        this.setActionHidden_(false);
	    }
	    this.textElement_.textContent = this.message_;
	    this.element_.classList.add(this.cssClasses_.ACTIVE);
	    this.element_.setAttribute('aria-hidden', 'false');
	    setTimeout(this.cleanup_.bind(this), this.timeout_);
	};
	/**
	   * Show the snackbar.
	   *
	   * @param {Object} data The data for the notification.
	   * @public
	   */
	MaterialSnackbar.prototype.showSnackbar = function (data) {
	    if (data === undefined) {
	        throw new Error('Please provide a data object with at least a message to display.');
	    }
	    if (data['message'] === undefined) {
	        throw new Error('Please provide a message to be displayed.');
	    }
	    if (data['actionHandler'] && !data['actionText']) {
	        throw new Error('Please provide action text with the handler.');
	    }
	    if (this.active) {
	        this.queuedNotifications_.push(data);
	    } else {
	        this.active = true;
	        this.message_ = data['message'];
	        if (data['timeout']) {
	            this.timeout_ = data['timeout'];
	        } else {
	            this.timeout_ = 2750;
	        }
	        if (data['actionHandler']) {
	            this.actionHandler_ = data['actionHandler'];
	        }
	        if (data['actionText']) {
	            this.actionText_ = data['actionText'];
	        }
	        this.displaySnackbar_();
	    }
	};
	MaterialSnackbar.prototype['showSnackbar'] = MaterialSnackbar.prototype.showSnackbar;
	/**
	   * Check if the queue has items within it.
	   * If it does, display the next entry.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.checkQueue_ = function () {
	    if (this.queuedNotifications_.length > 0) {
	        this.showSnackbar(this.queuedNotifications_.shift());
	    }
	};
	/**
	   * Cleanup the snackbar event listeners and accessiblity attributes.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.cleanup_ = function () {
	    this.element_.classList.remove(this.cssClasses_.ACTIVE);
	    setTimeout(function () {
	        this.element_.setAttribute('aria-hidden', 'true');
	        this.textElement_.textContent = '';
	        if (!Boolean(this.actionElement_.getAttribute('aria-hidden'))) {
	            this.setActionHidden_(true);
	            this.actionElement_.textContent = '';
	            this.actionElement_.removeEventListener('click', this.actionHandler_);
	        }
	        this.actionHandler_ = undefined;
	        this.message_ = undefined;
	        this.actionText_ = undefined;
	        this.active = false;
	        this.checkQueue_();
	    }.bind(this), this.Constant_.ANIMATION_LENGTH);
	};
	/**
	   * Set the action handler hidden state.
	   *
	   * @param {boolean} value
	   * @private
	   */
	MaterialSnackbar.prototype.setActionHidden_ = function (value) {
	    if (value) {
	        this.actionElement_.setAttribute('aria-hidden', 'true');
	    } else {
	        this.actionElement_.removeAttribute('aria-hidden');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSnackbar,
	    classAsString: 'MaterialSnackbar',
	    cssClass: 'mdl-js-snackbar',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Spinner MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @param {HTMLElement} element The element that will be upgraded.
	   * @constructor
	   */
	var MaterialSpinner = function MaterialSpinner(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSpinner'] = MaterialSpinner;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSpinner.prototype.Constant_ = { MDL_SPINNER_LAYER_COUNT: 4 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSpinner.prototype.CssClasses_ = {
	    MDL_SPINNER_LAYER: 'mdl-spinner__layer',
	    MDL_SPINNER_CIRCLE_CLIPPER: 'mdl-spinner__circle-clipper',
	    MDL_SPINNER_CIRCLE: 'mdl-spinner__circle',
	    MDL_SPINNER_GAP_PATCH: 'mdl-spinner__gap-patch',
	    MDL_SPINNER_LEFT: 'mdl-spinner__left',
	    MDL_SPINNER_RIGHT: 'mdl-spinner__right'
	};
	/**
	   * Auxiliary method to create a spinner layer.
	   *
	   * @param {number} index Index of the layer to be created.
	   * @public
	   */
	MaterialSpinner.prototype.createLayer = function (index) {
	    var layer = document.createElement('div');
	    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);
	    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + '-' + index);
	    var leftClipper = document.createElement('div');
	    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);
	    var gapPatch = document.createElement('div');
	    gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);
	    var rightClipper = document.createElement('div');
	    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);
	    var circleOwners = [
	        leftClipper,
	        gapPatch,
	        rightClipper
	    ];
	    for (var i = 0; i < circleOwners.length; i++) {
	        var circle = document.createElement('div');
	        circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);
	        circleOwners[i].appendChild(circle);
	    }
	    layer.appendChild(leftClipper);
	    layer.appendChild(gapPatch);
	    layer.appendChild(rightClipper);
	    this.element_.appendChild(layer);
	};
	MaterialSpinner.prototype['createLayer'] = MaterialSpinner.prototype.createLayer;
	/**
	   * Stops the spinner animation.
	   * Public method for users who need to stop the spinner for any reason.
	   *
	   * @public
	   */
	MaterialSpinner.prototype.stop = function () {
	    this.element_.classList.remove('is-active');
	};
	MaterialSpinner.prototype['stop'] = MaterialSpinner.prototype.stop;
	/**
	   * Starts the spinner animation.
	   * Public method for users who need to manually start the spinner for any reason
	   * (instead of just adding the 'is-active' class to their markup).
	   *
	   * @public
	   */
	MaterialSpinner.prototype.start = function () {
	    this.element_.classList.add('is-active');
	};
	MaterialSpinner.prototype['start'] = MaterialSpinner.prototype.start;
	/**
	   * Initialize element.
	   */
	MaterialSpinner.prototype.init = function () {
	    if (this.element_) {
	        for (var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++) {
	            this.createLayer(i);
	        }
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSpinner,
	    classAsString: 'MaterialSpinner',
	    cssClass: 'mdl-js-spinner',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Checkbox MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSwitch = function MaterialSwitch(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSwitch'] = MaterialSwitch;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSwitch.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSwitch.prototype.CssClasses_ = {
	    INPUT: 'mdl-switch__input',
	    TRACK: 'mdl-switch__track',
	    THUMB: 'mdl-switch__thumb',
	    FOCUS_HELPER: 'mdl-switch__focus-helper',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-switch__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialSwitch.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialSwitch.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the components disabled state.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialSwitch.prototype['checkDisabled'] = MaterialSwitch.prototype.checkDisabled;
	/**
	   * Check the components toggled state.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialSwitch.prototype['checkToggleState'] = MaterialSwitch.prototype.checkToggleState;
	/**
	   * Disable switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['disable'] = MaterialSwitch.prototype.disable;
	/**
	   * Enable switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['enable'] = MaterialSwitch.prototype.enable;
	/**
	   * Activate switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.on = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['on'] = MaterialSwitch.prototype.on;
	/**
	   * Deactivate switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.off = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['off'] = MaterialSwitch.prototype.off;
	/**
	   * Initialize element.
	   */
	MaterialSwitch.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        var track = document.createElement('div');
	        track.classList.add(this.CssClasses_.TRACK);
	        var thumb = document.createElement('div');
	        thumb.classList.add(this.CssClasses_.THUMB);
	        var focusHelper = document.createElement('span');
	        focusHelper.classList.add(this.CssClasses_.FOCUS_HELPER);
	        thumb.appendChild(focusHelper);
	        this.element_.appendChild(track);
	        this.element_.appendChild(thumb);
	        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundMouseUpHandler);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundChangeHandler = this.onChange_.bind(this);
	        this.boundFocusHandler = this.onFocus_.bind(this);
	        this.boundBlurHandler = this.onBlur_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundChangeHandler);
	        this.inputElement_.addEventListener('focus', this.boundFocusHandler);
	        this.inputElement_.addEventListener('blur', this.boundBlurHandler);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	        this.updateClasses_();
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSwitch,
	    classAsString: 'MaterialSwitch',
	    cssClass: 'mdl-js-switch',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Tabs MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {Element} element The element that will be upgraded.
	   */
	var MaterialTabs = function MaterialTabs(element) {
	    // Stores the HTML element.
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTabs'] = MaterialTabs;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTabs.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTabs.prototype.CssClasses_ = {
	    TAB_CLASS: 'mdl-tabs__tab',
	    PANEL_CLASS: 'mdl-tabs__panel',
	    ACTIVE_CLASS: 'is-active',
	    UPGRADED_CLASS: 'is-upgraded',
	    MDL_JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    MDL_RIPPLE_CONTAINER: 'mdl-tabs__ripple-container',
	    MDL_RIPPLE: 'mdl-ripple',
	    MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events'
	};
	/**
	   * Handle clicks to a tabs component
	   *
	   * @private
	   */
	MaterialTabs.prototype.initTabs_ = function () {
	    if (this.element_.classList.contains(this.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	        this.element_.classList.add(this.CssClasses_.MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS);
	    }
	    // Select element tabs, document panels
	    this.tabs_ = this.element_.querySelectorAll('.' + this.CssClasses_.TAB_CLASS);
	    this.panels_ = this.element_.querySelectorAll('.' + this.CssClasses_.PANEL_CLASS);
	    // Create new tabs for each tab element
	    for (var i = 0; i < this.tabs_.length; i++) {
	        new MaterialTab(this.tabs_[i], this);
	    }
	    this.element_.classList.add(this.CssClasses_.UPGRADED_CLASS);
	};
	/**
	   * Reset tab state, dropping active classes
	   *
	   * @private
	   */
	MaterialTabs.prototype.resetTabState_ = function () {
	    for (var k = 0; k < this.tabs_.length; k++) {
	        this.tabs_[k].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	    }
	};
	/**
	   * Reset panel state, droping active classes
	   *
	   * @private
	   */
	MaterialTabs.prototype.resetPanelState_ = function () {
	    for (var j = 0; j < this.panels_.length; j++) {
	        this.panels_[j].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	    }
	};
	/**
	   * Initialize element.
	   */
	MaterialTabs.prototype.init = function () {
	    if (this.element_) {
	        this.initTabs_();
	    }
	};
	/**
	   * Constructor for an individual tab.
	   *
	   * @constructor
	   * @param {Element} tab The HTML element for the tab.
	   * @param {MaterialTabs} ctx The MaterialTabs object that owns the tab.
	   */
	function MaterialTab(tab, ctx) {
	    if (tab) {
	        if (ctx.element_.classList.contains(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	            var rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(ctx.CssClasses_.MDL_RIPPLE_CONTAINER);
	            rippleContainer.classList.add(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT);
	            var ripple = document.createElement('span');
	            ripple.classList.add(ctx.CssClasses_.MDL_RIPPLE);
	            rippleContainer.appendChild(ripple);
	            tab.appendChild(rippleContainer);
	        }
	        tab.addEventListener('click', function (e) {
	            e.preventDefault();
	            ctx.resetTabState_();
	            tab.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
	        });
	    }
	}
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTabs,
	    classAsString: 'MaterialTabs',
	    cssClass: 'mdl-js-tabs'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Textfield MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialTextfield = function MaterialTextfield(element) {
	    this.element_ = element;
	    this.maxRows = this.Constant_.NO_MAX_ROWS;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTextfield'] = MaterialTextfield;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialTextfield.prototype.Constant_ = {
	    NO_MAX_ROWS: -1,
	    MAX_ROWS_ATTRIBUTE: 'maxrows'
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTextfield.prototype.CssClasses_ = {
	    LABEL: 'mdl-textfield__label',
	    INPUT: 'mdl-textfield__input',
	    IS_DIRTY: 'is-dirty',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_INVALID: 'is-invalid',
	    IS_UPGRADED: 'is-upgraded',
	    HAS_PLACEHOLDER: 'has-placeholder'
	};
	/**
	   * Handle input being entered.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onKeyDown_ = function (event) {
	    var currentRowCount = event.target.value.split('\n').length;
	    if (event.keyCode === 13) {
	        if (currentRowCount >= this.maxRows) {
	            event.preventDefault();
	        }
	    }
	};
	/**
	   * Handle focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle reset event from out side.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onReset_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialTextfield.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkValidity();
	    this.checkDirty();
	    this.checkFocus();
	};
	// Public methods.
	/**
	   * Check the disabled state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkDisabled = function () {
	    if (this.input_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialTextfield.prototype['checkDisabled'] = MaterialTextfield.prototype.checkDisabled;
	/**
	  * Check the focus state and update field accordingly.
	  *
	  * @public
	  */
	MaterialTextfield.prototype.checkFocus = function () {
	    if (Boolean(this.element_.querySelector(':focus'))) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    }
	};
	MaterialTextfield.prototype['checkFocus'] = MaterialTextfield.prototype.checkFocus;
	/**
	   * Check the validity state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkValidity = function () {
	    if (this.input_.validity) {
	        if (this.input_.validity.valid) {
	            this.element_.classList.remove(this.CssClasses_.IS_INVALID);
	        } else {
	            this.element_.classList.add(this.CssClasses_.IS_INVALID);
	        }
	    }
	};
	MaterialTextfield.prototype['checkValidity'] = MaterialTextfield.prototype.checkValidity;
	/**
	   * Check the dirty state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkDirty = function () {
	    if (this.input_.value && this.input_.value.length > 0) {
	        this.element_.classList.add(this.CssClasses_.IS_DIRTY);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
	    }
	};
	MaterialTextfield.prototype['checkDirty'] = MaterialTextfield.prototype.checkDirty;
	/**
	   * Disable text field.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.disable = function () {
	    this.input_.disabled = true;
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['disable'] = MaterialTextfield.prototype.disable;
	/**
	   * Enable text field.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.enable = function () {
	    this.input_.disabled = false;
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['enable'] = MaterialTextfield.prototype.enable;
	/**
	   * Update text field value.
	   *
	   * @param {string} value The value to which to set the control (optional).
	   * @public
	   */
	MaterialTextfield.prototype.change = function (value) {
	    this.input_.value = value || '';
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['change'] = MaterialTextfield.prototype.change;
	/**
	   * Initialize element.
	   */
	MaterialTextfield.prototype.init = function () {
	    if (this.element_) {
	        this.label_ = this.element_.querySelector('.' + this.CssClasses_.LABEL);
	        this.input_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        if (this.input_) {
	            if (this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)) {
	                this.maxRows = parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE), 10);
	                if (isNaN(this.maxRows)) {
	                    this.maxRows = this.Constant_.NO_MAX_ROWS;
	                }
	            }
	            if (this.input_.hasAttribute('placeholder')) {
	                this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);
	            }
	            this.boundUpdateClassesHandler = this.updateClasses_.bind(this);
	            this.boundFocusHandler = this.onFocus_.bind(this);
	            this.boundBlurHandler = this.onBlur_.bind(this);
	            this.boundResetHandler = this.onReset_.bind(this);
	            this.input_.addEventListener('input', this.boundUpdateClassesHandler);
	            this.input_.addEventListener('focus', this.boundFocusHandler);
	            this.input_.addEventListener('blur', this.boundBlurHandler);
	            this.input_.addEventListener('reset', this.boundResetHandler);
	            if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
	                // TODO: This should handle pasting multi line text.
	                // Currently doesn't.
	                this.boundKeyDownHandler = this.onKeyDown_.bind(this);
	                this.input_.addEventListener('keydown', this.boundKeyDownHandler);
	            }
	            var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);
	            this.updateClasses_();
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	            if (invalid) {
	                this.element_.classList.add(this.CssClasses_.IS_INVALID);
	            }
	            if (this.input_.hasAttribute('autofocus')) {
	                this.element_.focus();
	                this.checkFocus();
	            }
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTextfield,
	    classAsString: 'MaterialTextfield',
	    cssClass: 'mdl-js-textfield',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Tooltip MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialTooltip = function MaterialTooltip(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTooltip'] = MaterialTooltip;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialTooltip.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTooltip.prototype.CssClasses_ = {
	    IS_ACTIVE: 'is-active',
	    BOTTOM: 'mdl-tooltip--bottom',
	    LEFT: 'mdl-tooltip--left',
	    RIGHT: 'mdl-tooltip--right',
	    TOP: 'mdl-tooltip--top'
	};
	/**
	   * Handle mouseenter for tooltip.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTooltip.prototype.handleMouseEnter_ = function (event) {
	    var props = event.target.getBoundingClientRect();
	    var left = props.left + props.width / 2;
	    var top = props.top + props.height / 2;
	    var marginLeft = -1 * (this.element_.offsetWidth / 2);
	    var marginTop = -1 * (this.element_.offsetHeight / 2);
	    if (this.element_.classList.contains(this.CssClasses_.LEFT) || this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	        left = props.width / 2;
	        if (top + marginTop < 0) {
	            this.element_.style.top = '0';
	            this.element_.style.marginTop = '0';
	        } else {
	            this.element_.style.top = top + 'px';
	            this.element_.style.marginTop = marginTop + 'px';
	        }
	    } else {
	        if (left + marginLeft < 0) {
	            this.element_.style.left = '0';
	            this.element_.style.marginLeft = '0';
	        } else {
	            this.element_.style.left = left + 'px';
	            this.element_.style.marginLeft = marginLeft + 'px';
	        }
	    }
	    if (this.element_.classList.contains(this.CssClasses_.TOP)) {
	        this.element_.style.top = props.top - this.element_.offsetHeight - 10 + 'px';
	    } else if (this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	        this.element_.style.left = props.left + props.width + 10 + 'px';
	    } else if (this.element_.classList.contains(this.CssClasses_.LEFT)) {
	        this.element_.style.left = props.left - this.element_.offsetWidth - 10 + 'px';
	    } else {
	        this.element_.style.top = props.top + props.height + 10 + 'px';
	    }
	    this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
	};
	/**
	   * Hide tooltip on mouseleave or scroll
	   *
	   * @private
	   */
	MaterialTooltip.prototype.hideTooltip_ = function () {
	    this.element_.classList.remove(this.CssClasses_.IS_ACTIVE);
	};
	/**
	   * Initialize element.
	   */
	MaterialTooltip.prototype.init = function () {
	    if (this.element_) {
	        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
	        if (forElId) {
	            this.forElement_ = document.getElementById(forElId);
	        }
	        if (this.forElement_) {
	            // It's left here because it prevents accidental text selection on Android
	            if (!this.forElement_.hasAttribute('tabindex')) {
	                this.forElement_.setAttribute('tabindex', '0');
	            }
	            this.boundMouseEnterHandler = this.handleMouseEnter_.bind(this);
	            this.boundMouseLeaveAndScrollHandler = this.hideTooltip_.bind(this);
	            this.forElement_.addEventListener('mouseenter', this.boundMouseEnterHandler, false);
	            this.forElement_.addEventListener('touchend', this.boundMouseEnterHandler, false);
	            this.forElement_.addEventListener('mouseleave', this.boundMouseLeaveAndScrollHandler, false);
	            window.addEventListener('scroll', this.boundMouseLeaveAndScrollHandler, true);
	            window.addEventListener('touchstart', this.boundMouseLeaveAndScrollHandler);
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTooltip,
	    classAsString: 'MaterialTooltip',
	    cssClass: 'mdl-tooltip'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Layout MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialLayout = function MaterialLayout(element) {
	    this.element_ = element;
	    this.innerContainer_ = element.querySelector('.' + this.CssClasses_.INNER_CONTAINER);
	    // Initialize instance.
	    this.init();
	};
	window['MaterialLayout'] = MaterialLayout;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialLayout.prototype.Constant_ = {
	    MAX_WIDTH: '(max-width: 1024px)',
	    TAB_SCROLL_PIXELS: 100,
	    RESIZE_TIMEOUT: 100,
	    MENU_ICON: '&#xE5D2;',
	    CHEVRON_LEFT: 'chevron_left',
	    CHEVRON_RIGHT: 'chevron_right'
	};
	/**
	   * Keycodes, for code readability.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialLayout.prototype.Keycodes_ = {
	    ENTER: 13,
	    ESCAPE: 27,
	    SPACE: 32
	};
	/**
	   * Modes.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialLayout.prototype.Mode_ = {
	    STANDARD: 0,
	    SEAMED: 1,
	    WATERFALL: 2,
	    SCROLL: 3
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialLayout.prototype.CssClasses_ = {
	    INNER_CONTAINER: 'mdl-layout__inner-container',
	    HEADER: 'mdl-layout__header',
	    DRAWER: 'mdl-layout__drawer',
	    CONTENT: 'mdl-layout__content',
	    DRAWER_BTN: 'mdl-layout__drawer-button',
	    ICON: 'material-icons',
	    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_CONTAINER: 'mdl-layout__tab-ripple-container',
	    RIPPLE: 'mdl-ripple',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    HEADER_SEAMED: 'mdl-layout__header--seamed',
	    HEADER_WATERFALL: 'mdl-layout__header--waterfall',
	    HEADER_SCROLL: 'mdl-layout__header--scroll',
	    FIXED_HEADER: 'mdl-layout--fixed-header',
	    OBFUSCATOR: 'mdl-layout__obfuscator',
	    TAB_BAR: 'mdl-layout__tab-bar',
	    TAB_CONTAINER: 'mdl-layout__tab-bar-container',
	    TAB: 'mdl-layout__tab',
	    TAB_BAR_BUTTON: 'mdl-layout__tab-bar-button',
	    TAB_BAR_LEFT_BUTTON: 'mdl-layout__tab-bar-left-button',
	    TAB_BAR_RIGHT_BUTTON: 'mdl-layout__tab-bar-right-button',
	    PANEL: 'mdl-layout__tab-panel',
	    HAS_DRAWER: 'has-drawer',
	    HAS_TABS: 'has-tabs',
	    HAS_SCROLLING_HEADER: 'has-scrolling-header',
	    CASTING_SHADOW: 'is-casting-shadow',
	    IS_COMPACT: 'is-compact',
	    IS_SMALL_SCREEN: 'is-small-screen',
	    IS_DRAWER_OPEN: 'is-visible',
	    IS_ACTIVE: 'is-active',
	    IS_UPGRADED: 'is-upgraded',
	    IS_ANIMATING: 'is-animating',
	    ON_LARGE_SCREEN: 'mdl-layout--large-screen-only',
	    ON_SMALL_SCREEN: 'mdl-layout--small-screen-only'
	};
	/**
	   * Handles scrolling on the content.
	   *
	   * @private
	   */
	MaterialLayout.prototype.contentScrollHandler_ = function () {
	    if (this.header_.classList.contains(this.CssClasses_.IS_ANIMATING)) {
	        return;
	    }
	    var headerVisible = !this.element_.classList.contains(this.CssClasses_.IS_SMALL_SCREEN) || this.element_.classList.contains(this.CssClasses_.FIXED_HEADER);
	    if (this.content_.scrollTop > 0 && !this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	        this.header_.classList.add(this.CssClasses_.IS_COMPACT);
	        if (headerVisible) {
	            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	        }
	    } else if (this.content_.scrollTop <= 0 && this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	        if (headerVisible) {
	            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	        }
	    }
	};
	/**
	   * Handles a keyboard event on the drawer.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialLayout.prototype.keyboardEventHandler_ = function (evt) {
	    // Only react when the drawer is open.
	    if (evt.keyCode === this.Keycodes_.ESCAPE && this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
	        this.toggleDrawer();
	    }
	};
	/**
	   * Handles changes in screen size.
	   *
	   * @private
	   */
	MaterialLayout.prototype.screenSizeHandler_ = function () {
	    if (this.screenSizeMediaQuery_.matches) {
	        this.element_.classList.add(this.CssClasses_.IS_SMALL_SCREEN);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_SMALL_SCREEN);
	        // Collapse drawer (if any) when moving to a large screen size.
	        if (this.drawer_) {
	            this.drawer_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	            this.obfuscator_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	        }
	    }
	};
	/**
	   * Handles events of drawer button.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialLayout.prototype.drawerToggleHandler_ = function (evt) {
	    if (evt && evt.type === 'keydown') {
	        if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	            // prevent scrolling in drawer nav
	            evt.preventDefault();
	        } else {
	            // prevent other keys
	            return;
	        }
	    }
	    this.toggleDrawer();
	};
	/**
	   * Handles (un)setting the `is-animating` class
	   *
	   * @private
	   */
	MaterialLayout.prototype.headerTransitionEndHandler_ = function () {
	    this.header_.classList.remove(this.CssClasses_.IS_ANIMATING);
	};
	/**
	   * Handles expanding the header on click
	   *
	   * @private
	   */
	MaterialLayout.prototype.headerClickHandler_ = function () {
	    if (this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	        this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	    }
	};
	/**
	   * Reset tab state, dropping active classes
	   *
	   * @private
	   */
	MaterialLayout.prototype.resetTabState_ = function (tabBar) {
	    for (var k = 0; k < tabBar.length; k++) {
	        tabBar[k].classList.remove(this.CssClasses_.IS_ACTIVE);
	    }
	};
	/**
	   * Reset panel state, droping active classes
	   *
	   * @private
	   */
	MaterialLayout.prototype.resetPanelState_ = function (panels) {
	    for (var j = 0; j < panels.length; j++) {
	        panels[j].classList.remove(this.CssClasses_.IS_ACTIVE);
	    }
	};
	/**
	  * Toggle drawer state
	  *
	  * @public
	  */
	MaterialLayout.prototype.toggleDrawer = function () {
	    var drawerButton = this.innerContainer_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	    this.drawer_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	    this.obfuscator_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	    // Set accessibility properties.
	    if (this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
	        this.drawer_.setAttribute('aria-hidden', 'false');
	        drawerButton.setAttribute('aria-expanded', 'true');
	    } else {
	        this.drawer_.setAttribute('aria-hidden', 'true');
	        drawerButton.setAttribute('aria-expanded', 'false');
	    }
	};
	MaterialLayout.prototype['toggleDrawer'] = MaterialLayout.prototype.toggleDrawer;
	/**
	   * Initialize element.
	   */
	MaterialLayout.prototype.init = function () {
	    if (this.element_) {
	        var focusedElement = this.element_.querySelector(':focus');
	        if (focusedElement) {
	            focusedElement.focus();
	        }
	        var directChildren = this.innerContainer_.childNodes;
	        var numChildren = directChildren.length;
	        for (var c = 0; c < numChildren; c++) {
	            var child = directChildren[c];
	            if (child.classList && child.classList.contains(this.CssClasses_.HEADER)) {
	                this.header_ = child;
	            }
	            if (child.classList && child.classList.contains(this.CssClasses_.DRAWER)) {
	                this.drawer_ = child;
	            }
	            if (child.classList && child.classList.contains(this.CssClasses_.CONTENT)) {
	                this.content_ = child;
	            }
	        }
	        window.addEventListener('pageshow', function (e) {
	            if (e.persisted) {
	                // when page is loaded from back/forward cache
	                // trigger repaint to let layout scroll in safari
	                this.innerContainer_.style.overflowY = 'hidden';
	                requestAnimationFrame(function () {
	                    this.innerContainer_.style.overflowY = '';
	                }.bind(this));
	            }
	        }.bind(this), false);
	        if (this.header_) {
	            this.tabBar_ = this.header_.querySelector('.' + this.CssClasses_.TAB_BAR);
	        }
	        var mode = this.Mode_.STANDARD;
	        if (this.header_) {
	            if (this.header_.classList.contains(this.CssClasses_.HEADER_SEAMED)) {
	                mode = this.Mode_.SEAMED;
	            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_WATERFALL)) {
	                mode = this.Mode_.WATERFALL;
	                this.header_.addEventListener('transitionend', this.headerTransitionEndHandler_.bind(this));
	                this.header_.addEventListener('click', this.headerClickHandler_.bind(this));
	            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_SCROLL)) {
	                mode = this.Mode_.SCROLL;
	                this.element_.classList.add(this.CssClasses_.HAS_SCROLLING_HEADER);
	            }
	            if (mode === this.Mode_.STANDARD) {
	                this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                if (this.tabBar_) {
	                    this.tabBar_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                }
	            } else if (mode === this.Mode_.SEAMED || mode === this.Mode_.SCROLL) {
	                this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                if (this.tabBar_) {
	                    this.tabBar_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                }
	            } else if (mode === this.Mode_.WATERFALL) {
	                // Add and remove shadows depending on scroll position.
	                // Also add/remove auxiliary class for styling of the compact version of
	                // the header.
	                this.content_.addEventListener('scroll', this.contentScrollHandler_.bind(this));
	                this.contentScrollHandler_();
	            }
	        }
	        // Add drawer toggling button to our layout, if we have an openable drawer.
	        if (this.drawer_) {
	            var drawerButton = this.innerContainer_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	            if (!drawerButton) {
	                drawerButton = document.createElement('div');
	                drawerButton.setAttribute('aria-expanded', 'false');
	                drawerButton.setAttribute('role', 'button');
	                drawerButton.setAttribute('tabindex', '0');
	                drawerButton.classList.add(this.CssClasses_.DRAWER_BTN);
	                var drawerButtonIcon = document.createElement('i');
	                drawerButtonIcon.classList.add(this.CssClasses_.ICON);
	                drawerButtonIcon.innerHTML = this.Constant_.MENU_ICON;
	                drawerButton.appendChild(drawerButtonIcon);
	            }
	            if (this.drawer_.classList.contains(this.CssClasses_.ON_LARGE_SCREEN)) {
	                //If drawer has ON_LARGE_SCREEN class then add it to the drawer toggle button as well.
	                drawerButton.classList.add(this.CssClasses_.ON_LARGE_SCREEN);
	            } else if (this.drawer_.classList.contains(this.CssClasses_.ON_SMALL_SCREEN)) {
	                //If drawer has ON_SMALL_SCREEN class then add it to the drawer toggle button as well.
	                drawerButton.classList.add(this.CssClasses_.ON_SMALL_SCREEN);
	            }
	            drawerButton.addEventListener('click', this.drawerToggleHandler_.bind(this));
	            drawerButton.addEventListener('keydown', this.drawerToggleHandler_.bind(this));
	            // Add a class if the layout has a drawer, for altering the left padding.
	            // Adds the HAS_DRAWER to the elements since this.header_ may or may
	            // not be present.
	            this.element_.classList.add(this.CssClasses_.HAS_DRAWER);
	            // If we have a fixed header, add the button to the header rather than
	            // the layout.
	            if (this.element_.classList.contains(this.CssClasses_.FIXED_HEADER)) {
	                this.header_.insertBefore(drawerButton, this.header_.firstChild);
	            } else {
	                this.innerContainer_.insertBefore(drawerButton, this.content_);
	            }
	            var obfuscator = document.createElement('div');
	            obfuscator.classList.add(this.CssClasses_.OBFUSCATOR);
	            this.innerContainer_.appendChild(obfuscator);
	            obfuscator.addEventListener('click', this.drawerToggleHandler_.bind(this));
	            this.obfuscator_ = obfuscator;
	            this.drawer_.addEventListener('keydown', this.keyboardEventHandler_.bind(this));
	            this.drawer_.setAttribute('aria-hidden', 'true');
	        }
	        // Keep an eye on screen size, and add/remove auxiliary class for styling
	        // of small screens.
	        this.screenSizeMediaQuery_ = window.matchMedia(this.Constant_.MAX_WIDTH);
	        this.screenSizeMediaQuery_.addListener(this.screenSizeHandler_.bind(this));
	        this.screenSizeHandler_();
	        // Initialize tabs, if any.
	        if (this.header_ && this.tabBar_) {
	            this.element_.classList.add(this.CssClasses_.HAS_TABS);
	            var tabContainer = document.createElement('div');
	            tabContainer.classList.add(this.CssClasses_.TAB_CONTAINER);
	            this.header_.insertBefore(tabContainer, this.tabBar_);
	            this.header_.removeChild(this.tabBar_);
	            var leftButton = document.createElement('div');
	            leftButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	            leftButton.classList.add(this.CssClasses_.TAB_BAR_LEFT_BUTTON);
	            var leftButtonIcon = document.createElement('i');
	            leftButtonIcon.classList.add(this.CssClasses_.ICON);
	            leftButtonIcon.textContent = this.Constant_.CHEVRON_LEFT;
	            leftButton.appendChild(leftButtonIcon);
	            leftButton.addEventListener('click', function () {
	                this.tabBar_.scrollLeft -= this.Constant_.TAB_SCROLL_PIXELS;
	            }.bind(this));
	            var rightButton = document.createElement('div');
	            rightButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	            rightButton.classList.add(this.CssClasses_.TAB_BAR_RIGHT_BUTTON);
	            var rightButtonIcon = document.createElement('i');
	            rightButtonIcon.classList.add(this.CssClasses_.ICON);
	            rightButtonIcon.textContent = this.Constant_.CHEVRON_RIGHT;
	            rightButton.appendChild(rightButtonIcon);
	            rightButton.addEventListener('click', function () {
	                this.tabBar_.scrollLeft += this.Constant_.TAB_SCROLL_PIXELS;
	            }.bind(this));
	            tabContainer.appendChild(leftButton);
	            tabContainer.appendChild(this.tabBar_);
	            tabContainer.appendChild(rightButton);
	            // Add and remove tab buttons depending on scroll position and total
	            // window size.
	            var tabUpdateHandler = function () {
	                if (this.tabBar_.scrollLeft > 0) {
	                    leftButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                } else {
	                    leftButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                }
	                if (this.tabBar_.scrollLeft < this.tabBar_.scrollWidth - this.tabBar_.offsetWidth) {
	                    rightButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                } else {
	                    rightButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                }
	            }.bind(this);
	            this.tabBar_.addEventListener('scroll', tabUpdateHandler);
	            tabUpdateHandler();
	            // Update tabs when the window resizes.
	            var windowResizeHandler = function () {
	                // Use timeouts to make sure it doesn't happen too often.
	                if (this.resizeTimeoutId_) {
	                    clearTimeout(this.resizeTimeoutId_);
	                }
	                this.resizeTimeoutId_ = setTimeout(function () {
	                    tabUpdateHandler();
	                    this.resizeTimeoutId_ = null;
	                }.bind(this), this.Constant_.RESIZE_TIMEOUT);
	            }.bind(this);
	            window.addEventListener('resize', windowResizeHandler);
	            if (this.tabBar_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	                this.tabBar_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            }
	            // Select element tabs, document panels
	            var tabs = this.tabBar_.querySelectorAll('.' + this.CssClasses_.TAB);
	            var panels = this.content_.querySelectorAll('.' + this.CssClasses_.PANEL);
	            // Create new tabs for each tab element
	            for (var i = 0; i < tabs.length; i++) {
	                new MaterialLayoutTab(tabs[i], tabs, panels, this);
	            }
	        }
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	/**
	   * Constructor for an individual tab.
	   *
	   * @constructor
	   * @param {HTMLElement} tab The HTML element for the tab.
	   * @param {!Array<HTMLElement>} tabs Array with HTML elements for all tabs.
	   * @param {!Array<HTMLElement>} panels Array with HTML elements for all panels.
	   * @param {MaterialLayout} layout The MaterialLayout object that owns the tab.
	   */
	function MaterialLayoutTab(tab, tabs, panels, layout) {
	    /**
	     * Auxiliary method to programmatically select a tab in the UI.
	     */
	    function selectTab() {
	        layout.resetTabState_(tabs);
	        tab.classList.add(layout.CssClasses_.IS_ACTIVE);
	    }
	    if (layout.tabBar_.classList.contains(layout.CssClasses_.JS_RIPPLE_EFFECT)) {
	        var rippleContainer = document.createElement('span');
	        rippleContainer.classList.add(layout.CssClasses_.RIPPLE_CONTAINER);
	        rippleContainer.classList.add(layout.CssClasses_.JS_RIPPLE_EFFECT);
	        var ripple = document.createElement('span');
	        ripple.classList.add(layout.CssClasses_.RIPPLE);
	        rippleContainer.appendChild(ripple);
	        tab.appendChild(rippleContainer);
	    }
	    tab.addEventListener('click', function (e) {
	        e.preventDefault();
	        selectTab();
	    });
	    tab.show = selectTab;
	}
	window['MaterialLayoutTab'] = MaterialLayoutTab;
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialLayout,
	    classAsString: 'MaterialLayout',
	    cssClass: 'mdl-js-layout'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Data Table Card MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {Element} element The element that will be upgraded.
	   */
	var MaterialDataTable = function MaterialDataTable(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialDataTable'] = MaterialDataTable;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialDataTable.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialDataTable.prototype.CssClasses_ = {
	    DATA_TABLE: 'mdl-data-table',
	    SELECTABLE: 'mdl-data-table--selectable',
	    SELECT_ELEMENT: 'mdl-data-table__select',
	    IS_SELECTED: 'is-selected',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Generates and returns a function that toggles the selection state of a
	   * single row (or multiple rows).
	   *
	   * @param {Element} checkbox Checkbox that toggles the selection state.
	   * @param {Element} row Row to toggle when checkbox changes.
	   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	   * @private
	   */
	MaterialDataTable.prototype.selectRow_ = function (checkbox, row, opt_rows) {
	    if (row) {
	        return function () {
	            if (checkbox.checked) {
	                row.classList.add(this.CssClasses_.IS_SELECTED);
	            } else {
	                row.classList.remove(this.CssClasses_.IS_SELECTED);
	            }
	        }.bind(this);
	    }
	    if (opt_rows) {
	        return function () {
	            var i;
	            var el;
	            if (checkbox.checked) {
	                for (i = 0; i < opt_rows.length; i++) {
	                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                    el['MaterialCheckbox'].check();
	                    opt_rows[i].classList.add(this.CssClasses_.IS_SELECTED);
	                }
	            } else {
	                for (i = 0; i < opt_rows.length; i++) {
	                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                    el['MaterialCheckbox'].uncheck();
	                    opt_rows[i].classList.remove(this.CssClasses_.IS_SELECTED);
	                }
	            }
	        }.bind(this);
	    }
	};
	/**
	   * Creates a checkbox for a single or or multiple rows and hooks up the
	   * event handling.
	   *
	   * @param {Element} row Row to toggle when checkbox changes.
	   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	   * @private
	   */
	MaterialDataTable.prototype.createCheckbox_ = function (row, opt_rows) {
	    var label = document.createElement('label');
	    var labelClasses = [
	        'mdl-checkbox',
	        'mdl-js-checkbox',
	        'mdl-js-ripple-effect',
	        this.CssClasses_.SELECT_ELEMENT
	    ];
	    label.className = labelClasses.join(' ');
	    var checkbox = document.createElement('input');
	    checkbox.type = 'checkbox';
	    checkbox.classList.add('mdl-checkbox__input');
	    if (row) {
	        checkbox.checked = row.classList.contains(this.CssClasses_.IS_SELECTED);
	        checkbox.addEventListener('change', this.selectRow_(checkbox, row));
	    } else if (opt_rows) {
	        checkbox.addEventListener('change', this.selectRow_(checkbox, null, opt_rows));
	    }
	    label.appendChild(checkbox);
	    componentHandler.upgradeElement(label, 'MaterialCheckbox');
	    return label;
	};
	/**
	   * Initialize element.
	   */
	MaterialDataTable.prototype.init = function () {
	    if (this.element_) {
	        var firstHeader = this.element_.querySelector('th');
	        var bodyRows = Array.prototype.slice.call(this.element_.querySelectorAll('tbody tr'));
	        var footRows = Array.prototype.slice.call(this.element_.querySelectorAll('tfoot tr'));
	        var rows = bodyRows.concat(footRows);
	        if (this.element_.classList.contains(this.CssClasses_.SELECTABLE)) {
	            var th = document.createElement('th');
	            var headerCheckbox = this.createCheckbox_(null, rows);
	            th.appendChild(headerCheckbox);
	            firstHeader.parentElement.insertBefore(th, firstHeader);
	            for (var i = 0; i < rows.length; i++) {
	                var firstCell = rows[i].querySelector('td');
	                if (firstCell) {
	                    var td = document.createElement('td');
	                    if (rows[i].parentNode.nodeName.toUpperCase() === 'TBODY') {
	                        var rowCheckbox = this.createCheckbox_(rows[i]);
	                        td.appendChild(rowCheckbox);
	                    }
	                    rows[i].insertBefore(td, firstCell);
	                }
	            }
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialDataTable,
	    classAsString: 'MaterialDataTable',
	    cssClass: 'mdl-js-data-table'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Ripple MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialRipple = function MaterialRipple(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialRipple'] = MaterialRipple;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialRipple.prototype.Constant_ = {
	    INITIAL_SCALE: 'scale(0.0001, 0.0001)',
	    INITIAL_SIZE: '1px',
	    INITIAL_OPACITY: '0.4',
	    FINAL_OPACITY: '0',
	    FINAL_SCALE: ''
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialRipple.prototype.CssClasses_ = {
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE: 'mdl-ripple',
	    IS_ANIMATING: 'is-animating',
	    IS_VISIBLE: 'is-visible'
	};
	/**
	   * Handle mouse / finger down on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRipple.prototype.downHandler_ = function (event) {
	    if (!this.rippleElement_.style.width && !this.rippleElement_.style.height) {
	        var rect = this.element_.getBoundingClientRect();
	        this.boundHeight = rect.height;
	        this.boundWidth = rect.width;
	        this.rippleSize_ = Math.sqrt(rect.width * rect.width + rect.height * rect.height) * 2 + 2;
	        this.rippleElement_.style.width = this.rippleSize_ + 'px';
	        this.rippleElement_.style.height = this.rippleSize_ + 'px';
	    }
	    this.rippleElement_.classList.add(this.CssClasses_.IS_VISIBLE);
	    if (event.type === 'mousedown' && this.ignoringMouseDown_) {
	        this.ignoringMouseDown_ = false;
	    } else {
	        if (event.type === 'touchstart') {
	            this.ignoringMouseDown_ = true;
	        }
	        var frameCount = this.getFrameCount();
	        if (frameCount > 0) {
	            return;
	        }
	        this.setFrameCount(1);
	        var bound = event.currentTarget.getBoundingClientRect();
	        var x;
	        var y;
	        // Check if we are handling a keyboard click.
	        if (event.clientX === 0 && event.clientY === 0) {
	            x = Math.round(bound.width / 2);
	            y = Math.round(bound.height / 2);
	        } else {
	            var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	            var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	            x = Math.round(clientX - bound.left);
	            y = Math.round(clientY - bound.top);
	        }
	        this.setRippleXY(x, y);
	        this.setRippleStyles(true);
	        window.requestAnimationFrame(this.animFrameHandler.bind(this));
	    }
	};
	/**
	   * Handle mouse / finger up on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRipple.prototype.upHandler_ = function (event) {
	    // Don't fire for the artificial "mouseup" generated by a double-click.
	    if (event && event.detail !== 2) {
	        // Allow a repaint to occur before removing this class, so the animation
	        // shows for tap events, which seem to trigger a mouseup too soon after
	        // mousedown.
	        window.setTimeout(function () {
	            this.rippleElement_.classList.remove(this.CssClasses_.IS_VISIBLE);
	        }.bind(this), 0);
	    }
	};
	/**
	   * Initialize element.
	   */
	MaterialRipple.prototype.init = function () {
	    if (this.element_) {
	        var recentering = this.element_.classList.contains(this.CssClasses_.RIPPLE_CENTER);
	        if (!this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT_IGNORE_EVENTS)) {
	            this.rippleElement_ = this.element_.querySelector('.' + this.CssClasses_.RIPPLE);
	            this.frameCount_ = 0;
	            this.rippleSize_ = 0;
	            this.x_ = 0;
	            this.y_ = 0;
	            // Touch start produces a compat mouse down event, which would cause a
	            // second ripples. To avoid that, we use this property to ignore the first
	            // mouse down after a touch start.
	            this.ignoringMouseDown_ = false;
	            this.boundDownHandler = this.downHandler_.bind(this);
	            this.element_.addEventListener('mousedown', this.boundDownHandler);
	            this.element_.addEventListener('touchstart', this.boundDownHandler);
	            this.boundUpHandler = this.upHandler_.bind(this);
	            this.element_.addEventListener('mouseup', this.boundUpHandler);
	            this.element_.addEventListener('mouseleave', this.boundUpHandler);
	            this.element_.addEventListener('touchend', this.boundUpHandler);
	            this.element_.addEventListener('blur', this.boundUpHandler);
	            /**
	         * Getter for frameCount_.
	         * @return {number} the frame count.
	         */
	            this.getFrameCount = function () {
	                return this.frameCount_;
	            };
	            /**
	         * Setter for frameCount_.
	         * @param {number} fC the frame count.
	         */
	            this.setFrameCount = function (fC) {
	                this.frameCount_ = fC;
	            };
	            /**
	         * Getter for rippleElement_.
	         * @return {Element} the ripple element.
	         */
	            this.getRippleElement = function () {
	                return this.rippleElement_;
	            };
	            /**
	         * Sets the ripple X and Y coordinates.
	         * @param  {number} newX the new X coordinate
	         * @param  {number} newY the new Y coordinate
	         */
	            this.setRippleXY = function (newX, newY) {
	                this.x_ = newX;
	                this.y_ = newY;
	            };
	            /**
	         * Sets the ripple styles.
	         * @param  {boolean} start whether or not this is the start frame.
	         */
	            this.setRippleStyles = function (start) {
	                if (this.rippleElement_ !== null) {
	                    var transformString;
	                    var scale;
	                    var size;
	                    var offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';
	                    if (start) {
	                        scale = this.Constant_.INITIAL_SCALE;
	                        size = this.Constant_.INITIAL_SIZE;
	                    } else {
	                        scale = this.Constant_.FINAL_SCALE;
	                        size = this.rippleSize_ + 'px';
	                        if (recentering) {
	                            offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
	                        }
	                    }
	                    transformString = 'translate(-50%, -50%) ' + offset + scale;
	                    this.rippleElement_.style.webkitTransform = transformString;
	                    this.rippleElement_.style.msTransform = transformString;
	                    this.rippleElement_.style.transform = transformString;
	                    if (start) {
	                        this.rippleElement_.classList.remove(this.CssClasses_.IS_ANIMATING);
	                    } else {
	                        this.rippleElement_.classList.add(this.CssClasses_.IS_ANIMATING);
	                    }
	                }
	            };
	            /**
	         * Handles an animation frame.
	         */
	            this.animFrameHandler = function () {
	                if (this.frameCount_-- > 0) {
	                    window.requestAnimationFrame(this.animFrameHandler.bind(this));
	                } else {
	                    this.setRippleStyles(false);
	                }
	            };
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialRipple,
	    classAsString: 'MaterialRipple',
	    cssClass: 'mdl-js-ripple-effect',
	    widget: false
	});
	}());


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(421);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    accent: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    colored: _propTypes2.default.bool,
	    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
	    href: _propTypes2.default.string,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    ripple: _propTypes2.default.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button() {
	        _classCallCheck(this, Button);
	
	        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                accent = _props.accent,
	                className = _props.className,
	                colored = _props.colored,
	                primary = _props.primary,
	                raised = _props.raised,
	                ripple = _props.ripple,
	                component = _props.component,
	                href = _props.href,
	                children = _props.children,
	                otherProps = _objectWithoutProperties(_props, ['accent', 'className', 'colored', 'primary', 'raised', 'ripple', 'component', 'href', 'children']);
	
	            var buttonClasses = (0, _classnames2.default)('mdl-button mdl-js-button', {
	                'mdl-js-ripple-effect': ripple,
	                'mdl-button--raised': raised,
	                'mdl-button--colored': colored,
	                'mdl-button--primary': primary,
	                'mdl-button--accent': accent
	            }, className);
	
	            return _react2.default.createElement(component || (href ? 'a' : 'button'), _extends({
	                className: buttonClasses,
	                href: href
	            }, otherProps), children);
	        }
	    }]);
	
	    return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Button);

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MDLComponent = function (_Component) {
	    _inherits(MDLComponent, _Component);
	
	    function MDLComponent() {
	        _classCallCheck(this, MDLComponent);
	
	        return _possibleConstructorReturn(this, (MDLComponent.__proto__ || Object.getPrototypeOf(MDLComponent)).apply(this, arguments));
	    }
	
	    _createClass(MDLComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.recursive) {
	                window.componentHandler.upgradeElements((0, _reactDom.findDOMNode)(this));
	            } else {
	                window.componentHandler.upgradeElement((0, _reactDom.findDOMNode)(this));
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.componentHandler.downgradeElements((0, _reactDom.findDOMNode)(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react.Children.only(this.props.children);
	        }
	    }]);
	
	    return MDLComponent;
	}(_react.Component);
	
	exports.default = MDLComponent;
	
	
	MDLComponent.propTypes = {
	    recursive: _propTypes2.default.bool
	};

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MDLComponent = __webpack_require__(420);
	
	var _MDLComponent2 = _interopRequireDefault(_MDLComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function patchComponentClass(Component, recursive) {
	    var oldRender = Component.prototype.render;
	
	    Component.prototype.render = function render() {
	        // eslint-disable-line no-param-reassign
	        return _react2.default.createElement(
	            _MDLComponent2.default,
	            { recursive: recursive },
	            oldRender.call(this)
	        );
	    };
	
	    return Component;
	}
	
	function patchSFC(component, recursive) {
	    var patchedComponent = function patchedComponent(props) {
	        return _react2.default.createElement(
	            _MDLComponent2.default,
	            { recursive: recursive },
	            component(props)
	        );
	    };
	
	    // Attempt to change the function name for easier debugging, but don't die
	    // if the browser doesn't support it
	    try {
	        Object.defineProperty(patchedComponent, 'name', {
	            value: component.name
	        });
	    } catch (e) {} // eslint-disable-line no-empty
	
	    return patchedComponent;
	}
	
	exports.default = function (Component) {
	    var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return Component.prototype && Component.prototype.isReactComponent ? patchComponentClass(Component, recursive) : patchSFC(Component, recursive);
	};

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(452).enable();
	  window.Promise = __webpack_require__(451);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(453);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(450);


/***/ },
/* 423 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(442);
	
	var _Network = __webpack_require__(433);
	
	var _Network2 = _interopRequireDefault(_Network);
	
	var _AttributesPane = __webpack_require__(425);
	
	var _AttributesPane2 = _interopRequireDefault(_AttributesPane);
	
	var _FilterPane = __webpack_require__(428);
	
	var _FilterPane2 = _interopRequireDefault(_FilterPane);
	
	var _LoadData = __webpack_require__(431);
	
	var _LoadData2 = _interopRequireDefault(_LoadData);
	
	var _DownloadData = __webpack_require__(427);
	
	var _DownloadData2 = _interopRequireDefault(_DownloadData);
	
	var _FABButton = __webpack_require__(190);
	
	var _FABButton2 = _interopRequireDefault(_FABButton);
	
	var _Icons = __webpack_require__(191);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	var _Modal = __webpack_require__(432);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.handleUpload = _this.handleUpload.bind(_this);
	        _this.handleActiveNodeChange = _this.handleActiveNodeChange.bind(_this);
	        _this.handleFilterChange = _this.handleFilterChange.bind(_this);
	        _this.setFilterValues = _this.setFilterValues.bind(_this);
	        _this.setDefaultStateValues = _this.setDefaultStateValues.bind(_this);
	        _this.handleLoadData = _this.handleLoadData.bind(_this);
	        _this.doneLoading = _this.doneLoading.bind(_this);
	        _this.doneRemounting = _this.doneRemounting.bind(_this);
	        _this.resetFilterValues.bind(_this);
	        _this.getDefaultFilterValues = _this.getDefaultFilterValues.bind(_this);
	        _this.getNrVisibleNodes = _this.getNrVisibleNodes.bind(_this);
	        _this.setVisibleNodes = _this.setVisibleNodes.bind(_this);
	        _this.deactivate = _this.deactivate.bind(_this);
	        var data = __webpack_require__(448);
	        _this.state = {
	            showModal: false,
	            data: data,
	            loading: false,
	            mountLayout: true,
	            activeNode: {},
	            filterState: _this.getDefaultFilterValues(),
	            graphProps: {},
	            visibleNodes: []
	        };
	        return _this;
	    }
	
	    _createClass(App, [{
	        key: 'handleUpload',
	        value: function handleUpload() {
	            this.setState({ showModal: !this.state.showModal });
	        }
	    }, {
	        key: 'handleActiveNodeChange',
	        value: function handleActiveNodeChange(activeNode) {
	            this.setState({
	                activeNode: activeNode
	            });
	        }
	    }, {
	        key: 'handleFilterChange',
	        value: function handleFilterChange(newFilterState) {
	            // If the layout needs to be adjust, unmount the layout
	            if (newFilterState.minSliderValue || newFilterState.maxSliderValue) {
	                if (this.state.filterState.adjustLayout) {
	                    this.setState({
	                        "mountLayout": false
	                    });
	                }
	            }
	
	            // Merge the new filter state into the old one
	            this.setState(function (prevState, props) {
	                var mergedFilterState = {};
	                var prevFilterState = prevState.filterState;
	                for (var attrname in prevFilterState) {
	                    if ({}.hasOwnProperty.call(prevFilterState, attrname)) {
	                        mergedFilterState[attrname] = prevFilterState[attrname];
	                    }
	                }
	                for (var _attrname in newFilterState) {
	                    if ({}.hasOwnProperty.call(newFilterState, _attrname)) {
	                        mergedFilterState[_attrname] = newFilterState[_attrname];
	                    }
	                }
	                return {
	                    filterState: mergedFilterState
	                };
	            });
	        }
	    }, {
	        key: 'setFilterValues',
	        value: function setFilterValues(graphProps) {
	            this.setState({
	                graphProps: graphProps
	            });
	            this.setDefaultStateValues();
	        }
	    }, {
	        key: 'setDefaultStateValues',
	        value: function setDefaultStateValues() {
	            var defaultValues = this.getDefaultFilterValues();
	            this.setState(function (prevState, props) {
	                var filterState = prevState.filterState;
	                filterState.sliderAttributeValue = filterState.sliderAttributeValue || defaultValues.sizeAttributeValue;
	                filterState.minSliderValue = filterState.minSliderValue || defaultValues.minSliderValue;
	                filterState.maxSliderValue = filterState.maxSliderValue || defaultValues.maxSliderValue;
	                filterState.inDegreeValue = filterState.inDegreeValue || [prevState.graphProps.minInDegree, prevState.graphProps.maxInDegree];
	                filterState.subjectValue = filterState.subjectValue || defaultValues.subjectValue;
	                filterState.creatorValue = filterState.creatorValue || defaultValues.creatorValue;
	                filterState.communityValue = filterState.communityValue || defaultValues.communityValue;
	                filterState.sizeAttributeValue = filterState.sizeAttributeValue || defaultValues.sizeAttributeValue;
	                filterState.colorAttributeValue = filterState.colorAttributeValue || defaultValues.colorAttributeValue;
	                return {
	                    filterState: filterState
	                };
	            });
	        }
	    }, {
	        key: 'getDefaultFilterValues',
	        value: function getDefaultFilterValues() {
	            var filterState = {
	                sizeAttributeValue: "in_degree",
	                colorAttributeValue: "community",
	                sliderAttributeValue: "year",
	                subjectValue: [],
	                creatorValue: [],
	                communityValue: [],
	                adjustLayout: false,
	                filterSelected: false,
	                minSliderValue: null,
	                maxSliderValue: null
	            };
	            return filterState;
	        }
	    }, {
	        key: 'resetFilterValues',
	        value: function resetFilterValues() {
	            this.setState({
	                filterState: this.getDefaultFilterValues()
	            });
	        }
	    }, {
	        key: 'handleLoadData',
	        value: function handleLoadData(data) {
	            this.resetFilterValues();
	            this.setState({
	                data: data,
	                loading: true
	            });
	        }
	    }, {
	        key: 'doneLoading',
	        value: function doneLoading() {
	            this.setState({
	                loading: false
	            });
	        }
	    }, {
	        key: 'doneRemounting',
	        value: function doneRemounting() {
	            this.setState({
	                mountLayout: true
	            });
	        }
	    }, {
	        key: 'getNrVisibleNodes',
	        value: function getNrVisibleNodes() {
	            var nrNodes = this.state.data.nodes.length;
	            var nrVisibleNodes = this.state.visibleNodes.length;
	            return [nrNodes, nrVisibleNodes];
	        }
	    }, {
	        key: 'setVisibleNodes',
	        value: function setVisibleNodes(visibleNodes) {
	            this.setState({
	                visibleNodes: visibleNodes
	            });
	        }
	    }, {
	        key: 'deactivate',
	        value: function deactivate() {
	            this.setState({
	                activeNode: {}
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _state = this.state;
	            var activeNode = _state.activeNode;
	            var filterState = _state.filterState;
	            var graphProps = _state.graphProps;
	            var data = _state.data;
	            var loading = _state.loading;
	            var mountLayout = _state.mountLayout;
	            var visibleNodes = _state.visibleNodes;
	            var showModal = _state.showModal;
	
	            var title = data.title || "Network";
	            var version = __webpack_require__(447).version;
	            var version_url = "https://github.com/NLeSC/case-law-app/releases";
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'App' },
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { show: showModal },
	                    _react2.default.createElement(_LoadData2.default, {
	                        onClick: this.handleLoadData
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'App-header' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'App-title' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Case Law Analytics'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'App-buttonsContainer' },
	                        _react2.default.createElement(
	                            _FABButton2.default,
	                            { colored: true, mini: true, onClick: this.handleUpload },
	                            _react2.default.createElement(_Icons2.default, { icon: 'upload' })
	                        ),
	                        _react2.default.createElement(_DownloadData2.default, { data: visibleNodes })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'App-filter-pane' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'App-caseTitle' },
	                        title
	                    ),
	                    _react2.default.createElement(_FilterPane2.default, { onChange: this.handleFilterChange,
	                        filterState: filterState,
	                        graphProps: graphProps })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'App-network' },
	                    _react2.default.createElement(_Network2.default, { onChange: this.handleActiveNodeChange, filterState: filterState, selectedNode: activeNode,
	                        onInitialization: this.setFilterValues, loading: loading, doneLoading: this.doneLoading,
	                        doneRemounting: this.doneRemounting,
	                        mountLayout: mountLayout,
	                        data: data,
	                        setVisibleNodeFunction: this.setVisibleNodeFunction,
	                        setVisibleNodes: this.setVisibleNodes
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'App-attribute-pane' },
	                        _react2.default.createElement(_AttributesPane2.default, { activeNode: activeNode, deactivate: this.deactivate })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'App-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'App-info' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: version_url, target: '_blank' },
	                                'Version ',
	                                version
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            ' ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://github.com/NLeSC/case-law-app', target: '_blank' },
	                                'Source code'
	                            ),
	                            ' '
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(_react2.default.Component);
	
	exports.default = App;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttributesPane = function (_React$Component) {
	    _inherits(AttributesPane, _React$Component);
	
	    function AttributesPane(props) {
	        _classCallCheck(this, AttributesPane);
	
	        var _this = _possibleConstructorReturn(this, (AttributesPane.__proto__ || Object.getPrototypeOf(AttributesPane)).call(this, props));
	
	        _this.state = {};
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleClose = _this.handleClose.bind(_this);
	        return _this;
	    }
	
	    _createClass(AttributesPane, [{
	        key: "handleChange",
	        value: function handleChange(e) {
	            this.props.onChange(e.data.node);
	        }
	    }, {
	        key: "handleClose",
	        value: function handleClose() {
	            this.props.deactivate();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props$activeNode = this.props.activeNode;
	            var title = _props$activeNode.title;
	            var id = _props$activeNode.id;
	            var date = _props$activeNode.date;
	            var articles = _props$activeNode.articles;
	            var community = _props$activeNode.community;
	            var abstract = _props$activeNode.abstract;
	
	            var articles_s = articles ? articles.join(", ") : "";
	            if (this.props.activeNode.id) {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "button",
	                        { className: "close", onClick: this.handleClose },
	                        "x"
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: id, target: "_blank" },
	                            title
	                        ),
	                        " "
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        " ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "Date: "
	                        ),
	                        date,
	                        " "
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        " ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "Articles: "
	                        ),
	                        " ",
	                        articles_s,
	                        " "
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        " ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "Community: "
	                        ),
	                        " ",
	                        community,
	                        " "
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        " ",
	                        _react2.default.createElement(
	                            "b",
	                            null,
	                            "Abstract: "
	                        ),
	                        abstract
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    "Click on node"
	                );
	            }
	        }
	    }]);
	
	    return AttributesPane;
	}(_react2.default.Component);
	
	exports.default = AttributesPane;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tools = __webpack_require__(24);
	
	var _colormap = __webpack_require__(226);
	
	var _colormap2 = _interopRequireDefault(_colormap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//type Props = {
	//    attribute: String,
	//    sigma ? : sigma
	//};
	
	/**
	 **/
	
	var ColorOnAttribute = function (_React$Component) {
	    _inherits(ColorOnAttribute, _React$Component);
	
	    function ColorOnAttribute(props) {
	        _classCallCheck(this, ColorOnAttribute);
	
	        var _this = _possibleConstructorReturn(this, (ColorOnAttribute.__proto__ || Object.getPrototypeOf(ColorOnAttribute)).call(this, props));
	
	        _this.updateColor(props);
	        _this.updateColorCategorical = _this.updateColorCategorical.bind(_this);
	        _this.updateColorNumerical = _this.updateColorNumerical.bind(_this);
	        return _this;
	    }
	
	    _createClass(ColorOnAttribute, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            this.updateColor(props);
	        }
	    }, {
	        key: 'updateColor',
	        value: function updateColor(props) {
	            var s = props.sigma;
	            var att = props.attribute;
	            var nodes = s.graph.nodes();
	            if (att === 'none') {
	                nodes.forEach(function (node) {
	                    node.color_selected = 'green';
	                    node.color_unselected = 'dimgray';
	                    if (node.selected) {
	                        node.color = node.color_selected;
	                    } else {
	                        node.color = node.color_unselected;
	                    }
	                });
	            } else if (nodes.length > 0) {
	                if (typeof nodes[0][att] === 'string') {
	                    this.updateColorCategorical(nodes, att);
	                } else {
	                    this.updateColorNumerical(nodes, att);
	                }
	            }
	        }
	    }, {
	        key: 'updateColorNumerical',
	        value: function updateColorNumerical(nodes, att) {
	            var minValue = Number.MAX_SAFE_INTEGER;
	            var maxValue = 0;
	            nodes.forEach(function (node) {
	                minValue = Math.min(minValue, node[att]);
	                maxValue = Math.max(maxValue, node[att]);
	            });
	
	            //update color
	            var nshades = 16;
	            // Don't use 2 most extreme values
	            var scale = (nshades - 4) / (maxValue - minValue);
	            var cm_unselected = (0, _colormap2.default)({
	                colormap: 'greys', // pick a builtin colormap or add your own 
	                nshades: nshades, // how many divisions 
	                format: 'hex', // "hex" or "rgb" or "rgbaString" 
	                alpha: 1 // set an alpha value or a linear alpha mapping [start, end] 
	            });
	            var cm_selected = (0, _colormap2.default)({
	                colormap: 'greens', // pick a builtin colormap or add your own 
	                nshades: nshades, // how many divisions 
	                format: 'hex', // "hex" or "rgb" or "rgbaString" 
	                alpha: 1 // set an alpha value or a linear alpha mapping [start, end] 
	            });
	            nodes.forEach(function (node) {
	                var index = 2 + (node[att] - minValue) * scale;
	                node.color_selected = cm_selected[Math.floor(index)];
	                node.color_unselected = cm_unselected[Math.floor(index)];
	                if (node.selected) {
	                    node.color = node.color_selected;
	                } else {
	                    node.color = node.color_unselected;
	                }
	            });
	        }
	    }, {
	        key: 'updateColorCategorical',
	        value: function updateColorCategorical(nodes, att) {
	            var values = [];
	            nodes.forEach(function (node) {
	                var value = node[att];
	                if (values.indexOf(value) === -1) {
	                    values.push(value);
	                }
	            });
	
	            //update color
	            var nshades = Math.max(11, values.length);
	            var scale = nshades / values.length;
	            var cm_unselected = (0, _colormap2.default)({
	                colormap: 'jet', // pick a builtin colormap or add your own 
	                nshades: nshades, // how many divisions 
	                format: 'rgbaString', // "hex" or "rgb" or "rgbaString" 
	                alpha: 0.5 // set an alpha value or a linear alpha mapping [start, end] 
	            });
	
	            var cm_selected = (0, _colormap2.default)({
	                colormap: 'jet', // pick a builtin colormap or add your own 
	                nshades: nshades, // how many divisions 
	                format: 'rgbaString', // "hex" or "rgb" or "rgbaString" 
	                alpha: 1 // set an alpha value or a linear alpha mapping [start, end] 
	            });
	
	            nodes.forEach(function (node) {
	                var index = Math.floor(scale * values.indexOf(node[att]));
	                node.color_selected = cm_selected[index]; //'black';
	                node.color_unselected = cm_unselected[index];
	                if (node.selected) {
	                    node.color = node.color_selected;
	                } else {
	                    node.color = node.color_unselected;
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	            );
	        }
	    }]);
	
	    return ColorOnAttribute;
	}(_react2.default.Component);
	
	exports.default = ColorOnAttribute;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _babyparse = __webpack_require__(223);
	
	var _babyparse2 = _interopRequireDefault(_babyparse);
	
	var _FABButton = __webpack_require__(190);
	
	var _FABButton2 = _interopRequireDefault(_FABButton);
	
	var _Icons = __webpack_require__(191);
	
	var _Icons2 = _interopRequireDefault(_Icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DownloadData = function (_React$Component) {
	    _inherits(DownloadData, _React$Component);
	
	    function DownloadData(props) {
	        _classCallCheck(this, DownloadData);
	
	        var _this = _possibleConstructorReturn(this, (DownloadData.__proto__ || Object.getPrototypeOf(DownloadData)).call(this, props));
	
	        _this.dataToCSV = _this.dataToCSV.bind(_this);
	        _this.saveAs = _this.saveAs.bind(_this);
	        _this.onDownload = _this.onDownload.bind(_this);
	        return _this;
	    }
	
	    _createClass(DownloadData, [{
	        key: 'dataToCSV',
	        value: function dataToCSV(data) {
	            //TODO: filter columns to download
	            var csvtext = _babyparse2.default.unparse(data);
	            return csvtext;
	        }
	
	        // from http://stackoverflow.com/questions/283956/
	
	    }, {
	        key: 'saveAs',
	        value: function saveAs(uri, filename) {
	            var link = document.createElement('a');
	            if (typeof link.download === 'string') {
	                document.body.appendChild(link); //Firefox requires the link to be in the body
	                link.download = filename;
	                link.href = uri;
	                link.click();
	                document.body.removeChild(link); //remove the link when done
	            } else {
	                location.replace(uri);
	            }
	        }
	    }, {
	        key: 'onDownload',
	        value: function onDownload() {
	            var data = this.props.data;
	            var csvContent = this.dataToCSV(data);
	            var fileName = "nodes.csv";
	            var blob = new Blob([csvContent], {
	                type: "application/csv"
	            });
	            var url = URL.createObjectURL(blob);
	            this.saveAs(url, fileName);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            /*<button type="button" onClick={this.onClick}>Load new data</button>*/
	            return (
	                // <button onClick={this.onDownload}>
	                //   Download filtered nodes
	                //   </button>
	
	                _react2.default.createElement(
	                    _FABButton2.default,
	                    { colored: true, mini: true, onClick: this.onDownload },
	                    _react2.default.createElement(_Icons2.default, { icon: 'download' })
	                )
	            );
	        }
	    }]);
	
	    return DownloadData;
	}(_react2.default.Component);
	
	exports.default = DownloadData;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(443);
	
	__webpack_require__(228);
	
	var _reactSelect = __webpack_require__(455);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(441);
	
	var _rcSlider = __webpack_require__(340);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	__webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterPane = function (_Component) {
	    _inherits(FilterPane, _Component);
	
	    function FilterPane(props) {
	        _classCallCheck(this, FilterPane);
	
	        var _this = _possibleConstructorReturn(this, (FilterPane.__proto__ || Object.getPrototypeOf(FilterPane)).call(this, props));
	
	        _this.handleInDegreeChange = _this.handleInDegreeChange.bind(_this);
	        _this.handleSubjectChange = _this.handleSubjectChange.bind(_this);
	        _this.handleCreatorChange = _this.handleCreatorChange.bind(_this);
	        _this.handleCommunityChange = _this.handleCommunityChange.bind(_this);
	        _this.handleSliderChange = _this.handleSliderChange.bind(_this);
	        _this.handleSizeAttributeChange = _this.handleSizeAttributeChange.bind(_this);
	        _this.handleColorAttributeChange = _this.handleColorAttributeChange.bind(_this);
	        _this.handleAdjustLayoutChange = _this.handleAdjustLayoutChange.bind(_this);
	        _this.handleFilterSelectedChange = _this.handleFilterSelectedChange.bind(_this);
	        _this.handleSliderAttributeChange = _this.handleSliderAttributeChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(FilterPane, [{
	        key: 'handleInDegreeChange',
	        value: function handleInDegreeChange(range) {
	            var newState = {
	                inDegreeValue: range //parseInt(event.target.value, 10)
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleSliderChange',
	        value: function handleSliderChange(range) {
	            var newState = {
	                minSliderValue: range[0],
	                maxSliderValue: range[1]
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleAdjustLayoutChange',
	        value: function handleAdjustLayoutChange(event) {
	            var newState = {
	                adjustLayout: event.target.checked
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleSubjectChange',
	        value: function handleSubjectChange(value) {
	            var newState = {
	                subjectValue: value
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleCreatorChange',
	        value: function handleCreatorChange(value) {
	            var newState = {
	                creatorValue: value
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleCommunityChange',
	        value: function handleCommunityChange(value) {
	            var newState = {
	                communityValue: value
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleSliderAttributeChange',
	        value: function handleSliderAttributeChange(event) {
	            var newState = {
	                sliderAttributeValue: event.target.value,
	                minSliderValue: null,
	                maxSliderValue: null
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleSizeAttributeChange',
	        value: function handleSizeAttributeChange(event) {
	            var newState = {
	                sizeAttributeValue: event.target.value
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleColorAttributeChange',
	        value: function handleColorAttributeChange(event) {
	            var newState = {
	                colorAttributeValue: event.target.value
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'handleFilterSelectedChange',
	        value: function handleFilterSelectedChange(event) {
	            var newState = {
	                filterSelected: event.target.checked
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'componentIsMounted',
	        value: function componentIsMounted() {
	            //Set the default values
	            var newState = {
	                minSliderValue: null,
	                maxSliderValue: null
	            };
	            this.props.onChange(newState);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (this.props.graphProps) {
	                var _ret = function () {
	                    // Properties of the network, the possible filter values
	                    var graphProps = _this2.props.graphProps;
	                    var minInDegree = graphProps.minInDegree || 0;
	                    var maxInDegree = graphProps.maxInDegree || 0;
	                    var subjectCategories = graphProps.subjectCategories || {};
	                    var creatorCategories = graphProps.creatorCategories || {};
	                    var communityCategories = graphProps.communityCategories || {};
	
	                    var subjectOptions = Object.keys(subjectCategories).map(function (option) {
	                        return {
	                            value: option,
	                            label: subjectCategories[option]
	                        };
	                    });
	                    var creatorOptions = Object.keys(creatorCategories).map(function (option) {
	                        return {
	                            value: option,
	                            label: creatorCategories[option]
	                        };
	                    });
	                    var sizeAttributes = graphProps.sizeAttributes || [];
	                    var colorAttributes = graphProps.colorAttributes || [];
	                    var listSizeAttributes = sizeAttributes.map(function (option) {
	                        return _react2.default.createElement(
	                            'option',
	                            { value: option, key: option },
	                            ' ',
	                            option,
	                            ' '
	                        );
	                    });
	                    var listColorAttributes = colorAttributes.map(function (option) {
	                        return _react2.default.createElement(
	                            'option',
	                            { value: option, key: option },
	                            ' ',
	                            option,
	                            ' '
	                        );
	                    });
	                    var sliderMinMaxValues = graphProps.sliderMinMaxValues || {};
	                    var sliderAttributes = Object.keys(sliderMinMaxValues);
	                    var listSliderAttributes = sliderAttributes.map(function (option) {
	                        return _react2.default.createElement(
	                            'option',
	                            { value: option, key: option },
	                            ' ',
	                            option,
	                            ' '
	                        );
	                    });
	
	                    // The current values
	                    // TODO: adjust indegree to slider prop 
	                    var inDegreeValue = _this2.props.filterState.inDegreeValue || [minInDegree, maxInDegree];
	                    var minInDegreeValue = inDegreeValue[0];
	                    var maxInDegreeValue = inDegreeValue[1];
	                    var subjectValue = _this2.props.filterState.subjectValue;
	                    var creatorValue = _this2.props.filterState.creatorValue;
	                    var communityValue = _this2.props.filterState.communityValue;
	                    var sizeAttributeValue = _this2.props.filterState.sizeAttributeValue;
	                    var colorAttributeValue = _this2.props.filterState.colorAttributeValue;
	                    var adjustLayout = _this2.props.filterState.adjustLayout;
	                    var filterSelected = _this2.props.filterState.filterSelected; //|| false;
	                    var sliderAttributeValue = _this2.props.filterState.sliderAttributeValue; // || 'year';
	
	                    var slider_minmax = sliderMinMaxValues[sliderAttributeValue] || [0, 1];
	                    var minSliderValue = _this2.props.filterState.minSliderValue || slider_minmax[0];
	                    var maxSliderValue = _this2.props.filterState.maxSliderValue || slider_minmax[1];
	                    var communityFilter = null;
	                    if (Object.keys(communityCategories).length > 0) {
	                        var communityOptions = Object.keys(communityCategories).map(function (option) {
	                            return {
	                                value: option,
	                                label: communityCategories[option]
	                            };
	                        });
	
	                        communityFilter = _react2.default.createElement(
	                            'li',
	                            { className: 'App-filterItem' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Community'
	                            ),
	                            _react2.default.createElement(_reactSelect2.default, {
	                                name: 'community',
	                                value: communityValue,
	                                options: communityOptions,
	                                onChange: _this2.handleCommunityChange,
	                                multi: true,
	                                placeholder: 'Select Community'
	                            })
	                        );
	                    }
	
	                    return {
	                        v: _react2.default.createElement(
	                            'div',
	                            { className: 'App-filterContent' },
	                            _react2.default.createElement(
	                                'form',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'In-degree: ',
	                                        minInDegreeValue,
	                                        ' - ',
	                                        maxInDegreeValue
	                                    ),
	                                    _react2.default.createElement(_rcSlider.Range, { min: minInDegree, max: maxInDegree, value: [minInDegreeValue, maxInDegreeValue], onChange: _this2.handleInDegreeChange })
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        _react2.default.createElement(
	                                            'select',
	                                            { value: sliderAttributeValue, onChange: _this2.handleSliderAttributeChange },
	                                            listSliderAttributes
	                                        ),
	                                        ': ',
	                                        minSliderValue,
	                                        ' - ',
	                                        maxSliderValue
	                                    ),
	                                    _react2.default.createElement(_rcSlider.Range, { min: slider_minmax[0], max: slider_minmax[1], value: [minSliderValue, maxSliderValue], onChange: _this2.handleSliderChange })
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        ' Adjust layout for slider:',
	                                        _react2.default.createElement('input', { name: 'adjustLayout', type: 'checkbox', checked: adjustLayout, onChange: _this2.handleAdjustLayoutChange })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Rechtsgebied'
	                                    ),
	                                    _react2.default.createElement(_reactSelect2.default, {
	                                        name: 'subject',
	                                        value: subjectValue,
	                                        options: subjectOptions,
	                                        onChange: _this2.handleSubjectChange,
	                                        multi: true,
	                                        placeholder: 'Select Subject'
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Instantie'
	                                    ),
	                                    _react2.default.createElement(_reactSelect2.default, {
	                                        name: 'creator',
	                                        value: creatorValue,
	                                        options: creatorOptions,
	                                        onChange: _this2.handleCreatorChange,
	                                        multi: true,
	                                        placeholder: 'Select Creator'
	                                    })
	                                ),
	                                communityFilter,
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        ' Filter selected:',
	                                        _react2.default.createElement('input', { name: 'filterSelected', type: 'checkbox', checked: filterSelected, onChange: _this2.handleFilterSelectedChange })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Node Size'
	                                    ),
	                                    _react2.default.createElement(
	                                        'select',
	                                        { value: sizeAttributeValue, onChange: _this2.handleSizeAttributeChange },
	                                        listSizeAttributes
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'App-filterItem' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        'Node Color'
	                                    ),
	                                    _react2.default.createElement(
	                                        'select',
	                                        { value: colorAttributeValue, onChange: _this2.handleColorAttributeChange },
	                                        _react2.default.createElement(
	                                            'option',
	                                            { value: 'none' },
	                                            'none'
	                                        ),
	                                        listColorAttributes
	                                    )
	                                )
	                            )
	                        )
	                    };
	                }();
	
	                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return FilterPane;
	}(_react.Component);
	
	exports.default = FilterPane;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(78);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _tools = __webpack_require__(24);
	
	__webpack_require__(202);
	
	__webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Copied and adjusted from https://github.com/dunnock/react-sigma
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	/**
	ForceAtlas2 component, starts ForceAtlas2 sigma plugin once component is mounted.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted while graph is unavailable. It can be used within Sigma component if graph is
	preloaded, or within loader component, like NeoCypher.
	It accepts all the parameters of ForceAtlas2 described on its github page:
	@param {boolean} [worker=true]           Use a web worker to run calculations in separate thread
	@param {boolean} barnesHutOptimize  Use the algorithm's Barnes-Hut to improve repulsion's scalability
										This is useful for large graph but harmful to small ones.
	@param {number} barnesHutTheta
	@param {boolean} adjustSizes
	@param {number} iterationsPerRender
	@param {boolean} [linLogMode=true]
	@param {boolean} outboundAttractionDistribution
	@param {number} edgeWeightInfluence
	@param {number} scalingRatio
	@param {boolean} strongGravityMode
	@param {number} gravity
	@param {number} slowDown
	@param {number} timeout   how long algorythm should run. default=graph.nodes().length * 10
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.layout.forceAtlas2)
	**/
	
	var ForceAtlas2 = function (_React$Component) {
	    _inherits(ForceAtlas2, _React$Component);
	
	    function ForceAtlas2(props) {
	        _classCallCheck(this, ForceAtlas2);
	
	        var _this = _possibleConstructorReturn(this, (ForceAtlas2.__proto__ || Object.getPrototypeOf(ForceAtlas2)).call(this, props));
	
	        _this.state = {
	            running: true
	        };
	        return _this;
	    }
	
	    _createClass(ForceAtlas2, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._refreshGraph();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            var s = this.props.sigma;
	            if (prevState.running && !this.state.running && s) {
	                s.stopForceAtlas2();
	                s.settings({
	                    drawEdges: prevState.drawEdges === false ? false : true
	                });
	                s.refresh();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.props.sigma) this.props.sigma.killForceAtlas2();
	            if (this.state.timer) clearTimeout(this.state.timer);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.rerun && !this.props.rerun) {
	                this._refreshGraph();
	            }
	        }
	
	        //TODO: Add composition of child components after timeout
	
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.running) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	                );
	            }
	            return null;
	        }
	    }, {
	        key: '_refreshGraph',
	        value: function _refreshGraph() {
	            var _this2 = this;
	
	            var s = this.props.sigma;
	            if (!_main2.default || !s) return;
	
	            var drawEdges = s.settings("drawEdges");
	            if (s.graph.edges().length > 1000) s.settings({
	                drawEdges: false
	            });
	
	            s.startForceAtlas2(this._stripOptions(this.props));
	            // TODO: convert running status to state
	            var timer = setTimeout(function () {
	                _this2.setState({
	                    running: false,
	                    timer: undefined
	                });
	            }, this.props.timeout || s.graph.nodes().length * 8);
	            this.setState({
	                running: true,
	                timer: timer,
	                drawEdges: drawEdges
	            });
	        }
	
	        //strip force atlas options from component props
	
	    }, {
	        key: '_stripOptions',
	        value: function _stripOptions(props) {
	            return Object.assign({}, props, {
	                sigma: undefined,
	                children: undefined
	            });
	        }
	    }]);
	
	    return ForceAtlas2;
	}(_react2.default.Component);
	
	ForceAtlas2.defaultProps = {
	    worker: true,
	    linLogMode: true
	};
	exports.default = ForceAtlas2;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GraphProperties = function (_React$Component) {
	    _inherits(GraphProperties, _React$Component);
	
	    function GraphProperties(props) {
	        _classCallCheck(this, GraphProperties);
	
	        var _this = _possibleConstructorReturn(this, (GraphProperties.__proto__ || Object.getPrototypeOf(GraphProperties)).call(this, props));
	
	        _this.getGraphProperties = _this.getGraphProperties.bind(_this);
	        _this.getcolorAttributes = _this.getcolorAttributes.bind(_this);
	        _this.getSliderAttributes = _this.getSliderAttributes.bind(_this);
	        return _this;
	    }
	
	    _createClass(GraphProperties, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var graphProps = this.getGraphProperties();
	            this.props.onInitialization(graphProps);
	        }
	    }, {
	        key: 'getGraphProperties',
	        value: function getGraphProperties() {
	            var s = this.props.sigma;
	            var minInDegree = Number.MAX_SAFE_INTEGER,
	                maxInDegree = 0;
	            var subjectCategories = {};
	            var creatorCategories = {};
	            var communityCategories = {};
	            var sliderAttributes = this.getSliderAttributes();
	            var sliderMinMaxValues = {};
	            sliderAttributes.forEach(function (att) {
	                sliderMinMaxValues[att] = [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER];
	            });
	
	            s.graph.nodes().forEach(function (node) {
	                var inDegree = s.graph.degree(node.id, "in");
	                maxInDegree = Math.max(maxInDegree, inDegree);
	                minInDegree = Math.min(minInDegree, inDegree);
	                sliderAttributes.forEach(function (att) {
	                    sliderMinMaxValues[att][0] = Math.min(sliderMinMaxValues[att][0], node[att]);
	                    sliderMinMaxValues[att][1] = Math.max(sliderMinMaxValues[att][1], node[att]);
	                });
	                var subj_split = node.subject.split("#");
	                subjectCategories[node.subject] = subj_split[subj_split.length - 1];
	                var creator_split = node.creator.split("/");
	                creatorCategories[node.creator] = creator_split[creator_split.length - 1];
	                if (node.community) {
	                    communityCategories[node.community] = node.community;
	                }
	            });
	            return {
	                minInDegree: 0,
	                maxInDegree: maxInDegree,
	                subjectCategories: subjectCategories,
	                creatorCategories: creatorCategories,
	                communityCategories: communityCategories,
	                sizeAttributes: this.getSizeAttributes(),
	                colorAttributes: this.getcolorAttributes(),
	                sliderMinMaxValues: sliderMinMaxValues
	            };
	        }
	    }, {
	        key: 'getSizeAttributes',
	        value: function getSizeAttributes() {
	            var attributes = ['degree', 'in_degree', 'out_degree', 'year', 'hubs', 'authorities', 'betweenness_centrality', 'closeness_centrality', 'count_annotation', 'rel_in_degree', 'pagerank'];
	            // Check if first node contains these attributes
	            var s = this.props.sigma;
	            var exampleNode = [];
	            if (s.graph.nodes().length > 0) {
	                exampleNode = s.graph.nodes()[0];
	            }
	            var filteredAttributes = attributes.filter(function (att) {
	                return att in exampleNode;
	            });
	            return filteredAttributes;
	        }
	    }, {
	        key: 'getcolorAttributes',
	        value: function getcolorAttributes() {
	            var attributes = ['creator', 'subject', 'community', 'degree', 'in_degree', 'out_degree', 'year', 'hubs', 'authorities', 'betweenness_centrality', 'closeness_centrality', 'count_annotation', 'rel_in_degree', 'pagerank'];
	            // Check if first node contains these attributes
	            var s = this.props.sigma;
	            var exampleNode = [];
	            if (s.graph.nodes().length > 0) {
	                exampleNode = s.graph.nodes()[0];
	            }
	            var filteredAttributes = attributes.filter(function (att) {
	                return att in exampleNode;
	            });
	            return filteredAttributes;
	        }
	    }, {
	        key: 'getSliderAttributes',
	        value: function getSliderAttributes() {
	            // TODO: include non-discrete attributes
	            var attributes = ['degree', 'out_degree', 'year', 'count_annotation'];
	            // Check if first node contains these attributes
	            var s = this.props.sigma;
	            var exampleNode = [];
	            if (s.graph.nodes().length > 0) {
	                exampleNode = s.graph.nodes()[0];
	            }
	            var filteredAttributes = attributes.filter(function (att) {
	                return att in exampleNode;
	            });
	            return filteredAttributes;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	            );
	        }
	    }]);
	
	    return GraphProperties;
	}(_react2.default.Component);
	
	exports.default = GraphProperties;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSimpleFileInput = __webpack_require__(481);
	
	var _reactSimpleFileInput2 = _interopRequireDefault(_reactSimpleFileInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadData = function (_React$Component) {
	    _inherits(LoadData, _React$Component);
	
	    function LoadData(props) {
	        _classCallCheck(this, LoadData);
	
	        var _this = _possibleConstructorReturn(this, (LoadData.__proto__ || Object.getPrototypeOf(LoadData)).call(this, props));
	
	        _this.state = {};
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(LoadData, [{
	        key: 'onClick',
	        value: function onClick(e) {
	            var filetxt = e.target.result; //fileReader.readAsDataURL(file);
	            var data = JSON.parse(filetxt);
	            this.props.onClick(data);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            /*<button type="button" onClick={this.onClick}>Load new data</button>*/
	            return _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(_reactSimpleFileInput2.default, { readAs: 'text',
	                    className: 'inputClass',
	                    onLoad: this.onClick })
	            );
	        }
	    }]);
	
	    return LoadData;
	}(_react2.default.Component);
	
	exports.default = LoadData;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modal = function modal(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'Modal',
	                style: {
	                    opacity: props.show ? '1' : '0'
	                } },
	            props.children
	        )
	    );
	};
	
	exports.default = modal;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SigmaNetwork = __webpack_require__(434);
	
	var _SigmaNetwork2 = _interopRequireDefault(_SigmaNetwork);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Network = function (_React$Component) {
	    _inherits(Network, _React$Component);
	
	    function Network(props) {
	        _classCallCheck(this, Network);
	
	        var _this = _possibleConstructorReturn(this, (Network.__proto__ || Object.getPrototypeOf(Network)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.updateFilterProps = _this.updateFilterProps.bind(_this);
	        return _this;
	    }
	
	    _createClass(Network, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.data !== prevProps.data) {
	                this.props.doneLoading();
	            }
	            if (this.props.filterState.minSliderValue !== prevProps.filterState.minSliderValue) {
	                this.props.doneRemounting();
	            }
	            if (this.props.filterState.maxSliderValue !== prevProps.filterState.maxSliderValue) {
	                this.props.doneRemounting();
	            }
	        }
	    }, {
	        key: 'handleChange',
	        value: function handleChange(e) {
	            var node = e.data.node;
	            console.log(node);
	
	            if (node.selected) {
	                node.selected = false;
	            } else {
	                node.selected = true;
	            }
	            this.props.onChange(node);
	        }
	    }, {
	        key: 'updateFilterProps',
	        value: function updateFilterProps(graphProps) {
	            this.props.onInitialization(graphProps);
	        }
	    }, {
	        key: 'onGraphLoaded',
	        value: function onGraphLoaded(data) {
	            data.nodes.forEach(function (node) {
	                node.title = node.title === "" ? node.ecli : node.title;
	                var ecli_split = node.ecli.split(":");
	                node.label = ecli_split[2] + ' ' + ecli_split[3];
	                node.abstract = node.abstract ? node.abstract.replace("\n", "") : "";
	                node.year = node.year ? node.year : ecli_split[3];
	
	                // layout attributes
	                node.x = node.x || Math.random();
	                node.y = node.y || Math.random();
	                node.size = 2 * node.degree;
	                node.color = '#000';
	            });
	            data.edges.forEach(function (edge) {
	                edge.type = "arrow";
	                edge.color = '#999';
	            });
	
	            return data;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.props.loading) {
	                return null;
	            } else {
	                var data = this.onGraphLoaded(this.props.data);
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'Network' },
	                    _react2.default.createElement(_SigmaNetwork2.default, { renderer: 'canvas', style: { maxWidth: "inherit", height: "80vh" },
	                        graph: data,
	                        settings: { minNodeSize: 3, minArrowSize: 4, defaultEdgeColor: '#000' },
	                        onClickNode: this.handleChange,
	                        updateFilterProps: this.updateFilterProps,
	                        filterState: this.props.filterState,
	                        loading: false,
	                        mountLayout: this.props.mountLayout,
	                        setVisibleNodes: this.props.setVisibleNodes
	                    })
	                );
	            }
	        }
	    }]);
	
	    return Network;
	}(_react2.default.Component);
	
	exports.default = Network;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSigma = __webpack_require__(472);
	
	var _ForceAtlas = __webpack_require__(429);
	
	var _ForceAtlas2 = _interopRequireDefault(_ForceAtlas);
	
	var _GraphProperties = __webpack_require__(430);
	
	var _GraphProperties2 = _interopRequireDefault(_GraphProperties);
	
	var _SizeOnAttribute = __webpack_require__(435);
	
	var _SizeOnAttribute2 = _interopRequireDefault(_SizeOnAttribute);
	
	var _ColorOnAttribute = __webpack_require__(426);
	
	var _ColorOnAttribute2 = _interopRequireDefault(_ColorOnAttribute);
	
	var _utils = __webpack_require__(436);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SigmaNetwork = function (_Sigma) {
	    _inherits(SigmaNetwork, _Sigma);
	
	    function SigmaNetwork(props) {
	        _classCallCheck(this, SigmaNetwork);
	
	        var _this = _possibleConstructorReturn(this, (SigmaNetwork.__proto__ || Object.getPrototypeOf(SigmaNetwork)).call(this, props));
	
	        _this.getVisibleNodes = _this.getVisibleNodes.bind(_this);
	        return _this;
	    }
	
	    _createClass(SigmaNetwork, [{
	        key: 'getVisibleNodes',
	        value: function getVisibleNodes() {
	            var _this2 = this;
	
	            var visibleNodes = [];
	            if (this.props.graph.nodes) {
	                this.props.graph.nodes.forEach(function (node) {
	                    var sigmaNode = _this2.sigma.graph.nodes(node.id);
	                    if (!sigmaNode.hidden) {
	                        visibleNodes.push(node);
	                    }
	                });
	            }
	            return visibleNodes;
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.filterState !== this.props.filterState) {
	                this.props.setVisibleNodes(this.getVisibleNodes());
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.setVisibleNodes(this.getVisibleNodes());
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var nodesByIndegree = function nodesByIndegree(indegree) {
	                return function (node) {
	                    return "in_degree" in node && indegree ? node.in_degree >= indegree[0] && node.in_degree <= indegree[1] : true;
	                };
	            };
	
	            var nodesBySliderValue = function nodesBySliderValue(att, minValue, maxValue) {
	                return function (node) {
	                    if (att in node) {
	                        var isLarger = minValue == null ? true : parseInt(node[att], 10) >= minValue;
	                        var isSmaller = maxValue == null ? true : parseInt(node[att], 10) <= maxValue;
	                        return isLarger && isSmaller;
	                    }
	                    return true;
	                };
	            };
	
	            var nodesBySubject = function nodesBySubject(subject) {
	                var subjects = subject.map(function (s) {
	                    return s.value;
	                });
	                return function (node) {
	                    if (subjects.length === 0) {
	                        return true;
	                    } else {
	                        return subjects.includes(node.subject);
	                    }
	                };
	            };
	
	            var nodesByCreator = function nodesByCreator(creator) {
	                var creators = creator.map(function (s) {
	                    return s.value;
	                });
	                return function (node) {
	                    if (creators.length === 0) {
	                        return true;
	                    } else {
	                        return creators.includes(node.creator);
	                    }
	                };
	            };
	
	            var nodesByCommunity = function nodesByCommunity(community) {
	                var communities = community.map(function (s) {
	                    return s.value;
	                });
	                return function (node) {
	                    if (communities.length === 0) {
	                        return true;
	                    } else {
	                        return communities.includes(node.community);
	                    }
	                };
	            };
	
	            var nodesBySelected = function nodesBySelected(filterSelected) {
	                return function (node) {
	                    if (filterSelected) {
	                        return node.selected;
	                    } else {
	                        return true;
	                    }
	                };
	            };
	
	            var nodesBy = function nodesBy(indegree, subject, creator, community, sliderAttributeValue, minSliderValue, maxSliderValue, filterSelected) {
	                return function (node) {
	                    return nodesByIndegree(indegree)(node) && nodesBySliderValue(sliderAttributeValue, minSliderValue, maxSliderValue)(node) && nodesBySubject(subject)(node) && nodesByCreator(creator)(node) && nodesByCommunity(community)(node) && nodesBySelected(filterSelected)(node);
	                };
	            };
	
	            var _props$filterState = this.props.filterState;
	            var inDegreeValue = _props$filterState.inDegreeValue;
	            var subjectValue = _props$filterState.subjectValue;
	            var creatorValue = _props$filterState.creatorValue;
	            var communityValue = _props$filterState.communityValue;
	            var sliderAttributeValue = _props$filterState.sliderAttributeValue;
	            var minSliderValue = _props$filterState.minSliderValue;
	            var maxSliderValue = _props$filterState.maxSliderValue;
	            var sizeAttributeValue = _props$filterState.sizeAttributeValue;
	            var colorAttributeValue = _props$filterState.colorAttributeValue;
	            var filterSelected = _props$filterState.filterSelected;
	
	            var nrNodes = this.props.graph.nodes.length;
	            var nrEdges = this.props.graph.edges.length;
	            var iterationsPerRender = Math.max(Math.ceil(Math.log(nrEdges) / Math.log(10)), 1);
	            var timeout = Math.max(nrNodes * 25, 3000);
	            var forceLayout = _react2.default.createElement(_utils2.default, null); //<span></span>;
	            if (this.props.mountLayout) {
	                forceLayout = _react2.default.createElement(
	                    _ForceAtlas2.default,
	                    {
	                        iterationsPerRender: iterationsPerRender, timeout: timeout, gravity: 1.5,
	                        scalingRatio: 1.3, rerun: false },
	                    _react2.default.createElement(_reactSigma.NOverlap, {
	                        nodeMargin: 1.0, duration: 1000, speed: 5, maxIterations: 50, gridSize: 20, easing: 'quadraticInOut'
	                    })
	                );
	            }
	            if (this.props.loading) {
	                return null;
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { ref: this.initRenderer, style: this.props.style },
	                    _react2.default.createElement(_reactSigma.EdgeShapes, { 'default': 'arrow', sigma: this.sigma }),
	                    _react2.default.createElement(
	                        _GraphProperties2.default,
	                        { onInitialization: this.props.updateFilterProps, sigma: this.sigma },
	                        _react2.default.createElement(
	                            _SizeOnAttribute2.default,
	                            { attribute: sizeAttributeValue },
	                            _react2.default.createElement(
	                                _ColorOnAttribute2.default,
	                                { attribute: colorAttributeValue },
	                                _react2.default.createElement(_reactSigma.Filter, { nodesBy: nodesBy(inDegreeValue, subjectValue, creatorValue, communityValue, sliderAttributeValue, minSliderValue, maxSliderValue, filterSelected) }),
	                                forceLayout
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return SigmaNetwork;
	}(_reactSigma.Sigma);
	
	exports.default = SigmaNetwork;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//type Props = {
	//    attribute: String,
	//    sigma ? : sigma
	//};
	
	/**
	 **/
	
	var SizeOnAttribute = function (_React$Component) {
	    _inherits(SizeOnAttribute, _React$Component);
	
	    function SizeOnAttribute(props) {
	        _classCallCheck(this, SizeOnAttribute);
	
	        var _this = _possibleConstructorReturn(this, (SizeOnAttribute.__proto__ || Object.getPrototypeOf(SizeOnAttribute)).call(this, props));
	
	        _this.updateSize(props);
	        return _this;
	    }
	
	    _createClass(SizeOnAttribute, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            this.updateSize(props);
	        }
	    }, {
	        key: 'updateSize',
	        value: function updateSize(props) {
	            var s = props.sigma;
	            var minSize = Number.MAX_SAFE_INTEGER;
	            s.graph.nodes().forEach(function (node) {
	                minSize = Math.min(minSize, node[props.attribute]);
	            });
	            s.graph.nodes().forEach(function (node) {
	                node.size = node[props.attribute] - minSize;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	            );
	        }
	    }]);
	
	    return SizeOnAttribute;
	}(_react2.default.Component);
	
	exports.default = SizeOnAttribute;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	This helper component can be used if a component should be unmountent,
	so you want to render an empty component. Just rendering 'null' gives errors in some cases.
	*/
	var EmptyComponent = function (_React$Component) {
	    _inherits(EmptyComponent, _React$Component);
	
	    function EmptyComponent() {
	        _classCallCheck(this, EmptyComponent);
	
	        return _possibleConstructorReturn(this, (EmptyComponent.__proto__ || Object.getPrototypeOf(EmptyComponent)).apply(this, arguments));
	    }
	
	    _createClass(EmptyComponent, [{
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return EmptyComponent;
	}(_react2.default.Component);
	
	exports.default = EmptyComponent;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(440);
	
	__webpack_require__(418);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(424);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(444);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 438 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 439 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 440 */
439,
/* 441 */
439,
/* 442 */
439,
/* 443 */
439,
/* 444 */
439,
/* 445 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 446 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = {
		"name": "case-law-app-js",
		"version": "0.5.0",
		"private": true,
		"homepage": "https://nlesc.github.io/case-law-app",
		"devDependencies": {
			"enzyme": "=2.7.1",
			"gh-pages": "=0.12.0",
			"react-addons-test-utils": "=15.4.2",
			"react-dom": "15.4.2",
			"react-scripts": "0.7.0"
		},
		"dependencies": {
			"babyparse": "^0.4.6",
			"colormap": "2.2.0",
			"rc-slider": "^8.1.5",
			"react": "15.4.2",
			"react-dom": "15.4.2",
			"react-mdl": "^1.11.0",
			"react-select": "^1.0.0-rc.5",
			"react-sigma": "=1.2.17",
			"react-simple-file-input": "1.0.0"
		},
		"scripts": {
			"start": "react-scripts start",
			"build": "react-scripts build",
			"test": "react-scripts test --env=jsdom",
			"eject": "react-scripts eject",
			"deploy": "npm run build&&gh-pages -d build"
		}
	};

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Werkgever aansprakelijkheid",
		"edges": [
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596"
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632_http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
				"target": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
				"source": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632"
			}
		],
		"nodes": [
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:3019",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 690",
					"Burgerlijk Wetboek Boek 7 610"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Toepasselijkheid CAO's uitzendbranche. Overeenkomst waarbij een onderneming bemiddelt bij de plaatsing van MBO-leerlingen in leerbedrijven in het kader van in het onderwijs verplichte stages. Gaan de leerlingen een arbeidsovereenkomst aan? Motiveringsgebrek.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "10",
				"ecli": "ECLI:NL:HR:2015:3019",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2015-10-09",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 7,
				"x": 0.02987929754987806,
				"y": 0.7496325701649635,
				"title": "ECLI:NL:HR:2015:3019 Hoge Raad , 09-10-2015 / 14/03393",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2015
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2015:644",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 6,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Burgerlijk Wetboek Boek 6 129",
					"Invorderingswet 1990",
					"Invorderingswet 1990 38",
					"Burgerlijk Wetboek Boek 6",
					"Burgerlijk Wetboek Boek 6 127"
				],
				"in_degree": 0,
				"abstract": "Artikel 38 Invorderingswet 1990. Aansprakelijkstelling werknemer voor niet door werkgever ingehouden loonbelasting. Interne compensatie door ontvanger.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "27",
				"ecli": "ECLI:NL:HR:2015:644",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2015-03-20",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 7,
				"x": 0.7754500135230601,
				"y": 0.43450911131100023,
				"title": "ECLI:NL:HR:2015:644 Hoge Raad , 20-03-2015 / 13/04344",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2015
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:3519",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"6:74 bw",
					"Wetboek van Burgerlijke Rechtsvordering",
					"Burgerlijk Wetboek Boek 7 658",
					"Wetboek van Burgerlijke Rechtsvordering 25",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 611",
					"Burgerlijk Wetboek Boek 6 74",
					"Burgerlijk Wetboek Boek 6"
				],
				"in_degree": 0,
				"abstract": "Werkgeversaansprakelijkheid. Art. 7:658 BW. Zorgplicht werkgever. Aanvullende veiligheidsmaatregelen indien de plaats van werkzaamheden belet dat werkgever toezicht houdt op naleving van instructies? HR 7 december 2012, ECLI:NL:HR:2012:BX7590, NJ 2013/11. Mate waarin werkgever toezicht moet houden op naleving instructies. Hoge eisen aan stelplicht werkgever? Onderscheid met HR 11 november 2011, ECLI:NL:HR:2011:BR5223, NJ 2011/598. Omstandigheden van het geval. Verwijt dat werkgever in strijd met cao geen ongevallenverzekering heeft afgesloten; art. 6:74 BW; aanvulling rechtsgronden.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "2",
				"ecli": "ECLI:NL:HR:2014:3519",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2014-12-05",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.053277835587929236,
				"count_version": 8,
				"x": 0.7550405894812772,
				"y": 0.7795141268483574,
				"title": "ECLI:NL:HR:2014:3519 Hoge Raad , 05-12-2014 / 13/03613",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2014
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2014:943",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 5,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 1019bb",
					"Wetboek van Burgerlijke Rechtsvordering 1019aa",
					"Wetboek van Burgerlijke Rechtsvordering 1019w",
					"Wetboek van Burgerlijke Rechtsvordering 1019cc",
					"Wetboek van Burgerlijke Rechtsvordering"
				],
				"in_degree": 0,
				"abstract": "Deelgeschilprocedure, art. 1019w Rv. Doorbreking rechtsmiddelenverbod van art. 1019bb Rv? Doorbrekingsjurisprudentie van overeenkomstige toepassing? Vormt het rechtsmiddel, bedoeld in art. 1019cc lid 3 Rv aanleiding om doorbreking niet toe te staan? HR 28 september 2012, ECLI:NL:HR:2012:BX0598, NJ 2012/556. Levert stelling dat beëindiging deelgeschil niet kan bijdragen aan totstandkoming vaststellingsovereenkomst doorbrekingsgrond op? HR 24 september 1993, ECLI:NL:HR:1993:ZC1076, NJ 1993/758. Proceskosten in cassatie; art. 1019aa Rv.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "23",
				"ecli": "ECLI:NL:HR:2014:943",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2014-04-18",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 11,
				"x": 0.841335400674125,
				"y": 0.36903970667494834,
				"title": "ECLI:NL:HR:2014:943 Hoge Raad , 18-04-2014 / 13/01106",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2014
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1721",
				"out_degree_centrality": 0.03870967741935484,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wetboek van Burgerlijke Rechtsvordering",
					"Burgerlijk Wetboek Boek 7 658",
					"Burgerlijk Wetboek Boek 6 99",
					"Wetboek van Burgerlijke Rechtsvordering 150",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 6 101",
					"Burgerlijk Wetboek Boek 6",
					"Burgerlijk Wetboek Boek 6 98"
				],
				"in_degree": 0,
				"abstract": "\n         Werkgeversaansprakelijkheid wegens blootstelling aan gevaarlijke stoffen, art. 7:658 BW. Causaal verband, omkeringsregel, stelplicht en  bewijslast (HR 17 november 2000, LJN AA8369, NJ 2001/596, Unilever/[A], HR 23 juni 2006, LJN AW6166, NJ 2006/354, [B/C], en HR 9 januari 2009, LJN BF8875, NJ 2011/252, [D]/BAM). Grootte van de kans op veroorzaking door gestelde blootstelling mede van belang. Onzekerheid of onbepaaldheid van het verband tussen gezondheidsschade en arbeidsomstandigheden. Kenbaarheid van gevaren ten tijde van de blootstelling? Omvang zorgplicht werkgever, voorzorgsmaatregelen, omstandigheden van het geval. Proportionele aansprakelijkheid, oorzaak die voor risico van benadeelde zelf komt (HR 31 maart 2006, LJN AU6092, NJ 2011/250).",
				"authorities": 0,
				"hubs": 0.19199218276297386,
				"community": "0",
				"ecli": "ECLI:NL:HR:2013:BZ1721",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2013-06-07",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.04778972520908004,
				"count_version": 9,
				"x": 0.5342422767095781,
				"y": 0.028789163304819065,
				"title": "ECLI:NL:HR:2013:BZ1721 Hoge Raad , 07-06-2013 / 12/03390",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 6,
				"degree": 6,
				"year": 2013
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1717",
				"out_degree_centrality": 0.03225806451612903,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wetboek van Burgerlijke Rechtsvordering",
					"Burgerlijk Wetboek Boek 7 658",
					"Burgerlijk Wetboek Boek 6 99",
					"Wetboek van Burgerlijke Rechtsvordering 150",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 6 101",
					"Burgerlijk Wetboek Boek 6"
				],
				"in_degree": 0,
				"abstract": "\n         Werkgeversaansprakelijkheid voor RSI;, art. 7:658 BW. Zorgplicht werkgever, art. 4 Besluit beeldschermwerk; inlichtingenplicht werkgever over aard werkzaamheden en daaraan verbonden gevaren en maatregelen ter voorkoming of beperking gevaren, art. 6 lid 1 Arbeidsomstandighedenwet 1994.  Causaal verband, omkeringsregel, stelplicht en  bewijslast (HR 17 november 2000, LJN AA8369, NJ 2001/596, Unilever/[A], HR 23 juni 2006, LJN AW6166, NJ 2006/354, [B/C], en HR 9 januari 2009, LJN BF8875, NJ 2011/252, [D]/BAM). Onzekerheid of onbepaaldheid van het verband tussen gezondheidsschade en arbeidsomstandigheden; onduidelijkheid omtrent aard en oorzaak van gestelde gezondheidsklachten. Geen proportionele aansprakelijkheid (HR 31 maart 2006, LJN AU6092, NJ 2011/250). Vaststelling van verband tussen gezondheidsklachten en arbeidsomstandigheden oordeel van feitelijke aard.",
				"authorities": 0,
				"hubs": 0.1739452989471851,
				"community": "0",
				"ecli": "ECLI:NL:HR:2013:BZ1717",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2013-06-07",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0469208211143695,
				"count_version": 8,
				"x": 0.5834857221275371,
				"y": 0.8718783773185426,
				"title": "ECLI:NL:HR:2013:BZ1717 Hoge Raad , 07-06-2013 / 12/01939",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 5,
				"degree": 5,
				"year": 2013
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2013:BZ1780",
				"out_degree_centrality": 0.03225806451612903,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:663 bw",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 663",
					"Burgerlijk Wetboek Boek 7 662"
				],
				"in_degree": 0,
				"abstract": "Overgang van onderneming in de zin van art. 7:663 BW; voortzetting dienstverband met verkrijgende partij. Werknemer in dienst van personeelsvennootschap maar tewerkgesteld bij tot hetzelfde concern behorende andere vennootschap, wier onderneming wordt overgedragen. Richtlijnconforme uitleg van “werkgever” (art. 7:663 BW) in licht van art. 3 Richtlijn 2001/23/EG. Bedoeling van wetgever; algemene rechtsbeginselen, rechtszekerheidsbeginsel, verbod van terugwerkende kracht, contra legem-uitleg.",
				"authorities": 0,
				"hubs": 2.3409835357982093e-38,
				"community": "20",
				"ecli": "ECLI:NL:HR:2013:BZ1780",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2013-04-05",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03225806451612903,
				"count_version": 9,
				"x": 0.8181708111809385,
				"y": 0.7450794496272304,
				"title": "ECLI:NL:HR:2013:BZ1780 Hoge Raad , 05-04-2013 / 12/00667",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 5,
				"degree": 5,
				"year": 2013
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX7590",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Arubaanse zaak. Zorgverplichting werkgever, aansprakelijkheid; toezicht op naleving veiligheidsmaatregelen door (ervaren) werknemers. Beschikbaarheid veiligheidsmateriaal; instructies door werkgever. Art. 7A:1614x BWA (art. 7:658 BW).",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2012:BX7590",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2012-12-07",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.14285714285714285,
				"closeness_centrality": 0,
				"count_version": 7,
				"x": 0.22151717541163396,
				"y": 0.7466617017044543,
				"title": "ECLI:NL:HR:2012:BX7590 Hoge Raad , 07-12-2012 / 11/05535",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2012
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BX0598",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"10 evrm"
				],
				"in_degree": 1,
				"abstract": "(Appel)procesrecht. Recht op pleidooi in incident; art. 134, 208 en 353 Rv. Appelverbod van art. 337 lid 2 Rv; toepasselijkheid ‘doorbrekingsjurisprudentie’; gronden voor doorbreking wettelijk appelverbod. Art. 10 EVRM.",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "23",
				"ecli": "ECLI:NL:HR:2012:BX0598",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2012-09-28",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.125,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.5202191825928794,
				"y": 0.21833970074123765,
				"title": "ECLI:NL:HR:2012:BX0598 Hoge Raad , 28-09-2012 / 11/03974",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2012
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2012:BV1295",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw",
					"Burgerlijk Wetboek Boek 7 685",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 611"
				],
				"in_degree": 0,
				"abstract": "Uitleg dekkingsomvang AVB-polis. Aansprakelijkheid werkgever bij verkeersongeval werknemer op grond van art. 7:611 BW (verzekeringsplicht niet nagekomen). Is schade werknemer letselschade in zin van polis? Functie AVB-polis en daarop gebaseerde verwachtingen rechtvaardigen ruime uitleg dekkingsomvang; dekking tegen aansprakelijkheid voor letselschade omvat in beginsel ook dekking tegen op art. 7:611 gebaseerde aansprakelijkheid.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "2",
				"ecli": "ECLI:NL:HR:2012:BV1295",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2012-03-30",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03870967741935484,
				"count_version": 8,
				"x": 0.5914288260235278,
				"y": 0.3948126445905893,
				"title": "ECLI:NL:HR:2012:BV1295 Hoge Raad , 30-03-2012 / 11/01010",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2012
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BU7412",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:2 bw",
					"6:2 bw",
					"Burgerlijk Wetboek Boek 7 2",
					"Burgerlijk Wetboek Boek 6 2",
					"Burgerlijk Wetboek Boek 3 296",
					"Burgerlijk Wetboek Boek 3 39",
					"Burgerlijk Wetboek Boek 6",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 3"
				],
				"in_degree": 1,
				"abstract": "Cassatie in belang der wet. Koop. Ook aan particuliere verkoper komt jegens particuliere koper beroep toe op schriftelijkheidsvereiste art. 7:2 lid 1 BW. Medewerking aan schriftelijke vastlegging kan niet met rechterlijk vonnis worden afgedwongen. Vordering tot schadevergoeding evenmin toewijsbaar. Beroep op art. 6:2 lid 2 BW alleen onder zeer bijzondere omstandigheden. In dat geval slechts veroordeling tot schadevergoeding mogelijk.",
				"authorities": 1.6236909940434693e-38,
				"hubs": 0,
				"community": "20",
				"ecli": "ECLI:NL:HR:2011:BU7412",
				"pagerank": 0.004491219658822496,
				"betweenness_centrality": 0,
				"date": "2011-12-09",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.1,
				"closeness_centrality": 0,
				"count_version": 8,
				"x": 0.5711896553621079,
				"y": 0.6628610333561578,
				"title": "ECLI:NL:HR:2011:BU7412 Hoge Raad , 09-12-2011 / 11/03863 (CW 2629)",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5223",
				"out_degree_centrality": 0.03225806451612903,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw",
					"7:658 bw",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 611",
					"Burgerlijk Wetboek Boek 7 658"
				],
				"in_degree": 1,
				"abstract": "Werkgeversaansprakelijkheid. Letsel werknemer door geweldsdelict tijdens uitvoering werkzaamheden in TBS-instelling. Ongeval dat voortvloeit uit gevaarzettende situatie die rechtstreeks verband houdt met en inherent is aan uitvoering werkzaamheden waaraan werknemer zich niet kan onttrekken. In geval als onderhavige hoge eisen stelplicht werkgever dat hij in art. 7:658 lid 1 BW bedoelde maatregelen is nagekomen. Temeer nu ambtenaar met soortgelijke functie op grond van art. 69 lid 2 ARAR recht heeft op volledige schadevergoeding. Hof heeft miskend dat werkgever niet aan stelplicht en bewijslast heeft voldaan. Art. 7:658 geen absolute waarborg voor bescherming werknemer. Daarmee strookt niet bij “structureel gevaarlijk werk” aansprakelijkheid uit hoofde van goed werkgeverschap (art. 7:611 BW) aan te nemen indien werkgever uit art. 7:658 voortvloeiende verplichtingen is nagekomen. Op art. 7:611 BW gebaseerde verzekeringsverplichting niet ook in onderhavig geval; afbakening tot verkeersongevallen (vgl. HR 11 november 2011, nr. 10/04875).",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0.0035351501650317716,
				"community": "2",
				"ecli": "ECLI:NL:HR:2011:BR5223",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0.0012568077084206116,
				"date": "2011-11-11",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.09090909090909091,
				"closeness_centrality": 0.06311360448807854,
				"count_version": 9,
				"x": 0.3815432967340322,
				"y": 0.9728451661984117,
				"title": "ECLI:NL:HR:2011:BR5223 Hoge Raad , 11-11-2011 / 10/04571",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 5,
				"degree": 6,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BR5215",
				"out_degree_centrality": 0.03225806451612903,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 611",
					"Burgerlijk Wetboek Boek 7 658"
				],
				"in_degree": 1,
				"abstract": "Werkgeversaansprakelijkheid. Letsel werknemer door uitglijden tijdens te voet bezorgen van post. Uit goed werkgeverschap voortvloeiende verzekeringsverplichting beperkt tot verkeersongevallen. Algemene verzekeringsplicht in strijd met strekking art. 7:658 BW. Taak wetgever; algemene regeling voor bescherming tegen risico van ongevallen gaat rechtsvormende taak rechter te buiten. Afbakening verzekeringsverplichting nodig met oog op rechtszekerheid en hanteerbaarheid recht.",
				"authorities": 1.570337572619915e-96,
				"hubs": 0.0037281970513766936,
				"community": "2",
				"ecli": "ECLI:NL:HR:2011:BR5215",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0.0009635525764558023,
				"date": "2011-11-11",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.08333333333333333,
				"closeness_centrality": 0.04740143369175626,
				"count_version": 9,
				"x": 0.49857872641021583,
				"y": 0.10555493915933245,
				"title": "ECLI:NL:HR:2011:BR5215 Hoge Raad , 11-11-2011 / 10/04875",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 5,
				"degree": 6,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3514",
				"out_degree_centrality": 0.03225806451612903,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 658"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
				"authorities": 0,
				"hubs": 0.1686404843774492,
				"community": "0",
				"ecli": "ECLI:NL:HR:2011:BQ3514",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2011-07-08",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0380513495720869,
				"count_version": 7,
				"x": 0.18533088302002598,
				"y": 0.6682680599969092,
				"title": "ECLI:NL:HR:2011:BQ3514 Hoge Raad , 08-07-2011 / 10/00425",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 5,
				"degree": 5,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3519",
				"out_degree_centrality": 0.01935483870967742,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 658"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
				"authorities": 0,
				"hubs": 0.06583819041971194,
				"community": "0",
				"ecli": "ECLI:NL:HR:2011:BQ3519",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2011-07-08",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.01935483870967742,
				"count_version": 5,
				"x": 0.3529768768594268,
				"y": 0.7284771009369668,
				"title": "ECLI:NL:HR:2011:BQ3519 Hoge Raad , 08-07-2011 / 10/00430",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 3,
				"degree": 3,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BQ3517",
				"out_degree_centrality": 0.01935483870967742,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Schade werknemer als gevolg van blootstelling tijdens uitoefening werkzaamheden aan voor de gezondheid gevaarlijke concentratie van stoffen. Stelplicht en bewijslastverdeling. Ingevolge art. 7:658 lid 2 BW dient de werknemer te stellen en zo nodig te bewijzen gedurende zijn werkzaamheden te zijn blootgesteld aan voor de gezondheid gevaarlijke stoffen en aannemelijk te maken dat hij lijdt aan een ziekte of gezondheidsklacht die door die blootstelling kan zijn veroorzaakt (vgl. HR 17 november 2000, NJ 2001/596). Beoordeling rapport deskundige. Rechter dient ter beantwoording van de vraag of hij de conclusies van deskundige zal volgen, alle ter zake door partijen aangevoerde feiten en omstandigheden in aanmerking te nemen en op basis van die aangevoerde stellingen in volle omvang te toetsen of aanleiding bestaat van de in het rapport geformuleerde conclusies af te wijken.",
				"authorities": 0,
				"hubs": 0.06583819041971194,
				"community": "0",
				"ecli": "ECLI:NL:HR:2011:BQ3517",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2011-07-08",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.01935483870967742,
				"count_version": 3,
				"x": 0.4907846092437922,
				"y": 0.9161858992477155,
				"title": "ECLI:NL:HR:2011:BQ3517 Hoge Raad , 08-07-2011 / 10/00428",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 3,
				"degree": 3,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2011:BP9991",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 166",
					"Wetboek van Burgerlijke Rechtsvordering",
					"Burgerlijk Wetboek Boek 7 658",
					"Wetboek van Burgerlijke Rechtsvordering 150",
					"Algemene wet gelijke behandeling",
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 611",
					"Algemene wet gelijke behandeling 10"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht/Procesrecht. Vordering tot vergoeding op de voet van art. 7:611 en 7:658 BW tot vergoeding van als gevolg van discriminatie geleden schade. Aanbod aanvullend bewijs te leveren op ontoereikende gronden gepasseerd. Hoger beroep kan dienen om eigen fouten en vergissingen te herstellen. Het kan ook dienen om aanvullend bewijs te leveren als de eerste rechter het reeds bijgebrachte bewijs onvoldoende zwaarwegend heeft geacht. Van appellant die bij memorie van grieven nader bewijs aanbiedt, daarbij gebruikmakend van de gelegenheid tot verbetering of aanvulling van hetgeen hij in eerste aanleg heeft gedaan of nagelaten, kan in beginsel niet worden gevergd dat hij een rechtvaardiging geeft van zijn eerdere verzuim (vgl. HR 1 maart 2002, NJ 2003/355). Te hoge eisen aan (specificatie van) bewijsaanbod.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "11",
				"ecli": "ECLI:NL:HR:2011:BP9991",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2011-05-27",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 7,
				"x": 0.09721814629199965,
				"y": 0.35481552661979243,
				"title": "ECLI:NL:HR:2011:BP9991 Hoge Raad , 27-05-2011 / 10/02358",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2011
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BO1799",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Verbintenissenrecht. Beheerovereenkomst. Zorgplicht vermogensbeheerder. Causaliteitsonzekerheid. Op de vermogensbeheerder, als ter zake bij uitstek professionele en deskundige partij, rust naar de aard van de tussen partijen gesloten beheerovereenkomst een bijzondere op de eisen van redelijkheid en billijkheid gebaseerde, zorgplicht. Deze kon meebrengen dat de vermogensbeheerder de cliënt, ondanks diens eigenzinnigheid en betrokkenheid bij de onderneming waarin is belegd, uitdrukkelijk en in niet voor misverstand vatbare bewoordingen diende te waarschuwen voor de door deze m.b.t. de samenstelling van zijn portefeuille genomen risico’s. Ter beantwoording van de vragen of de waarschuwingsplicht in een concreet geval bestaat, en hoever zij strekt, dienen alle relevante omstandigheden van het geval te worden meegewogen. De in HR 31 maart 2006, LJN AU6092, Nefalit/Keramus, geformuleerde rechtsregel dient - gelet op het daaraan verbonden bezwaar dat iemand mogelijk aansprakelijk wordt gehouden voor een schade die hij niet, of niet in de door de rechter aangenomen mate, heeft veroorzaakt - met terughoudendheid te worden toegepast. De rechter die deze regel toepast dient, om deze reden, bovendien in zijn motivering te verantwoorden dat de strekking van de geschonden norm en de aard van de normschending - waaronder begrepen de aard van de door de benadeelde geleden schade - deze toepassing in het concrete geval rechtvaardigen. Deze rechtsregel is niet alleen van toepassing op een situatie als zich voordeed in Nefalit/Keramus. Voor toepassing kan met name aanleiding zijn als de aansprakelijkheid van de aangesprokene vaststaat, en een niet zeer kleine kans bestaat dat het c.s.q.n.-verband bestaat tussen geschonden norm en geleden schade en de strekking van de geschonden norm en de aard van de normschending toepassing rechtvaardigen.",
				"authorities": 0,
				"hubs": 0.028849603305574067,
				"community": "0",
				"ecli": "ECLI:NL:HR:2010:BO1799",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2010-12-24",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 8,
				"x": 0.14035861096535096,
				"y": 0.7221935424303828,
				"title": "ECLI:NL:HR:2010:BO1799 Hoge Raad , 24-12-2010 / 09/01275",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN6236",
				"out_degree_centrality": 0.01935483870967742,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 5,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6:174 bw"
				],
				"in_degree": 0,
				"abstract": "Bezittersaansprakelijkheid voor verschuiving kade (een veendijk). (Bouw)werk in de zin van art. 6:174 BW vereist menselijk ingrijpen dat heeft bijgedragen aan de (duurzame) bestemming of functie van dat werk. Oordeel hof dat de dijk een opstal is nu het dijklichaam is ontstaan door uitgraving en drooglegging, is gevormd naar de inzichten in waterkeringen, in stand is gehouden overeenkomstig daarvoor ontwikkelde richtlijnen en voorzien is van een in de grond aangebrachte beschoeiing, is juist. Bij het antwoord op de vraag of de opstal voldoet aan de eisen die men daaraan in de gegeven omstandigheden mag stellen, komt het aan op de - naar objectieve maatstaven te beantwoorden - vraag of de opstal, gelet op het te verwachten gebruik of de bestemming daarvan, met het oog op voorkoming van gevaar voor personen en zaken deugdelijk is, waarbij ook van belang is hoe groot de kans op verwezenlijking van het gevaar is en welke onderhouds- en veiligheidsmaatregelen mogelijk en redelijkerwijs te vergen zijn. Anders dan het hof heeft geoordeeld, komt bij de beoordeling of de dijk gebrekkig was betekenis toe aan de toenmalige stand van wetenschap en techniek en de financiële kaders waarbinnen het overheidslichaam zijn beleidsdoelstellingen tracht te realiseren, alsmede aan de gestelde specifieke en uitzonderlijke omstandigheden waaronder de dijkverschuiving zich heeft voorgedaan. Of bezitter bij bekendheid met het gevaar toerekenbaar onrechtmatig heeft gehandeld, hangt af van alle relevante omstandigheden van het geval en daarbij kan ook betekenis toekomen aan omstandigheden die de bezitter in het kader van zijn beroep op de afwezigheid van een gebrekkige toestand heeft aangevoerd. Oordeel hof dat beroep op tenzij-clausule moet worden afgewezen, onjuist noch onbegrijpelijk.",
				"authorities": 0,
				"hubs": 5.421299387173451e-57,
				"community": "7",
				"ecli": "ECLI:NL:HR:2010:BN6236",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2010-12-17",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.01935483870967742,
				"count_version": 10,
				"x": 0.33815463714618754,
				"y": 0.7375954463533632,
				"title": "ECLI:NL:HR:2010:BN6236 Hoge Raad , 17-12-2010 / 09/03735",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 3,
				"degree": 3,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN9977",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wet op de rechterlijke organisatie 81"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Arbeidsongeval in de zin van art. 7:658 BW; arbeidsongeschiktheid als gevolg van drinken verontreinigd drinkwater uit onverzegelde fles op platform in tropen en door onhygiënische situatie aldaar. Verweer werkgever dat hij ten aanzien van de te treffen voorzorgsmaatregelen aan zijn verplichtingen heeft voldaan, in het licht van gemotiveerde stellingen werkgever, onvoldoende betwist. Geen miskenning van ex art. 7:658 lid 2 BW op werkgever rustende bewijslast (vgl. HR 25 mei 2007, NJ 2008/463). Enkele omstandigheid dat een algemeen bekend risico zich verwezenlijkt, schept nog geen verplichting tot treffen maatregelen (vgl. HR 8 februari 2008, NJ 2008/93). Stelplicht.",
				"authorities": 0,
				"hubs": 0.00030255519676348423,
				"community": "4",
				"ecli": "ECLI:NL:HR:2010:BN9977",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2010-11-26",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.014746543778801843,
				"count_version": 9,
				"x": 0.7105313024185851,
				"y": 0.4783137714548331,
				"title": "ECLI:NL:HR:2010:BN9977 Hoge Raad , 26-11-2010 / 09/04674",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BO3935",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.6236909940434693e-38,
				"hubs": 0,
				"community": "20",
				"ecli": "ECLI:NL:XX:2010:BO3935",
				"pagerank": 0.004491219658822496,
				"betweenness_centrality": 0,
				"date": "2010-10-21",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.05,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.9369905681073917,
				"y": 0.9542872265781124,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7808",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6:100 bw"
				],
				"in_degree": 0,
				"abstract": "Verbintenissenrecht/verzekeringsrecht. Verrekening van voordeel ex art. 6:100 BW. Aan werknemer overkomen ongeval als gevolg waarvan hij blijvend invalide is. Of aan werknemer uit hoofde van een ten behoeve van hem door de werkgever afgesloten ongevallenverzekering uitbetaald bedrag als voordeel in de zin van art. 6:100 BW in redelijkheid in mindering moet worden gebracht op het door de aansprakelijkheidsverzekeraar van de werkgever aan werknemer uit te keren bedrag hangt af van diverse omstandigheden. Aan de rechter is een ruime vrijheid gelaten om te beoordelen of verrekening van voordeel in een concreet geval redelijk is. Gezichtspunten voor verrekening in geval van letselschade en voordeel dat bestaat uit een verzekeringsuitkering.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "19",
				"ecli": "ECLI:NL:HR:2010:BM7808",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2010-10-01",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 7,
				"x": 0.9337692396902756,
				"y": 0.5520852222824065,
				"title": "ECLI:NL:HR:2010:BM7808 Hoge Raad , 01-10-2010 / 09/00418",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BM7041",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"3:310 bw",
					"7:658 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Verjaring van op grond van art. 7:658 BW tegen werkgever ingestelde vordering tot vergoeding schade als gevolg van RSI-klachten. Om de verjaringstermijn te doen aanvangen is geen bekendheid van benadeelde met alle schadecomponenten vereist. Voldoende is dat benadeelde bekend is met schade die hij lijdt of heeft geleden als gevolg van foutief handelen. Verjaring die op de voet van art. 3:310 BW begint te lopen, geldt mede voor de vordering tot vergoeding van schade waarvan de benadeelde kon verwachten dat hij die als gevolg van datzelfde tekortschietend handelen zou kunnen gaan lijden. Maatstaf verjaring: HR 9 oktober 2009, LJN BJ 4850.",
				"authorities": 0,
				"hubs": 1.3401624883961085e-29,
				"community": "6",
				"ecli": "ECLI:NL:HR:2010:BM7041",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2010-09-10",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 9,
				"x": 0.09061799277723226,
				"y": 0.7228758966015412,
				"title": "ECLI:NL:HR:2010:BM7041 Hoge Raad , 10-09-2010 / 08/04220",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BN3831",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "Inkomstenbelasting/premie volksverzekeringen; artikel 3.145, lid 1, Wet IB: Hof verdeelt bewijslast bijtelling auto van de zaak verkeerd; beroep op interne compensatie in hoger beroep mogelijk zonder incidenteel hoger beroep in te stellen; verwijzing.",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "27",
				"ecli": "ECLI:NL:HR:2010:BN3831",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2010-08-13",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.043478260869565216,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.46825614111628633,
				"y": 0.8875582102835645,
				"title": "ECLI:NL:HR:2010:BN3831 Hoge Raad , 13-08-2010 / 08/03782",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2010:BK4476",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6:101 bw"
				],
				"in_degree": 3,
				"abstract": "Luchtvaartwet (LVW), schadeloosstelling ex art. 50 (oud), waardevermeerdering ex art. 55 (oud). Geschil over schade door bouwverbod voor terrein in nabijheid van luchthaven Schiphol (zie ook HR 6 februari 2009, LJN BG5056). Ontvankelijkheid in cassatie (art. 54 lid 4 en 5 LVW jo. 53 Ow), herstel vormverzuim niet-betekening afgelegde verklaring. Economisch eigenaar moet voor de toepassing van art. 50 en 55 LVW worden aangemerkt als eigenaar. Recht om waardevermeerdering te vorderen ex art. 55 LVW gaat niet teniet doordat deze bepaling in 2003 buiten werking is gesteld voor luchthaven Schiphol, nu het bouwverbod voor die tijd is opgelegd. Het systeem van de LVW laat toepassing van de eigenschuld-regeling van art. 6:101 BW onverlet. Bij de vaststelling van de schadeloosstelling ex art. 50 LVW dient ook rekening te worden gehouden met de (in art. 55 LVW bedoelde) gevolgen van de opheffing van het bouwverbod. In procedure ex art. 50 LVW mag rechter ook wat betreft zekerheidstelling rekening houden met het bepaalde in art. 55 LVW. Leer van de bindende eindbeslissing geldt niet in een procedure op de voet van art. 50 LVW. Regeling verandering/vermeerdering eis in art. 130 Rv. is niet van toepassing in procedure ex art. 50 LVW.",
				"authorities": 0.07610823628465141,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:2010:BK4476",
				"pagerank": 0.006666384047121367,
				"betweenness_centrality": 0,
				"date": "2010-02-19",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.125,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.6351150765315371,
				"y": 0.31119633468821406,
				"title": "ECLI:NL:HR:2010:BK4476 Hoge Raad , 19-02-2010 / 08/01550 en 08/01502",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 3,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2010:BL0510",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.6236909940434693e-38,
				"hubs": 0,
				"community": "20",
				"ecli": "ECLI:NL:XX:2010:BL0510",
				"pagerank": 0.004491219658822496,
				"betweenness_centrality": 0,
				"date": "2010-01-19",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.04,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.5891665187423467,
				"y": 0.5132926538949325,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 2010
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ7832",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"83c zfw",
					"Ziekenfondswet 83c"
				],
				"in_degree": 0,
				"abstract": "Sociale zekerheidsrecht. Regresrecht ex art. 83c Zfw? Zware verwonding bij arbeidsongeval. Aansprakelijkheid werkgever ex art. 7:658 BW brengt nog niet met zich dat ziekenfonds op hem ex art. 83c Zfw regres kan nemen. Het arbeidsongeval moet in overwegende mate het gevolg zijn van een, aan de leiding van de onderneming te wijten, falende organisatie van de bewuste, risicovolle, werkzaamheden binnen de onderneming van de werkgever, welke van dien aard is dat deze als opzet of bewuste roekeloosheid van de werkgever valt aan te merken. Om handelen of nalaten van een werknemer van een rechtspersoon als opzet of bewuste roekeloosheid van de werkgever te kunnen kwalificeren, zal in het algemeen bepalend zijn of de positie van deze werknemer binnen de kring van de onderneming in het maatschappelijk verkeer met die van de desbetreffende bestuurder op één lijn kan worden gesteld.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "21",
				"ecli": "ECLI:NL:HR:2009:BJ7832",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-11-27",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 7,
				"x": 0.10216875574675943,
				"y": 0.17264656102106635,
				"title": "ECLI:NL:HR:2009:BJ7832 Hoge Raad , 27-11-2009 / 07/13470",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI9632",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6 evrm",
					"Verdrag inzake de verlening van Europese octrooien (Europees Octrooiverdrag), München, 05-10-1973"
				],
				"in_degree": 0,
				"abstract": "Internationaal privaatrecht. Immuniteit van jurisdictie van internationale organisatie (Europese Octrooi Organisatie) in arbeidsgeschil voor Nederlandse rechter. Geschillen die onmiddellijk verband houden met de vervulling van de aan de internationale organisatie opgedragen taken (maatstaf). Vraag of interne rechtsgang binnen de internationale organisatie voldoet aan art. 6 EVRM (recht op openbare hoorzitting).",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "1",
				"ecli": "ECLI:NL:HR:2009:BI9632",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-10-23",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 6,
				"x": 0.1184961131647716,
				"y": 0.9984309024243107,
				"title": "ECLI:NL:HR:2009:BI9632 Hoge Raad , 23-10-2009 / 08/00118",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BJ4850",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"3:310 bw"
				],
				"in_degree": 1,
				"abstract": "Verbintenissenrecht. Borgstelling. Daadwerkelijk bekend met schade. Verjaringstermijn van 5 jaar als bedoeld in art. 3:310 lid 1 BW. Stuiting. Maatstaf (vgl. HR 24 januari 2003, NJ 2003, 300 en HR 20 februari 2004, NJ 2006, 113). Bekendheid met kans op schade niet voldoende.",
				"authorities": 7.206213554442336e-30,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:2009:BJ4850",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2009-10-09",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.03571428571428571,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.6331523163825813,
				"y": 0.7538687109079258,
				"title": "ECLI:NL:HR:2009:BJ4850 Hoge Raad , 09-10-2009 / 07/13351",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI6323",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Procesrecht. Arbeidsrecht. Kennelijk onredelijk ontslag. Oordeel niet te verenigen met oordeel van hof in 7:658-zaak. Innerlijke tegenstrijdigheid arrest.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "15",
				"ecli": "ECLI:NL:HR:2009:BI6323",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-09-11",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 7,
				"x": 0.10636939088209563,
				"y": 0.8363765186546518,
				"title": "ECLI:NL:HR:2009:BI6323 Hoge Raad , 11-09-2009 / 07/12246",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI4209",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:646 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Seksuele intimidatie?, maatstaf, gezichtspunten; aansluiting bij art. 7:646 lid 8 BW. Procesrecht. Overlegging van processtukken uit andere procedure.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "5",
				"ecli": "ECLI:NL:HR:2009:BI4209",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-07-10",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 6,
				"x": 0.13557845805201973,
				"y": 0.9902489314533248,
				"title": "ECLI:NL:HR:2009:BI4209 Hoge Raad , 10-07-2009 / 07/13308",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BI1508",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wet op de rechterlijke organisatie 81"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid op voet van art. 7:658 BW voor psychische schade;  vervolg op HR 11 maart 2005, nr. C03/289, RvdW 2005, 37; geding na verwijzing (81 RO).",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "12",
				"ecli": "ECLI:NL:HR:2009:BI1508",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-06-05",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 4,
				"x": 0.16715299140474782,
				"y": 0.6359719926740764,
				"title": "ECLI:NL:HR:2009:BI1508 Hoge Raad , 05-06-2009 / C07/164HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BH1996",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw",
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor letselschade van werknemer na ongeval tijdens bedrijfsuitje (rollerskateles) wegens schending van een op eisen van goed werkgeverschap ex art. 7:611 BW gebaseerde zorg- en preventieplicht; geen toepasselijkheid van art. 7:658 BW.",
				"authorities": 0.0009448238034196425,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2009:BH1996",
				"pagerank": 0.00504592452096377,
				"betweenness_centrality": 0,
				"date": "2009-04-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.03125,
				"closeness_centrality": 0,
				"count_version": 7,
				"x": 0.2115476069804738,
				"y": 0.7275099697063458,
				"title": "ECLI:NL:HR:2009:BH1996 Hoge Raad , 17-04-2009 / 08/00635",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF0003",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wet op de rechterlijke organisatie 81"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen ongeval bij uitstappen van vrachtwagen na tanken op ernstig vervuild benzinestation; zorgplicht van werkgever ex art. 7:658 BW; gevaarzetting; aanvullende verzekeringsplicht op grond van art. 7:611, behoorlijke verzekering?",
				"authorities": 0,
				"hubs": 0.0002787024929694404,
				"community": "2",
				"ecli": "ECLI:NL:HR:2009:BF0003",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2009-02-20",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.029325513196480937,
				"count_version": 9,
				"x": 0.22694557822340955,
				"y": 0.12924588127570769,
				"title": "ECLI:NL:HR:2009:BF0003 Hoge Raad , 20-02-2009 / 07/11410",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2009:BF8875",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; beroepsziekte (rugklachten na rugbelastend werk)?; causaal verband, maatstaf; stelplicht en bewijslastverdeling, omkeringsregel?; passeren van een bewijsaanbod; beleidsvrijheid (appel)rechter  tot inwinnen van gevraagd deskundigenbericht.",
				"authorities": 0.09273823602123499,
				"hubs": 0.10280229395773727,
				"community": "0",
				"ecli": "ECLI:NL:HR:2009:BF8875",
				"pagerank": 0.005035010755897214,
				"betweenness_centrality": 0,
				"date": "2009-01-09",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.058823529411764705,
				"closeness_centrality": 0.027489481065918652,
				"count_version": 9,
				"x": 0.4230782350715523,
				"y": 0.8411360721221801,
				"title": "ECLI:NL:HR:2009:BF8875 Hoge Raad , 09-01-2009 / 07/11534",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 4,
				"year": 2009
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD7480",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen verkeersongeval tijdens gemotoriseerd vervoer tussen vestigingen van werkgever, “woon-werkverkeer”?; zorgplicht van werkgever ex art. 7:658 en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers (ongevalleninzittendenverzekering).",
				"authorities": 0,
				"hubs": 0.008613686829314389,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BD7480",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2008-12-19",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.041634408602150536,
				"count_version": 9,
				"x": 0.7534678384259095,
				"y": 0.5057249522769127,
				"title": "ECLI:NL:HR:2008:BD7480 Hoge Raad , 19-12-2008 / 07/10672",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 4,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BG7775",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; aan werknemer in uitoefening van werkzaamheden overkomen verkeersongeval tijdens vervoer met auto-ambulance op weg naar bedrijf werkgever, “woon-werkverkeer”?; zorgplicht van werkgever ex art. 7:658 en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers.",
				"authorities": 0,
				"hubs": 0.002717666182918857,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BG7775",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2008-12-19",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.04003308519437552,
				"count_version": 9,
				"x": 0.7403094765068521,
				"y": 0.6722851257052685,
				"title": "ECLI:NL:HR:2008:BG7775 Hoge Raad , 19-12-2008 / 07/10859",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BD3129",
				"out_degree_centrality": 0.03870967741935484,
				"degree_centrality": 0.05161290322580645,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw",
					"7:658 bw"
				],
				"in_degree": 2,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid; bij eenzijdig verkeersongeval geleden letselschade door fietsende werknemer (thuiszorger) tijdens uitoefening van haar werkzaamheden; zorgplicht van werkgever ex art. 7:658 BW en aanvullende verzekeringsplicht op grond van art. 7:611 BW; behoorlijke verzekering van aan verkeer op de openbare weg deelnemende werknemers.",
				"authorities": 0.0009665312056490926,
				"hubs": 0.008406351433425547,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BD3129",
				"pagerank": 0.00803131867234144,
				"betweenness_centrality": 0.0009216589861751152,
				"date": "2008-12-12",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.05405405405405406,
				"closeness_centrality": 0.043548387096774194,
				"count_version": 9,
				"x": 0.4346445326456442,
				"y": 0.7066996798577558,
				"title": "ECLI:NL:HR:2008:BD3129 Hoge Raad , 12-12-2008 / C07/121HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 6,
				"degree": 8,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BE7201",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 24"
				],
				"in_degree": 1,
				"abstract": "Procesrecht. Grenzen rechtsstrijd van partijen; afspraak ter comparitie dat onder overlegging van alle gedingstukken uit de andere procedure deze geacht kunnen worden te zijn herhaald en ingelast in de onderhavige procedure; niet voldoende om wat in die stukken aan stellingen en feiten is te vinden als aangevoerd in het onderhavige geding te beschouwen; de partij die zulke stellingen en feiten wil inroepen, dient dit op een zodanige wijze te doen dat dat voor de rechter en de wederpartij duidelijk is.",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "5",
				"ecli": "ECLI:NL:HR:2008:BE7201",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2008-10-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.02631578947368421,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.9946255903315541,
				"y": 0.11271022487214866,
				"title": "ECLI:NL:HR:2008:BE7201 Hoge Raad , 17-10-2008 / C07/037HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC8791",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:661 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Verhaal door werkgever op werknemers van verkeersboetes die aan de werkgever als kentekenhouder zijn opgelegd voor door werknemers tijdens de uitoefening van hun werkzaamheden begane verkeersovertredingen; uitleg art. 7:661 BW.",
				"authorities": 0,
				"hubs": 8.75865925256645e-72,
				"community": "16",
				"ecli": "ECLI:NL:HR:2008:BC8791",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2008-06-13",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 11,
				"x": 0.5299505229820243,
				"y": 0.28940529201564213,
				"title": "ECLI:NL:HR:2008:BC8791 Hoge Raad , 13-06-2008 / C06/232HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9344",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid ex art. 7:658 BW voor uitglijden werknemer over opstapje tussen als kantoorruimte gebruikte portacabins; onveilige werksituatie, causaal verband.",
				"authorities": 0.002130391829413503,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BC9344",
				"pagerank": 0.004976441117049863,
				"betweenness_centrality": 0,
				"date": "2008-06-06",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.025,
				"closeness_centrality": 0,
				"count_version": 8,
				"x": 0.5898222601501113,
				"y": 0.07325648439471322,
				"title": "ECLI:NL:HR:2008:BC9344 Hoge Raad , 06-06-2008 / C07/088HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC7683",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wet op de rechterlijke organisatie 81"
				],
				"in_degree": 1,
				"abstract": "Arbeidrecht. Aansprakelijkheid werkgever ex art. 7:658 lid 2 BW; gezondheidsschade als gevolg van blootstelling aan organische oplosmiddelen; geen bewijs causaal verband met  uitoefening van de werkzaamheden (81 RO).",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "15",
				"ecli": "ECLI:NL:HR:2008:BC7683",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2008-05-16",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.024390243902439025,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.10767504260378835,
				"y": 0.565130900141761,
				"title": "ECLI:NL:HR:2008:BC7683 Hoge Raad , 16-05-2008 / C06/343HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC9225",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid ex art. 7:658 BW voor uitglijden werknemer op natte vloer; terbeschikkingstelling veiligheidsschoenen niet afdoende wegens mogelijkheid van neerleggen rubber matten.",
				"authorities": 0.000895900616080289,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BC9225",
				"pagerank": 0.004768572089893133,
				"betweenness_centrality": 0,
				"date": "2008-04-11",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.023809523809523808,
				"closeness_centrality": 0,
				"count_version": 9,
				"x": 0.6325909715326636,
				"y": 0.42456069116897965,
				"title": "ECLI:NL:HR:2008:BC9225 Hoge Raad , 11-04-2008 / C06/293HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BC6699",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:629 bw"
				],
				"in_degree": 0,
				"abstract": "Arbeidsrecht. Contractuele beperking van aanvulling op wettelijke minimumuitkering bij  arbeidsongeschiktheid, in verband met buiten de werksfeer liggende gedragingen of activiteiten van de werknemer, zonder dat sprake is van opzet werknemer is niet in strijd met art. 7:629 BW; uitleg CAO.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "28",
				"ecli": "ECLI:NL:HR:2008:BC6699",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2008-03-14",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 10,
				"x": 0.3988749210945245,
				"y": 0.3547479198296659,
				"title": "ECLI:NL:HR:2008:BC6699 Hoge Raad , 14-03-2008 / C06/278HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB7423",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6:171 bw",
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Arbeidsrecht. Afgewezen vordering werknemer tegen werkgever tot vergoeding van letselschade na ongeval met dichtgewaaide laaddeur van vrachtauto van derde; werkgeversaansprakelijkheid ex art. 7:658 BW, maatstaf; aansprakelijkheid voor niet-ondergeschikten ex art. 6:171 BW (81 RO).",
				"authorities": 0.00007667549632119902,
				"hubs": 0.00003232123175810883,
				"community": "4",
				"ecli": "ECLI:NL:HR:2008:BB7423",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0.00008378718056137411,
				"date": "2008-02-08",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.022727272727272728,
				"closeness_centrality": 0.008602150537634409,
				"count_version": 8,
				"x": 0.31889041721052647,
				"y": 0.04827544547748752,
				"title": "ECLI:NL:HR:2008:BB7423 Hoge Raad , 08-02-2008 / C06/202HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 2,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB6175",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw"
				],
				"in_degree": 4,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor de door werknemer bij een verkeersongeval met eigen auto geleden letselschade in de uitoefening van zijn werkzaamheden; zorgplicht werkgever ex art. 7:658 en op grond van goed werkgeverschap in art. 7:611 BW; behoorlijke verzekering van aan gemotoriseerd verkeer deelnemende werknemer; bewuste roekeloosheid van werknemer, maatstaf.",
				"authorities": 0.004712389086193691,
				"hubs": 0.015552022386814343,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BB6175",
				"pagerank": 0.008422886205360297,
				"betweenness_centrality": 0.0019689987431922916,
				"date": "2008-02-01",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.08888888888888889,
				"closeness_centrality": 0.032384566729917776,
				"count_version": 9,
				"x": 0.22605619341174976,
				"y": 0.1162044363688457,
				"title": "ECLI:NL:HR:2008:BB6175 Hoge Raad , 01-02-2008 / C06/044HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 5,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2008:BB4767",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.05161290322580645,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:611 bw"
				],
				"in_degree": 4,
				"abstract": "Arbeidsrecht. Werkgeversaansprakelijkheid voor de door werknemer als taxichauffeur (afroepkracht) in de uitoefening van zijn werkzaamheden bij een verkeersongeval geleden letselschade; zorgplicht werkgever ex art. 7:658 en op grond van goed werkgeverschap als bedoeld in art. 7:611 BW; uitwerking van HR 12 januari 2001, nr. C99/125, NJ 2001, 253 en HR 9 augustus 2002, nr. C00/234, NJ 2004, 235; behoorlijke verzekering van aan gemotoriseerd verkeer deelnemende werknemer.",
				"authorities": 0.004712389086193691,
				"hubs": 0.023321465598686603,
				"community": "2",
				"ecli": "ECLI:NL:HR:2008:BB4767",
				"pagerank": 0.008422886205360297,
				"betweenness_centrality": 0.0026183493925429407,
				"date": "2008-02-01",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.08695652173913043,
				"closeness_centrality": 0.04608294930875576,
				"count_version": 10,
				"x": 0.11382893612354317,
				"y": 0.000503944784689736,
				"title": "ECLI:NL:HR:2008:BB4767 Hoge Raad , 01-02-2008 / C06/211HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 8,
				"year": 2008
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB6178",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Werkgeversaansprakelijkheid. Geschil over schadevergoeding na verkeersongeval werknemer; zorgplicht werkgever; vervoer op één lijn te stellen met vervoer krachtens de verplichtingen uit arbeidsovereenkomst?; ‘in de uitoefening van de werkzaamheden’ in zin van art. 7:658 lid 2 BW, ruime wetsuitleg.",
				"authorities": 0.002130391829413503,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2007:BB6178",
				"pagerank": 0.004976441117049863,
				"betweenness_centrality": 0,
				"date": "2007-11-30",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.02127659574468085,
				"closeness_centrality": 0,
				"count_version": 8,
				"x": 0.7291661577310622,
				"y": 0.5658758019989,
				"title": "ECLI:NL:HR:2007:BB6178 Hoge Raad , 30-11-2007 / C06/171HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB7191",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw",
					"Wet op de rechterlijke organisatie 81"
				],
				"in_degree": 0,
				"abstract": "Internationaal privaatrecht; vervolg op HR 12 november 2004, nr. C03/149, NJ 2005, 552. Arbeidsongeval tijdens transport van boortoren; inlenersaansprakelijkheid; toepasselijkheid art. 7:658 lid 4 BW, overgangsrecht; kan de inlener als materiële werkgever aansprakelijk worden gesteld voor de fouten van derden bij wie werknemer was tewerkgesteld? (81 RO).",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "14",
				"ecli": "ECLI:NL:HR:2007:BB7191",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-11-23",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 2,
				"x": 0.002407551909779926,
				"y": 0.9335688789160488,
				"title": "ECLI:NL:HR:2007:BB7191 Hoge Raad , 23-11-2007 / C06/186HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9173",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"12 sv"
				],
				"in_degree": 1,
				"abstract": "Cassatie in belang der wet. Euratom. Functionele immuniteit. Het hof heeft n.a.v. een beklagprocedure ex art. 12 Sv de OvJ bevolen de vervolging van Euratom voort te zetten, betrekking hebbende op overtredingen van een of meer van de vergunningsvoorwaarden en van andere milieudelicten. Het hof heeft in zijn beschikking een te nauwe maatstaf aangelegd. Het gaat erom of de desbetreffende gedragingen onmiddellijk verband houden met de vervulling van de aan Euratom opgedragen taken en niet, zoals het hof klaarblijkelijk als maatstaf heeft genomen, of Euratom haar taken ook kan uitoefenen zonder strafbare feiten te begaan. HR vernietigt in het belang der wet de bestreden beschikking.",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "1",
				"ecli": "ECLI:NL:HR:2007:BA9173",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2007-11-13",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.02040816326530612,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.6439732641208743,
				"y": 0.9866235689322017,
				"title": "ECLI:NL:HR:2007:BA9173 Hoge Raad , 13-11-2007 / 01984/07 CW",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#strafrecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BB5172",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "Aansprakelijkheidsrecht. Afgewezen schadevordering van automobilist na aanrijding met tractor; causaal verband tussen ongeval en verlies arbeidsvermogen?; volgen door rechter van (voorlopig) deskundigenbericht, bezwaren partijen, stelplicht; smartengeld, schadebegroting, rechtsstrijd van partijen, taak appelrechter.",
				"authorities": 0.07610823628465141,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:2007:BB5172",
				"pagerank": 0.006666384047121367,
				"betweenness_centrality": 0,
				"date": "2007-10-19",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.06,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.3070353260403881,
				"y": 0.04238892303252473,
				"title": "ECLI:NL:HR:2007:BB5172 Hoge Raad , 19-10-2007 / C06/086HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 3,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA9705",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:941 bw"
				],
				"in_degree": 0,
				"abstract": "Verzekeringsrecht. Verwezenlijking van verzekerd risico, meldingsplicht verzekerde, verval recht op uitkering; art. 7:941 lid 4 BW is codificatie van naar oud recht gegroeide rechtsovertuiging; omvang stelplicht verzekeraar en verzekerde.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "22",
				"ecli": "ECLI:NL:HR:2007:BA9705",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-10-05",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 5,
				"x": 0.6036260772083,
				"y": 0.04801440815843894,
				"title": "ECLI:NL:HR:2007:BA9705 Hoge Raad , 05-10-2007 / C06/033HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA7217",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Verzekeringsrecht; vervolg op HR 4 oktober 2002, nr. C01/326, NJ 2002, 557. Vordering van uitzendbureau tegen verzekeraar tot verlenen dekking voor schadevergoeding aan zijn werknemer uit werkgeversaansprakelijkheid; uitleg van (uitsluitingsclausule in) polisvoorwaarden, maatstaf; ‘spiegelbeelddekking’ van AVB- en WAM-polissen; grenzen rechtsstrijd in hoger beroep.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "4",
				"ecli": "ECLI:NL:HR:2007:BA7217",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-07-13",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.00967741935483871,
				"count_version": 6,
				"x": 0.7613404156280678,
				"y": 0.05202984237778607,
				"title": "ECLI:NL:HR:2007:BA7217 Hoge Raad , 13-07-2007 / C06/089HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:BA3017",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "Werkgeversaansprakelijkheid. Schadevordering van werkneemster na val van podium ondanks waarschuwing en aanwezigheid van trapje; omvang van door werkgever jegens een verstandelijk gehandicapte werknemer te betrachten zorgplicht, extra inspanning tot geven van aanwijzingen, instructies of waarschuwingen?; stelplicht- en bewijslast; bevrijdend verweer van de werkgever, eisen te stellen aan motivering van de betwisting door de werknemer.",
				"authorities": 0.0009725761124014882,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:2007:BA3017",
				"pagerank": 0.006399945381117286,
				"betweenness_centrality": 0,
				"date": "2007-05-25",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.03773584905660377,
				"closeness_centrality": 0,
				"count_version": 8,
				"x": 0.7241684212922317,
				"y": 0.04821037988667709,
				"title": "ECLI:NL:HR:2007:BA3017 Hoge Raad , 25-05-2007 / C06/128HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6717",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Arbeidsomstandighedenbesluit 5.2"
				],
				"in_degree": 0,
				"abstract": "Werkgeversaansprakelijkheid. Schadevordering werknemer na ongeval bij het optillen van zware oven. Omvang van door werkgever jegens zijn werknemer te betrachten zorgplicht; regels van algemene bekendheid; stelplicht, aan gemotiveerde betwisting van de stellingen van werknemer te stellen eisen; uitwerking van HR 17 november 2000, nr. C98/273, NJ 2001, 596.",
				"authorities": 0,
				"hubs": 0.0757936806270237,
				"community": "0",
				"ecli": "ECLI:NL:HR:2007:AZ6717",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-04-27",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03303225806451613,
				"count_version": 8,
				"x": 0.9095503461193879,
				"y": 0.6276912518123491,
				"title": "ECLI:NL:HR:2007:AZ6717 Hoge Raad , 27-04-2007 / C05/192HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ7863",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Aanrijding voetganger door auto op donkere weg. Eis van bewustheid van het gevaar bij het slachtoffer voor aan opzet grenzende roekeloosheid als bedoeld in de 50%-regel. Stelplicht en bewijslast omvat ook de bewustheid van het gevaar bij het slachtoffer. Aan het bewijs van deze bewustheid door aansprakelijk gestelde partij te stellen eisen.",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "26",
				"ecli": "ECLI:NL:HR:2007:AZ7863",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-03-30",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 7,
				"x": 0.5248097379590805,
				"y": 0.4743854845592703,
				"title": "ECLI:NL:HR:2007:AZ7863 Hoge Raad , 30-03-2007 / C05/226HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2007:AZ6526",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Arbeidsongeval. Werkgeversaansprakelijkheid voor letselschade werknemer als gevolg van zijn val van een dak bij sloopwerkzaamheden (verwijdering van asbestplaten); zorgplicht werkgever, uitdrukkelijk opdracht door werkgever tot treffen en naleven van valbeschermingsmaatregelen; waardering getuigenbewijs waaronder verklaring van een jeugdige getuige.",
				"authorities": 0,
				"hubs": 0.000006721648365199486,
				"community": "18",
				"ecli": "ECLI:NL:HR:2007:AZ6526",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2007-02-09",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 8,
				"x": 0.1490714922671713,
				"y": 0.2512371710218888,
				"title": "ECLI:NL:HR:2007:AZ6526 Hoge Raad , 09-02-2007 / C05/337HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2007
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2006:AY0534",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.6236909940434693e-38,
				"hubs": 0,
				"community": "20",
				"ecli": "ECLI:NL:XX:2006:AY0534",
				"pagerank": 0.004491219658822496,
				"betweenness_centrality": 0,
				"date": "2006-07-04",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.017543859649122806,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.4303455092545325,
				"y": 0.24124654923585365,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AW6166",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 4,
				"abstract": "Werkgeversaansprakelijkheid. Geschil tussen een werknemer en zijn voormalige werkgever over aansprakelijkheid krachtens art. 7A:1638x (oud) BW voor een door de werknemer beweerdelijk tijdens de uitoefening van zijn werkzaamheden opgelopen aandoening aan de luchtwegen en aan het zenuwstelsel (organisch psychosyndroom); overgangsrecht NBW, onmiddellijke werking van art. 7:658 BW; oorzakelijk verband tussen blootstelling aan voor gezondheid gevaarlijke stoffen en lichamelijke klachten van de werknemer, stelplicht en bewijslastverdeling, regel als bedoeld in HR 17 november 2000, nr. C98/273, NJ 2001, 596 (Unilever/Dikmans) in casu niet toepasselijk.",
				"authorities": 0.16152901504573125,
				"hubs": 0.05622486436516606,
				"community": "0",
				"ecli": "ECLI:NL:HR:2006:AW6166",
				"pagerank": 0.007827412820573863,
				"betweenness_centrality": 0,
				"date": "2006-06-23",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.06896551724137931,
				"closeness_centrality": 0.024229390681003583,
				"count_version": 7,
				"x": 0.7220022474021931,
				"y": 0.483995334059821,
				"title": "ECLI:NL:HR:2006:AW6166 Hoge Raad , 23-06-2006 / C05/149HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 5,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6093",
				"out_degree_centrality": 0.01935483870967742,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 0,
				"abstract": "Geschil tussen een asbestverwerkend bedrijf dat van 1961 tot 1975 werkgever was van een asbestmenger die in 1984 aan longkanker zonder voorafgaande asbestose is overleden, en diens weduwe over aansprakelijkheid op de voet van art. 7:658 BW; was zijn longkanker ook zonder asbestexpositie ontstaan?; zorgplicht werkgever tot het treffen van de vereiste veiligheidsmaatregelen, ook bij aanzienlijke kansverhoging verwezenlijking van onbekende gevaren door nalatigheid werkgever.",
				"authorities": 0,
				"hubs": 5.509931302562919e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:2006:AU6093",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2006-03-31",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03629032258064516,
				"count_version": 3,
				"x": 0.31505645892084755,
				"y": 0.7722596669717336,
				"title": "ECLI:NL:HR:2006:AU6093 Hoge Raad , 31-03-2006 / C04/304HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 3,
				"degree": 3,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6092",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 3,
				"abstract": "Geschil tussen een asbestverwerkend bedrijf dat van 1964 tot 1979 werkgever was van een fabrieksarbeider die minstens 28 jaar heeft gerookt en in 2000 aan longkanker zonder voorafgaande asbestose is overleden, en zijn erfgenamen over werkgeversaansprakelijkheid op de voet van art. 7:658 BW; longkanker behalve door blootstelling aan asbeststof in de uitoefening van werkzaamheden ook veroorzaakt door langjarig rookgedrag?; zorgplicht werkgever tot het treffen van de vereiste veiligheidsmaatregelen, aanzienlijke kansverhoging verwezenlijking van nog onbekende gevaren door nalatigheid werkgever; aanvaarding door de HR van proportionele aansprakelijkheid; causaal verband normschending en geleden schade, eigen schuld; devolutieve werking van het appel, grievenstelsel.",
				"authorities": 0.10004948850059989,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:2006:AU6092",
				"pagerank": 0.008297757338345521,
				"betweenness_centrality": 0,
				"date": "2006-03-31",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.05,
				"closeness_centrality": 0,
				"count_version": 7,
				"x": 0.8361185320565112,
				"y": 0.06107769534341445,
				"title": "ECLI:NL:HR:2006:AU6092 Hoge Raad , 31-03-2006 / C04/303HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 3,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU6927",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 1,
				"abstract": "Asbestzaak. Geschil tussen werkgever en de erven van een oud-werknemer over werkgeversaansprakelijkheid op grond van art. 7:658 BW wegens blootstelling van deze werknemer aan asbeststof gedurende zijn dienstverband in de periode 1965-1967 in de uitoefening van werkzaamheden als monteur bij verwarmingsinstallatiebedrijf; leidt onbekendheid van werkgever met het gevaar van het ontstaan van mesothelioom tot ontheffing van zijn aansprakelijkheid als de omstandigheden geen gevaar meebrachten voor asbestose?, verhoogde zorgvuldigheidsnorm, veiligheidsmaatregelen die naar de destijds bestaande kennis en inzichten van de werkgever konden worden verwacht; verlichting van bewijslast werkgever.",
				"authorities": 1.9083244303450155e-13,
				"hubs": 6.609274964965129e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:2006:AU6927",
				"pagerank": 0.00492625253648227,
				"betweenness_centrality": 0.00041893590280687055,
				"date": "2006-02-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.01639344262295082,
				"closeness_centrality": 0.04360400444938821,
				"count_version": 7,
				"x": 0.7455611388907855,
				"y": 0.16953010565989113,
				"title": "ECLI:NL:HR:2006:AU6927 Hoge Raad , 17-02-2006 / C04/199HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 5,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2006:AU9717",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"6:97 bw"
				],
				"in_degree": 1,
				"abstract": "Internationaal verzekeringsgeschil n.a.v. een schikking binnen de filmindustrie; dekking polis, uitleg naar Nederlands recht van op de Londense beurs gesloten verzekering, Haviltex-maatstaf, ter beurze bestaande opvattingen; beroep op vervalbeding in een verzekeringsovereenkomst, derogerende werking van redelijkheid en billijkheid, motiveringsplicht; begroting schadeomvang op de voet van art. 6:97 BW, motiveringseisen.",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "22",
				"ecli": "ECLI:NL:HR:2006:AU9717",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2006-02-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.016129032258064516,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.26065443790735154,
				"y": 0.21194816418601792,
				"title": "ECLI:NL:HR:2006:AU9717 Hoge Raad , 17-02-2006 / C04/322HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2006
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AT8782",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "Kort geding asbestzaak, aansprakelijkheid van leverancier van asbestcementplaten voor ziekte mesothelioom die door blootstelling in 1971 aan asbest is veroorzaakt; tekortschieten van de leverancier in plicht het publiek te waarschuwen voor de toen reeds bekende gezondheidsrisico’s die aan verwerking van asbest zijn verbonden, onrechtmatige nalatigheid?, maatstaven; bevrijdende verjaring, beroep op objectieve verjaringstermijn (30 jaren), derogerende werking van de redelijkheid en billijkheid, gezichtspunten.",
				"authorities": 0,
				"hubs": 1.6496153691232217e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:2005:AT8782",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2005-11-25",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03831867057673509,
				"count_version": 5,
				"x": 0.4157469657347368,
				"y": 0.7929456933659428,
				"title": "ECLI:NL:HR:2005:AT8782 Hoge Raad , 25-11-2005 / C04/182HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2005
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU3313",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:658 bw"
				],
				"in_degree": 2,
				"abstract": "Arbeidsongeval met lichamelijk letsel bij de bediening van een gevaarlijke (inpak)machine ondanks de door de werkgever getroffen (veiligheids)maatregelen, werkgeversaansprakelijkheid, strekking van art. 7:658 BW, waarschuwingsplicht van werkgever, effectieve(re) maatregelen?, voorzienbaarheid van het te duchten gevaar.",
				"authorities": 0.0678640200637628,
				"hubs": 8.75865925256645e-72,
				"community": "0",
				"ecli": "ECLI:NL:HR:2005:AU3313",
				"pagerank": 0.006013834730631706,
				"betweenness_centrality": 0.00016757436112274822,
				"date": "2005-11-11",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.03125,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 8,
				"x": 0.9839033257817017,
				"y": 0.9959353092513058,
				"title": "ECLI:NL:HR:2005:AU3313 Hoge Raad , 11-11-2005 / C04/253HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 4,
				"year": 2005
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AU2235",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"7:661 bw",
					"7:658 bw"
				],
				"in_degree": 0,
				"abstract": "Aansprakelijkheid werknemer voor schade aan werkgever, verkeersongeval van taxichauffeur tijdens de uitoefening van werkzaamheden, negeren verkeersbord (inrijverbod) en wegafzetting, opzet of bewuste roekeloosheid in de zin van art. 7:661 lid 1 BW, gelijke uitleg van het begrip “bewuste roekeloosheid” als in art. 7:658 lid 2 BW, ervaringsfeit, bewijslastverdeling, omkeringsregel van toepassing?",
				"authorities": 0,
				"hubs": 4.8936151077444983e-32,
				"community": "4",
				"ecli": "ECLI:NL:HR:2005:AU2235",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2005-10-14",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.008602150537634409,
				"count_version": 7,
				"x": 0.2441778866851534,
				"y": 0.13105337253819904,
				"title": "ECLI:NL:HR:2005:AU2235 Hoge Raad , 14-10-2005 / C04/200HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2005
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2005:AR6657",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 5,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "11 maart 2005 Eerste Kamer Nr. C03/289HR JMH Hoge Raad der Nederlanden Arrest in de zaak van: ABN AMRO BANK N.V., gevestigd te Amsterdam, EISERES tot cassatie, incidenteel verweerster, advocaat: mr. E. Grabandt, t e g e n [Verweerder], wonende te [woonplaats], VERWEERDER in cassatie, incidenteel eiser, advocaten: mrs. E. van Staden ten Brink en A.H. Vermeulen. 1. Het geding in feitelijke instanties...",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "12",
				"ecli": "ECLI:NL:HR:2005:AR6657",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2005-03-11",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.015151515151515152,
				"closeness_centrality": 0,
				"count_version": 9,
				"x": 0.958049912570156,
				"y": 0.5395924042943255,
				"title": "ECLI:NL:HR:2005:AR6657 Hoge Raad , 11-03-2005 / C03/289HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2005
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AR3290",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "17 december 2004 Eerste Kamer Nr. C03/211HR RM/AT Hoge Raad der Nederlanden Arrest in de zaak van: HERTEL B.V., gevestigd te Amsterdam, EISERES tot cassatie, advocaat: mr. R.S. Meijer, t e g e n 1. [Verweerder 1], wonende te [woonplaats], 2. [Verweerder 2], wonende te [woonplaats], ten dezen handelend zowel voor zichzelf als in hun hoedanigheid van erfgenamen van [betrokkene 1], VERWEERDERS in cassatie, advocaat: mr. M.J. Schenck. 1. Het geding in feitelijke instanties...",
				"authorities": 2.860406296671996e-13,
				"hubs": 6.197545859961566e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:2004:AR3290",
				"pagerank": 0.006516857305061262,
				"betweenness_centrality": 0.0009216589861751152,
				"date": "2004-12-17",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.029850746268656716,
				"closeness_centrality": 0.03795066413662239,
				"count_version": 7,
				"x": 0.8128849901003169,
				"y": 0.7472563086318368,
				"title": "ECLI:NL:HR:2004:AR3290 Hoge Raad , 17-12-2004 / C03/211HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 6,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AP0965",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "12 november 2004 Eerste Kamer Nr. C03/149HR JMH Hoge Raad der Nederlanden Arrest in de zaak van: [Eiser], wonende te [woonplaats], EISER tot cassatie, advocaat: mr. E. Grabandt, t e g e n KCA DEUTAG NEDERLAND B.V., voorheen genaamd Deutag Nederland B.V., daarvoor genaamd Deutag Friesland Drilling B.V., gevestigd te Assen, VERWEERSTER in cassatie, advocaat: mr. R.A.A. Duk. 1. Het geding in feitelijke instanties...",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "14",
				"ecli": "ECLI:NL:HR:2004:AP0965",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2004-11-12",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.014705882352941176,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.028200259700374986,
				"y": 0.15300400630636934,
				"title": "ECLI:NL:HR:2004:AP0965 Hoge Raad , 12-11-2004 / C03/149HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:2004:AR5022",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.6236909940434693e-38,
				"hubs": 0,
				"community": "20",
				"ecli": "ECLI:NL:XX:2004:AR5022",
				"pagerank": 0.004491219658822496,
				"betweenness_centrality": 0,
				"date": "2004-10-05",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.014492753623188406,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.7594570796119381,
				"y": 0.7984704705184985,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO9053",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wet op de rechterlijke organisatie 81",
					"Wet op de rechterlijke organisatie 4"
				],
				"in_degree": 0,
				"abstract": "10 september 2004 Eerste Kamer Nr. C03/097HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], EISERES tot cassatie, incidenteel verweerster in cassatie, advocaat: mr. H.J.W. Alt, t e g e n 1. EURONEXT AMSTERDAM N.V., rechts-opvolgster van Amsterdam Exchanges N.V., 2. AMSTERDAM EXCHANGES N.V., beide gevestigd te Amsterdam, VERWEERSTERS in cassatie, incidenteel eiseressen tot cassatie, advocaat: mr. J.B.M.M. Wuisman.  1. Het geding in feitelijke instanties...",
				"authorities": 0,
				"hubs": 1.6941710905014642e-46,
				"community": "17",
				"ecli": "ECLI:NL:HR:2004:AO9053",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2004-09-10",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.025806451612903226,
				"count_version": 3,
				"x": 0.5235372325888104,
				"y": 0.1262658749295873,
				"title": "ECLI:NL:HR:2004:AO9053 Hoge Raad , 10-09-2004 / C03/097HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 4,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO8171",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "9 juli 2004 Eerste Kamer Nr. C03/150HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiser], wonende te [woonplaats], EISER tot cassatie, advocaat: mr. E. Grabandt, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. M.H. van der Woude. 1. Het geding in feitelijke instanties...",
				"authorities": 0,
				"hubs": 0.0007267529616578021,
				"community": "18",
				"ecli": "ECLI:NL:HR:2004:AO8171",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2004-07-09",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.014516129032258065,
				"count_version": 5,
				"x": 0.7865782664149304,
				"y": 0.743968776747423,
				"title": "ECLI:NL:HR:2004:AO8171 Hoge Raad , 09-07-2004 / C03/150HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO7817",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 166",
					"Wetboek van Burgerlijke Rechtsvordering 150",
					"Wetboek van Burgerlijke Rechtsvordering 353",
					"Wetboek van Burgerlijke Rechtsvordering"
				],
				"in_degree": 1,
				"abstract": "9 juli 2004 Eerste Kamer Nr. C03/079HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: OZ EXPORT PLANTEN B.V., gevestigd te Aalsmeer, EISERES tot cassatie, advocaat: mr. E. Grabandt, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. R.F. Thunnissen. 1. Het geding in feitelijke instanties...",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "11",
				"ecli": "ECLI:NL:HR:2004:AO7817",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2004-07-09",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.013888888888888888,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.7726340879956229,
				"y": 0.40826893109772855,
				"title": "ECLI:NL:HR:2004:AO7817 Hoge Raad , 09-07-2004 / C03/079HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4596",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Burgerlijk Wetboek Boek 7",
					"Burgerlijk Wetboek Boek 7 658"
				],
				"in_degree": 0,
				"abstract": "4 juni 2004 Eerste Kamer Nr. C03/034HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: 1. [Eiseres 1], wonende te [woonplaats], Spanje, 2. [Eiseres 2], wonende te [woonplaats], EISERESSEN tot cassatie, voorwaardelijk incidenteel verweersters, advocaat: mr. M.J. Schenck, t e g e n GEMEX B.V., gevestigd te 's-Gravenhage, VERWEERSTER in cassatie, voorwaardelijk incidenteel eiseres, advocaat: mr. R.S. Meijer. 1. Het geding in feitelijke instanties...",
				"authorities": 0,
				"hubs": 4.959659595841907e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:2004:AO4596",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2004-06-04",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.014746543778801843,
				"count_version": 2,
				"x": 0.2800867043553602,
				"y": 0.25417484592330286,
				"title": "ECLI:NL:HR:2004:AO4596 Hoge Raad , 04-06-2004 / C03/034HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AO4224",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "28 mei 2004 Eerste Kamer Nr. R03/026HR JMH/IS Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], Zwitserland, EISERES tot cassatie, advocaat: mr. M.B.C. Kloppenburg, t e g e n PRINCESS JULIANA INTERNATIONAL AIRPORT EXPLOITATIEMAATSCHAPPIJ N.V., gevestigd op Sint Maarten, Nederlandse Antillen, VERWEERSTER in cassatie, advocaat: mr. M.H. van der Woude. 1. Het geding in feitelijke instanties...",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:2004:AO4224",
				"pagerank": 0.006394551737125777,
				"betweenness_centrality": 0,
				"date": "2004-05-28",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.013513513513513514,
				"closeness_centrality": 0,
				"count_version": 7,
				"x": 0.16083995918257832,
				"y": 0.5254003535546338,
				"title": "ECLI:NL:HR:2004:AO4224 Hoge Raad , 28-05-2004 / R03/026HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN8601",
				"out_degree_centrality": 0.01935483870967742,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "\n         30 januari 2004 Eerste Kamer Nr. C02/204HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: [eiseres], gevestigd te [vestigingsplaats], EISERES tot cassatie, advocaat: mr. M.H. van der Woude, t e g e n [verweerder], wonende te [woonplaats], VERWEERDER in cassatie, niet verschenen. 1. Het geding in feitelijke instantie...",
				"authorities": 0,
				"hubs": 0.0000488602462016726,
				"community": "4",
				"ecli": "ECLI:NL:HR:2004:AN8601",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2004-01-30",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03634408602150538,
				"count_version": 4,
				"x": 0.1545284516917571,
				"y": 0.9113221343575445,
				"title": "ECLI:NL:HR:2004:AN8601 Hoge Raad , 30-01-2004 / C02/204HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 3,
				"degree": 3,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2004:AN7324",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "9 januari 2004 Eerste Kamer Nr. C02/199HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: MUNTENDAMSCHE INVESTERINGS MAATSCHAPPIJ B.V., gevestigd te 's-Gravenhage, EISERES tot cassatie, advocaat: mr. R.S. Meijer, t e g e n [Verweerder], wonende te [woonplaats], VERWEERDER in cassatie, advocaat: mr. D.G. Lasschuit. 1. Het geding in feitelijke instanties...",
				"authorities": 1.4688325974695944e-46,
				"hubs": 0,
				"community": "17",
				"ecli": "ECLI:NL:HR:2004:AN7324",
				"pagerank": 0.004654356987944911,
				"betweenness_centrality": 0,
				"date": "2004-01-09",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.013157894736842105,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.3114768551202747,
				"y": 0.18499657623192511,
				"title": "ECLI:NL:HR:2004:AN7324 Hoge Raad , 09-01-2004 / C02/199HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2004
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AN8478",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 194"
				],
				"in_degree": 3,
				"abstract": "\n         5 december 2003 Eerste Kamer Nr. C02/154HR JMH/AT Hoge Raad der Nederlanden Arrest in de zaak van: DE STICHTING NIEUW VREDENBURGH, gevestigd te Amsterdam, EISERES tot cassatie, advocaat: mr. M.J. Schenck, t e g e n NIEUWE HOLLANDSCHE LLOYD SCHADEVERZEKERING MAATSCHAPPIJ N.V., gevestigd te Woerden, VERWEERSTER in cassatie, advocaat: mr. J. van Duijvendijk-Brand. 1. Het geding in feitelijke instanties...",
				"authorities": 0.07610823628465141,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:2003:AN8478",
				"pagerank": 0.006666384047121367,
				"betweenness_centrality": 0,
				"date": "2003-12-05",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.03896103896103896,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.8956221144219642,
				"y": 0.10352406340006681,
				"title": "ECLI:NL:HR:2003:AN8478 Hoge Raad , 05-12-2003 / C02/154HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 3,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AL8168",
				"out_degree_centrality": 0.03870967741935484,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "\n         31 oktober 2003 Eerste Kamer Nr. C02/234HR AT Hoge Raad der Nederlanden Arrest in de zaak van: 1. [Eiseres 1], 2. [Eiser 2], in hun hoedanigheid van ouders en wettelijk vertegenwoordigers van [betrokkene 1], beiden wonende te [woonplaats], EISERS tot cassatie, advocaat: mr. J. van Duijvendijk-Brand, t e g e n 1. [Verweerder 1], wonende te [woonplaats], 2. de rechtspersoonlijkheid bezittende VERENIGING VOOR CHRISTELIJK WETENSCHAPPELIJK ONDERWIJS, EXPLOITERENDE HET ACADEMISCH ZIEKENHUIS DER VRIJE UNIVERSITEIT \"AZVU\", gevestigd te Amsterdam, VERWEERDERS in cassatie,  advocaat: mr. E. van Staden ten Brink. 1. Het geding in feitelijke instanties...",
				"authorities": 0,
				"hubs": 5.963039245781266e-29,
				"community": "6",
				"ecli": "ECLI:NL:HR:2003:AL8168",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2003-10-31",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.03951612903225806,
				"count_version": 5,
				"x": 0.8668596830871635,
				"y": 0.42227972606206543,
				"title": "ECLI:NL:HR:2003:AL8168 Hoge Raad , 31-10-2003 / C02/234HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 6,
				"degree": 6,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF8254",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.04516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "\n         12 september 2003 Eerste Kamer Nr. C01/264HR RM/AT Hoge Raad der Nederlanden Arrest in de zaak van: [Eiseres], wonende te [woonplaats], EISERES tot cassatie, advocaat: aanvankelijk mr. M.E.M.G. Peletier, thans mr. A.G. Castermans, t e g e n [Verweerster], gevestigd te [vestigingsplaats], VERWEERSTER in cassatie, advocaat: mr. A.J. Swelheim. 1. Het geding in feitelijke instanties",
				"authorities": 0.053933909193476584,
				"hubs": 0.00008525950579802631,
				"community": "18",
				"ecli": "ECLI:NL:HR:2003:AF8254",
				"pagerank": 0.013440277432296619,
				"betweenness_centrality": 0.005320485965647256,
				"date": "2003-09-12",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.0379746835443038,
				"closeness_centrality": 0.04147465437788018,
				"count_version": 5,
				"x": 0.7036085266803882,
				"y": 0.942742634168722,
				"title": "ECLI:NL:HR:2003:AF8254 Hoge Raad , 12-09-2003 / C01/264HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 7,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF5891",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "13",
				"ecli": "ECLI:NL:HR:2003:AF5891",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2003-06-06",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 3,
				"x": 0.043723474676954366,
				"y": 0.0811432917493854,
				"title": "ECLI:NL:HR:2003:AF5891 Hoge Raad , 06-06-2003 / C02/062HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF7000",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 0.000023310458507731642,
				"hubs": 0,
				"community": "18",
				"ecli": "ECLI:NL:HR:2003:AF7000",
				"pagerank": 0.009957610980482973,
				"betweenness_centrality": 0,
				"date": "2003-05-16",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.024691358024691357,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.24041366098627248,
				"y": 0.7920497829260212,
				"title": "ECLI:NL:HR:2003:AF7000 Hoge Raad , 16-05-2003 / C01/156HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF3422",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "28",
				"ecli": "ECLI:NL:HR:2003:AF3422",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2003-04-11",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.012195121951219513,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.26935561758552684,
				"y": 0.6243906961842657,
				"title": "ECLI:NL:HR:2003:AF3422 Hoge Raad , 11-04-2003 / C01/248HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2003:AF0694",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 3.9270186849238617e-29,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:2003:AF0694",
				"pagerank": 0.006013834730631705,
				"betweenness_centrality": 0,
				"date": "2003-01-24",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.024096385542168676,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.7588493604793688,
				"y": 0.6111273025713577,
				"title": "ECLI:NL:HR:2003:AF0694 Hoge Raad , 24-01-2003 / C02/011HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2003
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE9242",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 12a"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.4688325974695944e-46,
				"hubs": 0,
				"community": "17",
				"ecli": "ECLI:NL:HR:2002:AE9242",
				"pagerank": 0.004654356987944911,
				"betweenness_centrality": 0,
				"date": "2002-12-06",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.011904761904761904,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.08621148957109903,
				"y": 0.7066429787465804,
				"title": "ECLI:NL:HR:2002:AE9242 Hoge Raad , 06-12-2002 / C01/110HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7345",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 150"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 2.1464747059998783e-13,
				"hubs": 3.2770034786430284e-21,
				"community": "3",
				"ecli": "ECLI:NL:HR:2002:AE7345",
				"pagerank": 0.005223486315578651,
				"betweenness_centrality": 0.00033514872224549644,
				"date": "2002-11-29",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.011764705882352941,
				"closeness_centrality": 0.025806451612903226,
				"count_version": 7,
				"x": 0.4553269837434901,
				"y": 0.7916871623871047,
				"title": "ECLI:NL:HR:2002:AE7345 Hoge Raad , 29-11-2002 / C00/298HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 5,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE7351",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 150"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 2.1464747059998783e-13,
				"hubs": 3.2770034786430284e-21,
				"community": "3",
				"ecli": "ECLI:NL:HR:2002:AE7351",
				"pagerank": 0.005223486315578651,
				"betweenness_centrality": 0.00033514872224549644,
				"date": "2002-11-29",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.011627906976744186,
				"closeness_centrality": 0.025806451612903226,
				"count_version": 6,
				"x": 0.45120811506416414,
				"y": 0.02213226706316007,
				"title": "ECLI:NL:HR:2002:AE7351 Hoge Raad , 29-11-2002 / C01/071HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 5,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4080",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.570337572619915e-96,
				"hubs": 0.00003232123175810883,
				"community": "4",
				"ecli": "ECLI:NL:HR:2002:AE4080",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0.00008378718056137411,
				"date": "2002-10-04",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.011494252873563218,
				"closeness_centrality": 0.008602150537634409,
				"count_version": 4,
				"x": 0.23759920126366918,
				"y": 0.09579640561159242,
				"title": "ECLI:NL:HR:2002:AE4080 Hoge Raad , 04-10-2002 / C01/326HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 2,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE4090",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 0.00020578544181916691,
				"hubs": 0,
				"community": "18",
				"ecli": "ECLI:NL:HR:2002:AE4090",
				"pagerank": 0.00832623768925882,
				"betweenness_centrality": 0,
				"date": "2002-10-04",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.022727272727272728,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.5480542651649231,
				"y": 0.6470726656077117,
				"title": "ECLI:NL:HR:2002:AE4090 Hoge Raad , 04-10-2002 / C01/304HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AE2113",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "-",
				"authorities": 0.010223604179452879,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:2002:AE2113",
				"pagerank": 0.0075819393173567635,
				"betweenness_centrality": 0,
				"date": "2002-08-09",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.033707865168539325,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.6873754336764782,
				"y": 0.5461641253538062,
				"title": "ECLI:NL:HR:2002:AE2113 Hoge Raad , 09-08-2002 / C00/234HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 3,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD9124",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Koophandel 391"
				],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "25",
				"ecli": "ECLI:NL:HR:2002:AD9124",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2002-04-12",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 6,
				"x": 0.8666604221444575,
				"y": 0.3223098230131416,
				"title": "ECLI:NL:HR:2002:AD9124 Hoge Raad , 12-04-2002 / C00/207HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD7319",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 134"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "11",
				"ecli": "ECLI:NL:HR:2002:AD7319",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2002-03-01",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.01098901098901099,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.4253712128086302,
				"y": 0.10125354588366964,
				"title": "ECLI:NL:HR:2002:AD7319 Hoge Raad , 01-03-2002 / C00/063HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2002:AD4923",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "4",
				"ecli": "ECLI:NL:HR:2002:AD4923",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2002-01-18",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.026904598490048042,
				"count_version": 4,
				"x": 0.4595423028820401,
				"y": 0.9173863459092234,
				"title": "ECLI:NL:HR:2002:AD4923 Hoge Raad , 18-01-2002 / C00/103HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2002
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2737",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 2.8411354428361827e-21,
				"hubs": 0,
				"community": "3",
				"ecli": "ECLI:NL:HR:2001:AB2737",
				"pagerank": 0.006058570747168349,
				"betweenness_centrality": 0,
				"date": "2001-11-23",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.021505376344086023,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.6031371640983869,
				"y": 0.5238711176838718,
				"title": "ECLI:NL:HR:2001:AB2737 Hoge Raad , 23-11-2001 / C99/259HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AD3963",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 2.8411354428361827e-21,
				"hubs": 0,
				"community": "3",
				"ecli": "ECLI:NL:HR:2001:AD3963",
				"pagerank": 0.006058570747168349,
				"betweenness_centrality": 0,
				"date": "2001-11-23",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.02127659574468085,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.4160352248398296,
				"y": 0.29876891773725633,
				"title": "ECLI:NL:HR:2001:AD3963 Hoge Raad , 23-11-2001 / C00/069HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3677",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 0.000015188296082405083,
				"community": "4",
				"ecli": "ECLI:NL:HR:2001:ZC3677",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2001-11-09",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.033040078201368527,
				"count_version": 5,
				"x": 0.49857713019806515,
				"y": 0.5857557590280893,
				"title": "ECLI:NL:HR:2001:ZC3677 Hoge Raad , 09-11-2001 / C99/282HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:ZC3689",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 0.0023145702563165693,
				"hubs": 4.528120703550725e-97,
				"community": "18",
				"ecli": "ECLI:NL:HR:2001:ZC3689",
				"pagerank": 0.006607814408274016,
				"betweenness_centrality": 0.00020946795140343527,
				"date": "2001-10-19",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.020833333333333332,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 5,
				"x": 0.8897039917620493,
				"y": 0.3984237150269121,
				"title": "ECLI:NL:HR:2001:ZC3689 Hoge Raad , 19-10-2001 / C99/262HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 3,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB2149",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 6.266963476646511e-57,
				"hubs": 0,
				"community": "7",
				"ecli": "ECLI:NL:HR:2001:AB2149",
				"pagerank": 0.00492625253648227,
				"betweenness_centrality": 0,
				"date": "2001-06-15",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.010309278350515464,
				"closeness_centrality": 0,
				"count_version": 8,
				"x": 0.36080378189365414,
				"y": 0.26790146310326446,
				"title": "ECLI:NL:HR:2001:AB2149 Hoge Raad , 15-06-2001 / C99/350HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1430",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "24",
				"ecli": "ECLI:NL:HR:2001:AB1430",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2001-05-04",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 4,
				"x": 0.8290499799148427,
				"y": 0.9479021746388284,
				"title": "ECLI:NL:HR:2001:AB1430 Hoge Raad , 04-05-2001 / C99/225HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB1208",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 3.206397329479628e-29,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:2001:AB1208",
				"pagerank": 0.004382461439407553,
				"betweenness_centrality": 0,
				"date": "2001-04-20",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.010101010101010102,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.15404510163594276,
				"y": 0.10327040101802198,
				"title": "ECLI:NL:HR:2001:AB1208 Hoge Raad , 20-04-2001 / C99/293HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0900",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 3.206397329479628e-29,
				"hubs": 4.528120703550725e-97,
				"community": "6",
				"ecli": "ECLI:NL:HR:2001:AB0900",
				"pagerank": 0.004382461439407553,
				"betweenness_centrality": 0.000041893590280687055,
				"date": "2001-04-06",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.01,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 4,
				"x": 0.007971281167574507,
				"y": 0.6434757037926354,
				"title": "ECLI:NL:HR:2001:AB0900 Hoge Raad , 06-04-2001 / C99/158HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AB0377",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 2.8411354428361827e-21,
				"hubs": 0,
				"community": "3",
				"ecli": "ECLI:NL:HR:2001:AB0377",
				"pagerank": 0.006058570747168349,
				"betweenness_centrality": 0,
				"date": "2001-03-02",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.019801980198019802,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.18561958087508512,
				"y": 0.030940394683492856,
				"title": "ECLI:NL:HR:2001:AB0377 Hoge Raad , 02-03-2001 / C99/089HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9556",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 2.8411354428361827e-21,
				"hubs": 0,
				"community": "3",
				"ecli": "ECLI:NL:HR:2001:AA9556",
				"pagerank": 0.006058570747168349,
				"betweenness_centrality": 0,
				"date": "2001-01-19",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.0196078431372549,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.8316059939891546,
				"y": 0.0021252289399460444,
				"title": "ECLI:NL:HR:2001:AA9556 Hoge Raad , 19-01-2001 / C99/093HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9434",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "-",
				"authorities": 0.010223604179452879,
				"hubs": 0.0023150403857461303,
				"community": "2",
				"ecli": "ECLI:NL:HR:2001:AA9434",
				"pagerank": 0.0075819393173567635,
				"betweenness_centrality": 0.000397989107666527,
				"date": "2001-01-12",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.02912621359223301,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 5,
				"x": 0.1312350272933649,
				"y": 0.8835968177295939,
				"title": "ECLI:NL:HR:2001:AA9434 Hoge Raad , 12-01-2001 / C99/125HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 5,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9308",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Verdrag betreffende de overeenkomst tot internationaal vervoer van goederen over de weg (CMR), Genève, 19-05-1956 29"
				],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "9",
				"ecli": "ECLI:NL:HR:2001:AA9308",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2001-01-05",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 4,
				"x": 0.164449979791072,
				"y": 0.29738009807316934,
				"title": "ECLI:NL:HR:2001:AA9308 Hoge Raad , 05-01-2001 / C99/162HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9313",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.4688325974695944e-46,
				"hubs": 0,
				"community": "17",
				"ecli": "ECLI:NL:HR:2001:AA9313",
				"pagerank": 0.004654356987944911,
				"betweenness_centrality": 0,
				"date": "2001-01-05",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.009523809523809525,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.05845507881094991,
				"y": 0.5550271565320134,
				"title": "ECLI:NL:HR:2001:AA9313 Hoge Raad , 05-01-2001 / C99/122HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2001:AA9243",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wet op de loonbelasting 1964 10"
				],
				"in_degree": 1,
				"abstract": "Nr. 35438 3 januari 2001 gewezen op het beroep in cassatie van de Staatssecretaris van Financiën tegen de uitspraak van het Gerechtshof te Arnhem van 3 juni 1999, nr. 97/22511, betreffende na te melden aan de besloten vennootschap met beperkte aansprakelijkheid X te Z opgelegde naheffingsaanslag loonbelasting/premie volksverzekeringen. 1. Naheffingsaanslag, bezwaar en geding voor het Hof...",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "16",
				"ecli": "ECLI:NL:HR:2001:AA9243",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "2001-01-03",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.009433962264150943,
				"closeness_centrality": 0,
				"count_version": 10,
				"x": 0.7462409452640355,
				"y": 0.691568938079569,
				"title": "ECLI:NL:HR:2001:AA9243 Hoge Raad , 03-01-2001 / 35438",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#bestuursrecht_belastingrecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2001
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9051",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.570337572619915e-96,
				"hubs": 0.000015188296082405083,
				"community": "4",
				"ecli": "ECLI:NL:HR:2000:AA9051",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0.0005446166736489317,
				"date": "2000-12-15",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.009345794392523364,
				"closeness_centrality": 0.033040078201368527,
				"count_version": 5,
				"x": 0.7299803016070618,
				"y": 0.01606794114993404,
				"title": "ECLI:NL:HR:2000:AA9051 Hoge Raad , 15-12-2000 / C99/139HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 3,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA9048",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "24",
				"ecli": "ECLI:NL:HR:2000:AA9048",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "2000-12-15",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.009259259259259259,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.0403612591052781,
				"y": 0.24686162819807644,
				"title": "ECLI:NL:HR:2000:AA9048 Hoge Raad , 15-12-2000 / C99/074HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8369",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.04516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 5",
					"Wet op de rechterlijke organisatie 39",
					"Wetboek van Burgerlijke Rechtsvordering 157",
					"Overgangswet nieuw Burgerlijk Wetboek 74",
					"Wetboek van Burgerlijke Rechtsvordering 140",
					"Overgangswet nieuw Burgerlijk Wetboek 69",
					"Overgangswet nieuw Burgerlijk Wetboek 68a"
				],
				"in_degree": 6,
				"abstract": "-",
				"authorities": 0.19498600591376608,
				"hubs": 0.000012968485017164284,
				"community": "0",
				"ecli": "ECLI:NL:HR:2000:AA8369",
				"pagerank": 0.016111981596177855,
				"betweenness_centrality": 0.0027649769585253456,
				"date": "2000-11-17",
				"in_degree_centrality": 0.03870967741935484,
				"rel_in_degree": 0.05504587155963303,
				"closeness_centrality": 0.02903225806451613,
				"count_version": 5,
				"x": 0.8488267209364493,
				"y": 0.7511431226721579,
				"title": "ECLI:NL:HR:2000:AA8369 Hoge Raad , 17-11-2000 / C98/273HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 7,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA8364",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 6.266963476646511e-57,
				"hubs": 0,
				"community": "7",
				"ecli": "ECLI:NL:HR:2000:AA8364",
				"pagerank": 0.00492625253648227,
				"betweenness_centrality": 0,
				"date": "2000-11-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.00909090909090909,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.15335817721558853,
				"y": 0.9556009834459628,
				"title": "ECLI:NL:HR:2000:AA8364 Hoge Raad , 17-11-2000 / C99/016",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA7686",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Grondwet 121",
					"Wetboek van Burgerlijke Rechtsvordering 59",
					"Wetboek van Burgerlijke Rechtsvordering 176",
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 6.266963476646511e-57,
				"hubs": 0,
				"community": "7",
				"ecli": "ECLI:NL:HR:2000:AA7686",
				"pagerank": 0.00492625253648227,
				"betweenness_centrality": 0,
				"date": "2000-10-20",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.009009009009009009,
				"closeness_centrality": 0,
				"count_version": 5,
				"x": 0.08874477390771673,
				"y": 0.25600282205465363,
				"title": "ECLI:NL:HR:2000:AA7686 Hoge Raad , 20-10-2000 / C99/004HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5635",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 5,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "-",
				"authorities": 2.860406296671996e-13,
				"hubs": 1.3401624883961085e-29,
				"community": "8",
				"ecli": "ECLI:NL:HR:2000:AA5635",
				"pagerank": 0.006516857305061262,
				"betweenness_centrality": 0.00025136154168412233,
				"date": "2000-04-28",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.017857142857142856,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 9,
				"x": 0.09077143273606125,
				"y": 0.5569529114350582,
				"title": "ECLI:NL:HR:2000:AA5635 Hoge Raad , 28-04-2000 / C98/363HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 4,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:2000:AA5634",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Onteigeningswet 73"
				],
				"in_degree": 0,
				"abstract": "-",
				"authorities": 0,
				"hubs": 4.528120703550725e-97,
				"community": "8",
				"ecli": "ECLI:NL:HR:2000:AA5634",
				"pagerank": 0.0038386703423328346,
				"betweenness_centrality": 0,
				"date": "2000-04-28",
				"in_degree_centrality": 0,
				"rel_in_degree": 0,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 5,
				"x": 0.4335141987424399,
				"y": 0.8291632847446144,
				"title": "ECLI:NL:HR:2000:AA5634 Hoge Raad , 28-04-2000 / C98/220HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 1,
				"year": 2000
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3837",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.05806451612903226,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Overgangswet nieuw Burgerlijk Wetboek 74",
					"Overgangswet nieuw Burgerlijk Wetboek 69",
					"Overgangswet nieuw Burgerlijk Wetboek 68a"
				],
				"in_degree": 5,
				"abstract": "-",
				"authorities": 0.0000449742853949153,
				"hubs": 6.872489035210302e-14,
				"community": "4",
				"ecli": "ECLI:NL:HR:1999:AA3837",
				"pagerank": 0.02612714245389464,
				"betweenness_centrality": 0.009069962295768747,
				"date": "1999-12-10",
				"in_degree_centrality": 0.03225806451612903,
				"rel_in_degree": 0.043859649122807015,
				"closeness_centrality": 0.039032258064516136,
				"count_version": 5,
				"x": 0.3334175237996283,
				"y": 0.1416713399258165,
				"title": "ECLI:NL:HR:1999:AA3837 Hoge Raad , 10-12-1999 / C98/202HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 9,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AA3835",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 178"
				],
				"in_degree": 1,
				"abstract": "-",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:1999:AA3835",
				"pagerank": 0.007563670976565536,
				"betweenness_centrality": 0,
				"date": "1999-12-10",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008695652173913044,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.5865694196112933,
				"y": 0.6834393695961981,
				"title": "ECLI:NL:HR:1999:AA3835 Hoge Raad , 10-12-1999 / C98/158HR",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC2912",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "13",
				"ecli": "ECLI:NL:HR:1999:ZC2912",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "1999-05-28",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008620689655172414,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.9526664041473041,
				"y": 0.1421355950169223,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD2996",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "",
				"authorities": 0.0015315162764184982,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:1999:AD2996",
				"pagerank": 0.008268229337810198,
				"betweenness_centrality": 0,
				"date": "1999-01-22",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.017094017094017096,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.764000253645824,
				"y": 0.4256072005379581,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 2,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:AD299",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 0.002130391829413503,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:1999:AD299",
				"pagerank": 0.004976441117049863,
				"betweenness_centrality": 0,
				"date": "",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.00847457627118644,
				"closeness_centrality": 0,
				"count_version": 0,
				"x": 0.6584333224413725,
				"y": 0.03288225662594868,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1999:ZC293",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 3.206397329479628e-29,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:1999:ZC293",
				"pagerank": 0.004382461439407553,
				"betweenness_centrality": 0,
				"date": "",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008403361344537815,
				"closeness_centrality": 0,
				"count_version": 0,
				"x": 0.9178984612332374,
				"y": 0.6475743830317576,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1999
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2748",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 3.206397329479628e-29,
				"hubs": 0,
				"community": "6",
				"ecli": "ECLI:NL:HR:1998:ZC2748",
				"pagerank": 0.004382461439407553,
				"betweenness_centrality": 0,
				"date": "1998-10-23",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008333333333333333,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.10496502829044219,
				"y": 0.6894742243761094,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1998
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2721",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 134"
				],
				"in_degree": 4,
				"abstract": "",
				"authorities": 8.061615055298676e-13,
				"hubs": 4.7372917196627155e-14,
				"community": "8",
				"ecli": "ECLI:NL:HR:1998:ZC2721",
				"pagerank": 0.008989255472456515,
				"betweenness_centrality": 0.00020946795140343527,
				"date": "1998-10-02",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.03305785123966942,
				"closeness_centrality": 0.008602150537634409,
				"count_version": 4,
				"x": 0.8876215917826925,
				"y": 0.23824563311530755,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 1,
				"degree": 5,
				"year": 1998
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC2720",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 3.1087952108284664e-13,
				"community": "8",
				"ecli": "ECLI:NL:HR:1998:ZC2720",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0.00012568077084206116,
				"date": "1998-10-02",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.00819672131147541,
				"closeness_centrality": 0.014516129032258065,
				"count_version": 5,
				"x": 0.7480680586687117,
				"y": 0.9209738500532405,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 3,
				"year": 1998
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1998:ZC272",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 0.048655896835773274,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:1998:ZC272",
				"pagerank": 0.004382461439407553,
				"betweenness_centrality": 0,
				"date": "",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008130081300813009,
				"closeness_centrality": 0,
				"count_version": 0,
				"x": 0.060488527294226824,
				"y": 0.3394969834521663,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1998
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2495",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 48",
					"Wetboek van Burgerlijke Rechtsvordering 176"
				],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "10",
				"ecli": "ECLI:NL:HR:1997:ZC2495",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1997-11-14",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008064516129032258,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.4527595127483479,
				"y": 0.12394449287152542,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1997
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1997:ZC2460",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 2.3802363410719314e-14,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1997:ZC2460",
				"pagerank": 0.009390030667047345,
				"betweenness_centrality": 0,
				"date": "1997-10-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.008,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.3742220147021128,
				"y": 0.7049533076298207,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1997
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:XX:1996:AD4440",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 7.206213554442336e-30,
				"hubs": 0,
				"community": "8",
				"ecli": "ECLI:NL:XX:1996:AD4440",
				"pagerank": 0.006608302288824469,
				"betweenness_centrality": 0,
				"date": "1996-10-22",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007936507936507936,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.39573650419425854,
				"y": 0.3243718322586081,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1996
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1996:ZC2142",
				"out_degree_centrality": 0.025806451612903226,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 177"
				],
				"in_degree": 1,
				"abstract": "",
				"authorities": 2.3802363410719314e-14,
				"hubs": 1.4680845323233493e-31,
				"community": "4",
				"ecli": "ECLI:NL:HR:1996:ZC2142",
				"pagerank": 0.009390030667047345,
				"betweenness_centrality": 0.005152911604524508,
				"date": "1996-09-20",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007874015748031496,
				"closeness_centrality": 0.028739002932551317,
				"count_version": 4,
				"x": 0.39570405804068753,
				"y": 0.8106474849214197,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 4,
				"degree": 5,
				"year": 1996
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1995:ZC1867",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "",
				"authorities": 3.9270186849238617e-29,
				"hubs": 0,
				"community": "8",
				"ecli": "ECLI:NL:HR:1995:ZC1867",
				"pagerank": 0.007152093385899186,
				"betweenness_centrality": 0,
				"date": "1995-11-03",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.015625,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.37689023126529,
				"y": 0.2817534689512574,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 1995
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1994:ZC1405",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "18",
				"ecli": "ECLI:NL:HR:1994:ZC1405",
				"pagerank": 0.009455196098058734,
				"betweenness_centrality": 0,
				"date": "1994-06-24",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007751937984496124,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.6315904256880831,
				"y": 0.7949675052678337,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1994
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1076",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "23",
				"ecli": "ECLI:NL:HR:1993:ZC1076",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1993-09-24",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007692307692307693,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.43704883002082806,
				"y": 0.5634085866670117,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1993
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AC4282",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "16",
				"ecli": "ECLI:NL:HR:1993:AC4282",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1993-07-15",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007633587786259542,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.553475153118043,
				"y": 0.41520232562943327,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1993
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1044",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 157"
				],
				"in_degree": 1,
				"abstract": "",
				"authorities": 0.000012382480237382965,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1993:ZC1044",
				"pagerank": 0.00492625253648227,
				"betweenness_centrality": 0,
				"date": "1993-07-08",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007575757575757576,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.2347910501985635,
				"y": 0.1037750981782507,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1993
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:ZC1027",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Burgerlijke Rechtsvordering 4",
					"Wetboek van Burgerlijke Rechtsvordering 5"
				],
				"in_degree": 2,
				"abstract": "",
				"authorities": 0.000007698232772663564,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1993:ZC1027",
				"pagerank": 0.008488179080134325,
				"betweenness_centrality": 0,
				"date": "1993-07-01",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.015037593984962405,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.3723070366438761,
				"y": 0.09069414394403308,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 1993
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1993:AD1907",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03870967741935484,
				"count_annotation": 3,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Burgerlijk Wetboek Boek 7A 1638x",
					"Burgerlijk Wetboek Boek 7A"
				],
				"in_degree": 5,
				"abstract": "",
				"authorities": 9.138323552009703e-13,
				"hubs": 4.7372917196627155e-14,
				"community": "8",
				"ecli": "ECLI:NL:HR:1993:AD1907",
				"pagerank": 0.01200739091903385,
				"betweenness_centrality": 0.00020946795140343527,
				"date": "1993-06-25",
				"in_degree_centrality": 0.03225806451612903,
				"rel_in_degree": 0.03731343283582089,
				"closeness_centrality": 0.008602150537634409,
				"count_version": 7,
				"x": 0.586302705564782,
				"y": 0.932751381465059,
				"title": "",
				"subject": "",
				"out_degree": 1,
				"degree": 6,
				"year": 1993
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0717",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "",
				"authorities": 0.006496968690907915,
				"hubs": 0,
				"community": "2",
				"ecli": "ECLI:NL:HR:1992:ZC0717",
				"pagerank": 0.008850786713874088,
				"betweenness_centrality": 0,
				"date": "1992-10-16",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.014814814814814815,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.6467415657200369,
				"y": 0.7229437348953757,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 2,
				"year": 1992
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0559",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 8.485449232399809e-32,
				"hubs": 9.787230215488994e-32,
				"community": "4",
				"ecli": "ECLI:NL:HR:1992:ZC0559",
				"pagerank": 0.005832839607977089,
				"betweenness_centrality": 0,
				"date": "1992-03-27",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007352941176470588,
				"closeness_centrality": 0.012903225806451613,
				"count_version": 4,
				"x": 0.928866552263389,
				"y": 0.6852053090775568,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 3,
				"year": 1992
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1992:ZC0526",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 4,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "26",
				"ecli": "ECLI:NL:HR:1992:ZC0526",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "1992-02-28",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.0072992700729927005,
				"closeness_centrality": 0,
				"count_version": 6,
				"x": 0.23094847617853298,
				"y": 0.7467858794702896,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1992
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0394",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "25",
				"ecli": "ECLI:NL:HR:1991:ZC0394",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "1991-11-01",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007246376811594203,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.13657031592497526,
				"y": 0.7108171237299447,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1991
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0352",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "21",
				"ecli": "ECLI:NL:HR:1991:ZC0352",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1991-10-04",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007194244604316547,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.7477434335526444,
				"y": 0.8594585027337064,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1991
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1991:ZC0181",
				"out_degree_centrality": 0.012903225806451613,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 8.485449232399809e-32,
				"hubs": 0.0003287911887241735,
				"community": "4",
				"ecli": "ECLI:NL:HR:1991:ZC0181",
				"pagerank": 0.005832839607977089,
				"betweenness_centrality": 0.0017595307917888563,
				"date": "1991-03-22",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.007142857142857143,
				"closeness_centrality": 0.014516129032258065,
				"count_version": 2,
				"x": 0.9957765104024623,
				"y": 0.7503680159650892,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 2,
				"degree": 3,
				"year": 1991
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC0073",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "21",
				"ecli": "ECLI:NL:HR:1990:ZC0073",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1990-12-07",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.0070921985815602835,
				"closeness_centrality": 0,
				"count_version": 4,
				"x": 0.7101989631849347,
				"y": 0.6864858078948198,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#civielRecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1990
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AC4217",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 4,
				"abstract": "",
				"authorities": 0.00011208898336856304,
				"hubs": 7.624991590142904e-15,
				"community": "4",
				"ecli": "ECLI:NL:HR:1990:AC4217",
				"pagerank": 0.018089592653702944,
				"betweenness_centrality": 0.00027230833682446586,
				"date": "1990-06-15",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.028169014084507043,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 4,
				"x": 0.9006156798251723,
				"y": 0.38180959175118445,
				"title": "",
				"subject": "",
				"out_degree": 1,
				"degree": 5,
				"year": 1990
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:AB9376",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.03225806451612903,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 4,
				"abstract": "",
				"authorities": 1.6428774025423316e-13,
				"hubs": 4.528120703550725e-97,
				"community": "8",
				"ecli": "ECLI:NL:HR:1990:AB9376",
				"pagerank": 0.030254825181558538,
				"betweenness_centrality": 0.0012568077084206116,
				"date": "1990-04-06",
				"in_degree_centrality": 0.025806451612903226,
				"rel_in_degree": 0.027972027972027972,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 3,
				"x": 0.5787996600431016,
				"y": 0.9681331325515409,
				"title": "",
				"subject": "",
				"out_degree": 1,
				"degree": 5,
				"year": 1990
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1990:ZC8398",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [
					"Wetboek van Strafvordering 457"
				],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "8",
				"ecli": "ECLI:NL:HR:1990:ZC8398",
				"pagerank": 0.02955118866842518,
				"betweenness_centrality": 0,
				"date": "1990-01-30",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006944444444444444,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.12688126041572934,
				"y": 0.743910364955935,
				"title": "",
				"subject": "http://psi.rechtspraak.nl/rechtsgebied#strafrecht",
				"out_degree": 0,
				"degree": 1,
				"year": 1990
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AB9375",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "",
				"authorities": 0.0010281481944855258,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1989:AB9375",
				"pagerank": 0.007523485007228277,
				"betweenness_centrality": 0,
				"date": "1989-11-17",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.013793103448275862,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.5932784430875809,
				"y": 0.19430264286430665,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 2,
				"year": 1989
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1989:AD0808",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.570337572619915e-96,
				"hubs": 0,
				"community": "9",
				"ecli": "ECLI:NL:HR:1989:AD0808",
				"pagerank": 0.007101416924781142,
				"betweenness_centrality": 0,
				"date": "1989-05-26",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.00684931506849315,
				"closeness_centrality": 0,
				"count_version": 3,
				"x": 0.4727261060460959,
				"y": 0.07630462043826525,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1989
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AC3826",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.4688325974695944e-46,
				"hubs": 0,
				"community": "17",
				"ecli": "ECLI:NL:HR:1987:AC3826",
				"pagerank": 0.004654356987944911,
				"betweenness_centrality": 0,
				"date": "1987-11-13",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006802721088435374,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.4606356328072061,
				"y": 0.7042984049696792,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1987
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1987:AG5504",
				"out_degree_centrality": 0.0064516129032258064,
				"degree_centrality": 0.025806451612903226,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "",
				"authorities": 1.6970898464799618e-31,
				"hubs": 4.893615107744497e-32,
				"community": "4",
				"ecli": "ECLI:NL:HR:1987:AG5504",
				"pagerank": 0.011573146676689903,
				"betweenness_centrality": 0.000041893590280687055,
				"date": "1987-01-09",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.02027027027027027,
				"closeness_centrality": 0.0064516129032258064,
				"count_version": 2,
				"x": 0.34457852431994485,
				"y": 0.6677713378865175,
				"title": "",
				"subject": "",
				"out_degree": 1,
				"degree": 4,
				"year": 1987
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1983:AG4611",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 0.00002160701491610053,
				"hubs": 0,
				"community": "18",
				"ecli": "ECLI:NL:HR:1983:AG4611",
				"pagerank": 0.006694864398034667,
				"betweenness_centrality": 0,
				"date": "1983-06-10",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006711409395973154,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.17610574050472128,
				"y": 0.6369900138778088,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1983
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AC0442",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "10",
				"ecli": "ECLI:NL:HR:1982:AC0442",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1982-10-29",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006666666666666667,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.7515203459846401,
				"y": 0.03957403848943408,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1982
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1982:AG4420",
				"out_degree_centrality": 0,
				"degree_centrality": 0.012903225806451613,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 2,
				"abstract": "",
				"authorities": 2.6443223511076045e-14,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1982:AG4420",
				"pagerank": 0.02476957016265319,
				"betweenness_centrality": 0,
				"date": "1982-06-25",
				"in_degree_centrality": 0.012903225806451613,
				"rel_in_degree": 0.013245033112582781,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.5397319566424933,
				"y": 0.8124435260765773,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 2,
				"year": 1982
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1978:AC3514",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 0,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "0",
				"ecli": "ECLI:NL:HR:1978:AC3514",
				"pagerank": 0.006394551737125777,
				"betweenness_centrality": 0,
				"date": "1978-04-14",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006578947368421052,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.0022677864890102706,
				"y": 0.6459125559773297,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1978
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1976:AC5837",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 2,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "19",
				"ecli": "ECLI:NL:HR:1976:AC5837",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1976-12-17",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.006535947712418301,
				"closeness_centrality": 0,
				"count_version": 2,
				"x": 0.5081816608015803,
				"y": 0.6573264559156063,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1976
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1975:AC5607",
				"out_degree_centrality": 0,
				"degree_centrality": 0.01935483870967742,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 3,
				"abstract": "",
				"authorities": 1.6970898464799616e-31,
				"hubs": 0,
				"community": "4",
				"ecli": "ECLI:NL:HR:1975:AC5607",
				"pagerank": 0.018149548170559658,
				"betweenness_centrality": 0,
				"date": "1975-06-27",
				"in_degree_centrality": 0.01935483870967742,
				"rel_in_degree": 0.01948051948051948,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.09178559256874264,
				"y": 0.5138500146869134,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 3,
				"year": 1975
			},
			{
				"id": "http://deeplink.rechtspraak.nl/uitspraak?id=ECLI:NL:HR:1969:AC4973",
				"out_degree_centrality": 0,
				"degree_centrality": 0.0064516129032258064,
				"count_annotation": 1,
				"creator": "http://standaarden.overheid.nl/owms/terms/Hoge_Raad_der_Nederlanden",
				"articles": [],
				"in_degree": 1,
				"abstract": "",
				"authorities": 1.5187373096409423e-71,
				"hubs": 0,
				"community": "19",
				"ecli": "ECLI:NL:HR:1969:AC4973",
				"pagerank": 0.005470043633556988,
				"betweenness_centrality": 0,
				"date": "1969-11-28",
				"in_degree_centrality": 0.0064516129032258064,
				"rel_in_degree": 0.0064516129032258064,
				"closeness_centrality": 0,
				"count_version": 1,
				"x": 0.11058236354021633,
				"y": 0.2647051010504401,
				"title": "",
				"subject": "",
				"out_degree": 0,
				"degree": 1,
				"year": 1969
			}
		]
	};

/***/ },
/* 449 */
267,
/* 450 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(193);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(193);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 453 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(194);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(195);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(77);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(77);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(194);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(454);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(195);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(197);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(196);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(123);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(198);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(199);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(122);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 456 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 457 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	EdgeShapes component, interface for customEdgeShapes sigma plugin.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted until graph is available. It can be used within Sigma component if graph is
	preloaded, or within loader component, like LoadJSON.
	
	Note! this Component requires "canvas" renderer to work.
	
	To assign a shape renderer to an edge, simply set edge.type='shape-name' e.g. edge.type='dotted'.
	```
	<Sigma renderer="canvas" graph={{nodes:["id0", "id1"], edges:[{id:"e0",source:"id0",target:"id1"}]}}>
		<EdgeShapes default="dotted"/>
	</Sigma>
	```
	
	Supported shapes
	```
	type Sigma$Edge$Shapes = "line" | "arrow" | "curve" | "curvedArrow" | "dashed" | "dotted" | "parallel" | "tapered";
	```
	
	See [plugin page](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.renderers.customEdgeShapes)
	for more datails on implementation.
	
	@param {string} default  set default sigma edge to be applied to edges where type is not set
	
	**/
	
	var EdgeShapes = function (_React$Component) {
		_inherits(EdgeShapes, _React$Component);
	
		function EdgeShapes(props) {
			_classCallCheck(this, EdgeShapes);
	
			var _this = _possibleConstructorReturn(this, (EdgeShapes.__proto__ || Object.getPrototypeOf(EdgeShapes)).call(this, props));
	
			_this.render = function () {
				return null;
			};
	
			if (_this.props.sigma && _this.props.default) _this.props.sigma.settings({ defaultEdgeType: _this.props.default });
			return _this;
		}
	
		return EdgeShapes;
	}(_react2.default.Component);
	
	EdgeShapes.propTypes = {
		default: __webpack_require__(1).PropTypes.any,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = EdgeShapes;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	Filter component, interface for filter sigma plugin.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted until graph is available. It can be used within Sigma component if graph is
	preloaded, or within loader component, like NeoCypher.
	
	Filter is hiding all nodes which do not apply to the provided nodesBy criteria.
	
	@param {Nodes$Filter} nodesBy   will hide nodes where filter returns false
	
	type Nodes$Filter = (node: Sigma$Node) => boolean;
	
	
	**/
	
	var Filter = function (_React$Component) {
		_inherits(Filter, _React$Component);
	
		function Filter() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Filter);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filter.__proto__ || Object.getPrototypeOf(Filter)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
				return null;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Filter, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.filter = new sigma.plugins.filter(this.props.sigma);
				this._apply(this.props);
			}
	
			// TODO: will it work in composition with ForceAtlas for instance?
			//It should hide nodes before rendering of subplugins, therefore used in componentWillUpdate.. is it right?
	
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(props) {
				if (props.nodesBy !== this.props.nodesBy || props.neighborsOf !== this.props.neighborsOf) this._apply(props);
			}
	
			// TODO: Composition is not working yet!!
	
		}, {
			key: '_apply',
			value: function _apply(props) {
				this.filter.undo(["neighborsOf", "nodesBy"]);
				if (props.neighborsOf) {
					this.filter.neighborsOf(props.neighborsOf, "neighborsOf");
				}
				if (props.nodesBy) this.filter.nodesBy(props.nodesBy, "nodesBy");
				this.filter.apply();
				if (this.props.sigma) this.props.sigma.refresh();
			}
		}]);
	
		return Filter;
	}(_react2.default.Component);
	
	Filter.propTypes = {
		nodesBy: __webpack_require__(1).PropTypes.any,
		neighborsOf: __webpack_require__(1).PropTypes.string,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = Filter;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	ForceAtlas2 component, starts ForceAtlas2 sigma plugin once component is mounted.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted while graph is unavailable. It can be used within Sigma component if graph is
	preloaded, or within loader component, like NeoCypher.
	
	It accepts all the parameters of ForceAtlas2 described on its github page:
	@param {boolean} [worker=true]           Use a web worker to run calculations in separate thread
	@param {boolean} barnesHutOptimize  Use the algorithm's Barnes-Hut to improve repulsion's scalability
										This is useful for large graph but harmful to small ones.
	@param {number} barnesHutTheta
	@param {boolean} adjustSizes
	@param {number} iterationsPerRender
	@param {boolean} [linLogMode=true]
	@param {boolean} outboundAttractionDistribution
	@param {number} edgeWeightInfluence
	@param {number} scalingRatio
	@param {boolean} strongGravityMode
	@param {number} gravity
	@param {number} slowDown
	@param {number} timeout   how long algorythm should run. default=graph.nodes().length * 10
	
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.layout.forceAtlas2)
	
	**/
	
	var ForceAtlas2 = function (_React$Component) {
		_inherits(ForceAtlas2, _React$Component);
	
		function ForceAtlas2(props) {
			_classCallCheck(this, ForceAtlas2);
	
			var _this = _possibleConstructorReturn(this, (ForceAtlas2.__proto__ || Object.getPrototypeOf(ForceAtlas2)).call(this, props));
	
			_this.render = function () {
				return null;
			};
	
			_this.state = { running: false };
			return _this;
		}
	
		_createClass(ForceAtlas2, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this._refreshGraph();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				var s = this.props.sigma;
				if (prevState.running && !this.state.running && s) {
					s.stopForceAtlas2();
					s.settings({ drawEdges: prevState.drawEdges === false ? false : true });
					s.refresh();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.sigma) this.props.sigma.killForceAtlas2();
				if (this.state.timer) clearTimeout(this.state.timer);
			}
	
			//TODO: Add composition of child components after timeout
	
		}, {
			key: '_refreshGraph',
			value: function _refreshGraph() {
				var _this2 = this;
	
				var s = this.props.sigma;
				if (!sigma || !s) return;
	
				var drawEdges = s.settings("drawEdges");
				if (s.graph.edges().length > 1000) s.settings({ drawEdges: false });
	
				s.startForceAtlas2(this._stripOptions(this.props));
				// TODO: convert running status to state
				var timer = setTimeout(function () {
					_this2.setState({ running: false, timer: undefined });
				}, this.props.timeout || s.graph.nodes().length * 8);
				this.setState({ running: true, timer: timer, drawEdges: drawEdges });
			}
	
			//strip force atlas options from component props
	
		}, {
			key: '_stripOptions',
			value: function _stripOptions(props) {
				return Object.assign({}, props, { sigma: undefined });
			}
		}]);
	
		return ForceAtlas2;
	}(_react2.default.Component);
	
	ForceAtlas2.defaultProps = {
		worker: true,
		linLogMode: true
	};
	ForceAtlas2.propTypes = {
		worker: __webpack_require__(1).PropTypes.bool.isRequired,
		barnesHutOptimize: __webpack_require__(1).PropTypes.bool,
		barnesHutTheta: __webpack_require__(1).PropTypes.number,
		adjustSizes: __webpack_require__(1).PropTypes.bool,
		iterationsPerRender: __webpack_require__(1).PropTypes.number,
		linLogMode: __webpack_require__(1).PropTypes.bool.isRequired,
		outboundAttractionDistribution: __webpack_require__(1).PropTypes.bool,
		edgeWeightInfluence: __webpack_require__(1).PropTypes.number,
		scalingRatio: __webpack_require__(1).PropTypes.number,
		strongGravityMode: __webpack_require__(1).PropTypes.bool,
		slowDown: __webpack_require__(1).PropTypes.number,
		gravity: __webpack_require__(1).PropTypes.number,
		timeout: __webpack_require__(1).PropTypes.number,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = ForceAtlas2;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(477);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	LoadGEXF component, interface for parsers.json sigma plugin. Can be used within Sigma component.
	Can be composed with other plugins: on load it mounts all child components (e.g. other sigma plugins).
	Child's componentWillMount should be used to enable plugins on loaded graph.
	
	 @param {string} path   path to the GEXF file
	 @param {Function} onGraphLoaded        Optional callback for graph update
	
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.neo4j.cypher)
	
	**/
	
	var LoadGEXF = function (_React$PureComponent) {
	    _inherits(LoadGEXF, _React$PureComponent);
	
	    function LoadGEXF(props) {
	        _classCallCheck(this, LoadGEXF);
	
	        var _this = _possibleConstructorReturn(this, (LoadGEXF.__proto__ || Object.getPrototypeOf(LoadGEXF)).call(this, props));
	
	        _this.state = { loaded: false };
	        _this.onLoad = _this._onLoad.bind(_this);
	        return _this;
	    }
	
	    _createClass(LoadGEXF, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._load(this.props.path);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props) {
	            // reload only if path changes
	            if (this.props.path !== props.path) {
	                this.setState({ loaded: false });
	                this._load(props.path);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.loaded) return null;
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	            );
	        }
	    }, {
	        key: '_load',
	        value: function _load(url) {
	            sigma.parsers.gexf(this.props.path, this.props.sigma, this.onLoad);
	        }
	    }, {
	        key: '_onLoad',
	        value: function _onLoad() {
	            if (this.props.sigma) this.props.sigma.refresh();
	            this.setState({ loaded: true });
	            if (this.props.onGraphLoaded) return this.props.onGraphLoaded();
	        }
	    }]);
	
	    return LoadGEXF;
	}(_react2.default.PureComponent);
	
	LoadGEXF.propTypes = {
	    path: __webpack_require__(1).PropTypes.string.isRequired,
	    onGraphLoaded: __webpack_require__(1).PropTypes.func,
	    children: __webpack_require__(1).PropTypes.any,
	    sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = LoadGEXF;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(78);
	
	__webpack_require__(203);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: make a superclass for loaders??
	
	/**
	
	LoadJSON component, interface for parsers.json sigma plugin. Can be used within Sigma component.
	Can be composed with other plugins: on load it mounts all child components (e.g. other sigma plugins).
	Child's componentWillMount should be used to enable plugins on loaded graph.
	
	 @param {string} path   path to the JSON file
	 @param {Function} onGraphLoaded        Optional callback for graph update
	
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.neo4j.cypher)
	
	**/
	
	var LoadJSON = function (_React$PureComponent) {
	  _inherits(LoadJSON, _React$PureComponent);
	
	  function LoadJSON(props) {
	    _classCallCheck(this, LoadJSON);
	
	    var _this = _possibleConstructorReturn(this, (LoadJSON.__proto__ || Object.getPrototypeOf(LoadJSON)).call(this, props));
	
	    _this.state = { loaded: false };
	    _this.onLoad = _this._onLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(LoadJSON, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._load(this.props.path);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      // reload only if path changes
	      if (this.props.path !== props.path) {
	        this.setState({ loaded: false });
	        this._load(props.path);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.loaded) return null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	      );
	    }
	  }, {
	    key: '_load',
	    value: function _load(url) {
	      sigma.parsers.json(this.props.path, this.props.sigma, this.onLoad);
	    }
	  }, {
	    key: '_onLoad',
	    value: function _onLoad() {
	      if (this.props.sigma) this.props.sigma.refresh();
	      this.setState({ loaded: true });
	      if (this.props.onGraphLoaded) return this.props.onGraphLoaded();
	    }
	  }]);
	
	  return LoadJSON;
	}(_react2.default.PureComponent);
	
	LoadJSON.propTypes = {
	  path: __webpack_require__(1).PropTypes.string.isRequired,
	  onGraphLoaded: __webpack_require__(1).PropTypes.func,
	  children: __webpack_require__(1).PropTypes.any,
	  sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = LoadJSON;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(204);
	
	__webpack_require__(474);
	
	var _ReactSigmaLayoutPlugin = __webpack_require__(467);
	
	var _ReactSigmaLayoutPlugin2 = _interopRequireDefault(_ReactSigmaLayoutPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	
	NOverlap component, starts noverlap sigma plugin once component is mounted.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted while graph is unavailable. It can be used within Sigma component if graph is
	preloaded, or within loader component, like LoadJSON.
	
	@param {number} [nodeMargin=5]    additional minimum space to apply around each and every node
	@param {number} [scaleNodes=1.2]  multiplier,  larger nodes will have more space around
	@param {number} [gridSize=20]   number of rows and columns to use when dividing the nodes up into cell
	@param {number} [permittedExpansion=1.1]  maximum ratio to apply to the bounding box
	@param {number} speed     larger value increases the speed at the cost of precision
	@param {number} maxIterations  iterations to run the algorithm for before stopping it
	@param {number} easing     camera easing type for camera transition
	@param {number} duration     duration of the transition for the easing method
	
	It accepts all the parameters of sigma.layout.noverlap plugin described on its github page:
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.layout.noverlap)
	
	@example
	<Sigma graph={data}>
	 <NOverlap gridSize={10} maxIterations={100}/>
	</Sigma>
	
	**/
	
	var NOverlap = function NOverlap(props) {
		var s = props.sigma;
		if (s) return _react2.default.createElement(_ReactSigmaLayoutPlugin2.default, _extends({
			start: function start() {
				return s.startNoverlap();
			},
			config: function config(options) {
				return s.configNoverlap(options);
			},
			stop: function stop() {
				return s.stopNoverlap();
			} }, props));
		return null;
	};
	
	NOverlap.propTypes = {
		nodes: __webpack_require__(1).PropTypes.arrayOf(__webpack_require__(1).PropTypes.any),
		nodeMargin: __webpack_require__(1).PropTypes.number,
		scaleNodes: __webpack_require__(1).PropTypes.number,
		gridSize: __webpack_require__(1).PropTypes.number,
		permittedExpansion: __webpack_require__(1).PropTypes.number,
		speed: __webpack_require__(1).PropTypes.number,
		maxIterations: __webpack_require__(1).PropTypes.number,
		easing: __webpack_require__(1).PropTypes.any,
		duration: __webpack_require__(1).PropTypes.number,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = NOverlap;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(203);
	
	__webpack_require__(475);
	
	var _NeoGraphItemsProducers = __webpack_require__(201);
	
	var _NeoGraphItemsProducers2 = _interopRequireDefault(_NeoGraphItemsProducers);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	NeoCypher component, interface for neo4j.cypher sigma plugin. Can be used within Sigma component.
	Can be composed with other plugins: on load it mounts all child components (e.g. other sigma plugins).
	Child's componentWillMount should be used to enable plugins on loaded graph.
	
	 @param {string} url    Neo4j instance REST API URL
	 @param {string} user    Neo4j instance REST API user
	 @param {string} password    Neo4j instance REST API password
	 @param {string} query    Neo4j cypher query
	 @param {NeoGraphItemsProducers} producers   Optional transformer for creating Sigma nodes and edges,
	                                    instance compatible with NeoGraphItemsProducers
	 @param {Function} onGraphLoaded        Optional callback for graph update
	
	[see sigma plugin page for more details](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.neo4j.cypher)
	
	**/
	
	var NeoCypher = function (_React$PureComponent) {
	    _inherits(NeoCypher, _React$PureComponent);
	
	    function NeoCypher(props) {
	        _classCallCheck(this, NeoCypher);
	
	        var _this = _possibleConstructorReturn(this, (NeoCypher.__proto__ || Object.getPrototypeOf(NeoCypher)).call(this, props));
	
	        _this.state = { loaded: false };
	        _this.onLoad = _this._onLoad.bind(_this);
	        return _this;
	    }
	
	    _createClass(NeoCypher, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._runQuery(this.props.query);
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(props) {
	            // suppose url, user or password won't change for sigma instance, as well as sigma instance itself
	            if (this.props.query !== props.query) {
	                this.setState({ loaded: false });
	                this._runQuery(props.query);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.loaded) return null;
	            return _react2.default.createElement(
	                'div',
	                null,
	                (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	            );
	        }
	    }, {
	        key: '_runQuery',
	        value: function _runQuery(query) {
	            // TODO: add exception handling capability to Sigma Neo4j plugin
	            sigma.neo4j.cypher({ url: this.props.url, user: this.props.user, password: this.props.password }, query, this.props.sigma, this.onLoad, this.props.producers);
	        }
	    }, {
	        key: '_onLoad',
	        value: function _onLoad() {
	            this.setState({ loaded: true });
	            if (this.props.sigma) this.props.sigma.refresh();
	            if (this.props.onGraphLoaded) return this.props.onGraphLoaded();
	        }
	    }]);
	
	    return NeoCypher;
	}(_react2.default.PureComponent);
	
	NeoCypher.defaultProps = {
	    producers: new _NeoGraphItemsProducers2.default()
	};
	NeoCypher.propTypes = {
	    url: __webpack_require__(1).PropTypes.string.isRequired,
	    user: __webpack_require__(1).PropTypes.string.isRequired,
	    password: __webpack_require__(1).PropTypes.string.isRequired,
	    query: __webpack_require__(1).PropTypes.string.isRequired,
	    producers: __webpack_require__(1).PropTypes.any.isRequired,
	    onGraphLoaded: __webpack_require__(1).PropTypes.func,
	    children: __webpack_require__(1).PropTypes.any,
	    sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = NeoCypher;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	NodeShapes component, interface for customShapes sigma plugin.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted until graph is available. It can be used within Sigma component if graph is
	preloaded, or within loader component, like LoadJSON.
	
	Note! this Component requires "canvas" renderer to work.
	
	Extra node properties:
	 - node.type='shape-name' - node shape renderer e.g. node.type='cross'.
	 - node.borderColor - e.g. node.borderColor='#FF3333'
	Details on shapes configuration and possibility to apply images to nodes, please refer to
	[plugin page](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.renderers.customShapes#images).
	
	See [plugin page](https://github.com/jacomyal/sigma.js/tree/master/plugins/sigma.renderers.customEdgeShapes)
	for more datails on implementation.
	
	@param {string} default  set default sigma node renderer to be applied to nodes where type is not set
	
	
	@example
	```
	<Sigma renderer="canvas" graph={{nodes:["id0", "id1"], edges:[{id:"e0",source:"id0",target:"id1"}]}}>
		<NodeShapes default="star"/>
	</Sigma>
	```
	
	@example
	Supported shapes
	```
	type Sigma$Node$Shapes = "def" | "pacman" | "star" | "equilateral" | "cross" | "diamond" | "circle" | "square";
	```
	
	**/
	
	var NodeShapes = function (_React$Component) {
		_inherits(NodeShapes, _React$Component);
	
		function NodeShapes(props) {
			_classCallCheck(this, NodeShapes);
	
			var _this = _possibleConstructorReturn(this, (NodeShapes.__proto__ || Object.getPrototypeOf(NodeShapes)).call(this, props));
	
			_this.render = function () {
				return null;
			};
	
			if (_this.props.sigma && _this.props.default) _this.props.sigma.settings({ defaultNodeType: _this.props.default });
			return _this;
		}
	
		return NodeShapes;
	}(_react2.default.Component);
	
	NodeShapes.propTypes = {
		default: __webpack_require__(1).PropTypes.any,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = NodeShapes;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tools = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	RandomizeNodePositions component, sets random positions to all nodes.
	Can be used within Sigma component with predefined graph or within graph loader component.
	
	**/
	
	var RandomizeNodePositions = function (_React$PureComponent) {
	  _inherits(RandomizeNodePositions, _React$PureComponent);
	
	  function RandomizeNodePositions(props) {
	    _classCallCheck(this, RandomizeNodePositions);
	
	    var _this = _possibleConstructorReturn(this, (RandomizeNodePositions.__proto__ || Object.getPrototypeOf(RandomizeNodePositions)).call(this, props));
	
	    if (_this.props.sigma) {
	      _this.props.sigma.graph.nodes().forEach(function (n) {
	        n.x = Math.random();
	        n.y = Math.random();
	      });
	    }
	    if (_this.props.sigma) _this.props.sigma.refresh();
	    return _this;
	  }
	
	  _createClass(RandomizeNodePositions, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.sigma) this.props.sigma.refresh();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        (0, _tools.embedProps)(this.props.children, { sigma: this.props.sigma })
	      );
	    }
	  }]);
	
	  return RandomizeNodePositions;
	}(_react2.default.PureComponent);
	
	RandomizeNodePositions.propTypes = {
	  children: __webpack_require__(1).PropTypes.any,
	  sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = RandomizeNodePositions;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Utils = __webpack_require__(471);
	
	var Utils = _interopRequireWildcard(_Utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	ReactSigmaLayoutPlugin is a base class for sigma plugins.
	
	Usage
	```
	const NOverlap = (props: Props) => {
					const s = props.sigma
					if(s)
	          return <ReactSigmaLayoutPlugin
	              start={()=>s.startNoverlap()}
	              config={options=>s.configNoverlap(options)}
	              stop={s.stopNoverlap()} {...props} />
					return null
				}
	...
	<NOverlap easing="cubicInOut"/>
	```
	**/
	
	var ReactSigmaLayoutPlugin = function (_React$Component) {
		_inherits(ReactSigmaLayoutPlugin, _React$Component);
	
		function ReactSigmaLayoutPlugin(props) {
			_classCallCheck(this, ReactSigmaLayoutPlugin);
	
			var _this = _possibleConstructorReturn(this, (ReactSigmaLayoutPlugin.__proto__ || Object.getPrototypeOf(ReactSigmaLayoutPlugin)).call(this, props));
	
			_this._mounted = false;
	
			_this.render = function () {
				return null;
			};
	
			_this.state = { running: false };
			return _this;
		}
	
		_createClass(ReactSigmaLayoutPlugin, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this._start();
				this._mounted = true;
			}
	
			// Change sigma status only after react rendering complete
	
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.running && !this.state.running && this._mounted) {
					if (this.props.sigma) this.props.sigma.refresh();
				} else if (Utils.propsChanged(prevProps, this.props)) {
					this.props.stop();
					this._start();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._mounted = false;
				this.props.stop();
			}
	
			//TODO: Render composition of child components after animation
	
		}, {
			key: '_start',
			value: function _start() {
				var _this2 = this;
	
				this.props.config(ReactSigmaLayoutPlugin._stripOptions(this.props));
				var listener = this.props.start();
	
				listener.bind('stop', function () {
					_this2._mounted && _this2.setState({ running: false });
				});
	
				this.setState({ running: true });
			}
		}], [{
			key: '_stripOptions',
			value: function _stripOptions(props) {
				var config = {};
				for (var key in props) {
					if (key !== "start" && key !== "stop" && key !== "config" && key !== "sigma" && key !== "children") config[key] = props[key];
				}return config;
			}
		}]);
	
		return ReactSigmaLayoutPlugin;
	}(_react2.default.Component);
	
	ReactSigmaLayoutPlugin.propTypes = {
		config: __webpack_require__(1).PropTypes.func.isRequired,
		start: __webpack_require__(1).PropTypes.func.isRequired,
		stop: __webpack_require__(1).PropTypes.func.isRequired,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = ReactSigmaLayoutPlugin;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	
	RelativeSize component, interface for RelativeSize sigma plugin.
	It supposes that sigma graph is already in place, therefore component should not be
	mounted until graph is available. It can be used within Sigma component if graph is
	preloaded, or within loader component, like NeoCypher.
	
	Sets nodes sizes corresponding its degree.
	
	 @param {number} initialSize  start size for every node, will be multiplied by Math.sqrt(node.degree)
	
	**/
	
	var RelativeSize = function (_React$Component) {
		_inherits(RelativeSize, _React$Component);
	
		function RelativeSize(props) {
			_classCallCheck(this, RelativeSize);
	
			var _this = _possibleConstructorReturn(this, (RelativeSize.__proto__ || Object.getPrototypeOf(RelativeSize)).call(this, props));
	
			_this.render = function () {
				return null;
			};
	
			sigma.plugins.relativeSize(_this.props.sigma, _this.props.initialSize);
			return _this;
		}
	
		return RelativeSize;
	}(_react2.default.Component);
	
	RelativeSize.propTypes = {
		initialSize: __webpack_require__(1).PropTypes.number.isRequired,
		sigma: __webpack_require__(1).PropTypes.any
	};
	exports.default = RelativeSize;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tools = __webpack_require__(24);
	
	__webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * Sigma - React.JS flow-typed interface for Sigma js library - fastest opensource rendering engine for network graphs.
	 * Sigma makes it easy to publish networks on Web pages, and allows developers to integrate network exploration in
	 * rich Web applications.
	 *
	 * Parameter types
	 * ```
	 * type Sigma$Graph$Data = {
	 *   nodes: [Sigma$Node],
	 *   edges: [Sigma$Edge]
	 * };
	 *
	 * type Sigma$Node = {
	 *   id: string,
	 *   label?: string,
	 *   x?: number,
	 *   y?: number,
	 *   size?: number,
	 *   color?: color
	 * };
	 *
	 * type Sigma$Edge = {
	 *   id: string,
	 *   source: string,
	 *   target: string,
	 *   label?: string,
	 *   color?: color
	 * };
	 * ```
	 *
	 *
	 * @signature `<Sigma graph={graph} settings={settings} onClickNode={func}.../>`
	 *
	 * @param {CSS} style   CSS style description for main div holding graph, should be specified in React format
	 * @param {Sigma$Settings} settings     js object with sigma initialization options, for full list see [sigma settings page](https://github.com/jacomyal/sigma.js/wiki/Settings)
	 * @param {string} renderer     can be "webgl" or "canvas"
	 * @param {Sigma$Graph$Data} graph   js object with array of nodes and edges used to initialize sigma
	 * @param {Sigma$EventHandler} onClickNode      set sigma callback for "clickNode" event (see below)
	 * @param {Sigma$EventHandler} onOverNode      set sigma callback for "overNode" event
	 * @param {Sigma$EventHandler} onOutNode      set sigma callback for "outNode" event
	 * @param {Sigma$EventHandler} onClickEdge     set sigma callback for "clickEdge" event
	 * @param {Sigma$EventHandler} onOverEdge      set sigma callback for "overEdge" event
	 * @param {Sigma$EventHandler} onOutEdge      set sigma callback for "outEdge" event
	 *
	 * @example
	 * Can be composed with sigma sub-components using JSX syntax
	 * <Sigma renderer="webgl" style={{maxWidth:"inherit", height:"400px"}}
	 *        settings={{drawEdges:false}}
	 *        onOverNode={e => console.log("Mouse over node: " + e.data.node.label)}>
	 *        graph={{nodes:["id0", "id1"], edges:[{id:"e0",source:"id0",target:"id1"}]}}>
	 *   <RelativeSize initialSize={8}/>
	 * </Sigma>
	 *
	 */
	
	var Sigma = function (_React$PureComponent) {
	  _inherits(Sigma, _React$PureComponent);
	
	  function Sigma(props) {
	    _classCallCheck(this, Sigma);
	
	    var _this = _possibleConstructorReturn(this, (Sigma.__proto__ || Object.getPrototypeOf(Sigma)).call(this, props));
	
	    _this.state = { renderer: false };
	    var settings = _this.props.settings ? _this.props.settings : {};
	    _this.sigma = new sigma({ settings: settings });
	    _this.initRenderer = _this.initRenderer.bind(_this);
	    Sigma.bindHandlers(_this.props, _this.sigma);
	    if (_this.props.graph) _this.sigma.graph.read(_this.props.graph);
	    return _this;
	  }
	
	  _createClass(Sigma, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.graph !== prevProps.graph) {
	        this.sigma.graph.read(this.props.graph);
	        this.sigma.refresh();
	      }
	    }
	  }, {
	    key: 'initRenderer',
	    value: function initRenderer(container) {
	      if (container) {
	        var options = { container: container };
	        if (this.props.renderer) options.type = this.props.renderer;
	        this.sigmaRenderer = this.sigma.addRenderer(options);
	        this.sigma.refresh();
	        this.setState({ renderer: true });
	      } else if (this.sigmaRenderer) {
	        this.sigma.killRenderer(this.sigmaRenderer);
	        this.sigmaRenderer = null;
	        this.setState({ renderer: false });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      console.log("Sigma unmounting");
	      this.sigma.kill();
	      this.sigmaRenderer = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.state.renderer ? (0, _tools.embedProps)(this.props.children, { sigma: this.sigma }) : null;
	      return _react2.default.createElement(
	        'div',
	        { ref: this.initRenderer, style: this.props.style },
	        children
	      );
	    }
	
	    /**
	    Initialize event handlers with sigma.
	    
	    Event handler function receives [Sigma Event](https://github.com/jacomyal/sigma.js/wiki/Events-API)
	    with the structure of following type:
	    ```
	    type Sigma$Event = {
	      data: {
	        node?: Neo4j$Node, //for node events is sigma node data
	        edge?: Neo4j$Edge, //for edge events is sigma edge data
	        captor: {   // information about event handler, for instance position on the page {clientX, clientY}
	          clientX: number,
	          clientY: number
	    }}}
	    
	    type Sigma$EventHandler = (node:Sigma$Event) => void
	    
	    ```
	    **/
	
	  }], [{
	    key: 'bindHandlers',
	    value: function bindHandlers(handlers, sigma) {
	      ["clickNode", "overNode", "outNode", "clickEdge", "overEdge", "outEdge", "clickStage"].forEach(function (event) {
	        var handler = "on" + event[0].toUpperCase() + event.substr(1);
	        if (handlers[handler]) {
	          sigma.bind(event, handlers[handler]);
	        }
	      });
	    }
	  }]);
	
	  return Sigma;
	}(_react2.default.PureComponent);
	
	Sigma.defaultProps = {
	  settings: {
	    defaultNodeColor: "#3388AA",
	    defaultLabelSize: 8,
	    defaultLabelColor: "#777",
	    labelThreshold: 12,
	    hoverFontStyle: "text-size: 11",
	    batchEdgesDrawing: true,
	    drawEdges: true,
	    drawEdgeLabels: false
	  },
	  style: {
	    maxWidth: "inherit",
	    height: "400px"
	  }
	};
	Sigma.propTypes = {
	  settings: __webpack_require__(1).PropTypes.any.isRequired,
	  renderer: __webpack_require__(1).PropTypes.oneOf(['webgl', 'canvas']),
	  style: __webpack_require__(1).PropTypes.any,
	  children: __webpack_require__(1).PropTypes.any,
	  graph: __webpack_require__(1).PropTypes.any,
	  onClickNode: __webpack_require__(1).PropTypes.func,
	  onClickEdge: __webpack_require__(1).PropTypes.func,
	  onOverNode: __webpack_require__(1).PropTypes.func,
	  onOutNode: __webpack_require__(1).PropTypes.func,
	  onOverEdge: __webpack_require__(1).PropTypes.func,
	  onOutEdge: __webpack_require__(1).PropTypes.func,
	  onClickStage: __webpack_require__(1).PropTypes.func
	};
	exports.default = Sigma;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(78);
	
	__webpack_require__(480);
	
	/**
	  Component enables WebGL renderer, setting it as default renderer if WebGL is supported by browser.
	**/
	function SigmaEnableWebGL() {
	  return null;
	}
	
	exports.default = SigmaEnableWebGL;

/***/ },
/* 471 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.propsChanged = propsChanged;
	function propsChanged(prev, next) {
		for (var key in prev) {
			if (prev[key] !== next[key]) return true;
		}return false;
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SigmaEnableWebGL = exports.RandomizeNodePositions = exports.NeoGraphItemsProducers = exports.NeoCypher = exports.NOverlap = exports.RelativeSize = exports.ForceAtlas2 = exports.Filter = exports.LoadGEXF = exports.LoadJSON = exports.NodeShapes = exports.EdgeShapes = exports.Sigma = undefined;
	
	var _Sigma2 = __webpack_require__(469);
	
	var _Sigma3 = _interopRequireDefault(_Sigma2);
	
	var _EdgeShapes2 = __webpack_require__(458);
	
	var _EdgeShapes3 = _interopRequireDefault(_EdgeShapes2);
	
	var _NodeShapes2 = __webpack_require__(465);
	
	var _NodeShapes3 = _interopRequireDefault(_NodeShapes2);
	
	var _LoadJSON2 = __webpack_require__(462);
	
	var _LoadJSON3 = _interopRequireDefault(_LoadJSON2);
	
	var _LoadGEXF2 = __webpack_require__(461);
	
	var _LoadGEXF3 = _interopRequireDefault(_LoadGEXF2);
	
	var _Filter2 = __webpack_require__(459);
	
	var _Filter3 = _interopRequireDefault(_Filter2);
	
	var _ForceAtlas2 = __webpack_require__(460);
	
	var _ForceAtlas3 = _interopRequireDefault(_ForceAtlas2);
	
	var _RelativeSize2 = __webpack_require__(468);
	
	var _RelativeSize3 = _interopRequireDefault(_RelativeSize2);
	
	var _NOverlap2 = __webpack_require__(463);
	
	var _NOverlap3 = _interopRequireDefault(_NOverlap2);
	
	var _NeoCypher2 = __webpack_require__(464);
	
	var _NeoCypher3 = _interopRequireDefault(_NeoCypher2);
	
	var _NeoGraphItemsProducers2 = __webpack_require__(201);
	
	var _NeoGraphItemsProducers3 = _interopRequireDefault(_NeoGraphItemsProducers2);
	
	var _RandomizeNodePositions2 = __webpack_require__(466);
	
	var _RandomizeNodePositions3 = _interopRequireDefault(_RandomizeNodePositions2);
	
	var _SigmaEnableWebGL2 = __webpack_require__(470);
	
	var _SigmaEnableWebGL3 = _interopRequireDefault(_SigmaEnableWebGL2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sigma = _Sigma3.default;
	exports.EdgeShapes = _EdgeShapes3.default;
	exports.NodeShapes = _NodeShapes3.default;
	exports.LoadJSON = _LoadJSON3.default;
	exports.LoadGEXF = _LoadGEXF3.default;
	exports.Filter = _Filter3.default;
	exports.ForceAtlas2 = _ForceAtlas3.default;
	exports.RelativeSize = _RelativeSize3.default;
	exports.NOverlap = _NOverlap3.default;
	exports.NeoCypher = _NeoCypher3.default;
	exports.NeoGraphItemsProducers = _NeoGraphItemsProducers3.default;
	exports.RandomizeNodePositions = _RandomizeNodePositions3.default;
	exports.SigmaEnableWebGL = _SigmaEnableWebGL3.default;
	exports.default = _Sigma3.default;

/***/ },
/* 473 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_canvas_sigma_canvas_edges_curve_js__ = __webpack_require__(54);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_canvas_sigma_canvas_edges_curve_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_canvas_sigma_canvas_edges_curve_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_canvas_sigma_canvas_edges_arrow_js__ = __webpack_require__(53);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_canvas_sigma_canvas_edges_arrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_canvas_sigma_canvas_edges_arrow_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_canvas_sigma_canvas_edges_curvedArrow_js__ = __webpack_require__(55);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_canvas_sigma_canvas_edges_curvedArrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_canvas_sigma_canvas_edges_curvedArrow_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curve_js__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curve_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curve_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_arrow_js__ = __webpack_require__(49);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_arrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_arrow_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curvedArrow_js__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curvedArrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_canvas_sigma_canvas_edgehovers_curvedArrow_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dashed_js__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dashed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dashed_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dotted_js__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dotted_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_dotted_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_parallel_js__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_parallel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_parallel_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_tapered_js__ = __webpack_require__(24);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_tapered_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edgehovers_tapered_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dashed_js__ = __webpack_require__(25);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dashed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dashed_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dotted_js__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dotted_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_dotted_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_parallel_js__ = __webpack_require__(27);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_parallel_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_parallel_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_tapered_js__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_tapered_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_sigma_react_plugins_sigma_renderers_customEdgeShapes_sigma_canvas_edges_tapered_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_def_js__ = __webpack_require__(33);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curve_js__ = __webpack_require__(31);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curve_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curve_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curvedArrow_js__ = __webpack_require__(32);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curvedArrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sigma_react_plugins_sigma_renderers_edgeLabels_sigma_canvas_edges_labels_curvedArrow_js__);
	//base library
	
	
	
	
	
	
	//plugins
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.dashed =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');
	
	    context.save();
	
	    context.setLineDash([8,3]);
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.dotted =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');
	
	    context.save();
	
	    context.setLineDash([2]);
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 23:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.parallel =
	    function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        c,
	        d,
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');
	
	    // Intersection points of the source node circle:
	    c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);
	
	    // Intersection points of the target node circle:
	    d = sigma.utils.getCircleIntersection(tX, tY, size, sX, sY, dist);
	
	    context.save();
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(c.xi, c.yi);
	    context.lineTo(d.xi_prime, d.yi_prime);
	    context.closePath();
	    context.stroke();
	
	    context.beginPath();
	    context.moveTo(c.xi_prime, c.yi_prime);
	    context.lineTo(d.xi, d.yi);
	    context.closePath();
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 24:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.tapered =
	    function(edge, source, target, context, settings) {
	    // The goal is to draw a triangle where the target node is a point of
	    // the triangle, and the two other points are the intersection of the
	    // source circle and the circle (target, distance(source, target)).
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        prefix = settings('prefix') || '',
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	    size *= settings('edgeHoverSizeRatio');
	
	    // Intersection points:
	    var c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);
	
	    context.save();
	
	    // Turn transparency on:
	    context.globalAlpha = 0.65;
	
	    // Draw the triangle:
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(tX, tY);
	    context.lineTo(c.xi, c.yi);
	    context.lineTo(c.xi_prime, c.yi_prime);
	    context.closePath();
	    context.fill();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 25:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This method renders the edge as a dashed line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.dashed = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.save();
	
	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }
	
	    context.setLineDash([8,3]);
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 26:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This method renders the edge as a dotted line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.dotted = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor');
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.save();
	
	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }
	
	    context.setLineDash([2]);
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(
	      source[prefix + 'x'],
	      source[prefix + 'y']
	    );
	    context.lineTo(
	      target[prefix + 'x'],
	      target[prefix + 'y']
	    );
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 27:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This method renders the edge as two parallel lines.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.parallel = function(edge, source, target, context, settings) {
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        c,
	        d,
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    // Intersection points of the source node circle:
	    c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);
	
	    // Intersection points of the target node circle:
	    d = sigma.utils.getCircleIntersection(tX, tY, size, sX, sY, dist);
	
	    context.save();
	
	    if (edge.active) {
	      context.strokeStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.strokeStyle = color;
	    }
	
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(c.xi, c.yi);
	    context.lineTo(d.xi_prime, d.yi_prime);
	    context.closePath();
	    context.stroke();
	
	    context.beginPath();
	    context.moveTo(c.xi_prime, c.yi_prime);
	    context.lineTo(d.xi, d.yi);
	    context.closePath();
	    context.stroke();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 28:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This method renders the edge as a tapered line.
	   * Danny Holten, Petra Isenberg, Jean-Daniel Fekete, and J. Van Wijk (2010)
	   * Performance Evaluation of Tapered, Curved, and Animated Directed-Edge
	   * Representations in Node-Link Graphs. Research Report, Sep 2010.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.tapered = function(edge, source, target, context, settings) {
	    // The goal is to draw a triangle where the target node is a point of
	    // the triangle, and the two other points are the intersection of the
	    // source circle and the circle (target, distance(source, target)).
	    var color = edge.active ?
	          edge.active_color || settings('defaultEdgeActiveColor') :
	          edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        prefix = settings('prefix') || '',
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        dist = sigma.utils.getDistance(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    // Intersection points:
	    var c = sigma.utils.getCircleIntersection(sX, sY, size, tX, tY, dist);
	
	    context.save();
	
	    if (edge.active) {
	      context.fillStyle = settings('edgeActiveColor') === 'edge' ?
	        (color || defaultEdgeColor) :
	        settings('defaultEdgeActiveColor');
	    }
	    else {
	      context.fillStyle = color;
	    }
	
	    // Turn transparency on:
	    context.globalAlpha = 0.65;
	
	    // Draw the triangle:
	    context.beginPath();
	    context.moveTo(tX, tY);
	    context.lineTo(c.xi, c.yi);
	    context.lineTo(c.xi_prime, c.yi_prime);
	    context.closePath();
	    context.fill();
	
	    context.restore();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.edges.labels');
	
	  /**
	   * This label renderer will just display the label on the curve of the edge.
	   * The label is rendered at half distance of the edge extremities, and is
	   * always oriented from left to right on the top side of the curve.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.labels.curve =
	    function(edge, source, target, context, settings) {
	    if (typeof edge.label !== 'string')
	      return;
	
	    var prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1;
	
	    if (size < settings('edgeLabelThreshold'))
	      return;
	
	    var fontSize,
	        sSize = source[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        dX = tX - sX,
	        dY = tY - sY,
	        sign = (sX < tX) ? 1 : -1,
	        cp = {},
	        c,
	        angle,
	        t = 0.5;  //length of the curve
	
	    if (source.id === target.id) {
	      cp = sigma.utils.getSelfLoopControlPoints(sX, sY, sSize);
	      c = sigma.utils.getPointOnBezierCurve(
	        t, sX, sY, tX, tY, cp.x1, cp.y1, cp.x2, cp.y2
	      );
	      angle = Math.atan2(1, 1); // 45°
	    } else {
	      cp = sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);
	      c = sigma.utils.getPointOnQuadraticCurve(t, sX, sY, tX, tY, cp.x, cp.y);
	      angle = Math.atan2(dY * sign, dX * sign);
	    }
	
	    // The font size is sublineraly proportional to the edge size, in order to
	    // avoid very large labels on screen.
	    // This is achieved by f(x) = x * x^(-1/ a), where 'x' is the size and 'a'
	    // is the edgeLabelSizePowRatio. Notice that f(1) = 1.
	    // The final form is:
	    // f'(x) = b * x * x^(-1 / a), thus f'(1) = b. Application:
	    // fontSize = defaultEdgeLabelSize if edgeLabelSizePowRatio = 1
	    fontSize = (settings('edgeLabelSize') === 'fixed') ?
	      settings('defaultEdgeLabelSize') :
	      settings('defaultEdgeLabelSize') *
	      size *
	      Math.pow(size, -1 / settings('edgeLabelSizePowRatio'));
	
	    context.save();
	
	    
	    if (edge.active) {
	      context.font = [
	        settings('activeFontStyle'),
	        fontSize + 'px',
	        settings('activeFont') || settings('font')
	      ].join(' ');
	
	      context.fillStyle =
	        settings('edgeActiveColor') === 'edge' ?
	        (edge.active_color || settings('defaultEdgeActiveColor')) :
	        settings('defaultEdgeLabelActiveColor');
	    }
	    else {
	      context.font = [
	        settings('fontStyle'),
	        fontSize + 'px',
	        settings('font')
	      ].join(' ');
	
	      context.fillStyle =
	        (settings('edgeLabelColor') === 'edge') ?
	        (edge.color || settings('defaultEdgeColor')) :
	        settings('defaultEdgeLabelColor');
	    }
	
	    context.textAlign = 'center';
	    context.textBaseline = 'alphabetic';
	
	    context.translate(c.x, c.y);
	    context.rotate(angle);
	    context.fillText(
	      edge.label,
	      0,
	      (-size / 2) - 3
	    );
	
	    context.restore();
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 32:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.edges.labels');
	
	  /**
	   * This label renderer will just display the label on the curve of the edge.
	   * The label is rendered at half distance of the edge extremities, and is
	   * always oriented from left to right on the top side of the curve.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.labels.curvedArrow =
	    function(edge, source, target, context, settings) {
	    sigma.canvas.edges.labels.curve(edge, source, target, context, settings);
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 33:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.canvas.edges.labels');
	
	  /**
	   * This label renderer will just display the label on the line of the edge.
	   * The label is rendered at half distance of the edge extremities, and is
	   * always oriented from left to right on the top side of the line.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.labels.def =
	    function(edge, source, target, context, settings) {
	    if (typeof edge.label !== 'string' || source == target)
	      return;
	
	    var prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1;
	
	    if (size < settings('edgeLabelThreshold'))
	      return;
	
	    if (0 === settings('edgeLabelSizePowRatio'))
	      throw '"edgeLabelSizePowRatio" must not be 0.';
	
	    var fontSize,
	        x = (source[prefix + 'x'] + target[prefix + 'x']) / 2,
	        y = (source[prefix + 'y'] + target[prefix + 'y']) / 2,
	        dX = target[prefix + 'x'] - source[prefix + 'x'],
	        dY = target[prefix + 'y'] - source[prefix + 'y'],
	        sign = (source[prefix + 'x'] < target[prefix + 'x']) ? 1 : -1,
	        angle = Math.atan2(dY * sign, dX * sign);
	
	    // The font size is sublineraly proportional to the edge size, in order to
	    // avoid very large labels on screen.
	    // This is achieved by f(x) = x * x^(-1/ a), where 'x' is the size and 'a'
	    // is the edgeLabelSizePowRatio. Notice that f(1) = 1.
	    // The final form is:
	    // f'(x) = b * x * x^(-1 / a), thus f'(1) = b. Application:
	    // fontSize = defaultEdgeLabelSize if edgeLabelSizePowRatio = 1
	    fontSize = (settings('edgeLabelSize') === 'fixed') ?
	      settings('defaultEdgeLabelSize') :
	      settings('defaultEdgeLabelSize') *
	      size *
	      Math.pow(size, -1 / settings('edgeLabelSizePowRatio'));
	
	    context.save();
	
	    if (edge.active) {
	      context.font = [
	        settings('activeFontStyle'),
	        fontSize + 'px',
	        settings('activeFont') || settings('font')
	      ].join(' ');
	
	      context.fillStyle =
	        settings('edgeActiveColor') === 'edge' ?
	        (edge.active_color || settings('defaultEdgeActiveColor')) :
	        settings('defaultEdgeLabelActiveColor');
	    }
	    else {
	      context.font = [
	        settings('fontStyle'),
	        fontSize + 'px',
	        settings('font')
	      ].join(' ');
	
	      context.fillStyle =
	        (settings('edgeLabelColor') === 'edge') ?
	        (edge.color || settings('defaultEdgeColor')) :
	        settings('defaultEdgeLabelColor');
	    }
	
	    context.textAlign = 'center';
	    context.textBaseline = 'alphabetic';
	
	    context.translate(x, y);
	    context.rotate(angle);
	    context.fillText(
	      edge.label,
	      0,
	      (-size / 2) - 3
	    );
	
	    context.restore();
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 49:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.arrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];
	
	    size = (edge.hover) ?
	      settings('edgeHoverSizeRatio') * size : size;
	    var aSize = size * 2.5,
	        d = Math.sqrt(Math.pow(tX - sX, 2) + Math.pow(tY - sY, 2)),
	        aX = sX + (tX - sX) * (d - aSize - tSize) / d,
	        aY = sY + (tY - sY) * (d - aSize - tSize) / d,
	        vX = (tX - sX) * aSize / d,
	        vY = (tY - sY) * aSize / d;
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    context.lineTo(
	      aX,
	      aY
	    );
	    context.stroke();
	
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 50:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.curve =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = settings('edgeHoverSizeRatio') * (edge[prefix + 'size'] || 1),
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        sSize = source[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];
	
	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, sSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x1, cp.y1, cp.x2, cp.y2, tX, tY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, tX, tY);
	    }
	    context.stroke();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 51:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edgehovers');
	
	  /**
	   * This hover renderer will display the edge with a different color or size.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edgehovers.curvedArrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        size = settings('edgeHoverSizeRatio') * (edge[prefix + 'size'] || 1),
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        d,
	        aSize,
	        aX,
	        aY,
	        vX,
	        vY;
	
	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, tSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);
	
	    if (source.id === target.id) {
	      d = Math.sqrt(Math.pow(tX - cp.x1, 2) + Math.pow(tY - cp.y1, 2));
	      aSize = size * 2.5;
	      aX = cp.x1 + (tX - cp.x1) * (d - aSize - tSize) / d;
	      aY = cp.y1 + (tY - cp.y1) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x1) * aSize / d;
	      vY = (tY - cp.y1) * aSize / d;
	    }
	    else {
	      d = Math.sqrt(Math.pow(tX - cp.x, 2) + Math.pow(tY - cp.y, 2));
	      aSize = size * 2.5;
	      aX = cp.x + (tX - cp.x) * (d - aSize - tSize) / d;
	      aY = cp.y + (tY - cp.y) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x) * aSize / d;
	      vY = (tY - cp.y) * aSize / d;
	    }
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    if (settings('edgeHoverColor') === 'edge') {
	      color = edge.hover_color || color;
	    } else {
	      color = edge.hover_color || settings('defaultEdgeHoverColor') || color;
	    }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x2, cp.y2, cp.x1, cp.y1, aX, aY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, aX, aY);
	    }
	    context.stroke();
	
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 53:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This edge renderer will display edges as arrows going from the source node
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.arrow = function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        aSize = Math.max(size * 2.5, settings('minArrowSize')),
	        d = Math.sqrt(Math.pow(tX - sX, 2) + Math.pow(tY - sY, 2)),
	        aX = sX + (tX - sX) * (d - aSize - tSize) / d,
	        aY = sY + (tY - sY) * (d - aSize - tSize) / d,
	        vX = (tX - sX) * aSize / d,
	        vY = (tY - sY) * aSize / d;
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    context.lineTo(
	      aX,
	      aY
	    );
	    context.stroke();
	
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 54:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This edge renderer will display edges as curves.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.curve = function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        size = edge[prefix + 'size'] || 1,
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        sSize = source[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'];
	
	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, sSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x1, cp.y1, cp.x2, cp.y2, tX, tY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, tX, tY);
	    }
	    context.stroke();
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 55:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.canvas.edges');
	
	  /**
	   * This edge renderer will display edges as curves with arrow heading.
	   *
	   * @param  {object}                   edge         The edge object.
	   * @param  {object}                   source node  The edge source node.
	   * @param  {object}                   target node  The edge target node.
	   * @param  {CanvasRenderingContext2D} context      The canvas context.
	   * @param  {configurable}             settings     The settings function.
	   */
	  sigma.canvas.edges.curvedArrow =
	    function(edge, source, target, context, settings) {
	    var color = edge.color,
	        prefix = settings('prefix') || '',
	        edgeColor = settings('edgeColor'),
	        defaultNodeColor = settings('defaultNodeColor'),
	        defaultEdgeColor = settings('defaultEdgeColor'),
	        cp = {},
	        size = edge[prefix + 'size'] || 1,
	        tSize = target[prefix + 'size'],
	        sX = source[prefix + 'x'],
	        sY = source[prefix + 'y'],
	        tX = target[prefix + 'x'],
	        tY = target[prefix + 'y'],
	        aSize = Math.max(size * 2.5, settings('minArrowSize')),
	        d,
	        aX,
	        aY,
	        vX,
	        vY;
	
	    cp = (source.id === target.id) ?
	      sigma.utils.getSelfLoopControlPoints(sX, sY, tSize) :
	      sigma.utils.getQuadraticControlPoint(sX, sY, tX, tY);
	
	    if (source.id === target.id) {
	      d = Math.sqrt(Math.pow(tX - cp.x1, 2) + Math.pow(tY - cp.y1, 2));
	      aX = cp.x1 + (tX - cp.x1) * (d - aSize - tSize) / d;
	      aY = cp.y1 + (tY - cp.y1) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x1) * aSize / d;
	      vY = (tY - cp.y1) * aSize / d;
	    }
	    else {
	      d = Math.sqrt(Math.pow(tX - cp.x, 2) + Math.pow(tY - cp.y, 2));
	      aX = cp.x + (tX - cp.x) * (d - aSize - tSize) / d;
	      aY = cp.y + (tY - cp.y) * (d - aSize - tSize) / d;
	      vX = (tX - cp.x) * aSize / d;
	      vY = (tY - cp.y) * aSize / d;
	    }
	
	    if (!color)
	      switch (edgeColor) {
	        case 'source':
	          color = source.color || defaultNodeColor;
	          break;
	        case 'target':
	          color = target.color || defaultNodeColor;
	          break;
	        default:
	          color = defaultEdgeColor;
	          break;
	      }
	
	    context.strokeStyle = color;
	    context.lineWidth = size;
	    context.beginPath();
	    context.moveTo(sX, sY);
	    if (source.id === target.id) {
	      context.bezierCurveTo(cp.x2, cp.y2, cp.x1, cp.y1, aX, aY);
	    } else {
	      context.quadraticCurveTo(cp.x, cp.y, aX, aY);
	    }
	    context.stroke();
	
	    context.fillStyle = color;
	    context.beginPath();
	    context.moveTo(aX + vX, aY + vY);
	    context.lineTo(aX + vY * 0.6, aY - vX * 0.6);
	    context.lineTo(aX - vY * 0.6, aY + vX * 0.6);
	    context.lineTo(aX + vX, aY + vY);
	    context.closePath();
	    context.fill();
	  };
	})();
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 474 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 118);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 118:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw new Error('sigma is not declared');
	
	  // Initialize package:
	  sigma.utils.pkg('sigma.layout.noverlap');
	
	  /**
	   * Noverlap Layout
	   * ===============================
	   *
	   * Author: @apitts / Andrew Pitts
	   * Algorithm: @jacomyma / Mathieu Jacomy (originally contributed to Gephi and ported to sigma.js under the MIT license by @andpitts with permission)
	   * Acknowledgement: @sheyman / Sébastien Heymann (some inspiration has been taken from other MIT licensed layout algorithms authored by @sheyman)
	   * Version: 0.1
	   */
	
	  var settings = {
	    speed: 3,
	    scaleNodes: 1.2,
	    nodeMargin: 5.0,
	    gridSize: 20,
	    permittedExpansion: 1.1,
	    rendererIndex: 0,
	    maxIterations: 500
	  };
	
	  var _instance = {};
	
	  /**
	   * Event emitter Object
	   * ------------------
	   */
	  var _eventEmitter = {};
	
	   /**
	   * Noverlap Object
	   * ------------------
	   */
	  function Noverlap() {
	    var self = this;
	
	    this.init = function (sigInst, options) {
	      options = options || {};
	
	      // Properties
	      this.sigInst = sigInst;
	      this.config = sigma.utils.extend(options, settings);
	      this.easing = options.easing;
	      this.duration = options.duration;
	
	      if (options.nodes) {
	        this.nodes = options.nodes;
	        delete options.nodes;
	      }
	
	      if (!sigma.plugins || typeof sigma.plugins.animate === 'undefined') {
	        throw new Error('sigma.plugins.animate is not declared');
	      }
	
	      // State
	      this.running = false;
	    };
	
	    /**
	     * Single layout iteration.
	     */
	    this.atomicGo = function () {
	      if (!this.running || this.iterCount < 1) return false;
	
	      var nodes = this.nodes || this.sigInst.graph.nodes(),
	          nodesCount = nodes.length,
	          i,
	          n,
	          n1,
	          n2,
	          xmin = Infinity,
	          xmax = -Infinity,
	          ymin = Infinity,
	          ymax = -Infinity,
	          xwidth,
	          yheight,
	          xcenter,
	          ycenter,
	          grid,
	          row,
	          col,
	          minXBox,
	          maxXBox,
	          minYBox,
	          maxYBox,
	          adjacentNodes,
	          subRow,
	          subCol,
	          nxmin,
	          nxmax,
	          nymin,
	          nymax;
	
	      this.iterCount--;
	      this.running = false;
	
	      for (i=0; i < nodesCount; i++) {
	        n = nodes[i];
	        n.dn.dx = 0;
	        n.dn.dy = 0;
	
	        //Find the min and max for both x and y across all nodes
	        xmin = Math.min(xmin, n.dn_x - (n.dn_size*self.config.scaleNodes + self.config.nodeMargin) );
	        xmax = Math.max(xmax, n.dn_x + (n.dn_size*self.config.scaleNodes + self.config.nodeMargin) );
	        ymin = Math.min(ymin, n.dn_y - (n.dn_size*self.config.scaleNodes + self.config.nodeMargin) );
	        ymax = Math.max(ymax, n.dn_y + (n.dn_size*self.config.scaleNodes + self.config.nodeMargin) );
	
	      }
	
	      xwidth = xmax - xmin;
	      yheight = ymax - ymin;
	      xcenter = (xmin + xmax) / 2;
	      ycenter = (ymin + ymax) / 2;
	      xmin = xcenter - self.config.permittedExpansion*xwidth / 2;
	      xmax = xcenter + self.config.permittedExpansion*xwidth / 2;
	      ymin = ycenter - self.config.permittedExpansion*yheight / 2;
	      ymax = ycenter + self.config.permittedExpansion*yheight / 2;
	
	      grid = {}; //An object of objects where grid[row][col] is an array of node ids representing nodes that fall in that grid. Nodes can fall in more than one grid
	
	      for(row = 0; row < self.config.gridSize; row++) {
	        grid[row] = {};
	        for(col = 0; col < self.config.gridSize; col++) {
	          grid[row][col] = [];
	        }
	      }
	
	      //Place nodes in grid
	      for (i=0; i < nodesCount; i++) {
	        n = nodes[i];
	
	        nxmin = n.dn_x - (n.dn_size*self.config.scaleNodes + self.config.nodeMargin);
	        nxmax = n.dn_x + (n.dn_size*self.config.scaleNodes + self.config.nodeMargin);
	        nymin = n.dn_y - (n.dn_size*self.config.scaleNodes + self.config.nodeMargin);
	        nymax = n.dn_y + (n.dn_size*self.config.scaleNodes + self.config.nodeMargin);
	
	        minXBox = Math.floor(self.config.gridSize* (nxmin - xmin) / (xmax - xmin) );
	        maxXBox = Math.floor(self.config.gridSize* (nxmax - xmin) / (xmax - xmin) );
	        minYBox = Math.floor(self.config.gridSize* (nymin - ymin) / (ymax - ymin) );
	        maxYBox = Math.floor(self.config.gridSize* (nymax - ymin) / (ymax - ymin) );
	        for(col = minXBox; col <= maxXBox; col++) {
	          for(row = minYBox; row <= maxYBox; row++) {
	            grid[row][col].push(n.id);
	          }
	        }
	      }
	
	
	      adjacentNodes = {}; //An object that stores the node ids of adjacent nodes (either in same grid box or adjacent grid box) for all nodes
	
	      for(row = 0; row < self.config.gridSize; row++) {
	        for(col = 0; col < self.config.gridSize; col++) {
	          grid[row][col].forEach(function(nodeId) {
	            if(!adjacentNodes[nodeId]) {
	              adjacentNodes[nodeId] = [];
	            }
	            for(subRow = Math.max(0, row - 1); subRow <= Math.min(row + 1, self.config.gridSize - 1); subRow++) {
	              for(subCol = Math.max(0, col - 1); subCol <= Math.min(col + 1,  self.config.gridSize - 1); subCol++) {
	                grid[subRow][subCol].forEach(function(subNodeId) {
	                  if(subNodeId !== nodeId && adjacentNodes[nodeId].indexOf(subNodeId) === -1) {
	                    adjacentNodes[nodeId].push(subNodeId);
	                  }
	                });
	              }
	            }
	          });
	        }
	      }
	
	      //If two nodes overlap then repulse them
	      for (i=0; i < nodesCount; i++) {
	        n1 = nodes[i];
	        adjacentNodes[n1.id].forEach(function(nodeId) {
	          var n2 = self.sigInst.graph.nodes(nodeId);
	          var xDist = n2.dn_x - n1.dn_x;
	          var yDist = n2.dn_y - n1.dn_y;
	          var dist = Math.sqrt(xDist*xDist + yDist*yDist);
	          var collision = (dist < ((n1.dn_size*self.config.scaleNodes + self.config.nodeMargin) + (n2.dn_size*self.config.scaleNodes + self.config.nodeMargin)));
	          if(collision) {
	            self.running = true;
	            if(dist > 0) {
	              n2.dn.dx += xDist / dist * (1 + n1.dn_size);
	              n2.dn.dy += yDist / dist * (1 + n1.dn_size);
	            } else {
	              n2.dn.dx += xwidth * 0.01 * (0.5 - Math.random());
	              n2.dn.dy += yheight * 0.01 * (0.5 - Math.random());
	            }
	          }
	        });
	      }
	
	      for (i=0; i < nodesCount; i++) {
	        n = nodes[i];
	        if(!n.fixed) {
	          n.dn_x = n.dn_x + n.dn.dx * 0.1 * self.config.speed;
	          n.dn_y = n.dn_y + n.dn.dy * 0.1 * self.config.speed;
	        }
	      }
	
	      if(this.running && this.iterCount < 1) {
	        this.running = false;
	      }
	
	      return this.running;
	    };
	
	    this.go = function () {
	      this.iterCount = this.config.maxIterations;
	
	      while (this.running) {
	        this.atomicGo();
	      };
	
	      this.stop();
	    };
	
	    this.start = function() {
	      if (this.running) return;
	
	      var nodes = this.sigInst.graph.nodes();
	
	      var prefix = this.sigInst.renderers[self.config.rendererIndex].options.prefix;
	
	      this.running = true;
	
	      // Init nodes
	      for (var i = 0; i < nodes.length; i++) {
	        nodes[i].dn_x = nodes[i][prefix + 'x'];
	        nodes[i].dn_y = nodes[i][prefix + 'y'];
	        nodes[i].dn_size = nodes[i][prefix + 'size'];
	        nodes[i].dn = {
	          dx: 0,
	          dy: 0
	        };
	      }
	      _eventEmitter[self.sigInst.id].dispatchEvent('start');
	      this.go();
	    };
	
	    this.stop = function() {
	      var nodes = this.sigInst.graph.nodes();
	
	      this.running = false;
	
	      if (this.easing) {
	        _eventEmitter[self.sigInst.id].dispatchEvent('interpolate');
	        sigma.plugins.animate(
	          self.sigInst,
	          {
	            x: 'dn_x',
	            y: 'dn_y'
	          },
	          {
	            easing: self.easing,
	            onComplete: function() {
	              self.sigInst.refresh();
	              for (var i = 0; i < nodes.length; i++) {
	                nodes[i].dn = null;
	                nodes[i].dn_x = null;
	                nodes[i].dn_y = null;
	              }
	              _eventEmitter[self.sigInst.id].dispatchEvent('stop');
	            },
	            duration: self.duration
	          }
	        );
	      }
	      else {
	        // Apply changes
	        for (var i = 0; i < nodes.length; i++) {
	          nodes[i].x = nodes[i].dn_x;
	          nodes[i].y = nodes[i].dn_y;
	        }
	
	        this.sigInst.refresh();
	
	        for (var i = 0; i < nodes.length; i++) {
	          nodes[i].dn = null;
	          nodes[i].dn_x = null;
	          nodes[i].dn_y = null;
	        }
	        _eventEmitter[self.sigInst.id].dispatchEvent('stop');
	      }
	    };
	
	    this.kill = function() {
	      this.sigInst = null;
	      this.config = null;
	      this.easing = null;
	    };
	  };
	
	  /**
	   * Interface
	   * ----------
	   */
	
	  /**
	   * Configure the layout algorithm.
	
	   * Recognized options:
	   * **********************
	   * Here is the exhaustive list of every accepted parameter in the settings
	   * object:
	   *
	   *   {?number}            speed               A larger value increases the convergence speed at the cost of precision
	   *   {?number}            scaleNodes          The ratio to scale nodes by - a larger ratio will lead to more space around larger nodes
	   *   {?number}            nodeMargin          A fixed margin to apply around nodes regardless of size
	   *   {?number}            maxIterations       The maximum number of iterations to perform before the layout completes.
	   *   {?integer}           gridSize            The number of rows and columns to use when partioning nodes into a grid for efficient computation
	   *   {?number}            permittedExpansion  A permitted expansion factor to the overall size of the network applied at each iteration
	   *   {?integer}           rendererIndex       The index of the renderer to use for node co-ordinates. Defaults to zero.
	   *   {?(function|string)} easing              Either the name of an easing in the sigma.utils.easings package or a function. If not specified, the
	   *                                            quadraticInOut easing from this package will be used instead.
	   *   {?number}            duration            The duration of the animation. If not specified, the "animationsTime" setting value of the sigma instance will be used instead.
	   *
	   *
	   * @param  {object} config  The optional configuration object.
	   *
	   * @return {sigma.classes.dispatcher} Returns an event emitter.
	   */
	  sigma.prototype.configNoverlap = function(config) {
	
	    var sigInst = this;
	
	    if (!config) throw new Error('Missing argument: "config"');
	
	    // Create instance if undefined
	    if (!_instance[sigInst.id]) {
	      _instance[sigInst.id] = new Noverlap();
	
	      _eventEmitter[sigInst.id] = {};
	      sigma.classes.dispatcher.extend(_eventEmitter[sigInst.id]);
	
	      // Binding on kill to clear the references
	      sigInst.bind('kill', function() {
	        _instance[sigInst.id].kill();
	        _instance[sigInst.id] = null;
	        _eventEmitter[sigInst.id] = null;
	      });
	    }
	
	    _instance[sigInst.id].init(sigInst, config);
	
	    return _eventEmitter[sigInst.id];
	  };
	
	  /**
	   * Start the layout algorithm. It will use the existing configuration if no
	   * new configuration is passed.
	
	   * Recognized options:
	   * **********************
	   * Here is the exhaustive list of every accepted parameter in the settings
	   * object
	   *
	   *   {?number}            speed               A larger value increases the convergence speed at the cost of precision
	   *   {?number}            scaleNodes          The ratio to scale nodes by - a larger ratio will lead to more space around larger nodes
	   *   {?number}            nodeMargin          A fixed margin to apply around nodes regardless of size
	   *   {?number}            maxIterations       The maximum number of iterations to perform before the layout completes.
	   *   {?integer}           gridSize            The number of rows and columns to use when partioning nodes into a grid for efficient computation
	   *   {?number}            permittedExpansion  A permitted expansion factor to the overall size of the network applied at each iteration
	   *   {?integer}           rendererIndex       The index of the renderer to use for node co-ordinates. Defaults to zero.
	   *   {?(function|string)} easing              Either the name of an easing in the sigma.utils.easings package or a function. If not specified, the
	   *                                            quadraticInOut easing from this package will be used instead.
	   *   {?number}            duration            The duration of the animation. If not specified, the "animationsTime" setting value of the sigma instance will be used instead.
	   *
	   *
	   *
	   * @param  {object} config  The optional configuration object.
	   *
	   * @return {sigma.classes.dispatcher} Returns an event emitter.
	   */
	
	  sigma.prototype.startNoverlap = function(config) {
	
	    var sigInst = this;
	
	    if (config) {
	      this.configNoverlap(sigInst, config);
	    }
	
	    _instance[sigInst.id].start();
	
	    return _eventEmitter[sigInst.id];
	  };
	
	
	  sigma.prototype.stopNoverlap = function() {
	    var sigInst = this;
	
	    if (_instance[sigInst.id]) {
	      _instance[sigInst.id].stop();
	    }
	  };
	
	  /**
	   * Returns true if the layout has started and is not completed.
	   *
	   * @return {boolean}
	   */
	  sigma.prototype.isNoverlapRunning = function() {
	
	    var sigInst = this;
	
	    return !!_instance[sigInst.id] && _instance[sigInst.id].running;
	  };
	
	}).call(this);
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 475 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 119);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 119:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function (undefined) {
	    'use strict';
	
	    if (typeof sigma === 'undefined')
	        throw 'sigma is not declared';
	
	    // Declare neo4j package
	    sigma.utils.pkg("sigma.neo4j");
	
	    // Initialize package:
	    sigma.utils.pkg('sigma.utils');
	
	
	    /**
	     * This function is an helper for the neo4j communication.
	     *
	     * @param   {string|object}     neo4j       The URL of neo4j server or a neo4j server object.
	     * @param   {string}            endpoint    Endpoint of the neo4j server
	     * @param   {string}            method      The calling method for the endpoint : 'GET' or 'POST'
	     * @param   {object|string}     data        Data that will be send to the server
	     * @param   {function}          callback    The callback function
	     */
	    sigma.neo4j.send = function(neo4j, endpoint, method, data, callback) {
	        var xhr = sigma.utils.xhr(),
	            url, user, password;
	
	        // if neo4j arg is not an object
	        url = neo4j;
	        if(typeof neo4j === 'object') {
	            url = neo4j.url;
	            user = neo4j.user;
	            password = neo4j.password;
	        }
	
	        if (!xhr)
	            throw 'XMLHttpRequest not supported, cannot load the file.';
	
	        // Construct the endpoint url
	        url += endpoint;
	
	        xhr.open(method, url, true);
	        if( user && password) {
	            xhr.setRequestHeader('Authorization', 'Basic ' + btoa(user + ':' + password));
	        }
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState === 4) {
	                // Call the callback if specified:
	                callback(JSON.parse(xhr.responseText));
	            }
	        };
	        xhr.send(data);
	    };
	
	    /**
	     * This function parse a neo4j cypher query result, and transform it into
	     * a sigma graph object.
	     *
	     * @param  {object}     result      The server response of a cypher query.
	     *
	     * @return A graph object
	     */
	    sigma.neo4j.cypher_parse = function(result, producers) {
	        var graph = { nodes: [], edges: [] },
	            nodesMap = {},
	            edgesMap = {},
	            key;
	
	        // Iteration on all result data
	        result.results[0].data.forEach(function (data) {
	
	            // iteration on graph for all node
	            data.graph.nodes.forEach(function (node) {
	
	                var sigmaNode = producers.node(node);
	
	                if (sigmaNode.id in nodesMap) {
	                    // do nothing
	                } else {
	                    nodesMap[sigmaNode.id] = sigmaNode;
	                }
	            });
	
	            // iteration on graph for all edges
	            data.graph.relationships.forEach(function (edge) {
	
	                var sigmaEdge = producers.edge(edge);
	
	                if (sigmaEdge.id in edgesMap) {
	                    // do nothing
	                } else {
	                    edgesMap[sigmaEdge.id] = sigmaEdge;
	                }
	            });
	
	        });
	
	        // construct sigma nodes
	        for (key in nodesMap) {
	            graph.nodes.push(nodesMap[key]);
	        }
	        // construct sigma nodes
	        for (key in edgesMap) {
	            graph.edges.push(edgesMap[key]);
	        }
	
	        return graph;
	    };
	
	
	    /**
	     * This function execute a cypher and create a new sigma instance or
	     * updates the graph of a given instance. It is possible to give a callback
	     * that will be executed at the end of the process.
	     *
	     * @param  {object|string}      neo4j       The URL of neo4j server or a neo4j server object.
	     * @param  {string}             cypher      The cypher query
	     * @param  {?object|?sigma}     sig         A sigma configuration object or a sigma instance.
	     * @param  {?function}          callback    Eventually a callback to execute after
	     *                                          having parsed the file. It will be called
	     *                                          with the related sigma instance as
	     *                                          parameter.
	     * @param  {?object}            producers   Factory object with node and/or edge producers functions
	     *                                          By default sigma.neo4j produces black nodes and gray edges.
	     *                                          producers.node(node) takes neo4j node as input,
	     *                                          should output sigma node properties
	     *                                          producers.edge(edge) takes neo4j node as input,
	     *                                          should output sigma edge properties
	     */
	    sigma.neo4j.cypher = function (neo4j, cypher, sig, callback, producers) {
	        var endpoint = '/db/data/transaction/commit',
	            data, cypherCallback;
	
	        if(!producers) producers = sigma.neo4j.defaultProducers;
	
	        // Data that will be send to the server
	        data = JSON.stringify({
	            "statements": [
	                {
	                    "statement": cypher,
	                    "resultDataContents": ["graph"],
	                    "includeStats": false
	                }
	            ]
	        });
	
	        // Callback method after server response
	        cypherCallback = function (callback) {
	
	            return function (response) {
	
	                var graph = { nodes: [], edges: [] };
	
	                graph = sigma.neo4j.cypher_parse(response, producers);
	
	                // Update the instance's graph:
	                if (sig instanceof sigma) {
	                    sig.graph.clear();
	                    sig.graph.read(graph);
	
	                    // ...or instantiate sigma if needed:
	                } else if (typeof sig === 'object') {
	                    sig = new sigma(sig);
	                    sig.graph.read(graph);
	                    sig.refresh();
	
	                    // ...or it's finally the callback:
	                } else if (typeof sig === 'function') {
	                    callback = sig;
	                    sig = null;
	                }
	
	                // Call the callback if specified:
	                if (callback)
	                    callback(sig || graph);
	            };
	        };
	
	        // Let's call neo4j
	        sigma.neo4j.send(neo4j, endpoint, 'POST', data, cypherCallback(callback));
	    };
	
	    /**
	     * This function call neo4j to get all labels of the graph.
	     *
	     * @param  {string}       neo4j      The URL of neo4j server or an object with the url, user & password.
	     * @param  {function}     callback   The callback function
	     *
	     * @return An array of label
	     */
	    sigma.neo4j.getLabels = function(neo4j, callback) {
	        sigma.neo4j.send(neo4j, '/db/data/labels', 'GET', null, callback);
	    };
	
	    /**
	     * This function parse a neo4j cypher query result.
	     *
	     * @param  {string}       neo4j      The URL of neo4j server or an object with the url, user & password.
	     * @param  {function}     callback   The callback function
	     *
	     * @return An array of relationship type
	     */
	    sigma.neo4j.getTypes = function(neo4j, callback) {
	        sigma.neo4j.send(neo4j, '/db/data/relationship/types', 'GET', null, callback);
	    };
	
	    /**
	     * This object consist of sigma node and endge producers based on neo4j data node.
	     *
	     * @param  {object}       node   node(neo4j_node): sigma_node, where  neo4j_node = {id, label, properties}
	     * @param  {object}       edge   edge(neo4j_edge): sigma_edge, where  neo4j_edge = {id, type, startNode, endNode, properties}
	     *
	     * @return Sigma data object for node or edge
	     */
	    sigma.neo4j.defaultProducers = {
	        node: function(node) {
	            return {
	                id : node.id,
	                label : node.id,
	                x : Math.random(),
	                y : Math.random(),
	                size : 1,
	                color : '#666666',
	                neo4j_labels : node.labels,
	                neo4j_data : node.properties
	            }
	        },
	        edge: function(edge) {
	            return {
	                id : edge.id,
	                label : edge.type,
	                source : edge.startNode,
	                target : edge.endNode,
	                color : '#7D7C8E',
	                neo4j_type : edge.type,
	                neo4j_data : edge.properties
	            }
	        }
	    }
	
	}).call(this);
	
	    
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 476 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 116);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_plugins_sigma_renderers_customShapes_shape_library_js__ = __webpack_require__(29);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_plugins_sigma_renderers_customShapes_shape_library_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sigma_react_plugins_sigma_renderers_customShapes_shape_library_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_plugins_sigma_renderers_customShapes_sigma_renderers_customShapes_js__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_plugins_sigma_renderers_customShapes_sigma_renderers_customShapes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sigma_react_plugins_sigma_renderers_customShapes_sigma_renderers_customShapes_js__);
	
	
	
	/***/ }),
	
	/***/ 29:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  var shapes = [];
	  var register = function(name,drawShape,drawBorder) {
	    shapes.push({
	      'name': name,
	      'drawShape': drawShape,
	      'drawBorder': drawBorder
	    });
	  }
	
	  var enumerateShapes = function() {
	    return shapes;
	  }
	
	  /**
	   * For the standard closed shapes - the shape fill and border are drawn the
	   * same, with some minor differences for fill and border. To facilitate this we
	   * create the generic draw functions, that take a shape drawing func and
	   * return a shape-renderer/border-renderer
	   * ----------
	   */
	  var genericDrawShape = function(shapeFunc) {
	    return function(node,x,y,size,color,context) {
	      context.fillStyle = color;
	      context.beginPath();
	      shapeFunc(node,x,y,size,context);
	      context.closePath();
	      context.fill();
	    };
	  }
	
	  var genericDrawBorder = function(shapeFunc) {
	    return function(node,x,y,size,color,context) {
	      context.strokeStyle = color;
	      context.lineWidth = size / 5;
	      context.beginPath();
	      shapeFunc(node,x,y,size,context);
	      context.closePath();
	      context.stroke();
	    };
	  }
	
	  /**
	   * We now proced to use the generics to define our standard shape/border
	   * drawers: square, diamond, equilateral (polygon), and star
	   * ----------
	   */
	  var drawSquare = function(node,x,y,size,context) {
	    var rotate = Math.PI*45/180; // 45 deg rotation of a diamond shape
	    context.moveTo(x+size*Math.sin(rotate), y-size*Math.cos(rotate)); // first point on outer radius, dwangle 'rotate'
	    for(var i=1; i<4; i++) {
	      context.lineTo(x+Math.sin(rotate+2*Math.PI*i/4)*size, y-Math.cos(rotate+2*Math.PI*i/4)*size);
	    }
	  }
	  register("square",genericDrawShape(drawSquare),genericDrawBorder(drawSquare));
	
	  var drawCircle = function(node,x,y,size,context) {
	    context.arc(x,y,size,0,Math.PI*2,true);
	  }
	  register("circle",genericDrawShape(drawCircle),genericDrawBorder(drawCircle));
	
	  var drawDiamond = function(node,x,y,size,context) {
	    context.moveTo(x-size, y);
	    context.lineTo(x, y-size);
	    context.lineTo(x+size, y);
	    context.lineTo(x, y+size);
	  }
	  register("diamond",genericDrawShape(drawDiamond),genericDrawBorder(drawDiamond));
	
	  var drawCross = function(node,x,y,size,context) {
	    var lineWeight = (node.cross && node.cross.lineWeight) || 5;
	    context.moveTo(x-size, y-lineWeight);
	    context.lineTo(x-size, y+lineWeight);
	    context.lineTo(x-lineWeight, y+lineWeight);
	    context.lineTo(x-lineWeight, y+size);
	    context.lineTo(x+lineWeight, y+size);
	    context.lineTo(x+lineWeight, y+lineWeight);
	    context.lineTo(x+size, y+lineWeight);
	    context.lineTo(x+size, y-lineWeight);
	    context.lineTo(x+lineWeight, y-lineWeight);
	    context.lineTo(x+lineWeight, y-size);
	    context.lineTo(x-lineWeight, y-size);
	    context.lineTo(x-lineWeight, y-lineWeight);
	  }
	  register("cross",genericDrawShape(drawCross),genericDrawBorder(drawCross));
	
	  var drawEquilateral = function(node,x,y,size,context) {
	    var pcount = (node.equilateral && node.equilateral.numPoints) || 5;
	    var rotate = ((node.equilateral && node.equilateral.rotate) || 0)*Math.PI/180;
	    var radius = size;
	    context.moveTo(x+radius*Math.sin(rotate), y-radius*Math.cos(rotate)); // first point on outer radius, angle 'rotate'
	    for(var i=1; i<pcount; i++) {
	      context.lineTo(x+Math.sin(rotate+2*Math.PI*i/pcount)*radius, y-Math.cos(rotate+2*Math.PI*i/pcount)*radius);
	    }
	  }
	  register("equilateral",genericDrawShape(drawEquilateral),genericDrawBorder(drawEquilateral));
	
	
	  var starShape = function(node,x,y,size,context) {
	    var pcount = (node.star && node.star.numPoints) || 5,
	        inRatio = (node.star && node.star.innerRatio) || 0.5,
	        outR = size,
	        inR = size*inRatio,
	        angleOffset = Math.PI/pcount;
	    context.moveTo(x, y-size); // first point on outer radius, top
	    for(var i=0; i<pcount; i++) {
	      context.lineTo(x+Math.sin(angleOffset+2*Math.PI*i/pcount)*inR,
	          y-Math.cos(angleOffset+2*Math.PI*i/pcount)*inR);
	      context.lineTo(x+Math.sin(2*Math.PI*(i+1)/pcount)*outR,
	          y-Math.cos(2*Math.PI*(i+1)/pcount)*outR);
	    }
	  }
	  register("star",genericDrawShape(starShape),genericDrawBorder(starShape));
	
	  /**
	   * An example of a non standard shape (pacman). Here we WILL NOT use the
	   * genericDraw functions, but rather register a full custom node renderer for
	   * fill, and skip the border renderer which is irrelevant for this shape
	   * ----------
	   */
	  var drawPacman = function(node,x,y,size,color,context) {
	    context.fillStyle = 'yellow';
	    context.beginPath();
	    context.arc(x,y,size,1.25*Math.PI,0,false);
	    context.arc(x,y,size,0,0.75*Math.PI,false);
	    context.lineTo(x,y);
	    context.closePath();
	    context.fill();
	
	    context.fillStyle = 'white';
	    context.strokeStyle = 'black';
	    context.beginPath();
	    context.arc(x+size/3,y-size/3,size/4,0,2*Math.PI,false);
	    context.closePath();
	    context.fill();
	    context.stroke();
	
	    context.fillStyle = 'black';
	    context.beginPath();
	    context.arc(x+4*size/9,y-size/3,size/8,0,2*Math.PI,false);
	    context.closePath();
	    context.fill();
	  }
	  register("pacman",drawPacman,null);
	
	  /**
	   * Exporting
	   * ----------
	   */
	  this.ShapeLibrary = {
	
	    // Functions
	    enumerate: enumerateShapes,
	    // add: addShape,
	
	    // Version
	    version: '0.1'
	  };
	
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 30:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  if (typeof ShapeLibrary === 'undefined')
	    throw 'ShapeLibrary is not declared';
	
	
	  // Initialize package:
	  sigma.utils.pkg('sigma.canvas.nodes');
	  sigma.utils.pkg('sigma.svg.nodes');
	
	  var sigInst = undefined;
	  var imgCache = {};
	
	  var initPlugin = function(inst) {
	    sigInst = inst;
	  }
	
	  var drawImage = function (node,x,y,size,context) {
	    if(sigInst && node.image && node.image.url) {
	      var url = node.image.url;
	      var ih = node.image.h || 1; // 1 is arbitrary, anyway only the ratio counts
	      var iw = node.image.w || 1;
	      var scale = node.image.scale || 1;
	      var clip = node.image.clip || 1;
	
	      // create new IMG or get from imgCache
	      var image = imgCache[url];
	      if(!image) {
	        image = document.createElement('IMG');
	        image.src = url;
	        image.status = 'loading';
	        image.onerror = function() {
	          console.log("error loading", url);
	          image.status = 'error';
	        };
	        image.onload = function(){
	          // TODO see how we redraw on load
	          // need to provide the siginst as a parameter to the library
	          console.log("redraw on image load", url);
	          image.status = 'ok';
	          sigInst.refresh();
	        };
	        imgCache[url] = image;
	      }
	
	      // calculate position and draw
	      var xratio = (iw<ih) ? (iw/ih) : 1;
	      var yratio = (ih<iw) ? (ih/iw) : 1;
	      var r = size*scale;
	
	      // Draw the clipping disc:
	      context.save(); // enter clipping mode
	      context.beginPath();
	      context.arc(x,y,size*clip,0,Math.PI*2,true);
	      context.closePath();
	      context.clip();
	
	      if(image.status === 'ok') {
	        // Draw the actual image
	        context.drawImage(image,
	            x+Math.sin(-3.142/4)*r*xratio,
	            y-Math.cos(-3.142/4)*r*yratio,
	            r*xratio*2*Math.sin(-3.142/4)*(-1),
	            r*yratio*2*Math.cos(-3.142/4));
	      }
	      context.restore(); // exit clipping mode
	    }
	  }
	
	  var drawSVGImage = function (node, group, settings) {
	    if(sigInst && node.image && node.image.url) {
	      var clipCircle = document.createElementNS(settings('xmlns'), 'circle'),
	        clipPath = document.createElementNS(settings('xmlns'), 'clipPath'),
	        clipPathId = settings('classPrefix') + '-clip-path-' + node.id,
	        def = document.createElementNS(settings('xmlns'), 'defs'),
	        image = document.createElementNS(settings('xmlns'), 'image'),
	        url = node.image.url;
	
	      clipPath.setAttributeNS(null, 'id', clipPathId);
	      clipPath.appendChild(clipCircle);
	      def.appendChild(clipPath);
	
	      // angular's base tag will change the relative fragment id, so
	      // #<clipPathId> doesn't work
	      // HACKHACK: IE <=9 does not respect the HTML base element in SVG.
	      // They don't need the current URL in the clip path reference.
	      var absolutePath = /MSIE [5-9]/.test(navigator.userAgent) ?
	        "" : document.location.href;
	      // To fix cases where an anchor tag was used
	      absolutePath = absolutePath.split("#")[0];
	      image.setAttributeNS(null, 'class',
	        settings('classPrefix') + '-node-image');
	      image.setAttributeNS(null, 'clip-path',
	        'url(' + absolutePath + '#' + clipPathId + ')');
	      image.setAttributeNS(null, 'pointer-events', 'none');
	      image.setAttributeNS('http://www.w3.org/1999/xlink', 'href',
	        node.image.url);
	      group.appendChild(def);
	      group.appendChild(image);
	    }
	  }
	
	  var register = function(name,drawShape,drawBorder) {
	    sigma.canvas.nodes[name] = function(node, context, settings) {
	      var args = arguments,
	          prefix = settings('prefix') || '',
	          size = node[prefix + 'size'],
	          color = node.color || settings('defaultNodeColor'),
	          borderColor = node.borderColor || color,
	          x = node[prefix + 'x'],
	          y = node[prefix + 'y'];
	
	      context.save();
	
	      if(drawShape) {
	        drawShape(node,x,y,size,color,context);
	      }
	
	      if(drawBorder) {
	        drawBorder(node,x,y,size,borderColor,context);
	      }
	
	      drawImage(node,x,y,size,context);
	
	      context.restore();
	    };
	
	    sigma.svg.nodes[name] = {
	      create: function(node, settings) {
	        var group = document.createElementNS(settings('xmlns'), 'g'),
	        circle = document.createElementNS(settings('xmlns'), 'circle');
	
	        group.setAttributeNS(null, 'class',
	          settings('classPrefix') + '-node-group');
	        group.setAttributeNS(null, 'data-node-id', node.id);
	        // Defining the node's circle
	        circle.setAttributeNS(null, 'data-node-id', node.id);
	        circle.setAttributeNS(null, 'class',
	          settings('classPrefix') + '-node');
	        circle.setAttributeNS(null, 'fill',
	          node.color || settings('defaultNodeColor'));
	
	        group.appendChild(circle);
	        drawSVGImage(node, group, settings);
	        return group;
	      },
	      update: function(node, group, settings) {
	        var classPrefix = settings('classPrefix'),
	          clip = node.image.clip || 1,
	          // 1 is arbitrary, anyway only the ratio counts
	          ih = node.image.h || 1,
	          iw = node.image.w || 1,
	          prefix = settings('prefix') || '',
	          scale = node.image.scale || 1,
	          size = node[prefix + 'size'],
	          x = node[prefix + 'x'],
	          y = node[prefix + 'y'];
	
	          var r = scale * size,
	          xratio = (iw<ih) ? (iw/ih) : 1,
	          yratio = (ih<iw) ? (ih/iw) : 1;
	
	        for(var i = 0, childNodes = group.childNodes; i < childNodes.length; i ++) {
	          var className = childNodes[i].getAttribute('class');
	
	          switch (className) {
	            case classPrefix + '-node':
	              childNodes[i].setAttributeNS(null, 'cx', x);
	              childNodes[i].setAttributeNS(null, 'cy', y);
	              childNodes[i].setAttributeNS(null, 'r', size);
	
	              // // Updating only if not freestyle
	              if (!settings('freeStyle')) {
	                childNodes[i].setAttributeNS(
	                  null,
	                  'fill',
	                  node.color || settings('defaultNodeColor'));
	              }
	              break;
	            case classPrefix + '-node-image':
	              childNodes[i].setAttributeNS(null, 'x',
	                x+Math.sin(-3.142/4)*r*xratio);
	              childNodes[i].setAttributeNS(null, 'y',
	                y-Math.cos(-3.142/4)*r*yratio);
	              childNodes[i].setAttributeNS(null, 'width',
	                r*xratio*2*Math.sin(-3.142/4)*(-1));
	              childNodes[i].setAttributeNS(null, 'height',
	                r*yratio*2*Math.cos(-3.142/4));
	              break;
	            default:
	              // no class name, must be the clip-path
	              var clipPath = childNodes[i].firstChild;
	              if (clipPath != null) {
	                var clipPathId = classPrefix + '-clip-path-' + node.id;
	                if (clipPath.getAttribute('id') === clipPathId) {
	                  clipPath.firstChild.setAttributeNS(null, 'cx', x);
	                  clipPath.firstChild.setAttributeNS(null, 'cy', y);
	                  clipPath.firstChild.setAttributeNS(null, 'r',
	                    clip * size);
	                }
	              }
	              break;
	          }
	        }
	
	        // showing
	        group.style.display = '';
	      }
	    }
	  }
	
	  ShapeLibrary.enumerate().forEach(function(shape) {
	    register(shape.name,shape.drawShape,shape.drawBorder);
	  });
	
	  /**
	   * Exporting
	   * ----------
	   */
	  this.CustomShapes = {
	
	    // Functions
	    init: initPlugin,
	    // add pre-cache images
	
	    // Version
	    version: '0.1'
	  };
	
	
	
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 477 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 127);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 127:
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(19);
	module.exports = __webpack_require__(20);
	
	
	/***/ }),
	
	/***/ 19:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  /**
	   * GEXF Library
	   * =============
	   *
	   * Author: PLIQUE Guillaume (Yomguithereal)
	   * URL: https://github.com/Yomguithereal/gexf-parser
	   * Version: 0.1.1
	   */
	
	  /**
	   * Helper Namespace
	   * -----------------
	   *
	   * A useful batch of function dealing with DOM operations and types.
	   */
	  var _helpers = {
	    getModelTags: function(xml) {
	      var attributesTags = xml.getElementsByTagName('attributes'),
	          modelTags = {},
	          l = attributesTags.length,
	          i;
	
	      for (i = 0; i < l; i++)
	        modelTags[attributesTags[i].getAttribute('class')] =
	          attributesTags[i].childNodes;
	
	      return modelTags;
	    },
	    nodeListToArray: function(nodeList) {
	
	      // Return array
	      var children = [];
	
	      // Iterating
	      for (var i = 0, len = nodeList.length; i < len; ++i) {
	        if (nodeList[i].nodeName !== '#text')
	          children.push(nodeList[i]);
	      }
	
	      return children;
	    },
	    nodeListEach: function(nodeList, func) {
	
	      // Iterating
	      for (var i = 0, len = nodeList.length; i < len; ++i) {
	        if (nodeList[i].nodeName !== '#text')
	          func(nodeList[i]);
	      }
	    },
	    nodeListToHash: function(nodeList, filter) {
	
	      // Return object
	      var children = {};
	
	      // Iterating
	      for (var i = 0; i < nodeList.length; i++) {
	        if (nodeList[i].nodeName !== '#text') {
	          var prop = filter(nodeList[i]);
	          children[prop.key] = prop.value;
	        }
	      }
	
	      return children;
	    },
	    namedNodeMapToObject: function(nodeMap) {
	
	      // Return object
	      var attributes = {};
	
	      // Iterating
	      for (var i = 0; i < nodeMap.length; i++) {
	        attributes[nodeMap[i].name] = nodeMap[i].value;
	      }
	
	      return attributes;
	    },
	    getFirstElementByTagNS: function(node, ns, tag) {
	      var el = node.getElementsByTagName(ns + ':' + tag)[0];
	
	      if (!el)
	        el = node.getElementsByTagNameNS(ns, tag)[0];
	
	      if (!el)
	        el = node.getElementsByTagName(tag)[0];
	
	      return el;
	    },
	    getAttributeNS: function(node, ns, attribute) {
	      var attr_value = node.getAttribute(ns + ':' + attribute);
	
	      if (attr_value === undefined)
	        attr_value = node.getAttributeNS(ns, attribute);
	
	      if (attr_value === undefined)
	        attr_value = node.getAttribute(attribute);
	
	      return attr_value;
	    },
	    enforceType: function(type, value) {
	
	      switch (type) {
	        case 'boolean':
	          value = (value === 'true');
	          break;
	
	        case 'integer':
	        case 'long':
	        case 'float':
	        case 'double':
	          value = +value;
	          break;
	
	        case 'liststring':
	          value = value ? value.split('|') : [];
	          break;
	      }
	
	      return value;
	    },
	    getRGB: function(values) {
	      return (values[3]) ?
	        'rgba(' + values.join(',') + ')' :
	        'rgb(' + values.slice(0, -1).join(',') + ')';
	    }
	  };
	
	
	  /**
	   * Parser Core Functions
	   * ----------------------
	   *
	   * The XML parser's functions themselves.
	   */
	
	  /**
	   * Node structure.
	   * A function returning an object guarded with default value.
	   *
	   * @param  {object} properties The node properties.
	   * @return {object}            The guarded node object.
	   */
	  function Node(properties) {
	
	    // Possible Properties
	    var node = {
	      id: properties.id,
	      label: properties.label
	    };
	
	    if (properties.viz)
	      node.viz = properties.viz;
	
	    if (properties.attributes)
	      node.attributes = properties.attributes;
	
	    return node;
	  }
	
	
	  /**
	   * Edge structure.
	   * A function returning an object guarded with default value.
	   *
	   * @param  {object} properties The edge properties.
	   * @return {object}            The guarded edge object.
	   */
	  function Edge(properties) {
	
	    // Possible Properties
	    var edge = {
	      id: properties.id,
	      type: properties.type || 'undirected',
	      label: properties.label || '',
	      source: properties.source,
	      target: properties.target,
	      weight: +properties.weight || 1.0
	    };
	
	    if (properties.viz)
	      edge.viz = properties.viz;
	
	    if (properties.attributes)
	      edge.attributes = properties.attributes;
	
	    return edge;
	  }
	
	  /**
	   * Graph parser.
	   * This structure parse a gexf string and return an object containing the
	   * parsed graph.
	   *
	   * @param  {string} xml The xml string of the gexf file to parse.
	   * @return {object}     The parsed graph.
	   */
	  function Graph(xml) {
	    var _xml = {};
	
	    // Basic Properties
	    //------------------
	    _xml.els = {
	      root: xml.getElementsByTagName('gexf')[0],
	      graph: xml.getElementsByTagName('graph')[0],
	      meta: xml.getElementsByTagName('meta')[0],
	      nodes: xml.getElementsByTagName('node'),
	      edges: xml.getElementsByTagName('edge'),
	      model: _helpers.getModelTags(xml)
	    };
	
	    // Information
	    _xml.hasViz = !!_helpers.getAttributeNS(_xml.els.root, 'xmlns', 'viz');
	    _xml.version = _xml.els.root.getAttribute('version') || '1.0';
	    _xml.mode = _xml.els.graph.getAttribute('mode') || 'static';
	
	    var edgeType = _xml.els.graph.getAttribute('defaultedgetype');
	    _xml.defaultEdgetype = edgeType || 'undirected';
	
	    // Parser Functions
	    //------------------
	
	    // Meta Data
	    function _metaData() {
	
	      var metas = {};
	      if (!_xml.els.meta)
	        return metas;
	
	      // Last modified date
	      metas.lastmodifieddate = _xml.els.meta.getAttribute('lastmodifieddate');
	
	      // Other information
	      _helpers.nodeListEach(_xml.els.meta.childNodes, function(child) {
	        metas[child.tagName.toLowerCase()] = child.textContent;
	      });
	
	      return metas;
	    }
	
	    // Model
	    function _model(cls) {
	      var attributes = [];
	
	      // Iterating through attributes
	      if (_xml.els.model[cls])
	        _helpers.nodeListEach(_xml.els.model[cls], function(attr) {
	
	          // Properties
	          var properties = {
	            id: attr.getAttribute('id') || attr.getAttribute('for'),
	            type: attr.getAttribute('type') || 'string',
	            title: attr.getAttribute('title') || ''
	          };
	
	          // Defaults
	          var default_el = _helpers.nodeListToArray(attr.childNodes);
	
	          if (default_el.length > 0)
	            properties.defaultValue = default_el[0].textContent;
	
	          // Creating attribute
	          attributes.push(properties);
	        });
	
	      return attributes.length > 0 ? attributes : false;
	    }
	
	    // Data from nodes or edges
	    function _data(model, node_or_edge) {
	
	      var data = {};
	      var attvalues_els = node_or_edge.getElementsByTagName('attvalue');
	
	      // Getting Node Indicated Attributes
	      var ah = _helpers.nodeListToHash(attvalues_els, function(el) {
	        var attributes = _helpers.namedNodeMapToObject(el.attributes);
	        var key = attributes.id || attributes['for'];
	
	        // Returning object
	        return {key: key, value: attributes.value};
	      });
	
	
	      // Iterating through model
	      model.map(function(a) {
	
	        // Default value?
	        data[a.id] = !(a.id in ah) && 'defaultValue' in a ?
	          _helpers.enforceType(a.type, a.defaultValue) :
	          _helpers.enforceType(a.type, ah[a.id]);
	
	      });
	
	      return data;
	    }
	
	    // Nodes
	    function _nodes(model) {
	      var nodes = [];
	
	      // Iteration through nodes
	      _helpers.nodeListEach(_xml.els.nodes, function(n) {
	
	        // Basic properties
	        var properties = {
	          id: n.getAttribute('id'),
	          label: n.getAttribute('label') || ''
	        };
	
	        // Retrieving data from nodes if any
	        if (model)
	          properties.attributes = _data(model, n);
	
	        // Retrieving viz information
	        if (_xml.hasViz)
	          properties.viz = _nodeViz(n);
	
	        // Pushing node
	        nodes.push(Node(properties));
	      });
	
	      return nodes;
	    }
	
	    // Viz information from nodes
	    function _nodeViz(node) {
	      var viz = {};
	
	      // Color
	      var color_el = _helpers.getFirstElementByTagNS(node, 'viz', 'color');
	
	      if (color_el) {
	        var color = ['r', 'g', 'b', 'a'].map(function(c) {
	          return color_el.getAttribute(c);
	        });
	
	        viz.color = _helpers.getRGB(color);
	      }
	
	      // Position
	      var pos_el = _helpers.getFirstElementByTagNS(node, 'viz', 'position');
	
	      if (pos_el) {
	        viz.position = {};
	
	        ['x', 'y', 'z'].map(function(p) {
	          viz.position[p] = +pos_el.getAttribute(p);
	        });
	      }
	
	      // Size
	      var size_el = _helpers.getFirstElementByTagNS(node, 'viz', 'size');
	      if (size_el)
	        viz.size = +size_el.getAttribute('value');
	
	      // Shape
	      var shape_el = _helpers.getFirstElementByTagNS(node, 'viz', 'shape');
	      if (shape_el)
	        viz.shape = shape_el.getAttribute('value');
	
	      return viz;
	    }
	
	    // Edges
	    function _edges(model, default_type) {
	      var edges = [];
	
	      // Iteration through edges
	      _helpers.nodeListEach(_xml.els.edges, function(e) {
	
	        // Creating the edge
	        var properties = _helpers.namedNodeMapToObject(e.attributes);
	        if (!('type' in properties)) {
	          properties.type = default_type;
	        }
	
	        // Retrieving edge data
	        if (model)
	          properties.attributes = _data(model, e);
	
	
	        // Retrieving viz information
	        if (_xml.hasViz)
	          properties.viz = _edgeViz(e);
	
	        edges.push(Edge(properties));
	      });
	
	      return edges;
	    }
	
	    // Viz information from edges
	    function _edgeViz(edge) {
	      var viz = {};
	
	      // Color
	      var color_el = _helpers.getFirstElementByTagNS(edge, 'viz', 'color');
	
	      if (color_el) {
	        var color = ['r', 'g', 'b', 'a'].map(function(c) {
	          return color_el.getAttribute(c);
	        });
	
	        viz.color = _helpers.getRGB(color);
	      }
	
	      // Shape
	      var shape_el = _helpers.getFirstElementByTagNS(edge, 'viz', 'shape');
	      if (shape_el)
	        viz.shape = shape_el.getAttribute('value');
	
	      // Thickness
	      var thick_el = _helpers.getFirstElementByTagNS(edge, 'viz', 'thickness');
	      if (thick_el)
	        viz.thickness = +thick_el.getAttribute('value');
	
	      return viz;
	    }
	
	
	    // Returning the Graph
	    //---------------------
	    var nodeModel = _model('node'),
	        edgeModel = _model('edge');
	
	    var graph = {
	      version: _xml.version,
	      mode: _xml.mode,
	      defaultEdgeType: _xml.defaultEdgetype,
	      meta: _metaData(),
	      model: {},
	      nodes: _nodes(nodeModel),
	      edges: _edges(edgeModel, _xml.defaultEdgetype)
	    };
	
	    if (nodeModel)
	      graph.model.node = nodeModel;
	    if (edgeModel)
	      graph.model.edge = edgeModel;
	
	    return graph;
	  }
	
	
	  /**
	   * Public API
	   * -----------
	   *
	   * User-accessible functions.
	   */
	
	  // Fetching GEXF with XHR
	  function fetch(gexf_url, callback) {
	    var xhr = (function() {
	      if (window.XMLHttpRequest)
	        return new XMLHttpRequest();
	
	      var names,
	          i;
	
	      if (window.ActiveXObject) {
	        names = [
	          'Msxml2.XMLHTTP.6.0',
	          'Msxml2.XMLHTTP.3.0',
	          'Msxml2.XMLHTTP',
	          'Microsoft.XMLHTTP'
	        ];
	
	        for (i in names)
	          try {
	            return new ActiveXObject(names[i]);
	          } catch (e) {}
	      }
	
	      return null;
	    })();
	
	    if (!xhr)
	      throw 'XMLHttpRequest not supported, cannot load the file.';
	
	    // Async?
	    var async = (typeof callback === 'function'),
	        getResult;
	
	    // If we can't override MIME type, we are on IE 9
	    // We'll be parsing the response string then.
	    if (xhr.overrideMimeType) {
	      xhr.overrideMimeType('text/xml');
	      getResult = function(r) {
	        return r.responseXML;
	      };
	    }
	    else {
	      getResult = function(r) {
	        var p = new DOMParser();
	        return p.parseFromString(r.responseText, 'application/xml');
	      };
	    }
	
	    xhr.open('GET', gexf_url, async);
	
	    if (async)
	      xhr.onreadystatechange = function() {
	        if (xhr.readyState === 4)
	          callback(getResult(xhr));
	      };
	
	    xhr.send();
	
	    return (async) ? xhr : getResult(xhr);
	  }
	
	  // Parsing the GEXF File
	  function parse(gexf) {
	    return Graph(gexf);
	  }
	
	  // Fetch and parse the GEXF File
	  function fetchAndParse(gexf_url, callback) {
	    if (typeof callback === 'function') {
	      return fetch(gexf_url, function(gexf) {
	        callback(Graph(gexf));
	      });
	    } else
	      return Graph(fetch(gexf_url));
	  }
	
	
	  /**
	   * Exporting
	   * ----------
	   */
	  if (typeof this.gexf !== 'undefined')
	    throw 'gexf: error - a variable called "gexf" already ' +
	          'exists in the global scope';
	
	  this.gexf = {
	
	    // Functions
	    parse: parse,
	    fetch: fetchAndParse,
	
	    // Version
	    version: '0.1.1'
	  };
	
	  if (typeof exports !== 'undefined' && this.exports !== exports)
	    module.exports = this.gexf;
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 20:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize package:
	  sigma.utils.pkg('sigma.parsers');
	
	  // Just a basic ID generator:
	  var _id = 0;
	  function edgeId() {
	    return 'e' + (_id++);
	  }
	
	  /**
	   * If the first arguments is a valid URL, this function loads a GEXF file and
	   * creates a new sigma instance or updates the graph of a given instance. It
	   * is possible to give a callback that will be executed at the end of the
	   * process. And if the first argument is a DOM element, it will skip the
	   * loading step and parse the given XML tree to fill the graph.
	   *
	   * @param  {string|DOMElement} target   The URL of the GEXF file or a valid
	   *                                      GEXF tree.
	   * @param  {object|sigma}      sig      A sigma configuration object or a
	   *                                      sigma instance.
	   * @param  {?function}         callback Eventually a callback to execute
	   *                                      after having parsed the file. It will
	   *                                      be called with the related sigma
	   *                                      instance as parameter.
	   */
	  sigma.parsers.gexf = function(target, sig, callback) {
	    var i,
	        l,
	        arr,
	        obj;
	
	    function parse(graph) {
	      // Adapt the graph:
	      arr = graph.nodes;
	      for (i = 0, l = arr.length; i < l; i++) {
	        obj = arr[i];
	
	        obj.id = obj.id;
	        if (obj.viz && typeof obj.viz === 'object') {
	          if (obj.viz.position && typeof obj.viz.position === 'object') {
	            obj.x = obj.viz.position.x;
	            obj.y = -obj.viz.position.y; // Needed otherwise it's up side down
	          }
	          obj.size = obj.viz.size;
	          obj.color = obj.viz.color;
	        }
	      }
	
	      arr = graph.edges;
	      for (i = 0, l = arr.length; i < l; i++) {
	        obj = arr[i];
	
	        obj.id = typeof obj.id === 'string' ? obj.id : edgeId();
	        obj.source = '' + obj.source;
	        obj.target = '' + obj.target;
	
	        if (obj.viz && typeof obj.viz === 'object') {
	          obj.color = obj.viz.color;
	          obj.size = obj.viz.thickness;
	        }
	
	        // Weight over viz.thickness?
	        obj.size = obj.weight;
	
	        // Changing type to be direction so it won't mess with sigma's naming
	        obj.direction = obj.type;
	        delete obj.type;
	      }
	
	      // Update the instance's graph:
	      if (sig instanceof sigma) {
	        sig.graph.clear();
	
	        arr = graph.nodes;
	        for (i = 0, l = arr.length; i < l; i++)
	          sig.graph.addNode(arr[i]);
	
	        arr = graph.edges;
	        for (i = 0, l = arr.length; i < l; i++)
	          sig.graph.addEdge(arr[i]);
	
	      // ...or instantiate sigma if needed:
	      } else if (typeof sig === 'object') {
	        sig.graph = graph;
	        sig = new sigma(sig);
	
	      // ...or it's finally the callback:
	      } else if (typeof sig === 'function') {
	        callback = sig;
	        sig = null;
	      }
	
	      // Call the callback if specified:
	      if (callback) {
	        callback(sig || graph);
	        return;
	      } else
	        return graph;
	    }
	
	    if (typeof target === 'string')
	      gexf.fetch(target, parse);
	    else if (typeof target === 'object')
	      return parse(gexf.parse(target));
	  };
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 478 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 122);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 122:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize package:
	  sigma.utils.pkg('sigma.plugins');
	
	  // Add custom graph methods:
	  /**
	   * This methods returns an array of nodes that are adjacent to a node.
	   *
	   * @param  {string} id The node id.
	   * @return {array}     The array of adjacent nodes.
	   */
	  if (!sigma.classes.graph.hasMethod('adjacentNodes'))
	    sigma.classes.graph.addMethod('adjacentNodes', function(id) {
	      if (typeof id !== 'string')
	        throw 'adjacentNodes: the node id must be a string.';
	
	      var target,
	          nodes = [];
	      for(target in this.allNeighborsIndex[id]) {
	        nodes.push(this.nodesIndex[target]);
	      }
	      return nodes;
	    });
	
	  /**
	   * This methods returns an array of edges that are adjacent to a node.
	   *
	   * @param  {string} id The node id.
	   * @return {array}     The array of adjacent edges.
	   */
	  if (!sigma.classes.graph.hasMethod('adjacentEdges'))
	    sigma.classes.graph.addMethod('adjacentEdges', function(id) {
	      if (typeof id !== 'string')
	        throw 'adjacentEdges: the node id must be a string.';
	
	      var a = this.allNeighborsIndex[id],
	          eid,
	          target,
	          edges = [];
	      for(target in a) {
	        for(eid in a[target]) {
	          edges.push(a[target][eid]);
	        }
	      }
	      return edges;
	    });
	
	  /**
	   * Sigma Filter
	   * =============================
	   *
	   * @author Sébastien Heymann <seb@linkurio.us> (Linkurious)
	   * @version 0.1
	   */
	
	   var _g = undefined,
	       _s = undefined,
	       _chain = [], // chain of wrapped filters
	       _keysIndex = Object.create(null),
	       Processors = {};   // available predicate processors
	
	
	  /**
	   * Library of processors
	   * ------------------
	   */
	
	   /**
	    *
	    * @param  {function} fn The predicate.
	    */
	  Processors.nodes = function nodes(fn) {
	    var n = _g.nodes(),
	        ln = n.length,
	        e = _g.edges(),
	        le = e.length;
	
	    // hide node, or keep former value
	    while(ln--)
	      n[ln].hidden = !fn.call(_g, n[ln]) || n[ln].hidden;
	
	    while(le--)
	      if (_g.nodes(e[le].source).hidden || _g.nodes(e[le].target).hidden)
	        e[le].hidden = true;
	  };
	
	   /**
	    *
	    * @param  {function} fn The predicate.
	    */
	  Processors.edges = function edges(fn) {
	    var e = _g.edges(),
	        le = e.length;
	
	    // hide edge, or keep former value
	    while(le--)
	      e[le].hidden = !fn.call(_g, e[le]) || e[le].hidden;
	  };
	
	   /**
	    *
	    * @param  {string} id The center node.
	    */
	  Processors.neighbors = function neighbors(id) {
	    var n = _g.nodes(),
	        ln = n.length,
	        e = _g.edges(),
	        le = e.length,
	        neighbors = _g.adjacentNodes(id),
	        nn = neighbors.length,
	        no = {};
	
	    while(nn--)
	      no[neighbors[nn].id] = true;
	
	    while(ln--)
	      if (n[ln].id !== id && !(n[ln].id in no))
	        n[ln].hidden = true;
	
	    while(le--)
	      if (_g.nodes(e[le].source).hidden || _g.nodes(e[le].target).hidden)
	        e[le].hidden = true;
	  };
	
	
	  /**
	   * This function adds a filter to the chain of filters.
	   *
	   * @param  {function} fn  The filter (i.e. predicate processor).
	   * @param  {function} p   The predicate.
	   * @param  {?string}  key The key to identify the filter.
	   */
	  function register(fn, p, key) {
	    if (key != undefined && typeof key !== 'string')
	      throw 'The filter key "'+ key.toString() +'" must be a string.';
	
	    if (key != undefined && !key.length)
	      throw 'The filter key must be a non-empty string.';
	
	    if (typeof fn !== 'function')
	      throw 'The predicate of key "'+ key +'" must be a function.';
	
	    if ('undo' === key)
	      throw '"undo" is a reserved key.';
	
	    if (_keysIndex[key])
	      throw 'The filter "' + key + '" already exists.';
	
	    if (key)
	      _keysIndex[key] = true;
	
	    _chain.push({
	      'key': key,
	      'processor': fn,
	      'predicate': p
	    });
	  };
	
	  /**
	   * This function removes a set of filters from the chain.
	   *
	   * @param {object} o The filter keys.
	   */
	  function unregister (o) {
	    _chain = _chain.filter(function(a) {
	      return !(a.key in o);
	    });
	
	    for(var key in o)
	      delete _keysIndex[key];
	  };
	
	
	
	
	  /**
	   * Filter Object
	   * ------------------
	   * @param  {sigma} s The related sigma instance.
	   */
	  function Filter(s) {
	    _s = s;
	    _g = s.graph;
	  };
	
	
	  /**
	   * This method is used to filter the nodes. The method must be called with
	   * the predicate, which is a function that takes a node as argument and
	   * returns a boolean. It may take an identifier as argument to undo the
	   * filter later. The method wraps the predicate into an anonymous function
	   * that looks through each node in the graph. When executed, the anonymous
	   * function hides the nodes that fail a truth test (predicate). The method
	   * adds the anonymous function to the chain of filters. The filter is not
	   * executed until the apply() method is called.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter.nodesBy(function(n) {
	   * >   return this.degree(n.id) > 0;
	   * > }, 'degreeNotNull');
	   *
	   * @param  {function}             fn  The filter predicate.
	   * @param  {?string}              key The key to identify the filter.
	   * @return {sigma.plugins.filter}     Returns the instance.
	   */
	  Filter.prototype.nodesBy = function(fn, key) {
	    // Wrap the predicate to be applied on the graph and add it to the chain.
	    register(Processors.nodes, fn, key);
	
	    return this;
	  };
	
	  /**
	   * This method is used to filter the edges. The method must be called with
	   * the predicate, which is a function that takes a node as argument and
	   * returns a boolean. It may take an identifier as argument to undo the
	   * filter later. The method wraps the predicate into an anonymous function
	   * that looks through each edge in the graph. When executed, the anonymous
	   * function hides the edges that fail a truth test (predicate). The method
	   * adds the anonymous function to the chain of filters. The filter is not
	   * executed until the apply() method is called.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter.edgesBy(function(e) {
	   * >   return e.size > 1;
	   * > }, 'edgeSize');
	   *
	   * @param  {function}             fn  The filter predicate.
	   * @param  {?string}              key The key to identify the filter.
	   * @return {sigma.plugins.filter}     Returns the instance.
	   */
	  Filter.prototype.edgesBy = function(fn, key) {
	    // Wrap the predicate to be applied on the graph and add it to the chain.
	    register(Processors.edges, fn, key);
	
	    return this;
	  };
	
	  /**
	   * This method is used to filter the nodes which are not direct connections
	   * of a given node. The method must be called with the node identifier. It
	   * may take an identifier as argument to undo the filter later. The filter
	   * is not executed until the apply() method is called.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter.neighborsOf('n0');
	   *
	   * @param  {string}               id  The node id.
	   * @param  {?string}              key The key to identify the filter.
	   * @return {sigma.plugins.filter}     Returns the instance.
	   */
	  Filter.prototype.neighborsOf = function(id, key) {
	    if (typeof id !== 'string')
	      throw 'The node id "'+ id.toString() +'" must be a string.';
	    if (!id.length)
	      throw 'The node id must be a non-empty string.';
	
	    // Wrap the predicate to be applied on the graph and add it to the chain.
	    register(Processors.neighbors, id, key);
	
	    return this;
	  };
	
	  /**
	   * This method is used to execute the chain of filters and to refresh the
	   * display.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter
	   * >   .nodesBy(function(n) {
	   * >     return this.degree(n.id) > 0;
	   * >   }, 'degreeNotNull')
	   * >   .apply();
	   *
	   * @return {sigma.plugins.filter}      Returns the instance.
	   */
	  Filter.prototype.apply = function() {
	    for (var i = 0, len = _chain.length; i < len; ++i) {
	      _chain[i].processor(_chain[i].predicate);
	    };
	
	    if (_chain[0] && 'undo' === _chain[0].key) {
	      _chain.shift();
	    }
	
	    _s.refresh();
	
	    return this;
	  };
	
	  /**
	   * This method undoes one or several filters, depending on how it is called.
	   *
	   * To undo all filters, call "undo" without argument. To undo a specific
	   * filter, call it with the key of the filter. To undo multiple filters, call
	   * it with an array of keys or multiple arguments, and it will undo each
	   * filter, in the same order. The undo is not executed until the apply()
	   * method is called. For instance:
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter
	   * >   .nodesBy(function(n) {
	   * >     return this.degree(n.id) > 0;
	   * >   }, 'degreeNotNull');
	   * >   .edgesBy(function(e) {
	   * >     return e.size > 1;
	   * >   }, 'edgeSize')
	   * >   .undo();
	   *
	   * Other examples:
	   * > filter.undo();
	   * > filter.undo('myfilter');
	   * > filter.undo(['myfilter1', 'myfilter2']);
	   * > filter.undo('myfilter1', 'myfilter2');
	   *
	   * @param  {?(string|array|*string))} v Eventually one key, an array of keys.
	   * @return {sigma.plugins.filter}       Returns the instance.
	   */
	  Filter.prototype.undo = function(v) {
	    var q = Object.create(null),
	        la = arguments.length;
	
	    // find removable filters
	    if (la === 1) {
	      if (Object.prototype.toString.call(v) === '[object Array]')
	        for (var i = 0, len = v.length; i < len; i++)
	          q[v[i]] = true;
	
	      else // 1 filter key
	        q[v] = true;
	
	    } else if (la > 1) {
	      for (var i = 0; i < la; i++)
	        q[arguments[i]] = true;
	    }
	    else
	      this.clear();
	
	    unregister(q);
	
	    function processor() {
	      var n = _g.nodes(),
	          ln = n.length,
	          e = _g.edges(),
	          le = e.length;
	
	      while(ln--)
	        n[ln].hidden = false;
	
	      while(le--)
	        e[le].hidden = false;
	    };
	
	    _chain.unshift({
	      'key': 'undo',
	      'processor': processor
	    });
	
	    return this;
	  };
	
	  // fast deep copy function
	  function deepCopy(o) {
	    var copy = Object.create(null);
	    for (var i in o) {
	      if (typeof o[i] === "object" && o[i] !== null) {
	        copy[i] = deepCopy(o[i]);
	      }
	      else if (typeof o[i] === "function" && o[i] !== null) {
	        // clone function:
	        eval(" copy[i] = " +  o[i].toString());
	        //copy[i] = o[i].bind(_g);
	      }
	
	      else
	        copy[i] = o[i];
	    }
	    return copy;
	  };
	
	  function cloneChain(chain) {
	    // Clone the array of filters:
	    var copy = chain.slice(0);
	    for (var i = 0, len = copy.length; i < len; i++) {
	      copy[i] = deepCopy(copy[i]);
	      if (typeof copy[i].processor === "function")
	        copy[i].processor = 'filter.processors.' + copy[i].processor.name;
	    };
	    return copy;
	  }
	
	  /**
	   * This method is used to empty the chain of filters.
	   * Prefer the undo() method to reset filters.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > filter.clear();
	   *
	   * @return {sigma.plugins.filter} Returns the instance.
	   */
	  Filter.prototype.clear = function() {
	    _chain.length = 0; // clear the array
	    _keysIndex = Object.create(null);
	    return this;
	  };
	
	  /**
	   * This method clones the filter chain and return the copy.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > var chain = filter.export();
	   *
	   * @return {object}   The cloned chain of filters.
	   */
	  Filter.prototype.export = function() {
	    var c = cloneChain(_chain);
	    return c;
	  };
	
	  /**
	   * This method sets the chain of filters with the specified chain.
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   * > var chain = [
	   * >   {
	   * >     key: 'my-filter',
	   * >     predicate: function(n) {...},
	   * >     processor: 'filter.processors.nodes'
	   * >   }, ...
	   * > ];
	   * > filter.import(chain);
	   *
	   * @param {array} chain The chain of filters.
	   * @return {sigma.plugins.filter} Returns the instance.
	   */
	  Filter.prototype.import = function(chain) {
	    if (chain === undefined)
	      throw 'Wrong arguments.';
	
	    if (Object.prototype.toString.call(chain) !== '[object Array]')
	      throw 'The chain" must be an array.';
	
	    var copy = cloneChain(chain);
	
	    for (var i = 0, len = copy.length; i < len; i++) {
	      if (copy[i].predicate === undefined || copy[i].processor === undefined)
	        throw 'Wrong arguments.';
	
	      if (copy[i].key != undefined && typeof copy[i].key !== 'string')
	        throw 'The filter key "'+ copy[i].key.toString() +'" must be a string.';
	
	      if (typeof copy[i].predicate !== 'function')
	        throw 'The predicate of key "'+ copy[i].key +'" must be a function.';
	
	      if (typeof copy[i].processor !== 'string')
	        throw 'The processor of key "'+ copy[i].key +'" must be a string.';
	
	      // Replace the processor name by the corresponding function:
	      switch(copy[i].processor) {
	        case 'filter.processors.nodes':
	          copy[i].processor = Processors.nodes;
	          break;
	        case 'filter.processors.edges':
	          copy[i].processor = Processors.edges;
	          break;
	        case 'filter.processors.neighbors':
	          copy[i].processor = Processors.neighbors;
	          break;
	        default:
	          throw 'Unknown processor ' + copy[i].processor;
	      }
	    };
	
	    _chain = copy;
	
	    return this;
	  };
	
	
	  /**
	   * Interface
	   * ------------------
	   *
	   * > var filter = new sigma.plugins.filter(s);
	   */
	  var filter = null;
	
	  /**
	   * @param  {sigma} s The related sigma instance.
	   */
	  sigma.plugins.filter = function(s) {
	    // Create new filter to update the graph params. Be aware, filter is a singleton,
	    // therefore filter instance can work on one sigma instance at a time.
	    filter = new Filter(s);
	    return filter;
	  };
	
	}).call(this);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 479 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 124);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 124:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function() {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  sigma.utils.pkg('sigma.plugins');
	
	  var _id = 0,
	      _cache = {};
	
	  /**
	   * This function will change size for all nodes depending to their degree
	   *
	   * @param  {sigma}   s       		The related sigma instance.
	   * @param  {object}  initialSize 	Start size property
	   */
	  sigma.plugins.relativeSize = function(s, initialSize) {
	    var nodes = s.graph.nodes();
	
	    // second create size for every node
	    for(var i = 0; i < nodes.length; i++) {
	      var degree = s.graph.degree(nodes[i].id);
	      nodes[i].size = initialSize * Math.sqrt(degree);
	    }
	    s.refresh();
	  };
	}).call(window);
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 480 */
/***/ function(module, exports) {

	var Sigma =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 117);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 117:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_sigma_renderers_webgl_js__ = __webpack_require__(63);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_sigma_renderers_webgl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sigma_react_src_renderers_sigma_renderers_webgl_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_sigma_renderers_def_js__ = __webpack_require__(62);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_sigma_renderers_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sigma_react_src_renderers_sigma_renderers_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_webgl_sigma_webgl_nodes_def_js__ = __webpack_require__(67);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_webgl_sigma_webgl_nodes_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sigma_react_src_renderers_webgl_sigma_webgl_nodes_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_webgl_sigma_webgl_nodes_fast_js__ = __webpack_require__(68);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_webgl_sigma_webgl_nodes_fast_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sigma_react_src_renderers_webgl_sigma_webgl_nodes_fast_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_webgl_sigma_webgl_edges_def_js__ = __webpack_require__(65);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_webgl_sigma_webgl_edges_def_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sigma_react_src_renderers_webgl_sigma_webgl_edges_def_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_webgl_sigma_webgl_edges_fast_js__ = __webpack_require__(66);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_webgl_sigma_webgl_edges_fast_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sigma_react_src_renderers_webgl_sigma_webgl_edges_fast_js__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_src_renderers_webgl_sigma_webgl_edges_arrow_js__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sigma_react_src_renderers_webgl_sigma_webgl_edges_arrow_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sigma_react_src_renderers_webgl_sigma_webgl_edges_arrow_js__);
	
	
	
	
	
	
	
	
	/***/ }),
	
	/***/ 62:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(global) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.renderers');
	
	  // Check if WebGL is enabled:
	  var canvas,
	      webgl = !!global.WebGLRenderingContext;
	  if (webgl) {
	    canvas = document.createElement('canvas');
	    try {
	      webgl = !!(
	        canvas.getContext('webgl') ||
	        canvas.getContext('experimental-webgl')
	      );
	    } catch (e) {
	      webgl = false;
	    }
	  }
	
	  // Copy the good renderer:
	  sigma.renderers.def = webgl ?
	    sigma.renderers.webgl :
	    sigma.renderers.canvas;
	})(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 63:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function(undefined) {
	  'use strict';
	
	  if (typeof sigma === 'undefined')
	    throw 'sigma is not declared';
	
	  // Initialize packages:
	  sigma.utils.pkg('sigma.renderers');
	
	  /**
	   * This function is the constructor of the canvas sigma's renderer.
	   *
	   * @param  {sigma.classes.graph}            graph    The graph to render.
	   * @param  {sigma.classes.camera}           camera   The camera.
	   * @param  {configurable}           settings The sigma instance settings
	   *                                           function.
	   * @param  {object}                 object   The options object.
	   * @return {sigma.renderers.canvas}          The renderer instance.
	   */
	  sigma.renderers.webgl = function(graph, camera, settings, options) {
	    if (typeof options !== 'object')
	      throw 'sigma.renderers.webgl: Wrong arguments.';
	
	    if (!(options.container instanceof HTMLElement))
	      throw 'Container not found.';
	
	    var k,
	        i,
	        l,
	        a,
	        fn,
	        _self = this;
	
	    sigma.classes.dispatcher.extend(this);
	
	    // Conrad related attributes:
	    this.jobs = {};
	
	    Object.defineProperty(this, 'conradId', {
	      value: sigma.utils.id()
	    });
	
	    // Initialize main attributes:
	    this.graph = graph;
	    this.camera = camera;
	    this.contexts = {};
	    this.domElements = {};
	    this.options = options;
	    this.container = this.options.container;
	    this.settings = (
	        typeof options.settings === 'object' &&
	        options.settings
	      ) ?
	        settings.embedObjects(options.settings) :
	        settings;
	
	    // Find the prefix:
	    this.options.prefix = this.camera.readPrefix;
	
	    // Initialize programs hash
	    Object.defineProperty(this, 'nodePrograms', {
	      value: {}
	    });
	    Object.defineProperty(this, 'edgePrograms', {
	      value: {}
	    });
	    Object.defineProperty(this, 'nodeFloatArrays', {
	      value: {}
	    });
	    Object.defineProperty(this, 'edgeFloatArrays', {
	      value: {}
	    });
	    Object.defineProperty(this, 'edgeIndicesArrays', {
	      value: {}
	    });
	
	    // Initialize the DOM elements:
	    if (this.settings(options, 'batchEdgesDrawing')) {
	      this.initDOM('canvas', 'edges', true);
	      this.initDOM('canvas', 'nodes', true);
	    } else {
	      this.initDOM('canvas', 'scene', true);
	      this.contexts.nodes = this.contexts.scene;
	      this.contexts.edges = this.contexts.scene;
	    }
	
	    this.initDOM('canvas', 'labels');
	    this.initDOM('canvas', 'mouse');
	    this.contexts.hover = this.contexts.mouse;
	
	    // Initialize captors:
	    this.captors = [];
	    a = this.options.captors || [sigma.captors.mouse, sigma.captors.touch];
	    for (i = 0, l = a.length; i < l; i++) {
	      fn = typeof a[i] === 'function' ? a[i] : sigma.captors[a[i]];
	      this.captors.push(
	        new fn(
	          this.domElements.mouse,
	          this.camera,
	          this.settings
	        )
	      );
	    }
	
	    // Deal with sigma events:
	    sigma.misc.bindEvents.call(this, this.camera.prefix);
	    sigma.misc.drawHovers.call(this, this.camera.prefix);
	
	    this.resize();
	  };
	
	
	
	
	  /**
	   * This method will generate the nodes and edges float arrays. This step is
	   * separated from the "render" method, because to keep WebGL efficient, since
	   * all the camera and middlewares are modelised as matrices and they do not
	   * require the float arrays to be regenerated.
	   *
	   * Basically, when the user moves the camera or applies some specific linear
	   * transformations, this process step will be skipped, and the "render"
	   * method will efficiently refresh the rendering.
	   *
	   * And when the user modifies the graph colors or positions (applying a new
	   * layout or filtering the colors, for instance), this "process" step will be
	   * required to regenerate the float arrays.
	   *
	   * @return {sigma.renderers.webgl} Returns the instance itself.
	   */
	  sigma.renderers.webgl.prototype.process = function() {
	    var a,
	        i,
	        l,
	        k,
	        type,
	        renderer,
	        graph = this.graph,
	        options = sigma.utils.extend(options, this.options),
	        defaultEdgeType = this.settings(options, 'defaultEdgeType'),
	        defaultNodeType = this.settings(options, 'defaultNodeType');
	
	    // Empty float arrays:
	    for (k in this.nodeFloatArrays)
	      delete this.nodeFloatArrays[k];
	
	    for (k in this.edgeFloatArrays)
	      delete this.edgeFloatArrays[k];
	
	    for (k in this.edgeIndicesArrays)
	      delete this.edgeIndicesArrays[k];
	
	    // Sort edges and nodes per types:
	    for (a = graph.edges(), i = 0, l = a.length; i < l; i++) {
	      type = a[i].type || defaultEdgeType;
	      k = (type && sigma.webgl.edges[type]) ? type : 'def';
	
	      if (!this.edgeFloatArrays[k])
	        this.edgeFloatArrays[k] = {
	          edges: []
	        };
	
	      this.edgeFloatArrays[k].edges.push(a[i]);
	    }
	
	    for (a = graph.nodes(), i = 0, l = a.length; i < l; i++) {
	      type = a[i].type || defaultNodeType;
	      k = (type && sigma.webgl.nodes[type]) ? type : 'def';
	
	      if (!this.nodeFloatArrays[k])
	        this.nodeFloatArrays[k] = {
	          nodes: []
	        };
	
	      this.nodeFloatArrays[k].nodes.push(a[i]);
	    }
	
	    // Push edges:
	    for (k in this.edgeFloatArrays) {
	      renderer = sigma.webgl.edges[k];
	      a = this.edgeFloatArrays[k].edges;
	
	      // Creating the necessary arrays
	      this.edgeFloatArrays[k].array = new Float32Array(
	        a.length * renderer.POINTS * renderer.ATTRIBUTES
	      );
	
	      for (i = 0, l = a.length; i < l; i++) {
	
	        // Just check that the edge and both its extremities are visible:
	        if (
	          !a[i].hidden &&
	          !graph.nodes(a[i].source).hidden &&
	          !graph.nodes(a[i].target).hidden
	        )
	          renderer.addEdge(
	            a[i],
	            graph.nodes(a[i].source),
	            graph.nodes(a[i].target),
	            this.edgeFloatArrays[k].array,
	            i * renderer.POINTS * renderer.ATTRIBUTES,
	            options.prefix,
	            this.settings
	          );
	      }
	
	      if (typeof renderer.computeIndices === 'function')
	        this.edgeIndicesArrays[k] = renderer.computeIndices(
	          this.edgeFloatArrays[k].array
	        );
	    }
	
	    // Push nodes:
	    for (k in this.nodeFloatArrays) {
	      renderer = sigma.webgl.nodes[k];
	      a = this.nodeFloatArrays[k].nodes;
	
	      // Creating the necessary arrays
	      this.nodeFloatArrays[k].array = new Float32Array(
	        a.length * renderer.POINTS * renderer.ATTRIBUTES
	      );
	
	      for (i = 0, l = a.length; i < l; i++) {
	        if (!this.nodeFloatArrays[k].array)
	          this.nodeFloatArrays[k].array = new Float32Array(
	            a.length * renderer.POINTS * renderer.ATTRIBUTES
	          );
	
	        // Just check that the edge and both its extremities are visible:
	        if (
	          !a[i].hidden
	        )
	          renderer.addNode(
	            a[i],
	            this.nodeFloatArrays[k].array,
	            i * renderer.POINTS * renderer.ATTRIBUTES,
	            options.prefix,
	            this.settings
	          );
	      }
	    }
	
	    return this;
	  };
	
	
	
	
	  /**
	   * This method renders the graph. It basically calls each program (and
	   * generate them if they do not exist yet) to render nodes and edges, batched
	   * per renderer.
	   *
	   * As in the canvas renderer, it is possible to display edges, nodes and / or
	   * labels in batches, to make the whole thing way more scalable.
	   *
	   * @param  {?object}               params Eventually an object of options.
	   * @return {sigma.renderers.webgl}        Returns the instance itself.
	   */
	  sigma.renderers.webgl.prototype.render = function(params) {
	    var a,
	        i,
	        l,
	        k,
	        o,
	        program,
	        renderer,
	        self = this,
	        graph = this.graph,
	        nodesGl = this.contexts.nodes,
	        edgesGl = this.contexts.edges,
	        matrix = this.camera.getMatrix(),
	        options = sigma.utils.extend(params, this.options),
	        drawLabels = this.settings(options, 'drawLabels'),
	        drawEdges = this.settings(options, 'drawEdges'),
	        drawNodes = this.settings(options, 'drawNodes');
	
	    // Call the resize function:
	    this.resize(false);
	
	    // Check the 'hideEdgesOnMove' setting:
	    if (this.settings(options, 'hideEdgesOnMove'))
	      if (this.camera.isAnimated || this.camera.isMoving)
	        drawEdges = false;
	
	    // Clear canvases:
	    this.clear();
	
	    // Translate matrix to [width/2, height/2]:
	    matrix = sigma.utils.matrices.multiply(
	      matrix,
	      sigma.utils.matrices.translation(this.width / 2, this.height / 2)
	    );
	
	    // Kill running jobs:
	    for (k in this.jobs)
	      if (conrad.hasJob(k))
	        conrad.killJob(k);
	
	    if (drawEdges) {
	      if (this.settings(options, 'batchEdgesDrawing'))
	        (function() {
	          var a,
	              k,
	              i,
	              id,
	              job,
	              arr,
	              end,
	              start,
	              indices,
	              renderer,
	              batchSize,
	              currentProgram;
	
	          id = 'edges_' + this.conradId;
	          batchSize = this.settings(options, 'webglEdgesBatchSize');
	          a = Object.keys(this.edgeFloatArrays);
	
	          if (!a.length)
	            return;
	          i = 0;
	          renderer = sigma.webgl.edges[a[i]];
	          arr = this.edgeFloatArrays[a[i]].array;
	          indices = this.edgeIndicesArrays[a[i]];
	          start = 0;
	          end = Math.min(
	            start + batchSize * renderer.POINTS,
	            arr.length / renderer.ATTRIBUTES
	          );
	
	          job = function() {
	            // Check program:
	            if (!this.edgePrograms[a[i]])
	              this.edgePrograms[a[i]] = renderer.initProgram(edgesGl);
	
	            if (start < end) {
	              edgesGl.useProgram(this.edgePrograms[a[i]]);
	              renderer.render(
	                edgesGl,
	                this.edgePrograms[a[i]],
	                arr,
	                {
	                  settings: this.settings,
	                  matrix: matrix,
	                  width: this.width,
	                  height: this.height,
	                  ratio: this.camera.ratio,
	                  scalingRatio: this.settings(
	                    options,
	                    'webglOversamplingRatio'
	                  ),
	                  start: start,
	                  count: end - start,
	                  indicesData: indices
	                }
	              );
	            }
	
	            // Catch job's end:
	            if (
	              end >= arr.length / renderer.ATTRIBUTES &&
	              i === a.length - 1
	            ) {
	              delete this.jobs[id];
	              return false;
	            }
	
	            if (end >= arr.length / renderer.ATTRIBUTES) {
	              i++;
	              arr = this.edgeFloatArrays[a[i]].array;
	              renderer = sigma.webgl.edges[a[i]];
	              start = 0;
	              end = Math.min(
	                start + batchSize * renderer.POINTS,
	                arr.length / renderer.ATTRIBUTES
	              );
	            } else {
	              start = end;
	              end = Math.min(
	                start + batchSize * renderer.POINTS,
	                arr.length / renderer.ATTRIBUTES
	              );
	            }
	
	            return true;
	          };
	
	          this.jobs[id] = job;
	          conrad.addJob(id, job.bind(this));
	        }).call(this);
	      else {
	        for (k in this.edgeFloatArrays) {
	          renderer = sigma.webgl.edges[k];
	
	          // Check program:
	          if (!this.edgePrograms[k])
	            this.edgePrograms[k] = renderer.initProgram(edgesGl);
	
	          // Render
	          if (this.edgeFloatArrays[k]) {
	            edgesGl.useProgram(this.edgePrograms[k]);
	            renderer.render(
	              edgesGl,
	              this.edgePrograms[k],
	              this.edgeFloatArrays[k].array,
	              {
	                settings: this.settings,
	                matrix: matrix,
	                width: this.width,
	                height: this.height,
	                ratio: this.camera.ratio,
	                scalingRatio: this.settings(options, 'webglOversamplingRatio'),
	                indicesData: this.edgeIndicesArrays[k]
	              }
	            );
	          }
	        }
	      }
	    }
	
	    if (drawNodes) {
	      // Enable blending:
	      nodesGl.blendFunc(nodesGl.SRC_ALPHA, nodesGl.ONE_MINUS_SRC_ALPHA);
	      nodesGl.enable(nodesGl.BLEND);
	
	      for (k in this.nodeFloatArrays) {
	        renderer = sigma.webgl.nodes[k];
	
	        // Check program:
	        if (!this.nodePrograms[k])
	          this.nodePrograms[k] = renderer.initProgram(nodesGl);
	
	        // Render
	        if (this.nodeFloatArrays[k]) {
	          nodesGl.useProgram(this.nodePrograms[k]);
	          renderer.render(
	            nodesGl,
	            this.nodePrograms[k],
	            this.nodeFloatArrays[k].array,
	            {
	              settings: this.settings,
	              matrix: matrix,
	              width: this.width,
	              height: this.height,
	              ratio: this.camera.ratio,
	              scalingRatio: this.settings(options, 'webglOversamplingRatio')
	            }
	          );
	        }
	      }
	    }
	
	    if (drawLabels) {
	      a = this.camera.quadtree.area(
	        this.camera.getRectangle(this.width, this.height)
	      );
	
	      // Apply camera view to these nodes:
	      this.camera.applyView(
	        undefined,
	        undefined,
	        {
	          nodes: a,
	          edges: [],
	          width: this.width,
	          height: this.height
	        }
	      );
	
	      o = function(key) {
	        return self.settings({
	          prefix: self.camera.prefix
	        }, key);
	      };
	
	      for (i = 0, l = a.length; i < l; i++)
	        if (!a[i].hidden)
	          (
	            sigma.canvas.labels[
	              a[i].type ||
	              this.settings(options, 'defaultNodeType')
	            ] || sigma.canvas.labels.def
	          )(a[i], this.contexts.labels, o);
	    }
	
	    this.dispatchEvent('render');
	
	    return this;
	  };
	
	
	
	
	  /**
	   * This method creates a DOM element of the specified type, switches its
	   * position to "absolute", references it to the domElements attribute, and
	   * finally appends it to the container.
	   *
	   * @param  {string}   tag   The label tag.
	   * @param  {string}   id    The id of the element (to store it in
	   *                          "domElements").
	   * @param  {?boolean} webgl Will init the WebGL context if true.
	   */
	  sigma.renderers.webgl.prototype.initDOM = function(tag, id, webgl) {
	    var gl,
	        dom = document.createElement(tag),
	        self = this;
	
	    dom.style.position = 'absolute';
	    dom.setAttribute('class', 'sigma-' + id);
	
	    this.domElements[id] = dom;
	    this.container.appendChild(dom);
	
	    if (tag.toLowerCase() === 'canvas') {
	      this.contexts[id] = dom.getContext(webgl ? 'experimental-webgl' : '2d', {
	        preserveDrawingBuffer: true
	      });
	
	      // Adding webgl context loss listeners
	      if (webgl) {
	        dom.addEventListener('webglcontextlost', function(e) {
	          e.preventDefault();
	        }, false);
	
	        dom.addEventListener('webglcontextrestored', function(e) {
	          self.render();
	        }, false);
	      }
	    }
	  };
	
	  /**
	   * This method resizes each DOM elements in the container and stores the new
	   * dimensions. Then, it renders the graph.
	   *
	   * @param  {?number}               width  The new width of the container.
	   * @param  {?number}               height The new height of the container.
	   * @return {sigma.renderers.webgl}        Returns the instance itself.
	   */
	  sigma.renderers.webgl.prototype.resize = function(w, h) {
	    var k,
	        oldWidth = this.width,
	        oldHeight = this.height,
	        pixelRatio = sigma.utils.getPixelRatio();
	
	    if (w !== undefined && h !== undefined) {
	      this.width = w;
	      this.height = h;
	    } else {
	      this.width = this.container.offsetWidth;
	      this.height = this.container.offsetHeight;
	
	      w = this.width;
	      h = this.height;
	    }
	
	    if (oldWidth !== this.width || oldHeight !== this.height) {
	      for (k in this.domElements) {
	        this.domElements[k].style.width = w + 'px';
	        this.domElements[k].style.height = h + 'px';
	
	        if (this.domElements[k].tagName.toLowerCase() === 'canvas') {
	          // If simple 2D canvas:
	          if (this.contexts[k] && this.contexts[k].scale) {
	            this.domElements[k].setAttribute('width', (w * pixelRatio) + 'px');
	            this.domElements[k].setAttribute('height', (h * pixelRatio) + 'px');
	
	            if (pixelRatio !== 1)
	              this.contexts[k].scale(pixelRatio, pixelRatio);
	          } else {
	            this.domElements[k].setAttribute(
	              'width',
	              (w * this.settings('webglOversamplingRatio')) + 'px'
	            );
	            this.domElements[k].setAttribute(
	              'height',
	              (h * this.settings('webglOversamplingRatio')) + 'px'
	            );
	          }
	        }
	      }
	    }
	
	    // Scale:
	    for (k in this.contexts)
	      if (this.contexts[k] && this.contexts[k].viewport)
	        this.contexts[k].viewport(
	          0,
	          0,
	          this.width * this.settings('webglOversamplingRatio'),
	          this.height * this.settings('webglOversamplingRatio')
	        );
	
	    return this;
	  };
	
	  /**
	   * This method clears each canvas.
	   *
	   * @return {sigma.renderers.webgl} Returns the instance itself.
	   */
	  sigma.renderers.webgl.prototype.clear = function() {
	    this.contexts.labels.clearRect(0, 0, this.width, this.height);
	    this.contexts.nodes.clear(this.contexts.nodes.COLOR_BUFFER_BIT);
	    this.contexts.edges.clear(this.contexts.edges.COLOR_BUFFER_BIT);
	
	    return this;
	  };
	
	  /**
	   * This method kills contexts and other attributes.
	   */
	  sigma.renderers.webgl.prototype.kill = function() {
	    var k,
	        captor;
	
	    // Kill captors:
	    while ((captor = this.captors.pop()))
	      captor.kill();
	    delete this.captors;
	
	    // Kill contexts:
	    for (k in this.domElements) {
	      this.domElements[k].parentNode.removeChild(this.domElements[k]);
	      delete this.domElements[k];
	      delete this.contexts[k];
	    }
	    delete this.domElements;
	    delete this.contexts;
	  };
	
	
	
	
	  /**
	   * The object "sigma.webgl.nodes" contains the different WebGL node
	   * renderers. The default one draw nodes as discs. Here are the attributes
	   * any node renderer must have:
	   *
	   * {number}   POINTS      The number of points required to draw a node.
	   * {number}   ATTRIBUTES  The number of attributes needed to draw one point.
	   * {function} addNode     A function that adds a node to the data stack that
	   *                        will be given to the buffer. Here is the arguments:
	   *                        > {object}       node
	   *                        > {number}       index   The node index in the
	   *                                                 nodes array.
	   *                        > {Float32Array} data    The stack.
	   *                        > {object}       options Some options.
	   * {function} render      The function that will effectively render the nodes
	   *                        into the buffer.
	   *                        > {WebGLRenderingContext} gl
	   *                        > {WebGLProgram}          program
	   *                        > {Float32Array} data    The stack to give to the
	   *                                                 buffer.
	   *                        > {object}       params  An object containing some
	   *                                                 options, like width,
	   *                                                 height, the camera ratio.
	   * {function} initProgram The function that will initiate the program, with
	   *                        the relevant shaders and parameters. It must return
	   *                        the newly created program.
	   *
	   * Check sigma.webgl.nodes.def or sigma.webgl.nodes.fast to see how it
	   * works more precisely.
	   */
	  sigma.utils.pkg('sigma.webgl.nodes');
	
	
	
	
	  /**
	   * The object "sigma.webgl.edges" contains the different WebGL edge
	   * renderers. The default one draw edges as direct lines. Here are the
	   * attributes any edge renderer must have:
	   *
	   * {number}   POINTS      The number of points required to draw an edge.
	   * {number}   ATTRIBUTES  The number of attributes needed to draw one point.
	   * {function} addEdge     A function that adds an edge to the data stack that
	   *                        will be given to the buffer. Here is the arguments:
	   *                        > {object}       edge
	   *                        > {object}       source
	   *                        > {object}       target
	   *                        > {Float32Array} data    The stack.
	   *                        > {object}       options Some options.
	   * {function} render      The function that will effectively render the edges
	   *                        into the buffer.
	   *                        > {WebGLRenderingContext} gl
	   *                        > {WebGLProgram}          program
	   *                        > {Float32Array} data    The stack to give to the
	   *                                                 buffer.
	   *                        > {object}       params  An object containing some
	   *                                                 options, like width,
	   *                                                 height, the camera ratio.
	   * {function} initProgram The function that will initiate the program, with
	   *                        the relevant shaders and parameters. It must return
	   *                        the newly created program.
	   *
	   * Check sigma.webgl.edges.def or sigma.webgl.edges.fast to see how it
	   * works more precisely.
	   */
	  sigma.utils.pkg('sigma.webgl.edges');
	
	
	
	
	  /**
	   * The object "sigma.canvas.labels" contains the different
	   * label renderers for the WebGL renderer. Since displaying texts in WebGL is
	   * definitely painful and since there a way less labels to display than nodes
	   * or edges, the default renderer simply renders them in a canvas.
	   *
	   * A labels renderer is a simple function, taking as arguments the related
	   * node, the renderer and a settings function.
	   */
	  sigma.utils.pkg('sigma.canvas.labels');
	}).call(this);
	
	}.call(window));
	
	/***/ }),
	
	/***/ 64:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.webgl.edges');
	
	  /**
	   * This edge renderer will display edges as arrows going from the source node
	   * to the target node. To deal with edge thicknesses, the lines are made of
	   * three triangles: two forming rectangles, with the gl.TRIANGLES drawing
	   * mode.
	   *
	   * It is expensive, since drawing a single edge requires 9 points, each
	   * having a lot of attributes.
	   */
	  sigma.webgl.edges.arrow = {
	    POINTS: 9,
	    ATTRIBUTES: 11,
	    addEdge: function(edge, source, target, data, i, prefix, settings) {
	      var w = (edge[prefix + 'size'] || 1) / 2,
	          x1 = source[prefix + 'x'],
	          y1 = source[prefix + 'y'],
	          x2 = target[prefix + 'x'],
	          y2 = target[prefix + 'y'],
	          targetSize = target[prefix + 'size'],
	          color = edge.color;
	
	      if (!color)
	        switch (settings('edgeColor')) {
	          case 'source':
	            color = source.color || settings('defaultNodeColor');
	            break;
	          case 'target':
	            color = target.color || settings('defaultNodeColor');
	            break;
	          default:
	            color = settings('defaultEdgeColor');
	            break;
	        }
	
	      // Normalize color:
	      color = sigma.utils.floatColor(color);
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 0.0;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      // Arrow head:
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 1.0;
	      data[i++] = -1.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = targetSize;
	      data[i++] = 1.0;
	      data[i++] = 0.0;
	      data[i++] = 1.0;
	      data[i++] = 1.0;
	      data[i++] = color;
	    },
	    render: function(gl, program, data, params) {
	      var buffer;
	
	      // Define attributes:
	      var positionLocation1 =
	            gl.getAttribLocation(program, 'a_pos1'),
	          positionLocation2 =
	            gl.getAttribLocation(program, 'a_pos2'),
	          thicknessLocation =
	            gl.getAttribLocation(program, 'a_thickness'),
	          targetSizeLocation =
	            gl.getAttribLocation(program, 'a_tSize'),
	          delayLocation =
	            gl.getAttribLocation(program, 'a_delay'),
	          minusLocation =
	            gl.getAttribLocation(program, 'a_minus'),
	          headLocation =
	            gl.getAttribLocation(program, 'a_head'),
	          headPositionLocation =
	            gl.getAttribLocation(program, 'a_headPosition'),
	          colorLocation =
	            gl.getAttribLocation(program, 'a_color'),
	          resolutionLocation =
	            gl.getUniformLocation(program, 'u_resolution'),
	          matrixLocation =
	            gl.getUniformLocation(program, 'u_matrix'),
	          matrixHalfPiLocation =
	            gl.getUniformLocation(program, 'u_matrixHalfPi'),
	          matrixHalfPiMinusLocation =
	            gl.getUniformLocation(program, 'u_matrixHalfPiMinus'),
	          ratioLocation =
	            gl.getUniformLocation(program, 'u_ratio'),
	          nodeRatioLocation =
	            gl.getUniformLocation(program, 'u_nodeRatio'),
	          arrowHeadLocation =
	            gl.getUniformLocation(program, 'u_arrowHead'),
	          scaleLocation =
	            gl.getUniformLocation(program, 'u_scale');
	
	      buffer = gl.createBuffer();
	      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
	
	      gl.uniform2f(resolutionLocation, params.width, params.height);
	      gl.uniform1f(
	        ratioLocation,
	        params.ratio / Math.pow(params.ratio, params.settings('edgesPowRatio'))
	      );
	      gl.uniform1f(
	        nodeRatioLocation,
	        Math.pow(params.ratio, params.settings('nodesPowRatio')) /
	        params.ratio
	      );
	      gl.uniform1f(arrowHeadLocation, 5.0);
	      gl.uniform1f(scaleLocation, params.scalingRatio);
	      gl.uniformMatrix3fv(matrixLocation, false, params.matrix);
	      gl.uniformMatrix2fv(
	        matrixHalfPiLocation,
	        false,
	        sigma.utils.matrices.rotation(Math.PI / 2, true)
	      );
	      gl.uniformMatrix2fv(
	        matrixHalfPiMinusLocation,
	        false,
	        sigma.utils.matrices.rotation(-Math.PI / 2, true)
	      );
	
	      gl.enableVertexAttribArray(positionLocation1);
	      gl.enableVertexAttribArray(positionLocation2);
	      gl.enableVertexAttribArray(thicknessLocation);
	      gl.enableVertexAttribArray(targetSizeLocation);
	      gl.enableVertexAttribArray(delayLocation);
	      gl.enableVertexAttribArray(minusLocation);
	      gl.enableVertexAttribArray(headLocation);
	      gl.enableVertexAttribArray(headPositionLocation);
	      gl.enableVertexAttribArray(colorLocation);
	
	      gl.vertexAttribPointer(positionLocation1,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        0
	      );
	      gl.vertexAttribPointer(positionLocation2,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        8
	      );
	      gl.vertexAttribPointer(thicknessLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        16
	      );
	      gl.vertexAttribPointer(targetSizeLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        20
	      );
	      gl.vertexAttribPointer(delayLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        24
	      );
	      gl.vertexAttribPointer(minusLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        28
	      );
	      gl.vertexAttribPointer(headLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        32
	      );
	      gl.vertexAttribPointer(headPositionLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        36
	      );
	      gl.vertexAttribPointer(colorLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        40
	      );
	
	      gl.drawArrays(
	        gl.TRIANGLES,
	        params.start || 0,
	        params.count || (data.length / this.ATTRIBUTES)
	      );
	    },
	    initProgram: function(gl) {
	      var vertexShader,
	          fragmentShader,
	          program;
	
	      vertexShader = sigma.utils.loadShader(
	        gl,
	        [
	          'attribute vec2 a_pos1;',
	          'attribute vec2 a_pos2;',
	          'attribute float a_thickness;',
	          'attribute float a_tSize;',
	          'attribute float a_delay;',
	          'attribute float a_minus;',
	          'attribute float a_head;',
	          'attribute float a_headPosition;',
	          'attribute float a_color;',
	
	          'uniform vec2 u_resolution;',
	          'uniform float u_ratio;',
	          'uniform float u_nodeRatio;',
	          'uniform float u_arrowHead;',
	          'uniform float u_scale;',
	          'uniform mat3 u_matrix;',
	          'uniform mat2 u_matrixHalfPi;',
	          'uniform mat2 u_matrixHalfPiMinus;',
	
	          'varying vec4 color;',
	
	          'void main() {',
	            // Find the good point:
	            'vec2 pos = normalize(a_pos2 - a_pos1);',
	
	            'mat2 matrix = (1.0 - a_head) *',
	              '(',
	                'a_minus * u_matrixHalfPiMinus +',
	                '(1.0 - a_minus) * u_matrixHalfPi',
	              ') + a_head * (',
	                'a_headPosition * u_matrixHalfPiMinus * 0.6 +',
	                '(a_headPosition * a_headPosition - 1.0) * mat2(1.0)',
	              ');',
	
	            'pos = a_pos1 + (',
	              // Deal with body:
	              '(1.0 - a_head) * a_thickness * u_ratio * matrix * pos +',
	              // Deal with head:
	              'a_head * u_arrowHead * a_thickness * u_ratio * matrix * pos +',
	              // Deal with delay:
	              'a_delay * pos * (',
	                'a_tSize / u_nodeRatio +',
	                'u_arrowHead * a_thickness * u_ratio',
	              ')',
	            ');',
	
	            // Scale from [[-1 1] [-1 1]] to the container:
	            'gl_Position = vec4(',
	              '((u_matrix * vec3(pos, 1)).xy /',
	                'u_resolution * 2.0 - 1.0) * vec2(1, -1),',
	              '0,',
	              '1',
	            ');',
	
	            // Extract the color:
	            'float c = a_color;',
	            'color.b = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.g = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.r = mod(c, 256.0); c = floor(c / 256.0); color /= 255.0;',
	            'color.a = 1.0;',
	          '}'
	        ].join('\n'),
	        gl.VERTEX_SHADER
	      );
	
	      fragmentShader = sigma.utils.loadShader(
	        gl,
	        [
	          'precision mediump float;',
	
	          'varying vec4 color;',
	
	          'void main(void) {',
	            'gl_FragColor = color;',
	          '}'
	        ].join('\n'),
	        gl.FRAGMENT_SHADER
	      );
	
	      program = sigma.utils.loadProgram(gl, [vertexShader, fragmentShader]);
	
	      return program;
	    }
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 65:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.webgl.edges');
	
	  /**
	   * This edge renderer will display edges as lines going from the source node
	   * to the target node. To deal with edge thicknesses, the lines are made of
	   * two triangles forming rectangles, with the gl.TRIANGLES drawing mode.
	   *
	   * It is expensive, since drawing a single edge requires 6 points, each
	   * having 7 attributes (source position, target position, thickness, color
	   * and a flag indicating which vertice of the rectangle it is).
	   */
	  sigma.webgl.edges.def = {
	    POINTS: 6,
	    ATTRIBUTES: 7,
	    addEdge: function(edge, source, target, data, i, prefix, settings) {
	      var w = (edge[prefix + 'size'] || 1) / 2,
	          x1 = source[prefix + 'x'],
	          y1 = source[prefix + 'y'],
	          x2 = target[prefix + 'x'],
	          y2 = target[prefix + 'y'],
	          color = edge.color;
	
	      if (!color)
	        switch (settings('edgeColor')) {
	          case 'source':
	            color = source.color || settings('defaultNodeColor');
	            break;
	          case 'target':
	            color = target.color || settings('defaultNodeColor');
	            break;
	          default:
	            color = settings('defaultEdgeColor');
	            break;
	        }
	
	      // Normalize color:
	      color = sigma.utils.floatColor(color);
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = 1.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = w;
	      data[i++] = 0.0;
	      data[i++] = color;
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = 1.0;
	      data[i++] = color;
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = w;
	      data[i++] = 0.0;
	      data[i++] = color;
	    },
	    render: function(gl, program, data, params) {
	      var buffer;
	
	      // Define attributes:
	      var colorLocation =
	            gl.getAttribLocation(program, 'a_color'),
	          positionLocation1 =
	            gl.getAttribLocation(program, 'a_position1'),
	          positionLocation2 =
	            gl.getAttribLocation(program, 'a_position2'),
	          thicknessLocation =
	            gl.getAttribLocation(program, 'a_thickness'),
	          minusLocation =
	            gl.getAttribLocation(program, 'a_minus'),
	          resolutionLocation =
	            gl.getUniformLocation(program, 'u_resolution'),
	          matrixLocation =
	            gl.getUniformLocation(program, 'u_matrix'),
	          matrixHalfPiLocation =
	            gl.getUniformLocation(program, 'u_matrixHalfPi'),
	          matrixHalfPiMinusLocation =
	            gl.getUniformLocation(program, 'u_matrixHalfPiMinus'),
	          ratioLocation =
	            gl.getUniformLocation(program, 'u_ratio'),
	          scaleLocation =
	            gl.getUniformLocation(program, 'u_scale');
	
	      buffer = gl.createBuffer();
	      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
	
	      gl.uniform2f(resolutionLocation, params.width, params.height);
	      gl.uniform1f(
	        ratioLocation,
	        params.ratio / Math.pow(params.ratio, params.settings('edgesPowRatio'))
	      );
	      gl.uniform1f(scaleLocation, params.scalingRatio);
	      gl.uniformMatrix3fv(matrixLocation, false, params.matrix);
	      gl.uniformMatrix2fv(
	        matrixHalfPiLocation,
	        false,
	        sigma.utils.matrices.rotation(Math.PI / 2, true)
	      );
	      gl.uniformMatrix2fv(
	        matrixHalfPiMinusLocation,
	        false,
	        sigma.utils.matrices.rotation(-Math.PI / 2, true)
	      );
	
	      gl.enableVertexAttribArray(colorLocation);
	      gl.enableVertexAttribArray(positionLocation1);
	      gl.enableVertexAttribArray(positionLocation2);
	      gl.enableVertexAttribArray(thicknessLocation);
	      gl.enableVertexAttribArray(minusLocation);
	
	      gl.vertexAttribPointer(positionLocation1,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        0
	      );
	      gl.vertexAttribPointer(positionLocation2,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        8
	      );
	      gl.vertexAttribPointer(thicknessLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        16
	      );
	      gl.vertexAttribPointer(minusLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        20
	      );
	      gl.vertexAttribPointer(colorLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        24
	      );
	
	      gl.drawArrays(
	        gl.TRIANGLES,
	        params.start || 0,
	        params.count || (data.length / this.ATTRIBUTES)
	      );
	    },
	    initProgram: function(gl) {
	      var vertexShader,
	          fragmentShader,
	          program;
	
	      vertexShader = sigma.utils.loadShader(
	        gl,
	        [
	          'attribute vec2 a_position1;',
	          'attribute vec2 a_position2;',
	          'attribute float a_thickness;',
	          'attribute float a_minus;',
	          'attribute float a_color;',
	
	          'uniform vec2 u_resolution;',
	          'uniform float u_ratio;',
	          'uniform float u_scale;',
	          'uniform mat3 u_matrix;',
	          'uniform mat2 u_matrixHalfPi;',
	          'uniform mat2 u_matrixHalfPiMinus;',
	
	          'varying vec4 color;',
	
	          'void main() {',
	            // Find the good point:
	            'vec2 position = a_thickness * u_ratio *',
	              'normalize(a_position2 - a_position1);',
	
	            'mat2 matrix = a_minus * u_matrixHalfPiMinus +',
	              '(1.0 - a_minus) * u_matrixHalfPi;',
	
	            'position = matrix * position + a_position1;',
	
	            // Scale from [[-1 1] [-1 1]] to the container:
	            'gl_Position = vec4(',
	              '((u_matrix * vec3(position, 1)).xy /',
	                'u_resolution * 2.0 - 1.0) * vec2(1, -1),',
	              '0,',
	              '1',
	            ');',
	
	            // Extract the color:
	            'float c = a_color;',
	            'color.b = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.g = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.r = mod(c, 256.0); c = floor(c / 256.0); color /= 255.0;',
	            'color.a = 1.0;',
	          '}'
	        ].join('\n'),
	        gl.VERTEX_SHADER
	      );
	
	      fragmentShader = sigma.utils.loadShader(
	        gl,
	        [
	          'precision mediump float;',
	
	          'varying vec4 color;',
	
	          'void main(void) {',
	            'gl_FragColor = color;',
	          '}'
	        ].join('\n'),
	        gl.FRAGMENT_SHADER
	      );
	
	      program = sigma.utils.loadProgram(gl, [vertexShader, fragmentShader]);
	
	      return program;
	    }
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 66:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.webgl.edges');
	
	  /**
	   * This edge renderer will display edges as lines with the gl.LINES display
	   * mode. Since this mode does not support well thickness, edges are all drawn
	   * with the same thickness (3px), independantly of the edge attributes or the
	   * zooming ratio.
	   */
	  sigma.webgl.edges.fast = {
	    POINTS: 2,
	    ATTRIBUTES: 3,
	    addEdge: function(edge, source, target, data, i, prefix, settings) {
	      var w = (edge[prefix + 'size'] || 1) / 2,
	          x1 = source[prefix + 'x'],
	          y1 = source[prefix + 'y'],
	          x2 = target[prefix + 'x'],
	          y2 = target[prefix + 'y'],
	          color = edge.color;
	
	      if (!color)
	        switch (settings('edgeColor')) {
	          case 'source':
	            color = source.color || settings('defaultNodeColor');
	            break;
	          case 'target':
	            color = target.color || settings('defaultNodeColor');
	            break;
	          default:
	            color = settings('defaultEdgeColor');
	            break;
	        }
	
	      // Normalize color:
	      color = sigma.utils.floatColor(color);
	
	      data[i++] = x1;
	      data[i++] = y1;
	      data[i++] = color;
	
	      data[i++] = x2;
	      data[i++] = y2;
	      data[i++] = color;
	    },
	    render: function(gl, program, data, params) {
	      var buffer;
	
	      // Define attributes:
	      var colorLocation =
	            gl.getAttribLocation(program, 'a_color'),
	          positionLocation =
	            gl.getAttribLocation(program, 'a_position'),
	          resolutionLocation =
	            gl.getUniformLocation(program, 'u_resolution'),
	          matrixLocation =
	            gl.getUniformLocation(program, 'u_matrix');
	
	      buffer = gl.createBuffer();
	      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	      gl.bufferData(gl.ARRAY_BUFFER, data, gl.DYNAMIC_DRAW);
	
	      gl.uniform2f(resolutionLocation, params.width, params.height);
	      gl.uniformMatrix3fv(matrixLocation, false, params.matrix);
	
	      gl.enableVertexAttribArray(positionLocation);
	      gl.enableVertexAttribArray(colorLocation);
	
	      gl.vertexAttribPointer(positionLocation,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        0
	      );
	      gl.vertexAttribPointer(colorLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        8
	      );
	
	      gl.lineWidth(3);
	      gl.drawArrays(
	        gl.LINES,
	        params.start || 0,
	        params.count || (data.length / this.ATTRIBUTES)
	      );
	    },
	    initProgram: function(gl) {
	      var vertexShader,
	          fragmentShader,
	          program;
	
	      vertexShader = sigma.utils.loadShader(
	        gl,
	        [
	          'attribute vec2 a_position;',
	          'attribute float a_color;',
	
	          'uniform vec2 u_resolution;',
	          'uniform mat3 u_matrix;',
	
	          'varying vec4 color;',
	
	          'void main() {',
	            // Scale from [[-1 1] [-1 1]] to the container:
	            'gl_Position = vec4(',
	              '((u_matrix * vec3(a_position, 1)).xy /',
	                'u_resolution * 2.0 - 1.0) * vec2(1, -1),',
	              '0,',
	              '1',
	            ');',
	
	            // Extract the color:
	            'float c = a_color;',
	            'color.b = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.g = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.r = mod(c, 256.0); c = floor(c / 256.0); color /= 255.0;',
	            'color.a = 1.0;',
	          '}'
	        ].join('\n'),
	        gl.VERTEX_SHADER
	      );
	
	      fragmentShader = sigma.utils.loadShader(
	        gl,
	        [
	          'precision mediump float;',
	
	          'varying vec4 color;',
	
	          'void main(void) {',
	            'gl_FragColor = color;',
	          '}'
	        ].join('\n'),
	        gl.FRAGMENT_SHADER
	      );
	
	      program = sigma.utils.loadProgram(gl, [vertexShader, fragmentShader]);
	
	      return program;
	    }
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 67:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.webgl.nodes');
	
	  /**
	   * This node renderer will display nodes as discs, shaped in triangles with
	   * the gl.TRIANGLES display mode. So, to be more precise, to draw one node,
	   * it will store three times the center of node, with the color and the size,
	   * and an angle indicating which "corner" of the triangle to draw.
	   *
	   * The fragment shader does not deal with anti-aliasing, so make sure that
	   * you deal with it somewhere else in the code (by default, the WebGL
	   * renderer will oversample the rendering through the webglOversamplingRatio
	   * value).
	   */
	  sigma.webgl.nodes.def = {
	    POINTS: 3,
	    ATTRIBUTES: 5,
	    addNode: function(node, data, i, prefix, settings) {
	      var color = sigma.utils.floatColor(
	        node.color || settings('defaultNodeColor')
	      );
	
	      data[i++] = node[prefix + 'x'];
	      data[i++] = node[prefix + 'y'];
	      data[i++] = node[prefix + 'size'];
	      data[i++] = color;
	      data[i++] = 0;
	
	      data[i++] = node[prefix + 'x'];
	      data[i++] = node[prefix + 'y'];
	      data[i++] = node[prefix + 'size'];
	      data[i++] = color;
	      data[i++] = 2 * Math.PI / 3;
	
	      data[i++] = node[prefix + 'x'];
	      data[i++] = node[prefix + 'y'];
	      data[i++] = node[prefix + 'size'];
	      data[i++] = color;
	      data[i++] = 4 * Math.PI / 3;
	    },
	    render: function(gl, program, data, params) {
	      var buffer;
	
	      // Define attributes:
	      var positionLocation =
	            gl.getAttribLocation(program, 'a_position'),
	          sizeLocation =
	            gl.getAttribLocation(program, 'a_size'),
	          colorLocation =
	            gl.getAttribLocation(program, 'a_color'),
	          angleLocation =
	            gl.getAttribLocation(program, 'a_angle'),
	          resolutionLocation =
	            gl.getUniformLocation(program, 'u_resolution'),
	          matrixLocation =
	            gl.getUniformLocation(program, 'u_matrix'),
	          ratioLocation =
	            gl.getUniformLocation(program, 'u_ratio'),
	          scaleLocation =
	            gl.getUniformLocation(program, 'u_scale');
	
	      buffer = gl.createBuffer();
	      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	      gl.bufferData(gl.ARRAY_BUFFER, data, gl.DYNAMIC_DRAW);
	
	      gl.uniform2f(resolutionLocation, params.width, params.height);
	      gl.uniform1f(
	        ratioLocation,
	        1 / Math.pow(params.ratio, params.settings('nodesPowRatio'))
	      );
	      gl.uniform1f(scaleLocation, params.scalingRatio);
	      gl.uniformMatrix3fv(matrixLocation, false, params.matrix);
	
	      gl.enableVertexAttribArray(positionLocation);
	      gl.enableVertexAttribArray(sizeLocation);
	      gl.enableVertexAttribArray(colorLocation);
	      gl.enableVertexAttribArray(angleLocation);
	
	      gl.vertexAttribPointer(
	        positionLocation,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        0
	      );
	      gl.vertexAttribPointer(
	        sizeLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        8
	      );
	      gl.vertexAttribPointer(
	        colorLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        12
	      );
	      gl.vertexAttribPointer(
	        angleLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        16
	      );
	
	      gl.drawArrays(
	        gl.TRIANGLES,
	        params.start || 0,
	        params.count || (data.length / this.ATTRIBUTES)
	      );
	    },
	    initProgram: function(gl) {
	      var vertexShader,
	          fragmentShader,
	          program;
	
	      vertexShader = sigma.utils.loadShader(
	        gl,
	        [
	          'attribute vec2 a_position;',
	          'attribute float a_size;',
	          'attribute float a_color;',
	          'attribute float a_angle;',
	
	          'uniform vec2 u_resolution;',
	          'uniform float u_ratio;',
	          'uniform float u_scale;',
	          'uniform mat3 u_matrix;',
	
	          'varying vec4 color;',
	          'varying vec2 center;',
	          'varying float radius;',
	
	          'void main() {',
	            // Multiply the point size twice:
	            'radius = a_size * u_ratio;',
	
	            // Scale from [[-1 1] [-1 1]] to the container:
	            'vec2 position = (u_matrix * vec3(a_position, 1)).xy;',
	            // 'center = (position / u_resolution * 2.0 - 1.0) * vec2(1, -1);',
	            'center = position * u_scale;',
	            'center = vec2(center.x, u_scale * u_resolution.y - center.y);',
	
	            'position = position +',
	              '2.0 * radius * vec2(cos(a_angle), sin(a_angle));',
	            'position = (position / u_resolution * 2.0 - 1.0) * vec2(1, -1);',
	
	            'radius = radius * u_scale;',
	
	            'gl_Position = vec4(position, 0, 1);',
	
	            // Extract the color:
	            'float c = a_color;',
	            'color.b = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.g = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.r = mod(c, 256.0); c = floor(c / 256.0); color /= 255.0;',
	            'color.a = 1.0;',
	          '}'
	        ].join('\n'),
	        gl.VERTEX_SHADER
	      );
	
	      fragmentShader = sigma.utils.loadShader(
	        gl,
	        [
	          'precision mediump float;',
	
	          'varying vec4 color;',
	          'varying vec2 center;',
	          'varying float radius;',
	
	          'void main(void) {',
	            'vec4 color0 = vec4(0.0, 0.0, 0.0, 0.0);',
	
	            'vec2 m = gl_FragCoord.xy - center;',
	            'float diff = radius - sqrt(m.x * m.x + m.y * m.y);',
	
	            // Here is how we draw a disc instead of a square:
	            'if (diff > 0.0)',
	              'gl_FragColor = color;',
	            'else',
	              'gl_FragColor = color0;',
	          '}'
	        ].join('\n'),
	        gl.FRAGMENT_SHADER
	      );
	
	      program = sigma.utils.loadProgram(gl, [vertexShader, fragmentShader]);
	
	      return program;
	    }
	  };
	})();
	
	}.call(window));
	
	/***/ }),
	
	/***/ 68:
	/***/ (function(module, exports) {
	
	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	;(function() {
	  'use strict';
	
	  sigma.utils.pkg('sigma.webgl.nodes');
	
	  /**
	   * This node renderer will display nodes in the fastest way: Nodes are basic
	   * squares, drawn through the gl.POINTS drawing method. The size of the nodes
	   * are represented with the "gl_PointSize" value in the vertex shader.
	   *
	   * It is the fastest node renderer here since the buffer just takes one line
	   * to draw each node (with attributes "x", "y", "size" and "color").
	   *
	   * Nevertheless, this method has some problems, especially due to some issues
	   * with the gl.POINTS:
	   *  - First, if the center of a node is outside the scene, the point will not
	   *    be drawn, even if it should be partly on screen.
	   *  - I tried applying a fragment shader similar to the one in the default
	   *    node renderer to display them as discs, but it did not work fine on
	   *    some computers settings, filling the discs with weird gradients not
	   *    depending on the actual color.
	   */
	  sigma.webgl.nodes.fast = {
	    POINTS: 1,
	    ATTRIBUTES: 4,
	    addNode: function(node, data, i, prefix, settings) {
	      data[i++] = node[prefix + 'x'];
	      data[i++] = node[prefix + 'y'];
	      data[i++] = node[prefix + 'size'];
	      data[i++] = sigma.utils.floatColor(
	        node.color || settings('defaultNodeColor')
	      );
	    },
	    render: function(gl, program, data, params) {
	      var buffer;
	
	      // Define attributes:
	      var positionLocation =
	            gl.getAttribLocation(program, 'a_position'),
	          sizeLocation =
	            gl.getAttribLocation(program, 'a_size'),
	          colorLocation =
	            gl.getAttribLocation(program, 'a_color'),
	          resolutionLocation =
	            gl.getUniformLocation(program, 'u_resolution'),
	          matrixLocation =
	            gl.getUniformLocation(program, 'u_matrix'),
	          ratioLocation =
	            gl.getUniformLocation(program, 'u_ratio'),
	          scaleLocation =
	            gl.getUniformLocation(program, 'u_scale');
	
	      buffer = gl.createBuffer();
	      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	      gl.bufferData(gl.ARRAY_BUFFER, data, gl.DYNAMIC_DRAW);
	
	      gl.uniform2f(resolutionLocation, params.width, params.height);
	      gl.uniform1f(
	        ratioLocation,
	        1 / Math.pow(params.ratio, params.settings('nodesPowRatio'))
	      );
	      gl.uniform1f(scaleLocation, params.scalingRatio);
	      gl.uniformMatrix3fv(matrixLocation, false, params.matrix);
	
	      gl.enableVertexAttribArray(positionLocation);
	      gl.enableVertexAttribArray(sizeLocation);
	      gl.enableVertexAttribArray(colorLocation);
	
	      gl.vertexAttribPointer(
	        positionLocation,
	        2,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        0
	      );
	      gl.vertexAttribPointer(
	        sizeLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        8
	      );
	      gl.vertexAttribPointer(
	        colorLocation,
	        1,
	        gl.FLOAT,
	        false,
	        this.ATTRIBUTES * Float32Array.BYTES_PER_ELEMENT,
	        12
	      );
	
	      gl.drawArrays(
	        gl.POINTS,
	        params.start || 0,
	        params.count || (data.length / this.ATTRIBUTES)
	      );
	    },
	    initProgram: function(gl) {
	      var vertexShader,
	          fragmentShader,
	          program;
	
	      vertexShader = sigma.utils.loadShader(
	        gl,
	        [
	          'attribute vec2 a_position;',
	          'attribute float a_size;',
	          'attribute float a_color;',
	
	          'uniform vec2 u_resolution;',
	          'uniform float u_ratio;',
	          'uniform float u_scale;',
	          'uniform mat3 u_matrix;',
	
	          'varying vec4 color;',
	
	          'void main() {',
	            // Scale from [[-1 1] [-1 1]] to the container:
	            'gl_Position = vec4(',
	              '((u_matrix * vec3(a_position, 1)).xy /',
	                'u_resolution * 2.0 - 1.0) * vec2(1, -1),',
	              '0,',
	              '1',
	            ');',
	
	            // Multiply the point size twice:
	            //  - x SCALING_RATIO to correct the canvas scaling
	            //  - x 2 to correct the formulae
	            'gl_PointSize = a_size * u_ratio * u_scale * 2.0;',
	
	            // Extract the color:
	            'float c = a_color;',
	            'color.b = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.g = mod(c, 256.0); c = floor(c / 256.0);',
	            'color.r = mod(c, 256.0); c = floor(c / 256.0); color /= 255.0;',
	            'color.a = 1.0;',
	          '}'
	        ].join('\n'),
	        gl.VERTEX_SHADER
	      );
	
	      fragmentShader = sigma.utils.loadShader(
	        gl,
	        [
	          'precision mediump float;',
	
	          'varying vec4 color;',
	
	          'void main(void) {',
	            'float border = 0.01;',
	            'float radius = 0.5;',
	
	            'vec4 color0 = vec4(0.0, 0.0, 0.0, 0.0);',
	            'vec2 m = gl_PointCoord - vec2(0.5, 0.5);',
	            'float dist = radius - sqrt(m.x * m.x + m.y * m.y);',
	
	            'float t = 0.0;',
	            'if (dist > border)',
	              't = 1.0;',
	            'else if (dist > 0.0)',
	              't = dist / border;',
	
	            'gl_FragColor = mix(color0, color, t);',
	          '}'
	        ].join('\n'),
	        gl.FRAGMENT_SHADER
	      );
	
	      program = sigma.utils.loadProgram(gl, [vertexShader, fragmentShader]);
	
	      return program;
	    }
	  };
	})();
	
	}.call(window));
	
	/***/ })
	
	/******/ });

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var INPUT_FIELD_REF = 'inputField';
	
	var READ_METHOD_ALIASES = {
	  buffer: 'readAsArrayBuffer',
	  binary: 'readAsBinaryString',
	  dataUrl: 'readAsDataURL',
	  text: 'readAsText'
	};
	
	var SUPPORTED_EVENTS = ['onLoadStart', 'onLoadEnd', 'onLoad', 'onAbort', 'onError'];
	
	var UNSUPPORTED_BY_INPUT = {
	  readAs: true,
	  cancelIf: true,
	  onCancel: true
	};
	
	var FileInput = function (_Component) {
	  _inherits(FileInput, _Component);
	
	  function FileInput(props, context) {
	    _classCallCheck(this, FileInput);
	
	    var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props, context));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(FileInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      if (window && !window.File || !window.FileReader) {
	        console.warn('Browser does not appear to support API react-simple-file-input relies upon');
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      var _props = this.props,
	          readAs = _props.readAs,
	          cancelIf = _props.cancelIf,
	          onCancel = _props.onCancel,
	          onProgress = _props.onProgress,
	          abortIf = _props.abortIf,
	          onChange = _props.onChange,
	          multiple = _props.multiple;
	      var files = event.target.files;
	
	
	      if (onChange) {
	        if (multiple) {
	          onChange(files);
	        } else {
	          onChange(files[0]);
	        }
	      }
	
	      if (readAs) {
	        var _loop = function _loop(i) {
	          var file = files[i];
	
	          if (cancelIf && cancelIf(file)) {
	            if (onCancel) {
	              onCancel(file);
	            }
	
	            return {
	              v: void 0
	            };
	          }
	
	          var fileReader = new window.FileReader();
	
	          var _loop2 = function _loop2(_i) {
	            var handlerName = SUPPORTED_EVENTS[_i];
	
	            if (_this2.props[handlerName]) {
	              fileReader[handlerName.toLowerCase()] = function (fileReadEvent) {
	                _this2.props[handlerName](fileReadEvent, file);
	              };
	            }
	          };
	
	          for (var _i = 0; _i < SUPPORTED_EVENTS.length; _i++) {
	            _loop2(_i);
	          }
	
	          if (typeof abortIf !== 'undefined') {
	            fileReader.onprogress = function (event) {
	
	              if (abortIf(event, file)) {
	                fileReader.abort();
	              } else if (onProgress) {
	                onProgress(event, file);
	              }
	            };
	          } else if (onProgress) {
	            fileReader.onprogress = onProgress;
	          }
	
	          fileReader[READ_METHOD_ALIASES[readAs]](file);
	        };
	
	        for (var i = 0; i < files.length; i++) {
	          var _ret = _loop(i);
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var inputProps = {};
	
	      for (var property in this.props) {
	        if (this.props.hasOwnProperty(property) && !UNSUPPORTED_BY_INPUT[property]) {
	          inputProps[property] = this.props[property];
	        }
	      }
	
	      return _react2.default.createElement('input', _extends({}, inputProps, {
	        type: 'file',
	        ref: INPUT_FIELD_REF,
	        onChange: this.handleChange
	      }));
	    }
	  }]);
	
	  return FileInput;
	}(_react.Component);
	
	FileInput.propTypes = {
	  id: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	
	  multiple: _react.PropTypes.bool,
	
	  readAs: _react2.default.PropTypes.oneOf(Object.keys(READ_METHOD_ALIASES)),
	
	  onLoadStart: _react2.default.PropTypes.func,
	  onLoadEnd: _react2.default.PropTypes.func,
	  onLoad: _react2.default.PropTypes.func,
	  onAbort: _react2.default.PropTypes.func,
	  onCancel: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func,
	  onError: _react2.default.PropTypes.func,
	  onProgress: _react2.default.PropTypes.func,
	
	  cancelIf: _react2.default.PropTypes.func,
	  abortIf: _react2.default.PropTypes.func
	};
	
	exports.default = FileInput;

/***/ },
/* 482 */
109,
/* 483 */
[531, 49],
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(483);
	var ReactElement = __webpack_require__(48);
	
	var emptyFunction = __webpack_require__(17);
	var traverseAllChildren = __webpack_require__(492);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(49),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(124);
	var ReactElement = __webpack_require__(48);
	var ReactPropTypeLocationNames = __webpack_require__(207);
	var ReactNoopUpdateQueue = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(56);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(3);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(48);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(48);
	var ReactPropTypeLocationNames = __webpack_require__(207);
	var ReactPropTypesSecret = __webpack_require__(488);
	
	var emptyFunction = __webpack_require__(17);
	var getIteratorFn = __webpack_require__(209);
	var warning = __webpack_require__(3);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 488 */
386,
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(124);
	var ReactNoopUpdateQueue = __webpack_require__(125);
	
	var emptyObject = __webpack_require__(56);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 490 */
391,
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(49);
	
	var ReactElement = __webpack_require__(48);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(49);
	
	var ReactCurrentOwner = __webpack_require__(25);
	var REACT_ELEMENT_TYPE = __webpack_require__(206);
	
	var getIteratorFn = __webpack_require__(209);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(482);
	var warning = __webpack_require__(3);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 493 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.28c753fa.js
 **/